import { defineComponent as V, useId as tr, provide as Zt, createElementBlock as I, openBlock as S, renderSlot as F, inject as ft, createPropsRestProxy as wr, ref as H, readonly as O2, computed as O, watch as K, normalizeStyle as Ct, normalizeClass as de, createCommentVNode as Z, toDisplayString as Q, unref as g, markRaw as ye, createStaticVNode as bu, createBlock as B, resolveDynamicComponent as si, withCtx as D, useAttrs as Zr, createElementVNode as C, getCurrentInstance as Jr, Transition as jn, mergeProps as me, createVNode as j, mergeModels as $e, useModel as Ae, useTemplateRef as At, onMounted as He, onBeforeUnmount as wu, withModifiers as Jt, createSlots as _u, pushScopeId as T2, popScopeId as k2, nextTick as tt, normalizeProps as Ot, guardReactiveProps as Tt, resolveComponent as _o, withScopeId as I2, withKeys as Pt, Fragment as le, onUnmounted as Qr, toRef as R2, renderList as Ee, onBeforeMount as D2, isRef as $t, reactive as Gn, isReactive as N2, isReadonly as F2, toValue as Nr, createTextVNode as Me, withDirectives as Xe, vModelCheckbox as L2, toRefs as kt, toHandlers as B2, h as mr, toRaw as V2, Comment as j2, cloneVNode as G2, watchEffect as ui, effectScope as xu, vModelText as Un, vModelDynamic as U2, vShow as xo, shallowRef as H2, vModelRadio as W2, TransitionGroup as Su, useSlots as z2 } from "vue";
const rl = Symbol("Form Injection Key"), Cu = Symbol("FdxTabsInjectionKey"), Pu = Symbol(
  "FdxAccordionNameInjectionKey"
), Au = Symbol("FdxRadioGroupInjectionKey"), q2 = { role: "group" }, Ix = /* @__PURE__ */ V({
  __name: "FdxAccordion",
  props: {
    name: {}
  },
  setup(e) {
    const r = e.name || `fdx-accordion-${tr()}`;
    return Zt(Pu, r), (n, a) => (S(), I("section", q2, [
      F(n.$slots, "default")
    ]));
  }
});
function K2(e) {
  const t = e % 360, r = 50 + e % 30, n = 40 + e % 20;
  return `hsl(${t}, ${r}%, ${n}%)`;
}
function Y2(e) {
  const t = e.match(/hsl\((\d+),\s*(\d+)%,\s*(\d+)%\)/);
  return t && parseInt(t[3]) > 50 ? "#000000" : "#ffffff";
}
function Z2(e, t) {
  const r = ft(e, t);
  if (!r)
    throw new Error(`Could not resolve ${e.description}`);
  return r;
}
const Eu = (e, t) => {
  const r = {
    compact: !1,
    removingTrainingZeros: !0,
    ...t
  }, n = new Intl.NumberFormat("en-US", {
    currency: r.currency,
    maximumFractionDigits: r.showFraction ? 2 : 0,
    minimumFractionDigits: r.showFraction ? 2 : 0,
    notation: r.compact ? "compact" : "standard",
    style: r.currency ? "currency" : "decimal"
  }).format(e);
  return r.removingTrainingZeros ? n.replace(".00", "") : n;
}, Rx = (e, t = "SAR", r = !1) => Eu(e, { compact: r, currency: t });
function J2(e) {
  if (!e.trim())
    return "";
  const t = e.trim().split(/\s+/);
  return t.length === 1 ? t[0].charAt(0).toUpperCase() : t[0].charAt(0).toUpperCase() + t[t.length - 1].charAt(0).toUpperCase();
}
function Q2(e) {
  let t = 0;
  for (let r = 0; r < e.length; r++) {
    const n = e.charCodeAt(r);
    t = (t << 5) - t + n;
  }
  return Math.abs(t);
}
const ci = "-", X2 = (e) => {
  const t = t3(e), {
    conflictingClassGroups: r,
    conflictingClassGroupModifiers: n
  } = e;
  return {
    getClassGroupId: (o) => {
      const i = o.split(ci);
      return i[0] === "" && i.length !== 1 && i.shift(), Mu(i, t) || e3(o);
    },
    getConflictingClassGroupIds: (o, i) => {
      const l = r[o] || [];
      return i && n[o] ? [...l, ...n[o]] : l;
    }
  };
}, Mu = (e, t) => {
  var o;
  if (e.length === 0)
    return t.classGroupId;
  const r = e[0], n = t.nextPart.get(r), a = n ? Mu(e.slice(1), n) : void 0;
  if (a)
    return a;
  if (t.validators.length === 0)
    return;
  const d = e.join(ci);
  return (o = t.validators.find(({
    validator: i
  }) => i(d))) == null ? void 0 : o.classGroupId;
}, nl = /^\[(.+)\]$/, e3 = (e) => {
  if (nl.test(e)) {
    const t = nl.exec(e)[1], r = t == null ? void 0 : t.substring(0, t.indexOf(":"));
    if (r)
      return "arbitrary.." + r;
  }
}, t3 = (e) => {
  const {
    theme: t,
    classGroups: r
  } = e, n = {
    nextPart: /* @__PURE__ */ new Map(),
    validators: []
  };
  for (const a in r)
    So(r[a], n, a, t);
  return n;
}, So = (e, t, r, n) => {
  e.forEach((a) => {
    if (typeof a == "string") {
      const d = a === "" ? t : al(t, a);
      d.classGroupId = r;
      return;
    }
    if (typeof a == "function") {
      if (r3(a)) {
        So(a(n), t, r, n);
        return;
      }
      t.validators.push({
        validator: a,
        classGroupId: r
      });
      return;
    }
    Object.entries(a).forEach(([d, o]) => {
      So(o, al(t, d), r, n);
    });
  });
}, al = (e, t) => {
  let r = e;
  return t.split(ci).forEach((n) => {
    r.nextPart.has(n) || r.nextPart.set(n, {
      nextPart: /* @__PURE__ */ new Map(),
      validators: []
    }), r = r.nextPart.get(n);
  }), r;
}, r3 = (e) => e.isThemeGetter, n3 = (e) => {
  if (e < 1)
    return {
      get: () => {
      },
      set: () => {
      }
    };
  let t = 0, r = /* @__PURE__ */ new Map(), n = /* @__PURE__ */ new Map();
  const a = (d, o) => {
    r.set(d, o), t++, t > e && (t = 0, n = r, r = /* @__PURE__ */ new Map());
  };
  return {
    get(d) {
      let o = r.get(d);
      if (o !== void 0)
        return o;
      if ((o = n.get(d)) !== void 0)
        return a(d, o), o;
    },
    set(d, o) {
      r.has(d) ? r.set(d, o) : a(d, o);
    }
  };
}, Co = "!", Po = ":", a3 = Po.length, d3 = (e) => {
  const {
    prefix: t,
    experimentalParseClassName: r
  } = e;
  let n = (a) => {
    const d = [];
    let o = 0, i = 0, l = 0, s;
    for (let c = 0; c < a.length; c++) {
      let p = a[c];
      if (o === 0 && i === 0) {
        if (p === Po) {
          d.push(a.slice(l, c)), l = c + a3;
          continue;
        }
        if (p === "/") {
          s = c;
          continue;
        }
      }
      p === "[" ? o++ : p === "]" ? o-- : p === "(" ? i++ : p === ")" && i--;
    }
    const u = d.length === 0 ? a : a.substring(l), $ = o3(u), y = $ !== u, h = s && s > l ? s - l : void 0;
    return {
      modifiers: d,
      hasImportantModifier: y,
      baseClassName: $,
      maybePostfixModifierPosition: h
    };
  };
  if (t) {
    const a = t + Po, d = n;
    n = (o) => o.startsWith(a) ? d(o.substring(a.length)) : {
      isExternal: !0,
      modifiers: [],
      hasImportantModifier: !1,
      baseClassName: o,
      maybePostfixModifierPosition: void 0
    };
  }
  if (r) {
    const a = n;
    n = (d) => r({
      className: d,
      parseClassName: a
    });
  }
  return n;
}, o3 = (e) => e.endsWith(Co) ? e.substring(0, e.length - 1) : e.startsWith(Co) ? e.substring(1) : e, i3 = (e) => {
  const t = Object.fromEntries(e.orderSensitiveModifiers.map((n) => [n, !0]));
  return (n) => {
    if (n.length <= 1)
      return n;
    const a = [];
    let d = [];
    return n.forEach((o) => {
      o[0] === "[" || t[o] ? (a.push(...d.sort(), o), d = []) : d.push(o);
    }), a.push(...d.sort()), a;
  };
}, l3 = (e) => ({
  cache: n3(e.cacheSize),
  parseClassName: d3(e),
  sortModifiers: i3(e),
  ...X2(e)
}), s3 = /\s+/, u3 = (e, t) => {
  const {
    parseClassName: r,
    getClassGroupId: n,
    getConflictingClassGroupIds: a,
    sortModifiers: d
  } = t, o = [], i = e.trim().split(s3);
  let l = "";
  for (let s = i.length - 1; s >= 0; s -= 1) {
    const u = i[s], {
      isExternal: $,
      modifiers: y,
      hasImportantModifier: h,
      baseClassName: c,
      maybePostfixModifierPosition: p
    } = r(u);
    if ($) {
      l = u + (l.length > 0 ? " " + l : l);
      continue;
    }
    let f = !!p, v = n(f ? c.substring(0, p) : c);
    if (!v) {
      if (!f) {
        l = u + (l.length > 0 ? " " + l : l);
        continue;
      }
      if (v = n(c), !v) {
        l = u + (l.length > 0 ? " " + l : l);
        continue;
      }
      f = !1;
    }
    const w = d(y).join(":"), m = h ? w + Co : w, b = m + v;
    if (o.includes(b))
      continue;
    o.push(b);
    const _ = a(v, f);
    for (let x = 0; x < _.length; ++x) {
      const A = _[x];
      o.push(m + A);
    }
    l = u + (l.length > 0 ? " " + l : l);
  }
  return l;
};
function c3() {
  let e = 0, t, r, n = "";
  for (; e < arguments.length; )
    (t = arguments[e++]) && (r = Ou(t)) && (n && (n += " "), n += r);
  return n;
}
const Ou = (e) => {
  if (typeof e == "string")
    return e;
  let t, r = "";
  for (let n = 0; n < e.length; n++)
    e[n] && (t = Ou(e[n])) && (r && (r += " "), r += t);
  return r;
};
function dl(e, ...t) {
  let r, n, a, d = o;
  function o(l) {
    const s = t.reduce((u, $) => $(u), e());
    return r = l3(s), n = r.cache.get, a = r.cache.set, d = i, i(l);
  }
  function i(l) {
    const s = n(l);
    if (s)
      return s;
    const u = u3(l, r);
    return a(l, u), u;
  }
  return function() {
    return d(c3.apply(null, arguments));
  };
}
const Ie = (e) => {
  const t = (r) => r[e] || [];
  return t.isThemeGetter = !0, t;
}, Tu = /^\[(?:(\w[\w-]*):)?(.+)\]$/i, ku = /^\((?:(\w[\w-]*):)?(.+)\)$/i, f3 = /^\d+\/\d+$/, $3 = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/, p3 = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/, m3 = /^(rgba?|hsla?|hwb|(ok)?(lab|lch)|color-mix)\(.+\)$/, h3 = /^(inset_)?-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/, v3 = /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/, Tr = (e) => f3.test(e), ae = (e) => !!e && !Number.isNaN(Number(e)), Ft = (e) => !!e && Number.isInteger(Number(e)), id = (e) => e.endsWith("%") && ae(e.slice(0, -1)), vt = (e) => $3.test(e), y3 = () => !0, g3 = (e) => (
  // `colorFunctionRegex` check is necessary because color functions can have percentages in them which which would be incorrectly classified as lengths.
  // For example, `hsl(0 0% 0%)` would be classified as a length without this check.
  // I could also use lookbehind assertion in `lengthUnitRegex` but that isn't supported widely enough.
  p3.test(e) && !m3.test(e)
), Iu = () => !1, b3 = (e) => h3.test(e), w3 = (e) => v3.test(e), _3 = (e) => !z(e) && !q(e), x3 = (e) => Xr(e, Nu, Iu), z = (e) => Tu.test(e), ir = (e) => Xr(e, Fu, g3), ld = (e) => Xr(e, E3, ae), ol = (e) => Xr(e, Ru, Iu), S3 = (e) => Xr(e, Du, w3), Qn = (e) => Xr(e, Lu, b3), q = (e) => ku.test(e), un = (e) => en(e, Fu), C3 = (e) => en(e, M3), il = (e) => en(e, Ru), P3 = (e) => en(e, Nu), A3 = (e) => en(e, Du), Xn = (e) => en(e, Lu, !0), Xr = (e, t, r) => {
  const n = Tu.exec(e);
  return n ? n[1] ? t(n[1]) : r(n[2]) : !1;
}, en = (e, t, r = !1) => {
  const n = ku.exec(e);
  return n ? n[1] ? t(n[1]) : r : !1;
}, Ru = (e) => e === "position" || e === "percentage", Du = (e) => e === "image" || e === "url", Nu = (e) => e === "length" || e === "size" || e === "bg-size", Fu = (e) => e === "length", E3 = (e) => e === "number", M3 = (e) => e === "family-name", Lu = (e) => e === "shadow", ll = () => {
  const e = Ie("color"), t = Ie("font"), r = Ie("text"), n = Ie("font-weight"), a = Ie("tracking"), d = Ie("leading"), o = Ie("breakpoint"), i = Ie("container"), l = Ie("spacing"), s = Ie("radius"), u = Ie("shadow"), $ = Ie("inset-shadow"), y = Ie("text-shadow"), h = Ie("drop-shadow"), c = Ie("blur"), p = Ie("perspective"), f = Ie("aspect"), v = Ie("ease"), w = Ie("animate"), m = () => ["auto", "avoid", "all", "avoid-page", "page", "left", "right", "column"], b = () => [
    "center",
    "top",
    "bottom",
    "left",
    "right",
    "top-left",
    // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
    "left-top",
    "top-right",
    // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
    "right-top",
    "bottom-right",
    // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
    "right-bottom",
    "bottom-left",
    // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
    "left-bottom"
  ], _ = () => [...b(), q, z], x = () => ["auto", "hidden", "clip", "visible", "scroll"], A = () => ["auto", "contain", "none"], P = () => [q, z, l], k = () => [Tr, "full", "auto", ...P()], R = () => [Ft, "none", "subgrid", q, z], L = () => ["auto", {
    span: ["full", Ft, q, z]
  }, Ft, q, z], N = () => [Ft, "auto", q, z], U = () => ["auto", "min", "max", "fr", q, z], G = () => ["start", "end", "center", "between", "around", "evenly", "stretch", "baseline", "center-safe", "end-safe"], Y = () => ["start", "end", "center", "stretch", "center-safe", "end-safe"], te = () => ["auto", ...P()], re = () => [Tr, "auto", "full", "dvw", "dvh", "lvw", "lvh", "svw", "svh", "min", "max", "fit", ...P()], M = () => [e, q, z], X = () => [...b(), il, ol, {
    position: [q, z]
  }], ee = () => ["no-repeat", {
    repeat: ["", "x", "y", "space", "round"]
  }], Se = () => ["auto", "cover", "contain", P3, x3, {
    size: [q, z]
  }], he = () => [id, un, ir], ve = () => [
    // Deprecated since Tailwind CSS v4.0.0
    "",
    "none",
    "full",
    s,
    q,
    z
  ], _e = () => ["", ae, un, ir], Re = () => ["solid", "dashed", "dotted", "double"], ke = () => ["normal", "multiply", "screen", "overlay", "darken", "lighten", "color-dodge", "color-burn", "hard-light", "soft-light", "difference", "exclusion", "hue", "saturation", "color", "luminosity"], ce = () => [ae, id, il, ol], Le = () => [
    // Deprecated since Tailwind CSS v4.0.0
    "",
    "none",
    c,
    q,
    z
  ], ge = () => ["none", ae, q, z], W = () => ["none", ae, q, z], oe = () => [ae, q, z], ie = () => [Tr, "full", ...P()];
  return {
    cacheSize: 500,
    theme: {
      animate: ["spin", "ping", "pulse", "bounce"],
      aspect: ["video"],
      blur: [vt],
      breakpoint: [vt],
      color: [y3],
      container: [vt],
      "drop-shadow": [vt],
      ease: ["in", "out", "in-out"],
      font: [_3],
      "font-weight": ["thin", "extralight", "light", "normal", "medium", "semibold", "bold", "extrabold", "black"],
      "inset-shadow": [vt],
      leading: ["none", "tight", "snug", "normal", "relaxed", "loose"],
      perspective: ["dramatic", "near", "normal", "midrange", "distant", "none"],
      radius: [vt],
      shadow: [vt],
      spacing: ["px", ae],
      text: [vt],
      "text-shadow": [vt],
      tracking: ["tighter", "tight", "normal", "wide", "wider", "widest"]
    },
    classGroups: {
      // --------------
      // --- Layout ---
      // --------------
      /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */
      aspect: [{
        aspect: ["auto", "square", Tr, z, q, f]
      }],
      /**
       * Container
       * @see https://tailwindcss.com/docs/container
       * @deprecated since Tailwind CSS v4.0.0
       */
      container: ["container"],
      /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */
      columns: [{
        columns: [ae, z, q, i]
      }],
      /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */
      "break-after": [{
        "break-after": m()
      }],
      /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */
      "break-before": [{
        "break-before": m()
      }],
      /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */
      "break-inside": [{
        "break-inside": ["auto", "avoid", "avoid-page", "avoid-column"]
      }],
      /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */
      "box-decoration": [{
        "box-decoration": ["slice", "clone"]
      }],
      /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */
      box: [{
        box: ["border", "content"]
      }],
      /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */
      display: ["block", "inline-block", "inline", "flex", "inline-flex", "table", "inline-table", "table-caption", "table-cell", "table-column", "table-column-group", "table-footer-group", "table-header-group", "table-row-group", "table-row", "flow-root", "grid", "inline-grid", "contents", "list-item", "hidden"],
      /**
       * Screen Reader Only
       * @see https://tailwindcss.com/docs/display#screen-reader-only
       */
      sr: ["sr-only", "not-sr-only"],
      /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */
      float: [{
        float: ["right", "left", "none", "start", "end"]
      }],
      /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */
      clear: [{
        clear: ["left", "right", "both", "none", "start", "end"]
      }],
      /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */
      isolation: ["isolate", "isolation-auto"],
      /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */
      "object-fit": [{
        object: ["contain", "cover", "fill", "none", "scale-down"]
      }],
      /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */
      "object-position": [{
        object: _()
      }],
      /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */
      overflow: [{
        overflow: x()
      }],
      /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-x": [{
        "overflow-x": x()
      }],
      /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-y": [{
        "overflow-y": x()
      }],
      /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      overscroll: [{
        overscroll: A()
      }],
      /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-x": [{
        "overscroll-x": A()
      }],
      /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-y": [{
        "overscroll-y": A()
      }],
      /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */
      position: ["static", "fixed", "absolute", "relative", "sticky"],
      /**
       * Top / Right / Bottom / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      inset: [{
        inset: k()
      }],
      /**
       * Right / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-x": [{
        "inset-x": k()
      }],
      /**
       * Top / Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-y": [{
        "inset-y": k()
      }],
      /**
       * Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      start: [{
        start: k()
      }],
      /**
       * End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      end: [{
        end: k()
      }],
      /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      top: [{
        top: k()
      }],
      /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      right: [{
        right: k()
      }],
      /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      bottom: [{
        bottom: k()
      }],
      /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      left: [{
        left: k()
      }],
      /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */
      visibility: ["visible", "invisible", "collapse"],
      /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */
      z: [{
        z: [Ft, "auto", q, z]
      }],
      // ------------------------
      // --- Flexbox and Grid ---
      // ------------------------
      /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */
      basis: [{
        basis: [Tr, "full", "auto", i, ...P()]
      }],
      /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */
      "flex-direction": [{
        flex: ["row", "row-reverse", "col", "col-reverse"]
      }],
      /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */
      "flex-wrap": [{
        flex: ["nowrap", "wrap", "wrap-reverse"]
      }],
      /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */
      flex: [{
        flex: [ae, Tr, "auto", "initial", "none", z]
      }],
      /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */
      grow: [{
        grow: ["", ae, q, z]
      }],
      /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */
      shrink: [{
        shrink: ["", ae, q, z]
      }],
      /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */
      order: [{
        order: [Ft, "first", "last", "none", q, z]
      }],
      /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */
      "grid-cols": [{
        "grid-cols": R()
      }],
      /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start-end": [{
        col: L()
      }],
      /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start": [{
        "col-start": N()
      }],
      /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-end": [{
        "col-end": N()
      }],
      /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */
      "grid-rows": [{
        "grid-rows": R()
      }],
      /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start-end": [{
        row: L()
      }],
      /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start": [{
        "row-start": N()
      }],
      /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-end": [{
        "row-end": N()
      }],
      /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */
      "grid-flow": [{
        "grid-flow": ["row", "col", "dense", "row-dense", "col-dense"]
      }],
      /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */
      "auto-cols": [{
        "auto-cols": U()
      }],
      /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */
      "auto-rows": [{
        "auto-rows": U()
      }],
      /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */
      gap: [{
        gap: P()
      }],
      /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-x": [{
        "gap-x": P()
      }],
      /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-y": [{
        "gap-y": P()
      }],
      /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */
      "justify-content": [{
        justify: [...G(), "normal"]
      }],
      /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */
      "justify-items": [{
        "justify-items": [...Y(), "normal"]
      }],
      /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */
      "justify-self": [{
        "justify-self": ["auto", ...Y()]
      }],
      /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */
      "align-content": [{
        content: ["normal", ...G()]
      }],
      /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */
      "align-items": [{
        items: [...Y(), {
          baseline: ["", "last"]
        }]
      }],
      /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */
      "align-self": [{
        self: ["auto", ...Y(), {
          baseline: ["", "last"]
        }]
      }],
      /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */
      "place-content": [{
        "place-content": G()
      }],
      /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */
      "place-items": [{
        "place-items": [...Y(), "baseline"]
      }],
      /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */
      "place-self": [{
        "place-self": ["auto", ...Y()]
      }],
      // Spacing
      /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */
      p: [{
        p: P()
      }],
      /**
       * Padding X
       * @see https://tailwindcss.com/docs/padding
       */
      px: [{
        px: P()
      }],
      /**
       * Padding Y
       * @see https://tailwindcss.com/docs/padding
       */
      py: [{
        py: P()
      }],
      /**
       * Padding Start
       * @see https://tailwindcss.com/docs/padding
       */
      ps: [{
        ps: P()
      }],
      /**
       * Padding End
       * @see https://tailwindcss.com/docs/padding
       */
      pe: [{
        pe: P()
      }],
      /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */
      pt: [{
        pt: P()
      }],
      /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */
      pr: [{
        pr: P()
      }],
      /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */
      pb: [{
        pb: P()
      }],
      /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */
      pl: [{
        pl: P()
      }],
      /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */
      m: [{
        m: te()
      }],
      /**
       * Margin X
       * @see https://tailwindcss.com/docs/margin
       */
      mx: [{
        mx: te()
      }],
      /**
       * Margin Y
       * @see https://tailwindcss.com/docs/margin
       */
      my: [{
        my: te()
      }],
      /**
       * Margin Start
       * @see https://tailwindcss.com/docs/margin
       */
      ms: [{
        ms: te()
      }],
      /**
       * Margin End
       * @see https://tailwindcss.com/docs/margin
       */
      me: [{
        me: te()
      }],
      /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */
      mt: [{
        mt: te()
      }],
      /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */
      mr: [{
        mr: te()
      }],
      /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */
      mb: [{
        mb: te()
      }],
      /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */
      ml: [{
        ml: te()
      }],
      /**
       * Space Between X
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */
      "space-x": [{
        "space-x": P()
      }],
      /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */
      "space-x-reverse": ["space-x-reverse"],
      /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */
      "space-y": [{
        "space-y": P()
      }],
      /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */
      "space-y-reverse": ["space-y-reverse"],
      // --------------
      // --- Sizing ---
      // --------------
      /**
       * Size
       * @see https://tailwindcss.com/docs/width#setting-both-width-and-height
       */
      size: [{
        size: re()
      }],
      /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */
      w: [{
        w: [i, "screen", ...re()]
      }],
      /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */
      "min-w": [{
        "min-w": [
          i,
          "screen",
          /** Deprecated. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */
          "none",
          ...re()
        ]
      }],
      /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */
      "max-w": [{
        "max-w": [
          i,
          "screen",
          "none",
          /** Deprecated since Tailwind CSS v4.0.0. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */
          "prose",
          /** Deprecated since Tailwind CSS v4.0.0. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */
          {
            screen: [o]
          },
          ...re()
        ]
      }],
      /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */
      h: [{
        h: ["screen", "lh", ...re()]
      }],
      /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */
      "min-h": [{
        "min-h": ["screen", "lh", "none", ...re()]
      }],
      /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */
      "max-h": [{
        "max-h": ["screen", "lh", ...re()]
      }],
      // ------------------
      // --- Typography ---
      // ------------------
      /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */
      "font-size": [{
        text: ["base", r, un, ir]
      }],
      /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */
      "font-smoothing": ["antialiased", "subpixel-antialiased"],
      /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */
      "font-style": ["italic", "not-italic"],
      /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */
      "font-weight": [{
        font: [n, q, ld]
      }],
      /**
       * Font Stretch
       * @see https://tailwindcss.com/docs/font-stretch
       */
      "font-stretch": [{
        "font-stretch": ["ultra-condensed", "extra-condensed", "condensed", "semi-condensed", "normal", "semi-expanded", "expanded", "extra-expanded", "ultra-expanded", id, z]
      }],
      /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */
      "font-family": [{
        font: [C3, z, t]
      }],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-normal": ["normal-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-ordinal": ["ordinal"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-slashed-zero": ["slashed-zero"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-figure": ["lining-nums", "oldstyle-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-spacing": ["proportional-nums", "tabular-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-fraction": ["diagonal-fractions", "stacked-fractions"],
      /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */
      tracking: [{
        tracking: [a, q, z]
      }],
      /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */
      "line-clamp": [{
        "line-clamp": [ae, "none", q, ld]
      }],
      /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */
      leading: [{
        leading: [
          /** Deprecated since Tailwind CSS v4.0.0. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */
          d,
          ...P()
        ]
      }],
      /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */
      "list-image": [{
        "list-image": ["none", q, z]
      }],
      /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */
      "list-style-position": [{
        list: ["inside", "outside"]
      }],
      /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */
      "list-style-type": [{
        list: ["disc", "decimal", "none", q, z]
      }],
      /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */
      "text-alignment": [{
        text: ["left", "center", "right", "justify", "start", "end"]
      }],
      /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://v3.tailwindcss.com/docs/placeholder-color
       */
      "placeholder-color": [{
        placeholder: M()
      }],
      /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */
      "text-color": [{
        text: M()
      }],
      /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */
      "text-decoration": ["underline", "overline", "line-through", "no-underline"],
      /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */
      "text-decoration-style": [{
        decoration: [...Re(), "wavy"]
      }],
      /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */
      "text-decoration-thickness": [{
        decoration: [ae, "from-font", "auto", q, ir]
      }],
      /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */
      "text-decoration-color": [{
        decoration: M()
      }],
      /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */
      "underline-offset": [{
        "underline-offset": [ae, "auto", q, z]
      }],
      /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */
      "text-transform": ["uppercase", "lowercase", "capitalize", "normal-case"],
      /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */
      "text-overflow": ["truncate", "text-ellipsis", "text-clip"],
      /**
       * Text Wrap
       * @see https://tailwindcss.com/docs/text-wrap
       */
      "text-wrap": [{
        text: ["wrap", "nowrap", "balance", "pretty"]
      }],
      /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */
      indent: [{
        indent: P()
      }],
      /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */
      "vertical-align": [{
        align: ["baseline", "top", "middle", "bottom", "text-top", "text-bottom", "sub", "super", q, z]
      }],
      /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */
      whitespace: [{
        whitespace: ["normal", "nowrap", "pre", "pre-line", "pre-wrap", "break-spaces"]
      }],
      /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */
      break: [{
        break: ["normal", "words", "all", "keep"]
      }],
      /**
       * Overflow Wrap
       * @see https://tailwindcss.com/docs/overflow-wrap
       */
      wrap: [{
        wrap: ["break-word", "anywhere", "normal"]
      }],
      /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */
      hyphens: [{
        hyphens: ["none", "manual", "auto"]
      }],
      /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */
      content: [{
        content: ["none", q, z]
      }],
      // -------------------
      // --- Backgrounds ---
      // -------------------
      /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */
      "bg-attachment": [{
        bg: ["fixed", "local", "scroll"]
      }],
      /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */
      "bg-clip": [{
        "bg-clip": ["border", "padding", "content", "text"]
      }],
      /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */
      "bg-origin": [{
        "bg-origin": ["border", "padding", "content"]
      }],
      /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */
      "bg-position": [{
        bg: X()
      }],
      /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */
      "bg-repeat": [{
        bg: ee()
      }],
      /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */
      "bg-size": [{
        bg: Se()
      }],
      /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */
      "bg-image": [{
        bg: ["none", {
          linear: [{
            to: ["t", "tr", "r", "br", "b", "bl", "l", "tl"]
          }, Ft, q, z],
          radial: ["", q, z],
          conic: [Ft, q, z]
        }, A3, S3]
      }],
      /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */
      "bg-color": [{
        bg: M()
      }],
      /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from-pos": [{
        from: he()
      }],
      /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via-pos": [{
        via: he()
      }],
      /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to-pos": [{
        to: he()
      }],
      /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from": [{
        from: M()
      }],
      /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via": [{
        via: M()
      }],
      /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to": [{
        to: M()
      }],
      // ---------------
      // --- Borders ---
      // ---------------
      /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */
      rounded: [{
        rounded: ve()
      }],
      /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-s": [{
        "rounded-s": ve()
      }],
      /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-e": [{
        "rounded-e": ve()
      }],
      /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-t": [{
        "rounded-t": ve()
      }],
      /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-r": [{
        "rounded-r": ve()
      }],
      /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-b": [{
        "rounded-b": ve()
      }],
      /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-l": [{
        "rounded-l": ve()
      }],
      /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ss": [{
        "rounded-ss": ve()
      }],
      /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-se": [{
        "rounded-se": ve()
      }],
      /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ee": [{
        "rounded-ee": ve()
      }],
      /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-es": [{
        "rounded-es": ve()
      }],
      /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tl": [{
        "rounded-tl": ve()
      }],
      /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tr": [{
        "rounded-tr": ve()
      }],
      /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-br": [{
        "rounded-br": ve()
      }],
      /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-bl": [{
        "rounded-bl": ve()
      }],
      /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w": [{
        border: _e()
      }],
      /**
       * Border Width X
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-x": [{
        "border-x": _e()
      }],
      /**
       * Border Width Y
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-y": [{
        "border-y": _e()
      }],
      /**
       * Border Width Start
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-s": [{
        "border-s": _e()
      }],
      /**
       * Border Width End
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-e": [{
        "border-e": _e()
      }],
      /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-t": [{
        "border-t": _e()
      }],
      /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-r": [{
        "border-r": _e()
      }],
      /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-b": [{
        "border-b": _e()
      }],
      /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-l": [{
        "border-l": _e()
      }],
      /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/border-width#between-children
       */
      "divide-x": [{
        "divide-x": _e()
      }],
      /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/border-width#between-children
       */
      "divide-x-reverse": ["divide-x-reverse"],
      /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/border-width#between-children
       */
      "divide-y": [{
        "divide-y": _e()
      }],
      /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/border-width#between-children
       */
      "divide-y-reverse": ["divide-y-reverse"],
      /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */
      "border-style": [{
        border: [...Re(), "hidden", "none"]
      }],
      /**
       * Divide Style
       * @see https://tailwindcss.com/docs/border-style#setting-the-divider-style
       */
      "divide-style": [{
        divide: [...Re(), "hidden", "none"]
      }],
      /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color": [{
        border: M()
      }],
      /**
       * Border Color X
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-x": [{
        "border-x": M()
      }],
      /**
       * Border Color Y
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-y": [{
        "border-y": M()
      }],
      /**
       * Border Color S
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-s": [{
        "border-s": M()
      }],
      /**
       * Border Color E
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-e": [{
        "border-e": M()
      }],
      /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-t": [{
        "border-t": M()
      }],
      /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-r": [{
        "border-r": M()
      }],
      /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-b": [{
        "border-b": M()
      }],
      /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-l": [{
        "border-l": M()
      }],
      /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */
      "divide-color": [{
        divide: M()
      }],
      /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */
      "outline-style": [{
        outline: [...Re(), "none", "hidden"]
      }],
      /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */
      "outline-offset": [{
        "outline-offset": [ae, q, z]
      }],
      /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */
      "outline-w": [{
        outline: ["", ae, un, ir]
      }],
      /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */
      "outline-color": [{
        outline: M()
      }],
      // ---------------
      // --- Effects ---
      // ---------------
      /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */
      shadow: [{
        shadow: [
          // Deprecated since Tailwind CSS v4.0.0
          "",
          "none",
          u,
          Xn,
          Qn
        ]
      }],
      /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-shadow-color
       */
      "shadow-color": [{
        shadow: M()
      }],
      /**
       * Inset Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow#adding-an-inset-shadow
       */
      "inset-shadow": [{
        "inset-shadow": ["none", $, Xn, Qn]
      }],
      /**
       * Inset Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-inset-shadow-color
       */
      "inset-shadow-color": [{
        "inset-shadow": M()
      }],
      /**
       * Ring Width
       * @see https://tailwindcss.com/docs/box-shadow#adding-a-ring
       */
      "ring-w": [{
        ring: _e()
      }],
      /**
       * Ring Width Inset
       * @see https://v3.tailwindcss.com/docs/ring-width#inset-rings
       * @deprecated since Tailwind CSS v4.0.0
       * @see https://github.com/tailwindlabs/tailwindcss/blob/v4.0.0/packages/tailwindcss/src/utilities.ts#L4158
       */
      "ring-w-inset": ["ring-inset"],
      /**
       * Ring Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-ring-color
       */
      "ring-color": [{
        ring: M()
      }],
      /**
       * Ring Offset Width
       * @see https://v3.tailwindcss.com/docs/ring-offset-width
       * @deprecated since Tailwind CSS v4.0.0
       * @see https://github.com/tailwindlabs/tailwindcss/blob/v4.0.0/packages/tailwindcss/src/utilities.ts#L4158
       */
      "ring-offset-w": [{
        "ring-offset": [ae, ir]
      }],
      /**
       * Ring Offset Color
       * @see https://v3.tailwindcss.com/docs/ring-offset-color
       * @deprecated since Tailwind CSS v4.0.0
       * @see https://github.com/tailwindlabs/tailwindcss/blob/v4.0.0/packages/tailwindcss/src/utilities.ts#L4158
       */
      "ring-offset-color": [{
        "ring-offset": M()
      }],
      /**
       * Inset Ring Width
       * @see https://tailwindcss.com/docs/box-shadow#adding-an-inset-ring
       */
      "inset-ring-w": [{
        "inset-ring": _e()
      }],
      /**
       * Inset Ring Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-inset-ring-color
       */
      "inset-ring-color": [{
        "inset-ring": M()
      }],
      /**
       * Text Shadow
       * @see https://tailwindcss.com/docs/text-shadow
       */
      "text-shadow": [{
        "text-shadow": ["none", y, Xn, Qn]
      }],
      /**
       * Text Shadow Color
       * @see https://tailwindcss.com/docs/text-shadow#setting-the-shadow-color
       */
      "text-shadow-color": [{
        "text-shadow": M()
      }],
      /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */
      opacity: [{
        opacity: [ae, q, z]
      }],
      /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */
      "mix-blend": [{
        "mix-blend": [...ke(), "plus-darker", "plus-lighter"]
      }],
      /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */
      "bg-blend": [{
        "bg-blend": ke()
      }],
      /**
       * Mask Clip
       * @see https://tailwindcss.com/docs/mask-clip
       */
      "mask-clip": [{
        "mask-clip": ["border", "padding", "content", "fill", "stroke", "view"]
      }, "mask-no-clip"],
      /**
       * Mask Composite
       * @see https://tailwindcss.com/docs/mask-composite
       */
      "mask-composite": [{
        mask: ["add", "subtract", "intersect", "exclude"]
      }],
      /**
       * Mask Image
       * @see https://tailwindcss.com/docs/mask-image
       */
      "mask-image-linear-pos": [{
        "mask-linear": [ae]
      }],
      "mask-image-linear-from-pos": [{
        "mask-linear-from": ce()
      }],
      "mask-image-linear-to-pos": [{
        "mask-linear-to": ce()
      }],
      "mask-image-linear-from-color": [{
        "mask-linear-from": M()
      }],
      "mask-image-linear-to-color": [{
        "mask-linear-to": M()
      }],
      "mask-image-t-from-pos": [{
        "mask-t-from": ce()
      }],
      "mask-image-t-to-pos": [{
        "mask-t-to": ce()
      }],
      "mask-image-t-from-color": [{
        "mask-t-from": M()
      }],
      "mask-image-t-to-color": [{
        "mask-t-to": M()
      }],
      "mask-image-r-from-pos": [{
        "mask-r-from": ce()
      }],
      "mask-image-r-to-pos": [{
        "mask-r-to": ce()
      }],
      "mask-image-r-from-color": [{
        "mask-r-from": M()
      }],
      "mask-image-r-to-color": [{
        "mask-r-to": M()
      }],
      "mask-image-b-from-pos": [{
        "mask-b-from": ce()
      }],
      "mask-image-b-to-pos": [{
        "mask-b-to": ce()
      }],
      "mask-image-b-from-color": [{
        "mask-b-from": M()
      }],
      "mask-image-b-to-color": [{
        "mask-b-to": M()
      }],
      "mask-image-l-from-pos": [{
        "mask-l-from": ce()
      }],
      "mask-image-l-to-pos": [{
        "mask-l-to": ce()
      }],
      "mask-image-l-from-color": [{
        "mask-l-from": M()
      }],
      "mask-image-l-to-color": [{
        "mask-l-to": M()
      }],
      "mask-image-x-from-pos": [{
        "mask-x-from": ce()
      }],
      "mask-image-x-to-pos": [{
        "mask-x-to": ce()
      }],
      "mask-image-x-from-color": [{
        "mask-x-from": M()
      }],
      "mask-image-x-to-color": [{
        "mask-x-to": M()
      }],
      "mask-image-y-from-pos": [{
        "mask-y-from": ce()
      }],
      "mask-image-y-to-pos": [{
        "mask-y-to": ce()
      }],
      "mask-image-y-from-color": [{
        "mask-y-from": M()
      }],
      "mask-image-y-to-color": [{
        "mask-y-to": M()
      }],
      "mask-image-radial": [{
        "mask-radial": [q, z]
      }],
      "mask-image-radial-from-pos": [{
        "mask-radial-from": ce()
      }],
      "mask-image-radial-to-pos": [{
        "mask-radial-to": ce()
      }],
      "mask-image-radial-from-color": [{
        "mask-radial-from": M()
      }],
      "mask-image-radial-to-color": [{
        "mask-radial-to": M()
      }],
      "mask-image-radial-shape": [{
        "mask-radial": ["circle", "ellipse"]
      }],
      "mask-image-radial-size": [{
        "mask-radial": [{
          closest: ["side", "corner"],
          farthest: ["side", "corner"]
        }]
      }],
      "mask-image-radial-pos": [{
        "mask-radial-at": b()
      }],
      "mask-image-conic-pos": [{
        "mask-conic": [ae]
      }],
      "mask-image-conic-from-pos": [{
        "mask-conic-from": ce()
      }],
      "mask-image-conic-to-pos": [{
        "mask-conic-to": ce()
      }],
      "mask-image-conic-from-color": [{
        "mask-conic-from": M()
      }],
      "mask-image-conic-to-color": [{
        "mask-conic-to": M()
      }],
      /**
       * Mask Mode
       * @see https://tailwindcss.com/docs/mask-mode
       */
      "mask-mode": [{
        mask: ["alpha", "luminance", "match"]
      }],
      /**
       * Mask Origin
       * @see https://tailwindcss.com/docs/mask-origin
       */
      "mask-origin": [{
        "mask-origin": ["border", "padding", "content", "fill", "stroke", "view"]
      }],
      /**
       * Mask Position
       * @see https://tailwindcss.com/docs/mask-position
       */
      "mask-position": [{
        mask: X()
      }],
      /**
       * Mask Repeat
       * @see https://tailwindcss.com/docs/mask-repeat
       */
      "mask-repeat": [{
        mask: ee()
      }],
      /**
       * Mask Size
       * @see https://tailwindcss.com/docs/mask-size
       */
      "mask-size": [{
        mask: Se()
      }],
      /**
       * Mask Type
       * @see https://tailwindcss.com/docs/mask-type
       */
      "mask-type": [{
        "mask-type": ["alpha", "luminance"]
      }],
      /**
       * Mask Image
       * @see https://tailwindcss.com/docs/mask-image
       */
      "mask-image": [{
        mask: ["none", q, z]
      }],
      // ---------------
      // --- Filters ---
      // ---------------
      /**
       * Filter
       * @see https://tailwindcss.com/docs/filter
       */
      filter: [{
        filter: [
          // Deprecated since Tailwind CSS v3.0.0
          "",
          "none",
          q,
          z
        ]
      }],
      /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */
      blur: [{
        blur: Le()
      }],
      /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */
      brightness: [{
        brightness: [ae, q, z]
      }],
      /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */
      contrast: [{
        contrast: [ae, q, z]
      }],
      /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */
      "drop-shadow": [{
        "drop-shadow": [
          // Deprecated since Tailwind CSS v4.0.0
          "",
          "none",
          h,
          Xn,
          Qn
        ]
      }],
      /**
       * Drop Shadow Color
       * @see https://tailwindcss.com/docs/filter-drop-shadow#setting-the-shadow-color
       */
      "drop-shadow-color": [{
        "drop-shadow": M()
      }],
      /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */
      grayscale: [{
        grayscale: ["", ae, q, z]
      }],
      /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */
      "hue-rotate": [{
        "hue-rotate": [ae, q, z]
      }],
      /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */
      invert: [{
        invert: ["", ae, q, z]
      }],
      /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */
      saturate: [{
        saturate: [ae, q, z]
      }],
      /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */
      sepia: [{
        sepia: ["", ae, q, z]
      }],
      /**
       * Backdrop Filter
       * @see https://tailwindcss.com/docs/backdrop-filter
       */
      "backdrop-filter": [{
        "backdrop-filter": [
          // Deprecated since Tailwind CSS v3.0.0
          "",
          "none",
          q,
          z
        ]
      }],
      /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */
      "backdrop-blur": [{
        "backdrop-blur": Le()
      }],
      /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */
      "backdrop-brightness": [{
        "backdrop-brightness": [ae, q, z]
      }],
      /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */
      "backdrop-contrast": [{
        "backdrop-contrast": [ae, q, z]
      }],
      /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */
      "backdrop-grayscale": [{
        "backdrop-grayscale": ["", ae, q, z]
      }],
      /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */
      "backdrop-hue-rotate": [{
        "backdrop-hue-rotate": [ae, q, z]
      }],
      /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */
      "backdrop-invert": [{
        "backdrop-invert": ["", ae, q, z]
      }],
      /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */
      "backdrop-opacity": [{
        "backdrop-opacity": [ae, q, z]
      }],
      /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */
      "backdrop-saturate": [{
        "backdrop-saturate": [ae, q, z]
      }],
      /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */
      "backdrop-sepia": [{
        "backdrop-sepia": ["", ae, q, z]
      }],
      // --------------
      // --- Tables ---
      // --------------
      /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */
      "border-collapse": [{
        border: ["collapse", "separate"]
      }],
      /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing": [{
        "border-spacing": P()
      }],
      /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-x": [{
        "border-spacing-x": P()
      }],
      /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-y": [{
        "border-spacing-y": P()
      }],
      /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */
      "table-layout": [{
        table: ["auto", "fixed"]
      }],
      /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */
      caption: [{
        caption: ["top", "bottom"]
      }],
      // ---------------------------------
      // --- Transitions and Animation ---
      // ---------------------------------
      /**
       * Transition Property
       * @see https://tailwindcss.com/docs/transition-property
       */
      transition: [{
        transition: ["", "all", "colors", "opacity", "shadow", "transform", "none", q, z]
      }],
      /**
       * Transition Behavior
       * @see https://tailwindcss.com/docs/transition-behavior
       */
      "transition-behavior": [{
        transition: ["normal", "discrete"]
      }],
      /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */
      duration: [{
        duration: [ae, "initial", q, z]
      }],
      /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */
      ease: [{
        ease: ["linear", "initial", v, q, z]
      }],
      /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */
      delay: [{
        delay: [ae, q, z]
      }],
      /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */
      animate: [{
        animate: ["none", w, q, z]
      }],
      // ------------------
      // --- Transforms ---
      // ------------------
      /**
       * Backface Visibility
       * @see https://tailwindcss.com/docs/backface-visibility
       */
      backface: [{
        backface: ["hidden", "visible"]
      }],
      /**
       * Perspective
       * @see https://tailwindcss.com/docs/perspective
       */
      perspective: [{
        perspective: [p, q, z]
      }],
      /**
       * Perspective Origin
       * @see https://tailwindcss.com/docs/perspective-origin
       */
      "perspective-origin": [{
        "perspective-origin": _()
      }],
      /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */
      rotate: [{
        rotate: ge()
      }],
      /**
       * Rotate X
       * @see https://tailwindcss.com/docs/rotate
       */
      "rotate-x": [{
        "rotate-x": ge()
      }],
      /**
       * Rotate Y
       * @see https://tailwindcss.com/docs/rotate
       */
      "rotate-y": [{
        "rotate-y": ge()
      }],
      /**
       * Rotate Z
       * @see https://tailwindcss.com/docs/rotate
       */
      "rotate-z": [{
        "rotate-z": ge()
      }],
      /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */
      scale: [{
        scale: W()
      }],
      /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-x": [{
        "scale-x": W()
      }],
      /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-y": [{
        "scale-y": W()
      }],
      /**
       * Scale Z
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-z": [{
        "scale-z": W()
      }],
      /**
       * Scale 3D
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-3d": ["scale-3d"],
      /**
       * Skew
       * @see https://tailwindcss.com/docs/skew
       */
      skew: [{
        skew: oe()
      }],
      /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-x": [{
        "skew-x": oe()
      }],
      /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-y": [{
        "skew-y": oe()
      }],
      /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */
      transform: [{
        transform: [q, z, "", "none", "gpu", "cpu"]
      }],
      /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */
      "transform-origin": [{
        origin: _()
      }],
      /**
       * Transform Style
       * @see https://tailwindcss.com/docs/transform-style
       */
      "transform-style": [{
        transform: ["3d", "flat"]
      }],
      /**
       * Translate
       * @see https://tailwindcss.com/docs/translate
       */
      translate: [{
        translate: ie()
      }],
      /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-x": [{
        "translate-x": ie()
      }],
      /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-y": [{
        "translate-y": ie()
      }],
      /**
       * Translate Z
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-z": [{
        "translate-z": ie()
      }],
      /**
       * Translate None
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-none": ["translate-none"],
      // ---------------------
      // --- Interactivity ---
      // ---------------------
      /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */
      accent: [{
        accent: M()
      }],
      /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */
      appearance: [{
        appearance: ["none", "auto"]
      }],
      /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */
      "caret-color": [{
        caret: M()
      }],
      /**
       * Color Scheme
       * @see https://tailwindcss.com/docs/color-scheme
       */
      "color-scheme": [{
        scheme: ["normal", "dark", "light", "light-dark", "only-dark", "only-light"]
      }],
      /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */
      cursor: [{
        cursor: ["auto", "default", "pointer", "wait", "text", "move", "help", "not-allowed", "none", "context-menu", "progress", "cell", "crosshair", "vertical-text", "alias", "copy", "no-drop", "grab", "grabbing", "all-scroll", "col-resize", "row-resize", "n-resize", "e-resize", "s-resize", "w-resize", "ne-resize", "nw-resize", "se-resize", "sw-resize", "ew-resize", "ns-resize", "nesw-resize", "nwse-resize", "zoom-in", "zoom-out", q, z]
      }],
      /**
       * Field Sizing
       * @see https://tailwindcss.com/docs/field-sizing
       */
      "field-sizing": [{
        "field-sizing": ["fixed", "content"]
      }],
      /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */
      "pointer-events": [{
        "pointer-events": ["auto", "none"]
      }],
      /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */
      resize: [{
        resize: ["none", "", "y", "x"]
      }],
      /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */
      "scroll-behavior": [{
        scroll: ["auto", "smooth"]
      }],
      /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-m": [{
        "scroll-m": P()
      }],
      /**
       * Scroll Margin X
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mx": [{
        "scroll-mx": P()
      }],
      /**
       * Scroll Margin Y
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-my": [{
        "scroll-my": P()
      }],
      /**
       * Scroll Margin Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ms": [{
        "scroll-ms": P()
      }],
      /**
       * Scroll Margin End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-me": [{
        "scroll-me": P()
      }],
      /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mt": [{
        "scroll-mt": P()
      }],
      /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mr": [{
        "scroll-mr": P()
      }],
      /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mb": [{
        "scroll-mb": P()
      }],
      /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ml": [{
        "scroll-ml": P()
      }],
      /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-p": [{
        "scroll-p": P()
      }],
      /**
       * Scroll Padding X
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-px": [{
        "scroll-px": P()
      }],
      /**
       * Scroll Padding Y
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-py": [{
        "scroll-py": P()
      }],
      /**
       * Scroll Padding Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-ps": [{
        "scroll-ps": P()
      }],
      /**
       * Scroll Padding End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pe": [{
        "scroll-pe": P()
      }],
      /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pt": [{
        "scroll-pt": P()
      }],
      /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pr": [{
        "scroll-pr": P()
      }],
      /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pb": [{
        "scroll-pb": P()
      }],
      /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pl": [{
        "scroll-pl": P()
      }],
      /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */
      "snap-align": [{
        snap: ["start", "end", "center", "align-none"]
      }],
      /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */
      "snap-stop": [{
        snap: ["normal", "always"]
      }],
      /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-type": [{
        snap: ["none", "x", "y", "both"]
      }],
      /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-strictness": [{
        snap: ["mandatory", "proximity"]
      }],
      /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */
      touch: [{
        touch: ["auto", "none", "manipulation"]
      }],
      /**
       * Touch Action X
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-x": [{
        "touch-pan": ["x", "left", "right"]
      }],
      /**
       * Touch Action Y
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-y": [{
        "touch-pan": ["y", "up", "down"]
      }],
      /**
       * Touch Action Pinch Zoom
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-pz": ["touch-pinch-zoom"],
      /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */
      select: [{
        select: ["none", "text", "all", "auto"]
      }],
      /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */
      "will-change": [{
        "will-change": ["auto", "scroll", "contents", "transform", q, z]
      }],
      // -----------
      // --- SVG ---
      // -----------
      /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */
      fill: [{
        fill: ["none", ...M()]
      }],
      /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */
      "stroke-w": [{
        stroke: [ae, un, ir, ld]
      }],
      /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */
      stroke: [{
        stroke: ["none", ...M()]
      }],
      // ---------------------
      // --- Accessibility ---
      // ---------------------
      /**
       * Forced Color Adjust
       * @see https://tailwindcss.com/docs/forced-color-adjust
       */
      "forced-color-adjust": [{
        "forced-color-adjust": ["auto", "none"]
      }]
    },
    conflictingClassGroups: {
      overflow: ["overflow-x", "overflow-y"],
      overscroll: ["overscroll-x", "overscroll-y"],
      inset: ["inset-x", "inset-y", "start", "end", "top", "right", "bottom", "left"],
      "inset-x": ["right", "left"],
      "inset-y": ["top", "bottom"],
      flex: ["basis", "grow", "shrink"],
      gap: ["gap-x", "gap-y"],
      p: ["px", "py", "ps", "pe", "pt", "pr", "pb", "pl"],
      px: ["pr", "pl"],
      py: ["pt", "pb"],
      m: ["mx", "my", "ms", "me", "mt", "mr", "mb", "ml"],
      mx: ["mr", "ml"],
      my: ["mt", "mb"],
      size: ["w", "h"],
      "font-size": ["leading"],
      "fvn-normal": ["fvn-ordinal", "fvn-slashed-zero", "fvn-figure", "fvn-spacing", "fvn-fraction"],
      "fvn-ordinal": ["fvn-normal"],
      "fvn-slashed-zero": ["fvn-normal"],
      "fvn-figure": ["fvn-normal"],
      "fvn-spacing": ["fvn-normal"],
      "fvn-fraction": ["fvn-normal"],
      "line-clamp": ["display", "overflow"],
      rounded: ["rounded-s", "rounded-e", "rounded-t", "rounded-r", "rounded-b", "rounded-l", "rounded-ss", "rounded-se", "rounded-ee", "rounded-es", "rounded-tl", "rounded-tr", "rounded-br", "rounded-bl"],
      "rounded-s": ["rounded-ss", "rounded-es"],
      "rounded-e": ["rounded-se", "rounded-ee"],
      "rounded-t": ["rounded-tl", "rounded-tr"],
      "rounded-r": ["rounded-tr", "rounded-br"],
      "rounded-b": ["rounded-br", "rounded-bl"],
      "rounded-l": ["rounded-tl", "rounded-bl"],
      "border-spacing": ["border-spacing-x", "border-spacing-y"],
      "border-w": ["border-w-x", "border-w-y", "border-w-s", "border-w-e", "border-w-t", "border-w-r", "border-w-b", "border-w-l"],
      "border-w-x": ["border-w-r", "border-w-l"],
      "border-w-y": ["border-w-t", "border-w-b"],
      "border-color": ["border-color-x", "border-color-y", "border-color-s", "border-color-e", "border-color-t", "border-color-r", "border-color-b", "border-color-l"],
      "border-color-x": ["border-color-r", "border-color-l"],
      "border-color-y": ["border-color-t", "border-color-b"],
      translate: ["translate-x", "translate-y", "translate-none"],
      "translate-none": ["translate", "translate-x", "translate-y", "translate-z"],
      "scroll-m": ["scroll-mx", "scroll-my", "scroll-ms", "scroll-me", "scroll-mt", "scroll-mr", "scroll-mb", "scroll-ml"],
      "scroll-mx": ["scroll-mr", "scroll-ml"],
      "scroll-my": ["scroll-mt", "scroll-mb"],
      "scroll-p": ["scroll-px", "scroll-py", "scroll-ps", "scroll-pe", "scroll-pt", "scroll-pr", "scroll-pb", "scroll-pl"],
      "scroll-px": ["scroll-pr", "scroll-pl"],
      "scroll-py": ["scroll-pt", "scroll-pb"],
      touch: ["touch-x", "touch-y", "touch-pz"],
      "touch-x": ["touch"],
      "touch-y": ["touch"],
      "touch-pz": ["touch"]
    },
    conflictingClassGroupModifiers: {
      "font-size": ["leading"]
    },
    orderSensitiveModifiers: ["*", "**", "after", "backdrop", "before", "details-content", "file", "first-letter", "first-line", "marker", "placeholder", "selection"]
  };
}, O3 = (e, {
  cacheSize: t,
  prefix: r,
  experimentalParseClassName: n,
  extend: a = {},
  override: d = {}
}) => (mn(e, "cacheSize", t), mn(e, "prefix", r), mn(e, "experimentalParseClassName", n), ea(e.theme, d.theme), ea(e.classGroups, d.classGroups), ea(e.conflictingClassGroups, d.conflictingClassGroups), ea(e.conflictingClassGroupModifiers, d.conflictingClassGroupModifiers), mn(e, "orderSensitiveModifiers", d.orderSensitiveModifiers), ta(e.theme, a.theme), ta(e.classGroups, a.classGroups), ta(e.conflictingClassGroups, a.conflictingClassGroups), ta(e.conflictingClassGroupModifiers, a.conflictingClassGroupModifiers), Bu(e, a, "orderSensitiveModifiers"), e), mn = (e, t, r) => {
  r !== void 0 && (e[t] = r);
}, ea = (e, t) => {
  if (t)
    for (const r in t)
      mn(e, r, t[r]);
}, ta = (e, t) => {
  if (t)
    for (const r in t)
      Bu(e, t, r);
}, Bu = (e, t, r) => {
  const n = t[r];
  n !== void 0 && (e[r] = e[r] ? e[r].concat(n) : n);
}, T3 = (e, ...t) => typeof e == "function" ? dl(ll, e, ...t) : dl(() => O3(ll(), e), ...t), st = T3({
  extend: {
    theme: {
      text: [
        "body",
        "callout",
        "caption-1",
        "caption-2",
        "display-1",
        "footnote",
        "headline",
        "large-title",
        "subheadline",
        "title-1",
        "title-2",
        "title-3"
      ]
    }
  }
}), k3 = ["src"], Dx = /* @__PURE__ */ V({
  __name: "FdxAvatar",
  props: {
    color: {},
    fallbackSrc: {},
    label: {},
    size: { default: "sm" },
    src: {}
  },
  emits: ["update"],
  setup(e, { emit: t }) {
    const r = wr(e, ["size"]), n = t, a = H(r.src || r.fallbackSrc), d = H(0), o = O2({
      lg: "w-16 h-16",
      md: "w-12 h-12",
      sm: "w-8 h-8",
      xl: "w-24 h-24"
    }), i = O(() => o[e.size]), l = O(() => {
      if (r.color)
        return {
          backgroundColor: r.color.bg,
          color: r.color.text
        };
      if (!r.label)
        return { backgroundColor: "transparent", color: "transparent" };
      const u = Q2(r.label), $ = K2(u), y = Y2($);
      return {
        backgroundColor: $,
        color: y
      };
    });
    function s() {
      d.value++, a.value = r.fallbackSrc, d.value >= 2 && r.label && (a.value = void 0);
    }
    return K(
      () => l.value,
      (u) => {
        u && n("update", {
          bg: u.backgroundColor,
          text: u.color
        });
      },
      { immediate: !0 }
    ), (u, $) => (S(), I("div", {
      class: de(["flex items-center justify-center overflow-hidden rounded-full", i.value]),
      style: Ct({ backgroundColor: l.value.backgroundColor })
    }, [
      a.value ? (S(), I("img", {
        key: 0,
        src: a.value,
        onError: s,
        alt: "",
        class: "h-full w-full object-cover"
      }, null, 40, k3)) : u.label ? (S(), I("div", {
        key: 1,
        class: de({
          "text-sm": u.size === "sm",
          "text-base": u.size === "md",
          "text-lg": u.size === "lg",
          "text-xl": u.size === "xl"
        }),
        style: Ct({ color: l.value.color })
      }, Q(g(J2)(u.label)), 7)) : Z("", !0)
    ], 6));
  }
}), I3 = {
  width: "1.2em",
  height: "1.2em",
  viewBox: "0 0 38 38",
  xmlns: "http://www.w3.org/2000/svg"
};
function R3(e, t) {
  return S(), I("svg", I3, [...t[0] || (t[0] = [
    bu('<g fill="none" fill-rule="evenodd"><g transform="translate(1 1)" stroke-width="2"><circle stroke-opacity=".5" cx="18" cy="18" r="18"></circle><path d="M36 18c0-9.94-8.06-18-18-18"><animateTransform attributeName="transform" type="rotate" from="0 18 18" to="360 18 18" dur="1s" repeatCount="indefinite"></animateTransform></path></g></g>', 1)
  ])]);
}
const D3 = ye({ name: "icon-loader", render: R3 }), Vu = /* @__PURE__ */ V({
  __name: "FdxButton",
  props: {
    class: { type: [Array, String, null, Number, Boolean] },
    disabled: { type: Boolean, default: !1 },
    loading: { type: Boolean, default: !1 },
    size: { default: "sm" },
    to: { default: null },
    variant: { default: "primary" }
  },
  emits: ["click"],
  setup(e, { emit: t }) {
    const r = t, n = {
      lg: "p-4",
      md: "px-4 py-3",
      sm: "px-4 py-2"
    }, a = {
      danger: "bg-negative-500 hover:bg-negative-600 active:bg-negative-400 active:text-negative-500 text-white active:border-transparent disabled:opacity-50 disabled:bg-negative-500 disabled:text-white",
      link: "text-primary underline hover:bg-gray-300 disabled:opacity-75 disabled:bg-transparent  disabled:text-gray-1000",
      primary: "bg-primary hover:bg-primary-500 border border-transparent text-white shadow active:bg-primary-300 active:text-white disabled:bg-gray-400 disabled:text-gray-700",
      secondary: "text-gray-1000 border border-gray-500 bg-white shadow hover:border-transparent hover:bg-gray-300 active:bg-primary-300 active:text-white disabled:bg-white disabled:border-gray-400 disabled:text-gray-400",
      text: "text-gray-1000 underline hover:bg-gray-300 active:bg-primary-300 active:text-white disabled:opacity-75 disabled:bg-transparent disabled:text-gray-1000"
    }, d = O(() => st(
      "rounded-lg disabled:cursor-not-allowed",
      n[e.size],
      a[e.variant],
      e.class
    ));
    function o(i) {
      e.disabled || r("click", i);
    }
    return (i, l) => {
      const s = D3;
      return S(), B(si(i.to ? "router-link" : "button"), {
        to: i.to,
        disabled: i.disabled,
        class: de(d.value),
        "aria-busy": i.loading,
        "aria-disabled": i.disabled,
        tabindex: i.disabled ? "-1" : 0,
        onClick: o,
        "data-testid": "fdx-button"
      }, {
        default: D(() => [
          i.loading ? (S(), B(s, {
            key: 0,
            class: de(["w-6", i.disabled ? "stroke-white" : "stroke-gray"]),
            "data-testid": "icon-loader"
          }, null, 8, ["class"])) : F(i.$slots, "default", { key: 1 })
        ]),
        _: 3
      }, 8, ["to", "disabled", "class", "aria-busy", "aria-disabled", "tabindex"]);
    };
  }
}), N3 = /* @__PURE__ */ V({
  __name: "FdxCard",
  setup(e) {
    const t = Zr(), r = O(
      () => st("rounded-lg bg-white p-4 lg:p-8 shadow-lg", t == null ? void 0 : t.class)
    );
    return (n, a) => (S(), I("div", {
      class: de(r.value)
    }, [
      F(n.$slots, "default")
    ], 2));
  }
}), F3 = {
  width: "1.2em",
  height: "1.2em",
  viewBox: "0 0 20 20",
  xmlns: "http://www.w3.org/2000/svg"
};
function L3(e, t) {
  return S(), I("svg", F3, [...t[0] || (t[0] = [
    C("path", {
      d: "M10 0C4.47 0 0 4.47 0 10C0 15.53 4.47 20 10 20C15.53 20 20 15.53 20 10C20 4.47 15.53 0 10 0ZM15 13.59L13.59 15L10 11.41L6.41 15L5 13.59L8.59 10L5 6.41L6.41 5L10 8.59L13.59 5L15 6.41L11.41 10L15 13.59Z",
      fill: "current"
    }, null, -1)
  ])]);
}
const B3 = ye({ name: "icon-round-cross", render: L3 }), Vt = Object.freeze({
  alert: "alert",
  error: "error",
  gray: "gray",
  primary: "primary",
  secondary: "secondary",
  success: "success",
  warning: "warning"
}), V3 = Object.freeze({
  [Vt.alert]: {
    bg: "bg-alert-500",
    text: "text-white "
  },
  [Vt.error]: {
    bg: "bg-negative-500",
    text: "text-white "
  },
  [Vt.gray]: {
    bg: "bg-gray-100 ",
    text: "text-gray-1000"
  },
  [Vt.primary]: {
    bg: "bg-primary-300",
    text: "text-white "
  },
  [Vt.secondary]: {
    bg: "bg-secondary-300",
    text: "text-white "
  },
  [Vt.success]: {
    bg: "bg-positive-500",
    text: "text-white "
  },
  [Vt.warning]: {
    bg: "bg-warning-500",
    text: "text-white "
  }
}), la = Object.freeze({
  lg: "lg",
  md: "md",
  sm: "sm"
}), j3 = Object.freeze({
  [la.lg]: "px-6 py-3 text-base",
  [la.md]: "px-4 py-2 text-callout",
  [la.sm]: "px-2 py-1 text-xs"
}), G3 = /* @__PURE__ */ V({
  __name: "FdxChip",
  props: {
    color: { default: Vt.gray },
    dismissible: { type: Boolean },
    dismissIconColor: { default: "black" },
    size: { default: la.md }
  },
  emits: ["click", "dismiss"],
  setup(e, { emit: t }) {
    const r = e, n = t, a = H(!1), d = Jr(), o = O(() => V3[r.color]), i = O(() => j3[r.size]), l = O(() => {
      var $;
      return !!(($ = d == null ? void 0 : d.vnode.props) != null && $.onClick);
    }), s = ($) => {
      n("click", $);
    }, u = ($) => {
      $.stopPropagation(), a.value = !0, n("dismiss", $);
    };
    return ($, y) => {
      const h = B3;
      return S(), B(jn, { name: "fade" }, {
        default: D(() => [
          a.value ? Z("", !0) : (S(), I("div", me({ key: 0 }, $.$attrs, {
            class: [
              o.value.bg,
              o.value.text,
              i.value,
              "fdx-chip",
              { "cursor-pointer": l.value }
            ],
            "data-testid": "fdx-chip",
            onClick: s
          }), [
            F($.$slots, "prefix", {}, void 0, !0),
            F($.$slots, "default", {}, void 0, !0),
            F($.$slots, "suffix", {}, () => [
              $.dismissible ? (S(), I("button", {
                key: 0,
                class: "fdx-chip__dismiss",
                onClick: u
              }, [
                j(h, {
                  style: Ct({ fill: $.dismissIconColor })
                }, null, 8, ["style"])
              ])) : Z("", !0)
            ], !0)
          ], 16))
        ]),
        _: 3
      });
    };
  }
}), rr = (e, t) => {
  const r = e.__vccOpts || e;
  for (const [n, a] of t)
    r[n] = a;
  return r;
}, Nx = /* @__PURE__ */ rr(G3, [["__scopeId", "data-v-5eb85d91"]]), U3 = {
  width: "25",
  height: "24",
  viewBox: "0 0 25 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, H3 = ["clip-path"], W3 = ["id"];
function z3(e, t) {
  return S(), I("svg", U3, [
    C("g", {
      "clip-path": "url(#" + e.idMap.clip0_5_23850 + ")"
    }, [...t[0] || (t[0] = [
      C("path", {
        d: "M8.30636 8.59L12.8964 13.17L17.4864 8.59L18.8964 10L12.8964 16L6.89636 10L8.30636 8.59Z",
        fill: "#1C1C1E"
      }, null, -1)
    ])], 8, H3),
    C("defs", null, [
      C("clipPath", {
        id: e.idMap.clip0_5_23850
      }, [...t[1] || (t[1] = [
        C("rect", {
          width: "24",
          height: "24",
          fill: "white",
          transform: "translate(0.896362)"
        }, null, -1)
      ])], 8, W3)
    ])
  ]);
}
const q3 = ye({ name: "icon-keyboard-arrow-down", render: z3, setup() {
  return { idMap: { clip0_5_23850: "uicons-" + Math.random().toString(36).substr(2, 10) } };
} }), K3 = ["open", "name", "aria-expanded"], Y3 = { class: "fdx-collapsible__summary cursor-pointer" }, Z3 = { class: "fdx-collapsible__trigger flex gap-x-2 bg-gray-100 p-4" }, J3 = { class: "fdx-collapsible__trigger-content flex-grow" }, Q3 = { class: "fdx-collapsible__trigger-title text-callout font-bold" }, X3 = { class: "fdx-collapsible__content border-t border-gray-200 p-4" }, sl = "fdx-collapsible__icon transition-duration-300 ms-auto size-6 transition duration-300 group-open:rotate-180", ef = /* @__PURE__ */ V({
  __name: "FdxCollapsible",
  props: /* @__PURE__ */ $e({
    title: {}
  }, {
    modelValue: { type: Boolean },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    const t = Zr(), r = ft(Pu, "") || t.name, n = Ae(e, "modelValue"), a = At("details-element");
    function d() {
      a.value && (n.value = a.value.open);
    }
    return (o, i) => {
      const l = q3;
      return S(), I("details", {
        class: "fdx-collapsible__details group border border-b-0 border-gray-200 last-of-type:border-b",
        ref: "details-element",
        open: n.value,
        name: g(r),
        "aria-expanded": n.value,
        onToggle: d
      }, [
        C("summary", Y3, [
          F(o.$slots, "trigger", { open: n.value }, () => [
            C("div", Z3, [
              C("div", J3, [
                F(o.$slots, "trigger-title", {}, () => [
                  C("span", Q3, Q(o.title), 1)
                ], !0)
              ]),
              F(o.$slots, "trigger-icon", { classes: sl }, () => [
                j(l, {
                  class: de([sl])
                }, null, 8, ["class"])
              ], !0)
            ])
          ], !0)
        ]),
        C("div", X3, [
          F(o.$slots, "content", {}, void 0, !0)
        ])
      ], 40, K3);
    };
  }
}), Fx = /* @__PURE__ */ rr(ef, [["__scopeId", "data-v-72672884"]]), Lx = /* @__PURE__ */ V({
  __name: "FdxCountDown",
  props: {
    modelValue: {
      default: 0
    },
    modelModifiers: {}
  },
  emits: /* @__PURE__ */ $e(["done"], ["update:modelValue"]),
  setup(e, { emit: t }) {
    const r = Ae(e, "modelValue"), n = H(), a = H(r.value), d = t, o = () => {
      a.value === 0 && (clearInterval(n.value), d("done"));
    }, i = () => {
      clearInterval(n.value), n.value = setInterval(() => {
        a.value > 0 && (a.value -= 1, r.value = a.value), o();
      }, 1e3);
    }, l = O(() => {
      const s = Math.floor(a.value / 60).toString().padStart(2, "0"), u = Math.floor(a.value % 60).toString().padStart(2, "0");
      return `${s}:${u}`;
    });
    return K(r, () => {
      a.value !== r.value && (a.value = Math.max(r.value, 0), i());
    }), He(() => {
      i();
    }), wu(() => {
      clearInterval(n.value), n.value = void 0;
    }), (s, u) => (S(), I("span", null, Q(l.value), 1));
  }
}), tf = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, rf = ["clip-path"], nf = ["id"];
function af(e, t) {
  return S(), I("svg", tf, [
    C("g", {
      "clip-path": "url(#" + e.idMap.clip0_5_23649 + ")"
    }, [...t[0] || (t[0] = [
      C("path", {
        d: "M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z",
        fill: "#1C1C1E"
      }, null, -1)
    ])], 8, rf),
    C("defs", null, [
      C("clipPath", {
        id: e.idMap.clip0_5_23649
      }, [...t[1] || (t[1] = [
        C("rect", {
          width: "24",
          height: "24",
          fill: "white"
        }, null, -1)
      ])], 8, nf)
    ])
  ]);
}
const Hn = ye({ name: "icon-close", render: af, setup() {
  return { idMap: { clip0_5_23649: "uicons-" + Math.random().toString(36).substr(2, 10) } };
} }), df = ["aria-labelledby"], of = { class: "fdx-dialog__header flex flex-shrink-0 items-center justify-between gap-x-4 border-b border-gray-200 px-4 py-3" }, lf = ["id"], sf = { class: "fdx-dialog__body flex-grow overflow-y-auto px-4 py-6" }, uf = {
  key: 0,
  class: "flex-shrink-0 border-t border-gray-200 px-4 py-3"
}, cf = /* @__PURE__ */ V({
  __name: "FdxDialog",
  props: /* @__PURE__ */ $e({
    backdropCloses: { type: Boolean, default: !0 },
    title: {}
  }, {
    modelValue: { type: Boolean },
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ $e(["closed", "opened"], ["update:modelValue"]),
  setup(e, { emit: t }) {
    const r = t, n = Ae(e, "modelValue"), a = At("dialog-element");
    K(n, (s) => {
      s ? i() : d();
    }), He(() => {
      var s;
      n.value && i(), (s = a.value) == null || s.addEventListener("close", () => {
        n.value = !1;
      });
    });
    function d() {
      var s;
      (s = a.value) == null || s.close(), r("closed");
    }
    function o() {
      e.backdropCloses && d();
    }
    function i() {
      var s;
      (s = a.value) == null || s.showModal(), r("opened");
    }
    const l = tr();
    return (s, u) => {
      const $ = Hn;
      return S(), I("dialog", {
        ref: "dialog-element",
        "aria-labelledby": g(l),
        class: "m-0 flex-col opacity-0 outline-none open:flex open:flex-col open:opacity-100 starting:open:flex starting:open:flex-col starting:open:opacity-0",
        onClick: Jt(o, ["self"])
      }, [
        C("div", of, [
          F(s.$slots, "header", { dialogTitleId: g(l) }, () => [
            s.title ? (S(), I("span", {
              key: 0,
              id: g(l),
              class: "text-footnote font-normal"
            }, Q(s.title), 9, lf)) : Z("", !0)
          ], !0),
          C("div", {
            class: "ms-auto inline-block cursor-pointer rounded-full border p-1",
            "data-testid": "close-button-container",
            onClick: d
          }, [
            j($, { class: "size-6" })
          ])
        ]),
        C("div", sf, [
          F(s.$slots, "default", {}, void 0, !0)
        ]),
        s.$slots.footer ? (S(), I("div", uf, [
          F(s.$slots, "footer", {}, void 0, !0)
        ])) : Z("", !0)
      ], 8, df);
    };
  }
}), ju = /* @__PURE__ */ rr(cf, [["__scopeId", "data-v-5fc7f44a"]]), Bx = /* @__PURE__ */ V({
  __name: "FdxDrawer",
  props: /* @__PURE__ */ $e({
    backdropCloses: { type: Boolean, default: !0 },
    placement: { default: "end" },
    title: {}
  }, {
    modelValue: { type: Boolean },
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ $e(["closed", "opened"], ["update:modelValue"]),
  setup(e, { emit: t }) {
    const r = t, n = Ae(e, "modelValue");
    return (a, d) => (S(), B(ju, {
      modelValue: n.value,
      "onUpdate:modelValue": d[0] || (d[0] = (o) => n.value = o),
      title: a.title,
      "backdrop-closes": a.backdropCloses,
      class: de({
        "-end-full ms-auto min-h-full min-w-80 open:end-0 starting:open:-end-full": a.placement === "end",
        "-start-full me-auto min-h-full min-w-80 open:start-0 starting:open:-start-full": a.placement === "start",
        "-top-full mb-auto min-w-full open:top-0 starting:open:-top-full": a.placement === "top",
        "-bottom-full mt-auto min-w-full open:bottom-0 starting:open:-bottom-full": a.placement === "bottom"
      }),
      onClosed: d[1] || (d[1] = (o) => r("closed")),
      onOpened: d[2] || (d[2] = (o) => r("opened"))
    }, _u({
      default: D(() => [
        F(a.$slots, "default")
      ]),
      _: 2
    }, [
      a.$slots.header ? {
        name: "header",
        fn: D(({ dialogTitleId: o }) => [
          F(a.$slots, "header", { dialogTitleId: o })
        ]),
        key: "0"
      } : void 0,
      a.$slots.footer ? {
        name: "footer",
        fn: D(() => [
          F(a.$slots, "footer")
        ]),
        key: "1"
      } : void 0
    ]), 1032, ["modelValue", "title", "backdrop-closes", "class"]));
  }
}), ff = ["top", "right", "bottom", "left"], ul = ["start", "end"], cl = /* @__PURE__ */ ff.reduce((e, t) => e.concat(t, t + "-" + ul[0], t + "-" + ul[1]), []), Cn = Math.min, ur = Math.max, $f = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, pf = {
  start: "end",
  end: "start"
};
function Ao(e, t, r) {
  return ur(e, Cn(t, r));
}
function _r(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function pt(e) {
  return e.split("-")[0];
}
function et(e) {
  return e.split("-")[1];
}
function Gu(e) {
  return e === "x" ? "y" : "x";
}
function fi(e) {
  return e === "y" ? "height" : "width";
}
const mf = /* @__PURE__ */ new Set(["top", "bottom"]);
function _t(e) {
  return mf.has(pt(e)) ? "y" : "x";
}
function $i(e) {
  return Gu(_t(e));
}
function Uu(e, t, r) {
  r === void 0 && (r = !1);
  const n = et(e), a = $i(e), d = fi(a);
  let o = a === "x" ? n === (r ? "end" : "start") ? "right" : "left" : n === "start" ? "bottom" : "top";
  return t.reference[d] > t.floating[d] && (o = ma(o)), [o, ma(o)];
}
function hf(e) {
  const t = ma(e);
  return [pa(e), t, pa(t)];
}
function pa(e) {
  return e.replace(/start|end/g, (t) => pf[t]);
}
const fl = ["left", "right"], $l = ["right", "left"], vf = ["top", "bottom"], yf = ["bottom", "top"];
function gf(e, t, r) {
  switch (e) {
    case "top":
    case "bottom":
      return r ? t ? $l : fl : t ? fl : $l;
    case "left":
    case "right":
      return t ? vf : yf;
    default:
      return [];
  }
}
function bf(e, t, r, n) {
  const a = et(e);
  let d = gf(pt(e), r === "start", n);
  return a && (d = d.map((o) => o + "-" + a), t && (d = d.concat(d.map(pa)))), d;
}
function ma(e) {
  return e.replace(/left|right|bottom|top/g, (t) => $f[t]);
}
function wf(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function Hu(e) {
  return typeof e != "number" ? wf(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function gn(e) {
  const {
    x: t,
    y: r,
    width: n,
    height: a
  } = e;
  return {
    width: n,
    height: a,
    top: r,
    left: t,
    right: t + n,
    bottom: r + a,
    x: t,
    y: r
  };
}
function pl(e, t, r) {
  let {
    reference: n,
    floating: a
  } = e;
  const d = _t(t), o = $i(t), i = fi(o), l = pt(t), s = d === "y", u = n.x + n.width / 2 - a.width / 2, $ = n.y + n.height / 2 - a.height / 2, y = n[i] / 2 - a[i] / 2;
  let h;
  switch (l) {
    case "top":
      h = {
        x: u,
        y: n.y - a.height
      };
      break;
    case "bottom":
      h = {
        x: u,
        y: n.y + n.height
      };
      break;
    case "right":
      h = {
        x: n.x + n.width,
        y: $
      };
      break;
    case "left":
      h = {
        x: n.x - a.width,
        y: $
      };
      break;
    default:
      h = {
        x: n.x,
        y: n.y
      };
  }
  switch (et(t)) {
    case "start":
      h[o] -= y * (r && s ? -1 : 1);
      break;
    case "end":
      h[o] += y * (r && s ? -1 : 1);
      break;
  }
  return h;
}
const _f = async (e, t, r) => {
  const {
    placement: n = "bottom",
    strategy: a = "absolute",
    middleware: d = [],
    platform: o
  } = r, i = d.filter(Boolean), l = await (o.isRTL == null ? void 0 : o.isRTL(t));
  let s = await o.getElementRects({
    reference: e,
    floating: t,
    strategy: a
  }), {
    x: u,
    y: $
  } = pl(s, n, l), y = n, h = {}, c = 0;
  for (let p = 0; p < i.length; p++) {
    const {
      name: f,
      fn: v
    } = i[p], {
      x: w,
      y: m,
      data: b,
      reset: _
    } = await v({
      x: u,
      y: $,
      initialPlacement: n,
      placement: y,
      strategy: a,
      middlewareData: h,
      rects: s,
      platform: o,
      elements: {
        reference: e,
        floating: t
      }
    });
    u = w ?? u, $ = m ?? $, h = {
      ...h,
      [f]: {
        ...h[f],
        ...b
      }
    }, _ && c <= 50 && (c++, typeof _ == "object" && (_.placement && (y = _.placement), _.rects && (s = _.rects === !0 ? await o.getElementRects({
      reference: e,
      floating: t,
      strategy: a
    }) : _.rects), {
      x: u,
      y: $
    } = pl(s, y, l)), p = -1);
  }
  return {
    x: u,
    y: $,
    placement: y,
    strategy: a,
    middlewareData: h
  };
};
async function Ra(e, t) {
  var r;
  t === void 0 && (t = {});
  const {
    x: n,
    y: a,
    platform: d,
    rects: o,
    elements: i,
    strategy: l
  } = e, {
    boundary: s = "clippingAncestors",
    rootBoundary: u = "viewport",
    elementContext: $ = "floating",
    altBoundary: y = !1,
    padding: h = 0
  } = _r(t, e), c = Hu(h), f = i[y ? $ === "floating" ? "reference" : "floating" : $], v = gn(await d.getClippingRect({
    element: (r = await (d.isElement == null ? void 0 : d.isElement(f))) == null || r ? f : f.contextElement || await (d.getDocumentElement == null ? void 0 : d.getDocumentElement(i.floating)),
    boundary: s,
    rootBoundary: u,
    strategy: l
  })), w = $ === "floating" ? {
    x: n,
    y: a,
    width: o.floating.width,
    height: o.floating.height
  } : o.reference, m = await (d.getOffsetParent == null ? void 0 : d.getOffsetParent(i.floating)), b = await (d.isElement == null ? void 0 : d.isElement(m)) ? await (d.getScale == null ? void 0 : d.getScale(m)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, _ = gn(d.convertOffsetParentRelativeRectToViewportRelativeRect ? await d.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: i,
    rect: w,
    offsetParent: m,
    strategy: l
  }) : w);
  return {
    top: (v.top - _.top + c.top) / b.y,
    bottom: (_.bottom - v.bottom + c.bottom) / b.y,
    left: (v.left - _.left + c.left) / b.x,
    right: (_.right - v.right + c.right) / b.x
  };
}
const xf = (e) => ({
  name: "arrow",
  options: e,
  async fn(t) {
    const {
      x: r,
      y: n,
      placement: a,
      rects: d,
      platform: o,
      elements: i,
      middlewareData: l
    } = t, {
      element: s,
      padding: u = 0
    } = _r(e, t) || {};
    if (s == null)
      return {};
    const $ = Hu(u), y = {
      x: r,
      y: n
    }, h = $i(a), c = fi(h), p = await o.getDimensions(s), f = h === "y", v = f ? "top" : "left", w = f ? "bottom" : "right", m = f ? "clientHeight" : "clientWidth", b = d.reference[c] + d.reference[h] - y[h] - d.floating[c], _ = y[h] - d.reference[h], x = await (o.getOffsetParent == null ? void 0 : o.getOffsetParent(s));
    let A = x ? x[m] : 0;
    (!A || !await (o.isElement == null ? void 0 : o.isElement(x))) && (A = i.floating[m] || d.floating[c]);
    const P = b / 2 - _ / 2, k = A / 2 - p[c] / 2 - 1, R = Cn($[v], k), L = Cn($[w], k), N = R, U = A - p[c] - L, G = A / 2 - p[c] / 2 + P, Y = Ao(N, G, U), te = !l.arrow && et(a) != null && G !== Y && d.reference[c] / 2 - (G < N ? R : L) - p[c] / 2 < 0, re = te ? G < N ? G - N : G - U : 0;
    return {
      [h]: y[h] + re,
      data: {
        [h]: Y,
        centerOffset: G - Y - re,
        ...te && {
          alignmentOffset: re
        }
      },
      reset: te
    };
  }
});
function Sf(e, t, r) {
  return (e ? [...r.filter((a) => et(a) === e), ...r.filter((a) => et(a) !== e)] : r.filter((a) => pt(a) === a)).filter((a) => e ? et(a) === e || (t ? pa(a) !== a : !1) : !0);
}
const Cf = function(e) {
  return e === void 0 && (e = {}), {
    name: "autoPlacement",
    options: e,
    async fn(t) {
      var r, n, a;
      const {
        rects: d,
        middlewareData: o,
        placement: i,
        platform: l,
        elements: s
      } = t, {
        crossAxis: u = !1,
        alignment: $,
        allowedPlacements: y = cl,
        autoAlignment: h = !0,
        ...c
      } = _r(e, t), p = $ !== void 0 || y === cl ? Sf($ || null, h, y) : y, f = await Ra(t, c), v = ((r = o.autoPlacement) == null ? void 0 : r.index) || 0, w = p[v];
      if (w == null)
        return {};
      const m = Uu(w, d, await (l.isRTL == null ? void 0 : l.isRTL(s.floating)));
      if (i !== w)
        return {
          reset: {
            placement: p[0]
          }
        };
      const b = [f[pt(w)], f[m[0]], f[m[1]]], _ = [...((n = o.autoPlacement) == null ? void 0 : n.overflows) || [], {
        placement: w,
        overflows: b
      }], x = p[v + 1];
      if (x)
        return {
          data: {
            index: v + 1,
            overflows: _
          },
          reset: {
            placement: x
          }
        };
      const A = _.map((R) => {
        const L = et(R.placement);
        return [R.placement, L && u ? (
          // Check along the mainAxis and main crossAxis side.
          R.overflows.slice(0, 2).reduce((N, U) => N + U, 0)
        ) : (
          // Check only the mainAxis.
          R.overflows[0]
        ), R.overflows];
      }).sort((R, L) => R[1] - L[1]), k = ((a = A.filter((R) => R[2].slice(
        0,
        // Aligned placements should not check their opposite crossAxis
        // side.
        et(R[0]) ? 2 : 3
      ).every((L) => L <= 0))[0]) == null ? void 0 : a[0]) || A[0][0];
      return k !== i ? {
        data: {
          index: v + 1,
          overflows: _
        },
        reset: {
          placement: k
        }
      } : {};
    }
  };
}, Pf = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var r, n;
      const {
        placement: a,
        middlewareData: d,
        rects: o,
        initialPlacement: i,
        platform: l,
        elements: s
      } = t, {
        mainAxis: u = !0,
        crossAxis: $ = !0,
        fallbackPlacements: y,
        fallbackStrategy: h = "bestFit",
        fallbackAxisSideDirection: c = "none",
        flipAlignment: p = !0,
        ...f
      } = _r(e, t);
      if ((r = d.arrow) != null && r.alignmentOffset)
        return {};
      const v = pt(a), w = _t(i), m = pt(i) === i, b = await (l.isRTL == null ? void 0 : l.isRTL(s.floating)), _ = y || (m || !p ? [ma(i)] : hf(i)), x = c !== "none";
      !y && x && _.push(...bf(i, p, c, b));
      const A = [i, ..._], P = await Ra(t, f), k = [];
      let R = ((n = d.flip) == null ? void 0 : n.overflows) || [];
      if (u && k.push(P[v]), $) {
        const G = Uu(a, o, b);
        k.push(P[G[0]], P[G[1]]);
      }
      if (R = [...R, {
        placement: a,
        overflows: k
      }], !k.every((G) => G <= 0)) {
        var L, N;
        const G = (((L = d.flip) == null ? void 0 : L.index) || 0) + 1, Y = A[G];
        if (Y && (!($ === "alignment" ? w !== _t(Y) : !1) || // We leave the current main axis only if every placement on that axis
        // overflows the main axis.
        R.every((M) => _t(M.placement) === w ? M.overflows[0] > 0 : !0)))
          return {
            data: {
              index: G,
              overflows: R
            },
            reset: {
              placement: Y
            }
          };
        let te = (N = R.filter((re) => re.overflows[0] <= 0).sort((re, M) => re.overflows[1] - M.overflows[1])[0]) == null ? void 0 : N.placement;
        if (!te)
          switch (h) {
            case "bestFit": {
              var U;
              const re = (U = R.filter((M) => {
                if (x) {
                  const X = _t(M.placement);
                  return X === w || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  X === "y";
                }
                return !0;
              }).map((M) => [M.placement, M.overflows.filter((X) => X > 0).reduce((X, ee) => X + ee, 0)]).sort((M, X) => M[1] - X[1])[0]) == null ? void 0 : U[0];
              re && (te = re);
              break;
            }
            case "initialPlacement":
              te = i;
              break;
          }
        if (a !== te)
          return {
            reset: {
              placement: te
            }
          };
      }
      return {};
    }
  };
}, Af = /* @__PURE__ */ new Set(["left", "top"]);
async function Ef(e, t) {
  const {
    placement: r,
    platform: n,
    elements: a
  } = e, d = await (n.isRTL == null ? void 0 : n.isRTL(a.floating)), o = pt(r), i = et(r), l = _t(r) === "y", s = Af.has(o) ? -1 : 1, u = d && l ? -1 : 1, $ = _r(t, e);
  let {
    mainAxis: y,
    crossAxis: h,
    alignmentAxis: c
  } = typeof $ == "number" ? {
    mainAxis: $,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: $.mainAxis || 0,
    crossAxis: $.crossAxis || 0,
    alignmentAxis: $.alignmentAxis
  };
  return i && typeof c == "number" && (h = i === "end" ? c * -1 : c), l ? {
    x: h * u,
    y: y * s
  } : {
    x: y * s,
    y: h * u
  };
}
const Mf = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      var r, n;
      const {
        x: a,
        y: d,
        placement: o,
        middlewareData: i
      } = t, l = await Ef(t, e);
      return o === ((r = i.offset) == null ? void 0 : r.placement) && (n = i.arrow) != null && n.alignmentOffset ? {} : {
        x: a + l.x,
        y: d + l.y,
        data: {
          ...l,
          placement: o
        }
      };
    }
  };
}, Of = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(t) {
      const {
        x: r,
        y: n,
        placement: a
      } = t, {
        mainAxis: d = !0,
        crossAxis: o = !1,
        limiter: i = {
          fn: (f) => {
            let {
              x: v,
              y: w
            } = f;
            return {
              x: v,
              y: w
            };
          }
        },
        ...l
      } = _r(e, t), s = {
        x: r,
        y: n
      }, u = await Ra(t, l), $ = _t(pt(a)), y = Gu($);
      let h = s[y], c = s[$];
      if (d) {
        const f = y === "y" ? "top" : "left", v = y === "y" ? "bottom" : "right", w = h + u[f], m = h - u[v];
        h = Ao(w, h, m);
      }
      if (o) {
        const f = $ === "y" ? "top" : "left", v = $ === "y" ? "bottom" : "right", w = c + u[f], m = c - u[v];
        c = Ao(w, c, m);
      }
      const p = i.fn({
        ...t,
        [y]: h,
        [$]: c
      });
      return {
        ...p,
        data: {
          x: p.x - r,
          y: p.y - n,
          enabled: {
            [y]: d,
            [$]: o
          }
        }
      };
    }
  };
}, Tf = function(e) {
  return e === void 0 && (e = {}), {
    name: "size",
    options: e,
    async fn(t) {
      var r, n;
      const {
        placement: a,
        rects: d,
        platform: o,
        elements: i
      } = t, {
        apply: l = () => {
        },
        ...s
      } = _r(e, t), u = await Ra(t, s), $ = pt(a), y = et(a), h = _t(a) === "y", {
        width: c,
        height: p
      } = d.floating;
      let f, v;
      $ === "top" || $ === "bottom" ? (f = $, v = y === (await (o.isRTL == null ? void 0 : o.isRTL(i.floating)) ? "start" : "end") ? "left" : "right") : (v = $, f = y === "end" ? "top" : "bottom");
      const w = p - u.top - u.bottom, m = c - u.left - u.right, b = Cn(p - u[f], w), _ = Cn(c - u[v], m), x = !t.middlewareData.shift;
      let A = b, P = _;
      if ((r = t.middlewareData.shift) != null && r.enabled.x && (P = m), (n = t.middlewareData.shift) != null && n.enabled.y && (A = w), x && !y) {
        const R = ur(u.left, 0), L = ur(u.right, 0), N = ur(u.top, 0), U = ur(u.bottom, 0);
        h ? P = c - 2 * (R !== 0 || L !== 0 ? R + L : ur(u.left, u.right)) : A = p - 2 * (N !== 0 || U !== 0 ? N + U : ur(u.top, u.bottom));
      }
      await l({
        ...t,
        availableWidth: P,
        availableHeight: A
      });
      const k = await o.getDimensions(i.floating);
      return c !== k.width || p !== k.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function ze(e) {
  var t;
  return ((t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function ut(e) {
  return ze(e).getComputedStyle(e);
}
const ml = Math.min, bn = Math.max, ha = Math.round;
function Wu(e) {
  const t = ut(e);
  let r = parseFloat(t.width), n = parseFloat(t.height);
  const a = e.offsetWidth, d = e.offsetHeight, o = ha(r) !== a || ha(n) !== d;
  return o && (r = a, n = d), { width: r, height: n, fallback: o };
}
function Qt(e) {
  return qu(e) ? (e.nodeName || "").toLowerCase() : "";
}
let ra;
function zu() {
  if (ra) return ra;
  const e = navigator.userAgentData;
  return e && Array.isArray(e.brands) ? (ra = e.brands.map(((t) => t.brand + "/" + t.version)).join(" "), ra) : navigator.userAgent;
}
function ct(e) {
  return e instanceof ze(e).HTMLElement;
}
function qt(e) {
  return e instanceof ze(e).Element;
}
function qu(e) {
  return e instanceof ze(e).Node;
}
function hl(e) {
  return typeof ShadowRoot > "u" ? !1 : e instanceof ze(e).ShadowRoot || e instanceof ShadowRoot;
}
function Da(e) {
  const { overflow: t, overflowX: r, overflowY: n, display: a } = ut(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + n + r) && !["inline", "contents"].includes(a);
}
function kf(e) {
  return ["table", "td", "th"].includes(Qt(e));
}
function Eo(e) {
  const t = /firefox/i.test(zu()), r = ut(e), n = r.backdropFilter || r.WebkitBackdropFilter;
  return r.transform !== "none" || r.perspective !== "none" || !!n && n !== "none" || t && r.willChange === "filter" || t && !!r.filter && r.filter !== "none" || ["transform", "perspective"].some(((a) => r.willChange.includes(a))) || ["paint", "layout", "strict", "content"].some(((a) => {
    const d = r.contain;
    return d != null && d.includes(a);
  }));
}
function Ku() {
  return !/^((?!chrome|android).)*safari/i.test(zu());
}
function pi(e) {
  return ["html", "body", "#document"].includes(Qt(e));
}
function Yu(e) {
  return qt(e) ? e : e.contextElement;
}
const Zu = { x: 1, y: 1 };
function Fr(e) {
  const t = Yu(e);
  if (!ct(t)) return Zu;
  const r = t.getBoundingClientRect(), { width: n, height: a, fallback: d } = Wu(t);
  let o = (d ? ha(r.width) : r.width) / n, i = (d ? ha(r.height) : r.height) / a;
  return o && Number.isFinite(o) || (o = 1), i && Number.isFinite(i) || (i = 1), { x: o, y: i };
}
function Pn(e, t, r, n) {
  var a, d;
  t === void 0 && (t = !1), r === void 0 && (r = !1);
  const o = e.getBoundingClientRect(), i = Yu(e);
  let l = Zu;
  t && (n ? qt(n) && (l = Fr(n)) : l = Fr(e));
  const s = i ? ze(i) : window, u = !Ku() && r;
  let $ = (o.left + (u && ((a = s.visualViewport) == null ? void 0 : a.offsetLeft) || 0)) / l.x, y = (o.top + (u && ((d = s.visualViewport) == null ? void 0 : d.offsetTop) || 0)) / l.y, h = o.width / l.x, c = o.height / l.y;
  if (i) {
    const p = ze(i), f = n && qt(n) ? ze(n) : n;
    let v = p.frameElement;
    for (; v && n && f !== p; ) {
      const w = Fr(v), m = v.getBoundingClientRect(), b = getComputedStyle(v);
      m.x += (v.clientLeft + parseFloat(b.paddingLeft)) * w.x, m.y += (v.clientTop + parseFloat(b.paddingTop)) * w.y, $ *= w.x, y *= w.y, h *= w.x, c *= w.y, $ += m.x, y += m.y, v = ze(v).frameElement;
    }
  }
  return { width: h, height: c, top: y, right: $ + h, bottom: y + c, left: $, x: $, y };
}
function Kt(e) {
  return ((qu(e) ? e.ownerDocument : e.document) || window.document).documentElement;
}
function Na(e) {
  return qt(e) ? { scrollLeft: e.scrollLeft, scrollTop: e.scrollTop } : { scrollLeft: e.pageXOffset, scrollTop: e.pageYOffset };
}
function Ju(e) {
  return Pn(Kt(e)).left + Na(e).scrollLeft;
}
function An(e) {
  if (Qt(e) === "html") return e;
  const t = e.assignedSlot || e.parentNode || hl(e) && e.host || Kt(e);
  return hl(t) ? t.host : t;
}
function Qu(e) {
  const t = An(e);
  return pi(t) ? t.ownerDocument.body : ct(t) && Da(t) ? t : Qu(t);
}
function va(e, t) {
  var r;
  t === void 0 && (t = []);
  const n = Qu(e), a = n === ((r = e.ownerDocument) == null ? void 0 : r.body), d = ze(n);
  return a ? t.concat(d, d.visualViewport || [], Da(n) ? n : []) : t.concat(n, va(n));
}
function vl(e, t, r) {
  return t === "viewport" ? gn((function(n, a) {
    const d = ze(n), o = Kt(n), i = d.visualViewport;
    let l = o.clientWidth, s = o.clientHeight, u = 0, $ = 0;
    if (i) {
      l = i.width, s = i.height;
      const y = Ku();
      (y || !y && a === "fixed") && (u = i.offsetLeft, $ = i.offsetTop);
    }
    return { width: l, height: s, x: u, y: $ };
  })(e, r)) : qt(t) ? gn((function(n, a) {
    const d = Pn(n, !0, a === "fixed"), o = d.top + n.clientTop, i = d.left + n.clientLeft, l = ct(n) ? Fr(n) : { x: 1, y: 1 };
    return { width: n.clientWidth * l.x, height: n.clientHeight * l.y, x: i * l.x, y: o * l.y };
  })(t, r)) : gn((function(n) {
    const a = Kt(n), d = Na(n), o = n.ownerDocument.body, i = bn(a.scrollWidth, a.clientWidth, o.scrollWidth, o.clientWidth), l = bn(a.scrollHeight, a.clientHeight, o.scrollHeight, o.clientHeight);
    let s = -d.scrollLeft + Ju(n);
    const u = -d.scrollTop;
    return ut(o).direction === "rtl" && (s += bn(a.clientWidth, o.clientWidth) - i), { width: i, height: l, x: s, y: u };
  })(Kt(e)));
}
function yl(e) {
  return ct(e) && ut(e).position !== "fixed" ? e.offsetParent : null;
}
function gl(e) {
  const t = ze(e);
  let r = yl(e);
  for (; r && kf(r) && ut(r).position === "static"; ) r = yl(r);
  return r && (Qt(r) === "html" || Qt(r) === "body" && ut(r).position === "static" && !Eo(r)) ? t : r || (function(n) {
    let a = An(n);
    for (; ct(a) && !pi(a); ) {
      if (Eo(a)) return a;
      a = An(a);
    }
    return null;
  })(e) || t;
}
function If(e, t, r) {
  const n = ct(t), a = Kt(t), d = Pn(e, !0, r === "fixed", t);
  let o = { scrollLeft: 0, scrollTop: 0 };
  const i = { x: 0, y: 0 };
  if (n || !n && r !== "fixed") if ((Qt(t) !== "body" || Da(a)) && (o = Na(t)), ct(t)) {
    const l = Pn(t, !0);
    i.x = l.x + t.clientLeft, i.y = l.y + t.clientTop;
  } else a && (i.x = Ju(a));
  return { x: d.left + o.scrollLeft - i.x, y: d.top + o.scrollTop - i.y, width: d.width, height: d.height };
}
const Rf = { getClippingRect: function(e) {
  let { element: t, boundary: r, rootBoundary: n, strategy: a } = e;
  const d = r === "clippingAncestors" ? (function(s, u) {
    const $ = u.get(s);
    if ($) return $;
    let y = va(s).filter(((f) => qt(f) && Qt(f) !== "body")), h = null;
    const c = ut(s).position === "fixed";
    let p = c ? An(s) : s;
    for (; qt(p) && !pi(p); ) {
      const f = ut(p), v = Eo(p);
      (c ? v || h : v || f.position !== "static" || !h || !["absolute", "fixed"].includes(h.position)) ? h = f : y = y.filter(((w) => w !== p)), p = An(p);
    }
    return u.set(s, y), y;
  })(t, this._c) : [].concat(r), o = [...d, n], i = o[0], l = o.reduce(((s, u) => {
    const $ = vl(t, u, a);
    return s.top = bn($.top, s.top), s.right = ml($.right, s.right), s.bottom = ml($.bottom, s.bottom), s.left = bn($.left, s.left), s;
  }), vl(t, i, a));
  return { width: l.right - l.left, height: l.bottom - l.top, x: l.left, y: l.top };
}, convertOffsetParentRelativeRectToViewportRelativeRect: function(e) {
  let { rect: t, offsetParent: r, strategy: n } = e;
  const a = ct(r), d = Kt(r);
  if (r === d) return t;
  let o = { scrollLeft: 0, scrollTop: 0 }, i = { x: 1, y: 1 };
  const l = { x: 0, y: 0 };
  if ((a || !a && n !== "fixed") && ((Qt(r) !== "body" || Da(d)) && (o = Na(r)), ct(r))) {
    const s = Pn(r);
    i = Fr(r), l.x = s.x + r.clientLeft, l.y = s.y + r.clientTop;
  }
  return { width: t.width * i.x, height: t.height * i.y, x: t.x * i.x - o.scrollLeft * i.x + l.x, y: t.y * i.y - o.scrollTop * i.y + l.y };
}, isElement: qt, getDimensions: function(e) {
  return ct(e) ? Wu(e) : e.getBoundingClientRect();
}, getOffsetParent: gl, getDocumentElement: Kt, getScale: Fr, async getElementRects(e) {
  let { reference: t, floating: r, strategy: n } = e;
  const a = this.getOffsetParent || gl, d = this.getDimensions;
  return { reference: If(t, await a(r), n), floating: { x: 0, y: 0, ...await d(r) } };
}, getClientRects: (e) => Array.from(e.getClientRects()), isRTL: (e) => ut(e).direction === "rtl" }, Df = (e, t, r) => {
  const n = /* @__PURE__ */ new Map(), a = { platform: Rf, ...r }, d = { ...a.platform, _c: n };
  return _f(e, t, { ...a, platform: d });
}, hr = {
  // Disable popper components
  disabled: !1,
  // Default position offset along main axis (px)
  distance: 5,
  // Default position offset along cross axis (px)
  skidding: 0,
  // Default container where the tooltip will be appended
  container: "body",
  // Element used to compute position and size boundaries
  boundary: void 0,
  // Skip delay & CSS transitions when another popper is shown, so that the popper appear to instanly move to the new position.
  instantMove: !1,
  // Auto destroy tooltip DOM nodes (ms)
  disposeTimeout: 150,
  // Triggers on the popper itself
  popperTriggers: [],
  // Positioning strategy
  strategy: "absolute",
  // Prevent overflow
  preventOverflow: !0,
  // Flip to the opposite placement if needed
  flip: !0,
  // Shift on the cross axis to prevent the popper from overflowing
  shift: !0,
  // Overflow padding (px)
  overflowPadding: 0,
  // Arrow padding (px)
  arrowPadding: 0,
  // Compute arrow overflow (useful to hide it)
  arrowOverflow: !0,
  /**
   * By default, compute autohide on 'click'.
   */
  autoHideOnMousedown: !1,
  // Themes
  themes: {
    tooltip: {
      // Default tooltip placement relative to target element
      placement: "top",
      // Default events that trigger the tooltip
      triggers: ["hover", "focus", "touch"],
      // Close tooltip on click on tooltip target
      hideTriggers: (e) => [...e, "click"],
      // Delay (ms)
      delay: {
        show: 200,
        hide: 0
      },
      // Update popper on content resize
      handleResize: !1,
      // Enable HTML content in directive
      html: !1,
      // Displayed when tooltip content is loading
      loadingContent: "..."
    },
    dropdown: {
      // Default dropdown placement relative to target element
      placement: "bottom",
      // Default events that trigger the dropdown
      triggers: ["click"],
      // Delay (ms)
      delay: 0,
      // Update popper on content resize
      handleResize: !0,
      // Hide on clock outside
      autoHide: !0
    },
    menu: {
      $extend: "dropdown",
      triggers: ["hover", "focus"],
      popperTriggers: ["hover"],
      delay: {
        show: 0,
        hide: 400
      }
    }
  }
};
function Mo(e, t) {
  let r = hr.themes[e] || {}, n;
  do
    n = r[t], typeof n > "u" ? r.$extend ? r = hr.themes[r.$extend] || {} : (r = null, n = hr[t]) : r = null;
  while (r);
  return n;
}
function Nf(e) {
  const t = [e];
  let r = hr.themes[e] || {};
  do
    r.$extend && !r.$resetCss ? (t.push(r.$extend), r = hr.themes[r.$extend] || {}) : r = null;
  while (r);
  return t.map((n) => `v-popper--theme-${n}`);
}
function bl(e) {
  const t = [e];
  let r = hr.themes[e] || {};
  do
    r.$extend ? (t.push(r.$extend), r = hr.themes[r.$extend] || {}) : r = null;
  while (r);
  return t;
}
let En = !1;
if (typeof window < "u") {
  En = !1;
  try {
    const e = Object.defineProperty({}, "passive", {
      get() {
        En = !0;
      }
    });
    window.addEventListener("test", null, e);
  } catch {
  }
}
let Xu = !1;
typeof window < "u" && typeof navigator < "u" && (Xu = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream);
const Ff = ["auto", "top", "bottom", "left", "right"].reduce((e, t) => e.concat([
  t,
  `${t}-start`,
  `${t}-end`
]), []), wl = {
  hover: "mouseenter",
  focus: "focus",
  click: "click",
  touch: "touchstart",
  pointer: "pointerdown"
}, _l = {
  hover: "mouseleave",
  focus: "blur",
  click: "click",
  touch: "touchend",
  pointer: "pointerup"
};
function xl(e, t) {
  const r = e.indexOf(t);
  r !== -1 && e.splice(r, 1);
}
function sd() {
  return new Promise((e) => requestAnimationFrame(() => {
    requestAnimationFrame(e);
  }));
}
const Qe = [];
let lr = null;
const Sl = {};
function Cl(e) {
  let t = Sl[e];
  return t || (t = Sl[e] = []), t;
}
let Oo = function() {
};
typeof window < "u" && (Oo = window.Element);
function se(e) {
  return function(t) {
    return Mo(t.theme, e);
  };
}
const ud = "__floating-vue__popper", e1 = () => V({
  name: "VPopper",
  provide() {
    return {
      [ud]: {
        parentPopper: this
      }
    };
  },
  inject: {
    [ud]: { default: null }
  },
  props: {
    theme: {
      type: String,
      required: !0
    },
    targetNodes: {
      type: Function,
      required: !0
    },
    referenceNode: {
      type: Function,
      default: null
    },
    popperNode: {
      type: Function,
      required: !0
    },
    shown: {
      type: Boolean,
      default: !1
    },
    showGroup: {
      type: String,
      default: null
    },
    // eslint-disable-next-line vue/require-prop-types
    ariaId: {
      default: null
    },
    disabled: {
      type: Boolean,
      default: se("disabled")
    },
    positioningDisabled: {
      type: Boolean,
      default: se("positioningDisabled")
    },
    placement: {
      type: String,
      default: se("placement"),
      validator: (e) => Ff.includes(e)
    },
    delay: {
      type: [String, Number, Object],
      default: se("delay")
    },
    distance: {
      type: [Number, String],
      default: se("distance")
    },
    skidding: {
      type: [Number, String],
      default: se("skidding")
    },
    triggers: {
      type: Array,
      default: se("triggers")
    },
    showTriggers: {
      type: [Array, Function],
      default: se("showTriggers")
    },
    hideTriggers: {
      type: [Array, Function],
      default: se("hideTriggers")
    },
    popperTriggers: {
      type: Array,
      default: se("popperTriggers")
    },
    popperShowTriggers: {
      type: [Array, Function],
      default: se("popperShowTriggers")
    },
    popperHideTriggers: {
      type: [Array, Function],
      default: se("popperHideTriggers")
    },
    container: {
      type: [String, Object, Oo, Boolean],
      default: se("container")
    },
    boundary: {
      type: [String, Oo],
      default: se("boundary")
    },
    strategy: {
      type: String,
      validator: (e) => ["absolute", "fixed"].includes(e),
      default: se("strategy")
    },
    autoHide: {
      type: [Boolean, Function],
      default: se("autoHide")
    },
    handleResize: {
      type: Boolean,
      default: se("handleResize")
    },
    instantMove: {
      type: Boolean,
      default: se("instantMove")
    },
    eagerMount: {
      type: Boolean,
      default: se("eagerMount")
    },
    popperClass: {
      type: [String, Array, Object],
      default: se("popperClass")
    },
    computeTransformOrigin: {
      type: Boolean,
      default: se("computeTransformOrigin")
    },
    /**
     * @deprecated
     */
    autoMinSize: {
      type: Boolean,
      default: se("autoMinSize")
    },
    autoSize: {
      type: [Boolean, String],
      default: se("autoSize")
    },
    /**
     * @deprecated
     */
    autoMaxSize: {
      type: Boolean,
      default: se("autoMaxSize")
    },
    autoBoundaryMaxSize: {
      type: Boolean,
      default: se("autoBoundaryMaxSize")
    },
    preventOverflow: {
      type: Boolean,
      default: se("preventOverflow")
    },
    overflowPadding: {
      type: [Number, String],
      default: se("overflowPadding")
    },
    arrowPadding: {
      type: [Number, String],
      default: se("arrowPadding")
    },
    arrowOverflow: {
      type: Boolean,
      default: se("arrowOverflow")
    },
    flip: {
      type: Boolean,
      default: se("flip")
    },
    shift: {
      type: Boolean,
      default: se("shift")
    },
    shiftCrossAxis: {
      type: Boolean,
      default: se("shiftCrossAxis")
    },
    noAutoFocus: {
      type: Boolean,
      default: se("noAutoFocus")
    },
    disposeTimeout: {
      type: Number,
      default: se("disposeTimeout")
    }
  },
  emits: {
    show: () => !0,
    hide: () => !0,
    "update:shown": (e) => !0,
    "apply-show": () => !0,
    "apply-hide": () => !0,
    "close-group": () => !0,
    "close-directive": () => !0,
    "auto-hide": () => !0,
    resize: () => !0
  },
  data() {
    return {
      isShown: !1,
      isMounted: !1,
      skipTransition: !1,
      classes: {
        showFrom: !1,
        showTo: !1,
        hideFrom: !1,
        hideTo: !0
      },
      result: {
        x: 0,
        y: 0,
        placement: "",
        strategy: this.strategy,
        arrow: {
          x: 0,
          y: 0,
          centerOffset: 0
        },
        transformOrigin: null
      },
      randomId: `popper_${[Math.random(), Date.now()].map((e) => e.toString(36).substring(2, 10)).join("_")}`,
      shownChildren: /* @__PURE__ */ new Set(),
      lastAutoHide: !0,
      pendingHide: !1,
      containsGlobalTarget: !1,
      isDisposed: !0,
      mouseDownContains: !1
    };
  },
  computed: {
    popperId() {
      return this.ariaId != null ? this.ariaId : this.randomId;
    },
    shouldMountContent() {
      return this.eagerMount || this.isMounted;
    },
    slotData() {
      return {
        popperId: this.popperId,
        isShown: this.isShown,
        shouldMountContent: this.shouldMountContent,
        skipTransition: this.skipTransition,
        autoHide: typeof this.autoHide == "function" ? this.lastAutoHide : this.autoHide,
        show: this.show,
        hide: this.hide,
        handleResize: this.handleResize,
        onResize: this.onResize,
        classes: {
          ...this.classes,
          popperClass: this.popperClass
        },
        result: this.positioningDisabled ? null : this.result,
        attrs: this.$attrs
      };
    },
    parentPopper() {
      var e;
      return (e = this[ud]) == null ? void 0 : e.parentPopper;
    },
    hasPopperShowTriggerHover() {
      var e, t;
      return ((e = this.popperTriggers) == null ? void 0 : e.includes("hover")) || ((t = this.popperShowTriggers) == null ? void 0 : t.includes("hover"));
    }
  },
  watch: {
    shown: "$_autoShowHide",
    disabled(e) {
      e ? this.dispose() : this.init();
    },
    async container() {
      this.isShown && (this.$_ensureTeleport(), await this.$_computePosition());
    },
    triggers: {
      handler: "$_refreshListeners",
      deep: !0
    },
    positioningDisabled: "$_refreshListeners",
    ...[
      "placement",
      "distance",
      "skidding",
      "boundary",
      "strategy",
      "overflowPadding",
      "arrowPadding",
      "preventOverflow",
      "shift",
      "shiftCrossAxis",
      "flip"
    ].reduce((e, t) => (e[t] = "$_computePosition", e), {})
  },
  created() {
    this.autoMinSize && console.warn('[floating-vue] `autoMinSize` option is deprecated. Use `autoSize="min"` instead.'), this.autoMaxSize && console.warn("[floating-vue] `autoMaxSize` option is deprecated. Use `autoBoundaryMaxSize` instead.");
  },
  mounted() {
    this.init(), this.$_detachPopperNode();
  },
  activated() {
    this.$_autoShowHide();
  },
  deactivated() {
    this.hide();
  },
  beforeUnmount() {
    this.dispose();
  },
  methods: {
    show({ event: e = null, skipDelay: t = !1, force: r = !1 } = {}) {
      var n, a;
      (n = this.parentPopper) != null && n.lockedChild && this.parentPopper.lockedChild !== this || (this.pendingHide = !1, (r || !this.disabled) && (((a = this.parentPopper) == null ? void 0 : a.lockedChild) === this && (this.parentPopper.lockedChild = null), this.$_scheduleShow(e, t), this.$emit("show"), this.$_showFrameLocked = !0, requestAnimationFrame(() => {
        this.$_showFrameLocked = !1;
      })), this.$emit("update:shown", !0));
    },
    hide({ event: e = null, skipDelay: t = !1 } = {}) {
      var r;
      if (!this.$_hideInProgress) {
        if (this.shownChildren.size > 0) {
          this.pendingHide = !0;
          return;
        }
        if (this.hasPopperShowTriggerHover && this.$_isAimingPopper()) {
          this.parentPopper && (this.parentPopper.lockedChild = this, clearTimeout(this.parentPopper.lockedChildTimer), this.parentPopper.lockedChildTimer = setTimeout(() => {
            this.parentPopper.lockedChild === this && (this.parentPopper.lockedChild.hide({ skipDelay: t }), this.parentPopper.lockedChild = null);
          }, 1e3));
          return;
        }
        ((r = this.parentPopper) == null ? void 0 : r.lockedChild) === this && (this.parentPopper.lockedChild = null), this.pendingHide = !1, this.$_scheduleHide(e, t), this.$emit("hide"), this.$emit("update:shown", !1);
      }
    },
    init() {
      var e;
      this.isDisposed && (this.isDisposed = !1, this.isMounted = !1, this.$_events = [], this.$_preventShow = !1, this.$_referenceNode = ((e = this.referenceNode) == null ? void 0 : e.call(this)) ?? this.$el, this.$_targetNodes = this.targetNodes().filter((t) => t.nodeType === t.ELEMENT_NODE), this.$_popperNode = this.popperNode(), this.$_innerNode = this.$_popperNode.querySelector(".v-popper__inner"), this.$_arrowNode = this.$_popperNode.querySelector(".v-popper__arrow-container"), this.$_swapTargetAttrs("title", "data-original-title"), this.$_detachPopperNode(), this.triggers.length && this.$_addEventListeners(), this.shown && this.show());
    },
    dispose() {
      this.isDisposed || (this.isDisposed = !0, this.$_removeEventListeners(), this.hide({ skipDelay: !0 }), this.$_detachPopperNode(), this.isMounted = !1, this.isShown = !1, this.$_updateParentShownChildren(!1), this.$_swapTargetAttrs("data-original-title", "title"));
    },
    async onResize() {
      this.isShown && (await this.$_computePosition(), this.$emit("resize"));
    },
    async $_computePosition() {
      if (this.isDisposed || this.positioningDisabled)
        return;
      const e = {
        strategy: this.strategy,
        middleware: []
      };
      (this.distance || this.skidding) && e.middleware.push(Mf({
        mainAxis: this.distance,
        crossAxis: this.skidding
      }));
      const t = this.placement.startsWith("auto");
      if (t ? e.middleware.push(Cf({
        alignment: this.placement.split("-")[1] ?? ""
      })) : e.placement = this.placement, this.preventOverflow && (this.shift && e.middleware.push(Of({
        padding: this.overflowPadding,
        boundary: this.boundary,
        crossAxis: this.shiftCrossAxis
      })), !t && this.flip && e.middleware.push(Pf({
        padding: this.overflowPadding,
        boundary: this.boundary
      }))), e.middleware.push(xf({
        element: this.$_arrowNode,
        padding: this.arrowPadding
      })), this.arrowOverflow && e.middleware.push({
        name: "arrowOverflow",
        fn: ({ placement: n, rects: a, middlewareData: d }) => {
          let o;
          const { centerOffset: i } = d.arrow;
          return n.startsWith("top") || n.startsWith("bottom") ? o = Math.abs(i) > a.reference.width / 2 : o = Math.abs(i) > a.reference.height / 2, {
            data: {
              overflow: o
            }
          };
        }
      }), this.autoMinSize || this.autoSize) {
        const n = this.autoSize ? this.autoSize : this.autoMinSize ? "min" : null;
        e.middleware.push({
          name: "autoSize",
          fn: ({ rects: a, placement: d, middlewareData: o }) => {
            var i;
            if ((i = o.autoSize) != null && i.skip)
              return {};
            let l, s;
            return d.startsWith("top") || d.startsWith("bottom") ? l = a.reference.width : s = a.reference.height, this.$_innerNode.style[n === "min" ? "minWidth" : n === "max" ? "maxWidth" : "width"] = l != null ? `${l}px` : null, this.$_innerNode.style[n === "min" ? "minHeight" : n === "max" ? "maxHeight" : "height"] = s != null ? `${s}px` : null, {
              data: {
                skip: !0
              },
              reset: {
                rects: !0
              }
            };
          }
        });
      }
      (this.autoMaxSize || this.autoBoundaryMaxSize) && (this.$_innerNode.style.maxWidth = null, this.$_innerNode.style.maxHeight = null, e.middleware.push(Tf({
        boundary: this.boundary,
        padding: this.overflowPadding,
        apply: ({ availableWidth: n, availableHeight: a }) => {
          this.$_innerNode.style.maxWidth = n != null ? `${n}px` : null, this.$_innerNode.style.maxHeight = a != null ? `${a}px` : null;
        }
      })));
      const r = await Df(this.$_referenceNode, this.$_popperNode, e);
      Object.assign(this.result, {
        x: r.x,
        y: r.y,
        placement: r.placement,
        strategy: r.strategy,
        arrow: {
          ...r.middlewareData.arrow,
          ...r.middlewareData.arrowOverflow
        }
      });
    },
    $_scheduleShow(e, t = !1) {
      if (this.$_updateParentShownChildren(!0), this.$_hideInProgress = !1, clearTimeout(this.$_scheduleTimer), lr && this.instantMove && lr.instantMove && lr !== this.parentPopper) {
        lr.$_applyHide(!0), this.$_applyShow(!0);
        return;
      }
      t ? this.$_applyShow() : this.$_scheduleTimer = setTimeout(this.$_applyShow.bind(this), this.$_computeDelay("show"));
    },
    $_scheduleHide(e, t = !1) {
      if (this.shownChildren.size > 0) {
        this.pendingHide = !0;
        return;
      }
      this.$_updateParentShownChildren(!1), this.$_hideInProgress = !0, clearTimeout(this.$_scheduleTimer), this.isShown && (lr = this), t ? this.$_applyHide() : this.$_scheduleTimer = setTimeout(this.$_applyHide.bind(this), this.$_computeDelay("hide"));
    },
    $_computeDelay(e) {
      const t = this.delay;
      return parseInt(t && t[e] || t || 0);
    },
    async $_applyShow(e = !1) {
      clearTimeout(this.$_disposeTimer), clearTimeout(this.$_scheduleTimer), this.skipTransition = e, !this.isShown && (this.$_ensureTeleport(), await sd(), await this.$_computePosition(), await this.$_applyShowEffect(), this.positioningDisabled || this.$_registerEventListeners([
        ...va(this.$_referenceNode),
        ...va(this.$_popperNode)
      ], "scroll", () => {
        this.$_computePosition();
      }));
    },
    async $_applyShowEffect() {
      if (this.$_hideInProgress)
        return;
      if (this.computeTransformOrigin) {
        const t = this.$_referenceNode.getBoundingClientRect(), r = this.$_popperNode.querySelector(".v-popper__wrapper"), n = r.parentNode.getBoundingClientRect(), a = t.x + t.width / 2 - (n.left + r.offsetLeft), d = t.y + t.height / 2 - (n.top + r.offsetTop);
        this.result.transformOrigin = `${a}px ${d}px`;
      }
      this.isShown = !0, this.$_applyAttrsToTarget({
        "aria-describedby": this.popperId,
        "data-popper-shown": ""
      });
      const e = this.showGroup;
      if (e) {
        let t;
        for (let r = 0; r < Qe.length; r++)
          t = Qe[r], t.showGroup !== e && (t.hide(), t.$emit("close-group"));
      }
      Qe.push(this), document.body.classList.add("v-popper--some-open");
      for (const t of bl(this.theme))
        Cl(t).push(this), document.body.classList.add(`v-popper--some-open--${t}`);
      this.$emit("apply-show"), this.classes.showFrom = !0, this.classes.showTo = !1, this.classes.hideFrom = !1, this.classes.hideTo = !1, await sd(), this.classes.showFrom = !1, this.classes.showTo = !0, this.noAutoFocus || this.$_popperNode.focus();
    },
    async $_applyHide(e = !1) {
      if (this.shownChildren.size > 0) {
        this.pendingHide = !0, this.$_hideInProgress = !1;
        return;
      }
      if (clearTimeout(this.$_scheduleTimer), !this.isShown)
        return;
      this.skipTransition = e, xl(Qe, this), Qe.length === 0 && document.body.classList.remove("v-popper--some-open");
      for (const r of bl(this.theme)) {
        const n = Cl(r);
        xl(n, this), n.length === 0 && document.body.classList.remove(`v-popper--some-open--${r}`);
      }
      lr === this && (lr = null), this.isShown = !1, this.$_applyAttrsToTarget({
        "aria-describedby": void 0,
        "data-popper-shown": void 0
      }), clearTimeout(this.$_disposeTimer);
      const t = this.disposeTimeout;
      t !== null && (this.$_disposeTimer = setTimeout(() => {
        this.$_popperNode && (this.$_detachPopperNode(), this.isMounted = !1);
      }, t)), this.$_removeEventListeners("scroll"), this.$emit("apply-hide"), this.classes.showFrom = !1, this.classes.showTo = !1, this.classes.hideFrom = !0, this.classes.hideTo = !1, await sd(), this.classes.hideFrom = !1, this.classes.hideTo = !0;
    },
    $_autoShowHide() {
      this.shown ? this.show() : this.hide();
    },
    $_ensureTeleport() {
      if (this.isDisposed)
        return;
      let e = this.container;
      if (typeof e == "string" ? e = window.document.querySelector(e) : e === !1 && (e = this.$_targetNodes[0].parentNode), !e)
        throw new Error("No container for popover: " + this.container);
      e.appendChild(this.$_popperNode), this.isMounted = !0;
    },
    $_addEventListeners() {
      const e = (r) => {
        this.isShown && !this.$_hideInProgress || (r.usedByTooltip = !0, !this.$_preventShow && this.show({ event: r }));
      };
      this.$_registerTriggerListeners(this.$_targetNodes, wl, this.triggers, this.showTriggers, e), this.$_registerTriggerListeners([this.$_popperNode], wl, this.popperTriggers, this.popperShowTriggers, e);
      const t = (r) => {
        r.usedByTooltip || this.hide({ event: r });
      };
      this.$_registerTriggerListeners(this.$_targetNodes, _l, this.triggers, this.hideTriggers, t), this.$_registerTriggerListeners([this.$_popperNode], _l, this.popperTriggers, this.popperHideTriggers, t);
    },
    $_registerEventListeners(e, t, r) {
      this.$_events.push({ targetNodes: e, eventType: t, handler: r }), e.forEach((n) => n.addEventListener(t, r, En ? {
        passive: !0
      } : void 0));
    },
    $_registerTriggerListeners(e, t, r, n, a) {
      let d = r;
      n != null && (d = typeof n == "function" ? n(d) : n), d.forEach((o) => {
        const i = t[o];
        i && this.$_registerEventListeners(e, i, a);
      });
    },
    $_removeEventListeners(e) {
      const t = [];
      this.$_events.forEach((r) => {
        const { targetNodes: n, eventType: a, handler: d } = r;
        !e || e === a ? n.forEach((o) => o.removeEventListener(a, d)) : t.push(r);
      }), this.$_events = t;
    },
    $_refreshListeners() {
      this.isDisposed || (this.$_removeEventListeners(), this.$_addEventListeners());
    },
    $_handleGlobalClose(e, t = !1) {
      this.$_showFrameLocked || (this.hide({ event: e }), e.closePopover ? this.$emit("close-directive") : this.$emit("auto-hide"), t && (this.$_preventShow = !0, setTimeout(() => {
        this.$_preventShow = !1;
      }, 300)));
    },
    $_detachPopperNode() {
      this.$_popperNode.parentNode && this.$_popperNode.parentNode.removeChild(this.$_popperNode);
    },
    $_swapTargetAttrs(e, t) {
      for (const r of this.$_targetNodes) {
        const n = r.getAttribute(e);
        n && (r.removeAttribute(e), r.setAttribute(t, n));
      }
    },
    $_applyAttrsToTarget(e) {
      for (const t of this.$_targetNodes)
        for (const r in e) {
          const n = e[r];
          n == null ? t.removeAttribute(r) : t.setAttribute(r, n);
        }
    },
    $_updateParentShownChildren(e) {
      let t = this.parentPopper;
      for (; t; )
        e ? t.shownChildren.add(this.randomId) : (t.shownChildren.delete(this.randomId), t.pendingHide && t.hide()), t = t.parentPopper;
    },
    $_isAimingPopper() {
      const e = this.$_referenceNode.getBoundingClientRect();
      if (wn >= e.left && wn <= e.right && _n >= e.top && _n <= e.bottom) {
        const t = this.$_popperNode.getBoundingClientRect(), r = wn - jt, n = _n - Gt, a = t.left + t.width / 2 - jt + (t.top + t.height / 2) - Gt + t.width + t.height, d = jt + r * a, o = Gt + n * a;
        return na(jt, Gt, d, o, t.left, t.top, t.left, t.bottom) || // Left edge
        na(jt, Gt, d, o, t.left, t.top, t.right, t.top) || // Top edge
        na(jt, Gt, d, o, t.right, t.top, t.right, t.bottom) || // Right edge
        na(jt, Gt, d, o, t.left, t.bottom, t.right, t.bottom);
      }
      return !1;
    }
  },
  render() {
    return this.$slots.default(this.slotData);
  }
});
if (typeof document < "u" && typeof window < "u") {
  if (Xu) {
    const e = En ? {
      passive: !0,
      capture: !0
    } : !0;
    document.addEventListener("touchstart", (t) => Pl(t), e), document.addEventListener("touchend", (t) => Al(t, !0), e);
  } else
    window.addEventListener("mousedown", (e) => Pl(e), !0), window.addEventListener("click", (e) => Al(e, !1), !0);
  window.addEventListener("resize", Vf);
}
function Pl(e, t) {
  for (let r = 0; r < Qe.length; r++) {
    const n = Qe[r];
    try {
      n.mouseDownContains = n.popperNode().contains(e.target);
    } catch {
    }
  }
}
function Al(e, t) {
  Lf(e, t);
}
function Lf(e, t) {
  const r = {};
  for (let n = Qe.length - 1; n >= 0; n--) {
    const a = Qe[n];
    try {
      const d = a.containsGlobalTarget = a.mouseDownContains || a.popperNode().contains(e.target);
      a.pendingHide = !1, requestAnimationFrame(() => {
        if (a.pendingHide = !1, !r[a.randomId] && El(a, d, e)) {
          if (a.$_handleGlobalClose(e, t), !e.closeAllPopover && e.closePopover && d) {
            let i = a.parentPopper;
            for (; i; )
              r[i.randomId] = !0, i = i.parentPopper;
            return;
          }
          let o = a.parentPopper;
          for (; o && El(o, o.containsGlobalTarget, e); )
            o.$_handleGlobalClose(e, t), o = o.parentPopper;
        }
      });
    } catch {
    }
  }
}
function El(e, t, r) {
  return r.closeAllPopover || r.closePopover && t || Bf(e, r) && !t;
}
function Bf(e, t) {
  if (typeof e.autoHide == "function") {
    const r = e.autoHide(t);
    return e.lastAutoHide = r, r;
  }
  return e.autoHide;
}
function Vf() {
  for (let e = 0; e < Qe.length; e++)
    Qe[e].$_computePosition();
}
let jt = 0, Gt = 0, wn = 0, _n = 0;
typeof window < "u" && window.addEventListener("mousemove", (e) => {
  jt = wn, Gt = _n, wn = e.clientX, _n = e.clientY;
}, En ? {
  passive: !0
} : void 0);
function na(e, t, r, n, a, d, o, i) {
  const l = ((o - a) * (t - d) - (i - d) * (e - a)) / ((i - d) * (r - e) - (o - a) * (n - t)), s = ((r - e) * (t - d) - (n - t) * (e - a)) / ((i - d) * (r - e) - (o - a) * (n - t));
  return l >= 0 && l <= 1 && s >= 0 && s <= 1;
}
const jf = {
  extends: e1()
}, mi = (e, t) => {
  const r = e.__vccOpts || e;
  for (const [n, a] of t)
    r[n] = a;
  return r;
};
function Gf(e, t, r, n, a, d) {
  return S(), I("div", {
    ref: "reference",
    class: de(["v-popper", {
      "v-popper--shown": e.slotData.isShown
    }])
  }, [
    F(e.$slots, "default", Ot(Tt(e.slotData)))
  ], 2);
}
const Uf = /* @__PURE__ */ mi(jf, [["render", Gf]]);
function Hf() {
  var e = window.navigator.userAgent, t = e.indexOf("MSIE ");
  if (t > 0)
    return parseInt(e.substring(t + 5, e.indexOf(".", t)), 10);
  var r = e.indexOf("Trident/");
  if (r > 0) {
    var n = e.indexOf("rv:");
    return parseInt(e.substring(n + 3, e.indexOf(".", n)), 10);
  }
  var a = e.indexOf("Edge/");
  return a > 0 ? parseInt(e.substring(a + 5, e.indexOf(".", a)), 10) : -1;
}
let sa;
function To() {
  To.init || (To.init = !0, sa = Hf() !== -1);
}
var Fa = {
  name: "ResizeObserver",
  props: {
    emitOnMount: {
      type: Boolean,
      default: !1
    },
    ignoreWidth: {
      type: Boolean,
      default: !1
    },
    ignoreHeight: {
      type: Boolean,
      default: !1
    }
  },
  emits: [
    "notify"
  ],
  mounted() {
    To(), tt(() => {
      this._w = this.$el.offsetWidth, this._h = this.$el.offsetHeight, this.emitOnMount && this.emitSize();
    });
    const e = document.createElement("object");
    this._resizeObject = e, e.setAttribute("aria-hidden", "true"), e.setAttribute("tabindex", -1), e.onload = this.addResizeHandlers, e.type = "text/html", sa && this.$el.appendChild(e), e.data = "about:blank", sa || this.$el.appendChild(e);
  },
  beforeUnmount() {
    this.removeResizeHandlers();
  },
  methods: {
    compareAndNotify() {
      (!this.ignoreWidth && this._w !== this.$el.offsetWidth || !this.ignoreHeight && this._h !== this.$el.offsetHeight) && (this._w = this.$el.offsetWidth, this._h = this.$el.offsetHeight, this.emitSize());
    },
    emitSize() {
      this.$emit("notify", {
        width: this._w,
        height: this._h
      });
    },
    addResizeHandlers() {
      this._resizeObject.contentDocument.defaultView.addEventListener("resize", this.compareAndNotify), this.compareAndNotify();
    },
    removeResizeHandlers() {
      this._resizeObject && this._resizeObject.onload && (!sa && this._resizeObject.contentDocument && this._resizeObject.contentDocument.defaultView.removeEventListener("resize", this.compareAndNotify), this.$el.removeChild(this._resizeObject), this._resizeObject.onload = null, this._resizeObject = null);
    }
  }
};
const Wf = /* @__PURE__ */ I2("data-v-b329ee4c");
T2("data-v-b329ee4c");
const zf = {
  class: "resize-observer",
  tabindex: "-1"
};
k2();
const qf = /* @__PURE__ */ Wf((e, t, r, n, a, d) => (S(), B("div", zf)));
Fa.render = qf;
Fa.__scopeId = "data-v-b329ee4c";
Fa.__file = "src/components/ResizeObserver.vue";
const t1 = (e = "theme") => ({
  computed: {
    themeClass() {
      return Nf(this[e]);
    }
  }
}), Kf = V({
  name: "VPopperContent",
  components: {
    ResizeObserver: Fa
  },
  mixins: [
    t1()
  ],
  props: {
    popperId: String,
    theme: String,
    shown: Boolean,
    mounted: Boolean,
    skipTransition: Boolean,
    autoHide: Boolean,
    handleResize: Boolean,
    classes: Object,
    result: Object
  },
  emits: [
    "hide",
    "resize"
  ],
  methods: {
    toPx(e) {
      return e != null && !isNaN(e) ? `${e}px` : null;
    }
  }
}), Yf = ["id", "aria-hidden", "tabindex", "data-popper-placement"], Zf = {
  ref: "inner",
  class: "v-popper__inner"
}, Jf = /* @__PURE__ */ C("div", { class: "v-popper__arrow-outer" }, null, -1), Qf = /* @__PURE__ */ C("div", { class: "v-popper__arrow-inner" }, null, -1), Xf = [
  Jf,
  Qf
];
function e$(e, t, r, n, a, d) {
  const o = _o("ResizeObserver");
  return S(), I("div", {
    id: e.popperId,
    ref: "popover",
    class: de(["v-popper__popper", [
      e.themeClass,
      e.classes.popperClass,
      {
        "v-popper__popper--shown": e.shown,
        "v-popper__popper--hidden": !e.shown,
        "v-popper__popper--show-from": e.classes.showFrom,
        "v-popper__popper--show-to": e.classes.showTo,
        "v-popper__popper--hide-from": e.classes.hideFrom,
        "v-popper__popper--hide-to": e.classes.hideTo,
        "v-popper__popper--skip-transition": e.skipTransition,
        "v-popper__popper--arrow-overflow": e.result && e.result.arrow.overflow,
        "v-popper__popper--no-positioning": !e.result
      }
    ]]),
    style: Ct(e.result ? {
      position: e.result.strategy,
      transform: `translate3d(${Math.round(e.result.x)}px,${Math.round(e.result.y)}px,0)`
    } : void 0),
    "aria-hidden": e.shown ? "false" : "true",
    tabindex: e.autoHide ? 0 : void 0,
    "data-popper-placement": e.result ? e.result.placement : void 0,
    onKeyup: t[2] || (t[2] = Pt((i) => e.autoHide && e.$emit("hide"), ["esc"]))
  }, [
    C("div", {
      class: "v-popper__backdrop",
      onClick: t[0] || (t[0] = (i) => e.autoHide && e.$emit("hide"))
    }),
    C("div", {
      class: "v-popper__wrapper",
      style: Ct(e.result ? {
        transformOrigin: e.result.transformOrigin
      } : void 0)
    }, [
      C("div", Zf, [
        e.mounted ? (S(), I(le, { key: 0 }, [
          C("div", null, [
            F(e.$slots, "default")
          ]),
          e.handleResize ? (S(), B(o, {
            key: 0,
            onNotify: t[1] || (t[1] = (i) => e.$emit("resize", i))
          })) : Z("", !0)
        ], 64)) : Z("", !0)
      ], 512),
      C("div", {
        ref: "arrow",
        class: "v-popper__arrow-container",
        style: Ct(e.result ? {
          left: e.toPx(e.result.arrow.x),
          top: e.toPx(e.result.arrow.y)
        } : void 0)
      }, Xf, 4)
    ], 4)
  ], 46, Yf);
}
const r1 = /* @__PURE__ */ mi(Kf, [["render", e$]]), n1 = {
  methods: {
    show(...e) {
      return this.$refs.popper.show(...e);
    },
    hide(...e) {
      return this.$refs.popper.hide(...e);
    },
    dispose(...e) {
      return this.$refs.popper.dispose(...e);
    },
    onResize(...e) {
      return this.$refs.popper.onResize(...e);
    }
  }
};
let ko = function() {
};
typeof window < "u" && (ko = window.Element);
const t$ = V({
  name: "VPopperWrapper",
  components: {
    Popper: Uf,
    PopperContent: r1
  },
  mixins: [
    n1,
    t1("finalTheme")
  ],
  props: {
    theme: {
      type: String,
      default: null
    },
    referenceNode: {
      type: Function,
      default: null
    },
    shown: {
      type: Boolean,
      default: !1
    },
    showGroup: {
      type: String,
      default: null
    },
    // eslint-disable-next-line vue/require-prop-types
    ariaId: {
      default: null
    },
    disabled: {
      type: Boolean,
      default: void 0
    },
    positioningDisabled: {
      type: Boolean,
      default: void 0
    },
    placement: {
      type: String,
      default: void 0
    },
    delay: {
      type: [String, Number, Object],
      default: void 0
    },
    distance: {
      type: [Number, String],
      default: void 0
    },
    skidding: {
      type: [Number, String],
      default: void 0
    },
    triggers: {
      type: Array,
      default: void 0
    },
    showTriggers: {
      type: [Array, Function],
      default: void 0
    },
    hideTriggers: {
      type: [Array, Function],
      default: void 0
    },
    popperTriggers: {
      type: Array,
      default: void 0
    },
    popperShowTriggers: {
      type: [Array, Function],
      default: void 0
    },
    popperHideTriggers: {
      type: [Array, Function],
      default: void 0
    },
    container: {
      type: [String, Object, ko, Boolean],
      default: void 0
    },
    boundary: {
      type: [String, ko],
      default: void 0
    },
    strategy: {
      type: String,
      default: void 0
    },
    autoHide: {
      type: [Boolean, Function],
      default: void 0
    },
    handleResize: {
      type: Boolean,
      default: void 0
    },
    instantMove: {
      type: Boolean,
      default: void 0
    },
    eagerMount: {
      type: Boolean,
      default: void 0
    },
    popperClass: {
      type: [String, Array, Object],
      default: void 0
    },
    computeTransformOrigin: {
      type: Boolean,
      default: void 0
    },
    /**
     * @deprecated
     */
    autoMinSize: {
      type: Boolean,
      default: void 0
    },
    autoSize: {
      type: [Boolean, String],
      default: void 0
    },
    /**
     * @deprecated
     */
    autoMaxSize: {
      type: Boolean,
      default: void 0
    },
    autoBoundaryMaxSize: {
      type: Boolean,
      default: void 0
    },
    preventOverflow: {
      type: Boolean,
      default: void 0
    },
    overflowPadding: {
      type: [Number, String],
      default: void 0
    },
    arrowPadding: {
      type: [Number, String],
      default: void 0
    },
    arrowOverflow: {
      type: Boolean,
      default: void 0
    },
    flip: {
      type: Boolean,
      default: void 0
    },
    shift: {
      type: Boolean,
      default: void 0
    },
    shiftCrossAxis: {
      type: Boolean,
      default: void 0
    },
    noAutoFocus: {
      type: Boolean,
      default: void 0
    },
    disposeTimeout: {
      type: Number,
      default: void 0
    }
  },
  emits: {
    show: () => !0,
    hide: () => !0,
    "update:shown": (e) => !0,
    "apply-show": () => !0,
    "apply-hide": () => !0,
    "close-group": () => !0,
    "close-directive": () => !0,
    "auto-hide": () => !0,
    resize: () => !0
  },
  computed: {
    finalTheme() {
      return this.theme ?? this.$options.vPopperTheme;
    }
  },
  methods: {
    getTargetNodes() {
      return Array.from(this.$el.children).filter((e) => e !== this.$refs.popperContent.$el);
    }
  }
});
function r$(e, t, r, n, a, d) {
  const o = _o("PopperContent"), i = _o("Popper");
  return S(), B(i, me({ ref: "popper" }, e.$props, {
    theme: e.finalTheme,
    "target-nodes": e.getTargetNodes,
    "popper-node": () => e.$refs.popperContent.$el,
    class: [
      e.themeClass
    ],
    onShow: t[0] || (t[0] = () => e.$emit("show")),
    onHide: t[1] || (t[1] = () => e.$emit("hide")),
    "onUpdate:shown": t[2] || (t[2] = (l) => e.$emit("update:shown", l)),
    onApplyShow: t[3] || (t[3] = () => e.$emit("apply-show")),
    onApplyHide: t[4] || (t[4] = () => e.$emit("apply-hide")),
    onCloseGroup: t[5] || (t[5] = () => e.$emit("close-group")),
    onCloseDirective: t[6] || (t[6] = () => e.$emit("close-directive")),
    onAutoHide: t[7] || (t[7] = () => e.$emit("auto-hide")),
    onResize: t[8] || (t[8] = () => e.$emit("resize"))
  }), {
    default: D(({
      popperId: l,
      isShown: s,
      shouldMountContent: u,
      skipTransition: $,
      autoHide: y,
      show: h,
      hide: c,
      handleResize: p,
      onResize: f,
      classes: v,
      result: w
    }) => [
      F(e.$slots, "default", {
        shown: s,
        show: h,
        hide: c
      }),
      j(o, {
        ref: "popperContent",
        "popper-id": l,
        theme: e.finalTheme,
        shown: s,
        mounted: u,
        "skip-transition": $,
        "auto-hide": y,
        "handle-resize": p,
        classes: v,
        result: w,
        onHide: c,
        onResize: f
      }, {
        default: D(() => [
          F(e.$slots, "popper", {
            shown: s,
            hide: c
          })
        ]),
        _: 2
      }, 1032, ["popper-id", "theme", "shown", "mounted", "skip-transition", "auto-hide", "handle-resize", "classes", "result", "onHide", "onResize"])
    ]),
    _: 3
  }, 16, ["theme", "target-nodes", "popper-node", "class"]);
}
const hi = /* @__PURE__ */ mi(t$, [["render", r$]]), n$ = {
  ...hi,
  name: "VDropdown",
  vPopperTheme: "dropdown"
};
({
  ...hi
});
const a$ = {
  ...hi,
  name: "VTooltip",
  vPopperTheme: "tooltip"
};
V({
  name: "VTooltipDirective",
  components: {
    Popper: e1(),
    PopperContent: r1
  },
  mixins: [
    n1
  ],
  inheritAttrs: !1,
  props: {
    theme: {
      type: String,
      default: "tooltip"
    },
    html: {
      type: Boolean,
      default: (e) => Mo(e.theme, "html")
    },
    content: {
      type: [String, Number, Function],
      default: null
    },
    loadingContent: {
      type: String,
      default: (e) => Mo(e.theme, "loadingContent")
    },
    targetNodes: {
      type: Function,
      required: !0
    }
  },
  data() {
    return {
      asyncContent: null
    };
  },
  computed: {
    isContentAsync() {
      return typeof this.content == "function";
    },
    loading() {
      return this.isContentAsync && this.asyncContent == null;
    },
    finalContent() {
      return this.isContentAsync ? this.loading ? this.loadingContent : this.asyncContent : this.content;
    }
  },
  watch: {
    content: {
      handler() {
        this.fetchContent(!0);
      },
      immediate: !0
    },
    async finalContent() {
      await this.$nextTick(), this.$refs.popper.onResize();
    }
  },
  created() {
    this.$_fetchId = 0;
  },
  methods: {
    fetchContent(e) {
      if (typeof this.content == "function" && this.$_isShown && (e || !this.$_loading && this.asyncContent == null)) {
        this.asyncContent = null, this.$_loading = !0;
        const t = ++this.$_fetchId, r = this.content(this);
        r.then ? r.then((n) => this.onResult(t, n)) : this.onResult(t, r);
      }
    },
    onResult(e, t) {
      e === this.$_fetchId && (this.$_loading = !1, this.asyncContent = t);
    },
    onShow() {
      this.$_isShown = !0, this.fetchContent();
    },
    onHide() {
      this.$_isShown = !1;
    }
  }
});
const d$ = n$, o$ = a$;
var a1 = typeof global == "object" && global && global.Object === Object && global, i$ = typeof self == "object" && self && self.Object === Object && self, mt = a1 || i$ || Function("return this")(), Xt = mt.Symbol, d1 = Object.prototype, l$ = d1.hasOwnProperty, s$ = d1.toString, cn = Xt ? Xt.toStringTag : void 0;
function u$(e) {
  var t = l$.call(e, cn), r = e[cn];
  try {
    e[cn] = void 0;
    var n = !0;
  } catch {
  }
  var a = s$.call(e);
  return n && (t ? e[cn] = r : delete e[cn]), a;
}
var c$ = Object.prototype, f$ = c$.toString;
function $$(e) {
  return f$.call(e);
}
var p$ = "[object Null]", m$ = "[object Undefined]", Ml = Xt ? Xt.toStringTag : void 0;
function xr(e) {
  return e == null ? e === void 0 ? m$ : p$ : Ml && Ml in Object(e) ? u$(e) : $$(e);
}
function vr(e) {
  return e != null && typeof e == "object";
}
var h$ = "[object Symbol]";
function o1(e) {
  return typeof e == "symbol" || vr(e) && xr(e) == h$;
}
function v$(e, t) {
  for (var r = -1, n = e == null ? 0 : e.length, a = Array(n); ++r < n; )
    a[r] = t(e[r], r, e);
  return a;
}
var Gr = Array.isArray, Ol = Xt ? Xt.prototype : void 0, Tl = Ol ? Ol.toString : void 0;
function ya(e) {
  if (typeof e == "string")
    return e;
  if (Gr(e))
    return v$(e, ya) + "";
  if (o1(e))
    return Tl ? Tl.call(e) : "";
  var t = e + "";
  return t == "0" && 1 / e == -1 / 0 ? "-0" : t;
}
var y$ = /\s/;
function g$(e) {
  for (var t = e.length; t-- && y$.test(e.charAt(t)); )
    ;
  return t;
}
var b$ = /^\s+/;
function w$(e) {
  return e && e.slice(0, g$(e) + 1).replace(b$, "");
}
function yr(e) {
  var t = typeof e;
  return e != null && (t == "object" || t == "function");
}
var kl = NaN, _$ = /^[-+]0x[0-9a-f]+$/i, x$ = /^0b[01]+$/i, S$ = /^0o[0-7]+$/i, C$ = parseInt;
function Io(e) {
  if (typeof e == "number")
    return e;
  if (o1(e))
    return kl;
  if (yr(e)) {
    var t = typeof e.valueOf == "function" ? e.valueOf() : e;
    e = yr(t) ? t + "" : t;
  }
  if (typeof e != "string")
    return e === 0 ? e : +e;
  e = w$(e);
  var r = x$.test(e);
  return r || S$.test(e) ? C$(e.slice(2), r ? 2 : 8) : _$.test(e) ? kl : +e;
}
var Il = 1 / 0, P$ = 17976931348623157e292;
function A$(e) {
  if (!e)
    return e === 0 ? e : 0;
  if (e = Io(e), e === Il || e === -Il) {
    var t = e < 0 ? -1 : 1;
    return t * P$;
  }
  return e === e ? e : 0;
}
function E$(e) {
  var t = A$(e), r = t % 1;
  return t === t ? r ? t - r : t : 0;
}
var M$ = "[object AsyncFunction]", O$ = "[object Function]", T$ = "[object GeneratorFunction]", k$ = "[object Proxy]";
function i1(e) {
  if (!yr(e))
    return !1;
  var t = xr(e);
  return t == O$ || t == T$ || t == M$ || t == k$;
}
var cd = mt["__core-js_shared__"], Rl = (function() {
  var e = /[^.]+$/.exec(cd && cd.keys && cd.keys.IE_PROTO || "");
  return e ? "Symbol(src)_1." + e : "";
})();
function I$(e) {
  return !!Rl && Rl in e;
}
var R$ = Function.prototype, D$ = R$.toString;
function Sr(e) {
  if (e != null) {
    try {
      return D$.call(e);
    } catch {
    }
    try {
      return e + "";
    } catch {
    }
  }
  return "";
}
var N$ = /[\\^$.*+?()[\]{}|]/g, F$ = /^\[object .+?Constructor\]$/, L$ = Function.prototype, B$ = Object.prototype, V$ = L$.toString, j$ = B$.hasOwnProperty, G$ = RegExp(
  "^" + V$.call(j$).replace(N$, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function U$(e) {
  if (!yr(e) || I$(e))
    return !1;
  var t = i1(e) ? G$ : F$;
  return t.test(Sr(e));
}
function H$(e, t) {
  return e == null ? void 0 : e[t];
}
function tn(e, t) {
  var r = H$(e, t);
  return U$(r) ? r : void 0;
}
var Ro = tn(mt, "WeakMap"), W$ = 9007199254740991, z$ = /^(?:0|[1-9]\d*)$/;
function q$(e, t) {
  var r = typeof e;
  return t = t ?? W$, !!t && (r == "number" || r != "symbol" && z$.test(e)) && e > -1 && e % 1 == 0 && e < t;
}
function l1(e, t) {
  return e === t || e !== e && t !== t;
}
var K$ = 9007199254740991;
function s1(e) {
  return typeof e == "number" && e > -1 && e % 1 == 0 && e <= K$;
}
function u1(e) {
  return e != null && s1(e.length) && !i1(e);
}
var Y$ = Object.prototype;
function c1(e) {
  var t = e && e.constructor, r = typeof t == "function" && t.prototype || Y$;
  return e === r;
}
function Z$(e, t) {
  for (var r = -1, n = Array(e); ++r < e; )
    n[r] = t(r);
  return n;
}
var J$ = "[object Arguments]";
function Dl(e) {
  return vr(e) && xr(e) == J$;
}
var f1 = Object.prototype, Q$ = f1.hasOwnProperty, X$ = f1.propertyIsEnumerable, $1 = Dl(/* @__PURE__ */ (function() {
  return arguments;
})()) ? Dl : function(e) {
  return vr(e) && Q$.call(e, "callee") && !X$.call(e, "callee");
};
function e9() {
  return !1;
}
var p1 = typeof exports == "object" && exports && !exports.nodeType && exports, Nl = p1 && typeof module == "object" && module && !module.nodeType && module, t9 = Nl && Nl.exports === p1, Fl = t9 ? mt.Buffer : void 0, r9 = Fl ? Fl.isBuffer : void 0, ga = r9 || e9, n9 = "[object Arguments]", a9 = "[object Array]", d9 = "[object Boolean]", o9 = "[object Date]", i9 = "[object Error]", l9 = "[object Function]", s9 = "[object Map]", u9 = "[object Number]", c9 = "[object Object]", f9 = "[object RegExp]", $9 = "[object Set]", p9 = "[object String]", m9 = "[object WeakMap]", h9 = "[object ArrayBuffer]", v9 = "[object DataView]", y9 = "[object Float32Array]", g9 = "[object Float64Array]", b9 = "[object Int8Array]", w9 = "[object Int16Array]", _9 = "[object Int32Array]", x9 = "[object Uint8Array]", S9 = "[object Uint8ClampedArray]", C9 = "[object Uint16Array]", P9 = "[object Uint32Array]", Pe = {};
Pe[y9] = Pe[g9] = Pe[b9] = Pe[w9] = Pe[_9] = Pe[x9] = Pe[S9] = Pe[C9] = Pe[P9] = !0;
Pe[n9] = Pe[a9] = Pe[h9] = Pe[d9] = Pe[v9] = Pe[o9] = Pe[i9] = Pe[l9] = Pe[s9] = Pe[u9] = Pe[c9] = Pe[f9] = Pe[$9] = Pe[p9] = Pe[m9] = !1;
function A9(e) {
  return vr(e) && s1(e.length) && !!Pe[xr(e)];
}
function m1(e) {
  return function(t) {
    return e(t);
  };
}
var h1 = typeof exports == "object" && exports && !exports.nodeType && exports, xn = h1 && typeof module == "object" && module && !module.nodeType && module, E9 = xn && xn.exports === h1, fd = E9 && a1.process, ba = (function() {
  try {
    var e = xn && xn.require && xn.require("util").types;
    return e || fd && fd.binding && fd.binding("util");
  } catch {
  }
})(), Ll = ba && ba.isTypedArray, vi = Ll ? m1(Ll) : A9, M9 = Object.prototype, O9 = M9.hasOwnProperty;
function T9(e, t) {
  var r = Gr(e), n = !r && $1(e), a = !r && !n && ga(e), d = !r && !n && !a && vi(e), o = r || n || a || d, i = o ? Z$(e.length, String) : [], l = i.length;
  for (var s in e)
    O9.call(e, s) && !(o && // Safari 9 has enumerable `arguments.length` in strict mode.
    (s == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    a && (s == "offset" || s == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    d && (s == "buffer" || s == "byteLength" || s == "byteOffset") || // Skip index properties.
    q$(s, l))) && i.push(s);
  return i;
}
function k9(e, t) {
  return function(r) {
    return e(t(r));
  };
}
var I9 = k9(Object.keys, Object), R9 = Object.prototype, D9 = R9.hasOwnProperty;
function v1(e) {
  if (!c1(e))
    return I9(e);
  var t = [];
  for (var r in Object(e))
    D9.call(e, r) && r != "constructor" && t.push(r);
  return t;
}
function N9(e) {
  return u1(e) ? T9(e) : v1(e);
}
var Mn = tn(Object, "create");
function F9() {
  this.__data__ = Mn ? Mn(null) : {}, this.size = 0;
}
function L9(e) {
  var t = this.has(e) && delete this.__data__[e];
  return this.size -= t ? 1 : 0, t;
}
var B9 = "__lodash_hash_undefined__", V9 = Object.prototype, j9 = V9.hasOwnProperty;
function G9(e) {
  var t = this.__data__;
  if (Mn) {
    var r = t[e];
    return r === B9 ? void 0 : r;
  }
  return j9.call(t, e) ? t[e] : void 0;
}
var U9 = Object.prototype, H9 = U9.hasOwnProperty;
function W9(e) {
  var t = this.__data__;
  return Mn ? t[e] !== void 0 : H9.call(t, e);
}
var z9 = "__lodash_hash_undefined__";
function q9(e, t) {
  var r = this.__data__;
  return this.size += this.has(e) ? 0 : 1, r[e] = Mn && t === void 0 ? z9 : t, this;
}
function gr(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++t < r; ) {
    var n = e[t];
    this.set(n[0], n[1]);
  }
}
gr.prototype.clear = F9;
gr.prototype.delete = L9;
gr.prototype.get = G9;
gr.prototype.has = W9;
gr.prototype.set = q9;
function K9() {
  this.__data__ = [], this.size = 0;
}
function La(e, t) {
  for (var r = e.length; r--; )
    if (l1(e[r][0], t))
      return r;
  return -1;
}
var Y9 = Array.prototype, Z9 = Y9.splice;
function J9(e) {
  var t = this.__data__, r = La(t, e);
  if (r < 0)
    return !1;
  var n = t.length - 1;
  return r == n ? t.pop() : Z9.call(t, r, 1), --this.size, !0;
}
function Q9(e) {
  var t = this.__data__, r = La(t, e);
  return r < 0 ? void 0 : t[r][1];
}
function X9(e) {
  return La(this.__data__, e) > -1;
}
function ep(e, t) {
  var r = this.__data__, n = La(r, e);
  return n < 0 ? (++this.size, r.push([e, t])) : r[n][1] = t, this;
}
function It(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++t < r; ) {
    var n = e[t];
    this.set(n[0], n[1]);
  }
}
It.prototype.clear = K9;
It.prototype.delete = J9;
It.prototype.get = Q9;
It.prototype.has = X9;
It.prototype.set = ep;
var On = tn(mt, "Map");
function tp() {
  this.size = 0, this.__data__ = {
    hash: new gr(),
    map: new (On || It)(),
    string: new gr()
  };
}
function rp(e) {
  var t = typeof e;
  return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
}
function Ba(e, t) {
  var r = e.__data__;
  return rp(t) ? r[typeof t == "string" ? "string" : "hash"] : r.map;
}
function np(e) {
  var t = Ba(this, e).delete(e);
  return this.size -= t ? 1 : 0, t;
}
function ap(e) {
  return Ba(this, e).get(e);
}
function dp(e) {
  return Ba(this, e).has(e);
}
function op(e, t) {
  var r = Ba(this, e), n = r.size;
  return r.set(e, t), this.size += r.size == n ? 0 : 1, this;
}
function Cr(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++t < r; ) {
    var n = e[t];
    this.set(n[0], n[1]);
  }
}
Cr.prototype.clear = tp;
Cr.prototype.delete = np;
Cr.prototype.get = ap;
Cr.prototype.has = dp;
Cr.prototype.set = op;
function Ur(e) {
  return e == null ? "" : ya(e);
}
function ip(e, t) {
  for (var r = -1, n = t.length, a = e.length; ++r < n; )
    e[a + r] = t[r];
  return e;
}
function lp(e, t, r) {
  var n = -1, a = e.length;
  t < 0 && (t = -t > a ? 0 : a + t), r = r > a ? a : r, r < 0 && (r += a), a = t > r ? 0 : r - t >>> 0, t >>>= 0;
  for (var d = Array(a); ++n < a; )
    d[n] = e[n + t];
  return d;
}
function y1(e, t, r) {
  var n = e.length;
  return r = r === void 0 ? n : r, !t && r >= n ? e : lp(e, t, r);
}
var sp = "\\ud800-\\udfff", up = "\\u0300-\\u036f", cp = "\\ufe20-\\ufe2f", fp = "\\u20d0-\\u20ff", $p = up + cp + fp, pp = "\\ufe0e\\ufe0f", mp = "\\u200d", hp = RegExp("[" + mp + sp + $p + pp + "]");
function Va(e) {
  return hp.test(e);
}
function vp(e) {
  return e.split("");
}
var g1 = "\\ud800-\\udfff", yp = "\\u0300-\\u036f", gp = "\\ufe20-\\ufe2f", bp = "\\u20d0-\\u20ff", wp = yp + gp + bp, _p = "\\ufe0e\\ufe0f", xp = "[" + g1 + "]", Do = "[" + wp + "]", No = "\\ud83c[\\udffb-\\udfff]", Sp = "(?:" + Do + "|" + No + ")", b1 = "[^" + g1 + "]", w1 = "(?:\\ud83c[\\udde6-\\uddff]){2}", _1 = "[\\ud800-\\udbff][\\udc00-\\udfff]", Cp = "\\u200d", x1 = Sp + "?", S1 = "[" + _p + "]?", Pp = "(?:" + Cp + "(?:" + [b1, w1, _1].join("|") + ")" + S1 + x1 + ")*", Ap = S1 + x1 + Pp, Ep = "(?:" + [b1 + Do + "?", Do, w1, _1, xp].join("|") + ")", Mp = RegExp(No + "(?=" + No + ")|" + Ep + Ap, "g");
function Op(e) {
  return e.match(Mp) || [];
}
function C1(e) {
  return Va(e) ? Op(e) : vp(e);
}
function Tp(e) {
  return function(t) {
    t = Ur(t);
    var r = Va(t) ? C1(t) : void 0, n = r ? r[0] : t.charAt(0), a = r ? y1(r, 1).join("") : t.slice(1);
    return n[e]() + a;
  };
}
var kp = Tp("toUpperCase");
function Ip(e) {
  return kp(Ur(e).toLowerCase());
}
function Rp(e, t, r, n) {
  for (var a = -1, d = e == null ? 0 : e.length; ++a < d; )
    r = t(r, e[a], a, e);
  return r;
}
function Dp(e) {
  return function(t) {
    return e == null ? void 0 : e[t];
  };
}
var Np = {
  // Latin-1 Supplement block.
  À: "A",
  Á: "A",
  Â: "A",
  Ã: "A",
  Ä: "A",
  Å: "A",
  à: "a",
  á: "a",
  â: "a",
  ã: "a",
  ä: "a",
  å: "a",
  Ç: "C",
  ç: "c",
  Ð: "D",
  ð: "d",
  È: "E",
  É: "E",
  Ê: "E",
  Ë: "E",
  è: "e",
  é: "e",
  ê: "e",
  ë: "e",
  Ì: "I",
  Í: "I",
  Î: "I",
  Ï: "I",
  ì: "i",
  í: "i",
  î: "i",
  ï: "i",
  Ñ: "N",
  ñ: "n",
  Ò: "O",
  Ó: "O",
  Ô: "O",
  Õ: "O",
  Ö: "O",
  Ø: "O",
  ò: "o",
  ó: "o",
  ô: "o",
  õ: "o",
  ö: "o",
  ø: "o",
  Ù: "U",
  Ú: "U",
  Û: "U",
  Ü: "U",
  ù: "u",
  ú: "u",
  û: "u",
  ü: "u",
  Ý: "Y",
  ý: "y",
  ÿ: "y",
  Æ: "Ae",
  æ: "ae",
  Þ: "Th",
  þ: "th",
  ß: "ss",
  // Latin Extended-A block.
  Ā: "A",
  Ă: "A",
  Ą: "A",
  ā: "a",
  ă: "a",
  ą: "a",
  Ć: "C",
  Ĉ: "C",
  Ċ: "C",
  Č: "C",
  ć: "c",
  ĉ: "c",
  ċ: "c",
  č: "c",
  Ď: "D",
  Đ: "D",
  ď: "d",
  đ: "d",
  Ē: "E",
  Ĕ: "E",
  Ė: "E",
  Ę: "E",
  Ě: "E",
  ē: "e",
  ĕ: "e",
  ė: "e",
  ę: "e",
  ě: "e",
  Ĝ: "G",
  Ğ: "G",
  Ġ: "G",
  Ģ: "G",
  ĝ: "g",
  ğ: "g",
  ġ: "g",
  ģ: "g",
  Ĥ: "H",
  Ħ: "H",
  ĥ: "h",
  ħ: "h",
  Ĩ: "I",
  Ī: "I",
  Ĭ: "I",
  Į: "I",
  İ: "I",
  ĩ: "i",
  ī: "i",
  ĭ: "i",
  į: "i",
  ı: "i",
  Ĵ: "J",
  ĵ: "j",
  Ķ: "K",
  ķ: "k",
  ĸ: "k",
  Ĺ: "L",
  Ļ: "L",
  Ľ: "L",
  Ŀ: "L",
  Ł: "L",
  ĺ: "l",
  ļ: "l",
  ľ: "l",
  ŀ: "l",
  ł: "l",
  Ń: "N",
  Ņ: "N",
  Ň: "N",
  Ŋ: "N",
  ń: "n",
  ņ: "n",
  ň: "n",
  ŋ: "n",
  Ō: "O",
  Ŏ: "O",
  Ő: "O",
  ō: "o",
  ŏ: "o",
  ő: "o",
  Ŕ: "R",
  Ŗ: "R",
  Ř: "R",
  ŕ: "r",
  ŗ: "r",
  ř: "r",
  Ś: "S",
  Ŝ: "S",
  Ş: "S",
  Š: "S",
  ś: "s",
  ŝ: "s",
  ş: "s",
  š: "s",
  Ţ: "T",
  Ť: "T",
  Ŧ: "T",
  ţ: "t",
  ť: "t",
  ŧ: "t",
  Ũ: "U",
  Ū: "U",
  Ŭ: "U",
  Ů: "U",
  Ű: "U",
  Ų: "U",
  ũ: "u",
  ū: "u",
  ŭ: "u",
  ů: "u",
  ű: "u",
  ų: "u",
  Ŵ: "W",
  ŵ: "w",
  Ŷ: "Y",
  ŷ: "y",
  Ÿ: "Y",
  Ź: "Z",
  Ż: "Z",
  Ž: "Z",
  ź: "z",
  ż: "z",
  ž: "z",
  Ĳ: "IJ",
  ĳ: "ij",
  Œ: "Oe",
  œ: "oe",
  ŉ: "'n",
  ſ: "s"
}, Fp = Dp(Np), Lp = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, Bp = "\\u0300-\\u036f", Vp = "\\ufe20-\\ufe2f", jp = "\\u20d0-\\u20ff", Gp = Bp + Vp + jp, Up = "[" + Gp + "]", Hp = RegExp(Up, "g");
function Wp(e) {
  return e = Ur(e), e && e.replace(Lp, Fp).replace(Hp, "");
}
var zp = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
function qp(e) {
  return e.match(zp) || [];
}
var Kp = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
function Yp(e) {
  return Kp.test(e);
}
var P1 = "\\ud800-\\udfff", Zp = "\\u0300-\\u036f", Jp = "\\ufe20-\\ufe2f", Qp = "\\u20d0-\\u20ff", Xp = Zp + Jp + Qp, A1 = "\\u2700-\\u27bf", E1 = "a-z\\xdf-\\xf6\\xf8-\\xff", e4 = "\\xac\\xb1\\xd7\\xf7", t4 = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", r4 = "\\u2000-\\u206f", n4 = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", M1 = "A-Z\\xc0-\\xd6\\xd8-\\xde", a4 = "\\ufe0e\\ufe0f", O1 = e4 + t4 + r4 + n4, T1 = "['’]", Bl = "[" + O1 + "]", d4 = "[" + Xp + "]", k1 = "\\d+", o4 = "[" + A1 + "]", I1 = "[" + E1 + "]", R1 = "[^" + P1 + O1 + k1 + A1 + E1 + M1 + "]", i4 = "\\ud83c[\\udffb-\\udfff]", l4 = "(?:" + d4 + "|" + i4 + ")", s4 = "[^" + P1 + "]", D1 = "(?:\\ud83c[\\udde6-\\uddff]){2}", N1 = "[\\ud800-\\udbff][\\udc00-\\udfff]", Dr = "[" + M1 + "]", u4 = "\\u200d", Vl = "(?:" + I1 + "|" + R1 + ")", c4 = "(?:" + Dr + "|" + R1 + ")", jl = "(?:" + T1 + "(?:d|ll|m|re|s|t|ve))?", Gl = "(?:" + T1 + "(?:D|LL|M|RE|S|T|VE))?", F1 = l4 + "?", L1 = "[" + a4 + "]?", f4 = "(?:" + u4 + "(?:" + [s4, D1, N1].join("|") + ")" + L1 + F1 + ")*", $4 = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", p4 = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", m4 = L1 + F1 + f4, h4 = "(?:" + [o4, D1, N1].join("|") + ")" + m4, v4 = RegExp([
  Dr + "?" + I1 + "+" + jl + "(?=" + [Bl, Dr, "$"].join("|") + ")",
  c4 + "+" + Gl + "(?=" + [Bl, Dr + Vl, "$"].join("|") + ")",
  Dr + "?" + Vl + "+" + jl,
  Dr + "+" + Gl,
  p4,
  $4,
  k1,
  h4
].join("|"), "g");
function y4(e) {
  return e.match(v4) || [];
}
function g4(e, t, r) {
  return e = Ur(e), t = t, t === void 0 ? Yp(e) ? y4(e) : qp(e) : e.match(t) || [];
}
var b4 = "['’]", w4 = RegExp(b4, "g");
function _4(e) {
  return function(t) {
    return Rp(g4(Wp(t).replace(w4, "")), e, "");
  };
}
var Ul = _4(function(e, t, r) {
  return t = t.toLowerCase(), e + (r ? Ip(t) : t);
});
function x4() {
  this.__data__ = new It(), this.size = 0;
}
function S4(e) {
  var t = this.__data__, r = t.delete(e);
  return this.size = t.size, r;
}
function C4(e) {
  return this.__data__.get(e);
}
function P4(e) {
  return this.__data__.has(e);
}
var A4 = 200;
function E4(e, t) {
  var r = this.__data__;
  if (r instanceof It) {
    var n = r.__data__;
    if (!On || n.length < A4 - 1)
      return n.push([e, t]), this.size = ++r.size, this;
    r = this.__data__ = new Cr(n);
  }
  return r.set(e, t), this.size = r.size, this;
}
function Yt(e) {
  var t = this.__data__ = new It(e);
  this.size = t.size;
}
Yt.prototype.clear = x4;
Yt.prototype.delete = S4;
Yt.prototype.get = C4;
Yt.prototype.has = P4;
Yt.prototype.set = E4;
function M4(e, t) {
  for (var r = -1, n = e == null ? 0 : e.length, a = 0, d = []; ++r < n; ) {
    var o = e[r];
    t(o, r, e) && (d[a++] = o);
  }
  return d;
}
function O4() {
  return [];
}
var T4 = Object.prototype, k4 = T4.propertyIsEnumerable, Hl = Object.getOwnPropertySymbols, I4 = Hl ? function(e) {
  return e == null ? [] : (e = Object(e), M4(Hl(e), function(t) {
    return k4.call(e, t);
  }));
} : O4;
function R4(e, t, r) {
  var n = t(e);
  return Gr(e) ? n : ip(n, r(e));
}
function Wl(e) {
  return R4(e, N9, I4);
}
var Fo = tn(mt, "DataView"), Lo = tn(mt, "Promise"), Bo = tn(mt, "Set"), zl = "[object Map]", D4 = "[object Object]", ql = "[object Promise]", Kl = "[object Set]", Yl = "[object WeakMap]", Zl = "[object DataView]", N4 = Sr(Fo), F4 = Sr(On), L4 = Sr(Lo), B4 = Sr(Bo), V4 = Sr(Ro), gt = xr;
(Fo && gt(new Fo(new ArrayBuffer(1))) != Zl || On && gt(new On()) != zl || Lo && gt(Lo.resolve()) != ql || Bo && gt(new Bo()) != Kl || Ro && gt(new Ro()) != Yl) && (gt = function(e) {
  var t = xr(e), r = t == D4 ? e.constructor : void 0, n = r ? Sr(r) : "";
  if (n)
    switch (n) {
      case N4:
        return Zl;
      case F4:
        return zl;
      case L4:
        return ql;
      case B4:
        return Kl;
      case V4:
        return Yl;
    }
  return t;
});
var Jl = mt.Uint8Array, j4 = "__lodash_hash_undefined__";
function G4(e) {
  return this.__data__.set(e, j4), this;
}
function U4(e) {
  return this.__data__.has(e);
}
function wa(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.__data__ = new Cr(); ++t < r; )
    this.add(e[t]);
}
wa.prototype.add = wa.prototype.push = G4;
wa.prototype.has = U4;
function H4(e, t) {
  for (var r = -1, n = e == null ? 0 : e.length; ++r < n; )
    if (t(e[r], r, e))
      return !0;
  return !1;
}
function W4(e, t) {
  return e.has(t);
}
var z4 = 1, q4 = 2;
function B1(e, t, r, n, a, d) {
  var o = r & z4, i = e.length, l = t.length;
  if (i != l && !(o && l > i))
    return !1;
  var s = d.get(e), u = d.get(t);
  if (s && u)
    return s == t && u == e;
  var $ = -1, y = !0, h = r & q4 ? new wa() : void 0;
  for (d.set(e, t), d.set(t, e); ++$ < i; ) {
    var c = e[$], p = t[$];
    if (n)
      var f = o ? n(p, c, $, t, e, d) : n(c, p, $, e, t, d);
    if (f !== void 0) {
      if (f)
        continue;
      y = !1;
      break;
    }
    if (h) {
      if (!H4(t, function(v, w) {
        if (!W4(h, w) && (c === v || a(c, v, r, n, d)))
          return h.push(w);
      })) {
        y = !1;
        break;
      }
    } else if (!(c === p || a(c, p, r, n, d))) {
      y = !1;
      break;
    }
  }
  return d.delete(e), d.delete(t), y;
}
function K4(e) {
  var t = -1, r = Array(e.size);
  return e.forEach(function(n, a) {
    r[++t] = [a, n];
  }), r;
}
function Y4(e) {
  var t = -1, r = Array(e.size);
  return e.forEach(function(n) {
    r[++t] = n;
  }), r;
}
var Z4 = 1, J4 = 2, Q4 = "[object Boolean]", X4 = "[object Date]", em = "[object Error]", tm = "[object Map]", rm = "[object Number]", nm = "[object RegExp]", am = "[object Set]", dm = "[object String]", om = "[object Symbol]", im = "[object ArrayBuffer]", lm = "[object DataView]", Ql = Xt ? Xt.prototype : void 0, $d = Ql ? Ql.valueOf : void 0;
function sm(e, t, r, n, a, d, o) {
  switch (r) {
    case lm:
      if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset)
        return !1;
      e = e.buffer, t = t.buffer;
    case im:
      return !(e.byteLength != t.byteLength || !d(new Jl(e), new Jl(t)));
    case Q4:
    case X4:
    case rm:
      return l1(+e, +t);
    case em:
      return e.name == t.name && e.message == t.message;
    case nm:
    case dm:
      return e == t + "";
    case tm:
      var i = K4;
    case am:
      var l = n & Z4;
      if (i || (i = Y4), e.size != t.size && !l)
        return !1;
      var s = o.get(e);
      if (s)
        return s == t;
      n |= J4, o.set(e, t);
      var u = B1(i(e), i(t), n, a, d, o);
      return o.delete(e), u;
    case om:
      if ($d)
        return $d.call(e) == $d.call(t);
  }
  return !1;
}
var um = 1, cm = Object.prototype, fm = cm.hasOwnProperty;
function $m(e, t, r, n, a, d) {
  var o = r & um, i = Wl(e), l = i.length, s = Wl(t), u = s.length;
  if (l != u && !o)
    return !1;
  for (var $ = l; $--; ) {
    var y = i[$];
    if (!(o ? y in t : fm.call(t, y)))
      return !1;
  }
  var h = d.get(e), c = d.get(t);
  if (h && c)
    return h == t && c == e;
  var p = !0;
  d.set(e, t), d.set(t, e);
  for (var f = o; ++$ < l; ) {
    y = i[$];
    var v = e[y], w = t[y];
    if (n)
      var m = o ? n(w, v, y, t, e, d) : n(v, w, y, e, t, d);
    if (!(m === void 0 ? v === w || a(v, w, r, n, d) : m)) {
      p = !1;
      break;
    }
    f || (f = y == "constructor");
  }
  if (p && !f) {
    var b = e.constructor, _ = t.constructor;
    b != _ && "constructor" in e && "constructor" in t && !(typeof b == "function" && b instanceof b && typeof _ == "function" && _ instanceof _) && (p = !1);
  }
  return d.delete(e), d.delete(t), p;
}
var pm = 1, Xl = "[object Arguments]", es = "[object Array]", aa = "[object Object]", mm = Object.prototype, ts = mm.hasOwnProperty;
function hm(e, t, r, n, a, d) {
  var o = Gr(e), i = Gr(t), l = o ? es : gt(e), s = i ? es : gt(t);
  l = l == Xl ? aa : l, s = s == Xl ? aa : s;
  var u = l == aa, $ = s == aa, y = l == s;
  if (y && ga(e)) {
    if (!ga(t))
      return !1;
    o = !0, u = !1;
  }
  if (y && !u)
    return d || (d = new Yt()), o || vi(e) ? B1(e, t, r, n, a, d) : sm(e, t, l, r, n, a, d);
  if (!(r & pm)) {
    var h = u && ts.call(e, "__wrapped__"), c = $ && ts.call(t, "__wrapped__");
    if (h || c) {
      var p = h ? e.value() : e, f = c ? t.value() : t;
      return d || (d = new Yt()), a(p, f, r, n, d);
    }
  }
  return y ? (d || (d = new Yt()), $m(e, t, r, n, a, d)) : !1;
}
function V1(e, t, r, n, a) {
  return e === t ? !0 : e == null || t == null || !vr(e) && !vr(t) ? e !== e && t !== t : hm(e, t, r, n, V1, a);
}
function vm(e) {
  return function(t) {
    return t == null ? void 0 : t[e];
  };
}
var pd = function() {
  return mt.Date.now();
}, ym = "Expected a function", gm = Math.max, bm = Math.min;
function yi(e, t, r) {
  var n, a, d, o, i, l, s = 0, u = !1, $ = !1, y = !0;
  if (typeof e != "function")
    throw new TypeError(ym);
  t = Io(t) || 0, yr(r) && (u = !!r.leading, $ = "maxWait" in r, d = $ ? gm(Io(r.maxWait) || 0, t) : d, y = "trailing" in r ? !!r.trailing : y);
  function h(x) {
    var A = n, P = a;
    return n = a = void 0, s = x, o = e.apply(P, A), o;
  }
  function c(x) {
    return s = x, i = setTimeout(v, t), u ? h(x) : o;
  }
  function p(x) {
    var A = x - l, P = x - s, k = t - A;
    return $ ? bm(k, d - P) : k;
  }
  function f(x) {
    var A = x - l, P = x - s;
    return l === void 0 || A >= t || A < 0 || $ && P >= d;
  }
  function v() {
    var x = pd();
    if (f(x))
      return w(x);
    i = setTimeout(v, p(x));
  }
  function w(x) {
    return i = void 0, y && n ? h(x) : (n = a = void 0, o);
  }
  function m() {
    i !== void 0 && clearTimeout(i), s = 0, n = l = a = i = void 0;
  }
  function b() {
    return i === void 0 ? o : w(pd());
  }
  function _() {
    var x = pd(), A = f(x);
    if (n = arguments, a = this, l = x, A) {
      if (i === void 0)
        return c(l);
      if ($)
        return clearTimeout(i), i = setTimeout(v, t), h(l);
    }
    return i === void 0 && (i = setTimeout(v, t)), o;
  }
  return _.cancel = m, _.flush = b, _;
}
var wm = "[object Map]", _m = "[object Set]", xm = Object.prototype, Sm = xm.hasOwnProperty;
function gi(e) {
  if (e == null)
    return !0;
  if (u1(e) && (Gr(e) || typeof e == "string" || typeof e.splice == "function" || ga(e) || vi(e) || $1(e)))
    return !e.length;
  var t = gt(e);
  if (t == wm || t == _m)
    return !e.size;
  if (c1(e))
    return !v1(e).length;
  for (var r in e)
    if (Sm.call(e, r))
      return !1;
  return !0;
}
function Hr(e, t) {
  return V1(e, t);
}
var Cm = "[object RegExp]";
function Pm(e) {
  return vr(e) && xr(e) == Cm;
}
var rs = ba && ba.isRegExp, Am = rs ? m1(rs) : Pm, Em = vm("length"), j1 = "\\ud800-\\udfff", Mm = "\\u0300-\\u036f", Om = "\\ufe20-\\ufe2f", Tm = "\\u20d0-\\u20ff", km = Mm + Om + Tm, Im = "\\ufe0e\\ufe0f", Rm = "[" + j1 + "]", Vo = "[" + km + "]", jo = "\\ud83c[\\udffb-\\udfff]", Dm = "(?:" + Vo + "|" + jo + ")", G1 = "[^" + j1 + "]", U1 = "(?:\\ud83c[\\udde6-\\uddff]){2}", H1 = "[\\ud800-\\udbff][\\udc00-\\udfff]", Nm = "\\u200d", W1 = Dm + "?", z1 = "[" + Im + "]?", Fm = "(?:" + Nm + "(?:" + [G1, U1, H1].join("|") + ")" + z1 + W1 + ")*", Lm = z1 + W1 + Fm, Bm = "(?:" + [G1 + Vo + "?", Vo, U1, H1, Rm].join("|") + ")", ns = RegExp(jo + "(?=" + jo + ")|" + Bm + Lm, "g");
function Vm(e) {
  for (var t = ns.lastIndex = 0; ns.test(e); )
    ++t;
  return t;
}
function jm(e) {
  return Va(e) ? Vm(e) : Em(e);
}
var Gm = "Expected a function";
function Um(e, t, r) {
  var n = !0, a = !0;
  if (typeof e != "function")
    throw new TypeError(Gm);
  return yr(r) && (n = "leading" in r ? !!r.leading : n, a = "trailing" in r ? !!r.trailing : a), yi(e, t, {
    leading: n,
    maxWait: t,
    trailing: a
  });
}
var Hm = 30, Wm = "...", zm = /\w*$/;
function qm(e, t) {
  var r = Hm, n = Wm;
  if (yr(t)) {
    var a = "separator" in t ? t.separator : a;
    r = "length" in t ? E$(t.length) : r, n = "omission" in t ? ya(t.omission) : n;
  }
  e = Ur(e);
  var d = e.length;
  if (Va(e)) {
    var o = C1(e);
    d = o.length;
  }
  if (r >= d)
    return e;
  var i = r - jm(n);
  if (i < 1)
    return n;
  var l = o ? y1(o, 0, i).join("") : e.slice(0, i);
  if (a === void 0)
    return l + n;
  if (o && (i += l.length - i), Am(a)) {
    if (e.slice(i).search(a)) {
      var s, u = l;
      for (a.global || (a = RegExp(a.source, Ur(zm.exec(a)) + "g")), a.lastIndex = 0; s = a.exec(u); )
        var $ = s.index;
      l = l.slice(0, $ === void 0 ? i : $);
    }
  } else if (e.indexOf(ya(a), i) != i) {
    var y = l.lastIndexOf(a);
    y > -1 && (l = l.slice(0, y));
  }
  return l + n;
}
const _a = /* @__PURE__ */ new Set(), Go = Um(() => {
  _a.forEach((e) => e());
}, 100);
let xa = !1;
function Km(e, t) {
  const r = () => {
    _a.add(e), Zm();
  }, n = () => {
    _a.delete(e), Ym();
  };
  K(t, () => t.value ? r() : n(), { immediate: !0 }), Qr(() => {
    n();
  });
}
function Ym() {
  xa && _a.size === 0 && (window.removeEventListener("scroll", Go, !0), Go.cancel(), xa = !1);
}
function Zm() {
  xa || (window.addEventListener("scroll", Go, !0), xa = !0);
}
const Jm = { ref: "dropdown-container" }, bi = /* @__PURE__ */ V({
  __name: "FdxDropdown",
  props: {
    autoHide: { type: Boolean, default: !0 },
    autoMinSize: { type: Boolean, default: !0 },
    delay: { default: 0 },
    disabled: { type: Boolean, default: !1 },
    display: { default: "block" },
    distance: { default: 0 },
    hideOnScroll: { type: Boolean, default: !1 },
    placement: { default: "bottom-start" },
    popperHideTriggers: { default: () => ["click"] },
    popperShowTriggers: { default: () => ["click"] },
    popperTriggers: { default: () => ["click"] },
    shown: { type: Boolean, default: !1 },
    skidding: { default: 0 },
    triggers: { default: () => ["click"] }
  },
  setup(e) {
    const t = At("dropdown-container"), r = At("dropdown"), n = H(null);
    He(() => {
      var o;
      n.value = ((o = t.value) == null ? void 0 : o.closest("dialog")) || null, n.value && !n.value.dataset.name && (n.value.dataset.name = `fdx-dropdown-${tr()}`);
    }), Km(
      () => {
        var o;
        (o = r.value) == null || o.hide();
      },
      R2(() => e.hideOnScroll)
    );
    const d = O(() => {
      var o;
      return n.value ? `[data-name="${(o = n.value) == null ? void 0 : o.dataset.name}"]` : void 0;
    });
    return (o, i) => (S(), I("div", Jm, [
      j(g(d$), me({
        ref_key: "dropdown",
        ref: r,
        strategy: "fixed",
        disabled: o.disabled,
        distance: o.distance,
        skidding: o.skidding,
        class: [o.display],
        placement: o.placement,
        delay: o.delay,
        triggers: o.triggers,
        "popper-triggers": o.popperTriggers,
        "popper-show-triggers": o.popperShowTriggers,
        "popper-hide-triggers": o.popperHideTriggers,
        "auto-size": o.autoMinSize ? "min" : !1,
        "auto-hide": o.autoHide,
        shown: o.shown,
        container: d.value
      }, o.$attrs), {
        popper: D(({ hide: l }) => [
          F(o.$slots, "menu", { hide: l })
        ]),
        default: D(() => [
          F(o.$slots, "trigger")
        ]),
        _: 3
      }, 16, ["disabled", "distance", "skidding", "class", "placement", "delay", "triggers", "popper-triggers", "popper-show-triggers", "popper-hide-triggers", "auto-size", "auto-hide", "shown", "container"])
    ], 512));
  }
}), Qm = {
  key: 0,
  class: "border-red mb-6 rounded border bg-red-300 p-3"
}, Xm = /* @__PURE__ */ V({
  __name: "FdxErrorMessages",
  props: {
    errors: {}
  },
  setup(e) {
    const t = e, r = O(() => Object.values(t.errors).flat());
    return (n, a) => (S(), B(jn, { name: "slide-down" }, {
      default: D(() => [
        r.value.length ? (S(), I("div", Qm, [
          C("ul", null, [
            (S(!0), I(le, null, Ee(r.value, (d, o) => (S(), I("li", { key: o }, Q(d), 1))), 128))
          ])
        ])) : Z("", !0)
      ]),
      _: 1
    }));
  }
});
function as(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Ht(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? as(Object(r), !0).forEach(function(n) {
      e8(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : as(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function e8(e, t, r) {
  return t in e ? Object.defineProperty(e, t, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = r, e;
}
function ds(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
  return Object.keys(e).reduce((r, n) => (t.includes(n) || (r[n] = g(e[n])), r), {});
}
function Sa(e) {
  return typeof e == "function";
}
function t8(e) {
  return N2(e) || F2(e);
}
function q1(e, t, r) {
  let n = e;
  const a = t.split(".");
  for (let d = 0; d < a.length; d++) {
    if (!n[a[d]]) return r;
    n = n[a[d]];
  }
  return n;
}
function md(e, t, r) {
  return O(() => e.some((n) => q1(t, n, {
    [r]: !1
  })[r]));
}
function os(e, t, r) {
  return O(() => e.reduce((n, a) => {
    const d = q1(t, a, {
      [r]: !1
    })[r] || [];
    return n.concat(d);
  }, []));
}
function K1(e, t, r, n) {
  return e.call(n, g(t), g(r), n);
}
function Y1(e) {
  return e.$valid !== void 0 ? !e.$valid : !e;
}
function r8(e, t, r, n, a, d, o) {
  let {
    $lazy: i,
    $rewardEarly: l
  } = a, s = arguments.length > 7 && arguments[7] !== void 0 ? arguments[7] : [], u = arguments.length > 8 ? arguments[8] : void 0, $ = arguments.length > 9 ? arguments[9] : void 0, y = arguments.length > 10 ? arguments[10] : void 0;
  const h = H(!!n.value), c = H(0);
  r.value = !1;
  const p = K([t, n].concat(s, y), () => {
    if (i && !n.value || l && !$.value && !r.value)
      return;
    let f;
    try {
      f = K1(e, t, u, o);
    } catch (v) {
      f = Promise.reject(v);
    }
    c.value++, r.value = !!c.value, h.value = !1, Promise.resolve(f).then((v) => {
      c.value--, r.value = !!c.value, d.value = v, h.value = Y1(v);
    }).catch((v) => {
      c.value--, r.value = !!c.value, d.value = v, h.value = !0;
    });
  }, {
    immediate: !0,
    deep: typeof t == "object"
  });
  return {
    $invalid: h,
    $unwatch: p
  };
}
function n8(e, t, r, n, a, d, o, i) {
  let {
    $lazy: l,
    $rewardEarly: s
  } = n;
  const u = () => ({}), $ = O(() => {
    if (l && !r.value || s && !i.value)
      return !1;
    let y = !0;
    try {
      const h = K1(e, t, o, d);
      a.value = h, y = Y1(h);
    } catch (h) {
      a.value = h;
    }
    return y;
  });
  return {
    $unwatch: u,
    $invalid: $
  };
}
function a8(e, t, r, n, a, d, o, i, l, s, u) {
  const $ = H(!1), y = e.$params || {}, h = H(null);
  let c, p;
  e.$async ? {
    $invalid: c,
    $unwatch: p
  } = r8(e.$validator, t, $, r, n, h, a, e.$watchTargets, l, s, u) : {
    $invalid: c,
    $unwatch: p
  } = n8(e.$validator, t, r, n, h, a, l, s);
  const f = e.$message;
  return {
    $message: Sa(f) ? O(() => f(ds({
      $pending: $,
      $invalid: c,
      $params: ds(y),
      $model: t,
      $response: h,
      $validator: d,
      $propertyPath: i,
      $property: o
    }))) : f || "",
    $params: y,
    $pending: $,
    $invalid: c,
    $response: h,
    $unwatch: p
  };
}
function d8() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  const t = g(e), r = Object.keys(t), n = {}, a = {}, d = {};
  let o = null;
  return r.forEach((i) => {
    const l = t[i];
    switch (!0) {
      case Sa(l.$validator):
        n[i] = l;
        break;
      case Sa(l):
        n[i] = {
          $validator: l
        };
        break;
      case i === "$validationGroups":
        o = l;
        break;
      case i.startsWith("$"):
        d[i] = l;
        break;
      default:
        a[i] = l;
    }
  }), {
    rules: n,
    nestedValidators: a,
    config: d,
    validationGroups: o
  };
}
const o8 = "__root";
function i8(e, t, r, n, a, d, o, i, l) {
  const s = Object.keys(e), u = n.get(a, e), $ = H(!1), y = H(!1), h = H(0);
  if (u) {
    if (!u.$partial) return u;
    u.$unwatch(), $.value = u.$dirty.value;
  }
  const c = {
    $dirty: $,
    $path: a,
    $touch: () => {
      $.value || ($.value = !0);
    },
    $reset: () => {
      $.value && ($.value = !1);
    },
    $commit: () => {
    }
  };
  return s.length ? (s.forEach((p) => {
    c[p] = a8(e[p], t, c.$dirty, d, o, p, r, a, l, y, h);
  }), c.$externalResults = O(() => i.value ? [].concat(i.value).map((p, f) => ({
    $propertyPath: a,
    $property: r,
    $validator: "$externalResults",
    $uid: `${a}-externalResult-${f}`,
    $message: p,
    $params: {},
    $response: null,
    $pending: !1
  })) : []), c.$invalid = O(() => {
    const p = s.some((f) => g(c[f].$invalid));
    return y.value = p, !!c.$externalResults.value.length || p;
  }), c.$pending = O(() => s.some((p) => g(c[p].$pending))), c.$error = O(() => c.$dirty.value ? c.$pending.value || c.$invalid.value : !1), c.$silentErrors = O(() => s.filter((p) => g(c[p].$invalid)).map((p) => {
    const f = c[p];
    return Gn({
      $propertyPath: a,
      $property: r,
      $validator: p,
      $uid: `${a}-${p}`,
      $message: f.$message,
      $params: f.$params,
      $response: f.$response,
      $pending: f.$pending
    });
  }).concat(c.$externalResults.value)), c.$errors = O(() => c.$dirty.value ? c.$silentErrors.value : []), c.$unwatch = () => s.forEach((p) => {
    c[p].$unwatch();
  }), c.$commit = () => {
    y.value = !0, h.value = Date.now();
  }, n.set(a, e, c), c) : (u && n.set(a, e, c), c);
}
function l8(e, t, r, n, a, d, o) {
  const i = Object.keys(e);
  return i.length ? i.reduce((l, s) => (l[s] = Uo({
    validations: e[s],
    state: t,
    key: s,
    parentKey: r,
    resultsCache: n,
    globalConfig: a,
    instance: d,
    externalResults: o
  }), l), {}) : {};
}
function s8(e, t, r) {
  const n = O(() => [t, r].filter((c) => c).reduce((c, p) => c.concat(Object.values(g(p))), [])), a = O({
    get() {
      return e.$dirty.value || (n.value.length ? n.value.every((c) => c.$dirty) : !1);
    },
    set(c) {
      e.$dirty.value = c;
    }
  }), d = O(() => {
    const c = g(e.$silentErrors) || [], p = n.value.filter((f) => (g(f).$silentErrors || []).length).reduce((f, v) => f.concat(...v.$silentErrors), []);
    return c.concat(p);
  }), o = O(() => {
    const c = g(e.$errors) || [], p = n.value.filter((f) => (g(f).$errors || []).length).reduce((f, v) => f.concat(...v.$errors), []);
    return c.concat(p);
  }), i = O(() => n.value.some((c) => c.$invalid) || g(e.$invalid) || !1), l = O(() => n.value.some((c) => g(c.$pending)) || g(e.$pending) || !1), s = O(() => n.value.some((c) => c.$dirty) || n.value.some((c) => c.$anyDirty) || a.value), u = O(() => a.value ? l.value || i.value : !1), $ = () => {
    e.$touch(), n.value.forEach((c) => {
      c.$touch();
    });
  }, y = () => {
    e.$commit(), n.value.forEach((c) => {
      c.$commit();
    });
  }, h = () => {
    e.$reset(), n.value.forEach((c) => {
      c.$reset();
    });
  };
  return n.value.length && n.value.every((c) => c.$dirty) && $(), {
    $dirty: a,
    $errors: o,
    $invalid: i,
    $anyDirty: s,
    $error: u,
    $pending: l,
    $touch: $,
    $reset: h,
    $silentErrors: d,
    $commit: y
  };
}
function Uo(e) {
  let {
    validations: t,
    state: r,
    key: n,
    parentKey: a,
    childResults: d,
    resultsCache: o,
    globalConfig: i = {},
    instance: l,
    externalResults: s
  } = e;
  const u = a ? `${a}.${n}` : n, {
    rules: $,
    nestedValidators: y,
    config: h,
    validationGroups: c
  } = d8(t), p = Ht(Ht({}, i), h), f = n ? O(() => {
    const ee = g(r);
    return ee ? g(ee[n]) : void 0;
  }) : r, v = Ht({}, g(s) || {}), w = O(() => {
    const ee = g(s);
    return n ? ee ? g(ee[n]) : void 0 : ee;
  }), m = i8($, f, n, o, u, p, l, w, r), b = l8(y, f, u, o, p, l, w), _ = {};
  c && Object.entries(c).forEach((ee) => {
    let [Se, he] = ee;
    _[Se] = {
      $invalid: md(he, b, "$invalid"),
      $error: md(he, b, "$error"),
      $pending: md(he, b, "$pending"),
      $errors: os(he, b, "$errors"),
      $silentErrors: os(he, b, "$silentErrors")
    };
  });
  const {
    $dirty: x,
    $errors: A,
    $invalid: P,
    $anyDirty: k,
    $error: R,
    $pending: L,
    $touch: N,
    $reset: U,
    $silentErrors: G,
    $commit: Y
  } = s8(m, b, d), te = n ? O({
    get: () => g(f),
    set: (ee) => {
      x.value = !0;
      const Se = g(r), he = g(s);
      he && (he[n] = v[n]), $t(Se[n]) ? Se[n].value = ee : Se[n] = ee;
    }
  }) : null;
  n && p.$autoDirty && K(f, () => {
    x.value || N();
    const ee = g(s);
    ee && (ee[n] = v[n]);
  }, {
    flush: "sync"
  });
  async function re() {
    return N(), p.$rewardEarly && (Y(), await tt()), await tt(), new Promise((ee) => {
      if (!L.value) return ee(!P.value);
      const Se = K(L, () => {
        ee(!P.value), Se();
      });
    });
  }
  function M(ee) {
    return (d.value || {})[ee];
  }
  function X() {
    $t(s) ? s.value = v : Object.keys(v).length === 0 ? Object.keys(s).forEach((ee) => {
      delete s[ee];
    }) : Object.assign(s, v);
  }
  return Gn(Ht(Ht(Ht({}, m), {}, {
    $model: te,
    $dirty: x,
    $error: R,
    $errors: A,
    $invalid: P,
    $anyDirty: k,
    $pending: L,
    $touch: N,
    $reset: U,
    $path: u || o8,
    $silentErrors: G,
    $validate: re,
    $commit: Y
  }, d && {
    $getResultsForChild: M,
    $clearExternalResults: X,
    $validationGroups: _
  }), b));
}
class u8 {
  constructor() {
    this.storage = /* @__PURE__ */ new Map();
  }
  set(t, r, n) {
    this.storage.set(t, {
      rules: r,
      result: n
    });
  }
  checkRulesValidity(t, r, n) {
    const a = Object.keys(n), d = Object.keys(r);
    return d.length !== a.length || !d.every((i) => a.includes(i)) ? !1 : d.every((i) => r[i].$params ? Object.keys(r[i].$params).every((l) => g(n[i].$params[l]) === g(r[i].$params[l])) : !0);
  }
  get(t, r) {
    const n = this.storage.get(t);
    if (!n) return;
    const {
      rules: a,
      result: d
    } = n, o = this.checkRulesValidity(t, r, a), i = d.$unwatch ? d.$unwatch : () => ({});
    return o ? d : {
      $dirty: d.$dirty,
      $partial: !0,
      $unwatch: i
    };
  }
}
const ua = {
  COLLECT_ALL: !0,
  COLLECT_NONE: !1
}, is = Symbol("vuelidate#injectChildResults"), ls = Symbol("vuelidate#removeChildResults");
function c8(e) {
  let {
    $scope: t,
    instance: r
  } = e;
  const n = {}, a = H([]), d = O(() => a.value.reduce((u, $) => (u[$] = g(n[$]), u), {}));
  function o(u, $) {
    let {
      $registerAs: y,
      $scope: h,
      $stopPropagation: c
    } = $;
    c || t === ua.COLLECT_NONE || h === ua.COLLECT_NONE || t !== ua.COLLECT_ALL && t !== h || (n[y] = u, a.value.push(y));
  }
  r.__vuelidateInjectInstances = [].concat(r.__vuelidateInjectInstances || [], o);
  function i(u) {
    a.value = a.value.filter(($) => $ !== u), delete n[u];
  }
  r.__vuelidateRemoveInstances = [].concat(r.__vuelidateRemoveInstances || [], i);
  const l = ft(is, []);
  Zt(is, r.__vuelidateInjectInstances);
  const s = ft(ls, []);
  return Zt(ls, r.__vuelidateRemoveInstances), {
    childResults: d,
    sendValidationResultsToParent: l,
    removeValidationResultsFromParent: s
  };
}
function Z1(e) {
  return new Proxy(e, {
    get(t, r) {
      return typeof t[r] == "object" ? Z1(t[r]) : O(() => t[r]);
    }
  });
}
let ss = 0;
function J1(e, t) {
  var r;
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  arguments.length === 1 && (n = e, e = void 0, t = void 0);
  let {
    $registerAs: a,
    $scope: d = ua.COLLECT_ALL,
    $stopPropagation: o,
    $externalResults: i,
    currentVueInstance: l
  } = n;
  const s = l || ((r = Jr()) === null || r === void 0 ? void 0 : r.proxy), u = s ? s.$options : {};
  a || (ss += 1, a = `_vuelidate_${ss}`);
  const $ = H({}), y = new u8(), {
    childResults: h,
    sendValidationResultsToParent: c,
    removeValidationResultsFromParent: p
  } = s ? c8({
    $scope: d,
    instance: s
  }) : {
    childResults: H({})
  };
  if (!e && u.validations) {
    const f = u.validations;
    t = H({}), D2(() => {
      t.value = s, K(() => Sa(f) ? f.call(t.value, new Z1(t.value)) : f, (v) => {
        $.value = Uo({
          validations: v,
          state: t,
          childResults: h,
          resultsCache: y,
          globalConfig: n,
          instance: s,
          externalResults: i || s.vuelidateExternalResults
        });
      }, {
        immediate: !0
      });
    }), n = u.validationsConfig || n;
  } else {
    const f = $t(e) || t8(e) ? e : Gn(e || {});
    K(f, (v) => {
      $.value = Uo({
        validations: v,
        state: t,
        childResults: h,
        resultsCache: y,
        globalConfig: n,
        instance: s ?? {},
        externalResults: i
      });
    }, {
      immediate: !0
    });
  }
  return s && (c.forEach((f) => f($, {
    $registerAs: a,
    $scope: d,
    $stopPropagation: o
  })), wu(() => p.forEach((f) => f(a)))), O(() => Ht(Ht({}, g($.value)), h.value));
}
function Q1(e) {
  const t = ft(rl, null);
  if (t)
    return t;
  const r = J1(), n = Gn({});
  function a(s, u) {
    n[s] = u;
  }
  const d = O(() => Object.values(n).some((s) => s.dirty));
  function o(s) {
    const u = n[s];
    return u ? Nr(u.dirty) : !1;
  }
  function i(s = {}) {
    if (!(e != null && e.value))
      return;
    const u = new FormData(e.value), $ = Object.fromEntries(u.entries());
    return s.includeAllFields || Object.keys($).forEach((y) => {
      o(y) || delete $[y];
    }), $;
  }
  const l = {
    getSubmissionPayload: i,
    hasDirtyFields: d,
    isFieldDirty: o,
    registerField: a,
    v$: r
  };
  return Zt(rl, l), l;
}
const f8 = { class: "flex justify-end" }, Vx = /* @__PURE__ */ V({
  __name: "FdxFormBox",
  props: {
    disabled: { type: Boolean },
    errors: { default: void 0 },
    hideTooltip: { type: Boolean },
    includeAllFields: { type: Boolean },
    isLoading: { type: Boolean },
    showSaveButton: { type: Boolean, default: !0 },
    submitButtonText: { default: "Save" }
  },
  emits: ["submit"],
  setup(e, { emit: t }) {
    const r = e, n = t, a = H(null), { getSubmissionPayload: d, hasDirtyFields: o, v$: i } = Q1(a), l = O(() => r.isLoading || r.disabled || i.value.$invalid || !o.value);
    async function s() {
      const u = await i.value.$validate();
      if (i.value.$touch(), !u || !a.value)
        return;
      const $ = d({
        includeAllFields: r.includeAllFields
      });
      $ && n("submit", $);
    }
    return (u, $) => (S(), I("form", {
      id: "form-box-body",
      ref_key: "form",
      ref: a,
      "data-testid": "formBoxBody",
      class: "w-full",
      onSubmit: Jt(s, ["prevent"])
    }, [
      u.errors ? (S(), B(Xm, {
        key: 0,
        errors: u.errors
      }, null, 8, ["errors"])) : Z("", !0),
      F(u.$slots, "default"),
      $[0] || ($[0] = C("input", {
        type: "submit",
        hidden: ""
      }, null, -1)),
      C("div", f8, [
        F(u.$slots, "submit", {
          invalid: g(i).$invalid,
          hasDirtyFields: g(o)
        }, () => [
          u.showSaveButton ? (S(), B(Vu, {
            key: 0,
            disabled: l.value,
            loading: u.isLoading
          }, {
            default: D(() => [
              Me(Q(u.submitButtonText), 1)
            ]),
            _: 1
          }, 8, ["disabled", "loading"])) : Z("", !0)
        ])
      ])
    ], 544));
  }
}), hd = /* @__PURE__ */ new Map();
function Be(e, t, r) {
  const n = ft(us(e), null);
  if (n)
    return n;
  const a = H(r == null ? void 0 : r.initialValue), d = O(() => {
    const c = Nr(t) ?? {};
    return {
      [e]: c
    };
  }), o = J1(d, { [e]: a });
  K(a, () => {
    o.value[e].$touch();
  });
  const i = O(() => o.value.$silentErrors.map((p) => Nr(p.$message))), l = O(() => {
    const c = !!o.value[e].$dirty, p = !!i.value.length;
    return c && p;
  }), s = O(() => i.value.length > 0), u = O(() => !!o.value[e].required), $ = O(() => (r == null ? void 0 : r.initialValue) !== a.value), { registerField: y } = Q1();
  y(e, {
    dirty: $
  });
  const h = {
    errorMessages: i,
    isFieldNotValid: s,
    isFieldNotValidAndTouched: l,
    isRequired: u,
    v$: o,
    value: a
  };
  return Zt(us(e), h), h;
}
function us(e) {
  return hd.has(e) || hd.set(e, Symbol(e)), hd.get(e);
}
const $8 = { class: "group/fdx-form-item-container mb-4 flex flex-col" }, p8 = {
  key: 0,
  class: "mb-1 flex w-full items-center justify-between",
  "data-testid": "fdx-form-item-container-label"
}, m8 = { class: "flex items-center" }, h8 = { class: "me-1 text-footnote group-[.disabled]/fdx-form-item-container:text-gray-400" }, v8 = { key: 0 }, y8 = {
  key: 1,
  class: "ms-1 text-negative-500 group-[.disabled]/fdx-form-item-container:text-current"
}, g8 = { class: "w-full" }, b8 = {
  key: 1,
  class: "mt-2 w-full text-footnote text-gray-600"
}, w8 = { class: "error-messages mt-1 text-footnote text-negative-500" }, _8 = ["textContent"], at = /* @__PURE__ */ V({
  __name: "FdxFormItemContainer",
  props: {
    helpText: {},
    hideRequiredAsterisk: { type: Boolean },
    label: {},
    name: {}
  },
  setup(e) {
    const { errorMessages: t, isFieldNotValidAndTouched: r, isRequired: n } = Be(e.name), a = O(() => n.value && !e.hideRequiredAsterisk);
    return (d, o) => (S(), I("div", $8, [
      d.label ? (S(), I("div", p8, [
        C("div", m8, [
          F(d.$slots, "label", {}, () => [
            C("label", h8, [
              d.label ? (S(), I("span", v8, Q(d.label), 1)) : Z("", !0),
              a.value ? (S(), I("span", y8, " * ")) : Z("", !0)
            ])
          ])
        ]),
        F(d.$slots, "labelRight")
      ])) : Z("", !0),
      C("div", g8, [
        F(d.$slots, "default")
      ]),
      d.helpText ? (S(), I("p", b8, Q(d.helpText), 1)) : Z("", !0),
      j(jn, { name: "slide-down" }, {
        default: D(() => [
          g(r) ? F(d.$slots, "errorMessage", {
            key: 0,
            errorMessages: g(t)
          }, () => [
            C("div", w8, [
              C("ul", null, [
                (S(!0), I(le, null, Ee(g(t), (i) => (S(), I("li", {
                  key: i,
                  textContent: Q(i)
                }, null, 8, _8))), 128))
              ])
            ])
          ]) : Z("", !0)
        ]),
        _: 3
      })
    ]));
  }
}), x8 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, S8 = ["clip-path"], C8 = ["id"];
function P8(e, t) {
  return S(), I("svg", x8, [
    C("g", {
      "clip-path": "url(#" + e.idMap.clip0_5_23391 + ")"
    }, [...t[0] || (t[0] = [
      C("path", {
        d: "M19 3H5C3.89 3 3 3.9 3 5V19C3 20.1 3.89 21 5 21H19C20.11 21 21 20.1 21 19V5C21 3.9 20.11 3 19 3ZM10 17L5 12L6.41 10.59L10 14.17L17.59 6.58L19 8L10 17Z",
        fill: "currentColor"
      }, null, -1)
    ])], 8, S8),
    C("defs", null, [
      C("clipPath", {
        id: e.idMap.clip0_5_23391
      }, [...t[1] || (t[1] = [
        C("rect", {
          width: "24",
          height: "24",
          fill: "white"
        }, null, -1)
      ])], 8, C8)
    ])
  ]);
}
const X1 = ye({ name: "icon-check-box", render: P8, setup() {
  return { idMap: { clip0_5_23391: "uicons-" + Math.random().toString(36).substr(2, 10) } };
} }), A8 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, E8 = ["clip-path"], M8 = ["id"];
function O8(e, t) {
  return S(), I("svg", A8, [
    C("g", {
      "clip-path": "url(#" + e.idMap.clip0_5_23389 + ")"
    }, [...t[0] || (t[0] = [
      C("path", {
        d: "M19 5V19H5V5H19ZM19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3Z",
        fill: "currentColor"
      }, null, -1)
    ])], 8, E8),
    C("defs", null, [
      C("clipPath", {
        id: e.idMap.clip0_5_23389
      }, [...t[1] || (t[1] = [
        C("rect", {
          width: "24",
          height: "24",
          fill: "white"
        }, null, -1)
      ])], 8, M8)
    ])
  ]);
}
const ec = ye({ name: "icon-check-box-outline-blank", render: O8, setup() {
  return { idMap: { clip0_5_23389: "uicons-" + Math.random().toString(36).substr(2, 10) } };
} }), T8 = ["for"], k8 = ["id", "value", "name", "true-value"], I8 = { class: "error-messages mt-1 text-footnote text-negative-500" }, R8 = ["textContent"], jx = /* @__PURE__ */ V({
  __name: "FdxInputCheckbox",
  props: /* @__PURE__ */ $e({
    label: {},
    name: {},
    validations: {},
    value: { default: !0 }
  }, {
    modelValue: { type: Boolean, required: !1 },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    const t = wr(e, ["value"]), r = tr(), n = Ae(e, "modelValue"), {
      errorMessages: a,
      isFieldNotValidAndTouched: d,
      value: o
    } = Be(t.name, t.validations, {
      initialValue: n.value
    });
    return K(o, (i) => {
      i !== n.value && (n.value = i);
    }), K(n, (i) => {
      i !== o.value && (o.value = i);
    }), (i, l) => {
      const s = ec, u = X1;
      return S(), I("div", null, [
        C("label", {
          for: g(r),
          class: "inline-flex cursor-pointer items-start gap-x-2 disabled:cursor-not-allowed"
        }, [
          Xe(C("input", {
            type: "checkbox",
            hidden: "",
            id: g(r),
            value: i.value,
            "onUpdate:modelValue": l[0] || (l[0] = ($) => $t(o) ? o.value = $ : null),
            name: i.name,
            class: "peer",
            "true-value": i.value
          }, null, 8, k8), [
            [L2, g(o)]
          ]),
          j(s, { class: "fdx-input-checkbox__unchecked-icon size-6 flex-shrink-0 text-gray-500 peer-checked:hidden" }),
          j(u, { class: "fdx-input-checkbox__checked-icon hidden size-6 flex-shrink-0 text-primary-300 peer-checked:block" }),
          C("div", null, [
            F(i.$slots, "label", {}, () => [
              C("span", null, Q(i.label), 1)
            ])
          ])
        ], 8, T8),
        j(jn, { name: "slide-down" }, {
          default: D(() => [
            g(d) ? F(i.$slots, "errorMessage", {
              key: 0,
              errorMessages: g(a)
            }, () => [
              C("div", I8, [
                C("ul", null, [
                  (S(!0), I(le, null, Ee(g(a), ($) => (S(), I("li", {
                    key: $,
                    textContent: Q($)
                  }, null, 8, R8))), 128))
                ])
              ])
            ]) : Z("", !0)
          ]),
          _: 3
        })
      ]);
    };
  }
}), D8 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none"
}, N8 = ["id"], F8 = ["clip-path"];
function L8(e, t) {
  return S(), I("svg", D8, [
    C("defs", null, [
      C("clipPath", {
        id: e.idMap.clip0_double_arrow_right_centered
      }, [...t[0] || (t[0] = [
        C("rect", {
          width: "24",
          height: "24",
          fill: "white"
        }, null, -1)
      ])], 8, N8)
    ]),
    C("g", {
      fill: "currentColor",
      "clip-path": "url(#" + e.idMap.clip0_double_arrow_right_centered + ")"
    }, [...t[1] || (t[1] = [
      C("path", { d: "M2.13 3.8701L3.9 2.1001L13.8 12.0001L3.9 21.9001L2.13 20.1301L10.26 12.0001L2.13 3.8701Z" }, null, -1),
      C("path", { d: "M10.13 3.8701L11.9 2.1001L21.8 12.0001L11.9 21.9001L10.13 20.1301L18.26 12.0001L10.13 3.8701Z" }, null, -1)
    ])], 8, F8)
  ]);
}
const tc = ye({ name: "icon-double-arrow-forward-ios", render: L8, setup() {
  return { idMap: { clip0_double_arrow_right_centered: "uicons-" + Math.random().toString(36).substr(2, 10) } };
} }), B8 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, V8 = ["clip-path"], j8 = ["id"];
function G8(e, t) {
  return S(), I("svg", B8, [
    C("g", {
      "clip-path": "url(#" + e.idMap.clip0_5_23663 + ")"
    }, [...t[0] || (t[0] = [
      C("path", {
        d: "M5.88 4.12L13.76 12L5.88 19.88L8 22L18 12L8 2L5.88 4.12Z",
        fill: "currentColor"
      }, null, -1)
    ])], 8, V8),
    C("defs", null, [
      C("clipPath", {
        id: e.idMap.clip0_5_23663
      }, [...t[1] || (t[1] = [
        C("rect", {
          width: "24",
          height: "24",
          fill: "white"
        }, null, -1)
      ])], 8, j8)
    ])
  ]);
}
const rc = ye({ name: "icon-arrow-forward-ios", render: G8, setup() {
  return { idMap: { clip0_5_23663: "uicons-" + Math.random().toString(36).substr(2, 10) } };
} }), U8 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, H8 = ["clip-path"], W8 = ["id"];
function z8(e, t) {
  return S(), I("svg", U8, [
    C("g", {
      "clip-path": "url(#" + e.idMap.clip0_5_23667 + ")"
    }, [...t[0] || (t[0] = [
      C("path", {
        d: "M17.67 3.8701L15.9 2.1001L6 12.0001L15.9 21.9001L17.67 20.1301L9.54 12.0001L17.67 3.8701Z",
        fill: "currentColor"
      }, null, -1)
    ])], 8, H8),
    C("defs", null, [
      C("clipPath", {
        id: e.idMap.clip0_5_23667
      }, [...t[1] || (t[1] = [
        C("rect", {
          width: "24",
          height: "24",
          fill: "white"
        }, null, -1)
      ])], 8, W8)
    ])
  ]);
}
const nc = ye({ name: "icon-arrow-back-ios", render: z8, setup() {
  return { idMap: { clip0_5_23667: "uicons-" + Math.random().toString(36).substr(2, 10) } };
} }), q8 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none"
}, K8 = ["id"], Y8 = ["clip-path"];
function Z8(e, t) {
  return S(), I("svg", q8, [
    C("defs", null, [
      C("clipPath", {
        id: e.idMap.clip0_double_arrow_centered
      }, [...t[0] || (t[0] = [
        C("rect", {
          width: "24",
          height: "24",
          fill: "white"
        }, null, -1)
      ])], 8, K8)
    ]),
    C("g", {
      fill: "currentColor",
      "clip-path": "url(#" + e.idMap.clip0_double_arrow_centered + ")"
    }, [...t[1] || (t[1] = [
      C("path", { d: "M21.87 3.8701L20.1 2.1001L10.2 12.0001L20.1 21.9001L21.87 20.1301L13.74 12.0001L21.87 3.8701Z" }, null, -1),
      C("path", { d: "M13.87 3.8701L12.1 2.1001L2.2 12.0001L12.1 21.9001L13.87 20.1301L5.74 12.0001L13.87 3.8701Z" }, null, -1)
    ])], 8, Y8)
  ]);
}
const ac = ye({ name: "icon-double-arrow-back-ios", render: Z8, setup() {
  return { idMap: { clip0_double_arrow_centered: "uicons-" + Math.random().toString(36).substr(2, 10) } };
} }), J8 = {
  width: "20",
  height: "22",
  viewBox: "0 0 20 22",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function Q8(e, t) {
  return S(), I("svg", J8, [...t[0] || (t[0] = [
    C("path", {
      d: "M18 2H17V0H15V2H5V0H3V2H2C0.9 2 0 2.9 0 4V20C0 21.1 0.9 22 2 22H18C19.1 22 20 21.1 20 20V4C20 2.9 19.1 2 18 2ZM18 20H2V7H18V20Z",
      fill: "#1C1C1E"
    }, null, -1)
  ])]);
}
const dc = ye({ name: "icon-calendar", render: Q8 });
function Lr(e, t) {
  return e - t * Math.floor(e / t);
}
const oc = 1721426;
function pr(e, t, r, n) {
  t = Wn(e, t);
  let a = t - 1, d = -2;
  return r <= 2 ? d = 0 : zt(t) && (d = -1), oc - 1 + 365 * a + Math.floor(a / 4) - Math.floor(a / 100) + Math.floor(a / 400) + Math.floor((367 * r - 362) / 12 + d + n);
}
function zt(e) {
  return e % 4 === 0 && (e % 100 !== 0 || e % 400 === 0);
}
function Wn(e, t) {
  return e === "BC" ? 1 - t : t;
}
function ja(e) {
  let t = "AD";
  return e <= 0 && (t = "BC", e = 1 - e), [
    t,
    e
  ];
}
const X8 = {
  standard: [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
  ],
  leapyear: [
    31,
    29,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
  ]
};
class rt {
  fromJulianDay(t) {
    let r = t, n = r - oc, a = Math.floor(n / 146097), d = Lr(n, 146097), o = Math.floor(d / 36524), i = Lr(d, 36524), l = Math.floor(i / 1461), s = Lr(i, 1461), u = Math.floor(s / 365), $ = a * 400 + o * 100 + l * 4 + u + (o !== 4 && u !== 4 ? 1 : 0), [y, h] = ja($), c = r - pr(y, h, 1, 1), p = 2;
    r < pr(y, h, 3, 1) ? p = 0 : zt(h) && (p = 1);
    let f = Math.floor(((c + p) * 12 + 373) / 367), v = r - pr(y, h, f, 1) + 1;
    return new Te(y, h, f, v);
  }
  toJulianDay(t) {
    return pr(t.era, t.year, t.month, t.day);
  }
  getDaysInMonth(t) {
    return X8[zt(t.year) ? "leapyear" : "standard"][t.month - 1];
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  getMonthsInYear(t) {
    return 12;
  }
  getDaysInYear(t) {
    return zt(t.year) ? 366 : 365;
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  getYearsInEra(t) {
    return 9999;
  }
  getEras() {
    return [
      "BC",
      "AD"
    ];
  }
  isInverseEra(t) {
    return t.era === "BC";
  }
  balanceDate(t) {
    t.year <= 0 && (t.era = t.era === "BC" ? "AD" : "BC", t.year = 1 - t.year);
  }
  constructor() {
    this.identifier = "gregory";
  }
}
const e6 = {
  "001": 1,
  AD: 1,
  AE: 6,
  AF: 6,
  AI: 1,
  AL: 1,
  AM: 1,
  AN: 1,
  AR: 1,
  AT: 1,
  AU: 1,
  AX: 1,
  AZ: 1,
  BA: 1,
  BE: 1,
  BG: 1,
  BH: 6,
  BM: 1,
  BN: 1,
  BY: 1,
  CH: 1,
  CL: 1,
  CM: 1,
  CN: 1,
  CR: 1,
  CY: 1,
  CZ: 1,
  DE: 1,
  DJ: 6,
  DK: 1,
  DZ: 6,
  EC: 1,
  EE: 1,
  EG: 6,
  ES: 1,
  FI: 1,
  FJ: 1,
  FO: 1,
  FR: 1,
  GB: 1,
  GE: 1,
  GF: 1,
  GP: 1,
  GR: 1,
  HR: 1,
  HU: 1,
  IE: 1,
  IQ: 6,
  IR: 6,
  IS: 1,
  IT: 1,
  JO: 6,
  KG: 1,
  KW: 6,
  KZ: 1,
  LB: 1,
  LI: 1,
  LK: 1,
  LT: 1,
  LU: 1,
  LV: 1,
  LY: 6,
  MC: 1,
  MD: 1,
  ME: 1,
  MK: 1,
  MN: 1,
  MQ: 1,
  MV: 5,
  MY: 1,
  NL: 1,
  NO: 1,
  NZ: 1,
  OM: 6,
  PL: 1,
  QA: 6,
  RE: 1,
  RO: 1,
  RS: 1,
  RU: 1,
  SD: 6,
  SE: 1,
  SI: 1,
  SK: 1,
  SM: 1,
  SY: 6,
  TJ: 1,
  TM: 1,
  TR: 1,
  UA: 1,
  UY: 1,
  UZ: 1,
  VA: 1,
  VN: 1,
  XK: 1
};
function Ne(e, t) {
  return t = je(t, e.calendar), e.era === t.era && e.year === t.year && e.month === t.month && e.day === t.day;
}
function wi(e, t) {
  return t = je(t, e.calendar), e = Ho(e), t = Ho(t), e.era === t.era && e.year === t.year && e.month === t.month;
}
function it(e, t) {
  return _i(e.calendar, t.calendar) && Ne(e, t);
}
function cs(e, t) {
  return _i(e.calendar, t.calendar) && wi(e, t);
}
function _i(e, t) {
  var r, n, a, d;
  return (d = (a = (r = e.isEqual) === null || r === void 0 ? void 0 : r.call(e, t)) !== null && a !== void 0 ? a : (n = t.isEqual) === null || n === void 0 ? void 0 : n.call(t, e)) !== null && d !== void 0 ? d : e.identifier === t.identifier;
}
function ic(e, t) {
  return Ne(e, sc(t));
}
function lc(e, t, r) {
  let n = e.calendar.toJulianDay(e), a = a6(t), d = Math.ceil(n + 1 - a) % 7;
  return d < 0 && (d += 7), d;
}
function t6(e) {
  return xt(Date.now(), e);
}
function sc(e) {
  return i6(t6(e));
}
function uc(e, t) {
  return e.calendar.toJulianDay(e) - t.calendar.toJulianDay(t);
}
function r6(e, t) {
  return fs(e) - fs(t);
}
function fs(e) {
  return e.hour * 36e5 + e.minute * 6e4 + e.second * 1e3 + e.millisecond;
}
let vd = null;
function rn() {
  return vd == null && (vd = new Intl.DateTimeFormat().resolvedOptions().timeZone), vd;
}
function Ho(e) {
  return e.subtract({
    days: e.day - 1
  });
}
function $s(e) {
  return e.add({
    days: e.calendar.getDaysInMonth(e) - e.day
  });
}
const ps = /* @__PURE__ */ new Map();
function n6(e) {
  if (Intl.Locale) {
    let r = ps.get(e);
    return r || (r = new Intl.Locale(e).maximize().region, r && ps.set(e, r)), r;
  }
  let t = e.split("-")[1];
  return t === "u" ? void 0 : t;
}
function a6(e) {
  let t = n6(e);
  return t && e6[t] || 0;
}
function Wr(e) {
  e = je(e, new rt());
  let t = Wn(e.era, e.year);
  return cc(t, e.month, e.day, e.hour, e.minute, e.second, e.millisecond);
}
function cc(e, t, r, n, a, d, o) {
  let i = /* @__PURE__ */ new Date();
  return i.setUTCHours(n, a, d, o), i.setUTCFullYear(e, t - 1, r), i.getTime();
}
function Wo(e, t) {
  if (t === "UTC") return 0;
  if (e > 0 && t === rn()) return new Date(e).getTimezoneOffset() * -6e4;
  let { year: r, month: n, day: a, hour: d, minute: o, second: i } = fc(e, t);
  return cc(r, n, a, d, o, i, 0) - Math.floor(e / 1e3) * 1e3;
}
const ms = /* @__PURE__ */ new Map();
function fc(e, t) {
  let r = ms.get(t);
  r || (r = new Intl.DateTimeFormat("en-US", {
    timeZone: t,
    hour12: !1,
    era: "short",
    year: "numeric",
    month: "numeric",
    day: "numeric",
    hour: "numeric",
    minute: "numeric",
    second: "numeric"
  }), ms.set(t, r));
  let n = r.formatToParts(new Date(e)), a = {};
  for (let d of n) d.type !== "literal" && (a[d.type] = d.value);
  return {
    // Firefox returns B instead of BC... https://bugzilla.mozilla.org/show_bug.cgi?id=1752253
    year: a.era === "BC" || a.era === "B" ? -a.year + 1 : +a.year,
    month: +a.month,
    day: +a.day,
    hour: a.hour === "24" ? 0 : +a.hour,
    minute: +a.minute,
    second: +a.second
  };
}
const hs = 864e5;
function d6(e, t, r, n) {
  return (r === n ? [
    r
  ] : [
    r,
    n
  ]).filter((d) => o6(e, t, d));
}
function o6(e, t, r) {
  let n = fc(r, t);
  return e.year === n.year && e.month === n.month && e.day === n.day && e.hour === n.hour && e.minute === n.minute && e.second === n.second;
}
function wt(e, t, r = "compatible") {
  let n = zr(e);
  if (t === "UTC") return Wr(n);
  if (t === rn() && r === "compatible") {
    n = je(n, new rt());
    let l = /* @__PURE__ */ new Date(), s = Wn(n.era, n.year);
    return l.setFullYear(s, n.month - 1, n.day), l.setHours(n.hour, n.minute, n.second, n.millisecond), l.getTime();
  }
  let a = Wr(n), d = Wo(a - hs, t), o = Wo(a + hs, t), i = d6(n, t, a - d, a - o);
  if (i.length === 1) return i[0];
  if (i.length > 1) switch (r) {
    // 'compatible' means 'earlier' for "fall back" transitions
    case "compatible":
    case "earlier":
      return i[0];
    case "later":
      return i[i.length - 1];
    case "reject":
      throw new RangeError("Multiple possible absolute times found");
  }
  switch (r) {
    case "earlier":
      return Math.min(a - d, a - o);
    // 'compatible' means 'later' for "spring forward" transitions
    case "compatible":
    case "later":
      return Math.max(a - d, a - o);
    case "reject":
      throw new RangeError("No such absolute time found");
  }
}
function $c(e, t, r = "compatible") {
  return new Date(wt(e, t, r));
}
function xt(e, t) {
  let r = Wo(e, t), n = new Date(e + r), a = n.getUTCFullYear(), d = n.getUTCMonth() + 1, o = n.getUTCDate(), i = n.getUTCHours(), l = n.getUTCMinutes(), s = n.getUTCSeconds(), u = n.getUTCMilliseconds();
  return new Kr(a < 1 ? "BC" : "AD", a < 1 ? -a + 1 : a, d, o, t, r, i, l, s, u);
}
function i6(e) {
  return new Te(e.calendar, e.era, e.year, e.month, e.day);
}
function zr(e, t) {
  let r = 0, n = 0, a = 0, d = 0;
  if ("timeZone" in e) ({ hour: r, minute: n, second: a, millisecond: d } = e);
  else if ("hour" in e && !t) return e;
  return t && ({ hour: r, minute: n, second: a, millisecond: d } = t), new qr(e.calendar, e.era, e.year, e.month, e.day, r, n, a, d);
}
function je(e, t) {
  if (_i(e.calendar, t)) return e;
  let r = t.fromJulianDay(e.calendar.toJulianDay(e)), n = e.copy();
  return n.calendar = t, n.era = r.era, n.year = r.year, n.month = r.month, n.day = r.day, br(n), n;
}
function l6(e, t, r) {
  if (e instanceof Kr)
    return e.timeZone === t ? e : u6(e, t);
  let n = wt(e, t, r);
  return xt(n, t);
}
function s6(e) {
  let t = Wr(e) - e.offset;
  return new Date(t);
}
function u6(e, t) {
  let r = Wr(e) - e.offset;
  return je(xt(r, t), e.calendar);
}
const fn = 36e5;
function Ga(e, t) {
  let r = e.copy(), n = "hour" in r ? p6(r, t) : 0;
  zo(r, t.years || 0), r.calendar.balanceYearMonth && r.calendar.balanceYearMonth(r, e), r.month += t.months || 0, qo(r), pc(r), r.day += (t.weeks || 0) * 7, r.day += t.days || 0, r.day += n, c6(r), r.calendar.balanceDate && r.calendar.balanceDate(r), r.year < 1 && (r.year = 1, r.month = 1, r.day = 1);
  let a = r.calendar.getYearsInEra(r);
  if (r.year > a) {
    var d, o;
    let l = (d = (o = r.calendar).isInverseEra) === null || d === void 0 ? void 0 : d.call(o, r);
    r.year = a, r.month = l ? 1 : r.calendar.getMonthsInYear(r), r.day = l ? 1 : r.calendar.getDaysInMonth(r);
  }
  r.month < 1 && (r.month = 1, r.day = 1);
  let i = r.calendar.getMonthsInYear(r);
  return r.month > i && (r.month = i, r.day = r.calendar.getDaysInMonth(r)), r.day = Math.max(1, Math.min(r.calendar.getDaysInMonth(r), r.day)), r;
}
function zo(e, t) {
  var r, n;
  !((r = (n = e.calendar).isInverseEra) === null || r === void 0) && r.call(n, e) && (t = -t), e.year += t;
}
function qo(e) {
  for (; e.month < 1; )
    zo(e, -1), e.month += e.calendar.getMonthsInYear(e);
  let t = 0;
  for (; e.month > (t = e.calendar.getMonthsInYear(e)); )
    e.month -= t, zo(e, 1);
}
function c6(e) {
  for (; e.day < 1; )
    e.month--, qo(e), e.day += e.calendar.getDaysInMonth(e);
  for (; e.day > e.calendar.getDaysInMonth(e); )
    e.day -= e.calendar.getDaysInMonth(e), e.month++, qo(e);
}
function pc(e) {
  e.month = Math.max(1, Math.min(e.calendar.getMonthsInYear(e), e.month)), e.day = Math.max(1, Math.min(e.calendar.getDaysInMonth(e), e.day));
}
function br(e) {
  e.calendar.constrainDate && e.calendar.constrainDate(e), e.year = Math.max(1, Math.min(e.calendar.getYearsInEra(e), e.year)), pc(e);
}
function mc(e) {
  let t = {};
  for (let r in e) typeof e[r] == "number" && (t[r] = -e[r]);
  return t;
}
function hc(e, t) {
  return Ga(e, mc(t));
}
function xi(e, t) {
  let r = e.copy();
  return t.era != null && (r.era = t.era), t.year != null && (r.year = t.year), t.month != null && (r.month = t.month), t.day != null && (r.day = t.day), br(r), r;
}
function Ca(e, t) {
  let r = e.copy();
  return t.hour != null && (r.hour = t.hour), t.minute != null && (r.minute = t.minute), t.second != null && (r.second = t.second), t.millisecond != null && (r.millisecond = t.millisecond), $6(r), r;
}
function f6(e) {
  e.second += Math.floor(e.millisecond / 1e3), e.millisecond = da(e.millisecond, 1e3), e.minute += Math.floor(e.second / 60), e.second = da(e.second, 60), e.hour += Math.floor(e.minute / 60), e.minute = da(e.minute, 60);
  let t = Math.floor(e.hour / 24);
  return e.hour = da(e.hour, 24), t;
}
function $6(e) {
  e.millisecond = Math.max(0, Math.min(e.millisecond, 1e3)), e.second = Math.max(0, Math.min(e.second, 59)), e.minute = Math.max(0, Math.min(e.minute, 59)), e.hour = Math.max(0, Math.min(e.hour, 23));
}
function da(e, t) {
  let r = e % t;
  return r < 0 && (r += t), r;
}
function p6(e, t) {
  return e.hour += t.hours || 0, e.minute += t.minutes || 0, e.second += t.seconds || 0, e.millisecond += t.milliseconds || 0, f6(e);
}
function Si(e, t, r, n) {
  let a = e.copy();
  switch (t) {
    case "era": {
      let i = e.calendar.getEras(), l = i.indexOf(e.era);
      if (l < 0) throw new Error("Invalid era: " + e.era);
      l = St(l, r, 0, i.length - 1, n == null ? void 0 : n.round), a.era = i[l], br(a);
      break;
    }
    case "year":
      var d, o;
      !((d = (o = a.calendar).isInverseEra) === null || d === void 0) && d.call(o, a) && (r = -r), a.year = St(e.year, r, -1 / 0, 9999, n == null ? void 0 : n.round), a.year === -1 / 0 && (a.year = 1), a.calendar.balanceYearMonth && a.calendar.balanceYearMonth(a, e);
      break;
    case "month":
      a.month = St(e.month, r, 1, e.calendar.getMonthsInYear(e), n == null ? void 0 : n.round);
      break;
    case "day":
      a.day = St(e.day, r, 1, e.calendar.getDaysInMonth(e), n == null ? void 0 : n.round);
      break;
    default:
      throw new Error("Unsupported field " + t);
  }
  return e.calendar.balanceDate && e.calendar.balanceDate(a), br(a), a;
}
function vc(e, t, r, n) {
  let a = e.copy();
  switch (t) {
    case "hour": {
      let d = e.hour, o = 0, i = 23;
      if ((n == null ? void 0 : n.hourCycle) === 12) {
        let l = d >= 12;
        o = l ? 12 : 0, i = l ? 23 : 11;
      }
      a.hour = St(d, r, o, i, n == null ? void 0 : n.round);
      break;
    }
    case "minute":
      a.minute = St(e.minute, r, 0, 59, n == null ? void 0 : n.round);
      break;
    case "second":
      a.second = St(e.second, r, 0, 59, n == null ? void 0 : n.round);
      break;
    case "millisecond":
      a.millisecond = St(e.millisecond, r, 0, 999, n == null ? void 0 : n.round);
      break;
    default:
      throw new Error("Unsupported field " + t);
  }
  return a;
}
function St(e, t, r, n, a = !1) {
  if (a) {
    e += Math.sign(t), e < r && (e = n);
    let d = Math.abs(t);
    t > 0 ? e = Math.ceil(e / d) * d : e = Math.floor(e / d) * d, e > n && (e = r);
  } else
    e += t, e < r ? e = n - (r - e - 1) : e > n && (e = r + (e - n - 1));
  return e;
}
function yc(e, t) {
  let r;
  if (t.years != null && t.years !== 0 || t.months != null && t.months !== 0 || t.weeks != null && t.weeks !== 0 || t.days != null && t.days !== 0) {
    let a = Ga(zr(e), {
      years: t.years,
      months: t.months,
      weeks: t.weeks,
      days: t.days
    });
    r = wt(a, e.timeZone);
  } else
    r = Wr(e) - e.offset;
  r += t.milliseconds || 0, r += (t.seconds || 0) * 1e3, r += (t.minutes || 0) * 6e4, r += (t.hours || 0) * 36e5;
  let n = xt(r, e.timeZone);
  return je(n, e.calendar);
}
function m6(e, t) {
  return yc(e, mc(t));
}
function h6(e, t, r, n) {
  switch (t) {
    case "hour": {
      let a = 0, d = 23;
      if ((n == null ? void 0 : n.hourCycle) === 12) {
        let c = e.hour >= 12;
        a = c ? 12 : 0, d = c ? 23 : 11;
      }
      let o = zr(e), i = je(Ca(o, {
        hour: a
      }), new rt()), l = [
        wt(i, e.timeZone, "earlier"),
        wt(i, e.timeZone, "later")
      ].filter((c) => xt(c, e.timeZone).day === i.day)[0], s = je(Ca(o, {
        hour: d
      }), new rt()), u = [
        wt(s, e.timeZone, "earlier"),
        wt(s, e.timeZone, "later")
      ].filter((c) => xt(c, e.timeZone).day === s.day).pop(), $ = Wr(e) - e.offset, y = Math.floor($ / fn), h = $ % fn;
      return $ = St(y, r, Math.floor(l / fn), Math.floor(u / fn), n == null ? void 0 : n.round) * fn + h, je(xt($, e.timeZone), e.calendar);
    }
    case "minute":
    case "second":
    case "millisecond":
      return vc(e, t, r, n);
    case "era":
    case "year":
    case "month":
    case "day": {
      let a = Si(zr(e), t, r, n), d = wt(a, e.timeZone);
      return je(xt(d, e.timeZone), e.calendar);
    }
    default:
      throw new Error("Unsupported field " + t);
  }
}
function v6(e, t, r) {
  let n = zr(e), a = Ca(xi(n, t), t);
  if (a.compare(n) === 0) return e;
  let d = wt(a, e.timeZone, r);
  return je(xt(d, e.timeZone), e.calendar);
}
const y6 = /^([+-]\d{6}|\d{4})-(\d{2})-(\d{2})$/;
function Ko(e) {
  let t = e.match(y6);
  if (!t) throw new Error("Invalid ISO 8601 date string: " + e);
  let r = new Te(yd(t[1], 0, 9999), yd(t[2], 1, 12), 1);
  return r.day = yd(t[3], 1, r.calendar.getDaysInMonth(r)), r;
}
function yd(e, t, r) {
  let n = Number(e);
  if (n < t || n > r) throw new RangeError(`Value out of range: ${t} <= ${n} <= ${r}`);
  return n;
}
function g6(e) {
  return `${String(e.hour).padStart(2, "0")}:${String(e.minute).padStart(2, "0")}:${String(e.second).padStart(2, "0")}${e.millisecond ? String(e.millisecond / 1e3).slice(1) : ""}`;
}
function gc(e) {
  let t = je(e, new rt()), r;
  return t.era === "BC" ? r = t.year === 1 ? "0000" : "-" + String(Math.abs(1 - t.year)).padStart(6, "00") : r = String(t.year).padStart(4, "0"), `${r}-${String(t.month).padStart(2, "0")}-${String(t.day).padStart(2, "0")}`;
}
function bc(e) {
  return `${gc(e)}T${g6(e)}`;
}
function b6(e) {
  let t = Math.sign(e) < 0 ? "-" : "+";
  e = Math.abs(e);
  let r = Math.floor(e / 36e5), n = e % 36e5 / 6e4;
  return `${t}${String(r).padStart(2, "0")}:${String(n).padStart(2, "0")}`;
}
function w6(e) {
  return `${bc(e)}${b6(e.offset)}[${e.timeZone}]`;
}
function _6(e, t) {
  if (t.has(e))
    throw new TypeError("Cannot initialize the same private elements twice on an object");
}
function Ci(e, t, r) {
  _6(e, t), t.set(e, r);
}
function Pi(e) {
  let t = typeof e[0] == "object" ? e.shift() : new rt(), r;
  if (typeof e[0] == "string") r = e.shift();
  else {
    let o = t.getEras();
    r = o[o.length - 1];
  }
  let n = e.shift(), a = e.shift(), d = e.shift();
  return [
    t,
    r,
    n,
    a,
    d
  ];
}
var x6 = /* @__PURE__ */ new WeakMap();
class Te {
  /** Returns a copy of this date. */
  copy() {
    return this.era ? new Te(this.calendar, this.era, this.year, this.month, this.day) : new Te(this.calendar, this.year, this.month, this.day);
  }
  /** Returns a new `CalendarDate` with the given duration added to it. */
  add(t) {
    return Ga(this, t);
  }
  /** Returns a new `CalendarDate` with the given duration subtracted from it. */
  subtract(t) {
    return hc(this, t);
  }
  /** Returns a new `CalendarDate` with the given fields set to the provided values. Other fields will be constrained accordingly. */
  set(t) {
    return xi(this, t);
  }
  /**
  * Returns a new `CalendarDate` with the given field adjusted by a specified amount.
  * When the resulting value reaches the limits of the field, it wraps around.
  */
  cycle(t, r, n) {
    return Si(this, t, r, n);
  }
  /** Converts the date to a native JavaScript Date object, with the time set to midnight in the given time zone. */
  toDate(t) {
    return $c(this, t);
  }
  /** Converts the date to an ISO 8601 formatted string. */
  toString() {
    return gc(this);
  }
  /** Compares this date with another. A negative result indicates that this date is before the given one, and a positive date indicates that it is after. */
  compare(t) {
    return uc(this, t);
  }
  constructor(...t) {
    Ci(this, x6, {
      writable: !0,
      value: void 0
    });
    let [r, n, a, d, o] = Pi(t);
    this.calendar = r, this.era = n, this.year = a, this.month = d, this.day = o, br(this);
  }
}
var S6 = /* @__PURE__ */ new WeakMap();
class qr {
  /** Returns a copy of this date. */
  copy() {
    return this.era ? new qr(this.calendar, this.era, this.year, this.month, this.day, this.hour, this.minute, this.second, this.millisecond) : new qr(this.calendar, this.year, this.month, this.day, this.hour, this.minute, this.second, this.millisecond);
  }
  /** Returns a new `CalendarDateTime` with the given duration added to it. */
  add(t) {
    return Ga(this, t);
  }
  /** Returns a new `CalendarDateTime` with the given duration subtracted from it. */
  subtract(t) {
    return hc(this, t);
  }
  /** Returns a new `CalendarDateTime` with the given fields set to the provided values. Other fields will be constrained accordingly. */
  set(t) {
    return xi(Ca(this, t), t);
  }
  /**
  * Returns a new `CalendarDateTime` with the given field adjusted by a specified amount.
  * When the resulting value reaches the limits of the field, it wraps around.
  */
  cycle(t, r, n) {
    switch (t) {
      case "era":
      case "year":
      case "month":
      case "day":
        return Si(this, t, r, n);
      default:
        return vc(this, t, r, n);
    }
  }
  /** Converts the date to a native JavaScript Date object in the given time zone. */
  toDate(t, r) {
    return $c(this, t, r);
  }
  /** Converts the date to an ISO 8601 formatted string. */
  toString() {
    return bc(this);
  }
  /** Compares this date with another. A negative result indicates that this date is before the given one, and a positive date indicates that it is after. */
  compare(t) {
    let r = uc(this, t);
    return r === 0 ? r6(this, zr(t)) : r;
  }
  constructor(...t) {
    Ci(this, S6, {
      writable: !0,
      value: void 0
    });
    let [r, n, a, d, o] = Pi(t);
    this.calendar = r, this.era = n, this.year = a, this.month = d, this.day = o, this.hour = t.shift() || 0, this.minute = t.shift() || 0, this.second = t.shift() || 0, this.millisecond = t.shift() || 0, br(this);
  }
}
var C6 = /* @__PURE__ */ new WeakMap();
class Kr {
  /** Returns a copy of this date. */
  copy() {
    return this.era ? new Kr(this.calendar, this.era, this.year, this.month, this.day, this.timeZone, this.offset, this.hour, this.minute, this.second, this.millisecond) : new Kr(this.calendar, this.year, this.month, this.day, this.timeZone, this.offset, this.hour, this.minute, this.second, this.millisecond);
  }
  /** Returns a new `ZonedDateTime` with the given duration added to it. */
  add(t) {
    return yc(this, t);
  }
  /** Returns a new `ZonedDateTime` with the given duration subtracted from it. */
  subtract(t) {
    return m6(this, t);
  }
  /** Returns a new `ZonedDateTime` with the given fields set to the provided values. Other fields will be constrained accordingly. */
  set(t, r) {
    return v6(this, t, r);
  }
  /**
  * Returns a new `ZonedDateTime` with the given field adjusted by a specified amount.
  * When the resulting value reaches the limits of the field, it wraps around.
  */
  cycle(t, r, n) {
    return h6(this, t, r, n);
  }
  /** Converts the date to a native JavaScript Date object. */
  toDate() {
    return s6(this);
  }
  /** Converts the date to an ISO 8601 formatted string, including the UTC offset and time zone identifier. */
  toString() {
    return w6(this);
  }
  /** Converts the date to an ISO 8601 formatted string in UTC. */
  toAbsoluteString() {
    return this.toDate().toISOString();
  }
  /** Compares this date with another. A negative result indicates that this date is before the given one, and a positive date indicates that it is after. */
  compare(t) {
    return this.toDate().getTime() - l6(t, this.timeZone).toDate().getTime();
  }
  constructor(...t) {
    Ci(this, C6, {
      writable: !0,
      value: void 0
    });
    let [r, n, a, d, o] = Pi(t), i = t.shift(), l = t.shift();
    this.calendar = r, this.era = n, this.year = a, this.month = d, this.day = o, this.timeZone = i, this.offset = l, this.hour = t.shift() || 0, this.minute = t.shift() || 0, this.second = t.shift() || 0, this.millisecond = t.shift() || 0, br(this);
  }
}
const Br = [
  [
    1868,
    9,
    8
  ],
  [
    1912,
    7,
    30
  ],
  [
    1926,
    12,
    25
  ],
  [
    1989,
    1,
    8
  ],
  [
    2019,
    5,
    1
  ]
], P6 = [
  [
    1912,
    7,
    29
  ],
  [
    1926,
    12,
    24
  ],
  [
    1989,
    1,
    7
  ],
  [
    2019,
    4,
    30
  ]
], ca = [
  1867,
  1911,
  1925,
  1988,
  2018
], Wt = [
  "meiji",
  "taisho",
  "showa",
  "heisei",
  "reiwa"
];
function vs(e) {
  const t = Br.findIndex(([r, n, a]) => e.year < r || e.year === r && e.month < n || e.year === r && e.month === n && e.day < a);
  return t === -1 ? Br.length - 1 : t === 0 ? 0 : t - 1;
}
function gd(e) {
  let t = ca[Wt.indexOf(e.era)];
  if (!t) throw new Error("Unknown era: " + e.era);
  return new Te(e.year + t, e.month, e.day);
}
class A6 extends rt {
  fromJulianDay(t) {
    let r = super.fromJulianDay(t), n = vs(r);
    return new Te(this, Wt[n], r.year - ca[n], r.month, r.day);
  }
  toJulianDay(t) {
    return super.toJulianDay(gd(t));
  }
  balanceDate(t) {
    let r = gd(t), n = vs(r);
    Wt[n] !== t.era && (t.era = Wt[n], t.year = r.year - ca[n]), this.constrainDate(t);
  }
  constrainDate(t) {
    let r = Wt.indexOf(t.era), n = P6[r];
    if (n != null) {
      let [a, d, o] = n, i = a - ca[r];
      t.year = Math.max(1, Math.min(i, t.year)), t.year === i && (t.month = Math.min(d, t.month), t.month === d && (t.day = Math.min(o, t.day)));
    }
    if (t.year === 1 && r >= 0) {
      let [, a, d] = Br[r];
      t.month = Math.max(a, t.month), t.month === a && (t.day = Math.max(d, t.day));
    }
  }
  getEras() {
    return Wt;
  }
  getYearsInEra(t) {
    let r = Wt.indexOf(t.era), n = Br[r], a = Br[r + 1];
    if (a == null)
      return 9999 - n[0] + 1;
    let d = a[0] - n[0];
    return (t.month < a[1] || t.month === a[1] && t.day < a[2]) && d++, d;
  }
  getDaysInMonth(t) {
    return super.getDaysInMonth(gd(t));
  }
  getMinimumMonthInYear(t) {
    let r = ys(t);
    return r ? r[1] : 1;
  }
  getMinimumDayInMonth(t) {
    let r = ys(t);
    return r && t.month === r[1] ? r[2] : 1;
  }
  constructor(...t) {
    super(...t), this.identifier = "japanese";
  }
}
function ys(e) {
  if (e.year === 1) {
    let t = Wt.indexOf(e.era);
    return Br[t];
  }
}
const wc = -543;
class E6 extends rt {
  fromJulianDay(t) {
    let r = super.fromJulianDay(t), n = Wn(r.era, r.year);
    return new Te(this, n - wc, r.month, r.day);
  }
  toJulianDay(t) {
    return super.toJulianDay(gs(t));
  }
  getEras() {
    return [
      "BE"
    ];
  }
  getDaysInMonth(t) {
    return super.getDaysInMonth(gs(t));
  }
  balanceDate() {
  }
  constructor(...t) {
    super(...t), this.identifier = "buddhist";
  }
}
function gs(e) {
  let [t, r] = ja(e.year + wc);
  return new Te(t, r, e.month, e.day);
}
const Pa = 1911;
function _c(e) {
  return e.era === "minguo" ? e.year + Pa : 1 - e.year + Pa;
}
function bs(e) {
  let t = e - Pa;
  return t > 0 ? [
    "minguo",
    t
  ] : [
    "before_minguo",
    1 - t
  ];
}
class M6 extends rt {
  fromJulianDay(t) {
    let r = super.fromJulianDay(t), n = Wn(r.era, r.year), [a, d] = bs(n);
    return new Te(this, a, d, r.month, r.day);
  }
  toJulianDay(t) {
    return super.toJulianDay(ws(t));
  }
  getEras() {
    return [
      "before_minguo",
      "minguo"
    ];
  }
  balanceDate(t) {
    let [r, n] = bs(_c(t));
    t.era = r, t.year = n;
  }
  isInverseEra(t) {
    return t.era === "before_minguo";
  }
  getDaysInMonth(t) {
    return super.getDaysInMonth(ws(t));
  }
  getYearsInEra(t) {
    return t.era === "before_minguo" ? 9999 : 9999 - Pa;
  }
  constructor(...t) {
    super(...t), this.identifier = "roc";
  }
}
function ws(e) {
  let [t, r] = ja(_c(e));
  return new Te(t, r, e.month, e.day);
}
const _s = 1948320, xs = [
  0,
  31,
  62,
  93,
  124,
  155,
  186,
  216,
  246,
  276,
  306,
  336
  // Esfand
];
class O6 {
  fromJulianDay(t) {
    let r = t - _s, n = 1 + Math.floor((33 * r + 3) / 12053), a = 365 * (n - 1) + Math.floor((8 * n + 21) / 33), d = r - a, o = d < 216 ? Math.floor(d / 31) : Math.floor((d - 6) / 30), i = d - xs[o] + 1;
    return new Te(this, n, o + 1, i);
  }
  toJulianDay(t) {
    let r = _s - 1 + 365 * (t.year - 1) + Math.floor((8 * t.year + 21) / 33);
    return r += xs[t.month - 1], r += t.day, r;
  }
  getMonthsInYear() {
    return 12;
  }
  getDaysInMonth(t) {
    return t.month <= 6 ? 31 : t.month <= 11 || Lr(25 * t.year + 11, 33) < 8 ? 30 : 29;
  }
  getEras() {
    return [
      "AP"
    ];
  }
  getYearsInEra() {
    return 9377;
  }
  constructor() {
    this.identifier = "persian";
  }
}
const bd = 78, Ss = 80;
class T6 extends rt {
  fromJulianDay(t) {
    let r = super.fromJulianDay(t), n = r.year - bd, a = t - pr(r.era, r.year, 1, 1), d;
    a < Ss ? (n--, d = zt(r.year - 1) ? 31 : 30, a += d + 155 + 90 + 10) : (d = zt(r.year) ? 31 : 30, a -= Ss);
    let o, i;
    if (a < d)
      o = 1, i = a + 1;
    else {
      let l = a - d;
      l < 155 ? (o = Math.floor(l / 31) + 2, i = l % 31 + 1) : (l -= 155, o = Math.floor(l / 30) + 7, i = l % 30 + 1);
    }
    return new Te(this, n, o, i);
  }
  toJulianDay(t) {
    let r = t.year + bd, [n, a] = ja(r), d, o;
    return zt(a) ? (d = 31, o = pr(n, a, 3, 21)) : (d = 30, o = pr(n, a, 3, 22)), t.month === 1 ? o + t.day - 1 : (o += d + Math.min(t.month - 2, 5) * 31, t.month >= 8 && (o += (t.month - 7) * 30), o += t.day - 1, o);
  }
  getDaysInMonth(t) {
    return t.month === 1 && zt(t.year + bd) || t.month >= 2 && t.month <= 6 ? 31 : 30;
  }
  getYearsInEra() {
    return 9919;
  }
  getEras() {
    return [
      "saka"
    ];
  }
  balanceDate() {
  }
  constructor(...t) {
    super(...t), this.identifier = "indian";
  }
}
const Aa = 1948440, Cs = 1948439, We = 1300, kr = 1600, k6 = 460322;
function Ea(e, t, r, n) {
  return n + Math.ceil(29.5 * (r - 1)) + (t - 1) * 354 + Math.floor((3 + 11 * t) / 30) + e - 1;
}
function xc(e, t, r) {
  let n = Math.floor((30 * (r - t) + 10646) / 10631), a = Math.min(12, Math.ceil((r - (29 + Ea(t, n, 1, 1))) / 29.5) + 1), d = r - Ea(t, n, a, 1) + 1;
  return new Te(e, n, a, d);
}
function Ps(e) {
  return (14 + 11 * e) % 30 < 11;
}
class Ai {
  fromJulianDay(t) {
    return xc(this, Aa, t);
  }
  toJulianDay(t) {
    return Ea(Aa, t.year, t.month, t.day);
  }
  getDaysInMonth(t) {
    let r = 29 + t.month % 2;
    return t.month === 12 && Ps(t.year) && r++, r;
  }
  getMonthsInYear() {
    return 12;
  }
  getDaysInYear(t) {
    return Ps(t.year) ? 355 : 354;
  }
  getYearsInEra() {
    return 9665;
  }
  getEras() {
    return [
      "AH"
    ];
  }
  constructor() {
    this.identifier = "islamic-civil";
  }
}
class I6 extends Ai {
  fromJulianDay(t) {
    return xc(this, Cs, t);
  }
  toJulianDay(t) {
    return Ea(Cs, t.year, t.month, t.day);
  }
  constructor(...t) {
    super(...t), this.identifier = "islamic-tbla";
  }
}
const R6 = "qgpUDckO1AbqBmwDrQpVBakGkgepC9QF2gpcBS0NlQZKB1QLagutBa4ETwoXBYsGpQbVCtYCWwmdBE0KJg2VDawFtgm6AlsKKwWVCsoG6Qr0AnYJtgJWCcoKpAvSC9kF3AJtCU0FpQpSC6ULtAW2CVcFlwJLBaMGUgdlC2oFqworBZUMSg2lDcoF1gpXCasESwmlClILagt1BXYCtwhbBFUFqQW0BdoJ3QRuAjYJqgpUDbIN1QXaAlsJqwRVCkkLZAtxC7QFtQpVCiUNkg7JDtQG6QprCasEkwpJDaQNsg25CroEWworBZUKKgtVC1wFvQQ9Ah0JlQpKC1oLbQW2AjsJmwRVBqkGVAdqC2wFrQpVBSkLkgupC9QF2gpaBasKlQVJB2QHqgu1BbYCVgpNDiULUgtqC60FrgIvCZcESwalBqwG1gpdBZ0ETQoWDZUNqgW1BdoCWwmtBJUFygbkBuoK9QS2AlYJqgpUC9IL2QXqAm0JrQSVCkoLpQuyBbUJ1gSXCkcFkwZJB1ULagVrCisFiwpGDaMNygXWCtsEawJLCaUKUgtpC3UFdgG3CFsCKwVlBbQF2gntBG0BtgimClINqQ3UBdoKWwmrBFMGKQdiB6kLsgW1ClUFJQuSDckO0gbpCmsFqwRVCikNVA2qDbUJugQ7CpsETQqqCtUK2gJdCV4ELgqaDFUNsga5BroEXQotBZUKUguoC7QLuQXaAloJSgukDdEO6AZqC20FNQWVBkoNqA3UDdoGWwWdAisGFQtKC5ULqgWuCi4JjwwnBZUGqgbWCl0FnQI=";
let Yo, Vr;
function fa(e) {
  return k6 + Vr[e - We];
}
function hn(e, t) {
  let r = e - We, n = 1 << 11 - (t - 1);
  return (Yo[r] & n) === 0 ? 29 : 30;
}
function As(e, t) {
  let r = fa(e);
  for (let n = 1; n < t; n++) r += hn(e, n);
  return r;
}
function Es(e) {
  return Vr[e + 1 - We] - Vr[e - We];
}
class D6 extends Ai {
  fromJulianDay(t) {
    let r = t - Aa, n = fa(We), a = fa(kr);
    if (r < n || r > a) return super.fromJulianDay(t);
    {
      let d = We - 1, o = 1, i = 1;
      for (; i > 0; ) {
        d++, i = r - fa(d) + 1;
        let l = Es(d);
        if (i === l) {
          o = 12;
          break;
        } else if (i < l) {
          let s = hn(d, o);
          for (o = 1; i > s; )
            i -= s, o++, s = hn(d, o);
          break;
        }
      }
      return new Te(this, d, o, r - As(d, o) + 1);
    }
  }
  toJulianDay(t) {
    return t.year < We || t.year > kr ? super.toJulianDay(t) : Aa + As(t.year, t.month) + (t.day - 1);
  }
  getDaysInMonth(t) {
    return t.year < We || t.year > kr ? super.getDaysInMonth(t) : hn(t.year, t.month);
  }
  getDaysInYear(t) {
    return t.year < We || t.year > kr ? super.getDaysInYear(t) : Es(t.year);
  }
  constructor() {
    if (super(), this.identifier = "islamic-umalqura", Yo || (Yo = new Uint16Array(Uint8Array.from(atob(R6), (t) => t.charCodeAt(0)).buffer)), !Vr) {
      Vr = new Uint32Array(kr - We + 1);
      let t = 0;
      for (let r = We; r <= kr; r++) {
        Vr[r - We] = t;
        for (let n = 1; n <= 12; n++) t += hn(r, n);
      }
    }
  }
}
const Ms = 347997, Sc = 1080, Cc = 24 * Sc, N6 = 29, F6 = 12 * Sc + 793, L6 = N6 * Cc + F6;
function $r(e) {
  return Lr(e * 7 + 1, 19) < 7;
}
function $a(e) {
  let t = Math.floor((235 * e - 234) / 19), r = 12084 + 13753 * t, n = t * 29 + Math.floor(r / 25920);
  return Lr(3 * (n + 1), 7) < 3 && (n += 1), n;
}
function B6(e) {
  let t = $a(e - 1), r = $a(e);
  return $a(e + 1) - r === 356 ? 2 : r - t === 382 ? 1 : 0;
}
function Sn(e) {
  return $a(e) + B6(e);
}
function Pc(e) {
  return Sn(e + 1) - Sn(e);
}
function V6(e) {
  let t = Pc(e);
  switch (t > 380 && (t -= 30), t) {
    case 353:
      return 0;
    // deficient
    case 354:
      return 1;
    // normal
    case 355:
      return 2;
  }
}
function oa(e, t) {
  if (t >= 6 && !$r(e) && t++, t === 4 || t === 7 || t === 9 || t === 11 || t === 13) return 29;
  let r = V6(e);
  return t === 2 ? r === 2 ? 30 : 29 : t === 3 ? r === 0 ? 29 : 30 : t === 6 ? $r(e) ? 30 : 0 : 30;
}
class j6 {
  fromJulianDay(t) {
    let r = t - Ms, n = r * Cc / L6, a = Math.floor((19 * n + 234) / 235) + 1, d = Sn(a), o = Math.floor(r - d);
    for (; o < 1; )
      a--, d = Sn(a), o = Math.floor(r - d);
    let i = 1, l = 0;
    for (; l < o; )
      l += oa(a, i), i++;
    i--, l -= oa(a, i);
    let s = o - l;
    return new Te(this, a, i, s);
  }
  toJulianDay(t) {
    let r = Sn(t.year);
    for (let n = 1; n < t.month; n++) r += oa(t.year, n);
    return r + t.day + Ms;
  }
  getDaysInMonth(t) {
    return oa(t.year, t.month);
  }
  getMonthsInYear(t) {
    return $r(t.year) ? 13 : 12;
  }
  getDaysInYear(t) {
    return Pc(t.year);
  }
  getYearsInEra() {
    return 9999;
  }
  getEras() {
    return [
      "AM"
    ];
  }
  balanceYearMonth(t, r) {
    r.year !== t.year && ($r(r.year) && !$r(t.year) && r.month > 6 ? t.month-- : !$r(r.year) && $r(t.year) && r.month > 6 && t.month++);
  }
  constructor() {
    this.identifier = "hebrew";
  }
}
const Zo = 1723856, Os = 1824665, Jo = 5500;
function Ma(e, t, r, n) {
  return e + 365 * t + Math.floor(t / 4) + 30 * (r - 1) + n - 1;
}
function Ei(e, t) {
  let r = Math.floor(4 * (t - e) / 1461), n = 1 + Math.floor((t - Ma(e, r, 1, 1)) / 30), a = t + 1 - Ma(e, r, n, 1);
  return [
    r,
    n,
    a
  ];
}
function Ac(e) {
  return Math.floor(e % 4 / 3);
}
function Ec(e, t) {
  return t % 13 !== 0 ? 30 : Ac(e) + 5;
}
class Mi {
  fromJulianDay(t) {
    let [r, n, a] = Ei(Zo, t), d = "AM";
    return r <= 0 && (d = "AA", r += Jo), new Te(this, d, r, n, a);
  }
  toJulianDay(t) {
    let r = t.year;
    return t.era === "AA" && (r -= Jo), Ma(Zo, r, t.month, t.day);
  }
  getDaysInMonth(t) {
    return Ec(t.year, t.month);
  }
  getMonthsInYear() {
    return 13;
  }
  getDaysInYear(t) {
    return 365 + Ac(t.year);
  }
  getYearsInEra(t) {
    return t.era === "AA" ? 9999 : 9991;
  }
  getEras() {
    return [
      "AA",
      "AM"
    ];
  }
  constructor() {
    this.identifier = "ethiopic";
  }
}
class G6 extends Mi {
  fromJulianDay(t) {
    let [r, n, a] = Ei(Zo, t);
    return r += Jo, new Te(this, "AA", r, n, a);
  }
  getEras() {
    return [
      "AA"
    ];
  }
  getYearsInEra() {
    return 9999;
  }
  constructor(...t) {
    super(...t), this.identifier = "ethioaa";
  }
}
class U6 extends Mi {
  fromJulianDay(t) {
    let [r, n, a] = Ei(Os, t), d = "CE";
    return r <= 0 && (d = "BCE", r = 1 - r), new Te(this, d, r, n, a);
  }
  toJulianDay(t) {
    let r = t.year;
    return t.era === "BCE" && (r = 1 - r), Ma(Os, r, t.month, t.day);
  }
  getDaysInMonth(t) {
    let r = t.year;
    return t.era === "BCE" && (r = 1 - r), Ec(r, t.month);
  }
  isInverseEra(t) {
    return t.era === "BCE";
  }
  balanceDate(t) {
    t.year <= 0 && (t.era = t.era === "BCE" ? "CE" : "BCE", t.year = 1 - t.year);
  }
  getEras() {
    return [
      "BCE",
      "CE"
    ];
  }
  getYearsInEra(t) {
    return t.era === "BCE" ? 9999 : 9715;
  }
  constructor(...t) {
    super(...t), this.identifier = "coptic";
  }
}
function H6(e) {
  switch (e) {
    case "buddhist":
      return new E6();
    case "ethiopic":
      return new Mi();
    case "ethioaa":
      return new G6();
    case "coptic":
      return new U6();
    case "hebrew":
      return new j6();
    case "indian":
      return new T6();
    case "islamic-civil":
      return new Ai();
    case "islamic-tbla":
      return new I6();
    case "islamic-umalqura":
      return new D6();
    case "japanese":
      return new A6();
    case "persian":
      return new O6();
    case "roc":
      return new M6();
    case "gregory":
    default:
      return new rt();
  }
}
let wd = /* @__PURE__ */ new Map();
class yt {
  /** Formats a date as a string according to the locale and format options passed to the constructor. */
  format(t) {
    return this.formatter.format(t);
  }
  /** Formats a date to an array of parts such as separators, numbers, punctuation, and more. */
  formatToParts(t) {
    return this.formatter.formatToParts(t);
  }
  /** Formats a date range as a string. */
  formatRange(t, r) {
    if (typeof this.formatter.formatRange == "function")
      return this.formatter.formatRange(t, r);
    if (r < t) throw new RangeError("End date must be >= start date");
    return `${this.formatter.format(t)} – ${this.formatter.format(r)}`;
  }
  /** Formats a date range as an array of parts. */
  formatRangeToParts(t, r) {
    if (typeof this.formatter.formatRangeToParts == "function")
      return this.formatter.formatRangeToParts(t, r);
    if (r < t) throw new RangeError("End date must be >= start date");
    let n = this.formatter.formatToParts(t), a = this.formatter.formatToParts(r);
    return [
      ...n.map((d) => ({
        ...d,
        source: "startRange"
      })),
      {
        type: "literal",
        value: " – ",
        source: "shared"
      },
      ...a.map((d) => ({
        ...d,
        source: "endRange"
      }))
    ];
  }
  /** Returns the resolved formatting options based on the values passed to the constructor. */
  resolvedOptions() {
    let t = this.formatter.resolvedOptions();
    return q6() && (this.resolvedHourCycle || (this.resolvedHourCycle = K6(t.locale, this.options)), t.hourCycle = this.resolvedHourCycle, t.hour12 = this.resolvedHourCycle === "h11" || this.resolvedHourCycle === "h12"), t.calendar === "ethiopic-amete-alem" && (t.calendar = "ethioaa"), t;
  }
  constructor(t, r = {}) {
    this.formatter = Mc(t, r), this.options = r;
  }
}
const W6 = {
  true: {
    // Only Japanese uses the h11 style for 12 hour time. All others use h12.
    ja: "h11"
  },
  false: {}
};
function Mc(e, t = {}) {
  if (typeof t.hour12 == "boolean" && z6()) {
    t = {
      ...t
    };
    let a = W6[String(t.hour12)][e.split("-")[0]], d = t.hour12 ? "h12" : "h23";
    t.hourCycle = a ?? d, delete t.hour12;
  }
  let r = e + (t ? Object.entries(t).sort((a, d) => a[0] < d[0] ? -1 : 1).join() : "");
  if (wd.has(r)) return wd.get(r);
  let n = new Intl.DateTimeFormat(e, t);
  return wd.set(r, n), n;
}
let _d = null;
function z6() {
  return _d == null && (_d = new Intl.DateTimeFormat("en-US", {
    hour: "numeric",
    hour12: !1
  }).format(new Date(2020, 2, 3, 0)) === "24"), _d;
}
let xd = null;
function q6() {
  return xd == null && (xd = new Intl.DateTimeFormat("fr", {
    hour: "numeric",
    hour12: !1
  }).resolvedOptions().hourCycle === "h12"), xd;
}
function K6(e, t) {
  if (!t.timeStyle && !t.hour) return;
  e = e.replace(/(-u-)?-nu-[a-zA-Z0-9]+/, ""), e += (e.includes("-u-") ? "" : "-u") + "-nu-latn";
  let r = Mc(e, {
    ...t,
    timeZone: void 0
    // use local timezone
  }), n = parseInt(r.formatToParts(new Date(2020, 2, 3, 0)).find((d) => d.type === "hour").value, 10), a = parseInt(r.formatToParts(new Date(2020, 2, 3, 23)).find((d) => d.type === "hour").value, 10);
  if (n === 0 && a === 23) return "h23";
  if (n === 24 && a === 23) return "h24";
  if (n === 0 && a === 11) return "h11";
  if (n === 12 && a === 11) return "h12";
  throw new Error("Unexpected hour cycle result");
}
const Oc = 6048e5, Y6 = 864e5, Ts = Symbol.for("constructDateFrom");
function er(e, t) {
  return typeof e == "function" ? e(t) : e && typeof e == "object" && Ts in e ? e[Ts](t) : e instanceof Date ? new e.constructor(t) : new Date(t);
}
function dt(e, t) {
  return er(t || e, e);
}
let Z6 = {};
function Ua() {
  return Z6;
}
function Tn(e, t) {
  var i, l, s, u;
  const r = Ua(), n = (t == null ? void 0 : t.weekStartsOn) ?? ((l = (i = t == null ? void 0 : t.locale) == null ? void 0 : i.options) == null ? void 0 : l.weekStartsOn) ?? r.weekStartsOn ?? ((u = (s = r.locale) == null ? void 0 : s.options) == null ? void 0 : u.weekStartsOn) ?? 0, a = dt(e, t == null ? void 0 : t.in), d = a.getDay(), o = (d < n ? 7 : 0) + d - n;
  return a.setDate(a.getDate() - o), a.setHours(0, 0, 0, 0), a;
}
function Oa(e, t) {
  return Tn(e, { ...t, weekStartsOn: 1 });
}
function Tc(e, t) {
  const r = dt(e, t == null ? void 0 : t.in), n = r.getFullYear(), a = er(r, 0);
  a.setFullYear(n + 1, 0, 4), a.setHours(0, 0, 0, 0);
  const d = Oa(a), o = er(r, 0);
  o.setFullYear(n, 0, 4), o.setHours(0, 0, 0, 0);
  const i = Oa(o);
  return r.getTime() >= d.getTime() ? n + 1 : r.getTime() >= i.getTime() ? n : n - 1;
}
function ks(e) {
  const t = dt(e), r = new Date(
    Date.UTC(
      t.getFullYear(),
      t.getMonth(),
      t.getDate(),
      t.getHours(),
      t.getMinutes(),
      t.getSeconds(),
      t.getMilliseconds()
    )
  );
  return r.setUTCFullYear(t.getFullYear()), +e - +r;
}
function J6(e, ...t) {
  const r = er.bind(
    null,
    t.find((n) => typeof n == "object")
  );
  return t.map(r);
}
function Is(e, t) {
  const r = dt(e, t == null ? void 0 : t.in);
  return r.setHours(0, 0, 0, 0), r;
}
function Q6(e, t, r) {
  const [n, a] = J6(
    r == null ? void 0 : r.in,
    e,
    t
  ), d = Is(n), o = Is(a), i = +d - ks(d), l = +o - ks(o);
  return Math.round((i - l) / Y6);
}
function X6(e, t) {
  const r = Tc(e, t), n = er(e, 0);
  return n.setFullYear(r, 0, 4), n.setHours(0, 0, 0, 0), Oa(n);
}
function eh(e) {
  return e instanceof Date || typeof e == "object" && Object.prototype.toString.call(e) === "[object Date]";
}
function th(e) {
  return !(!eh(e) && typeof e != "number" || isNaN(+dt(e)));
}
function rh(e, t) {
  const r = dt(e, t == null ? void 0 : t.in);
  return r.setFullYear(r.getFullYear(), 0, 1), r.setHours(0, 0, 0, 0), r;
}
const nh = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, ah = (e, t, r) => {
  let n;
  const a = nh[e];
  return typeof a == "string" ? n = a : t === 1 ? n = a.one : n = a.other.replace("{{count}}", t.toString()), r != null && r.addSuffix ? r.comparison && r.comparison > 0 ? "in " + n : n + " ago" : n;
};
function Sd(e) {
  return (t = {}) => {
    const r = t.width ? String(t.width) : e.defaultWidth;
    return e.formats[r] || e.formats[e.defaultWidth];
  };
}
const dh = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, oh = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, ih = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, lh = {
  date: Sd({
    formats: dh,
    defaultWidth: "full"
  }),
  time: Sd({
    formats: oh,
    defaultWidth: "full"
  }),
  dateTime: Sd({
    formats: ih,
    defaultWidth: "full"
  })
}, sh = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, uh = (e, t, r, n) => sh[e];
function $n(e) {
  return (t, r) => {
    const n = r != null && r.context ? String(r.context) : "standalone";
    let a;
    if (n === "formatting" && e.formattingValues) {
      const o = e.defaultFormattingWidth || e.defaultWidth, i = r != null && r.width ? String(r.width) : o;
      a = e.formattingValues[i] || e.formattingValues[o];
    } else {
      const o = e.defaultWidth, i = r != null && r.width ? String(r.width) : e.defaultWidth;
      a = e.values[i] || e.values[o];
    }
    const d = e.argumentCallback ? e.argumentCallback(t) : t;
    return a[d];
  };
}
const ch = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, fh = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, $h = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ],
  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
}, ph = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ]
}, mh = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, hh = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, vh = (e, t) => {
  const r = Number(e), n = r % 100;
  if (n > 20 || n < 10)
    switch (n % 10) {
      case 1:
        return r + "st";
      case 2:
        return r + "nd";
      case 3:
        return r + "rd";
    }
  return r + "th";
}, yh = {
  ordinalNumber: vh,
  era: $n({
    values: ch,
    defaultWidth: "wide"
  }),
  quarter: $n({
    values: fh,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: $n({
    values: $h,
    defaultWidth: "wide"
  }),
  day: $n({
    values: ph,
    defaultWidth: "wide"
  }),
  dayPeriod: $n({
    values: mh,
    defaultWidth: "wide",
    formattingValues: hh,
    defaultFormattingWidth: "wide"
  })
};
function pn(e) {
  return (t, r = {}) => {
    const n = r.width, a = n && e.matchPatterns[n] || e.matchPatterns[e.defaultMatchWidth], d = t.match(a);
    if (!d)
      return null;
    const o = d[0], i = n && e.parsePatterns[n] || e.parsePatterns[e.defaultParseWidth], l = Array.isArray(i) ? bh(i, ($) => $.test(o)) : (
      // [TODO] -- I challenge you to fix the type
      gh(i, ($) => $.test(o))
    );
    let s;
    s = e.valueCallback ? e.valueCallback(l) : l, s = r.valueCallback ? (
      // [TODO] -- I challenge you to fix the type
      r.valueCallback(s)
    ) : s;
    const u = t.slice(o.length);
    return { value: s, rest: u };
  };
}
function gh(e, t) {
  for (const r in e)
    if (Object.prototype.hasOwnProperty.call(e, r) && t(e[r]))
      return r;
}
function bh(e, t) {
  for (let r = 0; r < e.length; r++)
    if (t(e[r]))
      return r;
}
function wh(e) {
  return (t, r = {}) => {
    const n = t.match(e.matchPattern);
    if (!n) return null;
    const a = n[0], d = t.match(e.parsePattern);
    if (!d) return null;
    let o = e.valueCallback ? e.valueCallback(d[0]) : d[0];
    o = r.valueCallback ? r.valueCallback(o) : o;
    const i = t.slice(a.length);
    return { value: o, rest: i };
  };
}
const _h = /^(\d+)(th|st|nd|rd)?/i, xh = /\d+/i, Sh = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, Ch = {
  any: [/^b/i, /^(a|c)/i]
}, Ph = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, Ah = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, Eh = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, Mh = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, Oh = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, Th = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, kh = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, Ih = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, Rh = {
  ordinalNumber: wh({
    matchPattern: _h,
    parsePattern: xh,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: pn({
    matchPatterns: Sh,
    defaultMatchWidth: "wide",
    parsePatterns: Ch,
    defaultParseWidth: "any"
  }),
  quarter: pn({
    matchPatterns: Ph,
    defaultMatchWidth: "wide",
    parsePatterns: Ah,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: pn({
    matchPatterns: Eh,
    defaultMatchWidth: "wide",
    parsePatterns: Mh,
    defaultParseWidth: "any"
  }),
  day: pn({
    matchPatterns: Oh,
    defaultMatchWidth: "wide",
    parsePatterns: Th,
    defaultParseWidth: "any"
  }),
  dayPeriod: pn({
    matchPatterns: kh,
    defaultMatchWidth: "any",
    parsePatterns: Ih,
    defaultParseWidth: "any"
  })
}, Dh = {
  code: "en-US",
  formatDistance: ah,
  formatLong: lh,
  formatRelative: uh,
  localize: yh,
  match: Rh,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
function Nh(e, t) {
  const r = dt(e, t == null ? void 0 : t.in);
  return Q6(r, rh(r)) + 1;
}
function Fh(e, t) {
  const r = dt(e, t == null ? void 0 : t.in), n = +Oa(r) - +X6(r);
  return Math.round(n / Oc) + 1;
}
function kc(e, t) {
  var u, $, y, h;
  const r = dt(e, t == null ? void 0 : t.in), n = r.getFullYear(), a = Ua(), d = (t == null ? void 0 : t.firstWeekContainsDate) ?? (($ = (u = t == null ? void 0 : t.locale) == null ? void 0 : u.options) == null ? void 0 : $.firstWeekContainsDate) ?? a.firstWeekContainsDate ?? ((h = (y = a.locale) == null ? void 0 : y.options) == null ? void 0 : h.firstWeekContainsDate) ?? 1, o = er((t == null ? void 0 : t.in) || e, 0);
  o.setFullYear(n + 1, 0, d), o.setHours(0, 0, 0, 0);
  const i = Tn(o, t), l = er((t == null ? void 0 : t.in) || e, 0);
  l.setFullYear(n, 0, d), l.setHours(0, 0, 0, 0);
  const s = Tn(l, t);
  return +r >= +i ? n + 1 : +r >= +s ? n : n - 1;
}
function Lh(e, t) {
  var i, l, s, u;
  const r = Ua(), n = (t == null ? void 0 : t.firstWeekContainsDate) ?? ((l = (i = t == null ? void 0 : t.locale) == null ? void 0 : i.options) == null ? void 0 : l.firstWeekContainsDate) ?? r.firstWeekContainsDate ?? ((u = (s = r.locale) == null ? void 0 : s.options) == null ? void 0 : u.firstWeekContainsDate) ?? 1, a = kc(e, t), d = er((t == null ? void 0 : t.in) || e, 0);
  return d.setFullYear(a, 0, n), d.setHours(0, 0, 0, 0), Tn(d, t);
}
function Bh(e, t) {
  const r = dt(e, t == null ? void 0 : t.in), n = +Tn(r, t) - +Lh(r, t);
  return Math.round(n / Oc) + 1;
}
function pe(e, t) {
  const r = e < 0 ? "-" : "", n = Math.abs(e).toString().padStart(t, "0");
  return r + n;
}
const Lt = {
  // Year
  y(e, t) {
    const r = e.getFullYear(), n = r > 0 ? r : 1 - r;
    return pe(t === "yy" ? n % 100 : n, t.length);
  },
  // Month
  M(e, t) {
    const r = e.getMonth();
    return t === "M" ? String(r + 1) : pe(r + 1, 2);
  },
  // Day of the month
  d(e, t) {
    return pe(e.getDate(), t.length);
  },
  // AM or PM
  a(e, t) {
    const r = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
        return r.toUpperCase();
      case "aaa":
        return r;
      case "aaaaa":
        return r[0];
      case "aaaa":
      default:
        return r === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h(e, t) {
    return pe(e.getHours() % 12 || 12, t.length);
  },
  // Hour [0-23]
  H(e, t) {
    return pe(e.getHours(), t.length);
  },
  // Minute
  m(e, t) {
    return pe(e.getMinutes(), t.length);
  },
  // Second
  s(e, t) {
    return pe(e.getSeconds(), t.length);
  },
  // Fraction of second
  S(e, t) {
    const r = t.length, n = e.getMilliseconds(), a = Math.trunc(
      n * Math.pow(10, r - 3)
    );
    return pe(a, t.length);
  }
}, Ir = {
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, Rs = {
  // Era
  G: function(e, t, r) {
    const n = e.getFullYear() > 0 ? 1 : 0;
    switch (t) {
      // AD, BC
      case "G":
      case "GG":
      case "GGG":
        return r.era(n, { width: "abbreviated" });
      // A, B
      case "GGGGG":
        return r.era(n, { width: "narrow" });
      // Anno Domini, Before Christ
      case "GGGG":
      default:
        return r.era(n, { width: "wide" });
    }
  },
  // Year
  y: function(e, t, r) {
    if (t === "yo") {
      const n = e.getFullYear(), a = n > 0 ? n : 1 - n;
      return r.ordinalNumber(a, { unit: "year" });
    }
    return Lt.y(e, t);
  },
  // Local week-numbering year
  Y: function(e, t, r, n) {
    const a = kc(e, n), d = a > 0 ? a : 1 - a;
    if (t === "YY") {
      const o = d % 100;
      return pe(o, 2);
    }
    return t === "Yo" ? r.ordinalNumber(d, { unit: "year" }) : pe(d, t.length);
  },
  // ISO week-numbering year
  R: function(e, t) {
    const r = Tc(e);
    return pe(r, t.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(e, t) {
    const r = e.getFullYear();
    return pe(r, t.length);
  },
  // Quarter
  Q: function(e, t, r) {
    const n = Math.ceil((e.getMonth() + 1) / 3);
    switch (t) {
      // 1, 2, 3, 4
      case "Q":
        return String(n);
      // 01, 02, 03, 04
      case "QQ":
        return pe(n, 2);
      // 1st, 2nd, 3rd, 4th
      case "Qo":
        return r.ordinalNumber(n, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "QQQ":
        return r.quarter(n, {
          width: "abbreviated",
          context: "formatting"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "QQQQQ":
        return r.quarter(n, {
          width: "narrow",
          context: "formatting"
        });
      // 1st quarter, 2nd quarter, ...
      case "QQQQ":
      default:
        return r.quarter(n, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(e, t, r) {
    const n = Math.ceil((e.getMonth() + 1) / 3);
    switch (t) {
      // 1, 2, 3, 4
      case "q":
        return String(n);
      // 01, 02, 03, 04
      case "qq":
        return pe(n, 2);
      // 1st, 2nd, 3rd, 4th
      case "qo":
        return r.ordinalNumber(n, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "qqq":
        return r.quarter(n, {
          width: "abbreviated",
          context: "standalone"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "qqqqq":
        return r.quarter(n, {
          width: "narrow",
          context: "standalone"
        });
      // 1st quarter, 2nd quarter, ...
      case "qqqq":
      default:
        return r.quarter(n, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(e, t, r) {
    const n = e.getMonth();
    switch (t) {
      case "M":
      case "MM":
        return Lt.M(e, t);
      // 1st, 2nd, ..., 12th
      case "Mo":
        return r.ordinalNumber(n + 1, { unit: "month" });
      // Jan, Feb, ..., Dec
      case "MMM":
        return r.month(n, {
          width: "abbreviated",
          context: "formatting"
        });
      // J, F, ..., D
      case "MMMMM":
        return r.month(n, {
          width: "narrow",
          context: "formatting"
        });
      // January, February, ..., December
      case "MMMM":
      default:
        return r.month(n, { width: "wide", context: "formatting" });
    }
  },
  // Stand-alone month
  L: function(e, t, r) {
    const n = e.getMonth();
    switch (t) {
      // 1, 2, ..., 12
      case "L":
        return String(n + 1);
      // 01, 02, ..., 12
      case "LL":
        return pe(n + 1, 2);
      // 1st, 2nd, ..., 12th
      case "Lo":
        return r.ordinalNumber(n + 1, { unit: "month" });
      // Jan, Feb, ..., Dec
      case "LLL":
        return r.month(n, {
          width: "abbreviated",
          context: "standalone"
        });
      // J, F, ..., D
      case "LLLLL":
        return r.month(n, {
          width: "narrow",
          context: "standalone"
        });
      // January, February, ..., December
      case "LLLL":
      default:
        return r.month(n, { width: "wide", context: "standalone" });
    }
  },
  // Local week of year
  w: function(e, t, r, n) {
    const a = Bh(e, n);
    return t === "wo" ? r.ordinalNumber(a, { unit: "week" }) : pe(a, t.length);
  },
  // ISO week of year
  I: function(e, t, r) {
    const n = Fh(e);
    return t === "Io" ? r.ordinalNumber(n, { unit: "week" }) : pe(n, t.length);
  },
  // Day of the month
  d: function(e, t, r) {
    return t === "do" ? r.ordinalNumber(e.getDate(), { unit: "date" }) : Lt.d(e, t);
  },
  // Day of year
  D: function(e, t, r) {
    const n = Nh(e);
    return t === "Do" ? r.ordinalNumber(n, { unit: "dayOfYear" }) : pe(n, t.length);
  },
  // Day of week
  E: function(e, t, r) {
    const n = e.getDay();
    switch (t) {
      // Tue
      case "E":
      case "EE":
      case "EEE":
        return r.day(n, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "EEEEE":
        return r.day(n, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "EEEEEE":
        return r.day(n, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "EEEE":
      default:
        return r.day(n, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(e, t, r, n) {
    const a = e.getDay(), d = (a - n.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      // Numerical value (Nth day of week with current locale or weekStartsOn)
      case "e":
        return String(d);
      // Padded numerical value
      case "ee":
        return pe(d, 2);
      // 1st, 2nd, ..., 7th
      case "eo":
        return r.ordinalNumber(d, { unit: "day" });
      case "eee":
        return r.day(a, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "eeeee":
        return r.day(a, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "eeeeee":
        return r.day(a, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "eeee":
      default:
        return r.day(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(e, t, r, n) {
    const a = e.getDay(), d = (a - n.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      // Numerical value (same as in `e`)
      case "c":
        return String(d);
      // Padded numerical value
      case "cc":
        return pe(d, t.length);
      // 1st, 2nd, ..., 7th
      case "co":
        return r.ordinalNumber(d, { unit: "day" });
      case "ccc":
        return r.day(a, {
          width: "abbreviated",
          context: "standalone"
        });
      // T
      case "ccccc":
        return r.day(a, {
          width: "narrow",
          context: "standalone"
        });
      // Tu
      case "cccccc":
        return r.day(a, {
          width: "short",
          context: "standalone"
        });
      // Tuesday
      case "cccc":
      default:
        return r.day(a, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(e, t, r) {
    const n = e.getDay(), a = n === 0 ? 7 : n;
    switch (t) {
      // 2
      case "i":
        return String(a);
      // 02
      case "ii":
        return pe(a, t.length);
      // 2nd
      case "io":
        return r.ordinalNumber(a, { unit: "day" });
      // Tue
      case "iii":
        return r.day(n, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "iiiii":
        return r.day(n, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "iiiiii":
        return r.day(n, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "iiii":
      default:
        return r.day(n, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(e, t, r) {
    const a = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
        return r.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return r.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return r.dayPeriod(a, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return r.dayPeriod(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(e, t, r) {
    const n = e.getHours();
    let a;
    switch (n === 12 ? a = Ir.noon : n === 0 ? a = Ir.midnight : a = n / 12 >= 1 ? "pm" : "am", t) {
      case "b":
      case "bb":
        return r.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return r.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return r.dayPeriod(a, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return r.dayPeriod(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(e, t, r) {
    const n = e.getHours();
    let a;
    switch (n >= 17 ? a = Ir.evening : n >= 12 ? a = Ir.afternoon : n >= 4 ? a = Ir.morning : a = Ir.night, t) {
      case "B":
      case "BB":
      case "BBB":
        return r.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return r.dayPeriod(a, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return r.dayPeriod(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(e, t, r) {
    if (t === "ho") {
      let n = e.getHours() % 12;
      return n === 0 && (n = 12), r.ordinalNumber(n, { unit: "hour" });
    }
    return Lt.h(e, t);
  },
  // Hour [0-23]
  H: function(e, t, r) {
    return t === "Ho" ? r.ordinalNumber(e.getHours(), { unit: "hour" }) : Lt.H(e, t);
  },
  // Hour [0-11]
  K: function(e, t, r) {
    const n = e.getHours() % 12;
    return t === "Ko" ? r.ordinalNumber(n, { unit: "hour" }) : pe(n, t.length);
  },
  // Hour [1-24]
  k: function(e, t, r) {
    let n = e.getHours();
    return n === 0 && (n = 24), t === "ko" ? r.ordinalNumber(n, { unit: "hour" }) : pe(n, t.length);
  },
  // Minute
  m: function(e, t, r) {
    return t === "mo" ? r.ordinalNumber(e.getMinutes(), { unit: "minute" }) : Lt.m(e, t);
  },
  // Second
  s: function(e, t, r) {
    return t === "so" ? r.ordinalNumber(e.getSeconds(), { unit: "second" }) : Lt.s(e, t);
  },
  // Fraction of second
  S: function(e, t) {
    return Lt.S(e, t);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(e, t, r) {
    const n = e.getTimezoneOffset();
    if (n === 0)
      return "Z";
    switch (t) {
      // Hours and optional minutes
      case "X":
        return Ns(n);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`
      case "XXXX":
      case "XX":
        return cr(n);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XXX`
      case "XXXXX":
      case "XXX":
      // Hours and minutes with `:` delimiter
      default:
        return cr(n, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(e, t, r) {
    const n = e.getTimezoneOffset();
    switch (t) {
      // Hours and optional minutes
      case "x":
        return Ns(n);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`
      case "xxxx":
      case "xx":
        return cr(n);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xxx`
      case "xxxxx":
      case "xxx":
      // Hours and minutes with `:` delimiter
      default:
        return cr(n, ":");
    }
  },
  // Timezone (GMT)
  O: function(e, t, r) {
    const n = e.getTimezoneOffset();
    switch (t) {
      // Short
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + Ds(n, ":");
      // Long
      case "OOOO":
      default:
        return "GMT" + cr(n, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(e, t, r) {
    const n = e.getTimezoneOffset();
    switch (t) {
      // Short
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + Ds(n, ":");
      // Long
      case "zzzz":
      default:
        return "GMT" + cr(n, ":");
    }
  },
  // Seconds timestamp
  t: function(e, t, r) {
    const n = Math.trunc(+e / 1e3);
    return pe(n, t.length);
  },
  // Milliseconds timestamp
  T: function(e, t, r) {
    return pe(+e, t.length);
  }
};
function Ds(e, t = "") {
  const r = e > 0 ? "-" : "+", n = Math.abs(e), a = Math.trunc(n / 60), d = n % 60;
  return d === 0 ? r + String(a) : r + String(a) + t + pe(d, 2);
}
function Ns(e, t) {
  return e % 60 === 0 ? (e > 0 ? "-" : "+") + pe(Math.abs(e) / 60, 2) : cr(e, t);
}
function cr(e, t = "") {
  const r = e > 0 ? "-" : "+", n = Math.abs(e), a = pe(Math.trunc(n / 60), 2), d = pe(n % 60, 2);
  return r + a + t + d;
}
const Fs = (e, t) => {
  switch (e) {
    case "P":
      return t.date({ width: "short" });
    case "PP":
      return t.date({ width: "medium" });
    case "PPP":
      return t.date({ width: "long" });
    case "PPPP":
    default:
      return t.date({ width: "full" });
  }
}, Ic = (e, t) => {
  switch (e) {
    case "p":
      return t.time({ width: "short" });
    case "pp":
      return t.time({ width: "medium" });
    case "ppp":
      return t.time({ width: "long" });
    case "pppp":
    default:
      return t.time({ width: "full" });
  }
}, Vh = (e, t) => {
  const r = e.match(/(P+)(p+)?/) || [], n = r[1], a = r[2];
  if (!a)
    return Fs(e, t);
  let d;
  switch (n) {
    case "P":
      d = t.dateTime({ width: "short" });
      break;
    case "PP":
      d = t.dateTime({ width: "medium" });
      break;
    case "PPP":
      d = t.dateTime({ width: "long" });
      break;
    case "PPPP":
    default:
      d = t.dateTime({ width: "full" });
      break;
  }
  return d.replace("{{date}}", Fs(n, t)).replace("{{time}}", Ic(a, t));
}, jh = {
  p: Ic,
  P: Vh
}, Gh = /^D+$/, Uh = /^Y+$/, Hh = ["D", "DD", "YY", "YYYY"];
function Wh(e) {
  return Gh.test(e);
}
function zh(e) {
  return Uh.test(e);
}
function qh(e, t, r) {
  const n = Kh(e, t, r);
  if (console.warn(n), Hh.includes(e)) throw new RangeError(n);
}
function Kh(e, t, r) {
  const n = e[0] === "Y" ? "years" : "days of the month";
  return `Use \`${e.toLowerCase()}\` instead of \`${e}\` (in \`${t}\`) for formatting ${n} to the input \`${r}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}
const Yh = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, Zh = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, Jh = /^'([^]*?)'?$/, Qh = /''/g, Xh = /[a-zA-Z]/;
function Qo(e, t, r) {
  var u, $, y, h;
  const n = Ua(), a = n.locale ?? Dh, d = n.firstWeekContainsDate ?? (($ = (u = n.locale) == null ? void 0 : u.options) == null ? void 0 : $.firstWeekContainsDate) ?? 1, o = n.weekStartsOn ?? ((h = (y = n.locale) == null ? void 0 : y.options) == null ? void 0 : h.weekStartsOn) ?? 0, i = dt(e, r == null ? void 0 : r.in);
  if (!th(i))
    throw new RangeError("Invalid time value");
  let l = t.match(Zh).map((c) => {
    const p = c[0];
    if (p === "p" || p === "P") {
      const f = jh[p];
      return f(c, a.formatLong);
    }
    return c;
  }).join("").match(Yh).map((c) => {
    if (c === "''")
      return { isToken: !1, value: "'" };
    const p = c[0];
    if (p === "'")
      return { isToken: !1, value: e5(c) };
    if (Rs[p])
      return { isToken: !0, value: c };
    if (p.match(Xh))
      throw new RangeError(
        "Format string contains an unescaped latin alphabet character `" + p + "`"
      );
    return { isToken: !1, value: c };
  });
  a.localize.preprocessor && (l = a.localize.preprocessor(i, l));
  const s = {
    firstWeekContainsDate: d,
    weekStartsOn: o,
    locale: a
  };
  return l.map((c) => {
    if (!c.isToken) return c.value;
    const p = c.value;
    (zh(p) || Wh(p)) && qh(p, t, String(e));
    const f = Rs[p[0]];
    return f(i, p, a.localize, s);
  }).join("");
}
function e5(e) {
  const t = e.match(Jh);
  return t ? t[1].replace(Qh, "'") : e;
}
function t5(e, t) {
  const r = [];
  for (let n = 0; n < e.length; n += t)
    r.push(e.slice(n, n + t));
  return r;
}
function Ue(e, t = rn()) {
  return Ha(e) ? e.toDate() : e.toDate(t);
}
function r5(e) {
  return e instanceof qr;
}
function Ha(e) {
  return e instanceof Kr;
}
function Xo(e) {
  return r5(e) || Ha(e);
}
function qe(e) {
  if (e instanceof Date) {
    const t = e.getFullYear(), r = e.getMonth() + 1;
    return new Date(t, r, 0).getDate();
  } else
    return e.set({ day: 100 }).day;
}
function lt(e, t) {
  return e.compare(t) < 0;
}
function vn(e, t) {
  return e.compare(t) > 0;
}
function n5(e, t) {
  return e.compare(t) <= 0;
}
function a5(e, t) {
  return e.compare(t) >= 0;
}
function d5(e, t, r) {
  return a5(e, t) && n5(e, r);
}
function o5(e, t, r) {
  return vn(e, t) && lt(e, r);
}
function i5(e, t, r) {
  const n = lc(e, r);
  return t > n ? e.subtract({ days: n + 7 - t }) : t === n ? e : e.subtract({ days: n - t });
}
function l5(e, t, r) {
  const n = lc(e, r), a = t === 0 ? 6 : t - 1;
  return n === a ? e : n > a ? e.add({ days: 7 - n + a }) : e.add({ days: a - n });
}
function s5(e, t, r, n) {
  if (r === void 0 && n === void 0)
    return !0;
  let a = e.add({ days: 1 });
  if (n != null && n(a) || r != null && r(a))
    return !1;
  const d = t;
  for (; a.compare(d) < 0; )
    if (a = a.add({ days: 1 }), n != null && n(a) || r != null && r(a))
      return !1;
  return !0;
}
function Ls(e, t) {
  const r = [];
  let n = e.add({ days: 1 });
  const a = t;
  for (; n.compare(a) < 0; )
    r.push(n), n = n.add({ days: 1 });
  return r;
}
function Cd(e) {
  const { dateObj: t, weekStartsOn: r, fixedWeeks: n, locale: a } = e, d = qe(t), o = Array.from({ length: d }, (f, v) => t.set({ day: v + 1 })), i = Ho(t), l = $s(t), s = i5(i, r, a), u = l5(l, r, a), $ = Ls(s.subtract({ days: 1 }), i), y = Ls(l, u.add({ days: 1 })), h = $.length + o.length + y.length;
  if (n && h < 42) {
    const f = 42 - h;
    let v = y[y.length - 1];
    v || (v = $s(t));
    const w = Array.from({ length: f }, (m, b) => {
      const _ = b + 1;
      return v.add({ days: _ });
    });
    y.push(...w);
  }
  const c = $.concat(o, y), p = t5(c, 7);
  return {
    value: t,
    cells: c,
    rows: p
  };
}
function sr(e) {
  const { numberOfMonths: t, dateObj: r, ...n } = e, a = [];
  if (!t || t === 1)
    return a.push(
      Cd({
        ...n,
        dateObj: r
      })
    ), a;
  a.push(
    Cd({
      ...n,
      dateObj: r
    })
  );
  for (let d = 1; d < t; d++) {
    const o = r.add({ months: d });
    a.push(
      Cd({
        ...n,
        dateObj: o
      })
    );
  }
  return a;
}
function Rt(e, t) {
  const r = typeof e == "string" && !t ? `${e}Context` : t, n = Symbol(r);
  return [(a) => {
    const d = ft(n, a);
    if (d || d === null)
      return d;
    throw new Error(
      `Injection \`${n.toString()}\` not found. Component must be used within ${Array.isArray(e) ? `one of the following components: ${e.join(
        ", "
      )}` : `\`${e}\``}`
    );
  }, (a) => (Zt(n, a), a)];
}
function Rc(e, t = Number.NEGATIVE_INFINITY, r = Number.POSITIVE_INFINITY) {
  return Math.min(r, Math.max(t, e));
}
function Bs(e) {
  return e == null;
}
function Oi(e) {
  const { defaultValue: t, defaultPlaceholder: r, granularity: n = "day", locale: a = "en" } = e;
  if (Array.isArray(t) && t.length)
    return t.at(-1).copy();
  if (t && !Array.isArray(t))
    return t.copy();
  if (r)
    return r.copy();
  const d = /* @__PURE__ */ new Date(), o = d.getFullYear(), i = d.getMonth() + 1, l = d.getDate(), s = ["hour", "minute", "second"], u = new yt(a), $ = H6(u.resolvedOptions().calendar);
  return s.includes(n ?? "day") ? je(new qr(o, i, l, 0, 0, 0), $) : je(new Te(o, i, l), $);
}
const u5 = [
  "ach",
  "af",
  "am",
  "an",
  "ar",
  "ast",
  "az",
  "be",
  "bg",
  "bn",
  "br",
  "bs",
  "ca",
  "cak",
  "ckb",
  "cs",
  "cy",
  "da",
  "de",
  "dsb",
  "el",
  "en",
  "eo",
  "es",
  "et",
  "eu",
  "fa",
  "ff",
  "fi",
  "fr",
  "fy",
  "ga",
  "gd",
  "gl",
  "he",
  "hr",
  "hsb",
  "hu",
  "ia",
  "id",
  "it",
  "ja",
  "ka",
  "kk",
  "kn",
  "ko",
  "lb",
  "lo",
  "lt",
  "lv",
  "meh",
  "ml",
  "ms",
  "nl",
  "nn",
  "no",
  "oc",
  "pl",
  "pt",
  "rm",
  "ro",
  "ru",
  "sc",
  "scn",
  "sk",
  "sl",
  "sr",
  "sv",
  "szl",
  "tg",
  "th",
  "tr",
  "uk",
  "zh-CN",
  "zh-TW"
], c5 = ["year", "month", "day"], Pd = {
  ach: { year: "mwaka", month: "dwe", day: "nino" },
  af: { year: "jjjj", month: "mm", day: "dd" },
  am: { year: "ዓዓዓዓ", month: "ሚሜ", day: "ቀቀ" },
  an: { year: "aaaa", month: "mm", day: "dd" },
  ar: { year: "سنة", month: "شهر", day: "يوم" },
  ast: { year: "aaaa", month: "mm", day: "dd" },
  az: { year: "iiii", month: "aa", day: "gg" },
  be: { year: "гггг", month: "мм", day: "дд" },
  bg: { year: "гггг", month: "мм", day: "дд" },
  bn: { year: "yyyy", month: "মিমি", day: "dd" },
  br: { year: "bbbb", month: "mm", day: "dd" },
  bs: { year: "gggg", month: "mm", day: "dd" },
  ca: { year: "aaaa", month: "mm", day: "dd" },
  cak: { year: "jjjj", month: "ii", day: "q'q'" },
  ckb: { year: "ساڵ", month: "مانگ", day: "ڕۆژ" },
  cs: { year: "rrrr", month: "mm", day: "dd" },
  cy: { year: "bbbb", month: "mm", day: "dd" },
  da: { year: "åååå", month: "mm", day: "dd" },
  de: { year: "jjjj", month: "mm", day: "tt" },
  dsb: { year: "llll", month: "mm", day: "źź" },
  el: { year: "εεεε", month: "μμ", day: "ηη" },
  en: { year: "yyyy", month: "mm", day: "dd" },
  eo: { year: "jjjj", month: "mm", day: "tt" },
  es: { year: "aaaa", month: "mm", day: "dd" },
  et: { year: "aaaa", month: "kk", day: "pp" },
  eu: { year: "uuuu", month: "hh", day: "ee" },
  fa: { year: "سال", month: "ماه", day: "روز" },
  ff: { year: "hhhh", month: "ll", day: "ññ" },
  fi: { year: "vvvv", month: "kk", day: "pp" },
  fr: { year: "aaaa", month: "mm", day: "jj" },
  fy: { year: "jjjj", month: "mm", day: "dd" },
  ga: { year: "bbbb", month: "mm", day: "ll" },
  gd: { year: "bbbb", month: "mm", day: "ll" },
  gl: { year: "aaaa", month: "mm", day: "dd" },
  he: { year: "שנה", month: "חודש", day: "יום" },
  hr: { year: "gggg", month: "mm", day: "dd" },
  hsb: { year: "llll", month: "mm", day: "dd" },
  hu: { year: "éééé", month: "hh", day: "nn" },
  ia: { year: "aaaa", month: "mm", day: "dd" },
  id: { year: "tttt", month: "bb", day: "hh" },
  it: { year: "aaaa", month: "mm", day: "gg" },
  ja: { year: " 年 ", month: "月", day: "日" },
  ka: { year: "წწწწ", month: "თთ", day: "რრ" },
  kk: { year: "жжжж", month: "аа", day: "кк" },
  kn: { year: "ವವವವ", month: "ಮಿಮೀ", day: "ದಿದಿ" },
  ko: { year: "연도", month: "월", day: "일" },
  lb: { year: "jjjj", month: "mm", day: "dd" },
  lo: { year: "ປປປປ", month: "ດດ", day: "ວວ" },
  lt: { year: "mmmm", month: "mm", day: "dd" },
  lv: { year: "gggg", month: "mm", day: "dd" },
  meh: { year: "aaaa", month: "mm", day: "dd" },
  ml: { year: "വർഷം", month: "മാസം", day: "തീയതി" },
  ms: { year: "tttt", month: "mm", day: "hh" },
  nl: { year: "jjjj", month: "mm", day: "dd" },
  nn: { year: "åååå", month: "mm", day: "dd" },
  no: { year: "åååå", month: "mm", day: "dd" },
  oc: { year: "aaaa", month: "mm", day: "jj" },
  pl: { year: "rrrr", month: "mm", day: "dd" },
  pt: { year: "aaaa", month: "mm", day: "dd" },
  rm: { year: "oooo", month: "mm", day: "dd" },
  ro: { year: "aaaa", month: "ll", day: "zz" },
  ru: { year: "гггг", month: "мм", day: "дд" },
  sc: { year: "aaaa", month: "mm", day: "dd" },
  scn: { year: "aaaa", month: "mm", day: "jj" },
  sk: { year: "rrrr", month: "mm", day: "dd" },
  sl: { year: "llll", month: "mm", day: "dd" },
  sr: { year: "гггг", month: "мм", day: "дд" },
  sv: { year: "åååå", month: "mm", day: "dd" },
  szl: { year: "rrrr", month: "mm", day: "dd" },
  tg: { year: "сссс", month: "мм", day: "рр" },
  th: { year: "ปปปป", month: "ดด", day: "วว" },
  tr: { year: "yyyy", month: "aa", day: "gg" },
  uk: { year: "рррр", month: "мм", day: "дд" },
  "zh-CN": { year: "年", month: "月", day: "日" },
  "zh-TW": { year: "年", month: "月", day: "日" }
};
function f5(e) {
  if (Vs(e))
    return Pd[e];
  {
    const t = h5(e);
    return Vs(t) ? Pd[t] : Pd.en;
  }
}
function Ad(e, t, r) {
  return $5(e) ? f5(r)[e] : m5(e) ? t : p5(e) ? "––" : "";
}
function Vs(e) {
  return u5.includes(e);
}
function $5(e) {
  return c5.includes(e);
}
function p5(e) {
  return e === "hour" || e === "minute" || e === "second";
}
function m5(e) {
  return e === "era" || e === "dayPeriod";
}
function h5(e) {
  return Intl.Locale ? new Intl.Locale(e).language : e.split("-")[0];
}
const Ti = ["day", "month", "year"], Dc = ["hour", "minute", "second", "dayPeriod"], Nc = [...Ti, ...Dc];
function v5(e) {
  return Ti.includes(e);
}
function Fc(e) {
  return Nc.includes(e);
}
function y5(e, t) {
  const r = {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    timeZoneName: "short",
    hourCycle: t === 24 ? "h24" : void 0,
    hour12: t === 24 ? !1 : void 0
  };
  return e === "day" && (delete r.second, delete r.hour, delete r.minute, delete r.timeZoneName), e === "hour" && (delete r.minute, delete r.second), e === "minute" && delete r.second, r;
}
function Lc(e) {
  const t = e.querySelector("[data-selected]");
  if (t)
    return t.focus();
  const r = e.querySelector("[data-today]");
  if (r)
    return r.focus();
  const n = e.querySelector("[data-radix-vue-calendar-day]");
  if (n)
    return n.focus();
}
function g5(e) {
  let t = !1, r;
  const n = xu(!0);
  return (...a) => (t || (r = n.run(() => e(...a)), t = !0), r);
}
function Bc(e) {
  return typeof e == "function" ? e() : g(e);
}
const Vc = typeof window < "u" && typeof document < "u";
typeof WorkerGlobalScope < "u" && globalThis instanceof WorkerGlobalScope;
const b5 = (e) => typeof e < "u";
function zn(e) {
  var t;
  const r = Bc(e);
  return (t = r == null ? void 0 : r.$el) != null ? t : r;
}
const w5 = Vc ? window : void 0;
function _5() {
  const e = H(!1), t = Jr();
  return t && He(() => {
    e.value = !0;
  }, t), e;
}
function x5(e) {
  return JSON.parse(JSON.stringify(e));
}
function Et(e, t, r, n = {}) {
  var a, d, o;
  const {
    clone: i = !1,
    passive: l = !1,
    eventName: s,
    deep: u = !1,
    defaultValue: $,
    shouldEmit: y
  } = n, h = Jr(), c = r || (h == null ? void 0 : h.emit) || ((a = h == null ? void 0 : h.$emit) == null ? void 0 : a.bind(h)) || ((o = (d = h == null ? void 0 : h.proxy) == null ? void 0 : d.$emit) == null ? void 0 : o.bind(h == null ? void 0 : h.proxy));
  let p = s;
  t || (t = "modelValue"), p = p || `update:${t.toString()}`;
  const f = (m) => i ? typeof i == "function" ? i(m) : x5(m) : m, v = () => b5(e[t]) ? f(e[t]) : $, w = (m) => {
    y ? y(m) && c(p, m) : c(p, m);
  };
  if (l) {
    const m = v(), b = H(m);
    let _ = !1;
    return K(
      () => e[t],
      (x) => {
        _ || (_ = !0, b.value = f(x), tt(() => _ = !1));
      }
    ), K(
      b,
      (x) => {
        !_ && (x !== e[t] || u) && w(x);
      },
      { deep: u }
    ), b;
  } else
    return O({
      get() {
        return v();
      },
      set(m) {
        w(m);
      }
    });
}
function ki(e) {
  return e ? e.flatMap((t) => t.type === le ? ki(t.children) : [t]) : [];
}
function S5() {
  let e = document.activeElement;
  if (e == null)
    return null;
  for (; e != null && e.shadowRoot != null && e.shadowRoot.activeElement != null; )
    e = e.shadowRoot.activeElement;
  return e;
}
const C5 = ["INPUT", "TEXTAREA"];
function P5(e, t, r, n = {}) {
  if (!t || n.enableIgnoredElement && C5.includes(t.nodeName))
    return null;
  const {
    arrowKeyOptions: a = "both",
    attributeName: d = "[data-radix-vue-collection-item]",
    itemsArray: o = [],
    loop: i = !0,
    dir: l = "ltr",
    preventScroll: s = !0,
    focus: u = !1
  } = n, [$, y, h, c, p, f] = [
    e.key === "ArrowRight",
    e.key === "ArrowLeft",
    e.key === "ArrowUp",
    e.key === "ArrowDown",
    e.key === "Home",
    e.key === "End"
  ], v = h || c, w = $ || y;
  if (!p && !f && (!v && !w || a === "vertical" && w || a === "horizontal" && v))
    return null;
  const m = o;
  if (!m.length)
    return null;
  s && e.preventDefault();
  let b = null;
  return w || v ? b = jc(m, t, {
    goForward: v ? c : l === "ltr" ? $ : y,
    loop: i
  }) : p ? b = m.at(0) || null : f && (b = m.at(-1) || null), u && (b == null || b.focus()), b;
}
function jc(e, t, r, n = e.length) {
  if (--n === 0)
    return null;
  const a = e.indexOf(t), d = r.goForward ? a + 1 : a - 1;
  if (!r.loop && (d < 0 || d >= e.length))
    return null;
  const o = (d + e.length) % e.length, i = e[o];
  return i ? i.hasAttribute("disabled") && i.getAttribute("disabled") !== "false" ? jc(
    e,
    i,
    r,
    n
  ) : i : null;
}
const [A5, Gx] = Rt("ConfigProvider");
function Gc(e) {
  const t = H(e);
  function r() {
    return t.value;
  }
  function n(p) {
    t.value = p;
  }
  function a(p, f) {
    return new yt(t.value, f).format(p);
  }
  function d(p, f = !0) {
    return Xo(p) && f ? a(Ue(p), {
      dateStyle: "long",
      timeStyle: "long"
    }) : a(Ue(p), {
      dateStyle: "long"
    });
  }
  function o(p, f = {}) {
    return new yt(t.value, { month: "long", year: "numeric", ...f }).format(p);
  }
  function i(p, f = {}) {
    return new yt(t.value, { month: "long", ...f }).format(p);
  }
  function l() {
    const p = sc(rn());
    return [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map((f) => ({ label: i(Ue(p.set({ month: f }))), value: f }));
  }
  function s(p, f = {}) {
    return new yt(t.value, { year: "numeric", ...f }).format(p);
  }
  function u(p, f) {
    return Ha(p) ? new yt(t.value, {
      ...f,
      timeZone: p.timeZone
    }).formatToParts(Ue(p)) : new yt(t.value, f).formatToParts(Ue(p));
  }
  function $(p, f = "narrow") {
    return new yt(t.value, { weekday: f }).format(p);
  }
  function y(p) {
    var f;
    return ((f = new yt(t.value, {
      hour: "numeric",
      minute: "numeric"
    }).formatToParts(p).find((v) => v.type === "dayPeriod")) == null ? void 0 : f.value) === "PM" ? "PM" : "AM";
  }
  const h = {
    year: "numeric",
    month: "numeric",
    day: "numeric",
    hour: "numeric",
    minute: "numeric",
    second: "numeric"
  };
  function c(p, f, v = {}) {
    const w = { ...h, ...v }, m = u(p, w).find((b) => b.type === f);
    return m ? m.value : "";
  }
  return {
    setLocale: n,
    getLocale: r,
    fullMonth: i,
    fullYear: s,
    fullMonthAndYear: o,
    toParts: u,
    custom: a,
    part: c,
    dayPeriod: y,
    selectedDate: d,
    dayOfWeek: $,
    getMonths: l
  };
}
function qn(e) {
  const t = A5({
    dir: H("ltr")
  });
  return O(() => {
    var r;
    return (e == null ? void 0 : e.value) || ((r = t.dir) == null ? void 0 : r.value) || "ltr";
  });
}
function Uc(e) {
  return O(() => {
    var t;
    return Bc(e) ? !!((t = zn(e)) != null && t.closest("form")) : !0;
  });
}
function ht() {
  const e = Jr(), t = H(), r = O(() => {
    var o, i;
    return ["#text", "#comment"].includes((o = t.value) == null ? void 0 : o.$el.nodeName) ? (i = t.value) == null ? void 0 : i.$el.nextElementSibling : zn(t);
  }), n = Object.assign({}, e.exposed), a = {};
  for (const o in e.props)
    Object.defineProperty(a, o, {
      enumerable: !0,
      configurable: !0,
      get: () => e.props[o]
    });
  if (Object.keys(n).length > 0)
    for (const o in n)
      Object.defineProperty(a, o, {
        enumerable: !0,
        configurable: !0,
        get: () => n[o]
      });
  Object.defineProperty(a, "$el", {
    enumerable: !0,
    configurable: !0,
    get: () => e.vnode.el
  }), e.exposed = a;
  function d(o) {
    t.value = o, o && (Object.defineProperty(a, "$el", {
      enumerable: !0,
      configurable: !0,
      get: () => o instanceof Element ? o : o.$el
    }), e.exposed = a);
  }
  return { forwardRef: d, currentRef: t, currentElement: r };
}
function E5(e) {
  const t = H(), r = O(() => {
    var a;
    return ((a = t.value) == null ? void 0 : a.width) ?? 0;
  }), n = O(() => {
    var a;
    return ((a = t.value) == null ? void 0 : a.height) ?? 0;
  });
  return He(() => {
    const a = zn(e);
    if (a) {
      t.value = { width: a.offsetWidth, height: a.offsetHeight };
      const d = new ResizeObserver((o) => {
        if (!Array.isArray(o) || !o.length)
          return;
        const i = o[0];
        let l, s;
        if ("borderBoxSize" in i) {
          const u = i.borderBoxSize, $ = Array.isArray(u) ? u[0] : u;
          l = $.inlineSize, s = $.blockSize;
        } else
          l = a.offsetWidth, s = a.offsetHeight;
        t.value = { width: l, height: s };
      });
      return d.observe(a, { box: "border-box" }), () => d.unobserve(a);
    } else
      t.value = void 0;
  }), {
    width: r,
    height: n
  };
}
function M5(e, t) {
  const r = H(e);
  function n(a) {
    return t[r.value][a] ?? r.value;
  }
  return {
    state: r,
    dispatch: (a) => {
      r.value = n(a);
    }
  };
}
function nn() {
  return {
    ALT: "Alt",
    ARROW_DOWN: "ArrowDown",
    ARROW_LEFT: "ArrowLeft",
    ARROW_RIGHT: "ArrowRight",
    ARROW_UP: "ArrowUp",
    BACKSPACE: "Backspace",
    CAPS_LOCK: "CapsLock",
    CONTROL: "Control",
    DELETE: "Delete",
    END: "End",
    ENTER: "Enter",
    ESCAPE: "Escape",
    F1: "F1",
    F10: "F10",
    F11: "F11",
    F12: "F12",
    F2: "F2",
    F3: "F3",
    F4: "F4",
    F5: "F5",
    F6: "F6",
    F7: "F7",
    F8: "F8",
    F9: "F9",
    HOME: "Home",
    META: "Meta",
    PAGE_DOWN: "PageDown",
    PAGE_UP: "PageUp",
    SHIFT: "Shift",
    SPACE: " ",
    TAB: "Tab",
    CTRL: "Control",
    ASTERISK: "*",
    SPACE_CODE: "Space"
  };
}
const Ii = V({
  name: "PrimitiveSlot",
  inheritAttrs: !1,
  setup(e, { attrs: t, slots: r }) {
    return () => {
      var n, a;
      if (!r.default)
        return null;
      const d = ki(r.default()), o = d.findIndex((u) => u.type !== j2);
      if (o === -1)
        return d;
      const i = d[o];
      (n = i.props) == null || delete n.ref;
      const l = i.props ? me(t, i.props) : t;
      t.class && (a = i.props) != null && a.class && delete i.props.class;
      const s = G2(i, l);
      for (const u in l)
        u.startsWith("on") && (s.props || (s.props = {}), s.props[u] = l[u]);
      return d.length === 1 ? s : (d[o] = s, d);
    };
  }
}), ue = V({
  name: "Primitive",
  inheritAttrs: !1,
  props: {
    asChild: {
      type: Boolean,
      default: !1
    },
    as: {
      type: [String, Object],
      default: "div"
    }
  },
  setup(e, { attrs: t, slots: r }) {
    const n = e.asChild ? "template" : e.as;
    return typeof n == "string" && ["area", "img", "input"].includes(n) ? () => mr(n, t) : n !== "template" ? () => mr(e.as, t, { default: r.default }) : () => mr(Ii, t, { default: r.default });
  }
});
function nr() {
  const e = H(), t = O(() => {
    var r, n;
    return ["#text", "#comment"].includes((r = e.value) == null ? void 0 : r.$el.nodeName) ? (n = e.value) == null ? void 0 : n.$el.nextElementSibling : zn(e);
  });
  return {
    primitiveElement: e,
    currentElement: t
  };
}
function O5(e, t) {
  var r;
  const n = H({}), a = H("none"), d = H(e), o = e.value ? "mounted" : "unmounted";
  let i;
  const l = ((r = t.value) == null ? void 0 : r.ownerDocument.defaultView) ?? w5, { state: s, dispatch: u } = M5(o, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  }), $ = (f) => {
    var v;
    if (Vc) {
      const w = new CustomEvent(f, { bubbles: !1, cancelable: !1 });
      (v = t.value) == null || v.dispatchEvent(w);
    }
  };
  K(
    e,
    async (f, v) => {
      var w;
      const m = v !== f;
      if (await tt(), m) {
        const b = a.value, _ = ia(t.value);
        f ? (u("MOUNT"), $("enter"), _ === "none" && $("after-enter")) : _ === "none" || ((w = n.value) == null ? void 0 : w.display) === "none" ? (u("UNMOUNT"), $("leave"), $("after-leave")) : v && b !== _ ? (u("ANIMATION_OUT"), $("leave")) : (u("UNMOUNT"), $("after-leave"));
      }
    },
    { immediate: !0 }
  );
  const y = (f) => {
    const v = ia(t.value), w = v.includes(
      f.animationName
    ), m = s.value === "mounted" ? "enter" : "leave";
    if (f.target === t.value && w && ($(`after-${m}`), u("ANIMATION_END"), !d.value)) {
      const b = t.value.style.animationFillMode;
      t.value.style.animationFillMode = "forwards", i = l == null ? void 0 : l.setTimeout(() => {
        var _;
        ((_ = t.value) == null ? void 0 : _.style.animationFillMode) === "forwards" && (t.value.style.animationFillMode = b);
      });
    }
    f.target === t.value && v === "none" && u("ANIMATION_END");
  }, h = (f) => {
    f.target === t.value && (a.value = ia(t.value));
  }, c = K(
    t,
    (f, v) => {
      f ? (n.value = getComputedStyle(f), f.addEventListener("animationstart", h), f.addEventListener("animationcancel", y), f.addEventListener("animationend", y)) : (u("ANIMATION_END"), i !== void 0 && (l == null || l.clearTimeout(i)), v == null || v.removeEventListener("animationstart", h), v == null || v.removeEventListener("animationcancel", y), v == null || v.removeEventListener("animationend", y));
    },
    { immediate: !0 }
  ), p = K(s, () => {
    const f = ia(t.value);
    a.value = s.value === "mounted" ? f : "none";
  });
  return Qr(() => {
    c(), p();
  }), {
    isPresent: O(
      () => ["mounted", "unmountSuspended"].includes(s.value)
    )
  };
}
function ia(e) {
  return e && getComputedStyle(e).animationName || "none";
}
V({
  name: "Presence",
  props: {
    present: {
      type: Boolean,
      required: !0
    },
    forceMount: {
      type: Boolean
    }
  },
  slots: {},
  setup(e, { slots: t, expose: r }) {
    var n;
    const { present: a, forceMount: d } = kt(e), o = H(), { isPresent: i } = O5(a, o);
    r({ present: i });
    let l = t.default({ present: i });
    l = ki(l || []);
    const s = Jr();
    if (l && (l == null ? void 0 : l.length) > 1) {
      const u = (n = s == null ? void 0 : s.parent) != null && n.type.name ? `<${s.parent.type.name} />` : "component";
      throw new Error(
        [
          `Detected an invalid children for \`${u}\` for  \`Presence\` component.`,
          "",
          "Note: Presence works similarly to `v-if` directly, but it waits for animation/transition to finished before unmounting. So it expect only one direct child of valid VNode type.",
          "You can apply a few solutions:",
          [
            "Provide a single child element so that `presence` directive attach correctly.",
            "Ensure the first child is an actual element instead of a raw text node or comment node."
          ].map(($) => `  - ${$}`).join(`
`)
        ].join(`
`)
      );
    }
    return () => d.value || a.value || i.value ? mr(t.default({ present: i })[0], {
      ref: (u) => {
        const $ = zn(u);
        return typeof ($ == null ? void 0 : $.hasAttribute) > "u" || ($ != null && $.hasAttribute("data-radix-popper-content-wrapper") ? o.value = $.firstElementChild : o.value = $), $;
      }
    }) : null;
  }
});
Gn({
  layersRoot: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
});
g5(() => H([]));
function T5(e) {
  function t(n) {
    return Array.isArray(e.date.value) ? e.date.value.some((a) => Ne(a, n)) : e.date.value ? Ne(e.date.value, n) : !1;
  }
  const r = O(
    () => {
      var n, a, d, o;
      if (Array.isArray(e.date.value)) {
        if (!e.date.value.length)
          return !1;
        for (const i of e.date.value)
          if ((n = e.isDateDisabled) != null && n.call(e, i) || (a = e.isDateUnavailable) != null && a.call(e, i))
            return !0;
      } else {
        if (!e.date.value)
          return !1;
        if ((d = e.isDateDisabled) != null && d.call(e, e.date.value) || (o = e.isDateUnavailable) != null && o.call(e, e.date.value))
          return !0;
      }
      return !1;
    }
  );
  return {
    isDateSelected: t,
    isInvalid: r
  };
}
function k5(e, t) {
  const r = t(e), n = r.compare(e), a = {};
  return n >= 7 && (a.day = 1), n >= qe(e) && (a.month = 1), r.set({ ...a });
}
function I5(e, t) {
  const r = t(e), n = e.compare(r), a = {};
  return n >= 7 && (a.day = 35), n >= qe(e) && (a.month = 13), r.set({ ...a });
}
function R5(e, t) {
  return t(e);
}
function D5(e, t) {
  return t(e);
}
function Hc(e) {
  const t = Gc(e.locale.value), r = O(() => {
    const p = {
      calendar: e.placeholder.value.calendar.identifier
    };
    return e.placeholder.value.calendar.identifier === "gregory" && e.placeholder.value.era === "BC" && (p.era = "short"), p;
  }), n = H(sr({
    dateObj: e.placeholder.value,
    weekStartsOn: e.weekStartsOn.value,
    locale: e.locale.value,
    fixedWeeks: e.fixedWeeks.value,
    numberOfMonths: e.numberOfMonths.value
  })), a = O(() => n.value.map((p) => p.value));
  function d(p) {
    return !a.value.some((f) => cs(p, f));
  }
  const o = (p = "month", f) => {
    if (!e.maxValue.value || !n.value.length)
      return !1;
    if (e.disabled.value)
      return !0;
    const v = n.value[n.value.length - 1].value;
    if (f || e.nextPage.value) {
      const m = k5(v, f || e.nextPage.value);
      return vn(m, e.maxValue.value);
    }
    if (p === "year") {
      const m = v.add({ years: 1 }).set({ day: 1, month: 1 });
      return vn(m, e.maxValue.value);
    }
    const w = v.add({ months: 1 }).set({ day: 1 });
    return vn(w, e.maxValue.value);
  }, i = (p = "month", f) => {
    if (!e.minValue.value || !n.value.length)
      return !1;
    if (e.disabled.value)
      return !0;
    const v = n.value[0].value;
    if (f || e.prevPage.value) {
      const m = I5(v, f || e.prevPage.value);
      return lt(m, e.minValue.value);
    }
    if (p === "year") {
      const m = v.subtract({ years: 1 }).set({ day: 35, month: 13 });
      return lt(m, e.minValue.value);
    }
    const w = v.subtract({ months: 1 }).set({ day: 35 });
    return lt(w, e.minValue.value);
  };
  function l(p) {
    var f;
    return !!((f = e.isDateDisabled) != null && f.call(e, p) || e.disabled.value || e.maxValue.value && vn(p, e.maxValue.value) || e.minValue.value && lt(p, e.minValue.value));
  }
  const s = (p) => {
    var f;
    return !!((f = e.isDateUnavailable) != null && f.call(e, p));
  }, u = O(() => n.value.length ? n.value[0].rows[0].map((p) => t.dayOfWeek(Ue(p), e.weekdayFormat.value)) : []), $ = (p = "month", f) => {
    const v = n.value[0].value;
    if (f || e.nextPage.value) {
      const b = R5(v, f || e.nextPage.value), _ = sr({
        dateObj: b,
        weekStartsOn: e.weekStartsOn.value,
        locale: e.locale.value,
        fixedWeeks: e.fixedWeeks.value,
        numberOfMonths: e.numberOfMonths.value
      });
      n.value = _;
      const x = {};
      if (!f) {
        const A = _[0].value.compare(v);
        A >= qe(v) && (x.day = 1), A >= 365 && (x.month = 1);
      }
      e.placeholder.value = _[0].value.set({ ...x });
      return;
    }
    const w = p === "month" ? v.add({ months: e.pagedNavigation.value ? e.numberOfMonths.value : 1 }) : v.add({ years: 1 }), m = sr({
      dateObj: w,
      weekStartsOn: e.weekStartsOn.value,
      locale: e.locale.value,
      fixedWeeks: e.fixedWeeks.value,
      numberOfMonths: e.numberOfMonths.value
    });
    n.value = m, e.placeholder.value = m[0].value.set({ day: 1 });
  }, y = (p = "month", f) => {
    const v = n.value[0].value;
    if (f || e.prevPage.value) {
      const b = D5(v, f || e.prevPage.value), _ = sr({
        dateObj: b,
        weekStartsOn: e.weekStartsOn.value,
        locale: e.locale.value,
        fixedWeeks: e.fixedWeeks.value,
        numberOfMonths: e.numberOfMonths.value
      });
      n.value = _;
      const x = {};
      if (!f) {
        const A = v.compare(_[0].value);
        A >= qe(v) && (x.day = 1), A >= 365 && (x.month = 1);
      }
      e.placeholder.value = _[0].value.set({ ...x });
      return;
    }
    const w = p === "month" ? v.subtract({ months: e.pagedNavigation.value ? e.numberOfMonths.value : 1 }) : v.subtract({ years: 1 }), m = sr({
      dateObj: w,
      weekStartsOn: e.weekStartsOn.value,
      locale: e.locale.value,
      fixedWeeks: e.fixedWeeks.value,
      numberOfMonths: e.numberOfMonths.value
    });
    n.value = m, e.placeholder.value = m[0].value.set({ day: 1 });
  };
  K(e.placeholder, (p) => {
    a.value.some((f) => cs(f, p)) || (n.value = sr({
      dateObj: p,
      weekStartsOn: e.weekStartsOn.value,
      locale: e.locale.value,
      fixedWeeks: e.fixedWeeks.value,
      numberOfMonths: e.numberOfMonths.value
    }));
  }), K([e.locale, e.weekStartsOn, e.fixedWeeks, e.numberOfMonths], () => {
    n.value = sr({
      dateObj: e.placeholder.value,
      weekStartsOn: e.weekStartsOn.value,
      locale: e.locale.value,
      fixedWeeks: e.fixedWeeks.value,
      numberOfMonths: e.numberOfMonths.value
    });
  });
  const h = O(() => {
    if (!n.value.length)
      return "";
    if (e.locale.value !== t.getLocale() && t.setLocale(e.locale.value), n.value.length === 1) {
      const _ = n.value[0].value;
      return `${t.fullMonthAndYear(Ue(_), r.value)}`;
    }
    const p = Ue(n.value[0].value), f = Ue(n.value[n.value.length - 1].value), v = t.fullMonth(p, r.value), w = t.fullMonth(f, r.value), m = t.fullYear(p, r.value), b = t.fullYear(f, r.value);
    return m === b ? `${v} - ${w} ${b}` : `${v} ${m} - ${w} ${b}`;
  }), c = O(() => `${e.calendarLabel.value ?? "Event Date"}, ${h.value}`);
  return {
    isDateDisabled: l,
    isDateUnavailable: s,
    isNextButtonDisabled: o,
    isPrevButtonDisabled: i,
    grid: n,
    weekdays: u,
    visibleView: a,
    isOutsideVisibleView: d,
    formatter: t,
    nextPage: $,
    prevPage: y,
    headingValue: h,
    fullCalendarLabel: c
  };
}
const N5 = { style: { border: "0px", clip: "rect(0px, 0px, 0px, 0px)", "clip-path": "inset(50%)", height: "1px", margin: "-1px", overflow: "hidden", padding: "0px", position: "absolute", "white-space": "nowrap", width: "1px" } }, F5 = {
  role: "heading",
  "aria-level": "2"
}, [an, L5] = Rt("CalendarRoot"), B5 = /* @__PURE__ */ V({
  __name: "CalendarRoot",
  props: {
    modelValue: {},
    multiple: { type: Boolean, default: !1 },
    defaultValue: { default: void 0 },
    defaultPlaceholder: {},
    placeholder: { default: void 0 },
    pagedNavigation: { type: Boolean, default: !1 },
    preventDeselect: { type: Boolean, default: !1 },
    weekStartsOn: { default: 0 },
    weekdayFormat: { default: "narrow" },
    calendarLabel: {},
    fixedWeeks: { type: Boolean, default: !1 },
    maxValue: {},
    minValue: {},
    locale: { default: "en" },
    numberOfMonths: { default: 1 },
    disabled: { type: Boolean, default: !1 },
    readonly: { type: Boolean, default: !1 },
    initialFocus: { type: Boolean, default: !1 },
    isDateDisabled: { type: Function, default: void 0 },
    isDateUnavailable: { type: Function, default: void 0 },
    dir: {},
    nextPage: {},
    prevPage: {},
    asChild: { type: Boolean },
    as: { default: "div" }
  },
  emits: ["update:modelValue", "update:placeholder"],
  setup(e, { emit: t }) {
    const r = e, n = t, {
      locale: a,
      disabled: d,
      readonly: o,
      initialFocus: i,
      pagedNavigation: l,
      weekStartsOn: s,
      weekdayFormat: u,
      fixedWeeks: $,
      multiple: y,
      minValue: h,
      maxValue: c,
      numberOfMonths: p,
      preventDeselect: f,
      isDateDisabled: v,
      isDateUnavailable: w,
      calendarLabel: m,
      defaultValue: b,
      nextPage: _,
      prevPage: x,
      dir: A
    } = kt(r), { primitiveElement: P, currentElement: k } = nr(), R = qn(A), L = Et(r, "modelValue", n, {
      defaultValue: b.value,
      passive: r.modelValue === void 0
    }), N = Oi({
      defaultPlaceholder: r.placeholder,
      defaultValue: L.value,
      locale: r.locale
    }), U = Et(r, "placeholder", n, {
      defaultValue: r.defaultPlaceholder ?? N.copy(),
      passive: r.placeholder === void 0
    });
    function G(W) {
      U.value = W.copy();
    }
    const {
      fullCalendarLabel: Y,
      headingValue: te,
      isDateDisabled: re,
      isDateUnavailable: M,
      isNextButtonDisabled: X,
      isPrevButtonDisabled: ee,
      weekdays: Se,
      isOutsideVisibleView: he,
      nextPage: ve,
      prevPage: _e,
      formatter: Re,
      grid: ke
    } = Hc({
      locale: a,
      placeholder: U,
      weekStartsOn: s,
      fixedWeeks: $,
      numberOfMonths: p,
      minValue: h,
      maxValue: c,
      disabled: d,
      weekdayFormat: u,
      pagedNavigation: l,
      isDateDisabled: v.value,
      isDateUnavailable: w.value,
      calendarLabel: m,
      nextPage: _,
      prevPage: x
    }), {
      isInvalid: ce,
      isDateSelected: Le
    } = T5({
      date: L,
      isDateDisabled: re,
      isDateUnavailable: M
    });
    K(L, (W) => {
      if (Array.isArray(W) && W.length) {
        const oe = W[W.length - 1];
        oe && !it(U.value, oe) && G(oe);
      } else !Array.isArray(W) && W && !it(U.value, W) && G(W);
    });
    function ge(W) {
      if (y.value) {
        if (!L.value)
          L.value = [W.copy()];
        else if (Array.isArray(L.value)) {
          if (L.value.findIndex((oe) => Ne(oe, W)) === -1)
            L.value = [...L.value, W];
          else if (!f.value) {
            const oe = L.value.filter((ie) => !Ne(ie, W));
            if (!oe.length) {
              U.value = W.copy(), L.value = void 0;
              return;
            }
            L.value = oe.map((ie) => ie.copy());
          }
        }
      } else {
        if (!L.value) {
          L.value = W.copy();
          return;
        }
        !f.value && it(L.value, W) ? (U.value = W.copy(), L.value = void 0) : L.value = W.copy();
      }
    }
    return He(() => {
      i.value && Lc(k.value);
    }), L5({
      isDateUnavailable: M,
      dir: R,
      isDateDisabled: re,
      locale: a,
      formatter: Re,
      modelValue: L,
      placeholder: U,
      disabled: d,
      initialFocus: i,
      pagedNavigation: l,
      weekStartsOn: s,
      weekdayFormat: u,
      fixedWeeks: $,
      multiple: y,
      numberOfMonths: p,
      readonly: o,
      preventDeselect: f,
      fullCalendarLabel: Y,
      headingValue: te,
      isInvalid: ce,
      isDateSelected: Le,
      isNextButtonDisabled: X,
      isPrevButtonDisabled: ee,
      isOutsideVisibleView: he,
      nextPage: ve,
      prevPage: _e,
      parentElement: k,
      onPlaceholderChange: G,
      onDateChange: ge
    }), (W, oe) => (S(), B(g(ue), {
      ref_key: "primitiveElement",
      ref: P,
      as: W.as,
      "as-child": W.asChild,
      role: "application",
      "aria-label": g(Y),
      "data-readonly": g(o) ? "" : void 0,
      "data-disabled": g(d) ? "" : void 0,
      "data-invalid": g(ce) ? "" : void 0,
      dir: g(R)
    }, {
      default: D(() => [
        F(W.$slots, "default", {
          date: g(U),
          grid: g(ke),
          weekDays: g(Se),
          weekStartsOn: g(s),
          locale: g(a),
          fixedWeeks: g($)
        }),
        C("div", N5, [
          C("div", F5, Q(g(Y)), 1)
        ])
      ]),
      _: 3
    }, 8, ["as", "as-child", "aria-label", "data-readonly", "data-disabled", "data-invalid", "dir"]));
  }
}), V5 = /* @__PURE__ */ V({
  __name: "CalendarHeader",
  props: {
    asChild: { type: Boolean },
    as: { default: "div" }
  },
  setup(e) {
    const t = e;
    return (r, n) => (S(), B(g(ue), Ot(Tt(t)), {
      default: D(() => [
        F(r.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), j5 = /* @__PURE__ */ V({
  __name: "CalendarHeading",
  props: {
    asChild: { type: Boolean },
    as: { default: "div" }
  },
  setup(e) {
    const t = e, r = an();
    return (n, a) => (S(), B(g(ue), me(t, {
      "data-disabled": g(r).disabled.value ? "" : void 0
    }), {
      default: D(() => [
        F(n.$slots, "default", {
          headingValue: g(r).headingValue.value
        }, () => [
          Me(Q(g(r).headingValue.value), 1)
        ])
      ]),
      _: 3
    }, 16, ["data-disabled"]));
  }
}), G5 = /* @__PURE__ */ V({
  __name: "CalendarGrid",
  props: {
    asChild: { type: Boolean },
    as: { default: "table" }
  },
  setup(e) {
    const t = e, r = an(), n = O(() => r.disabled.value ? !0 : void 0), a = O(() => r.readonly.value ? !0 : void 0);
    return (d, o) => (S(), B(g(ue), me(t, {
      tabindex: "-1",
      role: "grid",
      "aria-readonly": a.value,
      "aria-disabled": n.value,
      "data-readonly": a.value && "",
      "data-disabled": n.value && ""
    }), {
      default: D(() => [
        F(d.$slots, "default")
      ]),
      _: 3
    }, 16, ["aria-readonly", "aria-disabled", "data-readonly", "data-disabled"]));
  }
}), U5 = /* @__PURE__ */ V({
  __name: "CalendarCell",
  props: {
    date: {},
    asChild: { type: Boolean },
    as: { default: "td" }
  },
  setup(e) {
    const t = an();
    return (r, n) => {
      var a, d;
      return S(), B(g(ue), {
        as: r.as,
        "as-child": r.asChild,
        role: "gridcell",
        "aria-selected": g(t).isDateSelected(r.date) ? !0 : void 0,
        "aria-disabled": g(t).isDateDisabled(r.date) || ((d = (a = g(t)).isDateUnavailable) == null ? void 0 : d.call(a, r.date)),
        "data-disabled": g(t).isDateDisabled(r.date) ? "" : void 0
      }, {
        default: D(() => [
          F(r.$slots, "default")
        ]),
        _: 3
      }, 8, ["as", "as-child", "aria-selected", "aria-disabled", "data-disabled"]);
    };
  }
}), H5 = /* @__PURE__ */ V({
  __name: "CalendarHeadCell",
  props: {
    asChild: { type: Boolean },
    as: { default: "th" }
  },
  setup(e) {
    const t = e;
    return (r, n) => (S(), B(g(ue), Ot(Tt(t)), {
      default: D(() => [
        F(r.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), js = /* @__PURE__ */ V({
  __name: "CalendarNext",
  props: {
    step: { default: "month" },
    nextPage: {},
    asChild: { type: Boolean },
    as: { default: "button" }
  },
  setup(e) {
    const t = e, r = O(() => n.disabled.value || n.isNextButtonDisabled(t.step, t.nextPage)), n = an();
    return (a, d) => (S(), B(g(ue), {
      as: t.as,
      "as-child": t.asChild,
      "aria-label": "Next page",
      type: a.as === "button" ? "button" : void 0,
      "aria-disabled": r.value || void 0,
      "data-disabled": r.value || void 0,
      disabled: r.value,
      onClick: d[0] || (d[0] = (o) => g(n).nextPage(t.step, t.nextPage))
    }, {
      default: D(() => [
        F(a.$slots, "default", {}, () => [
          Me("Next page")
        ])
      ]),
      _: 3
    }, 8, ["as", "as-child", "type", "aria-disabled", "data-disabled", "disabled"]));
  }
}), Gs = /* @__PURE__ */ V({
  __name: "CalendarPrev",
  props: {
    step: { default: "month" },
    prevPage: {},
    asChild: { type: Boolean },
    as: { default: "button" }
  },
  setup(e) {
    const t = e, r = O(() => n.disabled.value || n.isPrevButtonDisabled(t.step, t.prevPage)), n = an();
    return (a, d) => (S(), B(g(ue), {
      "aria-label": "Previous page",
      as: t.as,
      "as-child": t.asChild,
      type: a.as === "button" ? "button" : void 0,
      "aria-disabled": r.value || void 0,
      "data-disabled": r.value || void 0,
      disabled: r.value,
      onClick: d[0] || (d[0] = (o) => g(n).prevPage(t.step, t.prevPage))
    }, {
      default: D(() => [
        F(a.$slots, "default", {}, () => [
          Me("Prev page")
        ])
      ]),
      _: 3
    }, 8, ["as", "as-child", "type", "aria-disabled", "data-disabled", "disabled"]));
  }
}), W5 = /* @__PURE__ */ V({
  __name: "CalendarGridHead",
  props: {
    asChild: { type: Boolean },
    as: { default: "thead" }
  },
  setup(e) {
    const t = e;
    return (r, n) => (S(), B(g(ue), me(t, { "aria-hidden": "true" }), {
      default: D(() => [
        F(r.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), z5 = /* @__PURE__ */ V({
  __name: "CalendarGridBody",
  props: {
    asChild: { type: Boolean },
    as: { default: "tbody" }
  },
  setup(e) {
    const t = e;
    return (r, n) => (S(), B(g(ue), Ot(Tt(t)), {
      default: D(() => [
        F(r.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), Us = /* @__PURE__ */ V({
  __name: "CalendarGridRow",
  props: {
    asChild: { type: Boolean },
    as: { default: "tr" }
  },
  setup(e) {
    const t = e;
    return (r, n) => (S(), B(g(ue), Ot(Tt(t)), {
      default: D(() => [
        F(r.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), q5 = /* @__PURE__ */ V({
  __name: "CalendarCellTrigger",
  props: {
    day: {},
    month: {},
    asChild: { type: Boolean },
    as: { default: "div" }
  },
  setup(e) {
    const t = e, r = nn(), n = an(), { primitiveElement: a, currentElement: d } = nr(), o = O(() => t.day.day.toLocaleString(n.locale.value)), i = O(() => n.formatter.custom(Ue(t.day), {
      weekday: "long",
      month: "long",
      day: "numeric",
      year: "numeric"
    })), l = O(() => n.isDateDisabled(t.day)), s = O(
      () => {
        var m;
        return (m = n.isDateUnavailable) == null ? void 0 : m.call(n, t.day);
      }
    ), u = O(() => ic(t.day, rn())), $ = O(() => !wi(t.day, t.month)), y = O(
      () => n.isOutsideVisibleView(t.day)
    ), h = O(() => !n.disabled.value && Ne(t.day, n.placeholder.value)), c = O(() => n.isDateSelected(t.day)), p = "[data-radix-vue-calendar-cell-trigger]:not([data-disabled]):not([data-outside-view]):not([data-outside-visible-view])";
    function f(m) {
      var b;
      n.readonly.value || n.isDateDisabled(m) || (b = n.isDateUnavailable) != null && b.call(n, m) || n.onDateChange(m);
    }
    function v() {
      f(t.day);
    }
    function w(m) {
      m.preventDefault(), m.stopPropagation();
      const b = n.parentElement.value, _ = b ? Array.from(b.querySelectorAll(p)) : [];
      let x = _.indexOf(d.value);
      const A = 7, P = n.dir.value === "rtl" ? -1 : 1;
      switch (m.code) {
        case r.ARROW_RIGHT:
          x += P;
          break;
        case r.ARROW_LEFT:
          x -= P;
          break;
        case r.ARROW_UP:
          x -= A;
          break;
        case r.ARROW_DOWN:
          x += A;
          break;
        case r.ENTER:
        case r.SPACE_CODE:
          f(t.day);
          return;
        default:
          return;
      }
      if (x >= 0 && x < _.length) {
        _[x].focus();
        return;
      }
      if (x < 0) {
        if (n.isPrevButtonDisabled("month"))
          return;
        n.prevPage(), tt(() => {
          const k = b ? Array.from(b.querySelectorAll(p)) : [];
          if (!n.pagedNavigation.value) {
            const R = qe(n.placeholder.value);
            k[R - Math.abs(x)].focus();
            return;
          }
          k[k.length - Math.abs(x)].focus();
        });
        return;
      }
      if (x >= _.length) {
        if (n.isNextButtonDisabled("month"))
          return;
        n.nextPage(), tt(() => {
          const k = b ? Array.from(b.querySelectorAll(p)) : [];
          if (!n.pagedNavigation.value) {
            const R = qe(n.placeholder.value.add({ months: n.numberOfMonths.value - 1 }));
            k[k.length - R + x - _.length].focus();
            return;
          }
          k[x - _.length].focus();
        });
      }
    }
    return (m, b) => (S(), B(g(ue), me({
      ref_key: "primitiveElement",
      ref: a
    }, t, {
      role: "button",
      "aria-label": i.value,
      "data-radix-vue-calendar-cell-trigger": "",
      "aria-disabled": l.value || s.value ? !0 : void 0,
      "data-selected": c.value ? !0 : void 0,
      "data-value": m.day.toString(),
      "data-disabled": l.value ? "" : void 0,
      "data-unavailable": s.value ? "" : void 0,
      "data-today": u.value ? "" : void 0,
      "data-outside-view": $.value ? "" : void 0,
      "data-outside-visible-view": y.value ? "" : void 0,
      "data-focused": h.value ? "" : void 0,
      tabindex: h.value ? 0 : $.value || l.value ? void 0 : -1,
      onClick: v,
      onKeydown: [
        Pt(w, ["up", "down", "left", "right", "space", "enter"]),
        b[0] || (b[0] = Pt(Jt(() => {
        }, ["prevent"]), ["enter"]))
      ]
    }), {
      default: D(() => [
        F(m.$slots, "default", { dayValue: o.value }, () => [
          Me(Q(o.value), 1)
        ])
      ]),
      _: 3
    }, 16, ["aria-label", "aria-disabled", "data-selected", "data-value", "data-disabled", "data-unavailable", "data-today", "data-outside-view", "data-outside-visible-view", "data-focused", "tabindex"]));
  }
}), K5 = "data-radix-vue-collection-item", [Ri, Y5] = Rt("CollectionProvider");
function Z5(e = K5) {
  const t = H(/* @__PURE__ */ new Map()), r = H(), n = Y5({
    collectionRef: r,
    itemMap: t,
    attrName: e
  }), { getItems: a } = Wc(n), d = O(() => Array.from(n.itemMap.value.values())), o = O(() => n.itemMap.value.size);
  return { getItems: a, reactiveItems: d, itemMapSize: o };
}
const J5 = V({
  name: "CollectionSlot",
  setup(e, { slots: t }) {
    const r = Ri(), { primitiveElement: n, currentElement: a } = nr();
    return K(a, () => {
      r.collectionRef.value = a.value;
    }), () => mr(Ii, { ref: n }, t);
  }
}), Q5 = V({
  name: "CollectionItem",
  inheritAttrs: !1,
  props: {
    value: {
      // It accepts any value
      validator: () => !0
    }
  },
  setup(e, { slots: t, attrs: r }) {
    const n = Ri(), { primitiveElement: a, currentElement: d } = nr();
    return ui((o) => {
      if (d.value) {
        const i = ye(d.value);
        n.itemMap.value.set(i, { ref: d.value, value: e.value }), o(() => n.itemMap.value.delete(i));
      }
    }), () => mr(Ii, { ...r, [n.attrName]: "", ref: a }, t);
  }
});
function Wc(e) {
  const t = e ?? Ri();
  return { getItems: () => {
    const r = t.collectionRef.value;
    if (!r)
      return [];
    const n = Array.from(r.querySelectorAll(`[${t.attrName}]`));
    return Array.from(t.itemMap.value.values()).sort(
      (a, d) => n.indexOf(a.ref) - n.indexOf(d.ref)
    );
  } };
}
const X5 = ["hour", "minute", "second"];
function Hs(e) {
  const { formatter: t } = e, r = Ti.map((n) => [n, e.value[n]]);
  if ("hour" in e.value) {
    const n = Dc.map((d) => d === "dayPeriod" ? [d, t.dayPeriod(Ue(e.value))] : [d, e.value[d]]), a = [...r, ...n];
    return Object.fromEntries(a);
  }
  return Object.fromEntries(r);
}
function e7(e) {
  const t = Nc.map((r) => r === "dayPeriod" ? [r, "AM"] : [r, null]).filter(([r]) => r === "literal" || r === null || e === "minute" && r === "second" || e === "hour" && (r === "second" || r === "minute") ? !1 : e === "day" ? !X5.includes(r) && r !== "dayPeriod" : !0);
  return Object.fromEntries(t);
}
function t7(e) {
  const { segmentValues: t, formatter: r, locale: n } = e;
  function a(d) {
    if ("hour" in t) {
      const o = t[d];
      return o !== null ? d === "day" && t.month !== null ? r.part(e.dateRef.set({ [d]: o, month: t.month }), d, {
        hourCycle: e.hourCycle === 24 ? "h24" : void 0
      }) : r.part(e.dateRef.set({ [d]: o }), d, {
        hourCycle: e.hourCycle === 24 ? "h24" : void 0
      }) : Ad(d, "", n.value);
    } else {
      if (v5(d)) {
        const o = t[d];
        return o !== null ? d === "day" && t.month !== null ? r.part(e.dateRef.set({ [d]: o, month: t.month }), d) : r.part(e.dateRef.set({ [d]: o }), d) : Ad(d, "", n.value);
      }
      return "";
    }
  }
  return Object.keys(t).reduce((d, o) => {
    if (!Fc(o))
      return d;
    if ("hour" in t && o === "dayPeriod") {
      const i = t[o];
      i !== null ? d[o] = i : d[o] = Ad(o, "AM", n.value);
    } else
      d[o] = a(o);
    return d;
  }, {});
}
function r7(e) {
  const { granularity: t, formatter: r, contentObj: n, hideTimeZone: a, hourCycle: d } = e;
  return r.toParts(e.dateRef, y5(t, d)).map((o) => ["literal", "timeZoneName", null].includes(o.type) || !Fc(o.type) ? {
    part: o.type,
    value: o.value
  } : {
    part: o.type,
    value: n[o.type]
  }).filter((o) => !(o.part === null || o.value === null || o.part === "timeZoneName" && (!Ha(e.dateRef) || a)));
}
function n7(e) {
  const t = t7(e), r = r7({
    contentObj: t,
    ...e
  });
  return {
    obj: t,
    arr: r
  };
}
function Ut(e) {
  const t = nn();
  return e === t.ARROW_RIGHT || e === t.ARROW_LEFT;
}
function fr(e) {
  return !Number.isNaN(Number.parseInt(e));
}
function Bt(e) {
  const t = nn();
  return !!([
    t.ENTER,
    t.ARROW_UP,
    t.ARROW_DOWN,
    t.ARROW_LEFT,
    t.ARROW_RIGHT,
    t.BACKSPACE,
    t.SPACE,
    "a",
    "A",
    "p",
    "P"
  ].includes(e) || fr(e));
}
function Ws(e) {
  return Array.from(e.querySelectorAll("[data-radix-vue-date-field-segment]")).filter((t) => t.getAttribute("data-radix-vue-date-field-segment") !== "literal");
}
const a7 = ["id", "value", "name", "disabled", "required"], [d7, o7] = Rt("DateFieldRoot"), i7 = /* @__PURE__ */ V({
  inheritAttrs: !1,
  __name: "DateFieldRoot",
  props: {
    defaultValue: { default: void 0 },
    defaultPlaceholder: {},
    placeholder: { default: void 0 },
    modelValue: {},
    hourCycle: {},
    granularity: {},
    hideTimeZone: { type: Boolean },
    maxValue: {},
    minValue: {},
    locale: { default: "en" },
    disabled: { type: Boolean, default: !1 },
    readonly: { type: Boolean, default: !1 },
    isDateUnavailable: { type: Function, default: void 0 },
    name: {},
    required: { type: Boolean },
    id: {},
    dir: {},
    asChild: { type: Boolean },
    as: {}
  },
  emits: ["update:modelValue", "update:placeholder"],
  setup(e, { expose: t, emit: r }) {
    const n = e, a = r, { locale: d, disabled: o, readonly: i, isDateUnavailable: l, granularity: s, defaultValue: u, dir: $ } = kt(n), y = Gc(n.locale), h = qn($), { primitiveElement: c, currentElement: p } = nr(), f = H(/* @__PURE__ */ new Set());
    He(() => {
      Ws(p.value).forEach((M) => f.value.add(M));
    });
    const v = Et(n, "modelValue", a, {
      defaultValue: u.value,
      passive: n.modelValue === void 0
    }), w = Oi({
      defaultPlaceholder: n.placeholder,
      granularity: s.value,
      defaultValue: v.value,
      locale: n.locale
    }), m = Et(n, "placeholder", a, {
      defaultValue: n.defaultPlaceholder ?? w.copy(),
      passive: n.placeholder === void 0
    }), b = O(() => n.granularity ? Xo(m.value) ? n.granularity : "day" : Xo(m.value) ? "minute" : "day"), _ = O(() => {
      var M;
      return v.value ? !!((M = l.value) != null && M.call(l, v.value) || n.minValue && lt(v.value, n.minValue) || n.maxValue && lt(n.maxValue, v.value)) : !1;
    }), x = e7(b.value), A = H(v.value ? { ...Hs({ value: v.value, formatter: y }) } : { ...x }), P = O(() => n7({
      granularity: b.value,
      dateRef: m.value,
      formatter: y,
      hideTimeZone: n.hideTimeZone,
      hourCycle: n.hourCycle,
      segmentValues: A.value,
      locale: d
    })), k = O(() => P.value.arr), R = O(() => k.value.filter(({ part: M }) => M !== "literal"));
    K(d, (M) => {
      y.getLocale() !== M && (y.setLocale(M), tt(() => {
        f.value.clear(), Ws(p.value).forEach((X) => f.value.add(X));
      }));
    }), K(v, (M) => {
      !Bs(M) && m.value.compare(M) !== 0 && (m.value = M.copy());
    }), K([v, d], ([M]) => {
      Bs(M) ? Object.values(A.value).every((X) => X !== null) && M === void 0 && (A.value = { ...x }) : A.value = { ...Hs({ value: M, formatter: y }) };
    });
    const L = H(null), N = O(() => Array.from(f.value).findIndex((M) => {
      var X;
      return M.getAttribute("data-radix-vue-date-field-segment") === ((X = L.value) == null ? void 0 : X.getAttribute("data-radix-vue-date-field-segment"));
    })), U = O(() => {
      const M = h.value === "rtl" ? -1 : 1;
      return (M < 0 ? N.value < 0 : N.value > f.value.size - 1) ? null : Array.from(f.value)[N.value + M];
    }), G = O(() => {
      const M = h.value === "rtl" ? -1 : 1;
      return (M > 0 ? N.value < 0 : N.value > f.value.size - 1) ? null : Array.from(f.value)[N.value - M];
    }), Y = nn();
    function te(M) {
      var X, ee;
      Ut(M.key) && (M.key === Y.ARROW_LEFT && ((X = G.value) == null || X.focus()), M.key === Y.ARROW_RIGHT && ((ee = U.value) == null || ee.focus()));
    }
    function re(M) {
      L.value = M;
    }
    return o7({
      isDateUnavailable: l.value,
      locale: d,
      modelValue: v,
      placeholder: m,
      disabled: o,
      formatter: y,
      hourCycle: n.hourCycle,
      readonly: i,
      segmentValues: A,
      isInvalid: _,
      segmentContents: R,
      elements: f,
      setFocusedElement: re,
      focusNext() {
        var M;
        (M = U.value) == null || M.focus();
      }
    }), t({
      /** Helper to set the focused element inside the DateField */
      setFocusedElement: re
    }), (M, X) => (S(), I(le, null, [
      j(g(ue), me(M.$attrs, {
        ref_key: "primitiveElement",
        ref: c,
        role: "group",
        "aria-disabled": g(o) ? !0 : void 0,
        "data-disabled": g(o) ? "" : void 0,
        "data-readonly": g(i) ? "" : void 0,
        "data-invalid": _.value ? "" : void 0,
        dir: g(h),
        onKeydown: Pt(te, ["left", "right"])
      }), {
        default: D(() => [
          F(M.$slots, "default", {
            modelValue: g(v),
            segments: k.value,
            isInvalid: _.value
          })
        ]),
        _: 3
      }, 16, ["aria-disabled", "data-disabled", "data-readonly", "data-invalid", "dir"]),
      C("input", {
        id: M.id,
        type: "text",
        tabindex: "-1",
        "aria-hidden": "true",
        value: g(v) ? g(v).toString() : "",
        name: M.name,
        disabled: g(o),
        required: M.required,
        style: {
          transform: "translateX(-100%)",
          position: "absolute",
          pointerEvents: "none",
          opacity: 0,
          margin: 0
        },
        onFocus: X[0] || (X[0] = (ee) => {
          var Se, he;
          return (he = (Se = Array.from(f.value)) == null ? void 0 : Se[0]) == null ? void 0 : he.focus();
        })
      }, null, 40, a7)
    ], 64));
  }
});
function ar(e) {
  return {
    role: "spinbutton",
    contenteditable: !0,
    tabindex: e.disabled ? void 0 : 0,
    spellcheck: !1,
    inputmode: "numeric",
    autocorrect: "off",
    enterkeyhint: "next",
    style: "caret-color: transparent;"
  };
}
function l7(e) {
  const { segmentValues: t, placeholder: r } = e, n = t.day === null, a = t.day ? r.set({ day: t.day }) : r, d = a.day, o = 1, i = qe(a), l = n ? "Empty" : `${d}`;
  return {
    ...ar(e),
    "aria-label": "day,",
    "aria-valuemin": o,
    "aria-valuemax": i,
    "aria-valuenow": d,
    "aria-valuetext": l,
    "data-placeholder": n ? "" : void 0
  };
}
function s7(e) {
  const { segmentValues: t, placeholder: r, formatter: n } = e, a = t.month === null, d = t.month ? r.set({ month: t.month }) : r, o = d.month, i = 1, l = 12, s = a ? "Empty" : `${o} - ${n.fullMonth(Ue(d))}`;
  return {
    ...ar(e),
    "aria-label": "month, ",
    contenteditable: !0,
    "aria-valuemin": i,
    "aria-valuemax": l,
    "aria-valuenow": o,
    "aria-valuetext": s,
    "data-placeholder": a ? "" : void 0
  };
}
function u7(e) {
  const { segmentValues: t, placeholder: r } = e, n = t.year === null, a = t.year ? r.set({ year: t.year }) : r, d = 1, o = 9999, i = a.year, l = n ? "Empty" : `${i}`;
  return {
    ...ar(e),
    "aria-label": "year, ",
    "aria-valuemin": d,
    "aria-valuemax": o,
    "aria-valuenow": i,
    "aria-valuetext": l,
    "data-placeholder": n ? "" : void 0
  };
}
function c7(e) {
  const { segmentValues: t, hourCycle: r, placeholder: n } = e;
  if (!("hour" in t) || !("hour" in n))
    return {};
  const a = t.hour === null, d = t.hour ? n.set({ hour: t.hour }) : n, o = r === 12 ? 1 : 0, i = r === 12 ? 12 : 23, l = d.hour, s = a ? "Empty" : `${l} ${t.dayPeriod ?? ""}`;
  return {
    ...ar(e),
    "aria-label": "hour, ",
    "aria-valuemin": o,
    "aria-valuemax": i,
    "aria-valuenow": l,
    "aria-valuetext": s,
    "data-placeholder": a ? "" : void 0
  };
}
function f7(e) {
  const { segmentValues: t, placeholder: r } = e;
  if (!("minute" in t) || !("minute" in r))
    return {};
  const n = t.minute === null, a = (t.minute ? r.set({ minute: t.minute }) : r).minute, d = 0, o = 59, i = n ? "Empty" : `${a}`;
  return {
    ...ar(e),
    "aria-label": "minute, ",
    "aria-valuemin": d,
    "aria-valuemax": o,
    "aria-valuenow": a,
    "aria-valuetext": i,
    "data-placeholder": n ? "" : void 0
  };
}
function $7(e) {
  const { segmentValues: t, placeholder: r } = e;
  if (!("second" in t) || !("second" in r))
    return {};
  const n = t.second === null, a = (t.second ? r.set({ second: t.second }) : r).second, d = 0, o = 59, i = n ? "Empty" : `${a}`;
  return {
    ...ar(e),
    "aria-label": "second, ",
    "aria-valuemin": d,
    "aria-valuemax": o,
    "aria-valuenow": a,
    "aria-valuetext": i,
    "data-placeholder": n ? "" : void 0
  };
}
function p7(e) {
  const { segmentValues: t } = e;
  if (!("dayPeriod" in t))
    return {};
  const r = 0, n = 12, a = t.hour ? t.hour > 12 ? t.hour - 12 : t.hour : 0, d = t.dayPeriod ?? "AM";
  return {
    ...ar(e),
    inputmode: "text",
    "aria-label": "AM/PM",
    "aria-valuemin": r,
    "aria-valuemax": n,
    "aria-valuenow": a,
    "aria-valuetext": d
  };
}
function m7(e) {
  return {
    "aria-hidden": !0,
    "data-segment": "literal"
  };
}
function h7(e) {
  return {
    role: "textbox",
    "aria-label": "timezone, ",
    "data-readonly": !0,
    "data-segment": "timeZoneName",
    tabindex: e.disabled ? void 0 : 0,
    style: "caret-color: transparent;"
  };
}
function v7(e) {
  const { segmentValues: t, placeholder: r } = e, n = 0, a = 0, d = 0, o = "era" in t ? t.era : r.era;
  return {
    ...ar(e),
    "aria-label": "era",
    "aria-valuemin": n,
    "aria-valuemax": a,
    "aria-valuenow": d,
    "aria-valuetext": o
  };
}
const y7 = {
  day: {
    attrs: l7
  },
  month: {
    attrs: s7
  },
  year: {
    attrs: u7
  },
  hour: {
    attrs: c7
  },
  minute: {
    attrs: f7
  },
  second: {
    attrs: $7
  },
  dayPeriod: {
    attrs: p7
  },
  literal: {
    attrs: m7
  },
  timeZoneName: {
    attrs: h7
  },
  era: {
    attrs: v7
  }
};
function g7(e) {
  const t = nn();
  function r({ e: m, part: b, dateRef: _, prevValue: x }) {
    const A = m.key === t.ARROW_UP ? 1 : -1, P = 0, k = 59;
    if (x === null)
      return A > 0 ? P : k;
    const R = [b, A];
    return _.set({ [b]: x }).cycle(...R)[b];
  }
  function n(m) {
    if (e.hasLeftFocus.value = !1, m === null)
      return m;
    const b = m.toString();
    return b.length === 1 ? (e.modelValue.value = void 0, null) : Number.parseInt(b.slice(0, -1));
  }
  function a({ e: m, part: b, dateRef: _, prevValue: x, hourCycle: A }) {
    const P = m.key === t.ARROW_UP ? 1 : -1;
    if (x === null)
      return _[b];
    if (b === "hour" && "hour" in _) {
      const R = [b, P, { hourCycle: A }];
      return _.set({ [b]: x }).cycle(...R)[b];
    }
    const k = [b, P];
    return b === "day" && e.segmentValues.value.month !== null ? _.set({ [b]: x, month: e.segmentValues.value.month }).cycle(...k)[b] : _.set({ [b]: x }).cycle(...k)[b];
  }
  function d(m, b, _) {
    let x = !1;
    const A = Math.floor(m / 10);
    if (e.hasLeftFocus.value && (e.hasLeftFocus.value = !1, _ = null), _ === null)
      return b === 0 ? (e.lastKeyZero.value = !0, { value: null, moveToNext: x }) : ((e.lastKeyZero.value || b > A) && (x = !0), e.lastKeyZero.value = !1, { value: b, moveToNext: x });
    const P = _.toString().length, k = Number.parseInt(_.toString() + b.toString());
    return P === 2 || k > m ? ((b > A || k > m) && (x = !0), { value: b, moveToNext: x }) : (x = !0, { value: k, moveToNext: x });
  }
  function o(m, b) {
    let _ = !1;
    const x = Math.floor(59 / 10);
    if (e.hasLeftFocus.value && (e.hasLeftFocus.value = !1, b = null), b === null)
      return m === 0 ? (e.lastKeyZero.value = !0, { value: 0, moveToNext: _ }) : ((e.lastKeyZero.value || m > x) && (_ = !0), e.lastKeyZero.value = !1, { value: m, moveToNext: _ });
    const A = b.toString().length, P = Number.parseInt(b.toString() + m.toString());
    return A === 2 || P > 59 ? (m > x && (_ = !0), { value: m, moveToNext: _ }) : (_ = !0, { value: P, moveToNext: _ });
  }
  function i(m, b) {
    let _ = !1;
    const x = Math.floor(24 / 10);
    if (e.hasLeftFocus.value && (e.hasLeftFocus.value = !1, b = null), b === null)
      return m === 0 ? (e.lastKeyZero.value = !0, { value: 0, moveToNext: _ }) : ((e.lastKeyZero.value || m > x) && (_ = !0), e.lastKeyZero.value = !1, { value: m, moveToNext: _ });
    const A = b.toString().length, P = Number.parseInt(b.toString() + m.toString());
    return A === 2 || P > 24 ? (m > x && (_ = !0), { value: m, moveToNext: _ }) : (_ = !0, { value: P, moveToNext: _ });
  }
  function l(m, b) {
    let _ = !1;
    if (e.hasLeftFocus.value && (e.hasLeftFocus.value = !1, b = null), b === null)
      return { value: m === 0 ? 1 : m, moveToNext: _ };
    const x = b.toString() + m.toString();
    return x.length > 4 ? { value: m === 0 ? 1 : m, moveToNext: _ } : (x.length === 4 && (_ = !0), { value: Number.parseInt(x), moveToNext: _ });
  }
  const s = O(() => {
    var m;
    return ((m = y7[e.part]) == null ? void 0 : m.attrs({
      disabled: e.disabled.value,
      placeholder: e.placeholder.value,
      hourCycle: e.hourCycle,
      segmentValues: e.segmentValues.value,
      formatter: e.formatter
    })) ?? {};
  });
  function u(m) {
    if (!Bt(m.key) || Ut(m.key))
      return;
    const b = e.segmentValues.value.day;
    if (m.key === t.ARROW_DOWN || m.key === t.ARROW_UP) {
      e.segmentValues.value.day = a({ e: m, part: "day", dateRef: e.placeholder.value, prevValue: b });
      return;
    }
    if (fr(m.key)) {
      const _ = Number.parseInt(m.key), x = e.segmentValues.value.month, A = qe(x ? e.placeholder.value.set({ month: x }) : e.placeholder.value), { value: P, moveToNext: k } = d(A, _, b);
      e.segmentValues.value.day = P, k && e.focusNext();
    }
    m.key === t.BACKSPACE && (e.hasLeftFocus.value = !1, e.segmentValues.value.day = n(b));
  }
  function $(m) {
    if (!Bt(m.key) || Ut(m.key))
      return;
    const b = e.segmentValues.value.month;
    if (m.key === t.ARROW_DOWN || m.key === t.ARROW_UP) {
      e.segmentValues.value.month = a({ e: m, part: "month", dateRef: e.placeholder.value, prevValue: b });
      return;
    }
    if (fr(m.key)) {
      const _ = Number.parseInt(m.key), { value: x, moveToNext: A } = d(12, _, b);
      e.segmentValues.value.month = x, A && e.focusNext();
    }
    m.key === t.BACKSPACE && (e.hasLeftFocus.value = !1, e.segmentValues.value.month = n(b));
  }
  function y(m) {
    if (!Bt(m.key) || Ut(m.key))
      return;
    const b = e.segmentValues.value.year;
    if (m.key === t.ARROW_DOWN || m.key === t.ARROW_UP) {
      e.segmentValues.value.year = a({ e: m, part: "year", dateRef: e.placeholder.value, prevValue: b });
      return;
    }
    if (fr(m.key)) {
      const _ = Number.parseInt(m.key), { value: x, moveToNext: A } = l(_, b);
      e.segmentValues.value.year = x, A && e.focusNext();
    }
    m.key === t.BACKSPACE && (e.hasLeftFocus.value = !1, e.segmentValues.value.year = n(b));
  }
  function h(m) {
    const b = e.placeholder.value;
    if (!Bt(m.key) || Ut(m.key) || !("hour" in b) || !("hour" in e.segmentValues.value))
      return;
    const _ = e.segmentValues.value.hour, x = e.hourCycle;
    if (m.key === t.ARROW_UP || m.key === t.ARROW_DOWN) {
      e.segmentValues.value.hour = a({ e: m, part: "hour", dateRef: e.placeholder.value, prevValue: _, hourCycle: x }), "dayPeriod" in e.segmentValues.value && (e.segmentValues.value.hour < 12 ? e.segmentValues.value.dayPeriod = "AM" : e.segmentValues.value.hour && (e.segmentValues.value.dayPeriod = "PM"));
      return;
    }
    if (fr(m.key)) {
      const A = Number.parseInt(m.key), { value: P, moveToNext: k } = i(A, _);
      "dayPeriod" in e.segmentValues.value && P && P > 12 ? e.segmentValues.value.dayPeriod = "PM" : "dayPeriod" in e.segmentValues.value && P && (e.segmentValues.value.dayPeriod = "AM"), e.segmentValues.value.hour = P, k && e.focusNext();
    }
    m.key === t.BACKSPACE && (e.hasLeftFocus.value = !1, e.segmentValues.value.hour = n(_));
  }
  function c(m) {
    const b = e.placeholder.value;
    if (!Bt(m.key) || Ut(m.key) || !("minute" in b) || !("minute" in e.segmentValues.value))
      return;
    const _ = e.segmentValues.value.minute;
    if (e.segmentValues.value.minute = r({ e: m, part: "minute", dateRef: e.placeholder.value, prevValue: _ }), fr(m.key)) {
      const x = Number.parseInt(m.key), { value: A, moveToNext: P } = o(x, _);
      e.segmentValues.value.minute = A, P && e.focusNext();
    }
    m.key === t.BACKSPACE && (e.hasLeftFocus.value = !1, e.segmentValues.value.minute = n(_));
  }
  function p(m) {
    const b = e.placeholder.value;
    if (!Bt(m.key) || Ut(m.key) || !("second" in b) || !("second" in e.segmentValues.value))
      return;
    const _ = e.segmentValues.value.second;
    if (e.segmentValues.value.second = r({ e: m, part: "second", dateRef: e.placeholder.value, prevValue: _ }), fr(m.key)) {
      const x = Number.parseInt(m.key), { value: A, moveToNext: P } = o(x, _);
      e.segmentValues.value.second = A, P && e.focusNext();
    }
    m.key === t.BACKSPACE && (e.hasLeftFocus.value = !1, e.segmentValues.value.second = n(_));
  }
  function f(m) {
    if (!((!Bt(m.key) || Ut(m.key)) && m.key !== "a" && m.key !== "p" || !("hour" in e.placeholder.value) || !("dayPeriod" in e.segmentValues.value))) {
      if (m.key === t.ARROW_UP || m.key === t.ARROW_DOWN) {
        if (e.segmentValues.value.dayPeriod === "AM") {
          e.segmentValues.value.dayPeriod = "PM", e.segmentValues.value.hour = e.segmentValues.value.hour + 12;
          return;
        }
        e.segmentValues.value.dayPeriod = "AM", e.segmentValues.value.hour = e.segmentValues.value.hour - 12;
        return;
      }
      if (["a", "A"].includes(m.key) && e.segmentValues.value.dayPeriod !== "AM") {
        e.segmentValues.value.dayPeriod = "AM", e.segmentValues.value.hour = e.segmentValues.value.hour - 12;
        return;
      }
      ["p", "P"].includes(m.key) && e.segmentValues.value.dayPeriod !== "PM" && (e.segmentValues.value.dayPeriod = "PM", e.segmentValues.value.hour = e.segmentValues.value.hour + 12);
    }
  }
  function v(m) {
    e.disabled.value && m.preventDefault();
  }
  function w(m) {
    const b = e.disabled.value, _ = e.readonly.value;
    if (m.key !== t.TAB && m.preventDefault(), !(b || _) && ({
      day: u,
      month: $,
      year: y,
      hour: h,
      minute: c,
      second: p,
      dayPeriod: f,
      timeZoneName: () => {
      }
    }[e.part](m), ![t.ARROW_LEFT, t.ARROW_RIGHT].includes(m.key) && m.key !== t.TAB && m.key !== t.SHIFT && Bt(m.key) && Object.values(e.segmentValues.value).every((x) => x !== null))) {
      const x = { ...e.segmentValues.value };
      let A = e.placeholder.value.copy();
      Object.keys(x).forEach((P) => {
        const k = x[P];
        A = A.set({ [P]: k });
      }), e.modelValue.value = A.copy();
    }
  }
  return {
    handleSegmentClick: v,
    handleSegmentKeydown: w,
    attributes: s
  };
}
const zs = /* @__PURE__ */ V({
  __name: "DateFieldInput",
  props: {
    part: {},
    asChild: { type: Boolean },
    as: {}
  },
  setup(e) {
    const t = e, r = d7(), n = H(!0), a = H(!1), {
      handleSegmentClick: d,
      handleSegmentKeydown: o,
      attributes: i
    } = g7({
      hasLeftFocus: n,
      lastKeyZero: a,
      placeholder: r.placeholder,
      hourCycle: r.hourCycle,
      segmentValues: r.segmentValues,
      formatter: r.formatter,
      part: t.part,
      disabled: r.disabled,
      readonly: r.readonly,
      focusNext: r.focusNext,
      modelValue: r.modelValue
    }), l = O(() => r.disabled.value), s = O(() => r.readonly.value), u = O(() => r.isInvalid.value);
    return ($, y) => (S(), B(g(ue), me({
      as: $.as,
      "as-child": $.asChild
    }, g(i), {
      contenteditable: l.value || s.value ? !1 : $.part !== "literal",
      "data-radix-vue-date-field-segment": $.part,
      "aria-disabled": l.value ? !0 : void 0,
      "aria-readonly": s.value ? !0 : void 0,
      "data-disabled": l.value ? "" : void 0,
      "data-invalid": u.value ? "" : void 0,
      "aria-invalid": u.value ? !0 : void 0
    }, B2($.part !== "literal" ? {
      mousedown: g(d),
      keydown: g(o),
      focusout: () => {
        n.value = !0;
      },
      focusin: (h) => {
        g(r).setFocusedElement(h.target);
      }
    } : {})), {
      default: D(() => [
        F($.$slots, "default")
      ]),
      _: 3
    }, 16, ["as", "as-child", "contenteditable", "data-radix-vue-date-field-segment", "aria-disabled", "aria-readonly", "data-disabled", "data-invalid", "aria-invalid"]));
  }
}), b7 = ["id", "value", "name", "disabled", "required"], [w7, _7] = Rt("PinInputRoot"), x7 = /* @__PURE__ */ V({
  inheritAttrs: !1,
  __name: "PinInputRoot",
  props: {
    modelValue: {},
    defaultValue: {},
    placeholder: { default: "" },
    mask: { type: Boolean },
    otp: { type: Boolean },
    type: { default: "text" },
    dir: {},
    name: {},
    disabled: { type: Boolean },
    required: { type: Boolean },
    id: {},
    asChild: { type: Boolean },
    as: {}
  },
  emits: ["update:modelValue", "complete"],
  setup(e, { emit: t }) {
    const r = e, n = t, { mask: a, otp: d, placeholder: o, type: i, disabled: l, dir: s } = kt(r), { forwardRef: u } = ht(), $ = qn(s), y = Et(r, "modelValue", n, {
      defaultValue: r.defaultValue ?? [],
      passive: r.modelValue === void 0
    }), h = H(/* @__PURE__ */ new Set());
    function c(f) {
      h.value.add(f);
    }
    const p = O(() => y.value.filter((f) => !!f).length === h.value.size);
    return K(y, () => {
      p.value && n("complete", y.value);
    }, { deep: !0 }), _7({
      modelValue: y,
      mask: a,
      otp: d,
      placeholder: o,
      type: i,
      dir: $,
      disabled: l,
      isCompleted: p,
      inputElements: h,
      onInputElementChange: c
    }), (f, v) => (S(), I(le, null, [
      j(g(ue), me(f.$attrs, {
        ref: g(u),
        dir: g($),
        "data-complete": p.value ? "" : void 0,
        "data-disabled": g(l) ? "" : void 0
      }), {
        default: D(() => [
          F(f.$slots, "default", { modelValue: g(y) })
        ]),
        _: 3
      }, 16, ["dir", "data-complete", "data-disabled"]),
      C("input", {
        id: f.id,
        type: "text",
        tabindex: "-1",
        "aria-hidden": "true",
        value: g(y).join(""),
        name: f.name,
        disabled: g(l),
        required: f.required,
        style: {
          transform: "translateX(-100%)",
          position: "absolute",
          pointerEvents: "none",
          opacity: 0,
          margin: 0
        },
        onFocus: v[0] || (v[0] = (w) => {
          var m, b;
          return (b = (m = Array.from(h.value)) == null ? void 0 : m[0]) == null ? void 0 : b.focus();
        })
      }, null, 40, b7)
    ], 64));
  }
}), S7 = /* @__PURE__ */ V({
  __name: "PinInputInput",
  props: {
    index: {},
    disabled: { type: Boolean },
    asChild: { type: Boolean },
    as: { default: "input" }
  },
  setup(e) {
    const t = e, r = w7(), n = O(() => Array.from(r.inputElements.value)), a = O(() => r.modelValue.value[t.index]), d = O(() => t.disabled || r.disabled.value), o = O(() => r.otp.value), i = O(() => r.type.value === "number"), l = O(() => r.mask.value), { primitiveElement: s, currentElement: u } = nr();
    function $(x) {
      var A;
      const P = x.target;
      if ((((A = x.data) == null ? void 0 : A.length) ?? 0) > 1) {
        m(P.value);
        return;
      }
      if (i.value && !/^\d*$/.test(P.value)) {
        P.value = P.value.replace(/\D/g, "");
        return;
      }
      P.value = P.value.slice(-1), _(t.index, P.value);
      const k = n.value[t.index + 1];
      k && k.focus();
    }
    function y() {
      const x = u.value;
      tt(() => {
        x && !x.value && (x.placeholder = r.placeholder.value);
      });
    }
    function h(x) {
      P5(x, S5(), void 0, {
        itemsArray: n.value,
        focus: !0,
        loop: !1,
        arrowKeyOptions: "horizontal",
        dir: r.dir.value
      });
    }
    function c(x) {
      if (x.preventDefault(), x.target.value)
        _(t.index, "");
      else {
        const A = n.value[t.index - 1];
        A && (A.focus(), _(t.index - 1, ""));
      }
    }
    function p(x) {
      x.key === "Delete" && (x.preventDefault(), _(t.index, ""));
    }
    function f(x) {
      const A = x.target;
      A.setSelectionRange(1, 1), A.value || (A.placeholder = "");
    }
    function v(x) {
      y();
    }
    function w(x) {
      x.preventDefault();
      const A = x.clipboardData;
      if (!A)
        return;
      const P = A.getData("text");
      m(P);
    }
    function m(x) {
      var A;
      const P = [...r.modelValue.value], k = x.length >= n.value.length ? 0 : t.index, R = Math.min(k + x.length, n.value.length);
      for (let L = k; L < R; L++) {
        const N = n.value[L], U = x[L - k];
        i.value && !/^\d*$/.test(U) || (P[L] = U, N.focus());
      }
      r.modelValue.value = P, (A = n.value[R]) == null || A.focus();
    }
    function b(x) {
      let A = x.length - 1;
      for (; A >= 0 && x[A] === ""; )
        x.pop(), A--;
      return x;
    }
    function _(x, A) {
      const P = [...r.modelValue.value];
      P[x] = A, r.modelValue.value = b(P);
    }
    return K(a, () => {
      a.value || y();
    }), He(() => {
      r.onInputElementChange(u.value);
    }), Qr(() => {
      var x;
      (x = r.inputElements) == null || x.value.delete(u.value);
    }), (x, A) => (S(), B(g(ue), {
      ref_key: "primitiveElement",
      ref: s,
      autocapitalize: "none",
      as: x.as,
      "as-child": x.asChild,
      autocomplete: o.value ? "one-time-code" : "false",
      type: l.value ? "password" : "text",
      inputmode: i.value ? "numeric" : "text",
      pattern: i.value ? "[0-9]*" : void 0,
      placeholder: g(r).placeholder.value,
      value: a.value,
      disabled: d.value,
      "data-disabled": d.value ? "" : void 0,
      "data-complete": g(r).isCompleted.value ? "" : void 0,
      "aria-label": `pin input ${x.index + 1} of ${n.value.length}`,
      onInput: A[0] || (A[0] = (P) => $(P)),
      onKeydown: [
        Pt(h, ["left", "right", "up", "down", "home", "end"]),
        Pt(c, ["backspace"]),
        Pt(p, ["delete"])
      ],
      onFocus: f,
      onBlur: v,
      onPaste: w
    }, {
      default: D(() => [
        F(x.$slots, "default")
      ]),
      _: 3
    }, 8, ["as", "as-child", "autocomplete", "type", "inputmode", "pattern", "placeholder", "value", "disabled", "data-disabled", "data-complete", "aria-label"]));
  }
});
function C7(e) {
  const t = O(() => e.start.value ? !!e.isDateDisabled(e.start.value) : !1), r = O(() => e.end.value ? !!e.isDateDisabled(e.end.value) : !1), n = O(
    () => t.value || r.value ? !1 : !!(e.start.value && e.end.value && lt(e.end.value, e.start.value))
  ), a = (l) => e.start.value ? Ne(e.start.value, l) : !1, d = (l) => e.end.value ? Ne(e.end.value, l) : !1, o = (l) => e.start.value && Ne(e.start.value, l) || e.end.value && Ne(e.end.value, l) ? !0 : e.end.value && e.start.value ? o5(l, e.start.value, e.end.value) : !1, i = O(() => {
    if (e.start.value && e.end.value || !e.start.value || !e.focusedValue.value)
      return null;
    const l = lt(e.start.value, e.focusedValue.value), s = l ? e.start.value : e.focusedValue.value, u = l ? e.focusedValue.value : e.start.value;
    return Ne(s, u) ? {
      start: s,
      end: u
    } : s5(s, u, e.isDateUnavailable, e.isDateDisabled) ? {
      start: s,
      end: u
    } : null;
  });
  return {
    isInvalid: n,
    isSelected: o,
    highlightedRange: i,
    isSelectionStart: a,
    isSelectionEnd: d,
    isHighlightedStart: (l) => !i.value || !i.value.start ? !1 : Ne(i.value.start, l),
    isHighlightedEnd: (l) => !i.value || !i.value.end ? !1 : Ne(i.value.end, l)
  };
}
const P7 = { style: { border: "0px", clip: "rect(0px, 0px, 0px, 0px)", "clip-path": "inset(50%)", height: "1px", margin: "-1px", overflow: "hidden", padding: "0px", position: "absolute", "white-space": "nowrap", width: "1px" } }, A7 = {
  role: "heading",
  "aria-level": "2"
}, [dn, E7] = Rt("RangeCalendarRoot"), M7 = /* @__PURE__ */ V({
  __name: "RangeCalendarRoot",
  props: {
    defaultPlaceholder: {},
    defaultValue: { default: () => ({ start: void 0, end: void 0 }) },
    modelValue: {},
    placeholder: { default: void 0 },
    pagedNavigation: { type: Boolean, default: !1 },
    preventDeselect: { type: Boolean, default: !1 },
    weekStartsOn: { default: 0 },
    weekdayFormat: { default: "narrow" },
    calendarLabel: {},
    fixedWeeks: { type: Boolean, default: !1 },
    maxValue: {},
    minValue: {},
    locale: { default: "en" },
    numberOfMonths: { default: 1 },
    disabled: { type: Boolean, default: !1 },
    readonly: { type: Boolean, default: !1 },
    initialFocus: { type: Boolean, default: !1 },
    isDateDisabled: { type: Function, default: void 0 },
    isDateUnavailable: { type: Function, default: void 0 },
    dir: {},
    nextPage: {},
    prevPage: {},
    asChild: { type: Boolean },
    as: { default: "div" }
  },
  emits: ["update:modelValue", "update:placeholder", "update:startValue"],
  setup(e, { emit: t }) {
    const r = e, n = t, {
      disabled: a,
      readonly: d,
      initialFocus: o,
      pagedNavigation: i,
      weekStartsOn: l,
      weekdayFormat: s,
      fixedWeeks: u,
      numberOfMonths: $,
      preventDeselect: y,
      isDateUnavailable: h,
      isDateDisabled: c,
      calendarLabel: p,
      maxValue: f,
      minValue: v,
      locale: w,
      dir: m,
      nextPage: b,
      prevPage: _
    } = kt(r), { primitiveElement: x, currentElement: A } = nr(), P = qn(m), k = H(), R = H(), L = Et(r, "modelValue", n, {
      defaultValue: r.defaultValue ?? { start: void 0, end: void 0 },
      passive: r.modelValue === void 0
    }), N = Oi({
      defaultPlaceholder: r.placeholder,
      defaultValue: L.value.start,
      locale: r.locale
    }), U = H(L.value.start), G = H(L.value.end), Y = Et(r, "placeholder", n, {
      defaultValue: r.defaultPlaceholder ?? N.copy(),
      passive: r.placeholder === void 0
    });
    function te(J) {
      Y.value = J.copy();
    }
    const {
      fullCalendarLabel: re,
      headingValue: M,
      isDateDisabled: X,
      isDateUnavailable: ee,
      isNextButtonDisabled: Se,
      isPrevButtonDisabled: he,
      grid: ve,
      weekdays: _e,
      isOutsideVisibleView: Re,
      nextPage: ke,
      prevPage: ce,
      formatter: Le
    } = Hc({
      locale: w,
      placeholder: Y,
      weekStartsOn: l,
      fixedWeeks: u,
      numberOfMonths: $,
      minValue: v,
      maxValue: f,
      disabled: a,
      weekdayFormat: s,
      pagedNavigation: i,
      isDateDisabled: c.value,
      isDateUnavailable: h.value,
      calendarLabel: p,
      nextPage: b,
      prevPage: _
    }), {
      isInvalid: ge,
      isSelected: W,
      highlightedRange: oe,
      isSelectionStart: ie,
      isSelectionEnd: Oe,
      isHighlightedStart: De,
      isHighlightedEnd: Ve
    } = C7({
      start: U,
      end: G,
      isDateDisabled: X,
      isDateUnavailable: ee,
      focusedValue: R
    });
    return K(L, (J) => {
      var be, we, ot, Ke;
      (!J || !J.start || U.value && !it(J.start, U.value)) && (U.value = (we = (be = J == null ? void 0 : J.start) == null ? void 0 : be.copy) == null ? void 0 : we.call(be)), (!J || !J.end || G.value && !it(J.end, G.value)) && (G.value = (Ke = (ot = J == null ? void 0 : J.end) == null ? void 0 : ot.copy) == null ? void 0 : Ke.call(ot));
    }), K(U, (J) => {
      J && !it(J, Y.value) && te(J), n("update:startValue", J);
    }), K([U, G], ([J, be]) => {
      const we = L.value;
      if (!(we && we.start && we.end && J && be && it(we.start, J) && it(we.end, be)))
        if (J && be) {
          if (we.start && we.end && it(we.start, J) && it(we.end, be))
            return;
          lt(be, J) ? L.value = {
            start: be.copy(),
            end: J.copy()
          } : L.value = {
            start: J.copy(),
            end: be.copy()
          };
        } else we.start && we.end && (L.value = {
          start: J == null ? void 0 : J.copy(),
          end: void 0
        });
    }), E7({
      isDateUnavailable: ee,
      startValue: U,
      endValue: G,
      formatter: Le,
      modelValue: L,
      placeholder: Y,
      disabled: a,
      initialFocus: o,
      pagedNavigation: i,
      weekStartsOn: l,
      weekdayFormat: s,
      fixedWeeks: u,
      numberOfMonths: $,
      readonly: d,
      preventDeselect: y,
      fullCalendarLabel: re,
      headingValue: M,
      isInvalid: ge,
      isDateDisabled: X,
      highlightedRange: oe,
      focusedValue: R,
      lastPressedDateValue: k,
      isSelected: W,
      isSelectionEnd: Oe,
      isSelectionStart: ie,
      isNextButtonDisabled: Se,
      isPrevButtonDisabled: he,
      isOutsideVisibleView: Re,
      nextPage: ke,
      prevPage: ce,
      parentElement: A,
      onPlaceholderChange: te,
      locale: w,
      dir: P,
      isHighlightedStart: De,
      isHighlightedEnd: Ve
    }), He(() => {
      o.value && Lc(A.value);
    }), (J, be) => (S(), B(g(ue), {
      ref_key: "primitiveElement",
      ref: x,
      as: J.as,
      "as-child": J.asChild,
      role: "application",
      "aria-label": g(re),
      "data-readonly": g(d) ? "" : void 0,
      "data-disabled": g(a) ? "" : void 0,
      "data-invalid": g(ge) ? "" : void 0,
      dir: g(P)
    }, {
      default: D(() => [
        C("div", P7, [
          C("div", A7, Q(g(re)), 1)
        ]),
        F(J.$slots, "default", {
          date: g(Y),
          grid: g(ve),
          weekDays: g(_e),
          weekStartsOn: g(l),
          locale: g(w),
          fixedWeeks: g(u)
        })
      ]),
      _: 3
    }, 8, ["as", "as-child", "aria-label", "data-readonly", "data-disabled", "data-invalid", "dir"]));
  }
}), O7 = /* @__PURE__ */ V({
  __name: "RangeCalendarHeader",
  props: {
    asChild: { type: Boolean },
    as: { default: "div" }
  },
  setup(e) {
    const t = e;
    return (r, n) => (S(), B(g(ue), Ot(Tt(t)), {
      default: D(() => [
        F(r.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), T7 = /* @__PURE__ */ V({
  __name: "RangeCalendarHeading",
  props: {
    asChild: { type: Boolean },
    as: { default: "div" }
  },
  setup(e) {
    const t = e, r = dn();
    return (n, a) => (S(), B(g(ue), me(t, {
      "data-disabled": g(r).disabled.value ? "" : void 0
    }), {
      default: D(() => [
        F(n.$slots, "default", {
          headingValue: g(r).headingValue.value
        }, () => [
          Me(Q(g(r).headingValue.value), 1)
        ])
      ]),
      _: 3
    }, 16, ["data-disabled"]));
  }
}), k7 = /* @__PURE__ */ V({
  __name: "RangeCalendarGrid",
  props: {
    asChild: { type: Boolean },
    as: { default: "table" }
  },
  setup(e) {
    const t = e, r = dn(), n = O(() => r.disabled.value ? !0 : void 0), a = O(() => r.readonly.value ? !0 : void 0);
    return (d, o) => (S(), B(g(ue), me(t, {
      tabindex: "-1",
      role: "grid",
      "aria-readonly": a.value,
      "aria-disabled": n.value,
      "data-readonly": a.value && "",
      "data-disabled": n.value && ""
    }), {
      default: D(() => [
        F(d.$slots, "default")
      ]),
      _: 3
    }, 16, ["aria-readonly", "aria-disabled", "data-readonly", "data-disabled"]));
  }
}), I7 = /* @__PURE__ */ V({
  __name: "RangeCalendarCell",
  props: {
    date: {},
    asChild: { type: Boolean },
    as: { default: "td" }
  },
  setup(e) {
    const t = dn();
    return (r, n) => {
      var a, d;
      return S(), B(g(ue), {
        as: r.as,
        "as-child": r.asChild,
        role: "gridcell",
        "aria-selected": g(t).isSelected(r.date) ? !0 : void 0,
        "aria-disabled": g(t).isDateDisabled(r.date) || ((d = (a = g(t)).isDateUnavailable) == null ? void 0 : d.call(a, r.date)),
        "data-disabled": g(t).isDateDisabled(r.date) ? "" : void 0
      }, {
        default: D(() => [
          F(r.$slots, "default")
        ]),
        _: 3
      }, 8, ["as", "as-child", "aria-selected", "aria-disabled", "data-disabled"]);
    };
  }
}), R7 = /* @__PURE__ */ V({
  __name: "RangeCalendarHeadCell",
  props: {
    asChild: { type: Boolean },
    as: { default: "th" }
  },
  setup(e) {
    const t = e;
    return (r, n) => (S(), B(g(ue), Ot(Tt(t)), {
      default: D(() => [
        F(r.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), qs = /* @__PURE__ */ V({
  __name: "RangeCalendarNext",
  props: {
    step: {},
    nextPage: {},
    asChild: { type: Boolean },
    as: { default: "button" }
  },
  setup(e) {
    const t = e, r = O(() => n.disabled.value || n.isNextButtonDisabled(t.step, t.nextPage)), n = dn();
    return (a, d) => (S(), B(g(ue), me(t, {
      "aria-label": "Next page",
      type: a.as === "button" ? "button" : void 0,
      "aria-disabled": r.value || void 0,
      "data-disabled": r.value || void 0,
      disabled: r.value,
      onClick: d[0] || (d[0] = (o) => g(n).nextPage(t.step, t.nextPage))
    }), {
      default: D(() => [
        F(a.$slots, "default", {}, () => [
          Me("Next page")
        ])
      ]),
      _: 3
    }, 16, ["type", "aria-disabled", "data-disabled", "disabled"]));
  }
}), Ks = /* @__PURE__ */ V({
  __name: "RangeCalendarPrev",
  props: {
    step: {},
    prevPage: {},
    asChild: { type: Boolean },
    as: { default: "button" }
  },
  setup(e) {
    const t = e, r = O(() => n.disabled.value || n.isPrevButtonDisabled(t.step, t.prevPage)), n = dn();
    return (a, d) => (S(), B(g(ue), me(t, {
      "aria-label": "Previous page",
      type: a.as === "button" ? "button" : void 0,
      "aria-disabled": r.value || void 0,
      "data-disabled": r.value || void 0,
      disabled: r.value,
      onClick: d[0] || (d[0] = (o) => g(n).prevPage(t.step, t.prevPage))
    }), {
      default: D(() => [
        F(a.$slots, "default", {}, () => [
          Me("Prev page")
        ])
      ]),
      _: 3
    }, 16, ["type", "aria-disabled", "data-disabled", "disabled"]));
  }
}), D7 = /* @__PURE__ */ V({
  __name: "RangeCalendarGridHead",
  props: {
    asChild: { type: Boolean },
    as: { default: "thead" }
  },
  setup(e) {
    const t = e;
    return (r, n) => (S(), B(g(ue), me(t, { "aria-hidden": "true" }), {
      default: D(() => [
        F(r.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), N7 = /* @__PURE__ */ V({
  __name: "RangeCalendarGridBody",
  props: {
    asChild: { type: Boolean },
    as: { default: "tbody" }
  },
  setup(e) {
    const t = e;
    return (r, n) => (S(), B(g(ue), Ot(Tt(t)), {
      default: D(() => [
        F(r.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), Ys = /* @__PURE__ */ V({
  __name: "RangeCalendarGridRow",
  props: {
    asChild: { type: Boolean },
    as: { default: "tr" }
  },
  setup(e) {
    const t = e;
    return (r, n) => (S(), B(g(ue), Ot(Tt(t)), {
      default: D(() => [
        F(r.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), F7 = /* @__PURE__ */ V({
  __name: "RangeCalendarCellTrigger",
  props: {
    day: {},
    month: {},
    asChild: { type: Boolean },
    as: { default: "div" }
  },
  setup(e) {
    const t = e, r = dn(), n = nn(), { primitiveElement: a, currentElement: d } = nr(), o = O(() => r.formatter.custom(Ue(t.day), {
      weekday: "long",
      month: "long",
      day: "numeric",
      year: "numeric"
    })), i = O(() => r.isDateDisabled(t.day)), l = O(() => {
      var k;
      return (k = r.isDateUnavailable) == null ? void 0 : k.call(r, t.day);
    }), s = O(() => r.isSelected(t.day)), u = O(() => r.isSelectionStart(t.day)), $ = O(() => r.isSelectionEnd(t.day)), y = O(() => r.isHighlightedStart(t.day)), h = O(() => r.isHighlightedEnd(t.day)), c = O(() => r.highlightedRange.value ? d5(t.day, r.highlightedRange.value.start, r.highlightedRange.value.end) : !1), p = "[data-radix-vue-calendar-cell-trigger]:not([data-disabled]):not([data-outside-view]):not([data-outside-visible-view])", f = O(() => ic(t.day, rn())), v = O(() => !wi(t.day, t.month)), w = O(
      () => r.isOutsideVisibleView(t.day)
    ), m = O(() => t.day.day.toLocaleString(r.locale.value)), b = O(() => !r.disabled.value && Ne(t.day, r.placeholder.value));
    function _(k, R) {
      var L;
      if (!r.readonly.value && !(r.isDateDisabled(R) || (L = r.isDateUnavailable) != null && L.call(r, R))) {
        if (r.lastPressedDateValue.value = R.copy(), r.startValue.value && r.highlightedRange.value === null) {
          if (Ne(R, r.startValue.value) && !r.preventDeselect.value && !r.endValue.value) {
            r.startValue.value = void 0, r.onPlaceholderChange(R);
            return;
          } else if (!r.endValue.value) {
            k.preventDefault(), r.lastPressedDateValue.value && Ne(r.lastPressedDateValue.value, R) && (r.startValue.value = R.copy());
            return;
          }
        }
        if (r.startValue.value && r.endValue.value && Ne(r.endValue.value, R) && !r.preventDeselect.value) {
          r.startValue.value = void 0, r.endValue.value = void 0, r.onPlaceholderChange(R);
          return;
        }
        r.startValue.value ? r.endValue.value ? r.endValue.value && r.startValue.value && (r.endValue.value = void 0, r.startValue.value = R.copy()) : r.endValue.value = R.copy() : r.startValue.value = R.copy();
      }
    }
    function x(k) {
      _(k, t.day);
    }
    function A() {
      var k;
      r.isDateDisabled(t.day) || (k = r.isDateUnavailable) != null && k.call(r, t.day) || (r.focusedValue.value = t.day.copy());
    }
    function P(k) {
      k.preventDefault(), k.stopPropagation();
      const R = r.parentElement.value, L = R ? Array.from(R.querySelectorAll(p)) : [];
      let N = L.indexOf(d.value);
      const U = 7, G = r.dir.value === "rtl" ? -1 : 1;
      switch (k.code) {
        case n.ARROW_RIGHT:
          N += G;
          break;
        case n.ARROW_LEFT:
          N -= G;
          break;
        case n.ARROW_UP:
          N -= U;
          break;
        case n.ARROW_DOWN:
          N += U;
          break;
        case n.ENTER:
        case n.SPACE_CODE:
          _(k, t.day);
          return;
        default:
          return;
      }
      if (N >= 0 && N < L.length) {
        L[N].focus();
        return;
      }
      if (N < 0) {
        if (r.isPrevButtonDisabled("month"))
          return;
        r.prevPage(), tt(() => {
          const Y = R ? Array.from(R.querySelectorAll(p)) : [];
          if (!r.pagedNavigation.value) {
            const te = qe(r.placeholder.value);
            Y[te - Math.abs(N)].focus();
            return;
          }
          Y[Y.length - Math.abs(N)].focus();
        });
        return;
      }
      if (N >= L.length) {
        if (r.isNextButtonDisabled("month"))
          return;
        r.nextPage(), tt(() => {
          const Y = R ? Array.from(R.querySelectorAll(p)) : [];
          if (!r.pagedNavigation.value) {
            const te = qe(r.placeholder.value.add({ months: r.numberOfMonths.value - 1 }));
            Y[Y.length - te + N - L.length].focus();
            return;
          }
          Y[N - L.length].focus();
        });
      }
    }
    return (k, R) => (S(), B(g(ue), me({
      ref_key: "primitiveElement",
      ref: a
    }, t, {
      role: "button",
      "aria-label": o.value,
      "data-radix-vue-calendar-cell-trigger": "",
      "aria-selected": s.value ? !0 : void 0,
      "aria-disabled": i.value || l.value ? !0 : void 0,
      "data-highlighted": c.value ? "" : void 0,
      "data-selection-start": u.value ? !0 : void 0,
      "data-selection-end": $.value ? !0 : void 0,
      "data-highlighted-start": y.value ? !0 : void 0,
      "data-highlighted-end": h.value ? !0 : void 0,
      "data-selected": s.value ? !0 : void 0,
      "data-outside-visible-view": w.value ? "" : void 0,
      "data-value": k.day.toString(),
      "data-disabled": i.value ? "" : void 0,
      "data-unavailable": l.value ? "" : void 0,
      "data-today": f.value ? "" : void 0,
      "data-outside-view": v.value ? "" : void 0,
      "data-focused": b.value ? "" : void 0,
      tabindex: b.value ? 0 : v.value || i.value ? void 0 : -1,
      onClick: x,
      onFocusin: A,
      onMouseenter: A,
      onKeydown: Pt(P, ["up", "down", "left", "right", "enter", "space"])
    }), {
      default: D(() => [
        F(k.$slots, "default", { dayValue: m.value }, () => [
          Me(Q(m.value), 1)
        ])
      ]),
      _: 3
    }, 16, ["aria-label", "aria-selected", "aria-disabled", "data-highlighted", "data-selection-start", "data-selection-end", "data-highlighted-start", "data-highlighted-end", "data-selected", "data-outside-visible-view", "data-value", "data-disabled", "data-unavailable", "data-today", "data-outside-view", "data-focused", "tabindex"]));
  }
});
function L7(e = [], t, r) {
  const n = [...e];
  return n[r] = t, n.sort((a, d) => a - d);
}
function zc(e, t, r) {
  const n = 100 / (r - t) * (e - t);
  return Rc(n, 0, 100);
}
function B7(e, t) {
  return t > 2 ? `Value ${e + 1} of ${t}` : t === 2 ? ["Minimum", "Maximum"][e] : void 0;
}
function V7(e, t) {
  if (e.length === 1)
    return 0;
  const r = e.map((a) => Math.abs(a - t)), n = Math.min(...r);
  return r.indexOf(n);
}
function j7(e, t, r) {
  const n = e / 2, a = Di([0, 50], [0, n]);
  return (n - a(t) * r) * r;
}
function G7(e) {
  return e.slice(0, -1).map((t, r) => e[r + 1] - t);
}
function U7(e, t) {
  if (t > 0) {
    const r = G7(e);
    return Math.min(...r) >= t;
  }
  return !0;
}
function Di(e, t) {
  return (r) => {
    if (e[0] === e[1] || t[0] === t[1])
      return t[0];
    const n = (t[1] - t[0]) / (e[1] - e[0]);
    return t[0] + n * (r - e[0]);
  };
}
function H7(e) {
  return (String(e).split(".")[1] || "").length;
}
function W7(e, t) {
  const r = 10 ** t;
  return Math.round(e * r) / r;
}
const qc = ["PageUp", "PageDown"], Kc = ["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"], Yc = {
  "from-left": ["Home", "PageDown", "ArrowDown", "ArrowLeft"],
  "from-right": ["Home", "PageDown", "ArrowDown", "ArrowRight"],
  "from-bottom": ["Home", "PageDown", "ArrowDown", "ArrowLeft"],
  "from-top": ["Home", "PageDown", "ArrowUp", "ArrowLeft"]
}, [Zc, Jc] = Rt(["SliderVertical", "SliderHorizontal"]), Qc = /* @__PURE__ */ V({
  __name: "SliderImpl",
  props: {
    asChild: { type: Boolean },
    as: { default: "span" }
  },
  emits: ["slideStart", "slideMove", "slideEnd", "homeKeyDown", "endKeyDown", "stepKeyDown"],
  setup(e, { emit: t }) {
    const r = e, n = t, a = Wa();
    return (d, o) => (S(), B(g(ue), me({ "data-slider-impl": "" }, r, {
      onKeydown: o[0] || (o[0] = (i) => {
        i.key === "Home" ? (n("homeKeyDown", i), i.preventDefault()) : i.key === "End" ? (n("endKeyDown", i), i.preventDefault()) : g(qc).concat(g(Kc)).includes(i.key) && (n("stepKeyDown", i), i.preventDefault());
      }),
      onPointerdown: o[1] || (o[1] = (i) => {
        const l = i.target;
        l.setPointerCapture(i.pointerId), i.preventDefault(), g(a).thumbElements.value.includes(l) ? l.focus() : n("slideStart", i);
      }),
      onPointermove: o[2] || (o[2] = (i) => {
        i.target.hasPointerCapture(i.pointerId) && n("slideMove", i);
      }),
      onPointerup: o[3] || (o[3] = (i) => {
        const l = i.target;
        l.hasPointerCapture(i.pointerId) && (l.releasePointerCapture(i.pointerId), n("slideEnd", i));
      })
    }), {
      default: D(() => [
        F(d.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), z7 = /* @__PURE__ */ V({
  __name: "SliderHorizontal",
  props: {
    dir: {},
    min: {},
    max: {},
    inverted: { type: Boolean }
  },
  emits: ["slideEnd", "slideStart", "slideMove", "homeKeyDown", "endKeyDown", "stepKeyDown"],
  setup(e, { emit: t }) {
    const r = e, n = t, { max: a, min: d, dir: o, inverted: i } = kt(r), { forwardRef: l, currentElement: s } = ht(), u = H(), $ = O(() => (o == null ? void 0 : o.value) === "ltr" && !i.value || (o == null ? void 0 : o.value) !== "ltr" && i.value);
    function y(h) {
      const c = u.value || s.value.getBoundingClientRect(), p = [0, c.width], f = $.value ? [d.value, a.value] : [a.value, d.value], v = Di(p, f);
      return u.value = c, v(h - c.left);
    }
    return Jc({
      startEdge: $.value ? "left" : "right",
      endEdge: $.value ? "right" : "left",
      direction: $.value ? 1 : -1,
      size: "width"
    }), (h, c) => (S(), B(Qc, {
      ref: g(l),
      dir: g(o),
      "data-orientation": "horizontal",
      style: {
        "--radix-slider-thumb-transform": "translateX(-50%)"
      },
      onSlideStart: c[0] || (c[0] = (p) => {
        const f = y(p.clientX);
        n("slideStart", f);
      }),
      onSlideMove: c[1] || (c[1] = (p) => {
        const f = y(p.clientX);
        n("slideMove", f);
      }),
      onSlideEnd: c[2] || (c[2] = () => {
        u.value = void 0, n("slideEnd");
      }),
      onStepKeyDown: c[3] || (c[3] = (p) => {
        const f = $.value ? "from-left" : "from-right", v = g(Yc)[f].includes(p.key);
        n("stepKeyDown", p, v ? -1 : 1);
      }),
      onEndKeyDown: c[4] || (c[4] = (p) => n("endKeyDown", p)),
      onHomeKeyDown: c[5] || (c[5] = (p) => n("homeKeyDown", p))
    }, {
      default: D(() => [
        F(h.$slots, "default")
      ]),
      _: 3
    }, 8, ["dir"]));
  }
}), q7 = /* @__PURE__ */ V({
  __name: "SliderVertical",
  props: {
    min: {},
    max: {},
    inverted: { type: Boolean }
  },
  emits: ["slideEnd", "slideStart", "slideMove", "homeKeyDown", "endKeyDown", "stepKeyDown"],
  setup(e, { emit: t }) {
    const r = e, n = t, { max: a, min: d, inverted: o } = kt(r), { forwardRef: i, currentElement: l } = ht(), s = H(), u = O(() => !o.value);
    function $(y) {
      const h = s.value || l.value.getBoundingClientRect(), c = [0, h.height], p = u.value ? [a.value, d.value] : [d.value, a.value], f = Di(c, p);
      return s.value = h, f(y - h.top);
    }
    return Jc({
      startEdge: u.value ? "bottom" : "top",
      endEdge: u.value ? "top" : "bottom",
      size: "height",
      direction: u.value ? 1 : -1
    }), (y, h) => (S(), B(Qc, {
      ref: g(i),
      "data-orientation": "vertical",
      style: {
        "--radix-slider-thumb-transform": "translateY(50%)"
      },
      onSlideStart: h[0] || (h[0] = (c) => {
        const p = $(c.clientY);
        n("slideStart", p);
      }),
      onSlideMove: h[1] || (h[1] = (c) => {
        const p = $(c.clientY);
        n("slideMove", p);
      }),
      onSlideEnd: h[2] || (h[2] = () => {
        s.value = void 0, n("slideEnd");
      }),
      onStepKeyDown: h[3] || (h[3] = (c) => {
        const p = u.value ? "from-bottom" : "from-top", f = g(Yc)[p].includes(c.key);
        n("stepKeyDown", c, f ? -1 : 1);
      }),
      onEndKeyDown: h[4] || (h[4] = (c) => n("endKeyDown", c)),
      onHomeKeyDown: h[5] || (h[5] = (c) => n("homeKeyDown", c))
    }, {
      default: D(() => [
        F(y.$slots, "default")
      ]),
      _: 3
    }, 512));
  }
}), K7 = ["value", "name", "disabled", "step"], [Wa, Y7] = Rt("SliderRoot"), Z7 = /* @__PURE__ */ V({
  inheritAttrs: !1,
  __name: "SliderRoot",
  props: {
    name: {},
    defaultValue: { default: () => [0] },
    modelValue: {},
    disabled: { type: Boolean, default: !1 },
    orientation: { default: "horizontal" },
    dir: {},
    inverted: { type: Boolean, default: !1 },
    min: { default: 0 },
    max: { default: 100 },
    step: { default: 1 },
    minStepsBetweenThumbs: { default: 0 },
    asChild: { type: Boolean },
    as: {}
  },
  emits: ["update:modelValue", "valueCommit"],
  setup(e, { emit: t }) {
    const r = e, n = t, { min: a, max: d, step: o, minStepsBetweenThumbs: i, orientation: l, disabled: s, dir: u } = kt(r), $ = qn(u), { forwardRef: y, currentElement: h } = ht(), c = Uc(h);
    Z5();
    const p = Et(r, "modelValue", n, {
      defaultValue: r.defaultValue,
      passive: r.modelValue === void 0
    }), f = H(0), v = H(p.value);
    function w(A) {
      const P = V7(p.value, A);
      _(A, P);
    }
    function m(A) {
      _(A, f.value);
    }
    function b() {
      const A = v.value[f.value];
      p.value[f.value] !== A && n("valueCommit", V2(p.value));
    }
    function _(A, P, { commit: k } = { commit: !1 }) {
      var R;
      const L = H7(o.value), N = W7(Math.round((A - a.value) / o.value) * o.value + a.value, L), U = Rc(N, a.value, d.value), G = L7(p.value, U, P);
      if (U7(G, i.value * o.value)) {
        f.value = G.indexOf(U);
        const Y = String(G) !== String(p.value);
        Y && k && n("valueCommit", G), Y && ((R = x.value[f.value]) == null || R.focus(), p.value = G);
      }
    }
    const x = H([]);
    return Y7({
      modelValue: p,
      valueIndexToChangeRef: f,
      thumbElements: x,
      orientation: l,
      min: a,
      max: d,
      disabled: s
    }), (A, P) => (S(), I(le, null, [
      j(g(J5), null, {
        default: D(() => [
          (S(), B(si(g(l) === "horizontal" ? z7 : q7), me(A.$attrs, {
            ref: g(y),
            "as-child": A.asChild,
            as: A.as,
            min: g(a),
            max: g(d),
            dir: g($),
            inverted: A.inverted,
            "aria-disabled": g(s),
            "data-disabled": g(s) ? "" : void 0,
            onPointerdown: P[0] || (P[0] = () => {
              g(s) || (v.value = g(p));
            }),
            onSlideStart: P[1] || (P[1] = (k) => !g(s) && w(k)),
            onSlideMove: P[2] || (P[2] = (k) => !g(s) && m(k)),
            onSlideEnd: P[3] || (P[3] = (k) => !g(s) && b()),
            onHomeKeyDown: P[4] || (P[4] = (k) => !g(s) && _(g(a), 0, { commit: !0 })),
            onEndKeyDown: P[5] || (P[5] = (k) => !g(s) && _(g(d), g(p).length - 1, { commit: !0 })),
            onStepKeyDown: P[6] || (P[6] = (k, R) => {
              if (!g(s)) {
                const L = g(qc).includes(k.key) || k.shiftKey && g(Kc).includes(k.key) ? 10 : 1, N = f.value, U = g(p)[N], G = g(o) * L * R;
                _(U + G, N, { commit: !0 });
              }
            })
          }), {
            default: D(() => [
              F(A.$slots, "default", { modelValue: g(p) })
            ]),
            _: 3
          }, 16, ["as-child", "as", "min", "max", "dir", "inverted", "aria-disabled", "data-disabled"]))
        ]),
        _: 3
      }),
      g(c) ? (S(!0), I(le, { key: 0 }, Ee(g(p), (k, R) => (S(), I("input", {
        key: R,
        value: k,
        type: "number",
        style: { display: "none" },
        name: A.name ? A.name + (g(p).length > 1 ? "[]" : "") : void 0,
        disabled: g(s),
        step: g(o)
      }, null, 8, K7))), 128)) : Z("", !0)
    ], 64));
  }
}), J7 = /* @__PURE__ */ V({
  inheritAttrs: !1,
  __name: "SliderThumbImpl",
  props: {
    index: {},
    asChild: { type: Boolean },
    as: {}
  },
  setup(e) {
    const t = e, r = Wa(), n = Zc(), { forwardRef: a, currentElement: d } = ht(), o = O(() => {
      var h, c;
      return (c = (h = r.modelValue) == null ? void 0 : h.value) == null ? void 0 : c[t.index];
    }), i = O(() => o.value === void 0 ? 0 : zc(o.value, r.min.value ?? 0, r.max.value ?? 100)), l = O(() => {
      var h, c;
      return B7(t.index, ((c = (h = r.modelValue) == null ? void 0 : h.value) == null ? void 0 : c.length) ?? 0);
    }), s = E5(d), u = O(() => s[n.size].value), $ = O(() => u.value ? j7(u.value, i.value, n.direction) : 0), y = _5();
    return He(() => {
      r.thumbElements.value.push(d.value);
    }), Qr(() => {
      const h = r.thumbElements.value.findIndex((c) => c === d.value) ?? -1;
      r.thumbElements.value.splice(h, 1);
    }), (h, c) => (S(), B(g(Q5), null, {
      default: D(() => [
        j(g(ue), me(h.$attrs, {
          ref: g(a),
          role: "slider",
          "data-radix-vue-collection-item": "",
          tabindex: g(r).disabled.value ? void 0 : 0,
          "aria-label": h.$attrs["aria-label"] || l.value,
          "data-disabled": g(r).disabled.value ? "" : void 0,
          "data-orientation": g(r).orientation.value,
          "aria-valuenow": o.value,
          "aria-valuemin": g(r).min.value,
          "aria-valuemax": g(r).max.value,
          "aria-orientation": g(r).orientation.value,
          "as-child": h.asChild,
          as: h.as,
          style: {
            transform: "var(--radix-slider-thumb-transform)",
            position: "absolute",
            [g(n).startEdge]: `calc(${i.value}% + ${$.value}px)`,
            /**
             * There will be no value on initial render while we work out the index so we hide thumbs
             * without a value, otherwise SSR will render them in the wrong position before they
             * snap into the correct position during hydration which would be visually jarring for
             * slower connections.
             */
            display: !g(y) && o.value === void 0 ? "none" : void 0
          },
          onFocus: c[0] || (c[0] = () => {
            g(r).valueIndexToChangeRef.value = h.index;
          })
        }), {
          default: D(() => [
            F(h.$slots, "default")
          ]),
          _: 3
        }, 16, ["tabindex", "aria-label", "data-disabled", "data-orientation", "aria-valuenow", "aria-valuemin", "aria-valuemax", "aria-orientation", "as-child", "as", "style"])
      ]),
      _: 3
    }));
  }
}), Q7 = /* @__PURE__ */ V({
  __name: "SliderThumb",
  props: {
    asChild: { type: Boolean },
    as: {}
  },
  setup(e) {
    const t = e, { getItems: r } = Wc(), { forwardRef: n, currentElement: a } = ht(), d = O(() => a.value ? r().findIndex((o) => o.ref === a.value) : -1);
    return (o, i) => (S(), B(J7, me({ ref: g(n) }, t, { index: d.value }), {
      default: D(() => [
        F(o.$slots, "default")
      ]),
      _: 3
    }, 16, ["index"]));
  }
}), X7 = /* @__PURE__ */ V({
  __name: "SliderTrack",
  props: {
    asChild: { type: Boolean },
    as: { default: "span" }
  },
  setup(e) {
    const t = Wa();
    return ht(), (r, n) => (S(), B(g(ue), {
      "as-child": r.asChild,
      as: r.as,
      "data-disabled": g(t).disabled.value ? "" : void 0,
      "data-orientation": g(t).orientation.value
    }, {
      default: D(() => [
        F(r.$slots, "default")
      ]),
      _: 3
    }, 8, ["as-child", "as", "data-disabled", "data-orientation"]));
  }
}), ev = /* @__PURE__ */ V({
  __name: "SliderRange",
  props: {
    asChild: { type: Boolean },
    as: { default: "span" }
  },
  setup(e) {
    const t = Wa(), r = Zc();
    ht();
    const n = O(() => {
      var o, i;
      return (i = (o = t.modelValue) == null ? void 0 : o.value) == null ? void 0 : i.map(
        (l) => zc(l, t.min.value, t.max.value)
      );
    }), a = O(() => t.modelValue.value.length > 1 ? Math.min(...n.value) : 0), d = O(() => 100 - Math.max(...n.value));
    return (o, i) => (S(), B(g(ue), {
      "data-disabled": g(t).disabled.value ? "" : void 0,
      "data-orientation": g(t).orientation.value,
      "as-child": o.asChild,
      as: o.as,
      style: Ct({
        [g(r).startEdge]: `${a.value}%`,
        [g(r).endEdge]: `${d.value}%`
      })
    }, {
      default: D(() => [
        F(o.$slots, "default")
      ]),
      _: 3
    }, 8, ["data-disabled", "data-orientation", "as-child", "as", "style"]));
  }
});
function tv() {
  if (typeof matchMedia == "function")
    return matchMedia("(pointer:coarse)").matches ? "coarse" : "fine";
}
tv();
const rv = ["name", "disabled", "required", "value", "checked", "data-state", "data-disabled"], [nv, av] = Rt("SwitchRoot"), dv = /* @__PURE__ */ V({
  __name: "SwitchRoot",
  props: {
    defaultChecked: { type: Boolean },
    checked: { type: Boolean, default: void 0 },
    disabled: { type: Boolean },
    required: { type: Boolean },
    name: {},
    id: {},
    value: { default: "on" },
    asChild: { type: Boolean },
    as: { default: "button" }
  },
  emits: ["update:checked"],
  setup(e, { emit: t }) {
    const r = e, n = t, { disabled: a } = kt(r), d = Et(r, "checked", n, {
      defaultValue: r.defaultChecked,
      passive: r.checked === void 0
    });
    function o() {
      a.value || (d.value = !d.value);
    }
    const { forwardRef: i, currentElement: l } = ht(), s = Uc(l), u = O(() => {
      var $;
      return r.id && l.value ? ($ = document.querySelector(`[for="${r.id}"]`)) == null ? void 0 : $.innerText : void 0;
    });
    return av({
      checked: d,
      toggleCheck: o,
      disabled: a
    }), ($, y) => (S(), I(le, null, [
      j(g(ue), me($.$attrs, {
        id: $.id,
        ref: g(i),
        role: "switch",
        type: $.as === "button" ? "button" : void 0,
        value: $.value,
        "aria-label": $.$attrs["aria-label"] || u.value,
        "aria-checked": g(d),
        "aria-required": $.required,
        "data-state": g(d) ? "checked" : "unchecked",
        "data-disabled": g(a) ? "" : void 0,
        "as-child": $.asChild,
        as: $.as,
        disabled: g(a),
        onClick: o,
        onKeydown: Pt(Jt(o, ["prevent"]), ["enter"])
      }), {
        default: D(() => [
          F($.$slots, "default", { checked: g(d) })
        ]),
        _: 3
      }, 16, ["id", "type", "value", "aria-label", "aria-checked", "aria-required", "data-state", "data-disabled", "as-child", "as", "disabled", "onKeydown"]),
      g(s) ? (S(), I("input", {
        key: 0,
        type: "checkbox",
        name: $.name,
        tabindex: "-1",
        "aria-hidden": "true",
        disabled: g(a),
        required: $.required,
        value: $.value,
        checked: !!g(d),
        "data-state": g(d) ? "checked" : "unchecked",
        "data-disabled": g(a) ? "" : void 0,
        style: {
          transform: "translateX(-100%)",
          position: "absolute",
          pointerEvents: "none",
          opacity: 0,
          margin: 0
        }
      }, null, 8, rv)) : Z("", !0)
    ], 64));
  }
}), ov = /* @__PURE__ */ V({
  __name: "SwitchThumb",
  props: {
    asChild: { type: Boolean },
    as: { default: "span" }
  },
  setup(e) {
    const t = nv();
    return ht(), (r, n) => {
      var a;
      return S(), B(g(ue), {
        "data-state": (a = g(t).checked) != null && a.value ? "checked" : "unchecked",
        "data-disabled": g(t).disabled.value ? "" : void 0,
        "as-child": r.asChild,
        as: r.as
      }, {
        default: D(() => [
          F(r.$slots, "default")
        ]),
        _: 3
      }, 8, ["data-state", "data-disabled", "as-child", "as"]);
    };
  }
}), iv = { class: "text-footnote text-gray-600" }, lv = { class: "text-footnote text-gray-1000" }, sv = ["name", "id"], uv = { class: "flex flex-col space-y-4 pt-4 sm:flex-row sm:space-x-4 sm:space-y-0" }, Ux = /* @__PURE__ */ V({
  __name: "FdxInputDate",
  props: /* @__PURE__ */ $e({
    allowYearNavigation: { type: Boolean },
    calendarRootProps: {},
    dateFieldRootProps: {},
    disableManualInput: { type: Boolean },
    helpText: {},
    label: {},
    name: {},
    placeholder: { default: "dd/mm/yyyy" },
    validations: {}
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    const t = wr(e, ["placeholder"]), r = H(!1), n = Ae(e, "modelValue"), { value: a } = Be(t.name, t.validations, {
      initialValue: n.value
    });
    function d(s) {
      n.value = s == null ? void 0 : s.toString(), r.value = !1;
    }
    function o(s) {
      try {
        return s ? Ko(s) : void 0;
      } catch {
        return;
      }
    }
    K(a, () => {
      Hr(a.value, n.value) || (n.value = a.value);
    }), K(n, () => {
      Hr(a.value, n.value) || (a.value = n.value);
    });
    function i(s) {
      return s ? `${Qo(s, "dd/MM/yyyy")}` : "dd/mm/yyyy";
    }
    function l(s) {
      const u = s.findIndex((y) => y.part === "day"), $ = s.findIndex((y) => y.part === "month");
      if (u !== -1 && $ !== -1) {
        const y = [...s];
        return [y[u], y[$]] = [y[$], y[u]], y;
      }
      return s;
    }
    return (s, u) => {
      const $ = dc, y = Hn, h = ac, c = nc, p = rc, f = tc;
      return S(), B(at, {
        name: s.name,
        label: s.label,
        "help-text": s.helpText
      }, {
        default: D(() => [
          j(bi, {
            triggers: [],
            display: "block",
            shown: r.value,
            onHide: u[4] || (u[4] = (v) => r.value = !1)
          }, {
            trigger: D(() => [
              C("div", {
                class: "flex w-full cursor-pointer items-center gap-x-2 rounded-lg border border-gray-500 px-4 py-2",
                onClick: u[3] || (u[3] = (v) => r.value = !r.value)
              }, [
                j($, { class: "size-6 text-gray-1000" }),
                s.disableManualInput ? n.value ? F(s.$slots, "selected", { key: 2 }, () => [
                  C("span", lv, Q(i(n.value)), 1)
                ]) : F(s.$slots, "placeholder", { key: 1 }, () => [
                  C("span", iv, Q(s.placeholder), 1)
                ]) : (S(), B(g(i7), me({
                  key: 0,
                  onClick: u[0] || (u[0] = Jt(() => {
                  }, ["stop"])),
                  "model-value": o(n.value),
                  "onUpdate:modelValue": d
                }, s.dateFieldRootProps, { class: "flex h-6 select-none items-center rounded-lg border border-transparent bg-white text-center data-[invalid]:border-red-500" }), {
                  default: D(({ segments: v }) => [
                    (S(!0), I(le, null, Ee(l(v), (w) => (S(), I(le, {
                      key: w.part
                    }, [
                      w.part === "literal" ? (S(), B(g(zs), {
                        key: 0,
                        part: w.part,
                        class: "text-footnote text-gray-600"
                      }, {
                        default: D(() => [
                          Me(Q(w.value), 1)
                        ]),
                        _: 2
                      }, 1032, ["part"])) : (S(), B(g(zs), {
                        key: 1,
                        part: w.part,
                        class: "rounded px-0.5 text-footnote focus:shadow-[0_0_0_2px] focus:shadow-black focus:outline-none data-[placeholder]:text-gray-600"
                      }, {
                        default: D(() => [
                          Me(Q(w.value.padStart(2, "0")), 1)
                        ]),
                        _: 2
                      }, 1032, ["part"]))
                    ], 64))), 128))
                  ]),
                  _: 1
                }, 16, ["model-value"])),
                n.value ? (S(), B(y, {
                  key: 3,
                  class: "ms-auto size-5 text-gray-1000",
                  onClick: u[1] || (u[1] = Jt((v) => n.value = void 0, ["stop"]))
                })) : Z("", !0),
                Xe(C("input", {
                  type: "hidden",
                  "onUpdate:modelValue": u[2] || (u[2] = (v) => n.value = v),
                  name: s.name,
                  id: s.name
                }, null, 8, sv), [
                  [Un, n.value]
                ])
              ])
            ]),
            menu: D(() => [
              C("div", null, [
                j(g(B5), me({
                  "model-value": o(n.value),
                  class: "rounded-xl bg-white p-4 shadow-xl",
                  "fixed-weeks": "",
                  "initial-focus": "",
                  "onUpdate:modelValue": d
                }, s.calendarRootProps), {
                  default: D(({ weekDays: v, grid: w }) => [
                    j(g(V5), { class: "flex items-center justify-between" }, {
                      default: D(() => [
                        s.allowYearNavigation ? (S(), B(g(Gs), {
                          key: 0,
                          class: "active:scale-98 inline-flex h-8 w-8 cursor-pointer items-center justify-center rounded-[9px] bg-transparent text-black hover:bg-primary-300 hover:text-white focus:shadow-[0_0_0_2px] focus:shadow-black active:transition-all",
                          "prev-page": (m) => m.add({ years: -1 })
                        }, {
                          default: D(() => [
                            j(h, { class: "size-4" })
                          ]),
                          _: 1
                        }, 8, ["prev-page"])) : Z("", !0),
                        j(g(Gs), { class: "active:scale-98 inline-flex h-8 w-8 cursor-pointer items-center justify-center rounded-[9px] bg-transparent text-black hover:bg-primary-300 hover:text-white focus:shadow-[0_0_0_2px] focus:shadow-black active:transition-all" }, {
                          default: D(() => [
                            j(c, { class: "size-4" })
                          ]),
                          _: 1
                        }),
                        j(g(j5), { class: "text-[15px] font-medium text-black" }),
                        j(g(js), { class: "active:scale-98 inline-flex h-8 w-8 cursor-pointer items-center justify-center rounded-[9px] bg-transparent text-black hover:bg-primary-300 hover:text-white focus:shadow-[0_0_0_2px] focus:shadow-black active:transition-all" }, {
                          default: D(() => [
                            j(p, { class: "size-4" })
                          ]),
                          _: 1
                        }),
                        s.allowYearNavigation ? (S(), B(g(js), {
                          key: 1,
                          class: "active:scale-98 inline-flex h-8 w-8 cursor-pointer items-center justify-center rounded-[9px] bg-transparent text-black hover:bg-primary-300 hover:text-white focus:shadow-[0_0_0_2px] focus:shadow-black active:transition-all",
                          "next-page": (m) => m.add({ years: 1 })
                        }, {
                          default: D(() => [
                            j(f, { class: "size-4" })
                          ]),
                          _: 1
                        }, 8, ["next-page"])) : Z("", !0)
                      ]),
                      _: 1
                    }),
                    C("div", uv, [
                      (S(!0), I(le, null, Ee(w, (m) => (S(), B(g(G5), {
                        key: m.value.toString(),
                        class: "w-full border-collapse select-none space-y-1"
                      }, {
                        default: D(() => [
                          j(g(W5), null, {
                            default: D(() => [
                              j(g(Us), { class: "mb-1 grid w-full grid-cols-7" }, {
                                default: D(() => [
                                  (S(!0), I(le, null, Ee(v, (b) => (S(), B(g(H5), {
                                    key: b,
                                    class: "rounded-md text-xs"
                                  }, {
                                    default: D(() => [
                                      Me(Q(b), 1)
                                    ]),
                                    _: 2
                                  }, 1024))), 128))
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024),
                          j(g(z5), { class: "grid" }, {
                            default: D(() => [
                              (S(!0), I(le, null, Ee(m.rows, (b, _) => (S(), B(g(Us), {
                                key: `weekDate-${_}`,
                                class: "grid grid-cols-7"
                              }, {
                                default: D(() => [
                                  (S(!0), I(le, null, Ee(b, (x) => (S(), B(g(U5), {
                                    key: x.toString(),
                                    date: x
                                  }, {
                                    default: D(() => [
                                      j(g(q5), {
                                        day: x,
                                        month: m.value,
                                        class: "relative flex h-8 w-8 items-center justify-center whitespace-nowrap rounded-full text-sm font-normal text-black outline-none before:absolute before:top-[5px] before:hidden before:h-1 before:w-1 before:rounded-full before:bg-white hover:!bg-primary-100 focus:shadow-[0_0_0_2px] focus:shadow-black data-[unavailable]:pointer-events-none data-[highlighted]:bg-primary-100 data-[selected]:!bg-primary-300 data-[today]:bg-gray-200 data-[disabled]:text-black/30 data-[outside-view]:text-black/30 data-[selected]:text-white data-[unavailable]:text-black/30 data-[unavailable]:line-through"
                                      }, null, 8, ["day", "month"])
                                    ]),
                                    _: 2
                                  }, 1032, ["date"]))), 128))
                                ]),
                                _: 2
                              }, 1024))), 128))
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024))), 128))
                    ])
                  ]),
                  _: 1
                }, 16, ["model-value"])
              ])
            ]),
            _: 3
          }, 8, ["shown"])
        ]),
        _: 3
      }, 8, ["name", "label", "help-text"]);
    };
  }
}), cv = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, fv = ["clip-path"], $v = ["id"];
function pv(e, t) {
  return S(), I("svg", cv, [
    C("g", {
      "clip-path": "url(#" + e.idMap.clip0_5_23662 + ")"
    }, [...t[0] || (t[0] = [
      C("path", {
        d: "M7 10L12 15L17 10H7Z",
        fill: "currentColor"
      }, null, -1)
    ])], 8, fv),
    C("defs", null, [
      C("clipPath", {
        id: e.idMap.clip0_5_23662
      }, [...t[1] || (t[1] = [
        C("rect", {
          width: "24",
          height: "24",
          fill: "white"
        }, null, -1)
      ])], 8, $v)
    ])
  ]);
}
const Ni = ye({ name: "icon-arrow-drop-down", render: pv, setup() {
  return { idMap: { clip0_5_23662: "uicons-" + Math.random().toString(36).substr(2, 10) } };
} }), mv = { class: "text-footnote text-gray-600" }, hv = { class: "text-footnote text-gray-1000" }, vv = { class: "ms-auto flex items-center gap-x-2" }, yv = ["name", "id"], gv = { class: "flex gap-2" }, bv = { class: "flex gap-2" }, wv = { class: "flex flex-col space-y-4 pt-4 sm:flex-row sm:space-x-4 sm:space-y-0" }, Hx = /* @__PURE__ */ V({
  __name: "FdxInputDateRange",
  props: /* @__PURE__ */ $e({
    allowYearNavigation: { type: Boolean, default: !1 },
    helpText: { default: "" },
    label: { default: "" },
    name: {},
    placeholder: { default: "dd/mm/yyyy - dd/mm/yyyy" },
    validations: { default: void 0 }
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    const t = e, r = H(!1), n = Ae(e, "modelValue"), { value: a } = Be(t.name, t.validations, {
      initialValue: n.value
    });
    K(a, () => {
      Hr(a.value, n.value) || (n.value = a.value);
    }), K(n, () => {
      Hr(a.value, n.value) || (a.value = n.value);
    });
    function d(u, $) {
      return $ === -1 ? u.subtract({ years: 1 }) : u.add({ years: 1 });
    }
    function o() {
      n.value = void 0, a.value = void 0;
    }
    function i(u) {
      var $, y;
      if (!u.start || !u.end) {
        n.value = void 0;
        return;
      }
      n.value = [($ = u.start) == null ? void 0 : $.toString(), (y = u.end) == null ? void 0 : y.toString()], r.value = !1;
    }
    function l(u) {
      const [$, y] = u;
      return !$ || !y ? t.placeholder : `${Qo($, "dd/MM/yyyy")} - ${Qo(y, "dd/MM/yyyy")}`;
    }
    function s(u) {
      if (!u)
        return { end: void 0, start: void 0 };
      try {
        return { end: Ko(u[1]), start: Ko(u[0]) };
      } catch {
        return { end: void 0, start: void 0 };
      }
    }
    return (u, $) => {
      const y = dc, h = Hn, c = Ni, p = ac, f = nc, v = rc, w = tc;
      return S(), B(at, {
        name: u.name,
        label: u.label,
        "help-text": u.helpText
      }, {
        default: D(() => [
          j(bi, {
            triggers: [],
            display: "block",
            shown: r.value,
            onHide: $[2] || ($[2] = (m) => r.value = !1)
          }, {
            trigger: D(() => [
              C("div", {
                class: "flex w-full cursor-pointer gap-x-2 rounded-lg border border-gray-500 px-4 py-2",
                onClick: $[1] || ($[1] = (m) => r.value = !r.value)
              }, [
                j(y, { class: "size-6 text-gray-1000" }),
                n.value ? F(u.$slots, "selected", { key: 1 }, () => [
                  C("span", hv, Q(l(n.value)), 1)
                ]) : F(u.$slots, "placeholder", { key: 0 }, () => [
                  C("span", mv, Q(u.placeholder), 1)
                ]),
                C("div", vv, [
                  n.value ? (S(), B(h, {
                    key: 0,
                    "data-testid": "clear-date-range",
                    class: "size-4 text-gray-1000",
                    onClick: Jt(o, ["stop"])
                  })) : Z("", !0),
                  j(c, { class: "size-6 text-gray-1000" })
                ]),
                Xe(C("input", {
                  type: "hidden",
                  "onUpdate:modelValue": $[0] || ($[0] = (m) => n.value = m),
                  name: u.name,
                  id: u.name
                }, null, 8, yv), [
                  [Un, n.value]
                ])
              ])
            ]),
            menu: D(() => [
              j(g(M7), {
                "model-value": s(n.value),
                class: "rounded-xl bg-white p-4 shadow-xl",
                "fixed-weeks": "",
                "initial-focus": "",
                "onUpdate:modelValue": i
              }, {
                default: D(({ weekDays: m, grid: b }) => [
                  j(g(O7), {
                    class: "flex items-center justify-between",
                    step: "year"
                  }, {
                    default: D(() => [
                      C("div", gv, [
                        u.allowYearNavigation ? (S(), B(g(Ks), {
                          key: 0,
                          class: "active:scale-98 inline-flex h-8 w-8 cursor-pointer items-center justify-center rounded-[9px] bg-transparent text-black hover:bg-primary-300 hover:text-white focus:shadow-[0_0_0_2px] focus:shadow-black active:transition-all",
                          "prev-page": (_) => d(_, -1)
                        }, {
                          default: D(() => [
                            j(p, { class: "size-6" })
                          ]),
                          _: 1
                        }, 8, ["prev-page"])) : Z("", !0),
                        j(g(Ks), { class: "active:scale-98 inline-flex h-8 w-8 cursor-pointer items-center justify-center rounded-[9px] bg-transparent text-black hover:bg-primary-300 hover:text-white focus:shadow-[0_0_0_2px] focus:shadow-black active:transition-all" }, {
                          default: D(() => [
                            j(f, { class: "size-6" })
                          ]),
                          _: 1
                        })
                      ]),
                      j(g(T7), { class: "text-[15px] font-medium text-black" }),
                      C("div", bv, [
                        j(g(qs), { class: "active:scale-98 inline-flex h-8 w-8 cursor-pointer items-center justify-center rounded-[9px] bg-transparent text-black hover:bg-primary-300 hover:text-white focus:shadow-[0_0_0_2px] focus:shadow-black active:transition-all" }, {
                          default: D(() => [
                            j(v, { class: "size-6" })
                          ]),
                          _: 1
                        }),
                        u.allowYearNavigation ? (S(), B(g(qs), {
                          key: 0,
                          class: "active:scale-98 inline-flex h-8 w-8 cursor-pointer items-center justify-center rounded-[9px] bg-transparent text-black hover:bg-primary-300 hover:text-white focus:shadow-[0_0_0_2px] focus:shadow-black active:transition-all",
                          "next-page": (_) => d(_, 1)
                        }, {
                          default: D(() => [
                            j(w, { class: "size-6" })
                          ]),
                          _: 1
                        }, 8, ["next-page"])) : Z("", !0)
                      ])
                    ]),
                    _: 1
                  }),
                  C("div", wv, [
                    (S(!0), I(le, null, Ee(b, (_) => (S(), B(g(k7), {
                      key: _.value.toString(),
                      class: "w-full border-collapse select-none space-y-1"
                    }, {
                      default: D(() => [
                        j(g(D7), null, {
                          default: D(() => [
                            j(g(Ys), { class: "mb-1 grid w-full grid-cols-7" }, {
                              default: D(() => [
                                (S(!0), I(le, null, Ee(m, (x) => (S(), B(g(R7), {
                                  key: x,
                                  class: "text-green8 rounded-md text-xs"
                                }, {
                                  default: D(() => [
                                    Me(Q(x), 1)
                                  ]),
                                  _: 2
                                }, 1024))), 128))
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1024),
                        j(g(N7), { class: "grid" }, {
                          default: D(() => [
                            (S(!0), I(le, null, Ee(_.rows, (x, A) => (S(), B(g(Ys), {
                              key: `weekDate-${A}`,
                              class: "grid grid-cols-7"
                            }, {
                              default: D(() => [
                                (S(!0), I(le, null, Ee(x, (P) => (S(), B(g(I7), {
                                  key: P.toString(),
                                  date: P
                                }, {
                                  default: D(() => [
                                    j(g(F7), {
                                      day: P,
                                      month: _.value,
                                      class: "hover:bg-green5 data-[highlighted-end]:!dbg-primary-300 data-[today]:before:bg-green9 relative flex h-8 w-8 items-center justify-center whitespace-nowrap rounded-full text-sm font-normal text-black outline-none before:absolute before:top-[5px] before:hidden before:h-1 before:w-1 before:rounded-full before:bg-white focus:shadow-[0_0_0_2px] focus:shadow-black data-[unavailable]:pointer-events-none data-[highlighted]:bg-primary-100 data-[selected]:!bg-primary-300 data-[disabled]:text-black/30 data-[selected]:text-white data-[unavailable]:text-black/30 data-[unavailable]:line-through data-[today]:before:block"
                                    }, null, 8, ["day", "month"])
                                  ]),
                                  _: 2
                                }, 1032, ["date"]))), 128))
                              ]),
                              _: 2
                            }, 1024))), 128))
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1024))), 128))
                  ])
                ]),
                _: 1
              }, 8, ["model-value"])
            ]),
            _: 3
          }, 8, ["shown"])
        ]),
        _: 3
      }, 8, ["name", "label", "help-text"]);
    };
  }
}), _v = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 30 30",
  width: "20px",
  height: "15px"
};
function xv(e, t) {
  return S(), I("svg", _v, [...t[0] || (t[0] = [
    C("path", { d: "M 7 4 C 6.744125 4 6.4879687 4.0974687 6.2929688 4.2929688 L 4.2929688 6.2929688 C 3.9019687 6.6839688 3.9019687 7.3170313 4.2929688 7.7070312 L 11.585938 15 L 4.2929688 22.292969 C 3.9019687 22.683969 3.9019687 23.317031 4.2929688 23.707031 L 6.2929688 25.707031 C 6.6839688 26.098031 7.3170313 26.098031 7.7070312 25.707031 L 15 18.414062 L 22.292969 25.707031 C 22.682969 26.098031 23.317031 26.098031 23.707031 25.707031 L 25.707031 23.707031 C 26.098031 23.316031 26.098031 22.682969 25.707031 22.292969 L 18.414062 15 L 25.707031 7.7070312 C 26.098031 7.3170312 26.098031 6.6829688 25.707031 6.2929688 L 23.707031 4.2929688 C 23.316031 3.9019687 22.682969 3.9019687 22.292969 4.2929688 L 15 11.585938 L 7.7070312 4.2929688 C 7.5115312 4.0974687 7.255875 4 7 4 z" }, null, -1)
  ])]);
}
const Sv = ye({ name: "icon-cross", render: xv }), Cv = {
  width: "16px",
  height: "16px",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
function Pv(e, t) {
  return S(), I("svg", Cv, [...t[0] || (t[0] = [
    bu('<g data-name="Layer 2"><g data-name="external-link"><rect width="24" height="24" opacity="0"></rect><path d="M20 11a1 1 0 0 0-1 1v6a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h6a1 1 0 0 0 0-2H6a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3v-6a1 1 0 0 0-1-1z" fill="currentColor"></path><path d="M16 5h1.58l-6.29 6.28a1 1 0 0 0 0 1.42 1 1 0 0 0 1.42 0L19 6.42V8a1 1 0 0 0 1 1 1 1 0 0 0 1-1V4a1 1 0 0 0-1-1h-4a1 1 0 0 0 0 2z" fill="currentColor"></path></g></g>', 1)
  ])]);
}
const Av = ye({ name: "icon-external-link", render: Pv }), Ev = {
  id: "Layer_1",
  width: "30",
  height: "30",
  fill: "#5A607F",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 300 300"
};
function Mv(e, t) {
  return S(), I("svg", Ev, [...t[0] || (t[0] = [
    C("g", { id: "VWtw2D" }, [
      C("path", { d: "M149.92,239.81H87.7c-14.68,0-25.67-9-28.42-23.39a16.16,16.16,0,0,1-.24-2.95c0-11.29-.18-22.58,0-33.86a9.53,9.53,0,0,1,14.6-7.89,9.39,9.39,0,0,1,4.67,8.61q0,15.55,0,31.11c0,5.34,3.52,8.84,8.88,8.84l126.27,0a8.16,8.16,0,0,0,8-8c0-10.53,0-21.05,0-31.58,0-6.26,4.23-10.53,10-10.4a9.56,9.56,0,0,1,9.15,7.54,18.37,18.37,0,0,1,.33,3.63q0,14.64,0,29.29c0,17.12-12,29-29.11,29Z" }),
      C("path", { d: "M159.79,97v2.63q0,37.64,0,75.26c0,6.37-4.22,10.65-10.13,10.42a9.62,9.62,0,0,1-9.15-8.86c-.07-1-.06-2-.06-3V97l-1-.74a9,9,0,0,1-1.19,2.21q-12.48,12.58-25,25.09c-2.87,2.86-6.25,4-10.21,2.75a9.34,9.34,0,0,1-6.63-7.73,9.16,9.16,0,0,1,1.87-7.31,20.78,20.78,0,0,1,2-2.19L142.12,67.2c5.4-5.4,10.64-5.39,16,0l42.37,42.38c3.83,3.84,4.58,8.3,2.15,12.42a9.6,9.6,0,0,1-14.07,2.87,21.71,21.71,0,0,1-2.37-2.13Q174.1,110.64,162,98.48a8.33,8.33,0,0,1-1.13-2.25Z" })
    ], -1)
  ])]);
}
const Ov = ye({ name: "icon-upload", render: Mv }), Tv = { class: "relative flex items-center justify-between" }, kv = { class: "" }, Iv = ["for", "data-testid"], Rv = { class: "fdx-input-file__extensions flex" }, Dv = ["multiple", "accept", "data-testid", "id", "disabled"], Nv = {
  key: 0,
  class: "fdx-input-file__files grid gap-2"
}, Fv = { class: "flex items-center gap-1" }, Lv = ["title"], Wx = /* @__PURE__ */ V({
  __name: "FdxInputFile",
  props: /* @__PURE__ */ $e({
    allowedExtensions: { default: "image/png, image/jpeg, image/jpg, application/pdf" },
    allowedExtensionsLabel: {},
    disabled: { type: Boolean },
    helpText: {},
    hideRequiredAsterisk: { type: Boolean },
    label: {},
    multiple: { type: Boolean },
    name: {},
    readonly: { type: Boolean },
    validations: {}
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ $e(["openURL"], ["update:modelValue"]),
  setup(e, { emit: t }) {
    const r = At("inputRef"), n = Zr(), a = wr(e, ["allowedExtensions"]), d = Ae(e, "modelValue"), o = t, { isRequired: i, v$: l, value: s } = Be(a.name, a.validations, {
      initialValue: d.value
    });
    K(s, () => {
      s.value !== d.value && (d.value = s.value);
    }), K(d, () => {
      d.value !== s.value && (s.value = d.value);
    });
    const u = O(() => i.value && !a.hideRequiredAsterisk), $ = O(() => (n == null ? void 0 : n.id) ?? `fdx-input-file-${a.name}-label`), y = O(() => {
      var m;
      return (m = d.value) == null ? void 0 : m.map((b) => typeof b == "string" ? b : b.name);
    }), h = O(() => a.allowedExtensionsLabel ? a.allowedExtensionsLabel : `Only ${e.allowedExtensions.split(",").map((b) => {
      var _;
      return (_ = b.split("/").pop()) == null ? void 0 : _.toUpperCase();
    }).reduce((b, _, x, A) => _ ? A.length === 1 ? _ : x === 0 ? `${_}` : (b += x === A.length - 1 ? ` and ${_}` : `, ${_}`, b) : b, "")} files are allowed`), c = () => {
      var m;
      (m = r.value) == null || m.click();
    }, p = (m) => {
      if (a.disabled || a.readonly)
        return;
      const _ = m.target.files;
      _ && _.length > 0 ? d.value = Array.from(_) : d.value = void 0;
    }, f = () => {
      l.value[a.name].$touch();
    }, v = (m) => {
      const b = Array.from(d.value || []);
      b.splice(m, 1), d.value = b.length ? b : void 0;
    }, w = (m) => {
      var _;
      const b = (_ = d.value) == null ? void 0 : _[m];
      typeof b == "string" && o("openURL", b);
    };
    return (m, b) => {
      var L;
      const _ = Ov, x = at, A = Av, P = Vu, k = Sv, R = N3;
      return S(), I("div", null, [
        j(x, {
          name: m.name,
          "help-text": m.helpText
        }, {
          default: D(() => [
            C("div", Tv, [
              C("div", kv, [
                m.label ? (S(), I("label", {
                  key: 0,
                  class: de(["fdx-input-file__label block", {
                    "cursor-pointer": !m.disabled && !m.readonly,
                    "text-gray-500": m.disabled
                  }]),
                  onClick: Jt(c, ["prevent"]),
                  for: $.value,
                  "data-testid": g(Ul)(m.label)
                }, [
                  Me(Q(m.label) + " ", 1),
                  u.value ? (S(), I("span", {
                    key: 0,
                    class: de({
                      "text-negative-500": g(i) && !m.disabled,
                      "text-gray-600": m.disabled
                    })
                  }, " * ", 2)) : Z("", !0)
                ], 10, Iv)) : Z("", !0),
                C("div", Rv, [
                  C("span", {
                    class: de(["text-sm", {
                      "text-gray-700": !m.disabled,
                      "text-gray-600": m.disabled
                    }])
                  }, Q(h.value), 3)
                ])
              ]),
              F(m.$slots, "icon", {}, () => [
                j(_, { class: "size-9 text-gray-600" })
              ]),
              C("input", me({
                type: "file",
                multiple: m.multiple,
                accept: m.allowedExtensions,
                class: ["absolute inset-0 z-10 opacity-0", { "cursor-pointer": !m.disabled && !m.readonly }],
                "data-testid": g(Ul)(m.label),
                onChange: p,
                onBlur: f,
                ref_key: "inputRef",
                ref: r,
                name: "label",
                id: $.value,
                disabled: m.disabled || m.readonly
              }, g(n)), null, 16, Dv)
            ])
          ]),
          _: 3
        }, 8, ["name", "help-text"]),
        (L = y.value) != null && L.length ? (S(), I("div", Nv, [
          (S(!0), I(le, null, Ee(y.value, (N, U) => (S(), B(R, {
            key: U,
            class: "relative flex w-full items-center justify-between !p-3"
          }, {
            default: D(() => {
              var G;
              return [
                C("div", Fv, [
                  C("span", { title: N }, Q(g(qm)(N, { length: 30 })), 9, Lv),
                  typeof ((G = d.value) == null ? void 0 : G[U]) == "string" ? (S(), B(P, {
                    key: 0,
                    variant: "link",
                    onClick: (Y) => w(U),
                    class: "fdx-input-file__external-btn p-1",
                    type: "button"
                  }, {
                    default: D(() => [
                      j(A)
                    ]),
                    _: 2
                  }, 1032, ["onClick"])) : Z("", !0)
                ]),
                !m.disabled && !m.readonly ? (S(), B(P, {
                  key: 0,
                  variant: "link",
                  onClick: (Y) => v(U),
                  class: "fdx-input-file__delete-btn px-1",
                  type: "button"
                }, {
                  default: D(() => [
                    j(k)
                  ]),
                  _: 2
                }, 1032, ["onClick"])) : Z("", !0)
              ];
            }),
            _: 2
          }, 1024))), 128))
        ])) : Z("", !0)
      ]);
    };
  }
}), Bv = { key: 0 }, Vv = ["name", "disabled", "readonly", "placeholder"], jv = { key: 1 }, Gv = /* @__PURE__ */ V({
  inheritAttrs: !1,
  __name: "FdxInputText",
  props: /* @__PURE__ */ $e({
    class: { type: [Array, String, null, Number, Boolean] },
    containerClass: {},
    disabled: { type: Boolean },
    helpText: {},
    label: {},
    name: {},
    placeholder: {},
    readonly: { type: Boolean },
    validations: {}
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    const t = Ae(e, "modelValue"), { isFieldNotValidAndTouched: r, value: n } = Be(e.name, e.validations, {
      initialValue: t.value
    });
    return K(n, () => {
      n.value !== t.value && (t.value = n.value);
    }), K(t, () => {
      t.value !== n.value && (n.value = t.value);
    }), (a, d) => (S(), B(at, {
      name: a.name,
      label: a.label,
      "help-text": a.helpText,
      class: de(["fdx-form-item-container", { disabled: a.disabled }, a.containerClass])
    }, {
      default: D(() => [
        C("div", {
          class: de([
            "fdx-input-text__wrapper group/fdx-input-text flex overflow-hidden rounded-lg border focus-within:border-primary",
            {
              "border-red-600": g(r),
              "border-gray-300": !g(r)
            }
          ])
        }, [
          a.$slots.prefix ? (S(), I("div", Bv, [
            F(a.$slots, "prefix")
          ])) : Z("", !0),
          Xe(C("input", me({
            "onUpdate:modelValue": d[0] || (d[0] = (o) => $t(n) ? n.value = o : null),
            name: a.name,
            type: "text",
            class: [
              "input fdx-input-text",
              g(st)(
                "w-full bg-white px-3 py-2 outline-none disabled:bg-gray-400",
                g(r) ? "bg-negative-400" : "",
                e.class
              )
            ],
            disabled: a.disabled,
            readonly: a.readonly,
            placeholder: a.placeholder
          }, a.$attrs), null, 16, Vv), [
            [Un, g(n)]
          ]),
          a.$slots.suffix ? (S(), I("div", jv, [
            F(a.$slots, "suffix")
          ])) : Z("", !0)
        ], 2)
      ]),
      _: 3
    }, 8, ["name", "label", "help-text", "class"]));
  }
}), Uv = /* @__PURE__ */ V({
  __name: "FdxInputNumber",
  props: /* @__PURE__ */ $e({
    allowEmpty: { type: Boolean },
    disabled: { type: Boolean },
    formatter: { type: Function },
    helpText: {},
    label: {},
    max: {},
    min: {},
    name: {},
    precision: {},
    validations: {}
  }, {
    modelValue: {
      default: "",
      required: !1
    },
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ $e(["beforeinput"], ["update:modelValue"]),
  setup(e, { emit: t }) {
    const r = Ae(e, "modelValue"), n = t, a = H(""), d = H(!1), o = (c) => {
      if (c === "")
        return "";
      const p = Number(c);
      return isNaN(p) ? c : (e.formatter ?? ((v) => typeof e.precision == "number" && e.precision >= 0 ? v.toFixed(e.precision) : v.toString()))(p);
    }, i = (c) => c.replace(/[^\d.-]/g, ""), l = () => {
      if (e.allowEmpty && a.value.trim() === "") {
        r.value !== "" && (r.value = ""), a.value = "";
        return;
      }
      const c = Number(i(a.value));
      let p = isNaN(c) ? 0 : c;
      const f = e.max ?? Number.MAX_SAFE_INTEGER, v = e.min ?? -Number.MAX_SAFE_INTEGER;
      p > f ? p = f : p < v && (p = v);
      let w;
      typeof e.precision == "number" && e.precision >= 0 ? w = p.toFixed(e.precision) : w = p.toString(), w !== r.value && (r.value = w), a.value = o(w);
    }, s = yi(l, 500);
    K(
      () => r.value,
      (c) => {
        const p = o(c || "");
        (p !== a.value || !d.value) && (a.value = p);
      },
      { immediate: !0 }
    );
    const u = (c) => {
      if (e.formatter) {
        n("beforeinput", c);
        return;
      } else {
        const p = c.target, f = p.selectionStart ?? 0, v = p.selectionEnd ?? 0, w = c.data || "", m = p.value.slice(0, f) + w + p.value.slice(v);
        if (m !== "" && m !== "-" && !/^-?(?:\d+(?:\.\d*)?|\.\d*)$/.test(m)) {
          c.preventDefault();
          return;
        }
      }
      n("beforeinput", c);
    }, $ = (c) => {
      a.value = c || "", i(a.value).trim() !== "-" ? s() : s.cancel();
    }, y = () => {
      d.value = !0;
    }, h = () => {
      d.value = !1, s.cancel(), l();
    };
    return (c, p) => (S(), B(Gv, {
      name: c.name,
      disabled: c.disabled,
      label: c.label,
      "help-text": c.helpText,
      validations: c.validations,
      "model-value": a.value,
      "onUpdate:modelValue": $,
      onBeforeinput: u,
      onFocus: y,
      onBlur: h
    }, null, 8, ["name", "disabled", "label", "help-text", "validations", "model-value"]));
  }
}), Hv = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  width: "22px",
  height: "16px"
};
function Wv(e, t) {
  return S(), I("svg", Hv, [...t[0] || (t[0] = [
    C("path", { d: "M 4.2070312 2.7929688 L 2.7929688 4.2070312 L 5.0761719 6.4902344 C 2.1993447 8.8382005 1 12 1 12 C 1 12 4 20 12 20 C 14.075568 20 15.806003 19.45473 17.242188 18.65625 L 19.792969 21.207031 L 21.207031 19.792969 L 4.2070312 2.7929688 z M 12 4 C 10.788 4 9.7057969 4.1997187 8.7167969 4.5117188 L 11.277344 7.0722656 C 11.514344 7.0372656 11.753 7 12 7 C 14.761 7 17 9.239 17 12 C 17 12.247 16.962734 12.485656 16.927734 12.722656 L 20.357422 16.152344 C 22.204422 14.102344 23 12 23 12 C 23 12 20 4 12 4 z M 7.8339844 9.2480469 L 9.296875 10.710938 C 9.1081595 11.100829 9 11.536566 9 12 C 9 13.657 10.343 15 12 15 C 12.463434 15 12.899171 14.89184 13.289062 14.703125 L 14.751953 16.166016 C 13.962039 16.689758 13.019271 17 12 17 C 9.239 17 7 14.761 7 12 C 7 10.980729 7.3102415 10.037961 7.8339844 9.2480469 z" }, null, -1)
  ])]);
}
const zv = ye({ name: "icon-hide-password", render: Wv }), qv = {
  width: "22",
  height: "16",
  viewBox: "0 0 22 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function Kv(e, t) {
  return S(), I("svg", qv, [...t[0] || (t[0] = [
    C("path", {
      d: "M11 0.5C6 0.5 1.73 3.61 0 8C1.73 12.39 6 15.5 11 15.5C16 15.5 20.27 12.39 22 8C20.27 3.61 16 0.5 11 0.5ZM11 13C8.24 13 6 10.76 6 8C6 5.24 8.24 3 11 3C13.76 3 16 5.24 16 8C16 10.76 13.76 13 11 13ZM11 5C9.34 5 8 6.34 8 8C8 9.66 9.34 11 11 11C12.66 11 14 9.66 14 8C14 6.34 12.66 5 11 5Z",
      fill: "#1C1C1E"
    }, null, -1)
  ])]);
}
const Yv = ye({ name: "icon-show-password", render: Kv }), Zv = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Jv = ["clip-path"], Qv = ["id"];
function Xv(e, t) {
  return S(), I("svg", Zv, [
    C("g", {
      "clip-path": "url(#" + e.idMap.clip0_5_23054 + ")"
    }, [...t[0] || (t[0] = [
      C("path", {
        d: "M8.9999 16.2L4.7999 12L3.3999 13.4L8.9999 19L20.9999 6.99998L19.5999 5.59998L8.9999 16.2Z",
        fill: "currentColor"
      }, null, -1)
    ])], 8, Jv),
    C("defs", null, [
      C("clipPath", {
        id: e.idMap.clip0_5_23054
      }, [...t[1] || (t[1] = [
        C("rect", {
          width: "24",
          height: "24",
          fill: "currentColor"
        }, null, -1)
      ])], 8, Qv)
    ])
  ]);
}
const ey = ye({ name: "icon-done", render: Xv, setup() {
  return { idMap: { clip0_5_23054: "uicons-" + Math.random().toString(36).substr(2, 10) } };
} }), ty = { class: "flex" }, ry = { class: "relative w-full" }, ny = ["name", "type", "placeholder"], ay = {
  key: 0,
  class: "ltr:unset-left rtl:unset-right absolute inset-y-0 flex items-center ltr:right-10 rtl:left-10"
}, zx = /* @__PURE__ */ V({
  __name: "FdxInputPassword",
  props: /* @__PURE__ */ $e({
    helpText: {},
    label: {},
    name: {},
    placeholder: {},
    showPasswordIcon: { type: Boolean },
    validations: {}
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    const t = e, r = Ae(e, "modelValue"), { isFieldNotValid: n, isFieldNotValidAndTouched: a, value: d } = Be(
      t.name,
      t.validations,
      { initialValue: r.value }
    ), o = H(!1);
    function i() {
      o.value = !o.value;
    }
    return K(d, () => {
      d.value !== r.value && (r.value = d.value);
    }), K(r, () => {
      r.value !== d.value && (d.value = r.value);
    }), (l, s) => {
      const u = ey, $ = Yv, y = zv;
      return S(), B(at, {
        label: l.label,
        "help-text": l.helpText,
        name: l.name
      }, {
        default: D(() => [
          C("div", ty, [
            C("div", ry, [
              Xe(C("input", me({
                "onUpdate:modelValue": s[0] || (s[0] = (h) => $t(d) ? d.value = h : null),
                name: l.name,
                type: o.value ? "text" : "password",
                class: ["input w-full rounded-lg border border-gray-300 bg-white p-2 px-3 outline-none focus-within:border-primary", {
                  "!border-red-600": g(a),
                  "!pe-16": l.showPasswordIcon
                }],
                placeholder: l.placeholder
              }, l.$attrs), null, 16, ny), [
                [U2, g(d)]
              ]),
              l.showPasswordIcon ? (S(), I(le, { key: 0 }, [
                g(n) ? Z("", !0) : (S(), I("div", ay, [
                  j(u, {
                    class: "h-5 w-5 text-positive-500",
                    "data-testid": "icon-done"
                  })
                ])),
                C("button", {
                  type: "button",
                  class: "ltr:unset-left rtl:unset-right absolute inset-y-0 flex items-center ltr:right-4 rtl:left-4",
                  tabindex: -1,
                  onClick: i
                }, [
                  Xe(j($, { class: "h-4 w-4" }, null, 512), [
                    [xo, !o.value]
                  ]),
                  Xe(j(y, { class: "h-4 w-4" }, null, 512), [
                    [xo, o.value]
                  ])
                ])
              ], 64)) : Z("", !0)
            ])
          ])
        ]),
        _: 1
      }, 8, ["label", "help-text", "name"]);
    };
  }
}), dy = { class: "text-footnote text-gray-600" }, oy = {
  "data-testid": "fdx-input-select-dropdown-menu",
  class: "flex max-h-72 flex-col gap-2 p-2"
}, iy = ["placeholder"], ly = {
  "data-testid": "fdx-input-select-option-list",
  class: "flex flex-col gap-y-2"
}, sy = {
  "data-testid": "fdx-input-select-no-options",
  class: "text-footnote text-gray-600"
}, uy = ["onClick"], cy = { class: "flex items-center gap-x-2" }, fy = { key: 0 }, $y = /* @__PURE__ */ V({
  __name: "FdxInputSelect",
  props: /* @__PURE__ */ $e({
    disabled: { type: Boolean, default: !1 },
    helpText: { default: () => {
    } },
    label: { default: () => {
    } },
    multiple: { type: Boolean, default: !1 },
    name: {},
    optionLabel: { default: "label" },
    options: {},
    optionValue: { default: "value" },
    placeholder: { default: "Select a value" },
    searchable: { type: Boolean, default: !1 },
    searchKeys: { default: () => ["label"] },
    searchPlaceholder: { default: "Type something to start searching" },
    validations: { default: () => {
    } },
    variant: { default: "sm" }
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    const t = H(""), r = H2([]);
    function n(c) {
      return e.searchKeys.map((p) => String(c[p] ?? "")).join(" ").toLowerCase();
    }
    const a = yi(() => {
      const c = t.value.trim().toLowerCase();
      let p = e.options.filter((f) => c ? n(f).includes(c) : !0);
      c && (p = p.sort((f, v) => {
        const w = n(f), m = n(v);
        return w.indexOf(c) - m.indexOf(c);
      })), r.value = p;
    }, 300);
    K([t, () => e.options], a, { deep: !0, immediate: !0 });
    function d(c) {
      return c[e.optionLabel] || "";
    }
    function o(c) {
      return c[e.optionValue] || "";
    }
    const i = Ae(e, "modelValue"), { isFieldNotValidAndTouched: l, value: s } = Be(e.name, e.validations, {
      initialValue: i.value
    });
    K(s, () => {
      s.value !== i.value && (i.value = s.value);
    }), K(i, () => {
      i.value !== s.value && (s.value = i.value);
    });
    const u = O(() => e.multiple ? e.options.filter((c) => (s.value || []).includes(o(c))) : e.options.find((c) => o(c) === s.value));
    function $(c, p) {
      const f = o(c);
      if (e.multiple) {
        (s.value || []).includes(f) ? s.value = s.value.filter((w) => w !== f) : s.value = (s.value || []).concat(f);
        return;
      }
      s.value = f, p == null || p();
    }
    const y = O(() => !gi(u.value));
    function h(c) {
      var p;
      return e.multiple ? !!((p = u.value) != null && p.includes(c)) : u.value === c;
    }
    return (c, p) => {
      const f = Ni, v = X1, w = ec;
      return S(), B(at, {
        label: c.label,
        "help-text": c.helpText,
        name: c.name
      }, {
        default: D(() => [
          j(bi, {
            placement: "bottom",
            triggers: ["click"],
            disabled: c.disabled,
            display: "block",
            "auto-min-size": ""
          }, {
            trigger: D(() => [
              C("div", {
                "data-testid": "fdx-input-select-trigger",
                class: de(["flex cursor-pointer items-center justify-between rounded-lg border border-gray-500", {
                  "px-4 py-2": c.variant === "sm",
                  "px-4 py-3": c.variant === "md",
                  "p-4": c.variant === "lg",
                  "border-red-600": g(l),
                  "cursor-not-allowed": c.disabled,
                  "cursor-pointer": !c.disabled
                }])
              }, [
                y.value ? Z("", !0) : F(c.$slots, "placeholder", { key: 0 }, () => [
                  C("span", dy, Q(c.placeholder), 1)
                ]),
                y.value && !c.multiple ? F(c.$slots, "selected", {
                  key: 1,
                  selectedOption: u.value
                }, () => [
                  Me(Q(d(u.value)), 1)
                ]) : Z("", !0),
                y.value && c.multiple ? F(c.$slots, "multiple-selected", {
                  key: 2,
                  selectedOptions: u.value
                }, () => [
                  Me(" (" + Q(u.value.length) + ") Selected ", 1)
                ]) : Z("", !0),
                j(f, { class: "ms-2 flex-shrink-0" })
              ], 2)
            ]),
            menu: D(({ hide: m }) => [
              C("div", oy, [
                c.searchable ? Xe((S(), I("input", {
                  key: 0,
                  ref: "input",
                  "data-testid": "fdx-input-select-search-input",
                  "onUpdate:modelValue": p[0] || (p[0] = (b) => t.value = b),
                  type: "text",
                  class: "block w-full rounded-lg border border-gray-400 bg-white p-2 outline-none",
                  placeholder: c.searchPlaceholder
                }, null, 8, iy)), [
                  [Un, t.value]
                ]) : Z("", !0),
                C("ul", ly, [
                  r.value.length ? Z("", !0) : F(c.$slots, "empty", {
                    key: 0,
                    searchTerm: t.value
                  }, () => [
                    C("div", sy, [
                      t.value ? (S(), I(le, { key: 0 }, [
                        Me("No results for " + Q(t.value), 1)
                      ], 64)) : (S(), I(le, { key: 1 }, [
                        Me("No options available")
                      ], 64))
                    ])
                  ]),
                  (S(!0), I(le, null, Ee(r.value, (b) => (S(), I("li", {
                    key: o(b),
                    "data-testid": "fdx-input-select-option",
                    class: de(["cursor-pointer rounded-lg text-body text-gray-1000 transition-colors hover:bg-gray-200", {
                      "px-4 py-2": c.variant === "sm",
                      "px-4 py-3": c.variant === "md",
                      "px-4 py-4": c.variant === "lg"
                    }]),
                    onClick: (_) => $(b, m)
                  }, [
                    F(c.$slots, "option", {
                      option: b,
                      isSelected: h(b)
                    }, () => [
                      C("div", cy, [
                        c.multiple ? (S(), I("div", fy, [
                          h(b) ? (S(), B(v, {
                            key: 0,
                            class: "size-6 text-primary-300"
                          })) : (S(), B(w, {
                            key: 1,
                            class: "size-6 text-gray-500"
                          }))
                        ])) : Z("", !0),
                        C("span", null, Q(d(b)), 1)
                      ])
                    ])
                  ], 10, uy))), 128))
                ])
              ])
            ]),
            _: 3
          }, 8, ["disabled"])
        ]),
        _: 3
      }, 8, ["label", "help-text", "name"]);
    };
  }
});
function Zs(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function kn(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Zs(Object(r), !0).forEach(function(n) {
      py(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Zs(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function py(e, t, r) {
  return t in e ? Object.defineProperty(e, t, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = r, e;
}
function Ta(e) {
  return typeof e == "function";
}
function ei(e) {
  return e !== null && typeof e == "object" && !Array.isArray(e);
}
function za(e) {
  return Ta(e.$validator) ? kn({}, e) : {
    $validator: e
  };
}
function Xc(e) {
  return typeof e == "object" ? e.$valid : e;
}
function e2(e) {
  return e.$validator || e;
}
function my(e, t) {
  if (!ei(e)) throw new Error(`[@vuelidate/validators]: First parameter to "withParams" should be an object, provided ${typeof e}`);
  if (!ei(t) && !Ta(t)) throw new Error("[@vuelidate/validators]: Validator must be a function or object with $validator parameter");
  const r = za(t);
  return r.$params = kn(kn({}, r.$params || {}), e), r;
}
function hy(e, t) {
  if (!Ta(e) && typeof g(e) != "string") throw new Error(`[@vuelidate/validators]: First parameter to "withMessage" should be string or a function returning a string, provided ${typeof e}`);
  if (!ei(t) && !Ta(t)) throw new Error("[@vuelidate/validators]: Validator must be a function or object with $validator parameter");
  const r = za(t);
  return r.$message = e, r;
}
function vy(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
  const r = za(e);
  return kn(kn({}, r), {}, {
    $async: !0,
    $watchTargets: t
  });
}
function yy(e) {
  return {
    $validator(t) {
      for (var r = arguments.length, n = new Array(r > 1 ? r - 1 : 0), a = 1; a < r; a++)
        n[a - 1] = arguments[a];
      return g(t).reduce((d, o, i) => {
        const l = Object.entries(o).reduce((s, u) => {
          let [$, y] = u;
          const h = e[$] || {}, c = Object.entries(h).reduce((p, f) => {
            let [v, w] = f;
            const b = e2(w).call(this, y, o, i, ...n), _ = Xc(b);
            if (p.$data[v] = b, p.$data.$invalid = !_ || !!p.$data.$invalid, p.$data.$error = p.$data.$invalid, !_) {
              let x = w.$message || "";
              const A = w.$params || {};
              typeof x == "function" && (x = x({
                $pending: !1,
                $invalid: !_,
                $params: A,
                $model: y,
                $response: b
              })), p.$errors.push({
                $property: $,
                $message: x,
                $params: A,
                $response: b,
                $model: y,
                $pending: !1,
                $validator: v
              });
            }
            return {
              $valid: p.$valid && _,
              $data: p.$data,
              $errors: p.$errors
            };
          }, {
            $valid: !0,
            $data: {},
            $errors: []
          });
          return s.$data[$] = c.$data, s.$errors[$] = c.$errors, {
            $valid: s.$valid && c.$valid,
            $data: s.$data,
            $errors: s.$errors
          };
        }, {
          $valid: !0,
          $data: {},
          $errors: {}
        });
        return {
          $valid: d.$valid && l.$valid,
          $data: d.$data.concat(l.$data),
          $errors: d.$errors.concat(l.$errors)
        };
      }, {
        $valid: !0,
        $data: [],
        $errors: []
      });
    },
    $message: (t) => {
      let {
        $response: r
      } = t;
      return r ? r.$errors.map((n) => Object.values(n).map((a) => a.map((d) => d.$message)).reduce((a, d) => a.concat(d), [])) : [];
    }
  };
}
const t2 = (e) => {
  if (e = g(e), Array.isArray(e)) return !!e.length;
  if (e == null)
    return !1;
  if (e === !1)
    return !0;
  if (e instanceof Date)
    return !isNaN(e.getTime());
  if (typeof e == "object") {
    for (let t in e) return !0;
    return !1;
  }
  return !!String(e).length;
}, gy = (e) => (e = g(e), Array.isArray(e) ? e.length : typeof e == "object" ? Object.keys(e).length : String(e).length);
function dr() {
  for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++)
    t[r] = arguments[r];
  return (n) => (n = g(n), !t2(n) || t.every((a) => (a.lastIndex = 0, a.test(n))));
}
var ti = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  forEach: yy,
  len: gy,
  normalizeValidatorObject: za,
  regex: dr,
  req: t2,
  unwrap: g,
  unwrapNormalizedValidator: e2,
  unwrapValidatorResponse: Xc,
  withAsync: vy,
  withMessage: hy,
  withParams: my
});
dr(/^[a-zA-Z]*$/);
dr(/^[a-zA-Z0-9]*$/);
dr(/^\d*(\.\d+)?$/);
const by = /^(?:[A-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[A-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9]{2,}(?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/i;
dr(by);
const wy = /^(?:(?:(?:https?|ftp):)?\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z0-9\u00a1-\uffff][a-z0-9\u00a1-\uffff_-]{0,62})?[a-z0-9\u00a1-\uffff]\.)+(?:[a-z\u00a1-\uffff]{2,}\.?))(?::\d{2,5})?(?:[/?#]\S*)?$/i;
dr(wy);
dr(/(^[0-9]*$)|(^-[0-9]+$)/);
dr(/^[-]?\d*(\.\d+)?$/);
const _y = { version: 4, country_calling_codes: { 1: ["US", "AG", "AI", "AS", "BB", "BM", "BS", "CA", "DM", "DO", "GD", "GU", "JM", "KN", "KY", "LC", "MP", "MS", "PR", "SX", "TC", "TT", "VC", "VG", "VI"], 7: ["RU", "KZ"], 20: ["EG"], 27: ["ZA"], 30: ["GR"], 31: ["NL"], 32: ["BE"], 33: ["FR"], 34: ["ES"], 36: ["HU"], 39: ["IT", "VA"], 40: ["RO"], 41: ["CH"], 43: ["AT"], 44: ["GB", "GG", "IM", "JE"], 45: ["DK"], 46: ["SE"], 47: ["NO", "SJ"], 48: ["PL"], 49: ["DE"], 51: ["PE"], 52: ["MX"], 53: ["CU"], 54: ["AR"], 55: ["BR"], 56: ["CL"], 57: ["CO"], 58: ["VE"], 60: ["MY"], 61: ["AU", "CC", "CX"], 62: ["ID"], 63: ["PH"], 64: ["NZ"], 65: ["SG"], 66: ["TH"], 81: ["JP"], 82: ["KR"], 84: ["VN"], 86: ["CN"], 90: ["TR"], 91: ["IN"], 92: ["PK"], 93: ["AF"], 94: ["LK"], 95: ["MM"], 98: ["IR"], 211: ["SS"], 212: ["MA", "EH"], 213: ["DZ"], 216: ["TN"], 218: ["LY"], 220: ["GM"], 221: ["SN"], 222: ["MR"], 223: ["ML"], 224: ["GN"], 225: ["CI"], 226: ["BF"], 227: ["NE"], 228: ["TG"], 229: ["BJ"], 230: ["MU"], 231: ["LR"], 232: ["SL"], 233: ["GH"], 234: ["NG"], 235: ["TD"], 236: ["CF"], 237: ["CM"], 238: ["CV"], 239: ["ST"], 240: ["GQ"], 241: ["GA"], 242: ["CG"], 243: ["CD"], 244: ["AO"], 245: ["GW"], 246: ["IO"], 247: ["AC"], 248: ["SC"], 249: ["SD"], 250: ["RW"], 251: ["ET"], 252: ["SO"], 253: ["DJ"], 254: ["KE"], 255: ["TZ"], 256: ["UG"], 257: ["BI"], 258: ["MZ"], 260: ["ZM"], 261: ["MG"], 262: ["RE", "YT"], 263: ["ZW"], 264: ["NA"], 265: ["MW"], 266: ["LS"], 267: ["BW"], 268: ["SZ"], 269: ["KM"], 290: ["SH", "TA"], 291: ["ER"], 297: ["AW"], 298: ["FO"], 299: ["GL"], 350: ["GI"], 351: ["PT"], 352: ["LU"], 353: ["IE"], 354: ["IS"], 355: ["AL"], 356: ["MT"], 357: ["CY"], 358: ["FI", "AX"], 359: ["BG"], 370: ["LT"], 371: ["LV"], 372: ["EE"], 373: ["MD"], 374: ["AM"], 375: ["BY"], 376: ["AD"], 377: ["MC"], 378: ["SM"], 380: ["UA"], 381: ["RS"], 382: ["ME"], 383: ["XK"], 385: ["HR"], 386: ["SI"], 387: ["BA"], 389: ["MK"], 420: ["CZ"], 421: ["SK"], 423: ["LI"], 500: ["FK"], 501: ["BZ"], 502: ["GT"], 503: ["SV"], 504: ["HN"], 505: ["NI"], 506: ["CR"], 507: ["PA"], 508: ["PM"], 509: ["HT"], 590: ["GP", "BL", "MF"], 591: ["BO"], 592: ["GY"], 593: ["EC"], 594: ["GF"], 595: ["PY"], 596: ["MQ"], 597: ["SR"], 598: ["UY"], 599: ["CW", "BQ"], 670: ["TL"], 672: ["NF"], 673: ["BN"], 674: ["NR"], 675: ["PG"], 676: ["TO"], 677: ["SB"], 678: ["VU"], 679: ["FJ"], 680: ["PW"], 681: ["WF"], 682: ["CK"], 683: ["NU"], 685: ["WS"], 686: ["KI"], 687: ["NC"], 688: ["TV"], 689: ["PF"], 690: ["TK"], 691: ["FM"], 692: ["MH"], 850: ["KP"], 852: ["HK"], 853: ["MO"], 855: ["KH"], 856: ["LA"], 880: ["BD"], 886: ["TW"], 960: ["MV"], 961: ["LB"], 962: ["JO"], 963: ["SY"], 964: ["IQ"], 965: ["KW"], 966: ["SA"], 967: ["YE"], 968: ["OM"], 970: ["PS"], 971: ["AE"], 972: ["IL"], 973: ["BH"], 974: ["QA"], 975: ["BT"], 976: ["MN"], 977: ["NP"], 992: ["TJ"], 993: ["TM"], 994: ["AZ"], 995: ["GE"], 996: ["KG"], 998: ["UZ"] }, countries: { AC: ["247", "00", "(?:[01589]\\d|[46])\\d{4}", [5, 6]], AD: ["376", "00", "(?:1|6\\d)\\d{7}|[135-9]\\d{5}", [6, 8, 9], [["(\\d{3})(\\d{3})", "$1 $2", ["[135-9]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["1"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]]]], AE: ["971", "00", "(?:[4-7]\\d|9[0-689])\\d{7}|800\\d{2,9}|[2-4679]\\d{7}", [5, 6, 7, 8, 9, 10, 11, 12], [["(\\d{3})(\\d{2,9})", "$1 $2", ["60|8"]], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[236]|[479][2-8]"], "0$1"], ["(\\d{3})(\\d)(\\d{5})", "$1 $2 $3", ["[479]"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["5"], "0$1"]], "0"], AF: ["93", "00", "[2-7]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-7]"], "0$1"]], "0"], AG: ["1", "011", "(?:268|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([457]\\d{6})$|1", "268$1", 0, "268"], AI: ["1", "011", "(?:264|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2457]\\d{6})$|1", "264$1", 0, "264"], AL: ["355", "00", "(?:700\\d\\d|900)\\d{3}|8\\d{5,7}|(?:[2-5]|6\\d)\\d{7}", [6, 7, 8, 9], [["(\\d{3})(\\d{3,4})", "$1 $2", ["80|9"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["4[2-6]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2358][2-5]|4"], "0$1"], ["(\\d{3})(\\d{5})", "$1 $2", ["[23578]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["6"], "0$1"]], "0"], AM: ["374", "00", "(?:[1-489]\\d|55|60|77)\\d{6}", [8], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[89]0"], "0 $1"], ["(\\d{3})(\\d{5})", "$1 $2", ["2|3[12]"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["1|47"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["[3-9]"], "0$1"]], "0"], AO: ["244", "00", "[29]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[29]"]]]], AR: ["54", "00", "(?:11|[89]\\d\\d)\\d{8}|[2368]\\d{9}", [10, 11], [["(\\d{4})(\\d{2})(\\d{4})", "$1 $2-$3", ["2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9])", "2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8]))|2(?:2[24-9]|3[1-59]|47)", "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5[56][46]|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]", "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|58|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|54(?:4|5[13-7]|6[89])|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:454|85[56])[46]|3(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"], "0$1", 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2-$3", ["1"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[68]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2-$3", ["[23]"], "0$1", 1], ["(\\d)(\\d{4})(\\d{2})(\\d{4})", "$2 15-$3-$4", ["9(?:2[2-469]|3[3-578])", "9(?:2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9]))", "9(?:2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8])))|92(?:2[24-9]|3[1-59]|47)", "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5(?:[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]", "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|5(?:4(?:4|5[13-7]|6[89])|[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"], "0$1", 0, "$1 $2 $3-$4"], ["(\\d)(\\d{2})(\\d{4})(\\d{4})", "$2 15-$3-$4", ["91"], "0$1", 0, "$1 $2 $3-$4"], ["(\\d{3})(\\d{3})(\\d{5})", "$1-$2-$3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{4})", "$2 15-$3-$4", ["9"], "0$1", 0, "$1 $2 $3-$4"]], "0", 0, "0?(?:(11|2(?:2(?:02?|[13]|2[13-79]|4[1-6]|5[2457]|6[124-8]|7[1-4]|8[13-6]|9[1267])|3(?:02?|1[467]|2[03-6]|3[13-8]|[49][2-6]|5[2-8]|[67])|4(?:7[3-578]|9)|6(?:[0136]|2[24-6]|4[6-8]?|5[15-8])|80|9(?:0[1-3]|[19]|2\\d|3[1-6]|4[02568]?|5[2-4]|6[2-46]|72?|8[23]?))|3(?:3(?:2[79]|6|8[2578])|4(?:0[0-24-9]|[12]|3[5-8]?|4[24-7]|5[4-68]?|6[02-9]|7[126]|8[2379]?|9[1-36-8])|5(?:1|2[1245]|3[237]?|4[1-46-9]|6[2-4]|7[1-6]|8[2-5]?)|6[24]|7(?:[069]|1[1568]|2[15]|3[145]|4[13]|5[14-8]|7[2-57]|8[126])|8(?:[01]|2[15-7]|3[2578]?|4[13-6]|5[4-8]?|6[1-357-9]|7[36-8]?|8[5-8]?|9[124])))15)?", "9$1"], AS: ["1", "011", "(?:[58]\\d\\d|684|900)\\d{7}", [10], 0, "1", 0, "([267]\\d{6})$|1", "684$1", 0, "684"], AT: ["43", "00", "1\\d{3,12}|2\\d{6,12}|43(?:(?:0\\d|5[02-9])\\d{3,9}|2\\d{4,5}|[3467]\\d{4}|8\\d{4,6}|9\\d{4,7})|5\\d{4,12}|8\\d{7,12}|9\\d{8,12}|(?:[367]\\d|4[0-24-9])\\d{4,11}", [4, 5, 6, 7, 8, 9, 10, 11, 12, 13], [["(\\d)(\\d{3,12})", "$1 $2", ["1(?:11|[2-9])"], "0$1"], ["(\\d{3})(\\d{2})", "$1 $2", ["517"], "0$1"], ["(\\d{2})(\\d{3,5})", "$1 $2", ["5[079]"], "0$1"], ["(\\d{3})(\\d{3,10})", "$1 $2", ["(?:31|4)6|51|6(?:48|5[0-3579]|[6-9])|7(?:20|32|8)|[89]", "(?:31|4)6|51|6(?:485|5[0-3579]|[6-9])|7(?:20|32|8)|[89]"], "0$1"], ["(\\d{4})(\\d{3,9})", "$1 $2", ["[2-467]|5[2-6]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4,7})", "$1 $2 $3", ["5"], "0$1"]], "0"], AU: ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{7}(?:\\d(?:\\d{2})?)?|8[0-24-9]\\d{7})|[2-478]\\d{8}|1\\d{4,7}", [5, 6, 7, 8, 9, 10, 12], [["(\\d{2})(\\d{3,4})", "$1 $2", ["16"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,4})", "$1 $2 $3", ["16"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["14|4"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["[2378]"], "(0$1)"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1(?:30|[89])"]]], "0", 0, "(183[12])|0", 0, 0, 0, [["(?:(?:2(?:(?:[0-26-9]\\d|3[0-8]|5[0135-9])\\d|4(?:[02-9]\\d|10))|3(?:(?:[0-3589]\\d|6[1-9]|7[0-35-9])\\d|4(?:[0-578]\\d|90))|7(?:[013-57-9]\\d|2[0-8])\\d)\\d\\d|8(?:51(?:0(?:0[03-9]|[12479]\\d|3[2-9]|5[0-8]|6[1-9]|8[0-7])|1(?:[0235689]\\d|1[0-69]|4[0-589]|7[0-47-9])|2(?:0[0-79]|[18][13579]|2[14-9]|3[0-46-9]|[4-6]\\d|7[89]|9[0-4])|[34]\\d\\d)|(?:6[0-8]|[78]\\d)\\d{3}|9(?:[02-9]\\d{3}|1(?:(?:[0-58]\\d|6[0135-9])\\d|7(?:0[0-24-9]|[1-9]\\d)|9(?:[0-46-9]\\d|5[0-79])))))\\d{3}", [9]], ["4(?:79[01]|83[0-389]|94[0-478])\\d{5}|4(?:[0-36]\\d|4[047-9]|[58][0-24-9]|7[02-8]|9[0-37-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, ["163\\d{2,6}", [5, 6, 7, 8, 9]], ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [6, 8, 10, 12]]], "0011"], AW: ["297", "00", "(?:[25-79]\\d\\d|800)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[25-9]"]]]], AX: ["358", "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))", "2\\d{4,9}|35\\d{4,5}|(?:60\\d\\d|800)\\d{4,6}|7\\d{5,11}|(?:[14]\\d|3[0-46-9]|50)\\d{4,8}", [5, 6, 7, 8, 9, 10, 11, 12], 0, "0", 0, 0, 0, 0, "18", 0, "00"], AZ: ["994", "00", "365\\d{6}|(?:[124579]\\d|60|88)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["90"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[28]|2|365|46", "1[28]|2|365[45]|46", "1[28]|2|365(?:4|5[02])|46"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[13-9]"], "0$1"]], "0"], BA: ["387", "00", "6\\d{8}|(?:[35689]\\d|49|70)\\d{6}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["6[1-3]|[7-9]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2-$3", ["[3-5]|6[56]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["6"], "0$1"]], "0"], BB: ["1", "011", "(?:246|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "246$1", 0, "246"], BD: ["880", "00", "[1-469]\\d{9}|8[0-79]\\d{7,8}|[2-79]\\d{8}|[2-9]\\d{7}|[3-9]\\d{6}|[57-9]\\d{5}", [6, 7, 8, 9, 10], [["(\\d{2})(\\d{4,6})", "$1-$2", ["31[5-8]|[459]1"], "0$1"], ["(\\d{3})(\\d{3,7})", "$1-$2", ["3(?:[67]|8[013-9])|4(?:6[168]|7|[89][18])|5(?:6[128]|9)|6(?:[15]|28|4[14])|7[2-589]|8(?:0[014-9]|[12])|9[358]|(?:3[2-5]|4[235]|5[2-578]|6[0389]|76|8[3-7]|9[24])1|(?:44|66)[01346-9]"], "0$1"], ["(\\d{4})(\\d{3,6})", "$1-$2", ["[13-9]|2[23]"], "0$1"], ["(\\d)(\\d{7,8})", "$1-$2", ["2"], "0$1"]], "0"], BE: ["32", "00", "4\\d{8}|[1-9]\\d{7}", [8, 9], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:80|9)0"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[239]|4[23]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[15-8]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["4"], "0$1"]], "0"], BF: ["226", "00", "(?:[025-7]\\d|44)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[024-7]"]]]], BG: ["359", "00", "00800\\d{7}|[2-7]\\d{6,7}|[89]\\d{6,8}|2\\d{5}", [6, 7, 8, 9, 12], [["(\\d)(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["2"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["43[1-6]|70[1-9]"], "0$1"], ["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:70|8)0"], "0$1"], ["(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3", ["43[1-7]|7"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[48]|9[08]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1"]], "0"], BH: ["973", "00", "[136-9]\\d{7}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[13679]|8[02-4679]"]]]], BI: ["257", "00", "(?:[267]\\d|31)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2367]"]]]], BJ: ["229", "00", "(?:01\\d|[24-689])\\d{7}", [8, 10], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24-689]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["0"]]]], BL: ["590", "00", "(?:590\\d|7090)\\d{5}|(?:69|80|9\\d)\\d{7}", [9], 0, "0", 0, 0, 0, 0, 0, [["590(?:2[7-9]|3[3-7]|5[12]|87)\\d{4}"], ["(?:69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))|7090[0-4])\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:(?:39[5-7]|76[018])\\d|475[0-6])\\d{4}"]]], BM: ["1", "011", "(?:441|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "441$1", 0, "441"], BN: ["673", "00", "[2-578]\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-578]"]]]], BO: ["591", "00(?:1\\d)?", "8001\\d{5}|(?:[2-467]\\d|50)\\d{6}", [8, 9], [["(\\d)(\\d{7})", "$1 $2", ["[235]|4[46]"]], ["(\\d{8})", "$1", ["[67]"]], ["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["8"]]], "0", 0, "0(1\\d)?"], BQ: ["599", "00", "(?:[34]1|7\\d)\\d{5}", [7], 0, 0, 0, 0, 0, 0, "[347]"], BR: ["55", "00(?:1[245]|2[1-35]|31|4[13]|[56]5|99)", "[1-467]\\d{9,10}|55[0-46-9]\\d{8}|[34]\\d{7}|55\\d{7,8}|(?:5[0-46-9]|[89]\\d)\\d{7,9}", [8, 9, 10, 11], [["(\\d{4})(\\d{4})", "$1-$2", ["300|4(?:0[02]|37|86)", "300|4(?:0(?:0|20)|370|864)"]], ["(\\d{3})(\\d{2,3})(\\d{4})", "$1 $2 $3", ["(?:[358]|90)0"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2-$3", ["(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-57]"], "($1)"], ["(\\d{2})(\\d{5})(\\d{4})", "$1 $2-$3", ["[16][1-9]|[2-57-9]"], "($1)"]], "0", 0, "(?:0|90)(?:(1[245]|2[1-35]|31|4[13]|[56]5|99)(\\d{10,11}))?", "$2"], BS: ["1", "011", "(?:242|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([3-8]\\d{6})$|1", "242$1", 0, "242"], BT: ["975", "00", "[17]\\d{7}|[2-8]\\d{6}", [7, 8], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-68]|7[246]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[67]|7"]]]], BW: ["267", "00", "(?:0800|(?:[37]|800)\\d)\\d{6}|(?:[2-6]\\d|90)\\d{5}", [7, 8, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["90"]], ["(\\d{3})(\\d{4})", "$1 $2", ["[24-6]|3[15-9]"]], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[37]"]], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["0"]], ["(\\d{3})(\\d{4})(\\d{3})", "$1 $2 $3", ["8"]]]], BY: ["375", "810", "(?:[12]\\d|33|44|902)\\d{7}|8(?:0[0-79]\\d{5,7}|[1-7]\\d{9})|8(?:1[0-489]|[5-79]\\d)\\d{7}|8[1-79]\\d{6,7}|8[0-79]\\d{5}|8\\d{5}", [6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{3})", "$1 $2", ["800"], "8 $1"], ["(\\d{3})(\\d{2})(\\d{2,4})", "$1 $2 $3", ["800"], "8 $1"], ["(\\d{4})(\\d{2})(\\d{3})", "$1 $2-$3", ["1(?:5[169]|6[3-5]|7[179])|2(?:1[35]|2[34]|3[3-5])", "1(?:5[169]|6(?:3[1-3]|4|5[125])|7(?:1[3-9]|7[0-24-6]|9[2-7]))|2(?:1[35]|2[34]|3[3-5])"], "8 0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["1(?:[56]|7[467])|2[1-3]"], "8 0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[1-4]"], "8 0$1"], ["(\\d{3})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["[89]"], "8 $1"]], "8", 0, "0|80?", 0, 0, 0, 0, "8~10"], BZ: ["501", "00", "(?:0800\\d|[2-8])\\d{6}", [7, 11], [["(\\d{3})(\\d{4})", "$1-$2", ["[2-8]"]], ["(\\d)(\\d{3})(\\d{4})(\\d{3})", "$1-$2-$3-$4", ["0"]]]], CA: ["1", "011", "[2-9]\\d{9}|3\\d{6}", [7, 10], 0, "1", 0, 0, 0, 0, 0, [["(?:2(?:04|[23]6|[48]9|5[07]|63)|3(?:06|43|54|6[578]|82)|4(?:03|1[68]|[26]8|3[178]|50|74)|5(?:06|1[49]|48|79|8[147])|6(?:04|[18]3|39|47|72)|7(?:0[59]|42|53|78|8[02])|8(?:[06]7|19|25|7[39])|9(?:0[25]|42))[2-9]\\d{6}", [10]], ["", [10]], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", [10]], ["900[2-9]\\d{6}", [10]], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|(?:5(?:2[125-9]|33|44|66|77|88)|6(?:22|33))[2-9]\\d{6}", [10]], 0, ["310\\d{4}", [7]], 0, ["600[2-9]\\d{6}", [10]]]], CC: ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}", [6, 7, 8, 9, 10, 12], 0, "0", 0, "([59]\\d{7})$|0", "8$1", 0, 0, [["8(?:51(?:0(?:02|31|60|89)|1(?:18|76)|223)|91(?:0(?:1[0-2]|29)|1(?:[28]2|50|79)|2(?:10|64)|3(?:[06]8|22)|4[29]8|62\\d|70[23]|959))\\d{3}", [9]], ["4(?:79[01]|83[0-389]|94[0-478])\\d{5}|4(?:[0-36]\\d|4[047-9]|[58][0-24-9]|7[02-8]|9[0-37-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, 0, ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [6, 8, 10, 12]]], "0011"], CD: ["243", "00", "(?:(?:[189]|5\\d)\\d|2)\\d{7}|[1-68]\\d{6}", [7, 8, 9, 10], [["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["88"], "0$1"], ["(\\d{2})(\\d{5})", "$1 $2", ["[1-6]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["5"], "0$1"]], "0"], CF: ["236", "00", "(?:[27]\\d{3}|8776)\\d{4}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[278]"]]]], CG: ["242", "00", "222\\d{6}|(?:0\\d|80)\\d{7}", [9], [["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["8"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[02]"]]]], CH: ["41", "00", "8\\d{11}|[2-9]\\d{8}", [9, 12], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8[047]|90"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-79]|81"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["8"], "0$1"]], "0"], CI: ["225", "00", "[02]\\d{9}", [10], [["(\\d{2})(\\d{2})(\\d)(\\d{5})", "$1 $2 $3 $4", ["2"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3 $4", ["0"]]]], CK: ["682", "00", "[2-578]\\d{4}", [5], [["(\\d{2})(\\d{3})", "$1 $2", ["[2-578]"]]]], CL: ["56", "(?:0|1(?:1[0-69]|2[02-5]|5[13-58]|69|7[0167]|8[018]))0", "12300\\d{6}|6\\d{9,10}|[2-9]\\d{8}", [9, 10, 11], [["(\\d{5})(\\d{4})", "$1 $2", ["219", "2196"], "($1)"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["60|809"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["44"]], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2[1-36]"], "($1)"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["9(?:10|[2-9])"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["3[2-5]|[47]|5[1-3578]|6[13-57]|8(?:0[1-8]|[1-9])"], "($1)"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["60|8"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]], ["(\\d{3})(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["60"]]]], CM: ["237", "00", "[26]\\d{8}|88\\d{6,7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["88"]], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[26]|88"]]]], CN: ["86", "00|1(?:[12]\\d|79)\\d\\d00", "(?:(?:1[03-689]|2\\d)\\d\\d|6)\\d{8}|1\\d{10}|[126]\\d{6}(?:\\d(?:\\d{2})?)?|86\\d{5,6}|(?:[3-579]\\d|8[0-57-9])\\d{5,9}", [7, 8, 9, 10, 11, 12], [["(\\d{2})(\\d{5,6})", "$1 $2", ["(?:10|2[0-57-9])[19]|3(?:[157]|35|49|9[1-68])|4(?:1[124-9]|2[179]|6[47-9]|7|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:07|1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3|4[13]|5[1-5]|7[0-79]|9[0-35-9])|(?:4[35]|59|85)[1-9]", "(?:10|2[0-57-9])(?:1[02]|9[56])|8078|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))1", "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|80781|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))12", "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|807812|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))123", "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:078|1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))123"], "0$1"], ["(\\d{3})(\\d{5,6})", "$1 $2", ["3(?:[157]|35|49|9[1-68])|4(?:[17]|2[179]|6[47-9]|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])|(?:4[35]|59|85)[1-9]", "(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))[19]", "85[23](?:10|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:10|9[56])", "85[23](?:100|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:100|9[56])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["(?:4|80)0"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["10|2(?:[02-57-9]|1[1-9])", "10|2(?:[02-57-9]|1[1-9])", "10[0-79]|2(?:[02-57-9]|1[1-79])|(?:10|21)8(?:0[1-9]|[1-9])"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["3(?:[3-59]|7[02-68])|4(?:[26-8]|3[3-9]|5[2-9])|5(?:3[03-9]|[468]|7[028]|9[2-46-9])|6|7(?:[0-247]|3[04-9]|5[0-4689]|6[2368])|8(?:[1-358]|9[1-7])|9(?:[013479]|5[1-5])|(?:[34]1|55|79|87)[02-9]"], "0$1", 1], ["(\\d{3})(\\d{7,8})", "$1 $2", ["9"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["80"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["[3-578]"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["1[3-9]"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["[12]"], "0$1", 1]], "0", 0, "(1(?:[12]\\d|79)\\d\\d)|0", 0, 0, 0, 0, "00"], CO: ["57", "00(?:4(?:[14]4|56)|[579])", "(?:46|60\\d\\d)\\d{6}|(?:1\\d|[39])\\d{9}", [8, 10, 11], [["(\\d{4})(\\d{4})", "$1 $2", ["46"]], ["(\\d{3})(\\d{7})", "$1 $2", ["6|90"], "($1)"], ["(\\d{3})(\\d{7})", "$1 $2", ["3[0-357]|9[14]"]], ["(\\d)(\\d{3})(\\d{7})", "$1-$2-$3", ["1"], "0$1", 0, "$1 $2 $3"]], "0", 0, "0([3579]|4(?:[14]4|56))?"], CR: ["506", "00", "(?:8\\d|90)\\d{8}|(?:[24-8]\\d{3}|3005)\\d{4}", [8, 10], [["(\\d{4})(\\d{4})", "$1 $2", ["[2-7]|8[3-9]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[89]"]]], 0, 0, "(19(?:0[0-2468]|1[09]|20|66|77|99))"], CU: ["53", "119", "(?:[2-7]|8\\d\\d)\\d{7}|[2-47]\\d{6}|[34]\\d{5}", [6, 7, 8, 10], [["(\\d{2})(\\d{4,6})", "$1 $2", ["2[1-4]|[34]"], "(0$1)"], ["(\\d)(\\d{6,7})", "$1 $2", ["7"], "(0$1)"], ["(\\d)(\\d{7})", "$1 $2", ["[56]"], "0$1"], ["(\\d{3})(\\d{7})", "$1 $2", ["8"], "0$1"]], "0"], CV: ["238", "0", "(?:[2-59]\\d\\d|800)\\d{4}", [7], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[2-589]"]]]], CW: ["599", "00", "(?:[34]1|60|(?:7|9\\d)\\d)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["[3467]"]], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["9[4-8]"]]], 0, 0, 0, 0, 0, "[69]"], CX: ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}", [6, 7, 8, 9, 10, 12], 0, "0", 0, "([59]\\d{7})$|0", "8$1", 0, 0, [["8(?:51(?:0(?:01|30|59|88)|1(?:17|46|75)|2(?:22|35))|91(?:00[6-9]|1(?:[28]1|49|78)|2(?:09|63)|3(?:12|26|75)|4(?:56|97)|64\\d|7(?:0[01]|1[0-2])|958))\\d{3}", [9]], ["4(?:79[01]|83[0-389]|94[0-478])\\d{5}|4(?:[0-36]\\d|4[047-9]|[58][0-24-9]|7[02-8]|9[0-37-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, 0, ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [6, 8, 10, 12]]], "0011"], CY: ["357", "00", "(?:[279]\\d|[58]0)\\d{6}", [8], [["(\\d{2})(\\d{6})", "$1 $2", ["[257-9]"]]]], CZ: ["420", "00", "(?:[2-578]\\d|60)\\d{7}|9\\d{8,11}", [9, 10, 11, 12], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-8]|9[015-7]"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3 $4", ["96"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]]]], DE: ["49", "00", "[2579]\\d{5,14}|49(?:[34]0|69|8\\d)\\d\\d?|49(?:37|49|60|7[089]|9\\d)\\d{1,3}|49(?:2[024-9]|3[2-689]|7[1-7])\\d{1,8}|(?:1|[368]\\d|4[0-8])\\d{3,13}|49(?:[015]\\d|2[13]|31|[46][1-8])\\d{1,9}", [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15], [["(\\d{2})(\\d{3,13})", "$1 $2", ["3[02]|40|[68]9"], "0$1"], ["(\\d{3})(\\d{3,12})", "$1 $2", ["2(?:0[1-389]|1[124]|2[18]|3[14])|3(?:[35-9][15]|4[015])|906|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1", "2(?:0[1-389]|12[0-8])|3(?:[35-9][15]|4[015])|906|2(?:[13][14]|2[18])|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1"], "0$1"], ["(\\d{4})(\\d{2,11})", "$1 $2", ["[24-6]|3(?:[3569][02-46-9]|4[2-4679]|7[2-467]|8[2-46-8])|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]", "[24-6]|3(?:3(?:0[1-467]|2[127-9]|3[124578]|7[1257-9]|8[1256]|9[145])|4(?:2[135]|4[13578]|9[1346])|5(?:0[14]|2[1-3589]|6[1-4]|7[13468]|8[13568])|6(?:2[1-489]|3[124-6]|6[13]|7[12579]|8[1-356]|9[135])|7(?:2[1-7]|4[145]|6[1-5]|7[1-4])|8(?:21|3[1468]|6|7[1467]|8[136])|9(?:0[12479]|2[1358]|4[134679]|6[1-9]|7[136]|8[147]|9[1468]))|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]|3[68]4[1347]|3(?:47|60)[1356]|3(?:3[46]|46|5[49])[1246]|3[4579]3[1357]"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["138"], "0$1"], ["(\\d{5})(\\d{2,10})", "$1 $2", ["3"], "0$1"], ["(\\d{3})(\\d{5,11})", "$1 $2", ["181"], "0$1"], ["(\\d{3})(\\d)(\\d{4,10})", "$1 $2 $3", ["1(?:3|80)|9"], "0$1"], ["(\\d{3})(\\d{7,8})", "$1 $2", ["1[67]"], "0$1"], ["(\\d{3})(\\d{7,12})", "$1 $2", ["8"], "0$1"], ["(\\d{5})(\\d{6})", "$1 $2", ["185", "1850", "18500"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{4})(\\d{7})", "$1 $2", ["18[68]"], "0$1"], ["(\\d{4})(\\d{7})", "$1 $2", ["15[1279]"], "0$1"], ["(\\d{5})(\\d{6})", "$1 $2", ["15[03568]", "15(?:[0568]|31)"], "0$1"], ["(\\d{3})(\\d{8})", "$1 $2", ["18"], "0$1"], ["(\\d{3})(\\d{2})(\\d{7,8})", "$1 $2 $3", ["1(?:6[023]|7)"], "0$1"], ["(\\d{4})(\\d{2})(\\d{7})", "$1 $2 $3", ["15[279]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{8})", "$1 $2 $3", ["15"], "0$1"]], "0"], DJ: ["253", "00", "(?:2\\d|77)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[27]"]]]], DK: ["45", "00", "[2-9]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-9]"]]]], DM: ["1", "011", "(?:[58]\\d\\d|767|900)\\d{7}", [10], 0, "1", 0, "([2-7]\\d{6})$|1", "767$1", 0, "767"], DO: ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "8001|8[024]9"], DZ: ["213", "00", "(?:[1-4]|[5-79]\\d|80)\\d{7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[1-4]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["9"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-8]"], "0$1"]], "0"], EC: ["593", "00", "1\\d{9,10}|(?:[2-7]|9\\d)\\d{7}", [8, 9, 10, 11], [["(\\d)(\\d{3})(\\d{4})", "$1 $2-$3", ["[2-7]"], "(0$1)", 0, "$1-$2-$3"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["1"]]], "0"], EE: ["372", "00", "8\\d{9}|[4578]\\d{7}|(?:[3-8]\\d|90)\\d{5}", [7, 8, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["[369]|4[3-8]|5(?:[0-2]|5[0-478]|6[45])|7[1-9]|88", "[369]|4[3-8]|5(?:[02]|1(?:[0-8]|95)|5[0-478]|6(?:4[0-4]|5[1-589]))|7[1-9]|88"]], ["(\\d{4})(\\d{3,4})", "$1 $2", ["[45]|8(?:00|[1-49])", "[45]|8(?:00[1-9]|[1-49])"]], ["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["7"]], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]]]], EG: ["20", "00", "[189]\\d{8,9}|[24-6]\\d{8}|[135]\\d{7}", [8, 9, 10], [["(\\d)(\\d{7,8})", "$1 $2", ["[23]"], "0$1"], ["(\\d{2})(\\d{6,7})", "$1 $2", ["1[35]|[4-6]|8[2468]|9[235-7]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{2})(\\d{8})", "$1 $2", ["1"], "0$1"]], "0"], EH: ["212", "00", "[5-8]\\d{8}", [9], 0, "0", 0, 0, 0, 0, "528[89]"], ER: ["291", "00", "[178]\\d{6}", [7], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[178]"], "0$1"]], "0"], ES: ["34", "00", "[5-9]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[89]00"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-9]"]]]], ET: ["251", "00", "(?:11|[2-579]\\d)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-579]"], "0$1"]], "0"], FI: ["358", "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))", "[1-35689]\\d{4}|7\\d{10,11}|(?:[124-7]\\d|3[0-46-9])\\d{8}|[1-9]\\d{5,8}", [5, 6, 7, 8, 9, 10, 11, 12], [["(\\d{5})", "$1", ["20[2-59]"], "0$1"], ["(\\d{3})(\\d{3,7})", "$1 $2", ["(?:[1-3]0|[68])0|70[07-9]"], "0$1"], ["(\\d{2})(\\d{4,8})", "$1 $2", ["[14]|2[09]|50|7[135]"], "0$1"], ["(\\d{2})(\\d{6,10})", "$1 $2", ["7"], "0$1"], ["(\\d)(\\d{4,9})", "$1 $2", ["(?:19|[2568])[1-8]|3(?:0[1-9]|[1-9])|9"], "0$1"]], "0", 0, 0, 0, 0, "1[03-79]|[2-9]", 0, "00"], FJ: ["679", "0(?:0|52)", "45\\d{5}|(?:0800\\d|[235-9])\\d{6}", [7, 11], [["(\\d{3})(\\d{4})", "$1 $2", ["[235-9]|45"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["0"]]], 0, 0, 0, 0, 0, 0, 0, "00"], FK: ["500", "00", "[2-7]\\d{4}", [5]], FM: ["691", "00", "(?:[39]\\d\\d|820)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[389]"]]]], FO: ["298", "00", "[2-9]\\d{5}", [6], [["(\\d{6})", "$1", ["[2-9]"]]], 0, 0, "(10(?:01|[12]0|88))"], FR: ["33", "00", "[1-9]\\d{8}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0 $1"], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[1-79]"], "0$1"]], "0"], GA: ["241", "00", "(?:[067]\\d|11)\\d{6}|[2-7]\\d{6}", [7, 8], [["(\\d)(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-7]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["0"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["11|[67]"], "0$1"]], 0, 0, "0(11\\d{6}|60\\d{6}|61\\d{6}|6[256]\\d{6}|7[467]\\d{6})", "$1"], GB: ["44", "00", "[1-357-9]\\d{9}|[18]\\d{8}|8\\d{6}", [7, 9, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["800", "8001", "80011", "800111", "8001111"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["845", "8454", "84546", "845464"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["800"], "0$1"], ["(\\d{5})(\\d{4,5})", "$1 $2", ["1(?:38|5[23]|69|76|94)", "1(?:(?:38|69)7|5(?:24|39)|768|946)", "1(?:3873|5(?:242|39[4-6])|(?:697|768)[347]|9467)"], "0$1"], ["(\\d{4})(\\d{5,6})", "$1 $2", ["1(?:[2-69][02-9]|[78])"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["[25]|7(?:0|6[02-9])", "[25]|7(?:0|6(?:[03-9]|2[356]))"], "0$1"], ["(\\d{4})(\\d{6})", "$1 $2", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1389]"], "0$1"]], "0", 0, "0|180020", 0, 0, 0, [["(?:1(?:1(?:3(?:[0-58]\\d\\d|73[0-35])|4(?:(?:[0-5]\\d|70)\\d|69[7-9])|(?:(?:5[0-26-9]|[78][0-49])\\d|6(?:[0-4]\\d|50))\\d)|(?:2(?:(?:0[024-9]|2[3-9]|3[3-79]|4[1-689]|[58][02-9]|6[0-47-9]|7[013-9]|9\\d)\\d|1(?:[0-7]\\d|8[0-3]))|(?:3(?:0\\d|1[0-8]|[25][02-9]|3[02-579]|[468][0-46-9]|7[1-35-79]|9[2-578])|4(?:0[03-9]|[137]\\d|[28][02-57-9]|4[02-69]|5[0-8]|[69][0-79])|5(?:0[1-35-9]|[16]\\d|2[024-9]|3[015689]|4[02-9]|5[03-9]|7[0-35-9]|8[0-468]|9[0-57-9])|6(?:0[034689]|1\\d|2[0-35689]|[38][013-9]|4[1-467]|5[0-69]|6[13-9]|7[0-8]|9[0-24578])|7(?:0[0246-9]|2\\d|3[0236-8]|4[03-9]|5[0-46-9]|6[013-9]|7[0-35-9]|8[024-9]|9[02-9])|8(?:0[35-9]|2[1-57-9]|3[02-578]|4[0-578]|5[124-9]|6[2-69]|7\\d|8[02-9]|9[02569])|9(?:0[02-589]|[18]\\d|2[02-689]|3[1-57-9]|4[2-9]|5[0-579]|6[2-47-9]|7[0-24578]|9[2-57]))\\d)\\d)|2(?:0[013478]|3[0189]|4[017]|8[0-46-9]|9[0-2])\\d{3})\\d{4}|1(?:2(?:0(?:46[1-4]|87[2-9])|545[1-79]|76(?:2\\d|3[1-8]|6[1-6])|9(?:7(?:2[0-4]|3[2-5])|8(?:2[2-8]|7[0-47-9]|8[3-5])))|3(?:6(?:38[2-5]|47[23])|8(?:47[04-9]|64[0157-9]))|4(?:044[1-7]|20(?:2[23]|8\\d)|6(?:0(?:30|5[2-57]|6[1-8]|7[2-8])|140)|8(?:052|87[1-3]))|5(?:2(?:4(?:3[2-79]|6\\d)|76\\d)|6(?:26[06-9]|686))|6(?:06(?:4\\d|7[4-79])|295[5-7]|35[34]\\d|47(?:24|61)|59(?:5[08]|6[67]|74)|9(?:55[0-4]|77[23]))|7(?:26(?:6[13-9]|7[0-7])|(?:442|688)\\d|50(?:2[0-3]|[3-68]2|76))|8(?:27[56]\\d|37(?:5[2-5]|8[239])|843[2-58])|9(?:0(?:0(?:6[1-8]|85)|52\\d)|3583|4(?:66[1-8]|9(?:2[01]|81))|63(?:23|3[1-4])|9561))\\d{3}", [9, 10]], ["7(?:457[0-57-9]|700[01]|911[028])\\d{5}|7(?:[1-3]\\d\\d|4(?:[0-46-9]\\d|5[0-689])|5(?:0[0-8]|[13-9]\\d|2[0-35-9])|7(?:0[1-9]|[1-7]\\d|8[02-9]|9[0-689])|8(?:[014-9]\\d|[23][0-8])|9(?:[024-9]\\d|1[02-9]|3[0-689]))\\d{6}", [10]], ["80[08]\\d{7}|800\\d{6}|8001111"], ["(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[2-49]))\\d{7}|845464\\d", [7, 10]], ["70\\d{8}", [10]], 0, ["(?:3[0347]|55)\\d{8}", [10]], ["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}", [10]], ["56\\d{8}", [10]]], 0, " x"], GD: ["1", "011", "(?:473|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "473$1", 0, "473"], GE: ["995", "00", "(?:[3-57]\\d\\d|800)\\d{6}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["70"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["32"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[57]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[348]"], "0$1"]], "0"], GF: ["594", "00", "(?:[56]94\\d|7093)\\d{5}|(?:80|9\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-7]|9[47]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[89]"], "0$1"]], "0"], GG: ["44", "00", "(?:1481|[357-9]\\d{3})\\d{6}|8\\d{6}(?:\\d{2})?", [7, 9, 10], 0, "0", 0, "([25-9]\\d{5})$|0|180020", "1481$1", 0, 0, [["1481[25-9]\\d{5}", [10]], ["7(?:(?:781|839)\\d|911[17])\\d{5}", [10]], ["80[08]\\d{7}|800\\d{6}|8001111"], ["(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[0-3]))\\d{7}|845464\\d", [7, 10]], ["70\\d{8}", [10]], 0, ["(?:3[0347]|55)\\d{8}", [10]], ["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}", [10]], ["56\\d{8}", [10]]]], GH: ["233", "00", "(?:[235]\\d{3}|800)\\d{5}", [8, 9], [["(\\d{3})(\\d{5})", "$1 $2", ["8"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[235]"], "0$1"]], "0"], GI: ["350", "00", "(?:[25]\\d|60)\\d{6}", [8], [["(\\d{3})(\\d{5})", "$1 $2", ["2"]]]], GL: ["299", "00", "(?:19|[2-689]\\d|70)\\d{4}", [6], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["19|[2-9]"]]]], GM: ["220", "00", "[2-9]\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]]], GN: ["224", "00", "722\\d{6}|(?:3|6\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["3"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[67]"]]]], GP: ["590", "00", "(?:590\\d|7090)\\d{5}|(?:69|80|9\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-79]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["590(?:0[1-68]|[14][0-24-9]|2[0-68]|3[1-9]|5[3-579]|[68][0-689]|7[08]|9\\d)\\d{4}"], ["(?:69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))|7090[0-4])\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:(?:39[5-7]|76[018])\\d|475[0-6])\\d{4}"]]], GQ: ["240", "00", "222\\d{6}|(?:3\\d|55|[89]0)\\d{7}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235]"]], ["(\\d{3})(\\d{6})", "$1 $2", ["[89]"]]]], GR: ["30", "00", "5005000\\d{3}|8\\d{9,11}|(?:[269]\\d|70)\\d{8}", [10, 11, 12], [["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["21|7"]], ["(\\d{4})(\\d{6})", "$1 $2", ["2(?:2|3[2-57-9]|4[2-469]|5[2-59]|6[2-9]|7[2-69]|8[2-49])|5"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2689]"]], ["(\\d{3})(\\d{3,4})(\\d{5})", "$1 $2 $3", ["8"]]]], GT: ["502", "00", "80\\d{6}|(?:1\\d{3}|[2-7])\\d{7}", [8, 11], [["(\\d{4})(\\d{4})", "$1 $2", ["[2-8]"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]]]], GU: ["1", "011", "(?:[58]\\d\\d|671|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "671$1", 0, "671"], GW: ["245", "00", "[49]\\d{8}|4\\d{6}", [7, 9], [["(\\d{3})(\\d{4})", "$1 $2", ["40"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[49]"]]]], GY: ["592", "001", "(?:[2-8]\\d{3}|9008)\\d{3}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]]], HK: ["852", "00(?:30|5[09]|[126-9]?)", "8[0-46-9]\\d{6,7}|9\\d{4,7}|(?:[2-7]|9\\d{3})\\d{7}", [5, 6, 7, 8, 9, 11], [["(\\d{3})(\\d{2,5})", "$1 $2", ["900", "9003"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[2-7]|8[1-4]|9(?:0[1-9]|[1-8])"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]], ["(\\d{3})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]]], 0, 0, 0, 0, 0, 0, 0, "00"], HN: ["504", "00", "8\\d{10}|[237-9]\\d{7}", [8, 11], [["(\\d{4})(\\d{4})", "$1-$2", ["[237-9]"]]]], HR: ["385", "00", "[2-69]\\d{8}|80\\d{5,7}|[1-79]\\d{7}|6\\d{6}", [7, 8, 9], [["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["6[01]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{4})(\\d{3})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["6|7[245]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-57]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"], "0$1"]], "0"], HT: ["509", "00", "[2-589]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["[2-589]"]]]], HU: ["36", "00", "[235-7]\\d{8}|[1-9]\\d{7}", [8, 9], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "(06 $1)"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6|8[2-57-9]|9[2-69]"], "(06 $1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-9]"], "06 $1"]], "06"], ID: ["62", "00[89]", "00[1-9]\\d{9,14}|(?:[1-36]|8\\d{5})\\d{6}|00\\d{9}|[1-9]\\d{8,10}|[2-9]\\d{7}", [7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["15"]], ["(\\d{2})(\\d{5,9})", "$1 $2", ["2[124]|[36]1"], "(0$1)"], ["(\\d{3})(\\d{5,7})", "$1 $2", ["800"], "0$1"], ["(\\d{3})(\\d{5,8})", "$1 $2", ["[2-79]"], "(0$1)"], ["(\\d{3})(\\d{3,4})(\\d{3})", "$1-$2-$3", ["8[1-35-9]"], "0$1"], ["(\\d{3})(\\d{6,8})", "$1 $2", ["1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["804"], "0$1"], ["(\\d{3})(\\d)(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["80"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1-$2-$3", ["8"], "0$1"]], "0"], IE: ["353", "00", "(?:1\\d|[2569])\\d{6,8}|4\\d{6,9}|7\\d{8}|8\\d{8,9}", [7, 8, 9, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["2[24-9]|47|58|6[237-9]|9[35-9]"], "(0$1)"], ["(\\d{3})(\\d{5})", "$1 $2", ["[45]0"], "(0$1)"], ["(\\d)(\\d{3,4})(\\d{4})", "$1 $2 $3", ["1"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2569]|4[1-69]|7[14]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["70"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["81"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[78]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["4"], "(0$1)"], ["(\\d{2})(\\d)(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"], IL: ["972", "0(?:0|1[2-9])", "1\\d{6}(?:\\d{3,5})?|[57]\\d{8}|[1-489]\\d{7}", [7, 8, 9, 10, 11, 12], [["(\\d{4})(\\d{3})", "$1-$2", ["125"]], ["(\\d{4})(\\d{2})(\\d{2})", "$1-$2-$3", ["121"]], ["(\\d)(\\d{3})(\\d{4})", "$1-$2-$3", ["[2-489]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["[57]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1-$2-$3", ["12"]], ["(\\d{4})(\\d{6})", "$1-$2", ["159"]], ["(\\d)(\\d{3})(\\d{3})(\\d{3})", "$1-$2-$3-$4", ["1[7-9]"]], ["(\\d{3})(\\d{1,2})(\\d{3})(\\d{4})", "$1-$2 $3-$4", ["15"]]], "0"], IM: ["44", "00", "1624\\d{6}|(?:[3578]\\d|90)\\d{8}", [10], 0, "0", 0, "([25-8]\\d{5})$|0|180020", "1624$1", 0, "74576|(?:16|7[56])24"], IN: ["91", "00", "(?:000800|[2-9]\\d\\d)\\d{7}|1\\d{7,12}", [8, 9, 10, 11, 12, 13], [["(\\d{8})", "$1", ["5(?:0|2[23]|3[03]|[67]1|88)", "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|888)", "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|8888)"], 0, 1], ["(\\d{4})(\\d{4,5})", "$1 $2", ["180", "1800"], 0, 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["140"], 0, 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["11|2[02]|33|4[04]|79[1-7]|80[2-46]", "11|2[02]|33|4[04]|79(?:[1-6]|7[19])|80(?:[2-4]|6[0-589])", "11|2[02]|33|4[04]|79(?:[124-6]|3(?:[02-9]|1[0-24-9])|7(?:1|9[1-6]))|80(?:[2-4]|6[0-589])"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["1(?:2[0-249]|3[0-25]|4[145]|[68]|7[1257])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5[12]|[78]1)|6(?:12|[2-4]1|5[17]|6[13]|80)|7(?:12|3[134]|4[47]|61|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)|(?:43|59|75)[15]|(?:1[59]|29|67|72)[14]", "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|674|7(?:(?:2[14]|3[34]|5[15])[2-6]|61[346]|88[0-8])|8(?:70[2-6]|84[235-7]|91[3-7])|(?:1(?:29|60|8[06])|261|552|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))[2-7]", "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12(?:[2-6]|7[0-8])|74[2-7])|7(?:(?:2[14]|5[15])[2-6]|3171|61[346]|88(?:[2-7]|82))|8(?:70[2-6]|84(?:[2356]|7[19])|91(?:[3-6]|7[19]))|73[134][2-6]|(?:74[47]|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[2-6]|7[19])|(?:1(?:29|60|8[06])|261|552|6(?:[2-4]1|5[17]|6[13]|7(?:1|4[0189])|80)|7(?:12|88[01]))[2-7]"], "0$1", 1], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2[2457-9]|3[2-5]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1[013-9]|28|3[129]|4[1-35689]|5[29]|6[02-5]|70)|807", "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2(?:[2457]|84|95)|3(?:[2-4]|55)|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1(?:[013-8]|9[6-9])|28[6-8]|3(?:17|2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4|5[0-367])|70[13-7])|807[19]", "1(?:[2-479]|5(?:[0236-9]|5[013-9]))|[2-5]|6(?:2(?:84|95)|355|83)|73179|807(?:1|9[1-3])|(?:1552|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])\\d|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]))[2-7]"], "0$1", 1], ["(\\d{5})(\\d{5})", "$1 $2", ["[6-9]"], "0$1", 1], ["(\\d{4})(\\d{2,4})(\\d{4})", "$1 $2 $3", ["1(?:6|8[06])", "1(?:6|8[06]0)"], 0, 1], ["(\\d{4})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["18"], 0, 1]], "0"], IO: ["246", "00", "3\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["3"]]]], IQ: ["964", "00", "(?:1|7\\d\\d)\\d{7}|[2-6]\\d{7,8}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-6]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"]], "0"], IR: ["98", "00", "[1-9]\\d{9}|(?:[1-8]\\d\\d|9)\\d{3,4}", [4, 5, 6, 7, 10], [["(\\d{4,5})", "$1", ["96"], "0$1"], ["(\\d{2})(\\d{4,5})", "$1 $2", ["(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])[12689]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["[1-8]"], "0$1"]], "0"], IS: ["354", "00|1(?:0(?:01|[12]0)|100)", "(?:38\\d|[4-9])\\d{6}", [7, 9], [["(\\d{3})(\\d{4})", "$1 $2", ["[4-9]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["3"]]], 0, 0, 0, 0, 0, 0, 0, "00"], IT: ["39", "00", "0\\d{5,10}|1\\d{8,10}|3(?:[0-8]\\d{7,10}|9\\d{7,8})|(?:43|55|70)\\d{8}|8\\d{5}(?:\\d{2,4})?", [6, 7, 8, 9, 10, 11, 12], [["(\\d{2})(\\d{4,6})", "$1 $2", ["0[26]"]], ["(\\d{3})(\\d{3,6})", "$1 $2", ["0[13-57-9][0159]|8(?:03|4[17]|9[2-5])", "0[13-57-9][0159]|8(?:03|4[17]|9(?:2|3[04]|[45][0-4]))"]], ["(\\d{4})(\\d{2,6})", "$1 $2", ["0(?:[13-579][2-46-8]|8[236-8])"]], ["(\\d{4})(\\d{4})", "$1 $2", ["894"]], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[26]|5"]], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["1(?:44|[679])|[378]|43"]], ["(\\d{3})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[13-57-9][0159]|14"]], ["(\\d{2})(\\d{4})(\\d{5})", "$1 $2 $3", ["0[26]"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["0"]], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["3"]]], 0, 0, 0, 0, 0, 0, [["0669[0-79]\\d{1,6}|0(?:1(?:[0159]\\d|[27][1-5]|31|4[1-4]|6[1356]|8[2-57])|2\\d\\d|3(?:[0159]\\d|2[1-4]|3[12]|[48][1-6]|6[2-59]|7[1-7])|4(?:[0159]\\d|[23][1-9]|4[245]|6[1-5]|7[1-4]|81)|5(?:[0159]\\d|2[1-5]|3[2-6]|4[1-79]|6[4-6]|7[1-578]|8[3-8])|6(?:[0-57-9]\\d|6[0-8])|7(?:[0159]\\d|2[12]|3[1-7]|4[2-46]|6[13569]|7[13-6]|8[1-59])|8(?:[0159]\\d|2[3-578]|3[1-356]|[6-8][1-5])|9(?:[0159]\\d|[238][1-5]|4[12]|6[1-8]|7[1-6]))\\d{2,7}", [6, 7, 8, 9, 10, 11]], ["3[2-9]\\d{7,8}|(?:31|43)\\d{8}", [9, 10]], ["80(?:0\\d{3}|3)\\d{3}", [6, 9]], ["(?:0878\\d{3}|89(?:2\\d|3[04]|4(?:[0-4]|[5-9]\\d\\d)|5[0-4]))\\d\\d|(?:1(?:44|6[346])|89(?:38|5[5-9]|9))\\d{6}", [6, 8, 9, 10]], ["1(?:78\\d|99)\\d{6}", [9, 10]], ["3[2-8]\\d{9,10}", [11, 12]], 0, 0, ["55\\d{8}", [10]], ["84(?:[08]\\d{3}|[17])\\d{3}", [6, 9]]]], JE: ["44", "00", "1534\\d{6}|(?:[3578]\\d|90)\\d{8}", [10], 0, "0", 0, "([0-24-8]\\d{5})$|0|180020", "1534$1", 0, 0, [["1534[0-24-8]\\d{5}"], ["7(?:(?:(?:50|82)9|937)\\d|7(?:00[378]|97\\d))\\d{5}"], ["80(?:07(?:35|81)|8901)\\d{4}"], ["(?:8(?:4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|90(?:066[59]|1810|71(?:07|55)))\\d{4}"], ["701511\\d{4}"], 0, ["(?:3(?:0(?:07(?:35|81)|8901)|3\\d{4}|4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|55\\d{4})\\d{4}"], ["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}"], ["56\\d{8}"]]], JM: ["1", "011", "(?:[58]\\d\\d|658|900)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "658|876"], JO: ["962", "00", "(?:(?:[2689]|7\\d)\\d|32|53)\\d{6}", [8, 9], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2356]|87"], "(0$1)"], ["(\\d{3})(\\d{5,6})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["70"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["7"], "0$1"]], "0"], JP: ["81", "010", "00[1-9]\\d{6,14}|[25-9]\\d{9}|(?:00|[1-9]\\d\\d)\\d{6}", [8, 9, 10, 11, 12, 13, 14, 15, 16, 17], [["(\\d{3})(\\d{3})(\\d{3})", "$1-$2-$3", ["(?:12|57|99)0"], "0$1"], ["(\\d{4})(\\d)(\\d{4})", "$1-$2-$3", ["1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|499|5(?:76|97)|746|8(?:3[89]|47|51)|9(?:80|9[16])", "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:76|97)9|7468|8(?:3(?:8[7-9]|96)|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]", "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:769|979[2-69])|7468|8(?:3(?:8[7-9]|96[2457-9])|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["60"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1-$2-$3", ["3|4(?:2[09]|7[01])|6[1-9]", "3|4(?:2(?:0|9[02-69])|7(?:0[019]|1))|6[1-9]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["1(?:1|5[45]|77|88|9[69])|2(?:2[1-37]|3[0-269]|4[59]|5|6[24]|7[1-358]|8[1369]|9[0-38])|4(?:[28][1-9]|3[0-57]|[45]|6[248]|7[2-579]|9[29])|5(?:2|3[0459]|4[0-369]|5[29]|8[02389]|9[0-389])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9[2-6])|8(?:2[124589]|3[26-9]|49|51|6|7[0-468]|8[68]|9[019])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9[1-489])", "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2(?:[127]|3[014-9])|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9[19])|62|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|8[1-9]|9[29])|5(?:2|3(?:[045]|9[0-8])|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0-2469])|3(?:[29]|60)|49|51|6(?:[0-24]|36|5[0-3589]|7[23]|9[01459])|7[0-468]|8[68])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3[34]|4[0178]))|(?:264|837)[016-9]|2(?:57|93)[015-9]|(?:25[0468]|422|838)[01]|(?:47[59]|59[89]|8(?:6[68]|9))[019]", "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3(?:[045]|9(?:[0-58]|6[4-9]|7[0-35689]))|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0169])|3(?:[29]|60|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[2-57-9]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|7(?:2[2-468]|3[78])|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:8294|96)[1-3]|2(?:57|93)[015-9]|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|8292|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{4})", "$1-$2-$3", ["[14]|[289][2-9]|5[3-9]|7[2-4679]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["800"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[25-9]"], "0$1"]], "0", 0, "(000[2569]\\d{4,6})$|(?:(?:003768)0?)|0", "$1"], KE: ["254", "000", "(?:[17]\\d\\d|900)\\d{6}|(?:2|80)0\\d{6,7}|[4-6]\\d{6,8}", [7, 8, 9, 10], [["(\\d{2})(\\d{5,7})", "$1 $2", ["[24-6]"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["[17]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[89]"], "0$1"]], "0"], KG: ["996", "00", "8\\d{9}|[235-9]\\d{8}", [9, 10], [["(\\d{4})(\\d{5})", "$1 $2", ["3(?:1[346]|[24-79])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235-79]|88"], "0$1"], ["(\\d{3})(\\d{3})(\\d)(\\d{2,3})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"], KH: ["855", "00[14-9]", "1\\d{9}|[1-9]\\d{7,8}", [8, 9, 10], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-9]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0"], KI: ["686", "00", "(?:[37]\\d|6[0-79])\\d{6}|(?:[2-48]\\d|50)\\d{3}", [5, 8], 0, "0"], KM: ["269", "00", "[3478]\\d{6}", [7], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[3478]"]]]], KN: ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-7]\\d{6})$|1", "869$1", 0, "869"], KP: ["850", "00|99", "85\\d{6}|(?:19\\d|[2-7])\\d{7}", [8, 10], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-7]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"]], "0"], KR: ["82", "00(?:[125689]|3(?:[46]5|91)|7(?:00|27|3|55|6[126]))", "00[1-9]\\d{8,11}|(?:[12]|5\\d{3})\\d{7}|[13-6]\\d{9}|(?:[1-6]\\d|80)\\d{7}|[3-6]\\d{4,5}|(?:00|7)0\\d{8}", [5, 6, 8, 9, 10, 11, 12, 13, 14], [["(\\d{2})(\\d{3,4})", "$1-$2", ["(?:3[1-3]|[46][1-4]|5[1-5])1"], "0$1"], ["(\\d{4})(\\d{4})", "$1-$2", ["1"]], ["(\\d)(\\d{3,4})(\\d{4})", "$1-$2-$3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["[36]0|8"], "0$1"], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1-$2-$3", ["[1346]|5[1-5]"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[57]"], "0$1"], ["(\\d{2})(\\d{5})(\\d{4})", "$1-$2-$3", ["5"], "0$1"]], "0", 0, "0(8(?:[1-46-8]|5\\d\\d))?"], KW: ["965", "00", "18\\d{5}|(?:[2569]\\d|41)\\d{6}", [7, 8], [["(\\d{4})(\\d{3,4})", "$1 $2", ["[169]|2(?:[235]|4[1-35-9])|52"]], ["(\\d{3})(\\d{5})", "$1 $2", ["[245]"]]]], KY: ["1", "011", "(?:345|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "345$1", 0, "345"], KZ: ["7", "810", "(?:33622|8\\d{8})\\d{5}|[78]\\d{9}", [10, 14], 0, "8", 0, 0, 0, 0, "33622|7", 0, "8~10"], LA: ["856", "00", "[23]\\d{9}|3\\d{8}|(?:[235-8]\\d|41)\\d{6}", [8, 9, 10], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["2[13]|3[14]|[4-8]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["3"], "0$1"], ["(\\d{2})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[23]"], "0$1"]], "0"], LB: ["961", "00", "[27-9]\\d{7}|[13-9]\\d{6}", [7, 8], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[13-69]|7(?:[2-57]|62|8[0-6]|9[04-9])|8[02-9]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[27-9]"]]], "0"], LC: ["1", "011", "(?:[58]\\d\\d|758|900)\\d{7}", [10], 0, "1", 0, "([2-8]\\d{6})$|1", "758$1", 0, "758"], LI: ["423", "00", "[68]\\d{8}|(?:[2378]\\d|90)\\d{5}", [7, 9], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[2379]|8(?:0[09]|7)", "[2379]|8(?:0(?:02|9)|7)"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["69"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]]], "0", 0, "(1001)|0"], LK: ["94", "00", "[1-9]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[1-689]"], "0$1"]], "0"], LR: ["231", "00", "(?:[2457]\\d|33|88)\\d{7}|(?:2\\d|[4-6])\\d{6}", [7, 8, 9], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["4[67]|[56]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-578]"], "0$1"]], "0"], LS: ["266", "00", "(?:[256]\\d\\d|800)\\d{5}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[2568]"]]]], LT: ["370", "00", "(?:[3469]\\d|52|[78]0)\\d{6}", [8], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["52[0-7]"], "(0-$1)", 1], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[7-9]"], "0 $1", 1], ["(\\d{2})(\\d{6})", "$1 $2", ["37|4(?:[15]|6[1-8])"], "(0-$1)", 1], ["(\\d{3})(\\d{5})", "$1 $2", ["[3-6]"], "(0-$1)", 1]], "0", 0, "[08]"], LU: ["352", "00", "35[013-9]\\d{4,8}|6\\d{8}|35\\d{2,4}|(?:[2457-9]\\d|3[0-46-9])\\d{2,9}", [4, 5, 6, 7, 8, 9, 10, 11], [["(\\d{2})(\\d{3})", "$1 $2", ["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"]], ["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"]], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["20[2-689]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})", "$1 $2 $3 $4", ["2(?:[0367]|4[3-8])"]], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["80[01]|90[015]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["20"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})", "$1 $2 $3 $4 $5", ["2(?:[0367]|4[3-8])"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{1,5})", "$1 $2 $3 $4", ["[3-57]|8[13-9]|9(?:0[89]|[2-579])|(?:2|80)[2-9]"]]], 0, 0, "(15(?:0[06]|1[12]|[35]5|4[04]|6[26]|77|88|99)\\d)"], LV: ["371", "00", "(?:[268]\\d|90)\\d{6}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[269]|8[01]"]]]], LY: ["218", "00", "[2-9]\\d{8}", [9], [["(\\d{2})(\\d{7})", "$1-$2", ["[2-9]"], "0$1"]], "0"], MA: ["212", "00", "[5-8]\\d{8}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["5[45]"], "0$1"], ["(\\d{4})(\\d{5})", "$1-$2", ["5(?:2[2-46-9]|3[3-9]|9)|8(?:0[89]|92)"], "0$1"], ["(\\d{2})(\\d{7})", "$1-$2", ["8"], "0$1"], ["(\\d{3})(\\d{6})", "$1-$2", ["[5-7]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["5(?:2(?:[0-25-79]\\d|3[1-578]|4[02-46-8]|8[0235-7])|3(?:[0-47]\\d|5[02-9]|6[02-8]|8[014-9]|9[3-9])|(?:4[067]|5[03])\\d)\\d{5}"], ["(?:6(?:[0-79]\\d|8[0-247-9])|7(?:[0167]\\d|2[0-8]|5[0-5]|8[0-7]))\\d{6}"], ["80[0-7]\\d{6}"], ["89\\d{7}"], 0, 0, 0, 0, ["(?:592(?:4[0-2]|93)|80[89]\\d\\d)\\d{4}"]]], MC: ["377", "00", "(?:[3489]|6\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["4"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[389]"]], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["6"], "0$1"]], "0"], MD: ["373", "00", "(?:[235-7]\\d|[89]0)\\d{6}", [8], [["(\\d{3})(\\d{5})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["22|3"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[25-7]"], "0$1"]], "0"], ME: ["382", "00", "(?:20|[3-79]\\d)\\d{6}|80\\d{6,7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-9]"], "0$1"]], "0"], MF: ["590", "00", "(?:590\\d|7090)\\d{5}|(?:69|80|9\\d)\\d{7}", [9], 0, "0", 0, 0, 0, 0, 0, [["590(?:0[079]|[14]3|[27][79]|3[03-7]|5[0-268]|87)\\d{4}"], ["(?:69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))|7090[0-4])\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:(?:39[5-7]|76[018])\\d|475[0-6])\\d{4}"]]], MG: ["261", "00", "[23]\\d{8}", [9], [["(\\d{2})(\\d{2})(\\d{3})(\\d{2})", "$1 $2 $3 $4", ["[23]"], "0$1"]], "0", 0, "([24-9]\\d{6})$|0", "20$1"], MH: ["692", "011", "329\\d{4}|(?:[256]\\d|45)\\d{5}", [7], [["(\\d{3})(\\d{4})", "$1-$2", ["[2-6]"]]], "1"], MK: ["389", "00", "[2-578]\\d{7}", [8], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["2|34[47]|4(?:[37]7|5[47]|64)"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[347]"], "0$1"], ["(\\d{3})(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[58]"], "0$1"]], "0"], ML: ["223", "00", "[24-9]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24-9]"]]]], MM: ["95", "00", "1\\d{5,7}|95\\d{6}|(?:[4-7]|9[0-46-9])\\d{6,8}|(?:2|8\\d)\\d{5,8}", [6, 7, 8, 9, 10], [["(\\d)(\\d{2})(\\d{3})", "$1 $2 $3", ["16|2"], "0$1"], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["4(?:[2-46]|5[3-5])|5|6(?:[1-689]|7[235-7])|7(?:[0-4]|5[2-7])|8[1-5]|(?:60|86)[23]"], "0$1"], ["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[12]|452|678|86", "[12]|452|6788|86"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[4-7]|8[1-35]"], "0$1"], ["(\\d)(\\d{3})(\\d{4,6})", "$1 $2 $3", ["9(?:2[0-4]|[35-9]|4[137-9])"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["92"], "0$1"], ["(\\d)(\\d{5})(\\d{4})", "$1 $2 $3", ["9"], "0$1"]], "0"], MN: ["976", "001", "[12]\\d{7,9}|[5-9]\\d{7}", [8, 9, 10], [["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["[12]1"], "0$1"], ["(\\d{4})(\\d{4})", "$1 $2", ["[5-9]"]], ["(\\d{3})(\\d{5,6})", "$1 $2", ["[12]2[1-3]"], "0$1"], ["(\\d{4})(\\d{5,6})", "$1 $2", ["[12](?:27|3[2-8]|4[2-68]|5[1-4689])", "[12](?:27|3[2-8]|4[2-68]|5[1-4689])[0-3]"], "0$1"], ["(\\d{5})(\\d{4,5})", "$1 $2", ["[12]"], "0$1"]], "0"], MO: ["853", "00", "0800\\d{3}|(?:28|[68]\\d)\\d{6}", [7, 8], [["(\\d{4})(\\d{3})", "$1 $2", ["0"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[268]"]]]], MP: ["1", "011", "[58]\\d{9}|(?:67|90)0\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "670$1", 0, "670"], MQ: ["596", "00", "(?:596\\d|7091)\\d{5}|(?:69|[89]\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-79]|8(?:0[6-9]|[36])"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"], MR: ["222", "00", "(?:[2-4]\\d\\d|800)\\d{5}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-48]"]]]], MS: ["1", "011", "(?:[58]\\d\\d|664|900)\\d{7}", [10], 0, "1", 0, "([34]\\d{6})$|1", "664$1", 0, "664"], MT: ["356", "00", "3550\\d{4}|(?:[2579]\\d\\d|800)\\d{5}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[2357-9]"]]]], MU: ["230", "0(?:0|[24-7]0|3[03])", "(?:[57]|8\\d\\d)\\d{7}|[2-468]\\d{6}", [7, 8, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-46]|8[013]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[57]"]], ["(\\d{5})(\\d{5})", "$1 $2", ["8"]]], 0, 0, 0, 0, 0, 0, 0, "020"], MV: ["960", "0(?:0|19)", "(?:800|9[0-57-9]\\d)\\d{7}|[34679]\\d{6}", [7, 10], [["(\\d{3})(\\d{4})", "$1-$2", ["[34679]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], MW: ["265", "00", "(?:[1289]\\d|31|77)\\d{7}|1\\d{6}", [7, 9], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["1[2-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[137-9]"], "0$1"]], "0"], MX: ["52", "0[09]", "[2-9]\\d{9}", [10], [["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["33|5[56]|81"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-9]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], MY: ["60", "00", "1\\d{8,9}|(?:3\\d|[4-9])\\d{7}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1-$2 $3", ["[4-79]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1-$2 $3", ["1(?:[02469]|[378][1-9]|53)|8", "1(?:[02469]|[37][1-9]|53|8(?:[1-46-9]|5[7-9]))|8"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1-$2 $3", ["3"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{4})", "$1-$2-$3-$4", ["1(?:[367]|80)"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2 $3", ["15"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2 $3", ["1"], "0$1"]], "0"], MZ: ["258", "00", "(?:2|8\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2|8[2-79]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]]]], NA: ["264", "00", "[68]\\d{7,8}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["88"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["6"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["87"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"]], "0"], NC: ["687", "00", "(?:050|[2-57-9]\\d\\d)\\d{3}", [6], [["(\\d{2})(\\d{2})(\\d{2})", "$1.$2.$3", ["[02-57-9]"]]]], NE: ["227", "00", "[027-9]\\d{7}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["08"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[089]|2[013]|7[0467]"]]]], NF: ["672", "00", "[13]\\d{5}", [6], [["(\\d{2})(\\d{4})", "$1 $2", ["1[0-3]"]], ["(\\d)(\\d{5})", "$1 $2", ["[13]"]]], 0, 0, "([0-258]\\d{4})$", "3$1"], NG: ["234", "009", "(?:20|9\\d)\\d{8}|[78]\\d{9,13}", [10, 11, 12, 13, 14], [["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[7-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["20[129]"], "0$1"], ["(\\d{4})(\\d{2})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["[78]"], "0$1"], ["(\\d{3})(\\d{5})(\\d{5,6})", "$1 $2 $3", ["[78]"], "0$1"]], "0"], NI: ["505", "00", "(?:1800|[25-8]\\d{3})\\d{4}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[125-8]"]]]], NL: ["31", "00", "(?:[124-7]\\d\\d|3(?:[02-9]\\d|1[0-8]))\\d{6}|8\\d{6,9}|9\\d{6,10}|1\\d{4,5}", [5, 6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{4,7})", "$1 $2", ["[89]0"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["66"], "0$1"], ["(\\d)(\\d{8})", "$1 $2", ["6"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["1[16-8]|2[259]|3[124]|4[17-9]|5[124679]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-578]|91"], "0$1"], ["(\\d{3})(\\d{3})(\\d{5})", "$1 $2 $3", ["9"], "0$1"]], "0"], NO: ["47", "00", "(?:0|[2-9]\\d{3})\\d{4}", [5, 8], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["8"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-79]"]]], 0, 0, 0, 0, 0, "[02-689]|7[0-8]"], NP: ["977", "00", "(?:1\\d|9)\\d{9}|[1-9]\\d{7}", [8, 10, 11], [["(\\d)(\\d{7})", "$1-$2", ["1[2-6]"], "0$1"], ["(\\d{2})(\\d{6})", "$1-$2", ["1[01]|[2-8]|9(?:[1-59]|[67][2-6])"], "0$1"], ["(\\d{3})(\\d{7})", "$1-$2", ["9"]]], "0"], NR: ["674", "00", "(?:222|444|(?:55|8\\d)\\d|666|777|999)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[24-9]"]]]], NU: ["683", "00", "(?:[4-7]|888\\d)\\d{3}", [4, 7], [["(\\d{3})(\\d{4})", "$1 $2", ["8"]]]], NZ: ["64", "0(?:0|161)", "[1289]\\d{9}|50\\d{5}(?:\\d{2,3})?|[27-9]\\d{7,8}|(?:[34]\\d|6[0-35-9])\\d{6}|8\\d{4,6}", [5, 6, 7, 8, 9, 10], [["(\\d{2})(\\d{3,8})", "$1 $2", ["8[1-79]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["50[036-8]|8|90", "50(?:[0367]|88)|8|90"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["24|[346]|7[2-57-9]|9[2-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2(?:10|74)|[589]"], "0$1"], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["1|2[028]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,5})", "$1 $2 $3", ["2(?:[169]|7[0-35-9])|7"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, "00"], OM: ["968", "00", "(?:1505|[279]\\d{3}|500)\\d{4}|800\\d{5,6}", [7, 8, 9], [["(\\d{3})(\\d{4,6})", "$1 $2", ["[58]"]], ["(\\d{2})(\\d{6})", "$1 $2", ["2"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[179]"]]]], PA: ["507", "00", "(?:00800|8\\d{3})\\d{6}|[68]\\d{7}|[1-57-9]\\d{6}", [7, 8, 10, 11], [["(\\d{3})(\\d{4})", "$1-$2", ["[1-57-9]"]], ["(\\d{4})(\\d{4})", "$1-$2", ["[68]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]]]], PE: ["51", "00|19(?:1[124]|77|90)00", "(?:[14-8]|9\\d)\\d{7}", [8, 9], [["(\\d{3})(\\d{5})", "$1 $2", ["80"], "(0$1)"], ["(\\d)(\\d{7})", "$1 $2", ["1"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["[4-8]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"]]], "0", 0, 0, 0, 0, 0, 0, "00", " Anexo "], PF: ["689", "00", "4\\d{5}(?:\\d{2})?|8\\d{7,8}", [6, 8, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["44"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["4|8[7-9]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]]]], PG: ["675", "00|140[1-3]", "(?:180|[78]\\d{3})\\d{4}|(?:[2-589]\\d|64)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["18|[2-69]|85"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[78]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], PH: ["63", "00", "(?:[2-7]|9\\d)\\d{8}|2\\d{5}|(?:1800|8)\\d{7,9}", [6, 8, 9, 10, 11, 12, 13], [["(\\d)(\\d{5})", "$1 $2", ["2"], "(0$1)"], ["(\\d{4})(\\d{4,6})", "$1 $2", ["3(?:23|39|46)|4(?:2[3-6]|[35]9|4[26]|76)|544|88[245]|(?:52|64|86)2", "3(?:230|397|461)|4(?:2(?:35|[46]4|51)|396|4(?:22|63)|59[347]|76[15])|5(?:221|446)|642[23]|8(?:622|8(?:[24]2|5[13]))"], "(0$1)"], ["(\\d{5})(\\d{4})", "$1 $2", ["346|4(?:27|9[35])|883", "3469|4(?:279|9(?:30|56))|8834"], "(0$1)"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[3-7]|8[2-8]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]], ["(\\d{4})(\\d{1,2})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["1"]]], "0"], PK: ["92", "00", "122\\d{6}|[24-8]\\d{10,11}|9(?:[013-9]\\d{8,10}|2(?:[01]\\d\\d|2(?:[06-8]\\d|1[01]))\\d{7})|(?:[2-8]\\d{3}|92(?:[0-7]\\d|8[1-9]))\\d{6}|[24-9]\\d{8}|[89]\\d{7}", [8, 9, 10, 11, 12], [["(\\d{3})(\\d{3})(\\d{2,7})", "$1 $2 $3", ["[89]0"], "0$1"], ["(\\d{4})(\\d{5})", "$1 $2", ["1"]], ["(\\d{3})(\\d{6,7})", "$1 $2", ["2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8])", "9(?:2[3-8]|98)|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:22|3[27-9]|4[2-6]|6[3569]|9[25-7]))[2-9]"], "(0$1)"], ["(\\d{2})(\\d{7,8})", "$1 $2", ["(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]"], "(0$1)"], ["(\\d{5})(\\d{5})", "$1 $2", ["58"], "(0$1)"], ["(\\d{3})(\\d{7})", "$1 $2", ["3"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[24-9]"], "(0$1)"]], "0"], PL: ["48", "00", "(?:6|8\\d\\d)\\d{7}|[1-9]\\d{6}(?:\\d{2})?|[26]\\d{5}", [6, 7, 8, 9, 10], [["(\\d{5})", "$1", ["19"]], ["(\\d{3})(\\d{3})", "$1 $2", ["11|20|64"]], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])1", "(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])19"]], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["64"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["21|39|45|5[0137]|6[0469]|7[02389]|8(?:0[14]|8)"]], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[2-8]|[2-7]|8[1-79]|9[145]"]], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["8"]]]], PM: ["508", "00", "[45]\\d{5}|(?:708|8\\d\\d)\\d{6}", [6, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["[45]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["7"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"], PR: ["1", "011", "(?:[589]\\d\\d|787)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "787|939"], PS: ["970", "00", "[2489]2\\d{6}|(?:1\\d|5)\\d{8}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2489]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0"], PT: ["351", "00", "1693\\d{5}|(?:[26-9]\\d|30)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["2[12]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["16|[236-9]"]]]], PW: ["680", "01[12]", "(?:[24-8]\\d\\d|345|900)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]]], PY: ["595", "00", "59\\d{4,6}|9\\d{5,10}|(?:[2-46-8]\\d|5[0-8])\\d{4,7}", [6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{3,6})", "$1 $2", ["[2-9]0"], "0$1"], ["(\\d{2})(\\d{5})", "$1 $2", ["[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36]"], "(0$1)"], ["(\\d{3})(\\d{4,5})", "$1 $2", ["2[279]|3[13-5]|4[359]|5|6(?:[34]|7[1-46-8])|7[46-8]|85"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2[14-68]|3[26-9]|4[1246-8]|6(?:1|75)|7[1-35]|8[1-36]"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["87"]], ["(\\d{3})(\\d{6})", "$1 $2", ["9(?:[5-79]|8[1-7])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-8]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["9"]]], "0"], QA: ["974", "00", "800\\d{4}|(?:2|800)\\d{6}|(?:0080|[3-7])\\d{7}", [7, 8, 9, 11], [["(\\d{3})(\\d{4})", "$1 $2", ["2[136]|8"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[3-7]"]]]], RE: ["262", "00", "709\\d{6}|(?:26|[689]\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[26-9]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["26(?:2\\d\\d|3(?:0\\d|1[0-6]))\\d{4}"], ["(?:69(?:2\\d\\d|3(?:[06][0-6]|1[0-3]|2[0-2]|3[0-39]|4\\d|5[0-5]|7[0-37]|8[0-8]|9[0-479]))|7092[0-3])\\d{4}"], ["80\\d{7}"], ["89[1-37-9]\\d{6}"], 0, 0, 0, 0, ["9(?:399[0-3]|479[0-6]|76(?:2[278]|3[0-37]))\\d{4}"], ["8(?:1[019]|2[0156]|84|90)\\d{6}"]]], RO: ["40", "00", "(?:[236-8]\\d|90)\\d{7}|[23]\\d{5}", [6, 9], [["(\\d{3})(\\d{3})", "$1 $2", ["2[3-6]", "2[3-6]\\d9"], "0$1"], ["(\\d{2})(\\d{4})", "$1 $2", ["219|31"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[23]1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[236-9]"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, 0, " int "], RS: ["381", "00", "38[02-9]\\d{6,9}|6\\d{7,9}|90\\d{4,8}|38\\d{5,6}|(?:7\\d\\d|800)\\d{3,9}|(?:[12]\\d|3[0-79])\\d{5,10}", [6, 7, 8, 9, 10, 11, 12], [["(\\d{3})(\\d{3,9})", "$1 $2", ["(?:2[389]|39)0|[7-9]"], "0$1"], ["(\\d{2})(\\d{5,10})", "$1 $2", ["[1-36]"], "0$1"]], "0"], RU: ["7", "810", "8\\d{13}|[347-9]\\d{9}", [10, 14], [["(\\d{4})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["7(?:1[0-8]|2[1-9])", "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:1[23]|[2-9]2))", "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:13[03-69]|62[013-9]))|72[1-57-9]2"], "8 ($1)", 1], ["(\\d{5})(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["7(?:1[0-68]|2[1-9])", "7(?:1(?:[06][3-6]|[18]|2[35]|[3-5][3-5])|2(?:[13][3-5]|[24-689]|7[457]))", "7(?:1(?:0(?:[356]|4[023])|[18]|2(?:3[013-9]|5)|3[45]|43[013-79]|5(?:3[1-8]|4[1-7]|5)|6(?:3[0-35-9]|[4-6]))|2(?:1(?:3[178]|[45])|[24-689]|3[35]|7[457]))|7(?:14|23)4[0-8]|71(?:33|45)[1-79]"], "8 ($1)", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "8 ($1)", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[349]|8(?:[02-7]|1[1-8])"], "8 ($1)", 1], ["(\\d{4})(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["8"], "8 ($1)"]], "8", 0, 0, 0, 0, 0, [["336(?:[013-9]\\d|2[013-9])\\d{5}|(?:3(?:0[12]|4[1-35-79]|5[1-3]|65|8[1-58]|9[0145])|4(?:01|1[1356]|2[13467]|7[1-5]|8[1-7]|9[1-689])|8(?:1[1-8]|2[01]|3[13-6]|4[0-8]|5[15-7]|6[0-35-79]|7[1-37-9]))\\d{7}", [10]], ["9\\d{9}", [10]], ["8(?:0[04]|108\\d{3})\\d{7}"], ["80[39]\\d{7}", [10]], ["808\\d{7}", [10]]], "8~10"], RW: ["250", "00", "(?:06|[27]\\d\\d|[89]00)\\d{6}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["0"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[7-9]"], "0$1"]], "0"], SA: ["966", "00", "(?:[15]\\d|800|92)\\d{7}", [9, 10], [["(\\d{4})(\\d{5})", "$1 $2", ["9"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]]], "0"], SB: ["677", "0[01]", "[6-9]\\d{6}|[1-6]\\d{4}", [5, 7], [["(\\d{2})(\\d{5})", "$1 $2", ["6[89]|7|8[4-9]|9(?:[1-8]|9[0-8])"]]]], SC: ["248", "010|0[0-2]", "(?:[2489]\\d|64)\\d{5}", [7], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[246]|9[57]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], SD: ["249", "00", "[19]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[19]"], "0$1"]], "0"], SE: ["46", "00", "(?:[26]\\d\\d|9)\\d{9}|[1-9]\\d{8}|[1-689]\\d{7}|[1-4689]\\d{6}|2\\d{5}", [6, 7, 8, 9, 10, 12], [["(\\d{2})(\\d{2,3})(\\d{2})", "$1-$2 $3", ["20"], "0$1", 0, "$1 $2 $3"], ["(\\d{3})(\\d{4})", "$1-$2", ["9(?:00|39|44|9)"], "0$1", 0, "$1 $2"], ["(\\d{2})(\\d{3})(\\d{2})", "$1-$2 $3", ["[12][136]|3[356]|4[0246]|6[03]|90[1-9]"], "0$1", 0, "$1 $2 $3"], ["(\\d)(\\d{2,3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["8"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2,3})(\\d{2})", "$1-$2 $3", ["1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[125689]|4[02-57]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"], "0$1", 0, "$1 $2 $3"], ["(\\d{3})(\\d{2,3})(\\d{3})", "$1-$2 $3", ["9(?:00|39|44)"], "0$1", 0, "$1 $2 $3"], ["(\\d{2})(\\d{2,3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["1[13689]|2[0136]|3[1356]|4[0246]|54|6[03]|90[1-9]"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["10|7"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d)(\\d{3})(\\d{3})(\\d{2})", "$1-$2 $3 $4", ["8"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["[13-5]|2(?:[247-9]|5[0138])|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{3})", "$1-$2 $3 $4", ["9"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1-$2 $3 $4 $5", ["[26]"], "0$1", 0, "$1 $2 $3 $4 $5"]], "0"], SG: ["65", "0[0-3]\\d", "(?:(?:1\\d|8)\\d\\d|7000)\\d{7}|[3689]\\d{7}", [8, 10, 11], [["(\\d{4})(\\d{4})", "$1 $2", ["[369]|8(?:0[1-9]|[1-9])"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]], ["(\\d{4})(\\d{4})(\\d{3})", "$1 $2 $3", ["7"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]]]], SH: ["290", "00", "(?:[256]\\d|8)\\d{3}", [4, 5], 0, 0, 0, 0, 0, 0, "[256]"], SI: ["386", "00|10(?:22|66|88|99)", "[1-7]\\d{7}|8\\d{4,7}|90\\d{4,6}", [5, 6, 7, 8], [["(\\d{2})(\\d{3,6})", "$1 $2", ["8[09]|9"], "0$1"], ["(\\d{3})(\\d{5})", "$1 $2", ["59|8"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[37][01]|4[0139]|51|6"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[1-57]"], "(0$1)"]], "0", 0, 0, 0, 0, 0, 0, "00"], SJ: ["47", "00", "0\\d{4}|(?:[489]\\d|79)\\d{6}", [5, 8], 0, 0, 0, 0, 0, 0, "79"], SK: ["421", "00", "[2-689]\\d{8}|[2-59]\\d{6}|[2-5]\\d{5}", [6, 7, 9], [["(\\d)(\\d{2})(\\d{3,4})", "$1 $2 $3", ["21"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["[3-5][1-8]1", "[3-5][1-8]1[67]"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{2})", "$1/$2 $3 $4", ["2"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[689]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1/$2 $3 $4", ["[3-5]"], "0$1"]], "0"], SL: ["232", "00", "(?:[237-9]\\d|66)\\d{6}", [8], [["(\\d{2})(\\d{6})", "$1 $2", ["[236-9]"], "(0$1)"]], "0"], SM: ["378", "00", "(?:0549|[5-7]\\d)\\d{6}", [8, 10], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-7]"]], ["(\\d{4})(\\d{6})", "$1 $2", ["0"]]], 0, 0, "([89]\\d{5})$", "0549$1"], SN: ["221", "00", "(?:[378]\\d|93)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[379]"]]]], SO: ["252", "00", "[346-9]\\d{8}|[12679]\\d{7}|[1-5]\\d{6}|[1348]\\d{5}", [6, 7, 8, 9], [["(\\d{2})(\\d{4})", "$1 $2", ["8[125]"]], ["(\\d{6})", "$1", ["[134]"]], ["(\\d)(\\d{6})", "$1 $2", ["[15]|2[0-79]|3[0-46-8]|4[0-7]"]], ["(\\d)(\\d{7})", "$1 $2", ["(?:2|90)4|[67]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[348]|64|79|90"]], ["(\\d{2})(\\d{5,7})", "$1 $2", ["1|28|6[0-35-9]|7[67]|9[2-9]"]]], "0"], SR: ["597", "00", "(?:[2-5]|68|[78]\\d|90)\\d{5}", [6, 7], [["(\\d{2})(\\d{2})(\\d{2})", "$1-$2-$3", ["56"]], ["(\\d{3})(\\d{3})", "$1-$2", ["[2-5]"]], ["(\\d{3})(\\d{4})", "$1-$2", ["[6-9]"]]]], SS: ["211", "00", "[19]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[19]"], "0$1"]], "0"], ST: ["239", "00", "(?:22|9\\d)\\d{5}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[29]"]]]], SV: ["503", "00", "[267]\\d{7}|(?:80\\d|900)\\d{4}(?:\\d{4})?", [7, 8, 11], [["(\\d{3})(\\d{4})", "$1 $2", ["[89]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[267]"]], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["[89]"]]]], SX: ["1", "011", "7215\\d{6}|(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "(5\\d{6})$|1", "721$1", 0, "721"], SY: ["963", "00", "[1-359]\\d{8}|[1-5]\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-4]|5[1-3]"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[59]"], "0$1", 1]], "0"], SZ: ["268", "00", "0800\\d{4}|(?:[237]\\d|900)\\d{6}", [8, 9], [["(\\d{4})(\\d{4})", "$1 $2", ["[0237]"]], ["(\\d{5})(\\d{4})", "$1 $2", ["9"]]]], TA: ["290", "00", "8\\d{3}", [4], 0, 0, 0, 0, 0, 0, "8"], TC: ["1", "011", "(?:[58]\\d\\d|649|900)\\d{7}", [10], 0, "1", 0, "([2-479]\\d{6})$|1", "649$1", 0, "649"], TD: ["235", "00|16", "(?:22|30|[689]\\d|77)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[236-9]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], TG: ["228", "00", "[279]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[279]"]]]], TH: ["66", "00[1-9]", "(?:001800|[2-57]|[689]\\d)\\d{7}|1\\d{7,9}", [8, 9, 10, 13], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[13-9]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0"], TJ: ["992", "810", "[0-57-9]\\d{8}", [9], [["(\\d{6})(\\d)(\\d{2})", "$1 $2 $3", ["331", "3317"]], ["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["44[02-479]|[34]7"]], ["(\\d{4})(\\d)(\\d{4})", "$1 $2 $3", ["3(?:[1245]|3[12])"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[0-57-9]"]]], 0, 0, 0, 0, 0, 0, 0, "8~10"], TK: ["690", "00", "[2-47]\\d{3,6}", [4, 5, 6, 7]], TL: ["670", "00", "7\\d{7}|(?:[2-47]\\d|[89]0)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-489]|70"]], ["(\\d{4})(\\d{4})", "$1 $2", ["7"]]]], TM: ["993", "810", "(?:[1-6]\\d|71)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["12"], "(8 $1)"], ["(\\d{3})(\\d)(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[1-5]"], "(8 $1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["[67]"], "8 $1"]], "8", 0, 0, 0, 0, 0, 0, "8~10"], TN: ["216", "00", "[2-57-9]\\d{7}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-57-9]"]]]], TO: ["676", "00", "(?:0800|(?:[5-8]\\d\\d|999)\\d)\\d{3}|[2-8]\\d{4}", [5, 7], [["(\\d{2})(\\d{3})", "$1-$2", ["[2-4]|50|6[09]|7[0-24-69]|8[05]"]], ["(\\d{4})(\\d{3})", "$1 $2", ["0"]], ["(\\d{3})(\\d{4})", "$1 $2", ["[5-9]"]]]], TR: ["90", "00", "4\\d{6}|8\\d{11,12}|(?:[2-58]\\d\\d|900)\\d{7}", [7, 10, 12, 13], [["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["512|8[01589]|90"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["5(?:[0-59]|61)", "5(?:[0-59]|61[06])", "5(?:[0-59]|61[06]1)"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24][1-8]|3[1-9]"], "(0$1)", 1], ["(\\d{3})(\\d{3})(\\d{6,7})", "$1 $2 $3", ["80"], "0$1", 1]], "0"], TT: ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-46-8]\\d{6})$|1", "868$1", 0, "868"], TV: ["688", "00", "(?:2|7\\d\\d|90)\\d{4}", [5, 6, 7], [["(\\d{2})(\\d{3})", "$1 $2", ["2"]], ["(\\d{2})(\\d{4})", "$1 $2", ["90"]], ["(\\d{2})(\\d{5})", "$1 $2", ["7"]]]], TW: ["886", "0(?:0[25-79]|19)", "[2-689]\\d{8}|7\\d{9,10}|[2-8]\\d{7}|2\\d{6}", [7, 8, 9, 10, 11], [["(\\d{2})(\\d)(\\d{4})", "$1 $2 $3", ["202"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[258]0"], "0$1"], ["(\\d)(\\d{3,4})(\\d{4})", "$1 $2 $3", ["[23568]|4(?:0[02-48]|[1-47-9])|7[1-9]", "[23568]|4(?:0[2-48]|[1-47-9])|(?:400|7)[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[49]"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["7"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, 0, "#"], TZ: ["255", "00[056]", "(?:[25-8]\\d|41|90)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[24]"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["5"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[67]"], "0$1"]], "0"], UA: ["380", "00", "[89]\\d{9}|[3-9]\\d{8}", [9, 10], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6[12][29]|(?:3[1-8]|4[136-8]|5[12457]|6[49])2|(?:56|65)[24]", "6[12][29]|(?:35|4[1378]|5[12457]|6[49])2|(?:56|65)[24]|(?:3[1-46-8]|46)2[013-9]"], "0$1"], ["(\\d{4})(\\d{5})", "$1 $2", ["3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6[0135689]|7[4-6])|6(?:[12][3-7]|[459])", "3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6(?:[015689]|3[02389])|7[4-6])|6(?:[12][3-7]|[459])"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[3-7]|89|9[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[89]"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, "0~0"], UG: ["256", "00[057]", "800\\d{6}|(?:[29]0|[347]\\d)\\d{7}", [9], [["(\\d{4})(\\d{5})", "$1 $2", ["202", "2024"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["[27-9]|4(?:6[45]|[7-9])"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["[34]"], "0$1"]], "0"], US: ["1", "011", "[2-9]\\d{9}|3\\d{6}", [10], [["(\\d{3})(\\d{4})", "$1-$2", ["310"], 0, 1], ["(\\d{3})(\\d{3})(\\d{4})", "($1) $2-$3", ["[2-9]"], 0, 1, "$1-$2-$3"]], "1", 0, 0, 0, 0, 0, [["(?:3052(?:0[0-8]|[1-9]\\d)|5056(?:[0-35-9]\\d|4[0-68]))\\d{4}|(?:2742|305[3-9]|(?:472|983)[2-47-9]|505[2-57-9])\\d{6}|(?:2(?:0[1-35-9]|1[02-9]|2[03-57-9]|3[1459]|4[08]|5[1-46]|6[0279]|7[0269]|8[13])|3(?:0[1-47-9]|1[02-9]|2[0135-79]|3[0-24679]|4[167]|5[0-2]|6[01349]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[023578]|58|6[349]|7[0589]|8[04])|5(?:0[1-47-9]|1[0235-8]|20|3[0149]|4[01]|5[179]|6[1-47]|7[0-5]|8[0256])|6(?:0[1-35-9]|1[024-9]|2[03689]|3[016]|4[0156]|5[01679]|6[0-279]|78|8[0-29])|7(?:0[1-46-8]|1[2-9]|2[04-8]|3[0-247]|4[0378]|5[47]|6[02359]|7[0-59]|8[156])|8(?:0[1-68]|1[02-8]|2[0168]|3[0-2589]|4[03578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[01357-9]|5[12469]|7[0-3589]|8[04-69]))[2-9]\\d{6}"], [""], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"], 0, 0, 0, ["305209\\d{4}"]]], UY: ["598", "0(?:0|1[3-9]\\d)", "0004\\d{2,9}|[1249]\\d{7}|(?:[49]\\d|80)\\d{5}", [6, 7, 8, 9, 10, 11, 12, 13], [["(\\d{3})(\\d{3,4})", "$1 $2", ["0"]], ["(\\d{3})(\\d{4})", "$1 $2", ["[49]0|8"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{4})(\\d{4})", "$1 $2", ["[124]"]], ["(\\d{3})(\\d{3})(\\d{2,4})", "$1 $2 $3", ["0"]], ["(\\d{3})(\\d{3})(\\d{3})(\\d{2,4})", "$1 $2 $3 $4", ["0"]]], "0", 0, 0, 0, 0, 0, 0, "00", " int. "], UZ: ["998", "00", "(?:20|33|[5-9]\\d)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[235-9]"]]]], VA: ["39", "00", "0\\d{5,10}|3[0-8]\\d{7,10}|55\\d{8}|8\\d{5}(?:\\d{2,4})?|(?:1\\d|39)\\d{7,8}", [6, 7, 8, 9, 10, 11, 12], 0, 0, 0, 0, 0, 0, "06698"], VC: ["1", "011", "(?:[58]\\d\\d|784|900)\\d{7}", [10], 0, "1", 0, "([2-7]\\d{6})$|1", "784$1", 0, "784"], VE: ["58", "00", "[68]00\\d{7}|(?:[24]\\d|[59]0)\\d{8}", [10], [["(\\d{3})(\\d{7})", "$1-$2", ["[24-689]"], "0$1"]], "0"], VG: ["1", "011", "(?:284|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-578]\\d{6})$|1", "284$1", 0, "284"], VI: ["1", "011", "[58]\\d{9}|(?:34|90)0\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "340$1", 0, "340"], VN: ["84", "00", "[12]\\d{9}|[135-9]\\d{8}|[16]\\d{7}|[16-8]\\d{6}", [7, 8, 9, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["80"], "0$1", 1], ["(\\d{4})(\\d{4,6})", "$1 $2", ["1"], 0, 1], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["6"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[357-9]"], "0$1", 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["2[48]"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{3})", "$1 $2 $3", ["2"], "0$1", 1]], "0"], VU: ["678", "00", "[57-9]\\d{6}|(?:[238]\\d|48)\\d{3}", [5, 7], [["(\\d{3})(\\d{4})", "$1 $2", ["[57-9]"]]]], WF: ["681", "00", "(?:40|72|8\\d{4})\\d{4}|[89]\\d{5}", [6, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["[47-9]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]]]], WS: ["685", "0", "(?:[2-6]|8\\d{5})\\d{4}|[78]\\d{6}|[68]\\d{5}", [5, 6, 7, 10], [["(\\d{5})", "$1", ["[2-5]|6[1-9]"]], ["(\\d{3})(\\d{3,7})", "$1 $2", ["[68]"]], ["(\\d{2})(\\d{5})", "$1 $2", ["7"]]]], XK: ["383", "00", "2\\d{7,8}|3\\d{7,11}|(?:4\\d\\d|[89]00)\\d{5}", [8, 9, 10, 11, 12], [["(\\d{3})(\\d{5})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-4]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2|39"], "0$1"], ["(\\d{2})(\\d{7,10})", "$1 $2", ["3"], "0$1"]], "0"], YE: ["967", "00", "(?:1|7\\d)\\d{7}|[1-7]\\d{6}", [7, 8, 9], [["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-6]|7(?:[24-6]|8[0-7])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["7"], "0$1"]], "0"], YT: ["262", "00", "7093\\d{5}|(?:80|9\\d)\\d{7}|(?:26|63)9\\d{6}", [9], 0, "0", 0, 0, 0, 0, 0, [["269(?:0[0-467]|15|5[0-4]|6\\d|[78]0)\\d{4}"], ["(?:639(?:0[0-79]|1[019]|[267]\\d|3[09]|40|5[05-9]|9[04-79])|7093[5-7])\\d{4}"], ["80\\d{7}"], 0, 0, 0, 0, 0, ["9(?:(?:39|47)8[01]|769\\d)\\d{4}"]]], ZA: ["27", "00", "[1-79]\\d{8}|8\\d{4,9}", [5, 6, 7, 8, 9, 10], [["(\\d{2})(\\d{3,4})", "$1 $2", ["8[1-4]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["8[1-4]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["860"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"]], "0"], ZM: ["260", "00", "800\\d{6}|(?:21|[579]\\d|63)\\d{7}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[28]"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["[579]"], "0$1"]], "0"], ZW: ["263", "00", "2(?:[0-57-9]\\d{6,8}|6[0-24-9]\\d{6,7})|[38]\\d{9}|[35-8]\\d{8}|[3-6]\\d{7}|[1-689]\\d{6}|[1-3569]\\d{5}|[1356]\\d{4}", [5, 6, 7, 8, 9, 10], [["(\\d{3})(\\d{3,5})", "$1 $2", ["2(?:0[45]|2[278]|[49]8)|3(?:[09]8|17)|6(?:[29]8|37|75)|[23][78]|(?:33|5[15]|6[68])[78]"], "0$1"], ["(\\d)(\\d{3})(\\d{2,4})", "$1 $2 $3", ["[49]"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["80"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["24|8[13-59]|(?:2[05-79]|39|5[45]|6[15-8])2", "2(?:02[014]|4|[56]20|[79]2)|392|5(?:42|525)|6(?:[16-8]21|52[013])|8[13-59]"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2(?:1[39]|2[0157]|[378]|[56][14])|3(?:12|29)", "2(?:1[39]|2[0157]|[378]|[56][14])|3(?:123|29)"], "0$1"], ["(\\d{4})(\\d{6})", "$1 $2", ["8"], "0$1"], ["(\\d{2})(\\d{3,5})", "$1 $2", ["1|2(?:0[0-36-9]|12|29|[56])|3(?:1[0-689]|[24-6])|5(?:[0236-9]|1[2-4])|6(?:[013-59]|7[0-46-9])|(?:33|55|6[68])[0-69]|(?:29|3[09]|62)[0-79]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["29[013-9]|39|54"], "0$1"], ["(\\d{4})(\\d{3,5})", "$1 $2", ["(?:25|54)8", "258|5483"], "0$1"]], "0"] }, nonGeographic: { 800: ["800", 0, "(?:00|[1-9]\\d)\\d{6}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["\\d"]]], 0, 0, 0, 0, 0, 0, [0, 0, ["(?:00|[1-9]\\d)\\d{6}"]]], 808: ["808", 0, "[1-9]\\d{7}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[1-9]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, 0, ["[1-9]\\d{7}"]]], 870: ["870", 0, "7\\d{11}|[235-7]\\d{8}", [9, 12], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235-7]"]]], 0, 0, 0, 0, 0, 0, [0, ["(?:[356]|774[45])\\d{8}|7[6-8]\\d{7}"], 0, 0, 0, 0, 0, 0, ["2\\d{8}", [9]]]], 878: ["878", 0, "10\\d{10}", [12], [["(\\d{2})(\\d{5})(\\d{5})", "$1 $2 $3", ["1"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, ["10\\d{10}"]]], 881: ["881", 0, "6\\d{9}|[0-36-9]\\d{8}", [9, 10], [["(\\d)(\\d{3})(\\d{5})", "$1 $2 $3", ["[0-37-9]"]], ["(\\d)(\\d{3})(\\d{5,6})", "$1 $2 $3", ["6"]]], 0, 0, 0, 0, 0, 0, [0, ["6\\d{9}|[0-36-9]\\d{8}"]]], 882: ["882", 0, "[13]\\d{6}(?:\\d{2,5})?|[19]\\d{7}|(?:[25]\\d\\d|4)\\d{7}(?:\\d{2})?", [7, 8, 9, 10, 11, 12], [["(\\d{2})(\\d{5})", "$1 $2", ["16|342"]], ["(\\d{2})(\\d{6})", "$1 $2", ["49"]], ["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["1[36]|9"]], ["(\\d{2})(\\d{4})(\\d{3})", "$1 $2 $3", ["3[23]"]], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["16"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["10|23|3(?:[15]|4[57])|4|51"]], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["34"]], ["(\\d{2})(\\d{4,5})(\\d{5})", "$1 $2 $3", ["[1-35]"]]], 0, 0, 0, 0, 0, 0, [0, ["342\\d{4}|(?:337|49)\\d{6}|(?:3(?:2|47|7\\d{3})|50\\d{3})\\d{7}", [7, 8, 9, 10, 12]], 0, 0, 0, ["348[57]\\d{7}", [11]], 0, 0, ["1(?:3(?:0[0347]|[13][0139]|2[035]|4[013568]|6[0459]|7[06]|8[15-8]|9[0689])\\d{4}|6\\d{5,10})|(?:345\\d|9[89])\\d{6}|(?:10|2(?:3|85\\d)|3(?:[15]|[69]\\d\\d)|4[15-8]|51)\\d{8}"]]], 883: ["883", 0, "(?:[1-4]\\d|51)\\d{6,10}", [8, 9, 10, 11, 12], [["(\\d{3})(\\d{3})(\\d{2,8})", "$1 $2 $3", ["[14]|2[24-689]|3[02-689]|51[24-9]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["510"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["21"]], ["(\\d{4})(\\d{4})(\\d{4})", "$1 $2 $3", ["51[13]"]], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[235]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, ["(?:2(?:00\\d\\d|10)|(?:370[1-9]|51\\d0)\\d)\\d{7}|51(?:00\\d{5}|[24-9]0\\d{4,7})|(?:1[0-79]|2[24-689]|3[02-689]|4[0-4])0\\d{5,9}"]]], 888: ["888", 0, "\\d{11}", [11], [["(\\d{3})(\\d{3})(\\d{5})", "$1 $2 $3"]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, ["\\d{11}"]]], 979: ["979", 0, "[1359]\\d{8}", [9], [["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["[1359]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, ["[1359]\\d{8}"]]] } };
function Fi(e, t) {
  var r = Array.prototype.slice.call(t);
  return r.push(_y), e.apply(this, r);
}
function Js(e, t) {
  e = e.split("-"), t = t.split("-");
  for (var r = e[0].split("."), n = t[0].split("."), a = 0; a < 3; a++) {
    var d = Number(r[a]), o = Number(n[a]);
    if (d > o) return 1;
    if (o > d) return -1;
    if (!isNaN(d) && isNaN(o)) return 1;
    if (isNaN(d) && !isNaN(o)) return -1;
  }
  return e[1] && t[1] ? e[1] > t[1] ? 1 : e[1] < t[1] ? -1 : 0 : !e[1] && t[1] ? 1 : e[1] && !t[1] ? -1 : 0;
}
var xy = {}.constructor;
function jr(e) {
  return e != null && e.constructor === xy;
}
function Yr(e) {
  "@babel/helpers - typeof";
  return Yr = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Yr(e);
}
function qa(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}
function Sy(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Cy(n.key), n);
  }
}
function Ka(e, t, r) {
  return t && Sy(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function Cy(e) {
  var t = Py(e, "string");
  return Yr(t) == "symbol" ? t : t + "";
}
function Py(e, t) {
  if (Yr(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (Yr(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
var Ay = "1.2.0", Ey = "1.7.35", Qs = " ext. ", My = /^\d+$/, Fe = /* @__PURE__ */ (function() {
  function e(t) {
    qa(this, e), r2(t), this.metadata = t, n2.call(this, t);
  }
  return Ka(e, [{
    key: "getCountries",
    value: function() {
      return Object.keys(this.metadata.countries).filter(function(r) {
        return r !== "001";
      });
    }
  }, {
    key: "getCountryMetadata",
    value: function(r) {
      return this.metadata.countries[r];
    }
  }, {
    key: "nonGeographic",
    value: function() {
      if (!(this.v1 || this.v2 || this.v3))
        return this.metadata.nonGeographic || this.metadata.nonGeographical;
    }
  }, {
    key: "hasCountry",
    value: function(r) {
      return this.getCountryMetadata(r) !== void 0;
    }
  }, {
    key: "hasCallingCode",
    value: function(r) {
      if (this.getCountryCodesForCallingCode(r))
        return !0;
      if (this.nonGeographic()) {
        if (this.nonGeographic()[r])
          return !0;
      } else {
        var n = this.countryCallingCodes()[r];
        if (n && n.length === 1 && n[0] === "001")
          return !0;
      }
    }
  }, {
    key: "isNonGeographicCallingCode",
    value: function(r) {
      return this.nonGeographic() ? !!this.nonGeographic()[r] : !this.getCountryCodesForCallingCode(r);
    }
    // Deprecated.
  }, {
    key: "country",
    value: function(r) {
      return this.selectNumberingPlan(r);
    }
  }, {
    key: "selectNumberingPlan",
    value: function(r, n) {
      if (r && My.test(r) && (n = r, r = null), r && r !== "001") {
        if (!this.hasCountry(r))
          throw new Error("Unknown country: ".concat(r));
        this.numberingPlan = new Xs(this.getCountryMetadata(r), this);
      } else if (n) {
        if (!this.hasCallingCode(n))
          throw new Error("Unknown calling code: ".concat(n));
        this.numberingPlan = new Xs(this.getNumberingPlanMetadata(n), this);
      } else
        this.numberingPlan = void 0;
      return this;
    }
  }, {
    key: "getCountryCodesForCallingCode",
    value: function(r) {
      var n = this.countryCallingCodes()[r];
      if (n)
        return n.length === 1 && n[0].length === 3 ? void 0 : n;
    }
  }, {
    key: "getCountryCodeForCallingCode",
    value: function(r) {
      var n = this.getCountryCodesForCallingCode(r);
      if (n)
        return n[0];
    }
  }, {
    key: "getNumberingPlanMetadata",
    value: function(r) {
      var n = this.getCountryCodeForCallingCode(r);
      if (n)
        return this.getCountryMetadata(n);
      if (this.nonGeographic()) {
        var a = this.nonGeographic()[r];
        if (a)
          return a;
      } else {
        var d = this.countryCallingCodes()[r];
        if (d && d.length === 1 && d[0] === "001")
          return this.metadata.countries["001"];
      }
    }
    // Deprecated.
  }, {
    key: "countryCallingCode",
    value: function() {
      return this.numberingPlan.callingCode();
    }
    // Deprecated.
  }, {
    key: "IDDPrefix",
    value: function() {
      return this.numberingPlan.IDDPrefix();
    }
    // Deprecated.
  }, {
    key: "defaultIDDPrefix",
    value: function() {
      return this.numberingPlan.defaultIDDPrefix();
    }
    // Deprecated.
  }, {
    key: "nationalNumberPattern",
    value: function() {
      return this.numberingPlan.nationalNumberPattern();
    }
    // Deprecated.
  }, {
    key: "possibleLengths",
    value: function() {
      return this.numberingPlan.possibleLengths();
    }
    // Deprecated.
  }, {
    key: "formats",
    value: function() {
      return this.numberingPlan.formats();
    }
    // Deprecated.
  }, {
    key: "nationalPrefixForParsing",
    value: function() {
      return this.numberingPlan.nationalPrefixForParsing();
    }
    // Deprecated.
  }, {
    key: "nationalPrefixTransformRule",
    value: function() {
      return this.numberingPlan.nationalPrefixTransformRule();
    }
    // Deprecated.
  }, {
    key: "leadingDigits",
    value: function() {
      return this.numberingPlan.leadingDigits();
    }
    // Deprecated.
  }, {
    key: "hasTypes",
    value: function() {
      return this.numberingPlan.hasTypes();
    }
    // Deprecated.
  }, {
    key: "type",
    value: function(r) {
      return this.numberingPlan.type(r);
    }
    // Deprecated.
  }, {
    key: "ext",
    value: function() {
      return this.numberingPlan.ext();
    }
  }, {
    key: "countryCallingCodes",
    value: function() {
      return this.v1 ? this.metadata.country_phone_code_to_countries : this.metadata.country_calling_codes;
    }
    // Deprecated.
  }, {
    key: "chooseCountryByCountryCallingCode",
    value: function(r) {
      return this.selectNumberingPlan(r);
    }
  }, {
    key: "hasSelectedNumberingPlan",
    value: function() {
      return this.numberingPlan !== void 0;
    }
  }]);
})(), Xs = /* @__PURE__ */ (function() {
  function e(t, r) {
    qa(this, e), this.globalMetadataObject = r, this.metadata = t, n2.call(this, r.metadata);
  }
  return Ka(e, [{
    key: "callingCode",
    value: function() {
      return this.metadata[0];
    }
    // Formatting information for regions which share
    // a country calling code is contained by only one region
    // for performance reasons. For example, for NANPA region
    // ("North American Numbering Plan Administration",
    //  which includes USA, Canada, Cayman Islands, Bahamas, etc)
    // it will be contained in the metadata for `US`.
  }, {
    key: "getDefaultCountryMetadataForRegion",
    value: function() {
      return this.globalMetadataObject.getNumberingPlanMetadata(this.callingCode());
    }
    // Is always present.
  }, {
    key: "IDDPrefix",
    value: function() {
      if (!(this.v1 || this.v2))
        return this.metadata[1];
    }
    // Is only present when a country supports multiple IDD prefixes.
  }, {
    key: "defaultIDDPrefix",
    value: function() {
      if (!(this.v1 || this.v2))
        return this.metadata[12];
    }
  }, {
    key: "nationalNumberPattern",
    value: function() {
      return this.v1 || this.v2 ? this.metadata[1] : this.metadata[2];
    }
    // "possible length" data is always present in Google's metadata.
  }, {
    key: "possibleLengths",
    value: function() {
      if (!this.v1)
        return this.metadata[this.v2 ? 2 : 3];
    }
  }, {
    key: "_getFormats",
    value: function(r) {
      return r[this.v1 ? 2 : this.v2 ? 3 : 4];
    }
    // For countries of the same region (e.g. NANPA)
    // formats are all stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".
  }, {
    key: "formats",
    value: function() {
      var r = this, n = this._getFormats(this.metadata) || this._getFormats(this.getDefaultCountryMetadataForRegion()) || [];
      return n.map(function(a) {
        return new Oy(a, r);
      });
    }
  }, {
    key: "nationalPrefix",
    value: function() {
      return this.metadata[this.v1 ? 3 : this.v2 ? 4 : 5];
    }
  }, {
    key: "_getNationalPrefixFormattingRule",
    value: function(r) {
      return r[this.v1 ? 4 : this.v2 ? 5 : 6];
    }
    // For countries of the same region (e.g. NANPA)
    // national prefix formatting rule is stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".
  }, {
    key: "nationalPrefixFormattingRule",
    value: function() {
      return this._getNationalPrefixFormattingRule(this.metadata) || this._getNationalPrefixFormattingRule(this.getDefaultCountryMetadataForRegion());
    }
  }, {
    key: "_nationalPrefixForParsing",
    value: function() {
      return this.metadata[this.v1 ? 5 : this.v2 ? 6 : 7];
    }
  }, {
    key: "nationalPrefixForParsing",
    value: function() {
      return this._nationalPrefixForParsing() || this.nationalPrefix();
    }
  }, {
    key: "nationalPrefixTransformRule",
    value: function() {
      return this.metadata[this.v1 ? 6 : this.v2 ? 7 : 8];
    }
  }, {
    key: "_getNationalPrefixIsOptionalWhenFormatting",
    value: function() {
      return !!this.metadata[this.v1 ? 7 : this.v2 ? 8 : 9];
    }
    // For countries of the same region (e.g. NANPA)
    // "national prefix is optional when formatting" flag is
    // stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".
  }, {
    key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
    value: function() {
      return this._getNationalPrefixIsOptionalWhenFormatting(this.metadata) || this._getNationalPrefixIsOptionalWhenFormatting(this.getDefaultCountryMetadataForRegion());
    }
  }, {
    key: "leadingDigits",
    value: function() {
      return this.metadata[this.v1 ? 8 : this.v2 ? 9 : 10];
    }
  }, {
    key: "types",
    value: function() {
      return this.metadata[this.v1 ? 9 : this.v2 ? 10 : 11];
    }
  }, {
    key: "hasTypes",
    value: function() {
      return this.types() && this.types().length === 0 ? !1 : !!this.types();
    }
  }, {
    key: "type",
    value: function(r) {
      if (this.hasTypes() && e0(this.types(), r))
        return new ky(e0(this.types(), r), this);
    }
  }, {
    key: "ext",
    value: function() {
      return this.v1 || this.v2 ? Qs : this.metadata[13] || Qs;
    }
  }]);
})(), Oy = /* @__PURE__ */ (function() {
  function e(t, r) {
    qa(this, e), this._format = t, this.metadata = r;
  }
  return Ka(e, [{
    key: "pattern",
    value: function() {
      return this._format[0];
    }
  }, {
    key: "format",
    value: function() {
      return this._format[1];
    }
  }, {
    key: "leadingDigitsPatterns",
    value: function() {
      return this._format[2] || [];
    }
  }, {
    key: "nationalPrefixFormattingRule",
    value: function() {
      return this._format[3] || this.metadata.nationalPrefixFormattingRule();
    }
  }, {
    key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
    value: function() {
      return !!this._format[4] || this.metadata.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
    }
  }, {
    key: "nationalPrefixIsMandatoryWhenFormattingInNationalFormat",
    value: function() {
      return this.usesNationalPrefix() && !this.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
    }
    // Checks whether national prefix formatting rule contains national prefix.
  }, {
    key: "usesNationalPrefix",
    value: function() {
      return !!(this.nationalPrefixFormattingRule() && // Check that national prefix formatting rule is not a "dummy" one.
      !Ty.test(this.nationalPrefixFormattingRule()));
    }
  }, {
    key: "internationalFormat",
    value: function() {
      return this._format[5] || this.format();
    }
  }]);
})(), Ty = /^\(?\$1\)?$/, ky = /* @__PURE__ */ (function() {
  function e(t, r) {
    qa(this, e), this.type = t, this.metadata = r;
  }
  return Ka(e, [{
    key: "pattern",
    value: function() {
      return this.metadata.v1 ? this.type : this.type[0];
    }
  }, {
    key: "possibleLengths",
    value: function() {
      if (!this.metadata.v1)
        return this.type[1] || this.metadata.possibleLengths();
    }
  }]);
})();
function e0(e, t) {
  switch (t) {
    case "FIXED_LINE":
      return e[0];
    case "MOBILE":
      return e[1];
    case "TOLL_FREE":
      return e[2];
    case "PREMIUM_RATE":
      return e[3];
    case "PERSONAL_NUMBER":
      return e[4];
    case "VOICEMAIL":
      return e[5];
    case "UAN":
      return e[6];
    case "PAGER":
      return e[7];
    case "VOIP":
      return e[8];
    case "SHARED_COST":
      return e[9];
  }
}
function r2(e) {
  if (!e)
    throw new Error("[libphonenumber-js] `metadata` argument not passed. Check your arguments.");
  if (!jr(e) || !jr(e.countries))
    throw new Error("[libphonenumber-js] `metadata` argument was passed but it's not a valid metadata. Must be an object having `.countries` child object property. Got ".concat(jr(e) ? "an object of shape: { " + Object.keys(e).join(", ") + " }" : "a " + Iy(e) + ": " + e, "."));
}
var Iy = function(t) {
  return Yr(t);
};
function Ya(e, t) {
  if (t = new Fe(t), t.hasCountry(e))
    return t.country(e).countryCallingCode();
  throw new Error("Unknown country: ".concat(e));
}
function Ry(e, t) {
  return t.countries.hasOwnProperty(e);
}
function n2(e) {
  var t = e.version;
  typeof t == "number" ? (this.v1 = t === 1, this.v2 = t === 2, this.v3 = t === 3, this.v4 = t === 4) : t ? Js(t, Ay) === -1 ? this.v2 = !0 : Js(t, Ey) === -1 ? this.v3 = !0 : this.v4 = !0 : this.v1 = !0;
}
function Li(e, t) {
  return Dy(e, void 0, t);
}
function Dy(e, t, r) {
  var n = r.type(t), a = n && n.possibleLengths() || r.possibleLengths();
  if (!a)
    return "IS_POSSIBLE";
  var d = e.length, o = a[0];
  return o === d ? "IS_POSSIBLE" : o > d ? "TOO_SHORT" : a[a.length - 1] < d ? "TOO_LONG" : a.indexOf(d, 1) >= 0 ? "IS_POSSIBLE" : "INVALID_LENGTH";
}
function Ny(e, t, r) {
  if (t === void 0 && (t = {}), r = new Fe(r), t.v2) {
    if (!e.countryCallingCode)
      throw new Error("Invalid phone number object passed");
    r.selectNumberingPlan(e.countryCallingCode);
  } else {
    if (!e.phone)
      return !1;
    if (e.country) {
      if (!r.hasCountry(e.country))
        throw new Error("Unknown country: ".concat(e.country));
      r.country(e.country);
    } else {
      if (!e.countryCallingCode)
        throw new Error("Invalid phone number object passed");
      r.selectNumberingPlan(e.countryCallingCode);
    }
  }
  if (r.possibleLengths())
    return a2(e.phone || e.nationalNumber, r);
  if (e.countryCallingCode && r.isNonGeographicCallingCode(e.countryCallingCode))
    return !0;
  throw new Error('Missing "possibleLengths" in metadata. Perhaps the metadata has been generated before v1.0.18.');
}
function a2(e, t) {
  switch (Li(e, t)) {
    case "IS_POSSIBLE":
      return !0;
    // This library ignores "local-only" phone numbers (for simplicity).
    // See the readme for more info on what are "local-only" phone numbers.
    // case 'IS_POSSIBLE_LOCAL_ONLY':
    // 	return !isInternational
    default:
      return !1;
  }
}
function Mt(e, t) {
  return e = e || "", new RegExp("^(?:" + t + ")$").test(e);
}
function Fy(e, t) {
  var r = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r) return (r = r.call(e)).next.bind(r);
  if (Array.isArray(e) || (r = Ly(e)) || t) {
    r && (e = r);
    var n = 0;
    return function() {
      return n >= e.length ? { done: !0 } : { done: !1, value: e[n++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Ly(e, t) {
  if (e) {
    if (typeof e == "string") return t0(e, t);
    var r = {}.toString.call(e).slice(8, -1);
    return r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set" ? Array.from(e) : r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? t0(e, t) : void 0;
  }
}
function t0(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = Array(t); r < t; r++) n[r] = e[r];
  return n;
}
var By = ["MOBILE", "PREMIUM_RATE", "TOLL_FREE", "SHARED_COST", "VOIP", "PERSONAL_NUMBER", "PAGER", "UAN", "VOICEMAIL"];
function Bi(e, t, r) {
  if (t = t || {}, !(!e.country && !e.countryCallingCode)) {
    r = new Fe(r), r.selectNumberingPlan(e.country, e.countryCallingCode);
    var n = t.v2 ? e.nationalNumber : e.phone;
    if (Mt(n, r.nationalNumberPattern())) {
      if (Ed(n, "FIXED_LINE", r))
        return r.type("MOBILE") && r.type("MOBILE").pattern() === "" || !r.type("MOBILE") || Ed(n, "MOBILE", r) ? "FIXED_LINE_OR_MOBILE" : "FIXED_LINE";
      for (var a = Fy(By), d; !(d = a()).done; ) {
        var o = d.value;
        if (Ed(n, o, r))
          return o;
      }
    }
  }
}
function Ed(e, t, r) {
  return t = r.type(t), !t || !t.pattern() || t.possibleLengths() && t.possibleLengths().indexOf(e.length) < 0 ? !1 : Mt(e, t.pattern());
}
function Vy(e, t, r) {
  if (t = t || {}, r = new Fe(r), r.selectNumberingPlan(e.country, e.countryCallingCode), r.hasTypes())
    return Bi(e, t, r.metadata) !== void 0;
  var n = t.v2 ? e.nationalNumber : e.phone;
  return Mt(n, r.nationalNumberPattern());
}
function jy(e, t, r) {
  var n = new Fe(r), a = n.getCountryCodesForCallingCode(e);
  return a ? a.filter(function(d) {
    return Gy(t, d, r);
  }) : [];
}
function Gy(e, t, r) {
  var n = new Fe(r);
  return n.selectNumberingPlan(t), n.numberingPlan.possibleLengths().indexOf(e.length) >= 0;
}
var Vi = 2, Uy = 17, Hy = 3, nt = "0-9０-９٠-٩۰-۹", Wy = "-‐-―−ー－", zy = "／/", qy = "．.", Ky = "  ­​⁠　", Yy = "()（）［］\\[\\]", Zy = "~⁓∼～", ka = "".concat(Wy).concat(zy).concat(qy).concat(Ky).concat(Yy).concat(Zy), ji = "+＋", Jy = new RegExp("([" + nt + "])");
function Qy(e, t, r, n) {
  if (t) {
    var a = new Fe(n);
    a.selectNumberingPlan(t, r);
    var d = new RegExp(a.IDDPrefix());
    if (e.search(d) === 0) {
      e = e.slice(e.match(d)[0].length);
      var o = e.match(Jy);
      if (!(o && o[1] != null && o[1].length > 0 && o[1] === "0"))
        return e;
    }
  }
}
function Xy(e, t) {
  if (e && t.numberingPlan.nationalPrefixForParsing()) {
    var r = new RegExp("^(?:" + t.numberingPlan.nationalPrefixForParsing() + ")"), n = r.exec(e);
    if (n) {
      var a, d, o = n.length - 1, i = o > 0 && n[o];
      if (t.nationalPrefixTransformRule() && i)
        a = e.replace(r, t.nationalPrefixTransformRule()), o > 1 && (d = n[1]);
      else {
        var l = n[0];
        a = e.slice(l.length), i && (d = n[1]);
      }
      var s;
      if (i) {
        var u = e.indexOf(n[1]), $ = e.slice(0, u);
        $ === t.numberingPlan.nationalPrefix() && (s = t.numberingPlan.nationalPrefix());
      } else
        s = n[0];
      return {
        nationalNumber: a,
        nationalPrefix: s,
        carrierCode: d
      };
    }
  }
  return {
    nationalNumber: e
  };
}
function ri(e, t) {
  var r = Xy(e, t), n = r.carrierCode, a = r.nationalNumber;
  if (a !== e) {
    if (!eg(e, a, t))
      return {
        nationalNumber: e
      };
    if (t.possibleLengths() && !tg(a, t))
      return {
        nationalNumber: e
      };
  }
  return {
    nationalNumber: a,
    carrierCode: n
  };
}
function eg(e, t, r) {
  return !(Mt(e, r.nationalNumberPattern()) && !Mt(t, r.nationalNumberPattern()));
}
function tg(e, t) {
  switch (Li(e, t)) {
    case "TOO_SHORT":
    case "INVALID_LENGTH":
      return !1;
    default:
      return !0;
  }
}
function rg(e, t, r, n) {
  var a = t ? Ya(t, n) : r;
  if (e.indexOf(a) === 0) {
    n = new Fe(n), n.selectNumberingPlan(t, r);
    var d = e.slice(a.length), o = ri(d, n), i = o.nationalNumber, l = ri(e, n), s = l.nationalNumber;
    if (!Mt(s, n.nationalNumberPattern()) && Mt(i, n.nationalNumberPattern()) || Li(s, n) === "TOO_LONG")
      return {
        countryCallingCode: a,
        number: d
      };
  }
  return {
    number: e
  };
}
function d2(e, t, r, n) {
  if (!e)
    return {};
  var a;
  if (e[0] !== "+") {
    var d = Qy(e, t, r, n);
    if (d && d !== e)
      a = !0, e = "+" + d;
    else {
      if (t || r) {
        var o = rg(e, t, r, n), i = o.countryCallingCode, l = o.number;
        if (i)
          return {
            countryCallingCodeSource: "FROM_NUMBER_WITHOUT_PLUS_SIGN",
            countryCallingCode: i,
            number: l
          };
      }
      return {
        // No need to set it to `UNSPECIFIED`. It can be just `undefined`.
        // countryCallingCodeSource: 'UNSPECIFIED',
        number: e
      };
    }
  }
  if (e[1] === "0")
    return {};
  n = new Fe(n);
  for (var s = 2; s - 1 <= Hy && s <= e.length; ) {
    var u = e.slice(1, s);
    if (n.hasCallingCode(u))
      return n.selectNumberingPlan(u), {
        countryCallingCodeSource: a ? "FROM_NUMBER_WITH_IDD" : "FROM_NUMBER_WITH_PLUS_SIGN",
        countryCallingCode: u,
        number: e.slice(s)
      };
    s++;
  }
  return {};
}
function ng(e) {
  return e.replace(new RegExp("[".concat(ka, "]+"), "g"), " ").trim();
}
var ag = /(\$\d)/;
function dg(e, t, r) {
  var n = r.useInternationalFormat, a = r.withNationalPrefix, d = e.replace(new RegExp(t.pattern()), n ? t.internationalFormat() : (
    // This library doesn't use `domestic_carrier_code_formatting_rule`,
    // because that one is only used when formatting phone numbers
    // for dialing from a mobile phone, and this is not a dialing library.
    // carrierCode && format.domesticCarrierCodeFormattingRule()
    // 	// First, replace the $CC in the formatting rule with the desired carrier code.
    // 	// Then, replace the $FG in the formatting rule with the first group
    // 	// and the carrier code combined in the appropriate way.
    // 	? format.format().replace(FIRST_GROUP_PATTERN, format.domesticCarrierCodeFormattingRule().replace('$CC', carrierCode))
    // 	: (
    // 		withNationalPrefix && format.nationalPrefixFormattingRule()
    // 			? format.format().replace(FIRST_GROUP_PATTERN, format.nationalPrefixFormattingRule())
    // 			: format.format()
    // 	)
    a && t.nationalPrefixFormattingRule() ? t.format().replace(ag, t.nationalPrefixFormattingRule()) : t.format()
  ));
  return n ? ng(d) : d;
}
var og = /^[\d]+(?:[~\u2053\u223C\uFF5E][\d]+)?$/;
function ig(e, t, r) {
  var n = new Fe(r);
  if (n.selectNumberingPlan(e, t), n.defaultIDDPrefix())
    return n.defaultIDDPrefix();
  if (og.test(n.IDDPrefix()))
    return n.IDDPrefix();
}
var lg = ";ext=", Rr = function(t) {
  return "([".concat(nt, "]{1,").concat(t, "})");
};
function o2(e) {
  var t = "20", r = "15", n = "9", a = "6", d = "[  \\t,]*", o = "[:\\.．]?[  \\t,-]*", i = "#?", l = "(?:e?xt(?:ensi(?:ó?|ó))?n?|ｅ?ｘｔｎ?|доб|anexo)", s = "(?:[xｘ#＃~～]|int|ｉｎｔ)", u = "[- ]+", $ = "[  \\t]*", y = "(?:,{2}|;)", h = lg + Rr(t), c = d + l + o + Rr(t) + i, p = d + s + o + Rr(n) + i, f = u + Rr(a) + "#", v = $ + y + o + Rr(r) + i, w = $ + "(?:,)+" + o + Rr(n) + i;
  return h + "|" + c + "|" + p + "|" + f + "|" + v + "|" + w;
}
var sg = "[" + nt + "]{" + Vi + "}", ug = "[" + ji + "]{0,1}(?:[" + ka + "]*[" + nt + "]){3,}[" + ka + nt + "]*", cg = new RegExp("^[" + ji + "]{0,1}(?:[" + ka + "]*[" + nt + "]){1,2}$", "i"), fg = ug + // Phone number extensions
"(?:" + o2() + ")?", $g = new RegExp(
  // Either a short two-digit-only phone number
  "^" + sg + "$|^" + fg + "$",
  "i"
);
function pg(e) {
  return e.length >= Vi && $g.test(e);
}
function mg(e) {
  return cg.test(e);
}
function hg(e) {
  var t = e.number, r = e.ext;
  if (!t)
    return "";
  if (t[0] !== "+")
    throw new Error('"formatRFC3966()" expects "number" to be in E.164 format.');
  return "tel:".concat(t).concat(r ? ";ext=" + r : "");
}
function In(e) {
  "@babel/helpers - typeof";
  return In = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, In(e);
}
function vg(e, t) {
  var r = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r) return (r = r.call(e)).next.bind(r);
  if (Array.isArray(e) || (r = yg(e)) || t) {
    r && (e = r);
    var n = 0;
    return function() {
      return n >= e.length ? { done: !0 } : { done: !1, value: e[n++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function yg(e, t) {
  if (e) {
    if (typeof e == "string") return r0(e, t);
    var r = {}.toString.call(e).slice(8, -1);
    return r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set" ? Array.from(e) : r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? r0(e, t) : void 0;
  }
}
function r0(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function n0(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function a0(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? n0(Object(r), !0).forEach(function(n) {
      gg(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : n0(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function gg(e, t, r) {
  return (t = bg(t)) in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function bg(e) {
  var t = wg(e, "string");
  return In(t) == "symbol" ? t : t + "";
}
function wg(e, t) {
  if (In(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (In(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var d0 = {
  formatExtension: function(t, r, n) {
    return "".concat(t).concat(n.ext()).concat(r);
  }
};
function _g(e, t, r, n) {
  if (r ? r = a0(a0({}, d0), r) : r = d0, n = new Fe(n), e.country && e.country !== "001") {
    if (!n.hasCountry(e.country))
      throw new Error("Unknown country: ".concat(e.country));
    n.country(e.country);
  } else if (e.countryCallingCode)
    n.selectNumberingPlan(e.countryCallingCode);
  else return e.phone || "";
  var a = n.countryCallingCode(), d = r.v2 ? e.nationalNumber : e.phone, o;
  switch (t) {
    case "NATIONAL":
      return d ? (o = Ia(d, e.carrierCode, "NATIONAL", n, r), Md(o, e.ext, n, r.formatExtension)) : "";
    case "INTERNATIONAL":
      return d ? (o = Ia(d, null, "INTERNATIONAL", n, r), o = "+".concat(a, " ").concat(o), Md(o, e.ext, n, r.formatExtension)) : "+".concat(a);
    case "E.164":
      return "+".concat(a).concat(d);
    case "RFC3966":
      return hg({
        number: "+".concat(a).concat(d),
        ext: e.ext
      });
    // For reference, here's Google's IDD formatter:
    // https://github.com/google/libphonenumber/blob/32719cf74e68796788d1ca45abc85dcdc63ba5b9/java/libphonenumber/src/com/google/i18n/phonenumbers/PhoneNumberUtil.java#L1546
    // Not saying that this IDD formatter replicates it 1:1, but it seems to work.
    // Who would even need to format phone numbers in IDD format anyway?
    case "IDD":
      if (!r.fromCountry)
        return;
      var i = Sg(d, e.carrierCode, a, r.fromCountry, n);
      return Md(i, e.ext, n, r.formatExtension);
    default:
      throw new Error('Unknown "format" argument passed to "formatNumber()": "'.concat(t, '"'));
  }
}
function Ia(e, t, r, n, a) {
  var d = xg(n.formats(), e);
  return d ? dg(e, d, {
    useInternationalFormat: r === "INTERNATIONAL",
    withNationalPrefix: !(d.nationalPrefixIsOptionalWhenFormattingInNationalFormat() && a && a.nationalPrefix === !1)
  }) : e;
}
function xg(e, t) {
  for (var r = vg(e), n; !(n = r()).done; ) {
    var a = n.value;
    if (a.leadingDigitsPatterns().length > 0) {
      var d = a.leadingDigitsPatterns()[a.leadingDigitsPatterns().length - 1];
      if (t.search(d) !== 0)
        continue;
    }
    if (Mt(t, a.pattern()))
      return a;
  }
}
function Md(e, t, r, n) {
  return t ? n(e, t, r) : e;
}
function Sg(e, t, r, n, a) {
  var d = Ya(n, a.metadata);
  if (d === r) {
    var o = Ia(e, t, "NATIONAL", a);
    return r === "1" ? r + " " + o : o;
  }
  var i = ig(n, void 0, a.metadata);
  if (i)
    return "".concat(i, " ").concat(r, " ").concat(Ia(e, null, "INTERNATIONAL", a));
}
function Rn(e) {
  "@babel/helpers - typeof";
  return Rn = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Rn(e);
}
function o0(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function i0(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? o0(Object(r), !0).forEach(function(n) {
      Cg(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : o0(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function Cg(e, t, r) {
  return (t = i2(t)) in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function Pg(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}
function Ag(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, i2(n.key), n);
  }
}
function Eg(e, t, r) {
  return t && Ag(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function i2(e) {
  var t = Mg(e, "string");
  return Rn(t) == "symbol" ? t : t + "";
}
function Mg(e, t) {
  if (Rn(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (Rn(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
var Og = /* @__PURE__ */ (function() {
  function e(t, r, n) {
    if (Pg(this, e), !t)
      throw new TypeError("First argument is required");
    if (typeof t != "string")
      throw new TypeError("First argument must be a string");
    if (t[0] === "+" && !r)
      throw new TypeError("`metadata` argument not passed");
    if (jr(r) && jr(r.countries)) {
      n = r;
      var a = t;
      if (!Ig.test(a))
        throw new Error('Invalid `number` argument passed: must consist of a "+" followed by digits');
      var d = d2(a, void 0, void 0, n), o = d.countryCallingCode, i = d.number;
      if (r = i, t = o, !r)
        throw new Error("Invalid `number` argument passed: too short");
    }
    if (!r)
      throw new TypeError("`nationalNumber` argument is required");
    if (typeof r != "string")
      throw new TypeError("`nationalNumber` argument must be a string");
    r2(n);
    var l = kg(t, n), s = l.country, u = l.countryCallingCode;
    this.country = s, this.countryCallingCode = u, this.nationalNumber = r, this.number = "+" + this.countryCallingCode + this.nationalNumber, this.getMetadata = function() {
      return n;
    };
  }
  return Eg(e, [{
    key: "setExt",
    value: function(r) {
      this.ext = r;
    }
  }, {
    key: "getPossibleCountries",
    value: function() {
      return this.country ? [this.country] : jy(this.countryCallingCode, this.nationalNumber, this.getMetadata());
    }
  }, {
    key: "isPossible",
    value: function() {
      return Ny(this, {
        v2: !0
      }, this.getMetadata());
    }
  }, {
    key: "isValid",
    value: function() {
      return Vy(this, {
        v2: !0
      }, this.getMetadata());
    }
  }, {
    key: "isNonGeographic",
    value: function() {
      var r = new Fe(this.getMetadata());
      return r.isNonGeographicCallingCode(this.countryCallingCode);
    }
  }, {
    key: "isEqual",
    value: function(r) {
      return this.number === r.number && this.ext === r.ext;
    }
    // This function was originally meant to be an equivalent for `validatePhoneNumberLength()`,
    // but later it was found out that it doesn't include the possible `TOO_SHORT` result
    // returned from `parsePhoneNumberWithError()` in the original `validatePhoneNumberLength()`,
    // so eventually I simply commented out this method from the `PhoneNumber` class
    // and just left the `validatePhoneNumberLength()` function, even though that one would require
    // and additional step to also validate the actual country / calling code of the phone number.
    // validateLength() {
    // 	const metadata = new Metadata(this.getMetadata())
    // 	metadata.selectNumberingPlan(this.countryCallingCode)
    // 	const result = checkNumberLength(this.nationalNumber, metadata)
    // 	if (result !== 'IS_POSSIBLE') {
    // 		return result
    // 	}
    // }
  }, {
    key: "getType",
    value: function() {
      return Bi(this, {
        v2: !0
      }, this.getMetadata());
    }
  }, {
    key: "format",
    value: function(r, n) {
      return _g(this, r, n ? i0(i0({}, n), {}, {
        v2: !0
      }) : {
        v2: !0
      }, this.getMetadata());
    }
  }, {
    key: "formatNational",
    value: function(r) {
      return this.format("NATIONAL", r);
    }
  }, {
    key: "formatInternational",
    value: function(r) {
      return this.format("INTERNATIONAL", r);
    }
  }, {
    key: "getURI",
    value: function(r) {
      return this.format("RFC3966", r);
    }
  }]);
})(), Tg = function(t) {
  return /^[A-Z]{2}$/.test(t);
};
function kg(e, t) {
  var r, n, a = new Fe(t);
  return Tg(e) ? (r = e, a.selectNumberingPlan(r), n = a.countryCallingCode()) : n = e, {
    country: r,
    countryCallingCode: n
  };
}
var Ig = /^\+\d+$/;
function ni(e) {
  "@babel/helpers - typeof";
  return ni = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, ni(e);
}
function Rg(e, t, r) {
  return Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function Dg(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}
function Ng(e, t, r) {
  return t = Nn(t), Fg(e, Gi() ? Reflect.construct(t, r || [], Nn(e).constructor) : t.apply(e, r));
}
function Fg(e, t) {
  if (t && (ni(t) == "object" || typeof t == "function")) return t;
  if (t !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
  return Lg(e);
}
function Lg(e) {
  if (e === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function Bg(e, t) {
  if (typeof t != "function" && t !== null) throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && Dn(e, t);
}
function ai(e) {
  var t = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
  return ai = function(n) {
    if (n === null || !jg(n)) return n;
    if (typeof n != "function") throw new TypeError("Super expression must either be null or a function");
    if (t !== void 0) {
      if (t.has(n)) return t.get(n);
      t.set(n, a);
    }
    function a() {
      return Vg(n, arguments, Nn(this).constructor);
    }
    return a.prototype = Object.create(n.prototype, { constructor: { value: a, enumerable: !1, writable: !0, configurable: !0 } }), Dn(a, n);
  }, ai(e);
}
function Vg(e, t, r) {
  if (Gi()) return Reflect.construct.apply(null, arguments);
  var n = [null];
  n.push.apply(n, t);
  var a = new (e.bind.apply(e, n))();
  return r && Dn(a, r.prototype), a;
}
function Gi() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (Gi = function() {
    return !!e;
  })();
}
function jg(e) {
  try {
    return Function.toString.call(e).indexOf("[native code]") !== -1;
  } catch {
    return typeof e == "function";
  }
}
function Dn(e, t) {
  return Dn = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, n) {
    return r.__proto__ = n, r;
  }, Dn(e, t);
}
function Nn(e) {
  return Nn = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, Nn(e);
}
var bt = /* @__PURE__ */ (function(e) {
  function t(r) {
    var n;
    return Dg(this, t), n = Ng(this, t, [r]), Object.setPrototypeOf(n, t.prototype), n.name = n.constructor.name, n;
  }
  return Bg(t, e), Rg(t);
})(/* @__PURE__ */ ai(Error)), l0 = new RegExp("(?:" + o2() + ")$", "i");
function Gg(e) {
  var t = e.search(l0);
  if (t < 0)
    return {};
  for (var r = e.slice(0, t), n = e.match(l0), a = 1; a < n.length; ) {
    if (n[a])
      return {
        number: r,
        ext: n[a]
      };
    a++;
  }
}
var Ug = {
  0: "0",
  1: "1",
  2: "2",
  3: "3",
  4: "4",
  5: "5",
  6: "6",
  7: "7",
  8: "8",
  9: "9",
  "０": "0",
  // Fullwidth digit 0
  "１": "1",
  // Fullwidth digit 1
  "２": "2",
  // Fullwidth digit 2
  "３": "3",
  // Fullwidth digit 3
  "４": "4",
  // Fullwidth digit 4
  "５": "5",
  // Fullwidth digit 5
  "６": "6",
  // Fullwidth digit 6
  "７": "7",
  // Fullwidth digit 7
  "８": "8",
  // Fullwidth digit 8
  "９": "9",
  // Fullwidth digit 9
  "٠": "0",
  // Arabic-indic digit 0
  "١": "1",
  // Arabic-indic digit 1
  "٢": "2",
  // Arabic-indic digit 2
  "٣": "3",
  // Arabic-indic digit 3
  "٤": "4",
  // Arabic-indic digit 4
  "٥": "5",
  // Arabic-indic digit 5
  "٦": "6",
  // Arabic-indic digit 6
  "٧": "7",
  // Arabic-indic digit 7
  "٨": "8",
  // Arabic-indic digit 8
  "٩": "9",
  // Arabic-indic digit 9
  "۰": "0",
  // Eastern-Arabic digit 0
  "۱": "1",
  // Eastern-Arabic digit 1
  "۲": "2",
  // Eastern-Arabic digit 2
  "۳": "3",
  // Eastern-Arabic digit 3
  "۴": "4",
  // Eastern-Arabic digit 4
  "۵": "5",
  // Eastern-Arabic digit 5
  "۶": "6",
  // Eastern-Arabic digit 6
  "۷": "7",
  // Eastern-Arabic digit 7
  "۸": "8",
  // Eastern-Arabic digit 8
  "۹": "9"
  // Eastern-Arabic digit 9
};
function Hg(e) {
  return Ug[e];
}
function Wg(e, t) {
  var r = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r) return (r = r.call(e)).next.bind(r);
  if (Array.isArray(e) || (r = zg(e)) || t) {
    r && (e = r);
    var n = 0;
    return function() {
      return n >= e.length ? { done: !0 } : { done: !1, value: e[n++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function zg(e, t) {
  if (e) {
    if (typeof e == "string") return s0(e, t);
    var r = {}.toString.call(e).slice(8, -1);
    return r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set" ? Array.from(e) : r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? s0(e, t) : void 0;
  }
}
function s0(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function u0(e) {
  for (var t = "", r = Wg(e.split("")), n; !(n = r()).done; ) {
    var a = n.value;
    t += qg(a, t) || "";
  }
  return t;
}
function qg(e, t, r) {
  return e === "+" ? t ? void 0 : "+" : Hg(e);
}
function Kg(e, t) {
  var r = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r) return (r = r.call(e)).next.bind(r);
  if (Array.isArray(e) || (r = Yg(e)) || t) {
    r && (e = r);
    var n = 0;
    return function() {
      return n >= e.length ? { done: !0 } : { done: !1, value: e[n++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Yg(e, t) {
  if (e) {
    if (typeof e == "string") return c0(e, t);
    var r = {}.toString.call(e).slice(8, -1);
    return r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set" ? Array.from(e) : r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? c0(e, t) : void 0;
  }
}
function c0(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function Zg(e, t) {
  var r = t.countries, n = t.metadata;
  n = new Fe(n);
  for (var a = Kg(r), d; !(d = a()).done; ) {
    var o = d.value;
    if (n.country(o), n.leadingDigits()) {
      if (e && e.search(n.leadingDigits()) === 0)
        return o;
    } else if (Bi({
      phone: e,
      country: o
    }, void 0, n.metadata))
      return o;
  }
}
function Jg(e, t) {
  var r = t.nationalNumber, n = t.metadata, a = n.getCountryCodesForCallingCode(e);
  if (a)
    return a.length === 1 ? a[0] : Zg(r, {
      countries: a,
      metadata: n.metadata
    });
}
var l2 = "+", Qg = "[\\-\\.\\(\\)]?", f0 = "([" + nt + "]|" + Qg + ")", Xg = "^\\" + l2 + f0 + "*[" + nt + "]" + f0 + "*$", eb = new RegExp(Xg, "g"), di = nt, tb = "[" + di + "]+((\\-)*[" + di + "])*", rb = "a-zA-Z", nb = "[" + rb + "]+((\\-)*[" + di + "])*", ab = "^(" + tb + "\\.)*" + nb + "\\.?$", db = new RegExp(ab, "g"), $0 = "tel:", oi = ";phone-context=", ob = ";isub=";
function ib(e) {
  var t = e.indexOf(oi);
  if (t < 0)
    return null;
  var r = t + oi.length;
  if (r >= e.length)
    return "";
  var n = e.indexOf(";", r);
  return n >= 0 ? e.substring(r, n) : e.substring(r);
}
function lb(e) {
  return e === null ? !0 : e.length === 0 ? !1 : eb.test(e) || db.test(e);
}
function sb(e, t) {
  var r = t.extractFormattedPhoneNumber, n = ib(e);
  if (!lb(n))
    throw new bt("NOT_A_NUMBER");
  var a;
  if (n === null)
    a = r(e) || "";
  else {
    a = "", n.charAt(0) === l2 && (a += n);
    var d = e.indexOf($0), o;
    d >= 0 ? o = d + $0.length : o = 0;
    var i = e.indexOf(oi);
    a += e.substring(o, i);
  }
  var l = a.indexOf(ob);
  if (l > 0 && (a = a.substring(0, l)), a !== "")
    return a;
}
var ub = 250, cb = new RegExp("[" + ji + nt + "]"), fb = new RegExp("[^" + nt + "#]+$");
function $b(e, t, r) {
  if (t = t || {}, r = new Fe(r), t.defaultCountry && !r.hasCountry(t.defaultCountry))
    throw t.v2 ? new bt("INVALID_COUNTRY") : new Error("Unknown country: ".concat(t.defaultCountry));
  var n = mb(e, t.v2, t.extract), a = n.number, d = n.ext, o = n.error;
  if (!a) {
    if (t.v2)
      throw o === "TOO_SHORT" ? new bt("TOO_SHORT") : new bt("NOT_A_NUMBER");
    return {};
  }
  var i = vb(a, t.defaultCountry, t.defaultCallingCode, r), l = i.country, s = i.nationalNumber, u = i.countryCallingCode, $ = i.countryCallingCodeSource, y = i.carrierCode;
  if (!r.hasSelectedNumberingPlan()) {
    if (t.v2)
      throw new bt("INVALID_COUNTRY");
    return {};
  }
  if (!s || s.length < Vi) {
    if (t.v2)
      throw new bt("TOO_SHORT");
    return {};
  }
  if (s.length > Uy) {
    if (t.v2)
      throw new bt("TOO_LONG");
    return {};
  }
  if (t.v2) {
    var h = new Og(u, s, r.metadata);
    return l && (h.country = l), y && (h.carrierCode = y), d && (h.ext = d), h.__countryCallingCodeSource = $, h;
  }
  var c = (t.extended ? r.hasSelectedNumberingPlan() : l) ? Mt(s, r.nationalNumberPattern()) : !1;
  return t.extended ? {
    country: l,
    countryCallingCode: u,
    carrierCode: y,
    valid: c,
    possible: c ? !0 : !!(t.extended === !0 && r.possibleLengths() && a2(s, r)),
    phone: s,
    ext: d
  } : c ? hb(l, s, d) : {};
}
function pb(e, t, r) {
  if (e) {
    if (e.length > ub) {
      if (r)
        throw new bt("TOO_LONG");
      return;
    }
    if (t === !1)
      return e;
    var n = e.search(cb);
    if (!(n < 0))
      return e.slice(n).replace(fb, "");
  }
}
function mb(e, t, r) {
  var n = sb(e, {
    extractFormattedPhoneNumber: function(o) {
      return pb(o, r, t);
    }
  });
  if (!n)
    return {};
  if (!pg(n))
    return mg(n) ? {
      error: "TOO_SHORT"
    } : {};
  var a = Gg(n);
  return a.ext ? a : {
    number: n
  };
}
function hb(e, t, r) {
  var n = {
    country: e,
    phone: t
  };
  return r && (n.ext = r), n;
}
function vb(e, t, r, n) {
  var a = d2(u0(e), t, r, n.metadata), d = a.countryCallingCodeSource, o = a.countryCallingCode, i = a.number, l;
  if (o)
    n.selectNumberingPlan(o);
  else if (i && (t || r))
    n.selectNumberingPlan(t, r), t && (l = t), o = r || Ya(t, n.metadata);
  else return {};
  if (!i)
    return {
      countryCallingCodeSource: d,
      countryCallingCode: o
    };
  var s = ri(u0(i), n), u = s.nationalNumber, $ = s.carrierCode, y = Jg(o, {
    nationalNumber: u,
    metadata: n
  });
  return y && (l = y, y === "001" || n.country(l)), {
    country: l,
    countryCallingCode: o,
    countryCallingCodeSource: d,
    nationalNumber: u,
    carrierCode: $
  };
}
function Fn(e) {
  "@babel/helpers - typeof";
  return Fn = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Fn(e);
}
function p0(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function m0(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? p0(Object(r), !0).forEach(function(n) {
      yb(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : p0(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function yb(e, t, r) {
  return (t = gb(t)) in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function gb(e) {
  var t = bb(e, "string");
  return Fn(t) == "symbol" ? t : t + "";
}
function bb(e, t) {
  if (Fn(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (Fn(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function s2(e, t, r) {
  return $b(e, m0(m0({}, t), {}, {
    v2: !0
  }), r);
}
function Ln(e) {
  "@babel/helpers - typeof";
  return Ln = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Ln(e);
}
function h0(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function wb(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? h0(Object(r), !0).forEach(function(n) {
      _b(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : h0(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function _b(e, t, r) {
  return (t = xb(t)) in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function xb(e) {
  var t = Sb(e, "string");
  return Ln(t) == "symbol" ? t : t + "";
}
function Sb(e, t) {
  if (Ln(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (Ln(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function Cb(e, t) {
  return Mb(e) || Eb(e, t) || Ab(e, t) || Pb();
}
function Pb() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Ab(e, t) {
  if (e) {
    if (typeof e == "string") return v0(e, t);
    var r = {}.toString.call(e).slice(8, -1);
    return r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set" ? Array.from(e) : r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? v0(e, t) : void 0;
  }
}
function v0(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function Eb(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n, a, d, o, i = [], l = !0, s = !1;
    try {
      if (d = (r = r.call(e)).next, t !== 0) for (; !(l = (n = d.call(r)).done) && (i.push(n.value), i.length !== t); l = !0) ;
    } catch (u) {
      s = !0, a = u;
    } finally {
      try {
        if (!l && r.return != null && (o = r.return(), Object(o) !== o)) return;
      } finally {
        if (s) throw a;
      }
    }
    return i;
  }
}
function Mb(e) {
  if (Array.isArray(e)) return e;
}
function u2(e) {
  var t = Array.prototype.slice.call(e), r = Cb(t, 4), n = r[0], a = r[1], d = r[2], o = r[3], i, l, s;
  if (typeof n == "string")
    i = n;
  else throw new TypeError("A text for parsing must be a string.");
  if (!a || typeof a == "string")
    o ? (l = d, s = o) : (l = void 0, s = d), a && (l = wb({
      defaultCountry: a
    }, l));
  else if (jr(a))
    d ? (l = a, s = d) : s = a;
  else throw new Error("Invalid second argument: ".concat(a));
  return {
    text: i,
    options: l,
    metadata: s
  };
}
function Ob() {
  var e = u2(arguments), t = e.text, r = e.options, n = e.metadata;
  return s2(t, r, n);
}
function Bn(e) {
  "@babel/helpers - typeof";
  return Bn = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Bn(e);
}
function y0(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function g0(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? y0(Object(r), !0).forEach(function(n) {
      Tb(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : y0(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function Tb(e, t, r) {
  return (t = kb(t)) in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function kb(e) {
  var t = Ib(e, "string");
  return Bn(t) == "symbol" ? t : t + "";
}
function Ib(e, t) {
  if (Bn(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (Bn(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function Rb(e, t, r) {
  t && t.defaultCountry && !Ry(t.defaultCountry, r) && (t = g0(g0({}, t), {}, {
    defaultCountry: void 0
  }));
  try {
    return s2(e, t, r);
  } catch (n) {
    if (!(n instanceof bt)) throw n;
  }
}
function Vn(e) {
  "@babel/helpers - typeof";
  return Vn = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Vn(e);
}
function b0(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function w0(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? b0(Object(r), !0).forEach(function(n) {
      Db(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : b0(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function Db(e, t, r) {
  return (t = Nb(t)) in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function Nb(e) {
  var t = Fb(e, "string");
  return Vn(t) == "symbol" ? t : t + "";
}
function Fb(e, t) {
  if (Vn(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (Vn(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function Lb() {
  var e = u2(arguments), t = e.text, r = e.options, n = e.metadata;
  r = w0(w0({}, r), {}, {
    extract: !1
  });
  var a = Rb(t, r, n);
  return a && a.isValid() || !1;
}
function Bb(e) {
  return new Fe(e).getCountries();
}
function _0() {
  return Fi(Ob, arguments);
}
function Vb() {
  return Fi(Bb, arguments);
}
function ii() {
  return Fi(Ya, arguments);
}
const jb = /* @__PURE__ */ JSON.parse(`[{"code":"AF","dial_code":"93","name":"Afghanistan","name_ar":"أفغانستان"},{"code":"AL","dial_code":"355","name":"Albania","name_ar":"ألبانيا"},{"code":"DZ","dial_code":"213","name":"Algeria","name_ar":"الجزائر"},{"code":"AS","dial_code":"1 684","name":"AmericanSamoa","name_ar":"ساموا الأمريكية"},{"code":"AD","dial_code":"376","name":"Andorra","name_ar":"أندورا"},{"code":"AO","dial_code":"244","name":"Angola","name_ar":"أنجولا"},{"code":"AI","dial_code":"1 264","name":"Anguilla","name_ar":"أنجويلا"},{"code":"AG","dial_code":"1268","name":"Antigua and Barbuda","name_ar":"أنتيجوا وبربودا"},{"code":"AR","dial_code":"54","name":"Argentina","name_ar":"الأرجنتين"},{"code":"AM","dial_code":"374","name":"Armenia","name_ar":"أرمينيا"},{"code":"AW","dial_code":"297","name":"Aruba","name_ar":"آروبا"},{"code":"AU","dial_code":"61","name":"Australia","name_ar":"أستراليا"},{"code":"AT","dial_code":"43","name":"Austria","name_ar":"النمسا"},{"code":"AZ","dial_code":"994","name":"Azerbaijan","name_ar":"أذربيجان"},{"code":"BS","dial_code":"1 242","name":"Bahamas","name_ar":"الباهاما"},{"code":"BH","dial_code":"973","name":"Bahrain","name_ar":"البحرين"},{"code":"BD","dial_code":"880","name":"Bangladesh","name_ar":"بنجلاديش"},{"code":"BB","dial_code":"1 246","name":"Barbados","name_ar":"بربادوس"},{"code":"BY","dial_code":"375","name":"Belarus","name_ar":"روسيا البيضاء"},{"code":"BE","dial_code":"32","name":"Belgium","name_ar":"بلجيكا"},{"code":"BZ","dial_code":"501","name":"Belize","name_ar":"بليز"},{"code":"BJ","dial_code":"229","name":"Benin","name_ar":"بنين"},{"code":"BM","dial_code":"1 441","name":"Bermuda","name_ar":"برمودا"},{"code":"BT","dial_code":"975","name":"Bhutan","name_ar":"بوتان"},{"code":"BA","dial_code":"387","name":"Bosnia and Herzegovina","name_ar":"البوسنة والهرسك"},{"code":"BW","dial_code":"267","name":"Botswana","name_ar":"بتسوانا"},{"code":"BR","dial_code":"55","name":"Brazil","name_ar":"البرازيل"},{"code":"IO","dial_code":"246","name":"British Indian Ocean Territory","name_ar":"المحيط الهندي البريطاني"},{"code":"BG","dial_code":"359","name":"Bulgaria","name_ar":"بلغاريا"},{"code":"BF","dial_code":"226","name":"Burkina Faso","name_ar":"بوركينا فاسو"},{"code":"BI","dial_code":"257","name":"Burundi","name_ar":"بوروندي"},{"code":"KH","dial_code":"855","name":"Cambodia","name_ar":"كمبوديا"},{"code":"CM","dial_code":"237","name":"Cameroon","name_ar":"الكاميرون"},{"code":"CV","dial_code":"238","name":"Cape Verde","name_ar":"الرأس الأخضر"},{"code":"KY","dial_code":"345","name":"Cayman Islands","name_ar":"جزر الكايمن"},{"code":"CF","dial_code":"236","name":"Central African Republic","name_ar":"جمهورية افريقيا الوسطى"},{"code":"TD","dial_code":"235","name":"Chad","name_ar":"تشاد"},{"code":"CL","dial_code":"56","name":"Chile","name_ar":"شيلي"},{"code":"CN","dial_code":"86","name":"China","name_ar":"الصين"},{"code":"CX","dial_code":"61","name":"Christmas Island","name_ar":"جزيرة الكريسماس"},{"code":"CO","dial_code":"57","name":"Colombia","name_ar":"كولومبيا"},{"code":"KM","dial_code":"269","name":"Comoros","name_ar":"جزر القمر"},{"code":"CG","dial_code":"242","name":"Congo","name_ar":"الكونغو - برازافيل"},{"code":"CK","dial_code":"682","name":"Cook Islands","name_ar":"جزر كوك"},{"code":"CR","dial_code":"506","name":"Costa Rica","name_ar":"كوستاريكا"},{"code":"HR","dial_code":"385","name":"Croatia","name_ar":"كرواتيا"},{"code":"CU","dial_code":"53","name":"Cuba","name_ar":"كوبا"},{"code":"CY","dial_code":"537","name":"Cyprus","name_ar":"قبرص"},{"code":"CZ","dial_code":"420","name":"Czech Republic","name_ar":"جمهورية التشيك"},{"code":"DK","dial_code":"45","name":"Denmark","name_ar":"الدانمرك"},{"code":"DJ","dial_code":"253","name":"Djibouti","name_ar":"جيبوتي"},{"code":"DM","dial_code":"1 767","name":"Dominica","name_ar":"دومينيكا"},{"code":"DO","dial_code":"1 849","name":"Dominican Republic","name_ar":"جمهورية الدومينيك"},{"code":"EC","dial_code":"593","name":"Ecuador","name_ar":"الاكوادور"},{"code":"EG","dial_code":"20","name":"Egypt","name_ar":"مصر"},{"code":"SV","dial_code":"503","name":"El Salvador","name_ar":"السلفادور"},{"code":"GQ","dial_code":"240","name":"Equatorial Guinea","name_ar":"غينيا الاستوائية"},{"code":"ER","dial_code":"291","name":"Eritrea","name_ar":"اريتريا"},{"code":"EE","dial_code":"372","name":"Estonia","name_ar":"استونيا"},{"code":"ET","dial_code":"251","name":"Ethiopia","name_ar":"اثيوبيا"},{"code":"FO","dial_code":"298","name":"Faroe Islands","name_ar":"جزر فارو"},{"code":"FJ","dial_code":"679","name":"Fiji","name_ar":"فيجي"},{"code":"FI","dial_code":"358","name":"Finland","name_ar":"فنلندا"},{"code":"FR","dial_code":"33","name":"France","name_ar":"فرنسا"},{"code":"GF","dial_code":"594","name":"French Guiana","name_ar":"غويانا"},{"code":"PF","dial_code":"689","name":"French Polynesia","name_ar":"بولينيزيا الفرنسية"},{"code":"GA","dial_code":"241","name":"Gabon","name_ar":"الجابون"},{"code":"GM","dial_code":"220","name":"Gambia","name_ar":"غامبيا"},{"code":"GE","dial_code":"995","name":"Georgia","name_ar":"جورجيا"},{"code":"DE","dial_code":"49","name":"Germany","name_ar":"ألمانيا"},{"code":"GH","dial_code":"233","name":"Ghana","name_ar":"غانا"},{"code":"GI","dial_code":"350","name":"Gibraltar","name_ar":"جبل طارق"},{"code":"GR","dial_code":"30","name":"Greece","name_ar":"اليونان"},{"code":"GL","dial_code":"299","name":"Greenland","name_ar":"جرينلاند"},{"code":"GD","dial_code":"1 473","name":"Grenada","name_ar":"جرينادا"},{"code":"GP","dial_code":"590","name":"Guadeloupe","name_ar":"جوادلوب"},{"code":"GU","dial_code":"1 671","name":"Guam","name_ar":"جوام"},{"code":"GT","dial_code":"502","name":"Guatemala","name_ar":"جواتيمالا"},{"code":"GN","dial_code":"224","name":"Guinea","name_ar":"غينيا"},{"code":"GW","dial_code":"245","name":"Guinea-Bissau","name_ar":"غينيا بيساو"},{"code":"GY","dial_code":"595","name":"Guyana","name_ar":"غيانا"},{"code":"HT","dial_code":"509","name":"Haiti","name_ar":"هايتي"},{"code":"HN","dial_code":"504","name":"Honduras","name_ar":"هندوراس"},{"code":"HU","dial_code":"36","name":"Hungary","name_ar":"المجر"},{"code":"IS","dial_code":"354","name":"Iceland","name_ar":"أيسلندا"},{"code":"IN","dial_code":"91","name":"India","name_ar":"الهند"},{"code":"ID","dial_code":"62","name":"Indonesia","name_ar":"اندونيسيا"},{"code":"IQ","dial_code":"964","name":"Iraq","name_ar":"العراق"},{"code":"IE","dial_code":"353","name":"Ireland","name_ar":"أيرلندا"},{"code":"IT","dial_code":"39","name":"Italy","name_ar":"ايطاليا"},{"code":"JM","dial_code":"1 876","name":"Jamaica","name_ar":"جامايكا"},{"code":"JP","dial_code":"81","name":"Japan","name_ar":"اليابان"},{"code":"JO","dial_code":"962","name":"Jordan","name_ar":"الأردن"},{"code":"KZ","dial_code":"7 7","name":"Kazakhstan","name_ar":"كازاخستان"},{"code":"KE","dial_code":"254","name":"Kenya","name_ar":"كينيا"},{"code":"KI","dial_code":"686","name":"Kiribati","name_ar":"كيريباتي"},{"code":"KW","dial_code":"965","name":"Kuwait","name_ar":"الكويت"},{"code":"KG","dial_code":"996","name":"Kyrgyzstan","name_ar":"قرغيزستان"},{"code":"LV","dial_code":"371","name":"Latvia","name_ar":"لاتفيا"},{"code":"LB","dial_code":"961","name":"Lebanon","name_ar":"لبنان"},{"code":"LS","dial_code":"266","name":"Lesotho","name_ar":"ليسوتو"},{"code":"LR","dial_code":"231","name":"Liberia","name_ar":"ليبيريا"},{"code":"LI","dial_code":"423","name":"Liechtenstein","name_ar":"ليختنشتاين"},{"code":"LT","dial_code":"370","name":"Lithuania","name_ar":"ليتوانيا"},{"code":"LU","dial_code":"352","name":"Luxembourg","name_ar":"لوكسمبورج"},{"code":"MG","dial_code":"261","name":"Madagascar","name_ar":"مدغشقر"},{"code":"MW","dial_code":"265","name":"Malawi","name_ar":"ملاوي"},{"code":"MY","dial_code":"60","name":"Malaysia","name_ar":"ماليزيا"},{"code":"MV","dial_code":"960","name":"Maldives","name_ar":"جزر الملديف"},{"code":"ML","dial_code":"223","name":"Mali","name_ar":"مالي"},{"code":"MT","dial_code":"356","name":"Malta","name_ar":"مالطا"},{"code":"MH","dial_code":"692","name":"Marshall Islands","name_ar":"جزر المارشال"},{"code":"MQ","dial_code":"596","name":"Martinique","name_ar":"مارتينيك"},{"code":"MR","dial_code":"222","name":"Mauritania","name_ar":"موريتانيا"},{"code":"MU","dial_code":"230","name":"Mauritius","name_ar":"موريشيوس"},{"code":"YT","dial_code":"262","name":"Mayotte","name_ar":"مايوت"},{"code":"MX","dial_code":"52","name":"Mexico","name_ar":"المكسيك"},{"code":"MC","dial_code":"377","name":"Monaco","name_ar":"موناكو"},{"code":"MN","dial_code":"976","name":"Mongolia","name_ar":"منغوليا"},{"code":"ME","dial_code":"382","name":"Montenegro","name_ar":"الجبل الأسود"},{"code":"MS","dial_code":"1664","name":"Montserrat","name_ar":"مونتسرات"},{"code":"MA","dial_code":"212","name":"Morocco","name_ar":"المغرب"},{"code":"MM","dial_code":"95","name":"Myanmar","name_ar":"ميانمار"},{"code":"NA","dial_code":"264","name":"Namibia","name_ar":"نامיבيا"},{"code":"NR","dial_code":"674","name":"Nauru","name_ar":"نورو"},{"code":"NP","dial_code":"977","name":"Nepal","name_ar":"نيبال"},{"code":"NL","dial_code":"31","name":"Netherlands","name_ar":"هولندا"},{"code":"NC","dial_code":"687","name":"New Caledonia","name_ar":"كاليدونيا الجديدة"},{"code":"NZ","dial_code":"64","name":"New Zealand","name_ar":"نيوزيلاندا"},{"code":"NI","dial_code":"505","name":"Nicaragua","name_ar":"نيكاراجوا"},{"code":"NE","dial_code":"227","name":"Niger","name_ar":"النيجر"},{"code":"NG","dial_code":"234","name":"Nigeria","name_ar":"نيجيريا"},{"code":"NU","dial_code":"683","name":"Niue","name_ar":"نيوي"},{"code":"NF","dial_code":"672","name":"Norfolk Island","name_ar":"جزيرة نورفوك"},{"code":"MP","dial_code":"1 670","name":"Northern Mariana Islands","name_ar":"جزر ماريانا"},{"code":"NO","dial_code":"47","name":"Norway","name_ar":"النرويج"},{"code":"OM","dial_code":"968","name":"Oman","name_ar":"عمان"},{"code":"PK","dial_code":"92","name":"Pakistan","name_ar":"باكستان"},{"code":"PW","dial_code":"680","name":"Palau","name_ar":"بالاو"},{"code":"PA","dial_code":"507","name":"Panama","name_ar":"بنما"},{"code":"PG","dial_code":"675","name":"Papua New Guinea","name_ar":"بابوا غينيا الجديدة"},{"code":"PY","dial_code":"595","name":"Paraguay","name_ar":"باراجواي"},{"code":"PE","dial_code":"51","name":"Peru","name_ar":"بيرو"},{"code":"PH","dial_code":"63","name":"Philippines","name_ar":"الفيلبين"},{"code":"PL","dial_code":"48","name":"Poland","name_ar":"بولندا"},{"code":"PT","dial_code":"351","name":"Portugal","name_ar":"البرتغال"},{"code":"PR","dial_code":"1 939","name":"Puerto Rico","name_ar":"بورتوريكو"},{"code":"QA","dial_code":"974","name":"Qatar","name_ar":"قطر"},{"code":"RO","dial_code":"40","name":"Romania","name_ar":"رومانيا"},{"code":"RW","dial_code":"250","name":"Rwanda","name_ar":"رواندا"},{"code":"WS","dial_code":"685","name":"Samoa","name_ar":"ساموا"},{"code":"SM","dial_code":"378","name":"San Marino","name_ar":"سان مارينو"},{"code":"SA","dial_code":"966","name":"Saudi Arabia","name_ar":"السعودية"},{"code":"SN","dial_code":"221","name":"Senegal","name_ar":"السنغال"},{"code":"RS","dial_code":"381","name":"Serbia","name_ar":"صربيا"},{"code":"SC","dial_code":"248","name":"Seychelles","name_ar":"سيشل"},{"code":"SL","dial_code":"232","name":"Sierra Leone","name_ar":"سيراليون"},{"code":"SG","dial_code":"65","name":"Singapore","name_ar":"سنغافورة"},{"code":"SK","dial_code":"421","name":"Slovakia","name_ar":"سلوفاكيا"},{"code":"SI","dial_code":"386","name":"Slovenia","name_ar":"سلوفينيا"},{"code":"SB","dial_code":"677","name":"Solomon Islands","name_ar":"جزر سليمان"},{"code":"ZA","dial_code":"27","name":"South Africa","name_ar":"جمهورية جنوب افريقيا"},{"code":"ES","dial_code":"34","name":"Spain","name_ar":"أسبانيا"},{"code":"LK","dial_code":"94","name":"Sri Lanka","name_ar":"سريلانكا"},{"code":"SD","dial_code":"249","name":"Sudan","name_ar":"السودان"},{"code":"SR","dial_code":"597","name":"Suriname","name_ar":"سورينام"},{"code":"SZ","dial_code":"268","name":"Swaziland","name_ar":"سوازيلاند"},{"code":"SE","dial_code":"46","name":"Sweden","name_ar":"السويد"},{"code":"CH","dial_code":"41","name":"Switzerland","name_ar":"سويسرا"},{"code":"TJ","dial_code":"992","name":"Tajikistan","name_ar":"طاجكستان"},{"code":"TH","dial_code":"66","name":"Thailand","name_ar":"تايلند"},{"code":"TG","dial_code":"228","name":"Togo","name_ar":"توجو"},{"code":"TK","dial_code":"690","name":"Tokelau","name_ar":"توكيلو"},{"code":"TO","dial_code":"676","name":"Tonga","name_ar":"تونجا"},{"code":"TT","dial_code":"1 868","name":"Trinidad and Tobago","name_ar":"ترينيداد وتوباغو"},{"code":"TN","dial_code":"216","name":"Tunisia","name_ar":"تونس"},{"code":"TR","dial_code":"90","name":"Turkey","name_ar":"تركيا"},{"code":"TM","dial_code":"993","name":"Turkmenistan","name_ar":"تركمانستان"},{"code":"TC","dial_code":"1 649","name":"Turks and Caicos Islands","name_ar":"جزر الترك وجايكوس"},{"code":"TV","dial_code":"688","name":"Tuvalu","name_ar":"توفالو"},{"code":"UG","dial_code":"256","name":"Uganda","name_ar":"أوغندا"},{"code":"UA","dial_code":"380","name":"Ukraine","name_ar":"أوكرانيا"},{"code":"AE","dial_code":"971","name":"United Arab Emirates","name_ar":"الامارات"},{"code":"GB","dial_code":"44","name":"United Kingdom","name_ar":"المملكة المتحدة"},{"code":"US","dial_code":"1","name":"United States","name_ar":"الولايات المتحدة الأمريكية"},{"code":"UY","dial_code":"598","name":"Uruguay","name_ar":"أورجواي"},{"code":"UZ","dial_code":"998","name":"Uzbekistan","name_ar":"أوزبكستان"},{"code":"VU","dial_code":"678","name":"Vanuatu","name_ar":"فانواتو"},{"code":"WF","dial_code":"681","name":"Wallis and Futuna","name_ar":"جزر والس وفوتونا"},{"code":"YE","dial_code":"967","name":"Yemen","name_ar":"اليمن"},{"code":"ZM","dial_code":"260","name":"Zambia","name_ar":"زامبيا"},{"code":"ZW","dial_code":"263","name":"Zimbabwe","name_ar":"زيمبابوي"},{"code":"BO","dial_code":"591","name":"Bolivia, Plurinational State of","name_ar":"بوليفيا"},{"code":"BN","dial_code":"673","name":"Brunei Darussalam","name_ar":"بروناي"},{"code":"CC","dial_code":"61","name":"Cocos (Keeling) Islands","name_ar":"جزر كوكوس"},{"code":"CD","dial_code":"243","name":"Congo, The Democratic Republic of the","name_ar":"الكونغو"},{"code":"CI","dial_code":"225","name":"Cote d'Ivoire","name_ar":"ساحل العاج"},{"code":"FK","dial_code":"500","name":"Falkland Islands (Malvinas)","name_ar":"جزر فوكلاند"},{"code":"GG","dial_code":"44","name":"Guernsey","name_ar":"غيرنزي"},{"code":"VA","dial_code":"379","name":"Holy See (Vatican City State)","name_ar":"الفاتيكان"},{"code":"HK","dial_code":"852","name":"Hong Kong","name_ar":"هونج كونج"},{"code":"IR","dial_code":"98","name":"Iran, Islamic Republic of","name_ar":"ايران"},{"code":"IM","dial_code":"44","name":"Isle of Man","name_ar":"جزيرة مان"},{"code":"JE","dial_code":"44","name":"Jersey","name_ar":"جيرسي"},{"code":"KP","dial_code":"850","name":"Korea, Democratic People's Republic of","name_ar":"كوريا الشمالية"},{"code":"KR","dial_code":"82","name":"Korea, Republic of","name_ar":"كوريا الجنوبية"},{"code":"LA","dial_code":"856","name":"Lao People's Democratic Republic","name_ar":"لاوس"},{"code":"LY","dial_code":"218","name":"Libyan Arab Jamahiriya","name_ar":"ليبيا"},{"code":"MO","dial_code":"853","name":"Macao","name_ar":"ماكاو الصينية"},{"code":"MK","dial_code":"389","name":"Macedonia, The Former Yugoslav Republic of","name_ar":"مقدونيا"},{"code":"FM","dial_code":"691","name":"Micronesia, Federated States of","name_ar":"ميكرونيزيا"},{"code":"MD","dial_code":"373","name":"Moldova, Republic of","name_ar":"مولدافيا"},{"code":"MZ","dial_code":"258","name":"Mozambique","name_ar":"موزمبيق"},{"code":"PS","dial_code":"970","name":"Palestinian Territory, Occupied","name_ar":"فلسطين"},{"code":"RE","dial_code":"262","name":"Réunion","name_ar":"روينيون"},{"code":"RU","dial_code":"7","name":"Russia","name_ar":"روسيا"},{"code":"BL","dial_code":"590","name":"Saint Barthélemy","name_ar":"سان بارتيلمي"},{"code":"SH","dial_code":"290","name":"Saint Helena, Ascension and Tristan Da Cunha","name_ar":"سانت هيلنا"},{"code":"KN","dial_code":"1 869","name":"Saint Kitts and Nevis","name_ar":"سانت كيتس ونيفيس"},{"code":"LC","dial_code":"1 758","name":"Saint Lucia","name_ar":"سانت لوسيا"},{"code":"MF","dial_code":"590","name":"Saint Martin","name_ar":"سانت مارتين"},{"code":"PM","dial_code":"508","name":"Saint Pierre and Miquelon","name_ar":"سانت بيير وميكولون"},{"code":"VC","dial_code":"1 784","name":"Saint Vincent and the Grenadines","name_ar":"سانت فنسنت وغرنادين"},{"code":"ST","dial_code":"239","name":"Sao Tome and Principe","name_ar":"ساو تومي وبرينسيبي"},{"code":"SO","dial_code":"252","name":"Somalia","name_ar":"الصومال"},{"code":"SJ","dial_code":"47","name":"Svalbard and Jan Mayen","name_ar":"سفالبارد وجان مايان"},{"code":"SY","dial_code":"963","name":"Syrian Arab Republic","name_ar":"سوريا"},{"code":"TW","dial_code":"886","name":"Taiwan, Province of China","name_ar":"تايوان"},{"code":"TZ","dial_code":"255","name":"Tanzania, United Republic of","name_ar":"تانزانيا"},{"code":"TL","dial_code":"670","name":"Timor-Leste","name_ar":"تيمور الشرقية"},{"code":"VE","dial_code":"58","name":"Venezuela, Bolivarian Republic of","name_ar":"فنزويلا"},{"code":"VN","dial_code":"84","name":"Viet Nam","name_ar":"فيتنام"},{"code":"VG","dial_code":"1 284","name":"Virgin Islands, British","name_ar":"جزر فرجين البريطانية"},{"code":"VI","dial_code":"1 340","name":"Virgin Islands, U.S.","name_ar":"جزر فرجين الأمريكية"}]`), Gb = jb, c2 = (e) => Object.fromEntries(Gb.map((t) => [t[e].trim(), t])), x0 = c2("code"), f2 = c2("dial_code"), Ub = (e) => {
  const t = e.toUpperCase().split("").map((r) => 127397 + r.charCodeAt(0));
  return String.fromCodePoint(...t);
};
function Hb() {
  const e = [];
  return Vb().forEach((t) => {
    if (x0[t])
      return e.push({
        ...x0[t],
        dial_code: ii(t)
      });
  }), e;
}
const Wb = Hb(), zb = { version: 4, country_calling_codes: { 1: ["US", "AG", "AI", "AS", "BB", "BM", "BS", "CA", "DM", "DO", "GD", "GU", "JM", "KN", "KY", "LC", "MP", "MS", "PR", "SX", "TC", "TT", "VC", "VG", "VI"], 7: ["RU", "KZ"], 20: ["EG"], 27: ["ZA"], 30: ["GR"], 31: ["NL"], 32: ["BE"], 33: ["FR"], 34: ["ES"], 36: ["HU"], 39: ["IT", "VA"], 40: ["RO"], 41: ["CH"], 43: ["AT"], 44: ["GB", "GG", "IM", "JE"], 45: ["DK"], 46: ["SE"], 47: ["NO", "SJ"], 48: ["PL"], 49: ["DE"], 51: ["PE"], 52: ["MX"], 53: ["CU"], 54: ["AR"], 55: ["BR"], 56: ["CL"], 57: ["CO"], 58: ["VE"], 60: ["MY"], 61: ["AU", "CC", "CX"], 62: ["ID"], 63: ["PH"], 64: ["NZ"], 65: ["SG"], 66: ["TH"], 81: ["JP"], 82: ["KR"], 84: ["VN"], 86: ["CN"], 90: ["TR"], 91: ["IN"], 92: ["PK"], 93: ["AF"], 94: ["LK"], 95: ["MM"], 98: ["IR"], 211: ["SS"], 212: ["MA", "EH"], 213: ["DZ"], 216: ["TN"], 218: ["LY"], 220: ["GM"], 221: ["SN"], 222: ["MR"], 223: ["ML"], 224: ["GN"], 225: ["CI"], 226: ["BF"], 227: ["NE"], 228: ["TG"], 229: ["BJ"], 230: ["MU"], 231: ["LR"], 232: ["SL"], 233: ["GH"], 234: ["NG"], 235: ["TD"], 236: ["CF"], 237: ["CM"], 238: ["CV"], 239: ["ST"], 240: ["GQ"], 241: ["GA"], 242: ["CG"], 243: ["CD"], 244: ["AO"], 245: ["GW"], 246: ["IO"], 247: ["AC"], 248: ["SC"], 249: ["SD"], 250: ["RW"], 251: ["ET"], 252: ["SO"], 253: ["DJ"], 254: ["KE"], 255: ["TZ"], 256: ["UG"], 257: ["BI"], 258: ["MZ"], 260: ["ZM"], 261: ["MG"], 262: ["RE", "YT"], 263: ["ZW"], 264: ["NA"], 265: ["MW"], 266: ["LS"], 267: ["BW"], 268: ["SZ"], 269: ["KM"], 290: ["SH", "TA"], 291: ["ER"], 297: ["AW"], 298: ["FO"], 299: ["GL"], 350: ["GI"], 351: ["PT"], 352: ["LU"], 353: ["IE"], 354: ["IS"], 355: ["AL"], 356: ["MT"], 357: ["CY"], 358: ["FI", "AX"], 359: ["BG"], 370: ["LT"], 371: ["LV"], 372: ["EE"], 373: ["MD"], 374: ["AM"], 375: ["BY"], 376: ["AD"], 377: ["MC"], 378: ["SM"], 380: ["UA"], 381: ["RS"], 382: ["ME"], 383: ["XK"], 385: ["HR"], 386: ["SI"], 387: ["BA"], 389: ["MK"], 420: ["CZ"], 421: ["SK"], 423: ["LI"], 500: ["FK"], 501: ["BZ"], 502: ["GT"], 503: ["SV"], 504: ["HN"], 505: ["NI"], 506: ["CR"], 507: ["PA"], 508: ["PM"], 509: ["HT"], 590: ["GP", "BL", "MF"], 591: ["BO"], 592: ["GY"], 593: ["EC"], 594: ["GF"], 595: ["PY"], 596: ["MQ"], 597: ["SR"], 598: ["UY"], 599: ["CW", "BQ"], 670: ["TL"], 672: ["NF"], 673: ["BN"], 674: ["NR"], 675: ["PG"], 676: ["TO"], 677: ["SB"], 678: ["VU"], 679: ["FJ"], 680: ["PW"], 681: ["WF"], 682: ["CK"], 683: ["NU"], 685: ["WS"], 686: ["KI"], 687: ["NC"], 688: ["TV"], 689: ["PF"], 690: ["TK"], 691: ["FM"], 692: ["MH"], 850: ["KP"], 852: ["HK"], 853: ["MO"], 855: ["KH"], 856: ["LA"], 880: ["BD"], 886: ["TW"], 960: ["MV"], 961: ["LB"], 962: ["JO"], 963: ["SY"], 964: ["IQ"], 965: ["KW"], 966: ["SA"], 967: ["YE"], 968: ["OM"], 970: ["PS"], 971: ["AE"], 972: ["IL"], 973: ["BH"], 974: ["QA"], 975: ["BT"], 976: ["MN"], 977: ["NP"], 992: ["TJ"], 993: ["TM"], 994: ["AZ"], 995: ["GE"], 996: ["KG"], 998: ["UZ"] }, countries: { AC: ["247", "00", "(?:[01589]\\d|[46])\\d{4}", [5, 6], 0, 0, 0, 0, 0, 0, 0, [0, ["4\\d{4}", [5]]]], AD: ["376", "00", "(?:1|6\\d)\\d{7}|[135-9]\\d{5}", [6, 8, 9], [["(\\d{3})(\\d{3})", "$1 $2", ["[135-9]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["1"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]]], 0, 0, 0, 0, 0, 0, [0, ["690\\d{6}|[356]\\d{5}", [6, 9]]]], AE: ["971", "00", "(?:[4-7]\\d|9[0-689])\\d{7}|800\\d{2,9}|[2-4679]\\d{7}", [5, 6, 7, 8, 9, 10, 11, 12], [["(\\d{3})(\\d{2,9})", "$1 $2", ["60|8"]], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[236]|[479][2-8]"], "0$1"], ["(\\d{3})(\\d)(\\d{5})", "$1 $2 $3", ["[479]"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["5"], "0$1"]], "0", 0, 0, 0, 0, 0, [0, ["5[024-68]\\d{7}", [9]]]], AF: ["93", "00", "[2-7]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-7]"], "0$1"]], "0", 0, 0, 0, 0, 0, [0, ["7\\d{8}"]]], AG: ["1", "011", "(?:268|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([457]\\d{6})$|1", "268$1", 0, "268", [0, ["268(?:464|7(?:1[3-9]|[28]\\d|3[0246]|64|7[0-689]))\\d{4}"]]], AI: ["1", "011", "(?:264|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2457]\\d{6})$|1", "264$1", 0, "264", [0, ["264(?:235|4(?:69|76)|5(?:3[6-9]|8[1-4])|7(?:29|72))\\d{4}"]]], AL: ["355", "00", "(?:700\\d\\d|900)\\d{3}|8\\d{5,7}|(?:[2-5]|6\\d)\\d{7}", [6, 7, 8, 9], [["(\\d{3})(\\d{3,4})", "$1 $2", ["80|9"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["4[2-6]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2358][2-5]|4"], "0$1"], ["(\\d{3})(\\d{5})", "$1 $2", ["[23578]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["6"], "0$1"]], "0", 0, 0, 0, 0, 0, [0, ["6(?:[78][2-9]|9\\d)\\d{6}", [9]]]], AM: ["374", "00", "(?:[1-489]\\d|55|60|77)\\d{6}", [8], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[89]0"], "0 $1"], ["(\\d{3})(\\d{5})", "$1 $2", ["2|3[12]"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["1|47"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["[3-9]"], "0$1"]], "0", 0, 0, 0, 0, 0, [0, ["(?:33|4[1349]|55|77|88|9[13-9])\\d{6}"]]], AO: ["244", "00", "[29]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[29]"]]], 0, 0, 0, 0, 0, 0, [0, ["9[1-79]\\d{7}"]]], AR: ["54", "00", "(?:11|[89]\\d\\d)\\d{8}|[2368]\\d{9}", [10, 11], [["(\\d{4})(\\d{2})(\\d{4})", "$1 $2-$3", ["2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9])", "2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8]))|2(?:2[24-9]|3[1-59]|47)", "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5[56][46]|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]", "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|58|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|54(?:4|5[13-7]|6[89])|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:454|85[56])[46]|3(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"], "0$1", 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2-$3", ["1"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[68]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2-$3", ["[23]"], "0$1", 1], ["(\\d)(\\d{4})(\\d{2})(\\d{4})", "$2 15-$3-$4", ["9(?:2[2-469]|3[3-578])", "9(?:2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9]))", "9(?:2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8])))|92(?:2[24-9]|3[1-59]|47)", "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5(?:[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]", "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|5(?:4(?:4|5[13-7]|6[89])|[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"], "0$1", 0, "$1 $2 $3-$4"], ["(\\d)(\\d{2})(\\d{4})(\\d{4})", "$2 15-$3-$4", ["91"], "0$1", 0, "$1 $2 $3-$4"], ["(\\d{3})(\\d{3})(\\d{5})", "$1-$2-$3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{4})", "$2 15-$3-$4", ["9"], "0$1", 0, "$1 $2 $3-$4"]], "0", 0, "0?(?:(11|2(?:2(?:02?|[13]|2[13-79]|4[1-6]|5[2457]|6[124-8]|7[1-4]|8[13-6]|9[1267])|3(?:02?|1[467]|2[03-6]|3[13-8]|[49][2-6]|5[2-8]|[67])|4(?:7[3-578]|9)|6(?:[0136]|2[24-6]|4[6-8]?|5[15-8])|80|9(?:0[1-3]|[19]|2\\d|3[1-6]|4[02568]?|5[2-4]|6[2-46]|72?|8[23]?))|3(?:3(?:2[79]|6|8[2578])|4(?:0[0-24-9]|[12]|3[5-8]?|4[24-7]|5[4-68]?|6[02-9]|7[126]|8[2379]?|9[1-36-8])|5(?:1|2[1245]|3[237]?|4[1-46-9]|6[2-4]|7[1-6]|8[2-5]?)|6[24]|7(?:[069]|1[1568]|2[15]|3[145]|4[13]|5[14-8]|7[2-57]|8[126])|8(?:[01]|2[15-7]|3[2578]?|4[13-6]|5[4-8]?|6[1-357-9]|7[36-8]?|8[5-8]?|9[124])))15)?", "9$1", 0, 0, [0, ["93(?:7(?:1[15]|81)|8(?:21|4[16]|69|9[12]))[46]\\d{5}|9(?:2(?:2(?:2[59]|44|52)|3(?:26|44)|47[35]|9(?:[07]2|2[26]|34|46))|3327)[45]\\d{5}|9(?:2(?:657|9(?:54|66))|3(?:48[27]|7(?:55|77)|8(?:65|78)))[2-8]\\d{5}|9(?:2(?:284|3(?:02|23)|477|622|920)|3(?:4(?:46|89|92)|541))[2-7]\\d{5}|(?:675\\d|9(?:11[1-8]\\d|2(?:2(?:0[45]|1[2-6]|3[3-6])|3(?:[06]4|7[45])|494|6(?:04|1[2-8]|[36][45]|4[3-6])|80[45]|9(?:[17][4-6]|[48][45]|9[3-6]))|3(?:364|4(?:1[2-8]|[25][4-6]|3[3-6]|84)|5(?:1[2-9]|[38][4-6])|6(?:2[45]|44)|7[069][45]|8(?:0[45]|1[2-7]|3[4-6]|5[3-6]|7[2-6]|8[3-68]))))\\d{6}|9(?:2(?:2(?:62|81)|320|9(?:42|83))|3(?:329|4(?:62|7[16])|5(?:43|64)|7(?:18|5[17])))[2-6]\\d{5}|92(?:2(?:21|4[23]|6[145]|7[1-4]|8[356]|9[267])|3(?:16|3[13-8]|43|5[346-8]|9[3-5])|6(?:2[46]|4[78]|5[1568])|9(?:03|2[1457-9]|3[1356]|4[08]|[56][23]|82))4\\d{5}|9(?:2(?:257|3(?:24|46|92)|9(?:01|23|64))|3(?:4(?:42|64)|5(?:25|37|4[47]|71)|7(?:35|72)|825))[3-6]\\d{5}|9(?:2(?:2(?:02|2[3467]|4[156]|5[45]|6[6-8]|91)|3(?:1[47]|25|[45][25]|96)|47[48]|625|932)|3(?:38[2578]|4(?:0[0-24-9]|3[78]|4[457]|58|6[035-9]|72|83|9[136-8])|5(?:2[124]|[368][23]|4[2689]|7[2-6])|7(?:16|2[15]|3[14]|4[13]|5[468]|7[3-5]|8[26])|8(?:2[67]|3[278]|4[3-5]|5[78]|6[1-378]|[78]7|94)))[4-6]\\d{5}"]]], AS: ["1", "011", "(?:[58]\\d\\d|684|900)\\d{7}", [10], 0, "1", 0, "([267]\\d{6})$|1", "684$1", 0, "684", [0, ["684(?:2(?:48|5[2468]|7[26])|7(?:3[13]|70|82))\\d{4}"]]], AT: ["43", "00", "1\\d{3,12}|2\\d{6,12}|43(?:(?:0\\d|5[02-9])\\d{3,9}|2\\d{4,5}|[3467]\\d{4}|8\\d{4,6}|9\\d{4,7})|5\\d{4,12}|8\\d{7,12}|9\\d{8,12}|(?:[367]\\d|4[0-24-9])\\d{4,11}", [4, 5, 6, 7, 8, 9, 10, 11, 12, 13], [["(\\d)(\\d{3,12})", "$1 $2", ["1(?:11|[2-9])"], "0$1"], ["(\\d{3})(\\d{2})", "$1 $2", ["517"], "0$1"], ["(\\d{2})(\\d{3,5})", "$1 $2", ["5[079]"], "0$1"], ["(\\d{3})(\\d{3,10})", "$1 $2", ["(?:31|4)6|51|6(?:48|5[0-3579]|[6-9])|7(?:20|32|8)|[89]", "(?:31|4)6|51|6(?:485|5[0-3579]|[6-9])|7(?:20|32|8)|[89]"], "0$1"], ["(\\d{4})(\\d{3,9})", "$1 $2", ["[2-467]|5[2-6]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4,7})", "$1 $2 $3", ["5"], "0$1"]], "0", 0, 0, 0, 0, 0, [0, ["6(?:485|(?:5[0-3579]|6[013-9]|[7-9]\\d)\\d)\\d{3,9}", [7, 8, 9, 10, 11, 12, 13]]]], AU: ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{7}(?:\\d(?:\\d{2})?)?|8[0-24-9]\\d{7})|[2-478]\\d{8}|1\\d{4,7}", [5, 6, 7, 8, 9, 10, 12], [["(\\d{2})(\\d{3,4})", "$1 $2", ["16"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,4})", "$1 $2 $3", ["16"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["14|4"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["[2378]"], "(0$1)"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1(?:30|[89])"]]], "0", 0, "(183[12])|0", 0, 0, 0, [0, ["4(?:79[01]|83[0-389]|94[0-478])\\d{5}|4(?:[0-36]\\d|4[047-9]|[58][0-24-9]|7[02-8]|9[0-37-9])\\d{6}", [9]]], "0011"], AW: ["297", "00", "(?:[25-79]\\d\\d|800)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[25-9]"]]], 0, 0, 0, 0, 0, 0, [0, ["(?:290|5[69]\\d|6(?:[03]0|22|4[0-2]|[69]\\d)|7(?:[34]\\d|7[07])|9(?:6[45]|9[4-8]))\\d{4}"]]], AX: ["358", "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))", "2\\d{4,9}|35\\d{4,5}|(?:60\\d\\d|800)\\d{4,6}|7\\d{5,11}|(?:[14]\\d|3[0-46-9]|50)\\d{4,8}", [5, 6, 7, 8, 9, 10, 11, 12], 0, "0", 0, 0, 0, 0, "18", [0, ["4946\\d{2,6}|(?:4[0-8]|50)\\d{4,8}", [6, 7, 8, 9, 10]]], "00"], AZ: ["994", "00", "365\\d{6}|(?:[124579]\\d|60|88)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["90"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[28]|2|365|46", "1[28]|2|365[45]|46", "1[28]|2|365(?:4|5[02])|46"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[13-9]"], "0$1"]], "0", 0, 0, 0, 0, 0, [0, ["36554\\d{4}|(?:[16]0|4[04]|5[015]|7[07]|99)\\d{7}"]]], BA: ["387", "00", "6\\d{8}|(?:[35689]\\d|49|70)\\d{6}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["6[1-3]|[7-9]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2-$3", ["[3-5]|6[56]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["6"], "0$1"]], "0", 0, 0, 0, 0, 0, [0, ["6040\\d{5}|6(?:03|[1-356]|44|7\\d)\\d{6}"]]], BB: ["1", "011", "(?:246|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "246$1", 0, "246", [0, ["246(?:(?:2(?:[3568]\\d|4[0-57-9])|3(?:5[2-9]|6[0-6])|4(?:46|5\\d)|69[5-7]|8(?:[2-5]\\d|83))\\d|52(?:1[147]|20))\\d{3}"]]], BD: ["880", "00", "[1-469]\\d{9}|8[0-79]\\d{7,8}|[2-79]\\d{8}|[2-9]\\d{7}|[3-9]\\d{6}|[57-9]\\d{5}", [6, 7, 8, 9, 10], [["(\\d{2})(\\d{4,6})", "$1-$2", ["31[5-8]|[459]1"], "0$1"], ["(\\d{3})(\\d{3,7})", "$1-$2", ["3(?:[67]|8[013-9])|4(?:6[168]|7|[89][18])|5(?:6[128]|9)|6(?:[15]|28|4[14])|7[2-589]|8(?:0[014-9]|[12])|9[358]|(?:3[2-5]|4[235]|5[2-578]|6[0389]|76|8[3-7]|9[24])1|(?:44|66)[01346-9]"], "0$1"], ["(\\d{4})(\\d{3,6})", "$1-$2", ["[13-9]|2[23]"], "0$1"], ["(\\d)(\\d{7,8})", "$1-$2", ["2"], "0$1"]], "0", 0, 0, 0, 0, 0, [0, ["(?:1[13-9]\\d|644)\\d{7}|(?:3[78]|44|66)[02-9]\\d{7}", [10]]]], BE: ["32", "00", "4\\d{8}|[1-9]\\d{7}", [8, 9], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:80|9)0"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[239]|4[23]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[15-8]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["4"], "0$1"]], "0", 0, 0, 0, 0, 0, [0, ["4[5-9]\\d{7}", [9]]]], BF: ["226", "00", "(?:[025-7]\\d|44)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[024-7]"]]], 0, 0, 0, 0, 0, 0, [0, ["(?:0[1-7]|44|5[0-8]|[67]\\d)\\d{6}"]]], BG: ["359", "00", "00800\\d{7}|[2-7]\\d{6,7}|[89]\\d{6,8}|2\\d{5}", [6, 7, 8, 9, 12], [["(\\d)(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["2"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["43[1-6]|70[1-9]"], "0$1"], ["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:70|8)0"], "0$1"], ["(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3", ["43[1-7]|7"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[48]|9[08]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1"]], "0", 0, 0, 0, 0, 0, [0, ["(?:43[07-9]|99[69]\\d)\\d{5}|(?:8[7-9]|98)\\d{7}", [8, 9]]]], BH: ["973", "00", "[136-9]\\d{7}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[13679]|8[02-4679]"]]], 0, 0, 0, 0, 0, 0, [0, ["(?:3(?:[0-79]\\d|8[0-57-9])\\d|6(?:3(?:00|33|6[16])|441|6(?:3[03-9]|[69]\\d|7[0-689])))\\d{4}"]]], BI: ["257", "00", "(?:[267]\\d|31)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2367]"]]], 0, 0, 0, 0, 0, 0, [0, ["(?:29|6[124-9]|7[125-9])\\d{6}"]]], BJ: ["229", "00", "(?:01\\d|[24-689])\\d{7}", [8, 10], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24-689]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["0"]]], 0, 0, 0, 0, 0, 0, [0, ["(?:01(?:2[5-9]|[4-69]\\d)|4[0-8]|[56]\\d|9[013-9])\\d{6}"]]], BL: ["590", "00", "(?:590\\d|7090)\\d{5}|(?:69|80|9\\d)\\d{7}", [9], 0, "0", 0, 0, 0, 0, 0, [0, ["(?:69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))|7090[0-4])\\d{4}"]]], BM: ["1", "011", "(?:441|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "441$1", 0, "441", [0, ["441(?:[2378]\\d|5[0-39]|9[02])\\d{5}"]]], BN: ["673", "00", "[2-578]\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-578]"]]], 0, 0, 0, 0, 0, 0, [0, ["(?:22[89]|[78]\\d\\d)\\d{4}"]]], BO: ["591", "00(?:1\\d)?", "8001\\d{5}|(?:[2-467]\\d|50)\\d{6}", [8, 9], [["(\\d)(\\d{7})", "$1 $2", ["[235]|4[46]"]], ["(\\d{8})", "$1", ["[67]"]], ["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["8"]]], "0", 0, "0(1\\d)?", 0, 0, 0, [0, ["[67]\\d{7}", [8]]]], BQ: ["599", "00", "(?:[34]1|7\\d)\\d{5}", [7], 0, 0, 0, 0, 0, 0, "[347]", [0, ["(?:31(?:8[14-8]|9[14578])|416[14-9]|7(?:0[01]|7[07]|8\\d|9[056])\\d)\\d{3}"]]], BR: ["55", "00(?:1[245]|2[1-35]|31|4[13]|[56]5|99)", "[1-467]\\d{9,10}|55[0-46-9]\\d{8}|[34]\\d{7}|55\\d{7,8}|(?:5[0-46-9]|[89]\\d)\\d{7,9}", [8, 9, 10, 11], [["(\\d{4})(\\d{4})", "$1-$2", ["300|4(?:0[02]|37|86)", "300|4(?:0(?:0|20)|370|864)"]], ["(\\d{3})(\\d{2,3})(\\d{4})", "$1 $2 $3", ["(?:[358]|90)0"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2-$3", ["(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-57]"], "($1)"], ["(\\d{2})(\\d{5})(\\d{4})", "$1 $2-$3", ["[16][1-9]|[2-57-9]"], "($1)"]], "0", 0, "(?:0|90)(?:(1[245]|2[1-35]|31|4[13]|[56]5|99)(\\d{10,11}))?", "$2", 0, 0, [0, ["(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])(?:7|9\\d)\\d{7}", [10, 11]]]], BS: ["1", "011", "(?:242|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([3-8]\\d{6})$|1", "242$1", 0, "242", [0, ["242(?:3(?:5[79]|7[56]|95)|4(?:[23][1-9]|4[1-35-9]|5[1-8]|6[2-8]|7\\d|81)|5(?:2[45]|3[35]|44|5[1-46-9]|65|77)|6[34]6|7(?:27|38)|8(?:0[1-9]|1[02-9]|2\\d|3[0-4]|[89]9))\\d{4}"]]], BT: ["975", "00", "[17]\\d{7}|[2-8]\\d{6}", [7, 8], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-68]|7[246]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[67]|7"]]], 0, 0, 0, 0, 0, 0, [0, ["(?:1[67]|77)\\d{6}", [8]]]], BW: ["267", "00", "(?:0800|(?:[37]|800)\\d)\\d{6}|(?:[2-6]\\d|90)\\d{5}", [7, 8, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["90"]], ["(\\d{3})(\\d{4})", "$1 $2", ["[24-6]|3[15-9]"]], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[37]"]], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["0"]], ["(\\d{3})(\\d{4})(\\d{3})", "$1 $2 $3", ["8"]]], 0, 0, 0, 0, 0, 0, [0, ["(?:321|7[1-8]\\d)\\d{5}", [8]]]], BY: ["375", "810", "(?:[12]\\d|33|44|902)\\d{7}|8(?:0[0-79]\\d{5,7}|[1-7]\\d{9})|8(?:1[0-489]|[5-79]\\d)\\d{7}|8[1-79]\\d{6,7}|8[0-79]\\d{5}|8\\d{5}", [6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{3})", "$1 $2", ["800"], "8 $1"], ["(\\d{3})(\\d{2})(\\d{2,4})", "$1 $2 $3", ["800"], "8 $1"], ["(\\d{4})(\\d{2})(\\d{3})", "$1 $2-$3", ["1(?:5[169]|6[3-5]|7[179])|2(?:1[35]|2[34]|3[3-5])", "1(?:5[169]|6(?:3[1-3]|4|5[125])|7(?:1[3-9]|7[0-24-6]|9[2-7]))|2(?:1[35]|2[34]|3[3-5])"], "8 0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["1(?:[56]|7[467])|2[1-3]"], "8 0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[1-4]"], "8 0$1"], ["(\\d{3})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["[89]"], "8 $1"]], "8", 0, "0|80?", 0, 0, 0, [0, ["(?:2(?:5[5-79]|9[1-9])|(?:33|44)\\d)\\d{6}", [9]]], "8~10"], BZ: ["501", "00", "(?:0800\\d|[2-8])\\d{6}", [7, 11], [["(\\d{3})(\\d{4})", "$1-$2", ["[2-8]"]], ["(\\d)(\\d{3})(\\d{4})(\\d{3})", "$1-$2-$3-$4", ["0"]]], 0, 0, 0, 0, 0, 0, [0, ["6[0-35-7]\\d{5}", [7]]]], CA: ["1", "011", "[2-9]\\d{9}|3\\d{6}", [7, 10], 0, "1", 0, 0, 0, 0, 0, [0, ["(?:2(?:04|[23]6|[48]9|5[07]|63)|3(?:06|43|54|6[578]|82)|4(?:03|1[68]|[26]8|3[178]|50|74)|5(?:06|1[49]|48|79|8[147])|6(?:04|[18]3|39|47|72)|7(?:0[59]|42|53|78|8[02])|8(?:[06]7|19|25|7[39])|9(?:0[25]|42))[2-9]\\d{6}", [10]]]], CC: ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}", [6, 7, 8, 9, 10, 12], 0, "0", 0, "([59]\\d{7})$|0", "8$1", 0, 0, [0, ["4(?:79[01]|83[0-389]|94[0-478])\\d{5}|4(?:[0-36]\\d|4[047-9]|[58][0-24-9]|7[02-8]|9[0-37-9])\\d{6}", [9]]], "0011"], CD: ["243", "00", "(?:(?:[189]|5\\d)\\d|2)\\d{7}|[1-68]\\d{6}", [7, 8, 9, 10], [["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["88"], "0$1"], ["(\\d{2})(\\d{5})", "$1 $2", ["[1-6]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["5"], "0$1"]], "0", 0, 0, 0, 0, 0, [0, ["88\\d{5}|(?:8[0-69]|9[017-9])\\d{7}", [7, 9]]]], CF: ["236", "00", "(?:[27]\\d{3}|8776)\\d{4}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[278]"]]], 0, 0, 0, 0, 0, 0, [0, ["7[024-7]\\d{6}"]]], CG: ["242", "00", "222\\d{6}|(?:0\\d|80)\\d{7}", [9], [["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["8"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[02]"]]], 0, 0, 0, 0, 0, 0, [0, ["026(?:1[0-5]|6[6-9])\\d{4}|0(?:[14-6]\\d\\d|2(?:40|5[5-8]|6[07-9]))\\d{5}"]]], CH: ["41", "00", "8\\d{11}|[2-9]\\d{8}", [9, 12], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8[047]|90"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-79]|81"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [0, ["(?:6[89]|7[235-9])\\d{7}", [9]]]], CI: ["225", "00", "[02]\\d{9}", [10], [["(\\d{2})(\\d{2})(\\d)(\\d{5})", "$1 $2 $3 $4", ["2"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3 $4", ["0"]]], 0, 0, 0, 0, 0, 0, [0, ["0[157]\\d{8}"]]], CK: ["682", "00", "[2-578]\\d{4}", [5], [["(\\d{2})(\\d{3})", "$1 $2", ["[2-578]"]]], 0, 0, 0, 0, 0, 0, [0, ["[578]\\d{4}"]]], CL: ["56", "(?:0|1(?:1[0-69]|2[02-5]|5[13-58]|69|7[0167]|8[018]))0", "12300\\d{6}|6\\d{9,10}|[2-9]\\d{8}", [9, 10, 11], [["(\\d{5})(\\d{4})", "$1 $2", ["219", "2196"], "($1)"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["60|809"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["44"]], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2[1-36]"], "($1)"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["9(?:10|[2-9])"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["3[2-5]|[47]|5[1-3578]|6[13-57]|8(?:0[1-8]|[1-9])"], "($1)"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["60|8"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]], ["(\\d{3})(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["60"]]], 0, 0, 0, 0, 0, 0, [0, ["2(?:1982[0-6]|3314[05-9])\\d{3}|(?:2(?:1(?:160|962)|2\\d{3}|3(?:(?:2\\d|50)\\d|3(?:[03467]\\d|1[0-35-9]|2[1-9]|5[0-24-9]|8[0-389]|9[0-8])|600)|646[59])|(?:(?:3[2-5]|[47][1-35]|5[1-3578]|6[13-57])\\d|8(?:0[1-8]|[1-9]\\d))\\d\\d|9(?:(?:10[01]|(?:[2458]\\d|7[1-9])\\d)\\d|3(?:[0-57-9]\\d\\d|6(?:0[02-9]|[1-9]\\d))|6(?:[0-8]\\d\\d|9(?:[02-79]\\d|1[05-9]))|9(?:[03-9]\\d\\d|1(?:[0235-9]\\d|4[0-24-9])|2(?:[0-79]\\d|8[0-46-9]))))\\d{4}", [9]]]], CM: ["237", "00", "[26]\\d{8}|88\\d{6,7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["88"]], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[26]|88"]]], 0, 0, 0, 0, 0, 0, [0, ["(?:24[23]|6(?:[25-9]\\d|40))\\d{6}", [9]]]], CN: ["86", "00|1(?:[12]\\d|79)\\d\\d00", "(?:(?:1[03-689]|2\\d)\\d\\d|6)\\d{8}|1\\d{10}|[126]\\d{6}(?:\\d(?:\\d{2})?)?|86\\d{5,6}|(?:[3-579]\\d|8[0-57-9])\\d{5,9}", [7, 8, 9, 10, 11, 12], [["(\\d{2})(\\d{5,6})", "$1 $2", ["(?:10|2[0-57-9])[19]|3(?:[157]|35|49|9[1-68])|4(?:1[124-9]|2[179]|6[47-9]|7|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:07|1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3|4[13]|5[1-5]|7[0-79]|9[0-35-9])|(?:4[35]|59|85)[1-9]", "(?:10|2[0-57-9])(?:1[02]|9[56])|8078|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))1", "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|80781|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))12", "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|807812|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))123", "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:078|1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))123"], "0$1"], ["(\\d{3})(\\d{5,6})", "$1 $2", ["3(?:[157]|35|49|9[1-68])|4(?:[17]|2[179]|6[47-9]|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])|(?:4[35]|59|85)[1-9]", "(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))[19]", "85[23](?:10|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:10|9[56])", "85[23](?:100|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:100|9[56])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["(?:4|80)0"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["10|2(?:[02-57-9]|1[1-9])", "10|2(?:[02-57-9]|1[1-9])", "10[0-79]|2(?:[02-57-9]|1[1-79])|(?:10|21)8(?:0[1-9]|[1-9])"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["3(?:[3-59]|7[02-68])|4(?:[26-8]|3[3-9]|5[2-9])|5(?:3[03-9]|[468]|7[028]|9[2-46-9])|6|7(?:[0-247]|3[04-9]|5[0-4689]|6[2368])|8(?:[1-358]|9[1-7])|9(?:[013479]|5[1-5])|(?:[34]1|55|79|87)[02-9]"], "0$1", 1], ["(\\d{3})(\\d{7,8})", "$1 $2", ["9"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["80"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["[3-578]"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["1[3-9]"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["[12]"], "0$1", 1]], "0", 0, "(1(?:[12]\\d|79)\\d\\d)|0", 0, 0, 0, [0, ["1740[0-5]\\d{6}|1(?:[38]\\d|4[57]|[59][0-35-9]|6[25-7]|7[0-35-8])\\d{8}", [11]]], "00"], CO: ["57", "00(?:4(?:[14]4|56)|[579])", "(?:46|60\\d\\d)\\d{6}|(?:1\\d|[39])\\d{9}", [8, 10, 11], [["(\\d{4})(\\d{4})", "$1 $2", ["46"]], ["(\\d{3})(\\d{7})", "$1 $2", ["6|90"], "($1)"], ["(\\d{3})(\\d{7})", "$1 $2", ["3[0-357]|9[14]"]], ["(\\d)(\\d{3})(\\d{7})", "$1-$2-$3", ["1"], "0$1", 0, "$1 $2 $3"]], "0", 0, "0([3579]|4(?:[14]4|56))?", 0, 0, 0, [0, ["333301[0-5]\\d{3}|3333(?:00|2[5-9]|[3-9]\\d)\\d{4}|(?:3(?:(?:0[0-5]|1\\d|5[01]|70)\\d|2(?:[0-3]\\d|4[1-9])|3(?:00|3[0-24-9]))|9(?:101|408))\\d{6}", [10]]]], CR: ["506", "00", "(?:8\\d|90)\\d{8}|(?:[24-8]\\d{3}|3005)\\d{4}", [8, 10], [["(\\d{4})(\\d{4})", "$1 $2", ["[2-7]|8[3-9]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[89]"]]], 0, 0, "(19(?:0[0-2468]|1[09]|20|66|77|99))", 0, 0, 0, [0, ["(?:3005\\d|6500[01])\\d{3}|(?:5[07]|6[0-4]|7[0-3]|8[3-9])\\d{6}", [8]]]], CU: ["53", "119", "(?:[2-7]|8\\d\\d)\\d{7}|[2-47]\\d{6}|[34]\\d{5}", [6, 7, 8, 10], [["(\\d{2})(\\d{4,6})", "$1 $2", ["2[1-4]|[34]"], "(0$1)"], ["(\\d)(\\d{6,7})", "$1 $2", ["7"], "(0$1)"], ["(\\d)(\\d{7})", "$1 $2", ["[56]"], "0$1"], ["(\\d{3})(\\d{7})", "$1 $2", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [0, ["(?:5\\d|6[2-4])\\d{6}", [8]]]], CV: ["238", "0", "(?:[2-59]\\d\\d|800)\\d{4}", [7], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[2-589]"]]], 0, 0, 0, 0, 0, 0, [0, ["(?:36|5[1-389]|9\\d)\\d{5}"]]], CW: ["599", "00", "(?:[34]1|60|(?:7|9\\d)\\d)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["[3467]"]], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["9[4-8]"]]], 0, 0, 0, 0, 0, "[69]", [0, ["953[01]\\d{4}|9(?:5[12467]|6[5-9])\\d{5}"]]], CX: ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}", [6, 7, 8, 9, 10, 12], 0, "0", 0, "([59]\\d{7})$|0", "8$1", 0, 0, [0, ["4(?:79[01]|83[0-389]|94[0-478])\\d{5}|4(?:[0-36]\\d|4[047-9]|[58][0-24-9]|7[02-8]|9[0-37-9])\\d{6}", [9]]], "0011"], CY: ["357", "00", "(?:[279]\\d|[58]0)\\d{6}", [8], [["(\\d{2})(\\d{6})", "$1 $2", ["[257-9]"]]], 0, 0, 0, 0, 0, 0, [0, ["9(?:10|[4-79]\\d)\\d{5}"]]], CZ: ["420", "00", "(?:[2-578]\\d|60)\\d{7}|9\\d{8,11}", [9, 10, 11, 12], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-8]|9[015-7]"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3 $4", ["96"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]]], 0, 0, 0, 0, 0, 0, [0, ["(?:60[1-8]\\d|7(?:0(?:[2-5]\\d|60)|19[0-4]|[2379]\\d\\d))\\d{5}", [9]]]], DE: ["49", "00", "[2579]\\d{5,14}|49(?:[34]0|69|8\\d)\\d\\d?|49(?:37|49|60|7[089]|9\\d)\\d{1,3}|49(?:2[024-9]|3[2-689]|7[1-7])\\d{1,8}|(?:1|[368]\\d|4[0-8])\\d{3,13}|49(?:[015]\\d|2[13]|31|[46][1-8])\\d{1,9}", [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15], [["(\\d{2})(\\d{3,13})", "$1 $2", ["3[02]|40|[68]9"], "0$1"], ["(\\d{3})(\\d{3,12})", "$1 $2", ["2(?:0[1-389]|1[124]|2[18]|3[14])|3(?:[35-9][15]|4[015])|906|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1", "2(?:0[1-389]|12[0-8])|3(?:[35-9][15]|4[015])|906|2(?:[13][14]|2[18])|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1"], "0$1"], ["(\\d{4})(\\d{2,11})", "$1 $2", ["[24-6]|3(?:[3569][02-46-9]|4[2-4679]|7[2-467]|8[2-46-8])|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]", "[24-6]|3(?:3(?:0[1-467]|2[127-9]|3[124578]|7[1257-9]|8[1256]|9[145])|4(?:2[135]|4[13578]|9[1346])|5(?:0[14]|2[1-3589]|6[1-4]|7[13468]|8[13568])|6(?:2[1-489]|3[124-6]|6[13]|7[12579]|8[1-356]|9[135])|7(?:2[1-7]|4[145]|6[1-5]|7[1-4])|8(?:21|3[1468]|6|7[1467]|8[136])|9(?:0[12479]|2[1358]|4[134679]|6[1-9]|7[136]|8[147]|9[1468]))|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]|3[68]4[1347]|3(?:47|60)[1356]|3(?:3[46]|46|5[49])[1246]|3[4579]3[1357]"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["138"], "0$1"], ["(\\d{5})(\\d{2,10})", "$1 $2", ["3"], "0$1"], ["(\\d{3})(\\d{5,11})", "$1 $2", ["181"], "0$1"], ["(\\d{3})(\\d)(\\d{4,10})", "$1 $2 $3", ["1(?:3|80)|9"], "0$1"], ["(\\d{3})(\\d{7,8})", "$1 $2", ["1[67]"], "0$1"], ["(\\d{3})(\\d{7,12})", "$1 $2", ["8"], "0$1"], ["(\\d{5})(\\d{6})", "$1 $2", ["185", "1850", "18500"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{4})(\\d{7})", "$1 $2", ["18[68]"], "0$1"], ["(\\d{4})(\\d{7})", "$1 $2", ["15[1279]"], "0$1"], ["(\\d{5})(\\d{6})", "$1 $2", ["15[03568]", "15(?:[0568]|31)"], "0$1"], ["(\\d{3})(\\d{8})", "$1 $2", ["18"], "0$1"], ["(\\d{3})(\\d{2})(\\d{7,8})", "$1 $2 $3", ["1(?:6[023]|7)"], "0$1"], ["(\\d{4})(\\d{2})(\\d{7})", "$1 $2 $3", ["15[279]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{8})", "$1 $2 $3", ["15"], "0$1"]], "0", 0, 0, 0, 0, 0, [0, ["15310\\d{6}|1(?:5[0-25-9]\\d|7[013-5])\\d{7}|1(?:6[023]|7[26-9])\\d{7,8}", [10, 11]]]], DJ: ["253", "00", "(?:2\\d|77)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[27]"]]], 0, 0, 0, 0, 0, 0, [0, ["77\\d{6}"]]], DK: ["45", "00", "[2-9]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-9]"]]], 0, 0, 0, 0, 0, 0, [0, ["(?:2[6-8]|37|6[78]|96)\\d{6}|(?:2[0-59]|3[0-689]|[457]\\d|6[0-69]|8[126-9]|9[1-47-9])[1-9]\\d{5}"]]], DM: ["1", "011", "(?:[58]\\d\\d|767|900)\\d{7}", [10], 0, "1", 0, "([2-7]\\d{6})$|1", "767$1", 0, "767", [0, ["767(?:2(?:[2-4689]5|7[5-7])|31[5-7]|61[1-8]|70[1-6])\\d{4}"]]], DO: ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "8001|8[024]9", [0, ["8[024]9[2-9]\\d{6}"]]], DZ: ["213", "00", "(?:[1-4]|[5-79]\\d|80)\\d{7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[1-4]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["9"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-8]"], "0$1"]], "0", 0, 0, 0, 0, 0, [0, ["(?:5(?:4[0-29]|5\\d|6[0-3])|6(?:[569]\\d|7[0-6])|7[7-9]\\d)\\d{6}", [9]]]], EC: ["593", "00", "1\\d{9,10}|(?:[2-7]|9\\d)\\d{7}", [8, 9, 10, 11], [["(\\d)(\\d{3})(\\d{4})", "$1 $2-$3", ["[2-7]"], "(0$1)", 0, "$1-$2-$3"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["1"]]], "0", 0, 0, 0, 0, 0, [0, ["964[0-2]\\d{5}|9(?:39|[57][89]|6[0-36-9]|[89]\\d)\\d{6}", [9]]]], EE: ["372", "00", "8\\d{9}|[4578]\\d{7}|(?:[3-8]\\d|90)\\d{5}", [7, 8, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["[369]|4[3-8]|5(?:[0-2]|5[0-478]|6[45])|7[1-9]|88", "[369]|4[3-8]|5(?:[02]|1(?:[0-8]|95)|5[0-478]|6(?:4[0-4]|5[1-589]))|7[1-9]|88"]], ["(\\d{4})(\\d{3,4})", "$1 $2", ["[45]|8(?:00|[1-49])", "[45]|8(?:00[1-9]|[1-49])"]], ["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["7"]], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]]], 0, 0, 0, 0, 0, 0, [0, ["(?:5\\d{5}|8(?:1(?:0(?:0(?:00|[178]\\d)|[3-9]\\d\\d)|(?:1(?:0[2-6]|1\\d)|(?:2[0-59]|[3-79]\\d)\\d)\\d)|2(?:0(?:0(?:00|4\\d)|(?:19|[2-7]\\d)\\d)|(?:(?:[124-69]\\d|3[5-9])\\d|7(?:[0-79]\\d|8[13-9])|8(?:[2-6]\\d|7[01]))\\d)|[349]\\d{4}))\\d\\d|5(?:(?:[02]\\d|5[0-478])\\d|1(?:[0-8]\\d|95)|6(?:4[0-4]|5[1-589]))\\d{3}", [7, 8]]]], EG: ["20", "00", "[189]\\d{8,9}|[24-6]\\d{8}|[135]\\d{7}", [8, 9, 10], [["(\\d)(\\d{7,8})", "$1 $2", ["[23]"], "0$1"], ["(\\d{2})(\\d{6,7})", "$1 $2", ["1[35]|[4-6]|8[2468]|9[235-7]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{2})(\\d{8})", "$1 $2", ["1"], "0$1"]], "0", 0, 0, 0, 0, 0, [0, ["1[0-25]\\d{8}", [10]]]], EH: ["212", "00", "[5-8]\\d{8}", [9], 0, "0", 0, 0, 0, 0, "528[89]", [0, ["(?:6(?:[0-79]\\d|8[0-247-9])|7(?:[0167]\\d|2[0-8]|5[0-5]|8[0-7]))\\d{6}"]]], ER: ["291", "00", "[178]\\d{6}", [7], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[178]"], "0$1"]], "0", 0, 0, 0, 0, 0, [0, ["(?:17[1-3]|7\\d\\d)\\d{4}"]]], ES: ["34", "00", "[5-9]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[89]00"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-9]"]]], 0, 0, 0, 0, 0, 0, [0, ["(?:590[16]00\\d|9(?:6906(?:09|10)|7390\\d\\d))\\d\\d|(?:6\\d|7[1-48])\\d{7}"]]], ET: ["251", "00", "(?:11|[2-579]\\d)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-579]"], "0$1"]], "0", 0, 0, 0, 0, 0, [0, ["700[1-9]\\d{5}|(?:7(?:0[1-9]|1[0-8]|22|77|86|99)|9\\d\\d)\\d{6}"]]], FI: ["358", "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))", "[1-35689]\\d{4}|7\\d{10,11}|(?:[124-7]\\d|3[0-46-9])\\d{8}|[1-9]\\d{5,8}", [5, 6, 7, 8, 9, 10, 11, 12], [["(\\d{5})", "$1", ["20[2-59]"], "0$1"], ["(\\d{3})(\\d{3,7})", "$1 $2", ["(?:[1-3]0|[68])0|70[07-9]"], "0$1"], ["(\\d{2})(\\d{4,8})", "$1 $2", ["[14]|2[09]|50|7[135]"], "0$1"], ["(\\d{2})(\\d{6,10})", "$1 $2", ["7"], "0$1"], ["(\\d)(\\d{4,9})", "$1 $2", ["(?:19|[2568])[1-8]|3(?:0[1-9]|[1-9])|9"], "0$1"]], "0", 0, 0, 0, 0, "1[03-79]|[2-9]", [0, ["4946\\d{2,6}|(?:4[0-8]|50)\\d{4,8}", [6, 7, 8, 9, 10]]], "00"], FJ: ["679", "0(?:0|52)", "45\\d{5}|(?:0800\\d|[235-9])\\d{6}", [7, 11], [["(\\d{3})(\\d{4})", "$1 $2", ["[235-9]|45"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["0"]]], 0, 0, 0, 0, 0, 0, [0, ["(?:[279]\\d|45|5[01568]|8[034679])\\d{5}", [7]]], "00"], FK: ["500", "00", "[2-7]\\d{4}", [5], 0, 0, 0, 0, 0, 0, 0, [0, ["[56]\\d{4}"]]], FM: ["691", "00", "(?:[39]\\d\\d|820)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[389]"]]], 0, 0, 0, 0, 0, 0, [0, ["31(?:00[67]|208|309)\\d\\d|(?:3(?:[2357]0[1-9]|602|804|905)|(?:820|9[2-7]\\d)\\d)\\d{3}"]]], FO: ["298", "00", "[2-9]\\d{5}", [6], [["(\\d{6})", "$1", ["[2-9]"]]], 0, 0, "(10(?:01|[12]0|88))", 0, 0, 0, [0, ["(?:[27][1-9]|5\\d|9[16])\\d{4}"]]], FR: ["33", "00", "[1-9]\\d{8}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0 $1"], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[1-79]"], "0$1"]], "0", 0, 0, 0, 0, 0, [0, ["(?:6(?:[0-24-8]\\d|3[0-8]|9[589])|7[3-9]\\d)\\d{6}"]]], GA: ["241", "00", "(?:[067]\\d|11)\\d{6}|[2-7]\\d{6}", [7, 8], [["(\\d)(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-7]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["0"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["11|[67]"], "0$1"]], 0, 0, "0(11\\d{6}|60\\d{6}|61\\d{6}|6[256]\\d{6}|7[467]\\d{6})", "$1", 0, 0, [0, ["(?:(?:0[2-7]|7[467])\\d|6(?:0[0-4]|10|[256]\\d))\\d{5}|[2-7]\\d{6}"]]], GB: ["44", "00", "[1-357-9]\\d{9}|[18]\\d{8}|8\\d{6}", [7, 9, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["800", "8001", "80011", "800111", "8001111"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["845", "8454", "84546", "845464"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["800"], "0$1"], ["(\\d{5})(\\d{4,5})", "$1 $2", ["1(?:38|5[23]|69|76|94)", "1(?:(?:38|69)7|5(?:24|39)|768|946)", "1(?:3873|5(?:242|39[4-6])|(?:697|768)[347]|9467)"], "0$1"], ["(\\d{4})(\\d{5,6})", "$1 $2", ["1(?:[2-69][02-9]|[78])"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["[25]|7(?:0|6[02-9])", "[25]|7(?:0|6(?:[03-9]|2[356]))"], "0$1"], ["(\\d{4})(\\d{6})", "$1 $2", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1389]"], "0$1"]], "0", 0, "0|180020", 0, 0, 0, [0, ["7(?:457[0-57-9]|700[01]|911[028])\\d{5}|7(?:[1-3]\\d\\d|4(?:[0-46-9]\\d|5[0-689])|5(?:0[0-8]|[13-9]\\d|2[0-35-9])|7(?:0[1-9]|[1-7]\\d|8[02-9]|9[0-689])|8(?:[014-9]\\d|[23][0-8])|9(?:[024-9]\\d|1[02-9]|3[0-689]))\\d{6}", [10]]], 0, " x"], GD: ["1", "011", "(?:473|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "473$1", 0, "473", [0, ["473(?:4(?:0[2-79]|1[04-9]|2[0-5]|49|5[6-8])|5(?:2[01]|3[3-8])|901)\\d{4}"]]], GE: ["995", "00", "(?:[3-57]\\d\\d|800)\\d{6}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["70"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["32"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[57]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[348]"], "0$1"]], "0", 0, 0, 0, 0, 0, [0, ["5(?:(?:(?:0555|1(?:[17]77|555))[5-9]|757(?:7[7-9]|8[01]))\\d|22252[0-4])\\d\\d|5(?:0(?:0[17]0|505)|1(?:0[01]0|1(?:07|33|51))|2(?:0[02]0|2[25]2)|3(?:0[03]0|3[35]3)|(?:40[04]|900)0|5222)[0-4]\\d{3}|(?:5(?:0(?:0(?:0\\d|11|22|3[0-6]|44|5[05]|77|88|9[09])|(?:[14]\\d|77)\\d|22[02])|1(?:1(?:[03][01]|[124]\\d|5[2-6]|7[0-4])|4\\d\\d)|[23]555|4(?:4\\d\\d|555)|5(?:[0157-9]\\d\\d|200|333|444)|6[89]\\d\\d|7(?:[0147-9]\\d\\d|5(?:00|[57]5))|8(?:0(?:[018]\\d|2[0-4])|5(?:55|8[89])|8(?:55|88))|9(?:090|[1-35-9]\\d\\d))|790\\d\\d)\\d{4}"]]], GF: ["594", "00", "(?:[56]94\\d|7093)\\d{5}|(?:80|9\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-7]|9[47]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[89]"], "0$1"]], "0", 0, 0, 0, 0, 0, [0, ["(?:694(?:[0-249]\\d|3[0-8])|7093[0-3])\\d{4}"]]], GG: ["44", "00", "(?:1481|[357-9]\\d{3})\\d{6}|8\\d{6}(?:\\d{2})?", [7, 9, 10], 0, "0", 0, "([25-9]\\d{5})$|0|180020", "1481$1", 0, 0, [0, ["7(?:(?:781|839)\\d|911[17])\\d{5}", [10]]]], GH: ["233", "00", "(?:[235]\\d{3}|800)\\d{5}", [8, 9], [["(\\d{3})(\\d{5})", "$1 $2", ["8"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[235]"], "0$1"]], "0", 0, 0, 0, 0, 0, [0, ["(?:2(?:[0346-9]\\d|5[67])|5(?:[03-7]\\d|9[1-9]))\\d{6}", [9]]]], GI: ["350", "00", "(?:[25]\\d|60)\\d{6}", [8], [["(\\d{3})(\\d{5})", "$1 $2", ["2"]]], 0, 0, 0, 0, 0, 0, [0, ["5251[0-4]\\d{3}|(?:5(?:[146-8]\\d\\d|250)|60(?:1[01]|6\\d))\\d{4}"]]], GL: ["299", "00", "(?:19|[2-689]\\d|70)\\d{4}", [6], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["19|[2-9]"]]], 0, 0, 0, 0, 0, 0, [0, ["[245]\\d{5}"]]], GM: ["220", "00", "[2-9]\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]], 0, 0, 0, 0, 0, 0, [0, ["556\\d{4}|(?:[23679]\\d|4[015]|5[0-489]|8[67])\\d{5}"]]], GN: ["224", "00", "722\\d{6}|(?:3|6\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["3"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[67]"]]], 0, 0, 0, 0, 0, 0, [0, ["6[0-356]\\d{7}", [9]]]], GP: ["590", "00", "(?:590\\d|7090)\\d{5}|(?:69|80|9\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-79]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [0, ["(?:69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))|7090[0-4])\\d{4}"]]], GQ: ["240", "00", "222\\d{6}|(?:3\\d|55|[89]0)\\d{7}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235]"]], ["(\\d{3})(\\d{6})", "$1 $2", ["[89]"]]], 0, 0, 0, 0, 0, 0, [0, ["(?:222|55\\d)\\d{6}"]]], GR: ["30", "00", "5005000\\d{3}|8\\d{9,11}|(?:[269]\\d|70)\\d{8}", [10, 11, 12], [["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["21|7"]], ["(\\d{4})(\\d{6})", "$1 $2", ["2(?:2|3[2-57-9]|4[2-469]|5[2-59]|6[2-9]|7[2-69]|8[2-49])|5"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2689]"]], ["(\\d{3})(\\d{3,4})(\\d{5})", "$1 $2 $3", ["8"]]], 0, 0, 0, 0, 0, 0, [0, ["68[57-9]\\d{7}|(?:69|94)\\d{8}", [10]]]], GT: ["502", "00", "80\\d{6}|(?:1\\d{3}|[2-7])\\d{7}", [8, 11], [["(\\d{4})(\\d{4})", "$1 $2", ["[2-8]"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]]], 0, 0, 0, 0, 0, 0, [0, ["(?:[3-5]\\d\\d|80[0-4])\\d{5}", [8]]]], GU: ["1", "011", "(?:[58]\\d\\d|671|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "671$1", 0, "671", [0, ["671(?:2\\d\\d|3(?:00|3[39]|4[349]|55|6[26])|4(?:00|56|7[1-9]|8[02-9])|5(?:55|6[2-5]|88)|6(?:3[2-578]|4[24-9]|5[34]|78|8[235-9])|7(?:[0479]7|2[0167]|3[45]|8[7-9])|8(?:[2-57-9]8|6[478])|9(?:2[29]|6[79]|7[1279]|8[7-9]|9[78]))\\d{4}"]]], GW: ["245", "00", "[49]\\d{8}|4\\d{6}", [7, 9], [["(\\d{3})(\\d{4})", "$1 $2", ["40"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[49]"]]], 0, 0, 0, 0, 0, 0, [0, ["9(?:5\\d|6[569]|77)\\d{6}", [9]]]], GY: ["592", "001", "(?:[2-8]\\d{3}|9008)\\d{3}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]], 0, 0, 0, 0, 0, 0, [0, ["(?:51[01]|6\\d\\d|7(?:[0-5]\\d|6[019]|70))\\d{4}"]]], HK: ["852", "00(?:30|5[09]|[126-9]?)", "8[0-46-9]\\d{6,7}|9\\d{4,7}|(?:[2-7]|9\\d{3})\\d{7}", [5, 6, 7, 8, 9, 11], [["(\\d{3})(\\d{2,5})", "$1 $2", ["900", "9003"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[2-7]|8[1-4]|9(?:0[1-9]|[1-8])"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]], ["(\\d{3})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]]], 0, 0, 0, 0, 0, 0, [0, ["(?:4(?:44[0-35-9]|6(?:4[0-57-9]|6[0-4])|7(?:3[0-4]|4[0-48]|6[0-5]))|5(?:35[4-8]|73[0-6]|95[0-8])|6(?:26[013-8]|(?:66|78)[0-5])|70(?:7[1-8]|8[0-8])|84(?:4[0-2]|8[0-35-9])|9(?:29[013-9]|39[014-9]|59[0-4]|899))\\d{4}|(?:4(?:4[0-35-9]|6[0-357-9]|7[0-25])|5(?:[1-59][0-46-9]|6[0-4689]|7[0-246-9])|6(?:0[1-9]|[13-59]\\d|[268][0-57-9]|7[0-79])|70[1-59]|84[0-39]|9(?:0[1-9]|1[02-9]|[2358][0-8]|[467]\\d))\\d{5}", [8]]], "00"], HN: ["504", "00", "8\\d{10}|[237-9]\\d{7}", [8, 11], [["(\\d{4})(\\d{4})", "$1-$2", ["[237-9]"]]], 0, 0, 0, 0, 0, 0, [0, ["[37-9]\\d{7}", [8]]]], HR: ["385", "00", "[2-69]\\d{8}|80\\d{5,7}|[1-79]\\d{7}|6\\d{6}", [7, 8, 9], [["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["6[01]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{4})(\\d{3})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["6|7[245]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-57]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [0, ["9(?:(?:0[1-9]|[12589]\\d)\\d\\d|7(?:[0679]\\d\\d|5(?:[01]\\d|44|55|77|9[5-79])))\\d{4}|98\\d{6}", [8, 9]]]], HT: ["509", "00", "[2-589]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["[2-589]"]]], 0, 0, 0, 0, 0, 0, [0, ["(?:[34]\\d|5[56])\\d{6}"]]], HU: ["36", "00", "[235-7]\\d{8}|[1-9]\\d{7}", [8, 9], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "(06 $1)"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6|8[2-57-9]|9[2-69]"], "(06 $1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-9]"], "06 $1"]], "06", 0, 0, 0, 0, 0, [0, ["(?:[257]0|3[01])\\d{7}", [9]]]], ID: ["62", "00[89]", "00[1-9]\\d{9,14}|(?:[1-36]|8\\d{5})\\d{6}|00\\d{9}|[1-9]\\d{8,10}|[2-9]\\d{7}", [7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["15"]], ["(\\d{2})(\\d{5,9})", "$1 $2", ["2[124]|[36]1"], "(0$1)"], ["(\\d{3})(\\d{5,7})", "$1 $2", ["800"], "0$1"], ["(\\d{3})(\\d{5,8})", "$1 $2", ["[2-79]"], "(0$1)"], ["(\\d{3})(\\d{3,4})(\\d{3})", "$1-$2-$3", ["8[1-35-9]"], "0$1"], ["(\\d{3})(\\d{6,8})", "$1 $2", ["1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["804"], "0$1"], ["(\\d{3})(\\d)(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["80"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1-$2-$3", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [0, ["8[1-35-9]\\d{7,10}", [9, 10, 11, 12]]]], IE: ["353", "00", "(?:1\\d|[2569])\\d{6,8}|4\\d{6,9}|7\\d{8}|8\\d{8,9}", [7, 8, 9, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["2[24-9]|47|58|6[237-9]|9[35-9]"], "(0$1)"], ["(\\d{3})(\\d{5})", "$1 $2", ["[45]0"], "(0$1)"], ["(\\d)(\\d{3,4})(\\d{4})", "$1 $2 $3", ["1"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2569]|4[1-69]|7[14]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["70"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["81"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[78]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["4"], "(0$1)"], ["(\\d{2})(\\d)(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [0, ["8(?:22|[35-9]\\d)\\d{6}", [9]]]], IL: ["972", "0(?:0|1[2-9])", "1\\d{6}(?:\\d{3,5})?|[57]\\d{8}|[1-489]\\d{7}", [7, 8, 9, 10, 11, 12], [["(\\d{4})(\\d{3})", "$1-$2", ["125"]], ["(\\d{4})(\\d{2})(\\d{2})", "$1-$2-$3", ["121"]], ["(\\d)(\\d{3})(\\d{4})", "$1-$2-$3", ["[2-489]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["[57]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1-$2-$3", ["12"]], ["(\\d{4})(\\d{6})", "$1-$2", ["159"]], ["(\\d)(\\d{3})(\\d{3})(\\d{3})", "$1-$2-$3-$4", ["1[7-9]"]], ["(\\d{3})(\\d{1,2})(\\d{3})(\\d{4})", "$1-$2 $3-$4", ["15"]]], "0", 0, 0, 0, 0, 0, [0, ["55(?:4(?:[01]0|5[0-5])|57[0-289])\\d{4}|5(?:(?:[0-2][02-9]|[36]\\d|[49][2-9]|8[3-7])\\d|5(?:01|2\\d|3[0-3]|4[34]|5[0-25689]|6[6-8]|7[0-267]|8[7-9]|9[1-9]))\\d{5}", [9]]]], IM: ["44", "00", "1624\\d{6}|(?:[3578]\\d|90)\\d{8}", [10], 0, "0", 0, "([25-8]\\d{5})$|0|180020", "1624$1", 0, "74576|(?:16|7[56])24", [0, ["76245[06]\\d{4}|7(?:4576|[59]24\\d|624[0-4689])\\d{5}"]]], IN: ["91", "00", "(?:000800|[2-9]\\d\\d)\\d{7}|1\\d{7,12}", [8, 9, 10, 11, 12, 13], [["(\\d{8})", "$1", ["5(?:0|2[23]|3[03]|[67]1|88)", "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|888)", "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|8888)"], 0, 1], ["(\\d{4})(\\d{4,5})", "$1 $2", ["180", "1800"], 0, 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["140"], 0, 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["11|2[02]|33|4[04]|79[1-7]|80[2-46]", "11|2[02]|33|4[04]|79(?:[1-6]|7[19])|80(?:[2-4]|6[0-589])", "11|2[02]|33|4[04]|79(?:[124-6]|3(?:[02-9]|1[0-24-9])|7(?:1|9[1-6]))|80(?:[2-4]|6[0-589])"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["1(?:2[0-249]|3[0-25]|4[145]|[68]|7[1257])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5[12]|[78]1)|6(?:12|[2-4]1|5[17]|6[13]|80)|7(?:12|3[134]|4[47]|61|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)|(?:43|59|75)[15]|(?:1[59]|29|67|72)[14]", "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|674|7(?:(?:2[14]|3[34]|5[15])[2-6]|61[346]|88[0-8])|8(?:70[2-6]|84[235-7]|91[3-7])|(?:1(?:29|60|8[06])|261|552|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))[2-7]", "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12(?:[2-6]|7[0-8])|74[2-7])|7(?:(?:2[14]|5[15])[2-6]|3171|61[346]|88(?:[2-7]|82))|8(?:70[2-6]|84(?:[2356]|7[19])|91(?:[3-6]|7[19]))|73[134][2-6]|(?:74[47]|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[2-6]|7[19])|(?:1(?:29|60|8[06])|261|552|6(?:[2-4]1|5[17]|6[13]|7(?:1|4[0189])|80)|7(?:12|88[01]))[2-7]"], "0$1", 1], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2[2457-9]|3[2-5]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1[013-9]|28|3[129]|4[1-35689]|5[29]|6[02-5]|70)|807", "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2(?:[2457]|84|95)|3(?:[2-4]|55)|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1(?:[013-8]|9[6-9])|28[6-8]|3(?:17|2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4|5[0-367])|70[13-7])|807[19]", "1(?:[2-479]|5(?:[0236-9]|5[013-9]))|[2-5]|6(?:2(?:84|95)|355|83)|73179|807(?:1|9[1-3])|(?:1552|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])\\d|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]))[2-7]"], "0$1", 1], ["(\\d{5})(\\d{5})", "$1 $2", ["[6-9]"], "0$1", 1], ["(\\d{4})(\\d{2,4})(\\d{4})", "$1 $2 $3", ["1(?:6|8[06])", "1(?:6|8[06]0)"], 0, 1], ["(\\d{4})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["18"], 0, 1]], "0", 0, 0, 0, 0, 0, [0, ["(?:61279|7(?:887[02-9]|9(?:313|79[07-9]))|8(?:079[04-9]|(?:84|91)7[02-8]))\\d{5}|(?:6(?:12|[2-47]1|5[17]|6[13]|80)[0189]|7(?:1(?:2[0189]|9[0-5])|2(?:[14][017-9]|8[0-59])|3(?:2[5-8]|[34][017-9]|9[016-9])|4(?:1[015-9]|[29][89]|39|8[389])|5(?:[15][017-9]|2[04-9]|9[7-9])|6(?:0[0-47]|1[0-257-9]|2[0-4]|3[19]|5[4589])|70[0289]|88[089]|97[02-8])|8(?:0(?:6[67]|7[02-8])|70[017-9]|84[01489]|91[0-289]))\\d{6}|(?:7(?:31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[0189]\\d|7[02-8])\\d{5}|(?:6(?:[09]\\d|1[04679]|2[03689]|3[05-9]|4[0489]|50|6[069]|7[07]|8[7-9])|7(?:0\\d|2[0235-79]|3[05-8]|40|5[0346-8]|6[6-9]|7[1-9]|8[0-79]|9[089])|8(?:0[01589]|1[0-57-9]|2[235-9]|3[03-57-9]|[45]\\d|6[02457-9]|7[1-69]|8[0-25-9]|9[02-9])|9\\d\\d)\\d{7}|(?:6(?:(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|8[124-6])\\d|7(?:[235689]\\d|4[0189]))|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-5])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]|881))[0189]\\d{5}", [10]]]], IO: ["246", "00", "3\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["3"]]], 0, 0, 0, 0, 0, 0, [0, ["38\\d{5}"]]], IQ: ["964", "00", "(?:1|7\\d\\d)\\d{7}|[2-6]\\d{7,8}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-6]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"]], "0", 0, 0, 0, 0, 0, [0, ["7[3-9]\\d{8}", [10]]]], IR: ["98", "00", "[1-9]\\d{9}|(?:[1-8]\\d\\d|9)\\d{3,4}", [4, 5, 6, 7, 10], [["(\\d{4,5})", "$1", ["96"], "0$1"], ["(\\d{2})(\\d{4,5})", "$1 $2", ["(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])[12689]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["[1-8]"], "0$1"]], "0", 0, 0, 0, 0, 0, [0, ["9(?:(?:0[0-5]|[13]\\d|2[0-3])\\d\\d|9(?:[0-46]\\d\\d|5(?:10|5\\d)|8(?:[12]\\d|88)|9(?:0[0-3]|[19]\\d|21|69|77|8[7-9])))\\d{5}", [10]]]], IS: ["354", "00|1(?:0(?:01|[12]0)|100)", "(?:38\\d|[4-9])\\d{6}", [7, 9], [["(\\d{3})(\\d{4})", "$1 $2", ["[4-9]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["3"]]], 0, 0, 0, 0, 0, 0, [0, ["(?:38[589]\\d\\d|6(?:1[1-8]|2[0-6]|3[026-9]|4[014679]|5[0159]|6[0-69]|70|8[06-8]|9\\d)|7(?:5[057]|[6-9]\\d)|8(?:2[0-59]|[3-69]\\d|8[238]))\\d{4}"]], "00"], IT: ["39", "00", "0\\d{5,10}|1\\d{8,10}|3(?:[0-8]\\d{7,10}|9\\d{7,8})|(?:43|55|70)\\d{8}|8\\d{5}(?:\\d{2,4})?", [6, 7, 8, 9, 10, 11, 12], [["(\\d{2})(\\d{4,6})", "$1 $2", ["0[26]"]], ["(\\d{3})(\\d{3,6})", "$1 $2", ["0[13-57-9][0159]|8(?:03|4[17]|9[2-5])", "0[13-57-9][0159]|8(?:03|4[17]|9(?:2|3[04]|[45][0-4]))"]], ["(\\d{4})(\\d{2,6})", "$1 $2", ["0(?:[13-579][2-46-8]|8[236-8])"]], ["(\\d{4})(\\d{4})", "$1 $2", ["894"]], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[26]|5"]], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["1(?:44|[679])|[378]|43"]], ["(\\d{3})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[13-57-9][0159]|14"]], ["(\\d{2})(\\d{4})(\\d{5})", "$1 $2 $3", ["0[26]"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["0"]], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["3"]]], 0, 0, 0, 0, 0, 0, [0, ["3[2-9]\\d{7,8}|(?:31|43)\\d{8}", [9, 10]]]], JE: ["44", "00", "1534\\d{6}|(?:[3578]\\d|90)\\d{8}", [10], 0, "0", 0, "([0-24-8]\\d{5})$|0|180020", "1534$1", 0, 0, [0, ["7(?:(?:(?:50|82)9|937)\\d|7(?:00[378]|97\\d))\\d{5}"]]], JM: ["1", "011", "(?:[58]\\d\\d|658|900)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "658|876", [0, ["(?:658295|876(?:2(?:0[1-9]|[13-9]\\d|2[013-9])|[348]\\d\\d|5(?:0[1-9]|[1-9]\\d)|6(?:4[89]|6[67])|7(?:0[07]|7\\d|8[1-47-9]|9[0-36-9])|9(?:[01]9|9[0579])))\\d{4}"]]], JO: ["962", "00", "(?:(?:[2689]|7\\d)\\d|32|53)\\d{6}", [8, 9], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2356]|87"], "(0$1)"], ["(\\d{3})(\\d{5,6})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["70"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["7"], "0$1"]], "0", 0, 0, 0, 0, 0, [0, ["7(?:[78][0-25-9]|9\\d)\\d{6}", [9]]]], JP: ["81", "010", "00[1-9]\\d{6,14}|[25-9]\\d{9}|(?:00|[1-9]\\d\\d)\\d{6}", [8, 9, 10, 11, 12, 13, 14, 15, 16, 17], [["(\\d{3})(\\d{3})(\\d{3})", "$1-$2-$3", ["(?:12|57|99)0"], "0$1"], ["(\\d{4})(\\d)(\\d{4})", "$1-$2-$3", ["1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|499|5(?:76|97)|746|8(?:3[89]|47|51)|9(?:80|9[16])", "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:76|97)9|7468|8(?:3(?:8[7-9]|96)|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]", "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:769|979[2-69])|7468|8(?:3(?:8[7-9]|96[2457-9])|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["60"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1-$2-$3", ["3|4(?:2[09]|7[01])|6[1-9]", "3|4(?:2(?:0|9[02-69])|7(?:0[019]|1))|6[1-9]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["1(?:1|5[45]|77|88|9[69])|2(?:2[1-37]|3[0-269]|4[59]|5|6[24]|7[1-358]|8[1369]|9[0-38])|4(?:[28][1-9]|3[0-57]|[45]|6[248]|7[2-579]|9[29])|5(?:2|3[0459]|4[0-369]|5[29]|8[02389]|9[0-389])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9[2-6])|8(?:2[124589]|3[26-9]|49|51|6|7[0-468]|8[68]|9[019])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9[1-489])", "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2(?:[127]|3[014-9])|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9[19])|62|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|8[1-9]|9[29])|5(?:2|3(?:[045]|9[0-8])|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0-2469])|3(?:[29]|60)|49|51|6(?:[0-24]|36|5[0-3589]|7[23]|9[01459])|7[0-468]|8[68])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3[34]|4[0178]))|(?:264|837)[016-9]|2(?:57|93)[015-9]|(?:25[0468]|422|838)[01]|(?:47[59]|59[89]|8(?:6[68]|9))[019]", "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3(?:[045]|9(?:[0-58]|6[4-9]|7[0-35689]))|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0169])|3(?:[29]|60|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[2-57-9]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|7(?:2[2-468]|3[78])|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:8294|96)[1-3]|2(?:57|93)[015-9]|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|8292|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{4})", "$1-$2-$3", ["[14]|[289][2-9]|5[3-9]|7[2-4679]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["800"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[25-9]"], "0$1"]], "0", 0, "(000[2569]\\d{4,6})$|(?:(?:003768)0?)|0", "$1", 0, 0, [0, ["(?:601[0-4]0|[7-9]0[1-9]\\d\\d)\\d{5}", [10]]]], KE: ["254", "000", "(?:[17]\\d\\d|900)\\d{6}|(?:2|80)0\\d{6,7}|[4-6]\\d{6,8}", [7, 8, 9, 10], [["(\\d{2})(\\d{5,7})", "$1 $2", ["[24-6]"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["[17]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[89]"], "0$1"]], "0", 0, 0, 0, 0, 0, [0, ["(?:1(?:0[0-8]|1[0-7]|2[014]|30)|7\\d\\d)\\d{6}", [9]]]], KG: ["996", "00", "8\\d{9}|[235-9]\\d{8}", [9, 10], [["(\\d{4})(\\d{5})", "$1 $2", ["3(?:1[346]|[24-79])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235-79]|88"], "0$1"], ["(\\d{3})(\\d{3})(\\d)(\\d{2,3})", "$1 $2 $3 $4", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [0, ["312(?:58\\d|973)\\d{3}|(?:2(?:0[0-35]|2\\d)|5[0-24-7]\\d|600|7(?:[07]\\d|55)|88[08]|9(?:12|9[05-9]))\\d{6}", [9]]]], KH: ["855", "00[14-9]", "1\\d{9}|[1-9]\\d{7,8}", [8, 9, 10], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-9]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0", 0, 0, 0, 0, 0, [0, ["(?:(?:1[28]|3[18]|9[67])\\d|6[016-9]|7(?:[07-9]|[16]\\d)|8(?:[013-79]|8\\d))\\d{6}|(?:1\\d|9[0-57-9])\\d{6}|(?:2[3-6]|3[2-6]|4[2-4]|[5-7][2-5])48\\d{5}", [8, 9]]]], KI: ["686", "00", "(?:[37]\\d|6[0-79])\\d{6}|(?:[2-48]\\d|50)\\d{3}", [5, 8], 0, "0", 0, 0, 0, 0, 0, [0, ["(?:6200[01]|7(?:310[1-9]|5(?:02[03-9]|12[0-47-9]|22[0-7]|[34](?:0[1-9]|8[02-9])|50[1-9])))\\d{3}|(?:63\\d\\d|7(?:(?:[0146-9]\\d|2[0-689])\\d|3(?:[02-9]\\d|1[1-9])|5(?:[0-2][013-9]|[34][1-79]|5[1-9]|[6-9]\\d)))\\d{4}", [8]]]], KM: ["269", "00", "[3478]\\d{6}", [7], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[3478]"]]], 0, 0, 0, 0, 0, 0, [0, ["[34]\\d{6}"]]], KN: ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-7]\\d{6})$|1", "869$1", 0, "869", [0, ["869(?:48[89]|55[6-8]|66\\d|76[02-7])\\d{4}"]]], KP: ["850", "00|99", "85\\d{6}|(?:19\\d|[2-7])\\d{7}", [8, 10], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-7]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"]], "0", 0, 0, 0, 0, 0, [0, ["19[1-3]\\d{7}", [10]]]], KR: ["82", "00(?:[125689]|3(?:[46]5|91)|7(?:00|27|3|55|6[126]))", "00[1-9]\\d{8,11}|(?:[12]|5\\d{3})\\d{7}|[13-6]\\d{9}|(?:[1-6]\\d|80)\\d{7}|[3-6]\\d{4,5}|(?:00|7)0\\d{8}", [5, 6, 8, 9, 10, 11, 12, 13, 14], [["(\\d{2})(\\d{3,4})", "$1-$2", ["(?:3[1-3]|[46][1-4]|5[1-5])1"], "0$1"], ["(\\d{4})(\\d{4})", "$1-$2", ["1"]], ["(\\d)(\\d{3,4})(\\d{4})", "$1-$2-$3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["[36]0|8"], "0$1"], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1-$2-$3", ["[1346]|5[1-5]"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[57]"], "0$1"], ["(\\d{2})(\\d{5})(\\d{4})", "$1-$2-$3", ["5"], "0$1"]], "0", 0, "0(8(?:[1-46-8]|5\\d\\d))?", 0, 0, 0, [0, ["1(?:05(?:[0-8]\\d|9[0-6])|22[13]\\d)\\d{4,5}|1(?:0[0-46-9]|[16-9]\\d|2[013-9])\\d{6,7}", [9, 10]]]], KW: ["965", "00", "18\\d{5}|(?:[2569]\\d|41)\\d{6}", [7, 8], [["(\\d{4})(\\d{3,4})", "$1 $2", ["[169]|2(?:[235]|4[1-35-9])|52"]], ["(\\d{3})(\\d{5})", "$1 $2", ["[245]"]]], 0, 0, 0, 0, 0, 0, [0, ["(?:41\\d\\d|5(?:(?:[05]\\d|1[0-7]|6[56])\\d|2(?:22|5[25])|7(?:55|77)|88[58])|6(?:(?:0[034679]|5[015-9]|6\\d)\\d|1(?:00|11|6[16])|2[26]2|3[36]3|4[46]4|7(?:0[013-9]|[67]\\d)|8[68]8|9(?:[069]\\d|3[039]))|9(?:(?:[04679]\\d|8[057-9])\\d|1(?:00|1[01]|99)|2(?:00|2\\d)|3(?:00|3[03])|5(?:00|5\\d)))\\d{4}", [8]]]], KY: ["1", "011", "(?:345|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "345$1", 0, "345", [0, ["345(?:32[1-9]|42[0-4]|5(?:1[67]|2[5-79]|4[6-9]|50|76)|649|82[56]|9(?:1[679]|2[2-9]|3[06-9]|90))\\d{4}"]]], KZ: ["7", "810", "(?:33622|8\\d{8})\\d{5}|[78]\\d{9}", [10, 14], 0, "8", 0, 0, 0, 0, "33622|7", [0, ["7(?:0[0-25-8]|47|6[0-4]|7[15-8]|85)\\d{7}", [10]]], "8~10"], LA: ["856", "00", "[23]\\d{9}|3\\d{8}|(?:[235-8]\\d|41)\\d{6}", [8, 9, 10], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["2[13]|3[14]|[4-8]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["3"], "0$1"], ["(\\d{2})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[23]"], "0$1"]], "0", 0, 0, 0, 0, 0, [0, ["(?:20(?:[23579]\\d|8[78])|30[24]\\d)\\d{6}|30\\d{7}", [9, 10]]]], LB: ["961", "00", "[27-9]\\d{7}|[13-9]\\d{6}", [7, 8], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[13-69]|7(?:[2-57]|62|8[0-6]|9[04-9])|8[02-9]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[27-9]"]]], "0", 0, 0, 0, 0, 0, [0, ["(?:(?:3|81)\\d|7(?:[01]\\d|6[013-9]|8[7-9]|9[1-3]))\\d{5}"]]], LC: ["1", "011", "(?:[58]\\d\\d|758|900)\\d{7}", [10], 0, "1", 0, "([2-8]\\d{6})$|1", "758$1", 0, "758", [0, ["758(?:28[4-7]|384|4(?:6[01]|8[4-9])|5(?:1[89]|20|84)|7(?:1[2-9]|2\\d|3[0-3])|812)\\d{4}"]]], LI: ["423", "00", "[68]\\d{8}|(?:[2378]\\d|90)\\d{5}", [7, 9], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[2379]|8(?:0[09]|7)", "[2379]|8(?:0(?:02|9)|7)"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["69"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]]], "0", 0, "(1001)|0", 0, 0, 0, [0, ["(?:6(?:(?:4[5-9]|5[0-46-9])\\d|6(?:[024-6]\\d|[17]0|3[7-9]))\\d|7(?:[37-9]\\d|42|56))\\d{4}"]]], LK: ["94", "00", "[1-9]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[1-689]"], "0$1"]], "0", 0, 0, 0, 0, 0, [0, ["7(?:[0-25-8]\\d|4[0-4])\\d{6}"]]], LR: ["231", "00", "(?:[2457]\\d|33|88)\\d{7}|(?:2\\d|[4-6])\\d{6}", [7, 8, 9], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["4[67]|[56]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-578]"], "0$1"]], "0", 0, 0, 0, 0, 0, [0, ["(?:(?:(?:22|33)0|555|7(?:6[01]|7\\d)|88\\d)\\d|4(?:240|[67]))\\d{5}|[56]\\d{6}", [7, 9]]]], LS: ["266", "00", "(?:[256]\\d\\d|800)\\d{5}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[2568]"]]], 0, 0, 0, 0, 0, 0, [0, ["[56]\\d{7}"]]], LT: ["370", "00", "(?:[3469]\\d|52|[78]0)\\d{6}", [8], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["52[0-7]"], "(0-$1)", 1], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[7-9]"], "0 $1", 1], ["(\\d{2})(\\d{6})", "$1 $2", ["37|4(?:[15]|6[1-8])"], "(0-$1)", 1], ["(\\d{3})(\\d{5})", "$1 $2", ["[3-6]"], "(0-$1)", 1]], "0", 0, "[08]", 0, 0, 0, [0, ["6\\d{7}"]]], LU: ["352", "00", "35[013-9]\\d{4,8}|6\\d{8}|35\\d{2,4}|(?:[2457-9]\\d|3[0-46-9])\\d{2,9}", [4, 5, 6, 7, 8, 9, 10, 11], [["(\\d{2})(\\d{3})", "$1 $2", ["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"]], ["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"]], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["20[2-689]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})", "$1 $2 $3 $4", ["2(?:[0367]|4[3-8])"]], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["80[01]|90[015]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["20"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})", "$1 $2 $3 $4 $5", ["2(?:[0367]|4[3-8])"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{1,5})", "$1 $2 $3 $4", ["[3-57]|8[13-9]|9(?:0[89]|[2-579])|(?:2|80)[2-9]"]]], 0, 0, "(15(?:0[06]|1[12]|[35]5|4[04]|6[26]|77|88|99)\\d)", 0, 0, 0, [0, ["6(?:[269][18]|5[1568]|7[189]|81)\\d{6}", [9]]]], LV: ["371", "00", "(?:[268]\\d|90)\\d{6}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[269]|8[01]"]]], 0, 0, 0, 0, 0, 0, [0, ["2333[0-8]\\d{3}|2(?:[0-24-9]\\d\\d|3(?:0[07]|[14-9]\\d|2[02-9]|3[0-24-9]))\\d{4}"]]], LY: ["218", "00", "[2-9]\\d{8}", [9], [["(\\d{2})(\\d{7})", "$1-$2", ["[2-9]"], "0$1"]], "0", 0, 0, 0, 0, 0, [0, ["9[1-6]\\d{7}"]]], MA: ["212", "00", "[5-8]\\d{8}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["5[45]"], "0$1"], ["(\\d{4})(\\d{5})", "$1-$2", ["5(?:2[2-46-9]|3[3-9]|9)|8(?:0[89]|92)"], "0$1"], ["(\\d{2})(\\d{7})", "$1-$2", ["8"], "0$1"], ["(\\d{3})(\\d{6})", "$1-$2", ["[5-7]"], "0$1"]], "0", 0, 0, 0, 0, 0, [0, ["(?:6(?:[0-79]\\d|8[0-247-9])|7(?:[0167]\\d|2[0-8]|5[0-5]|8[0-7]))\\d{6}"]]], MC: ["377", "00", "(?:[3489]|6\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["4"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[389]"]], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["6"], "0$1"]], "0", 0, 0, 0, 0, 0, [0, ["4(?:[469]\\d|5[1-9])\\d{5}|(?:3|6\\d)\\d{7}"]]], MD: ["373", "00", "(?:[235-7]\\d|[89]0)\\d{6}", [8], [["(\\d{3})(\\d{5})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["22|3"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[25-7]"], "0$1"]], "0", 0, 0, 0, 0, 0, [0, ["562\\d{5}|(?:6\\d|7[16-9])\\d{6}"]]], ME: ["382", "00", "(?:20|[3-79]\\d)\\d{6}|80\\d{6,7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-9]"], "0$1"]], "0", 0, 0, 0, 0, 0, [0, ["6(?:[07-9]\\d|3[024]|6[0-25])\\d{5}", [8]]]], MF: ["590", "00", "(?:590\\d|7090)\\d{5}|(?:69|80|9\\d)\\d{7}", [9], 0, "0", 0, 0, 0, 0, 0, [0, ["(?:69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))|7090[0-4])\\d{4}"]]], MG: ["261", "00", "[23]\\d{8}", [9], [["(\\d{2})(\\d{2})(\\d{3})(\\d{2})", "$1 $2 $3 $4", ["[23]"], "0$1"]], "0", 0, "([24-9]\\d{6})$|0", "20$1", 0, 0, [0, ["3[2-47-9]\\d{7}"]]], MH: ["692", "011", "329\\d{4}|(?:[256]\\d|45)\\d{5}", [7], [["(\\d{3})(\\d{4})", "$1-$2", ["[2-6]"]]], "1", 0, 0, 0, 0, 0, [0, ["(?:(?:23|54)5|329|45[35-8])\\d{4}"]]], MK: ["389", "00", "[2-578]\\d{7}", [8], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["2|34[47]|4(?:[37]7|5[47]|64)"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[347]"], "0$1"], ["(\\d{3})(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[58]"], "0$1"]], "0", 0, 0, 0, 0, 0, [0, ["7(?:3555|(?:474|9[019]7)7)\\d{3}|7(?:[0-25-8]\\d\\d|3(?:[1-478]\\d|6[01])|4(?:2\\d|60|7[01578])|9(?:[2-4]\\d|5[01]|7[015]))\\d{4}"]]], ML: ["223", "00", "[24-9]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24-9]"]]], 0, 0, 0, 0, 0, 0, [0, ["2(?:0(?:01|79)|17\\d)\\d{4}|(?:5[0-3]|[679]\\d|8[2-59])\\d{6}"]]], MM: ["95", "00", "1\\d{5,7}|95\\d{6}|(?:[4-7]|9[0-46-9])\\d{6,8}|(?:2|8\\d)\\d{5,8}", [6, 7, 8, 9, 10], [["(\\d)(\\d{2})(\\d{3})", "$1 $2 $3", ["16|2"], "0$1"], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["4(?:[2-46]|5[3-5])|5|6(?:[1-689]|7[235-7])|7(?:[0-4]|5[2-7])|8[1-5]|(?:60|86)[23]"], "0$1"], ["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[12]|452|678|86", "[12]|452|6788|86"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[4-7]|8[1-35]"], "0$1"], ["(\\d)(\\d{3})(\\d{4,6})", "$1 $2 $3", ["9(?:2[0-4]|[35-9]|4[137-9])"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["92"], "0$1"], ["(\\d)(\\d{5})(\\d{4})", "$1 $2 $3", ["9"], "0$1"]], "0", 0, 0, 0, 0, 0, [0, ["(?:17[01]|9(?:2(?:[0-4]|[56]\\d\\d)|(?:3(?:[0-36]|4\\d)|(?:6\\d|8[89]|9[4-8])\\d|7(?:3|40|[5-9]\\d))\\d|4(?:(?:[0245]\\d|[1379])\\d|88)|5[0-6])\\d)\\d{4}|9[69]1\\d{6}|9(?:[68]\\d|9[089])\\d{5}", [7, 8, 9, 10]]]], MN: ["976", "001", "[12]\\d{7,9}|[5-9]\\d{7}", [8, 9, 10], [["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["[12]1"], "0$1"], ["(\\d{4})(\\d{4})", "$1 $2", ["[5-9]"]], ["(\\d{3})(\\d{5,6})", "$1 $2", ["[12]2[1-3]"], "0$1"], ["(\\d{4})(\\d{5,6})", "$1 $2", ["[12](?:27|3[2-8]|4[2-68]|5[1-4689])", "[12](?:27|3[2-8]|4[2-68]|5[1-4689])[0-3]"], "0$1"], ["(\\d{5})(\\d{4,5})", "$1 $2", ["[12]"], "0$1"]], "0", 0, 0, 0, 0, 0, [0, ["92[0139]\\d{5}|(?:5[05]|6[069]|7[28]|8[0135689]|9[013-9])\\d{6}", [8]]]], MO: ["853", "00", "0800\\d{3}|(?:28|[68]\\d)\\d{6}", [7, 8], [["(\\d{4})(\\d{3})", "$1 $2", ["0"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[268]"]]], 0, 0, 0, 0, 0, 0, [0, ["6800[0-79]\\d{3}|6(?:[235]\\d\\d|6(?:0[0-5]|[1-9]\\d)|8(?:0[1-9]|[14-8]\\d|2[5-9]|[39][0-4]))\\d{4}", [8]]]], MP: ["1", "011", "[58]\\d{9}|(?:67|90)0\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "670$1", 0, "670", [0, ["670(?:2(?:3[3-7]|56|8[4-8])|32[1-38]|4(?:33|8[348])|5(?:32|55|88)|6(?:64|70|82)|78[3589]|8[3-9]8|989)\\d{4}"]]], MQ: ["596", "00", "(?:596\\d|7091)\\d{5}|(?:69|[89]\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-79]|8(?:0[6-9]|[36])"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [0, ["(?:69[67]\\d\\d|7091[0-3])\\d{4}"]]], MR: ["222", "00", "(?:[2-4]\\d\\d|800)\\d{5}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-48]"]]], 0, 0, 0, 0, 0, 0, [0, ["[2-4][0-46-9]\\d{6}"]]], MS: ["1", "011", "(?:[58]\\d\\d|664|900)\\d{7}", [10], 0, "1", 0, "([34]\\d{6})$|1", "664$1", 0, "664", [0, ["664(?:3(?:49|9[1-6])|49[2-6])\\d{4}"]]], MT: ["356", "00", "3550\\d{4}|(?:[2579]\\d\\d|800)\\d{5}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[2357-9]"]]], 0, 0, 0, 0, 0, 0, [0, ["(?:7(?:210|[79]\\d\\d)|9(?:[29]\\d\\d|69[67]|8(?:1[1-3]|89|97)))\\d{4}"]]], MU: ["230", "0(?:0|[24-7]0|3[03])", "(?:[57]|8\\d\\d)\\d{7}|[2-468]\\d{6}", [7, 8, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-46]|8[013]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[57]"]], ["(\\d{5})(\\d{5})", "$1 $2", ["8"]]], 0, 0, 0, 0, 0, 0, [0, ["5(?:4(?:2[1-389]|7[1-9])|87[15-8])\\d{4}|(?:5(?:2[5-9]|4[3-689]|[57]\\d|8[0-689]|9[0-8])|7(?:0[0-6]|3[013]))\\d{5}", [8]]], "020"], MV: ["960", "0(?:0|19)", "(?:800|9[0-57-9]\\d)\\d{7}|[34679]\\d{6}", [7, 10], [["(\\d{3})(\\d{4})", "$1-$2", ["[34679]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"]]], 0, 0, 0, 0, 0, 0, [0, ["(?:46[46]|[79]\\d\\d)\\d{4}", [7]]], "00"], MW: ["265", "00", "(?:[1289]\\d|31|77)\\d{7}|1\\d{6}", [7, 9], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["1[2-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[137-9]"], "0$1"]], "0", 0, 0, 0, 0, 0, [0, ["111\\d{6}|(?:31|77|[89][89])\\d{7}", [9]]]], MX: ["52", "0[09]", "[2-9]\\d{9}", [10], [["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["33|5[56]|81"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-9]"]]], 0, 0, 0, 0, 0, 0, [0, ["(?:2(?:2\\d|3[1-35-8]|4[13-9]|7[1-689]|8[1-578]|9[467])|3(?:1[1-79]|[2458][1-9]|3\\d|7[1-8]|9[1-5])|4(?:1[1-57-9]|[267][1-9]|3[1-8]|[45]\\d|8[1-35-9]|9[2-689])|5(?:[56]\\d|88|9[1-79])|6(?:1[2-68]|[2-4][1-9]|5[1-36-9]|6[0-57-9]|7[1-7]|8[67]|9[4-8])|7(?:[1346][1-9]|[27]\\d|5[13-9]|8[1-69]|9[17])|8(?:1\\d|2[13-689]|3[1-6]|4[124-6]|6[1246-9]|7[0-378]|9[12479])|9(?:1[346-9]|2[1-4]|3[2-46-8]|5[1348]|[69]\\d|7[12]|8[1-8]))\\d{7}"]], "00"], MY: ["60", "00", "1\\d{8,9}|(?:3\\d|[4-9])\\d{7}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1-$2 $3", ["[4-79]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1-$2 $3", ["1(?:[02469]|[378][1-9]|53)|8", "1(?:[02469]|[37][1-9]|53|8(?:[1-46-9]|5[7-9]))|8"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1-$2 $3", ["3"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{4})", "$1-$2-$3-$4", ["1(?:[367]|80)"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2 $3", ["15"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2 $3", ["1"], "0$1"]], "0", 0, 0, 0, 0, 0, [0, ["1(?:1888[689]|4400|8(?:47|8[27])[0-4])\\d{4}|1(?:0(?:[23568]\\d|4[0-6]|7[016-9]|9[0-8])|1(?:[1-5]\\d\\d|6(?:0[5-9]|[1-9]\\d)|7(?:[0-4]\\d|5[0-7]))|(?:[269]\\d|[37][1-9]|4[235-9])\\d|5(?:31|9\\d\\d)|8(?:1[23]|[236]\\d|4[06]|5(?:46|[7-9])|7[016-9]|8[01]|9[0-8]))\\d{5}", [9, 10]]]], MZ: ["258", "00", "(?:2|8\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2|8[2-79]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]]], 0, 0, 0, 0, 0, 0, [0, ["8[2-79]\\d{7}", [9]]]], NA: ["264", "00", "[68]\\d{7,8}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["88"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["6"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["87"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [0, ["(?:60|8[1245])\\d{7}", [9]]]], NC: ["687", "00", "(?:050|[2-57-9]\\d\\d)\\d{3}", [6], [["(\\d{2})(\\d{2})(\\d{2})", "$1.$2.$3", ["[02-57-9]"]]], 0, 0, 0, 0, 0, 0, [0, ["(?:[579]\\d|8[0-79])\\d{4}"]]], NE: ["227", "00", "[027-9]\\d{7}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["08"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[089]|2[013]|7[0467]"]]], 0, 0, 0, 0, 0, 0, [0, ["(?:23|7[0467]|[89]\\d)\\d{6}"]]], NF: ["672", "00", "[13]\\d{5}", [6], [["(\\d{2})(\\d{4})", "$1 $2", ["1[0-3]"]], ["(\\d)(\\d{5})", "$1 $2", ["[13]"]]], 0, 0, "([0-258]\\d{4})$", "3$1", 0, 0, [0, ["(?:14|3[58])\\d{4}"]]], NG: ["234", "009", "(?:20|9\\d)\\d{8}|[78]\\d{9,13}", [10, 11, 12, 13, 14], [["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[7-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["20[129]"], "0$1"], ["(\\d{4})(\\d{2})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["[78]"], "0$1"], ["(\\d{3})(\\d{5})(\\d{5,6})", "$1 $2 $3", ["[78]"], "0$1"]], "0", 0, 0, 0, 0, 0, [0, ["(?:702[0-24-9]|819[01])\\d{6}|(?:7(?:0[13-9]|[12]\\d)|8(?:0[1-9]|1[0-8])|9(?:0[1-9]|1[1-6]))\\d{7}", [10]]]], NI: ["505", "00", "(?:1800|[25-8]\\d{3})\\d{4}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[125-8]"]]], 0, 0, 0, 0, 0, 0, [0, ["(?:5(?:5[0-7]|[78]\\d)|6(?:20|3[035]|4[045]|5[05]|77|8[1-9]|9[059])|(?:7[5-8]|8\\d)\\d)\\d{5}"]]], NL: ["31", "00", "(?:[124-7]\\d\\d|3(?:[02-9]\\d|1[0-8]))\\d{6}|8\\d{6,9}|9\\d{6,10}|1\\d{4,5}", [5, 6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{4,7})", "$1 $2", ["[89]0"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["66"], "0$1"], ["(\\d)(\\d{8})", "$1 $2", ["6"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["1[16-8]|2[259]|3[124]|4[17-9]|5[124679]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-578]|91"], "0$1"], ["(\\d{3})(\\d{3})(\\d{5})", "$1 $2 $3", ["9"], "0$1"]], "0", 0, 0, 0, 0, 0, [0, ["(?:6[1-58]|970\\d)\\d{7}", [9, 11]]]], NO: ["47", "00", "(?:0|[2-9]\\d{3})\\d{4}", [5, 8], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["8"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-79]"]]], 0, 0, 0, 0, 0, "[02-689]|7[0-8]", [0, ["(?:4[015-8]|9\\d)\\d{6}", [8]]]], NP: ["977", "00", "(?:1\\d|9)\\d{9}|[1-9]\\d{7}", [8, 10, 11], [["(\\d)(\\d{7})", "$1-$2", ["1[2-6]"], "0$1"], ["(\\d{2})(\\d{6})", "$1-$2", ["1[01]|[2-8]|9(?:[1-59]|[67][2-6])"], "0$1"], ["(\\d{3})(\\d{7})", "$1-$2", ["9"]]], "0", 0, 0, 0, 0, 0, [0, ["9(?:00|6[0-3]|7[0-24-6]|8[0-24-68])\\d{7}", [10]]]], NR: ["674", "00", "(?:222|444|(?:55|8\\d)\\d|666|777|999)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[24-9]"]]], 0, 0, 0, 0, 0, 0, [0, ["(?:222|55[3-9]|666|777|8\\d\\d|999)\\d{4}"]]], NU: ["683", "00", "(?:[4-7]|888\\d)\\d{3}", [4, 7], [["(\\d{3})(\\d{4})", "$1 $2", ["8"]]], 0, 0, 0, 0, 0, 0, [0, ["(?:[56]|888[1-9])\\d{3}"]]], NZ: ["64", "0(?:0|161)", "[1289]\\d{9}|50\\d{5}(?:\\d{2,3})?|[27-9]\\d{7,8}|(?:[34]\\d|6[0-35-9])\\d{6}|8\\d{4,6}", [5, 6, 7, 8, 9, 10], [["(\\d{2})(\\d{3,8})", "$1 $2", ["8[1-79]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["50[036-8]|8|90", "50(?:[0367]|88)|8|90"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["24|[346]|7[2-57-9]|9[2-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2(?:10|74)|[589]"], "0$1"], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["1|2[028]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,5})", "$1 $2 $3", ["2(?:[169]|7[0-35-9])|7"], "0$1"]], "0", 0, 0, 0, 0, 0, [0, ["2(?:[0-27-9]\\d|6)\\d{6,7}|2(?:1\\d|75)\\d{5}", [8, 9, 10]]], "00"], OM: ["968", "00", "(?:1505|[279]\\d{3}|500)\\d{4}|800\\d{5,6}", [7, 8, 9], [["(\\d{3})(\\d{4,6})", "$1 $2", ["[58]"]], ["(\\d{2})(\\d{6})", "$1 $2", ["2"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[179]"]]], 0, 0, 0, 0, 0, 0, [0, ["1505\\d{4}|(?:7(?:[126-9]\\d|41)|9(?:0[1-9]|[1-9]\\d))\\d{5}", [8]]]], PA: ["507", "00", "(?:00800|8\\d{3})\\d{6}|[68]\\d{7}|[1-57-9]\\d{6}", [7, 8, 10, 11], [["(\\d{3})(\\d{4})", "$1-$2", ["[1-57-9]"]], ["(\\d{4})(\\d{4})", "$1-$2", ["[68]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]]], 0, 0, 0, 0, 0, 0, [0, ["(?:1[16]1|21[89]|6\\d{3}|8(?:1[01]|7[23]))\\d{4}", [7, 8]]]], PE: ["51", "00|19(?:1[124]|77|90)00", "(?:[14-8]|9\\d)\\d{7}", [8, 9], [["(\\d{3})(\\d{5})", "$1 $2", ["80"], "(0$1)"], ["(\\d)(\\d{7})", "$1 $2", ["1"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["[4-8]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"]]], "0", 0, 0, 0, 0, 0, [0, ["9\\d{8}", [9]]], "00", " Anexo "], PF: ["689", "00", "4\\d{5}(?:\\d{2})?|8\\d{7,8}", [6, 8, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["44"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["4|8[7-9]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]]], 0, 0, 0, 0, 0, 0, [0, ["8[7-9]\\d{6}", [8]]]], PG: ["675", "00|140[1-3]", "(?:180|[78]\\d{3})\\d{4}|(?:[2-589]\\d|64)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["18|[2-69]|85"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[78]"]]], 0, 0, 0, 0, 0, 0, [0, ["(?:7\\d|8[1-48])\\d{6}", [8]]], "00"], PH: ["63", "00", "(?:[2-7]|9\\d)\\d{8}|2\\d{5}|(?:1800|8)\\d{7,9}", [6, 8, 9, 10, 11, 12, 13], [["(\\d)(\\d{5})", "$1 $2", ["2"], "(0$1)"], ["(\\d{4})(\\d{4,6})", "$1 $2", ["3(?:23|39|46)|4(?:2[3-6]|[35]9|4[26]|76)|544|88[245]|(?:52|64|86)2", "3(?:230|397|461)|4(?:2(?:35|[46]4|51)|396|4(?:22|63)|59[347]|76[15])|5(?:221|446)|642[23]|8(?:622|8(?:[24]2|5[13]))"], "(0$1)"], ["(\\d{5})(\\d{4})", "$1 $2", ["346|4(?:27|9[35])|883", "3469|4(?:279|9(?:30|56))|8834"], "(0$1)"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[3-7]|8[2-8]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]], ["(\\d{4})(\\d{1,2})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["1"]]], "0", 0, 0, 0, 0, 0, [0, ["(?:8(?:1[37]|9[5-8])|9(?:0[5-9]|1[0-24-9]|[235-7]\\d|4[2-9]|8[135-9]|9[1-9]))\\d{7}", [10]]]], PK: ["92", "00", "122\\d{6}|[24-8]\\d{10,11}|9(?:[013-9]\\d{8,10}|2(?:[01]\\d\\d|2(?:[06-8]\\d|1[01]))\\d{7})|(?:[2-8]\\d{3}|92(?:[0-7]\\d|8[1-9]))\\d{6}|[24-9]\\d{8}|[89]\\d{7}", [8, 9, 10, 11, 12], [["(\\d{3})(\\d{3})(\\d{2,7})", "$1 $2 $3", ["[89]0"], "0$1"], ["(\\d{4})(\\d{5})", "$1 $2", ["1"]], ["(\\d{3})(\\d{6,7})", "$1 $2", ["2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8])", "9(?:2[3-8]|98)|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:22|3[27-9]|4[2-6]|6[3569]|9[25-7]))[2-9]"], "(0$1)"], ["(\\d{2})(\\d{7,8})", "$1 $2", ["(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]"], "(0$1)"], ["(\\d{5})(\\d{5})", "$1 $2", ["58"], "(0$1)"], ["(\\d{3})(\\d{7})", "$1 $2", ["3"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[24-9]"], "(0$1)"]], "0", 0, 0, 0, 0, 0, [0, ["3(?:[0-247]\\d|3[0-79]|55|64)\\d{7}", [10]]]], PL: ["48", "00", "(?:6|8\\d\\d)\\d{7}|[1-9]\\d{6}(?:\\d{2})?|[26]\\d{5}", [6, 7, 8, 9, 10], [["(\\d{5})", "$1", ["19"]], ["(\\d{3})(\\d{3})", "$1 $2", ["11|20|64"]], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])1", "(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])19"]], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["64"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["21|39|45|5[0137]|6[0469]|7[02389]|8(?:0[14]|8)"]], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[2-8]|[2-7]|8[1-79]|9[145]"]], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["8"]]], 0, 0, 0, 0, 0, 0, [0, ["2131[89]\\d{4}|21(?:1[013-5]|2\\d|3[2-9])\\d{5}|(?:45|5[0137]|6[069]|7[2389]|88)\\d{7}", [9]]]], PM: ["508", "00", "[45]\\d{5}|(?:708|8\\d\\d)\\d{6}", [6, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["[45]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["7"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [0, ["(?:4[02-489]|5[02-9]|708(?:4[0-5]|5[0-6]))\\d{4}"]]], PR: ["1", "011", "(?:[589]\\d\\d|787)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "787|939", [0, ["(?:787|939)[2-9]\\d{6}"]]], PS: ["970", "00", "[2489]2\\d{6}|(?:1\\d|5)\\d{8}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2489]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0", 0, 0, 0, 0, 0, [0, ["5[69]\\d{7}", [9]]]], PT: ["351", "00", "1693\\d{5}|(?:[26-9]\\d|30)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["2[12]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["16|[236-9]"]]], 0, 0, 0, 0, 0, 0, [0, ["6(?:[06]92(?:30|9\\d)|[35]92(?:[049]\\d|3[034]))\\d{3}|(?:(?:16|6[0356])93|9(?:[1-36]\\d\\d|480))\\d{5}"]]], PW: ["680", "01[12]", "(?:[24-8]\\d\\d|345|900)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]], 0, 0, 0, 0, 0, 0, [0, ["(?:(?:46|83)[0-5]|(?:6[2-4689]|78)0)\\d{4}|(?:45|77|88)\\d{5}"]]], PY: ["595", "00", "59\\d{4,6}|9\\d{5,10}|(?:[2-46-8]\\d|5[0-8])\\d{4,7}", [6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{3,6})", "$1 $2", ["[2-9]0"], "0$1"], ["(\\d{2})(\\d{5})", "$1 $2", ["[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36]"], "(0$1)"], ["(\\d{3})(\\d{4,5})", "$1 $2", ["2[279]|3[13-5]|4[359]|5|6(?:[34]|7[1-46-8])|7[46-8]|85"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2[14-68]|3[26-9]|4[1246-8]|6(?:1|75)|7[1-35]|8[1-36]"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["87"]], ["(\\d{3})(\\d{6})", "$1 $2", ["9(?:[5-79]|8[1-7])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-8]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["9"]]], "0", 0, 0, 0, 0, 0, [0, ["9(?:51|6[129]|7[1-6]|8[1-7]|9[1-5])\\d{6}", [9]]]], QA: ["974", "00", "800\\d{4}|(?:2|800)\\d{6}|(?:0080|[3-7])\\d{7}", [7, 8, 9, 11], [["(\\d{3})(\\d{4})", "$1 $2", ["2[136]|8"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[3-7]"]]], 0, 0, 0, 0, 0, 0, [0, ["[35-7]\\d{7}", [8]]]], RE: ["262", "00", "709\\d{6}|(?:26|[689]\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[26-9]"], "0$1"]], "0", 0, 0, 0, 0, 0, [0, ["(?:69(?:2\\d\\d|3(?:[06][0-6]|1[0-3]|2[0-2]|3[0-39]|4\\d|5[0-5]|7[0-37]|8[0-8]|9[0-479]))|7092[0-3])\\d{4}"]]], RO: ["40", "00", "(?:[236-8]\\d|90)\\d{7}|[23]\\d{5}", [6, 9], [["(\\d{3})(\\d{3})", "$1 $2", ["2[3-6]", "2[3-6]\\d9"], "0$1"], ["(\\d{2})(\\d{4})", "$1 $2", ["219|31"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[23]1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[236-9]"], "0$1"]], "0", 0, 0, 0, 0, 0, [0, ["(?:630|702)0\\d{5}|(?:6(?:00|2\\d)|7(?:0[013-9]|1[0-3]|[2-7]\\d|8[03-8]|9[0-39]))\\d{6}", [9]]], 0, " int "], RS: ["381", "00", "38[02-9]\\d{6,9}|6\\d{7,9}|90\\d{4,8}|38\\d{5,6}|(?:7\\d\\d|800)\\d{3,9}|(?:[12]\\d|3[0-79])\\d{5,10}", [6, 7, 8, 9, 10, 11, 12], [["(\\d{3})(\\d{3,9})", "$1 $2", ["(?:2[389]|39)0|[7-9]"], "0$1"], ["(\\d{2})(\\d{5,10})", "$1 $2", ["[1-36]"], "0$1"]], "0", 0, 0, 0, 0, 0, [0, ["6(?:[0-689]|7\\d)\\d{6,7}", [8, 9, 10]]]], RU: ["7", "810", "8\\d{13}|[347-9]\\d{9}", [10, 14], [["(\\d{4})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["7(?:1[0-8]|2[1-9])", "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:1[23]|[2-9]2))", "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:13[03-69]|62[013-9]))|72[1-57-9]2"], "8 ($1)", 1], ["(\\d{5})(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["7(?:1[0-68]|2[1-9])", "7(?:1(?:[06][3-6]|[18]|2[35]|[3-5][3-5])|2(?:[13][3-5]|[24-689]|7[457]))", "7(?:1(?:0(?:[356]|4[023])|[18]|2(?:3[013-9]|5)|3[45]|43[013-79]|5(?:3[1-8]|4[1-7]|5)|6(?:3[0-35-9]|[4-6]))|2(?:1(?:3[178]|[45])|[24-689]|3[35]|7[457]))|7(?:14|23)4[0-8]|71(?:33|45)[1-79]"], "8 ($1)", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "8 ($1)", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[349]|8(?:[02-7]|1[1-8])"], "8 ($1)", 1], ["(\\d{4})(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["8"], "8 ($1)"]], "8", 0, 0, 0, 0, 0, [0, ["9\\d{9}", [10]]], "8~10"], RW: ["250", "00", "(?:06|[27]\\d\\d|[89]00)\\d{6}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["0"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[7-9]"], "0$1"]], "0", 0, 0, 0, 0, 0, [0, ["7[237-9]\\d{7}", [9]]]], SA: ["966", "00", "(?:[15]\\d|800|92)\\d{7}", [9, 10], [["(\\d{4})(\\d{5})", "$1 $2", ["9"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]]], "0", 0, 0, 0, 0, 0, [0, ["579[01]\\d{5}|5(?:[013-689]\\d|7[0-8])\\d{6}", [9]]]], SB: ["677", "0[01]", "[6-9]\\d{6}|[1-6]\\d{4}", [5, 7], [["(\\d{2})(\\d{5})", "$1 $2", ["6[89]|7|8[4-9]|9(?:[1-8]|9[0-8])"]]], 0, 0, 0, 0, 0, 0, [0, ["48\\d{3}|(?:(?:6[89]|7[1-9]|8[4-9])\\d|9(?:1[2-9]|2[013-9]|3[0-2]|[46]\\d|5[0-46-9]|7[0-689]|8[0-79]|9[0-8]))\\d{4}"]]], SC: ["248", "010|0[0-2]", "(?:[2489]\\d|64)\\d{5}", [7], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[246]|9[57]"]]], 0, 0, 0, 0, 0, 0, [0, ["2[125-8]\\d{5}"]], "00"], SD: ["249", "00", "[19]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[19]"], "0$1"]], "0", 0, 0, 0, 0, 0, [0, ["(?:1[0-2]|9[0-3569])\\d{7}"]]], SE: ["46", "00", "(?:[26]\\d\\d|9)\\d{9}|[1-9]\\d{8}|[1-689]\\d{7}|[1-4689]\\d{6}|2\\d{5}", [6, 7, 8, 9, 10, 12], [["(\\d{2})(\\d{2,3})(\\d{2})", "$1-$2 $3", ["20"], "0$1", 0, "$1 $2 $3"], ["(\\d{3})(\\d{4})", "$1-$2", ["9(?:00|39|44|9)"], "0$1", 0, "$1 $2"], ["(\\d{2})(\\d{3})(\\d{2})", "$1-$2 $3", ["[12][136]|3[356]|4[0246]|6[03]|90[1-9]"], "0$1", 0, "$1 $2 $3"], ["(\\d)(\\d{2,3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["8"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2,3})(\\d{2})", "$1-$2 $3", ["1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[125689]|4[02-57]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"], "0$1", 0, "$1 $2 $3"], ["(\\d{3})(\\d{2,3})(\\d{3})", "$1-$2 $3", ["9(?:00|39|44)"], "0$1", 0, "$1 $2 $3"], ["(\\d{2})(\\d{2,3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["1[13689]|2[0136]|3[1356]|4[0246]|54|6[03]|90[1-9]"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["10|7"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d)(\\d{3})(\\d{3})(\\d{2})", "$1-$2 $3 $4", ["8"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["[13-5]|2(?:[247-9]|5[0138])|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{3})", "$1-$2 $3 $4", ["9"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1-$2 $3 $4 $5", ["[26]"], "0$1", 0, "$1 $2 $3 $4 $5"]], "0", 0, 0, 0, 0, 0, [0, ["7[02369]\\d{7}", [9]]]], SG: ["65", "0[0-3]\\d", "(?:(?:1\\d|8)\\d\\d|7000)\\d{7}|[3689]\\d{7}", [8, 10, 11], [["(\\d{4})(\\d{4})", "$1 $2", ["[369]|8(?:0[1-9]|[1-9])"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]], ["(\\d{4})(\\d{4})(\\d{3})", "$1 $2 $3", ["7"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]]], 0, 0, 0, 0, 0, 0, [0, ["89(?:7[0-689]|80)\\d{4}|(?:8(?:0[1-9]|[1-8]\\d|9[0-6])|9[0-8]\\d)\\d{5}", [8]]]], SH: ["290", "00", "(?:[256]\\d|8)\\d{3}", [4, 5], 0, 0, 0, 0, 0, 0, "[256]", [0, ["[56]\\d{4}", [5]]]], SI: ["386", "00|10(?:22|66|88|99)", "[1-7]\\d{7}|8\\d{4,7}|90\\d{4,6}", [5, 6, 7, 8], [["(\\d{2})(\\d{3,6})", "$1 $2", ["8[09]|9"], "0$1"], ["(\\d{3})(\\d{5})", "$1 $2", ["59|8"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[37][01]|4[0139]|51|6"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[1-57]"], "(0$1)"]], "0", 0, 0, 0, 0, 0, [0, ["65(?:[178]\\d|5[56]|6[01])\\d{4}|(?:[37][01]|4[0139]|51|6[489])\\d{6}", [8]]], "00"], SJ: ["47", "00", "0\\d{4}|(?:[489]\\d|79)\\d{6}", [5, 8], 0, 0, 0, 0, 0, 0, "79", [0, ["(?:4[015-8]|9\\d)\\d{6}", [8]]]], SK: ["421", "00", "[2-689]\\d{8}|[2-59]\\d{6}|[2-5]\\d{5}", [6, 7, 9], [["(\\d)(\\d{2})(\\d{3,4})", "$1 $2 $3", ["21"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["[3-5][1-8]1", "[3-5][1-8]1[67]"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{2})", "$1/$2 $3 $4", ["2"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[689]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1/$2 $3 $4", ["[3-5]"], "0$1"]], "0", 0, 0, 0, 0, 0, [0, ["909[1-9]\\d{5}|9(?:0[1-8]|1[0-24-9]|4[03-57-9]|5\\d)\\d{6}", [9]]]], SL: ["232", "00", "(?:[237-9]\\d|66)\\d{6}", [8], [["(\\d{2})(\\d{6})", "$1 $2", ["[236-9]"], "(0$1)"]], "0", 0, 0, 0, 0, 0, [0, ["(?:25|3[0-5]|66|7[1-9]|8[08]|9[09])\\d{6}"]]], SM: ["378", "00", "(?:0549|[5-7]\\d)\\d{6}", [8, 10], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-7]"]], ["(\\d{4})(\\d{6})", "$1 $2", ["0"]]], 0, 0, "([89]\\d{5})$", "0549$1", 0, 0, [0, ["6[16]\\d{6}", [8]]]], SN: ["221", "00", "(?:[378]\\d|93)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[379]"]]], 0, 0, 0, 0, 0, 0, [0, ["7(?:(?:[06-8]\\d|[19]0|21)\\d|5(?:0[01]|[19]0|2[25]|3[356]|[4-7]\\d|8[35]))\\d{5}"]]], SO: ["252", "00", "[346-9]\\d{8}|[12679]\\d{7}|[1-5]\\d{6}|[1348]\\d{5}", [6, 7, 8, 9], [["(\\d{2})(\\d{4})", "$1 $2", ["8[125]"]], ["(\\d{6})", "$1", ["[134]"]], ["(\\d)(\\d{6})", "$1 $2", ["[15]|2[0-79]|3[0-46-8]|4[0-7]"]], ["(\\d)(\\d{7})", "$1 $2", ["(?:2|90)4|[67]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[348]|64|79|90"]], ["(\\d{2})(\\d{5,7})", "$1 $2", ["1|28|6[0-35-9]|7[67]|9[2-9]"]]], "0", 0, 0, 0, 0, 0, [0, ["(?:(?:15|(?:3[59]|4[89]|6\\d|7[679]|8[08])\\d|9(?:0\\d|[2-9]))\\d|2(?:4\\d|8))\\d{5}|(?:[67]\\d\\d|904)\\d{5}", [7, 8, 9]]]], SR: ["597", "00", "(?:[2-5]|68|[78]\\d|90)\\d{5}", [6, 7], [["(\\d{2})(\\d{2})(\\d{2})", "$1-$2-$3", ["56"]], ["(\\d{3})(\\d{3})", "$1-$2", ["[2-5]"]], ["(\\d{3})(\\d{4})", "$1-$2", ["[6-9]"]]], 0, 0, 0, 0, 0, 0, [0, ["(?:7[124-7]|8[1-9])\\d{5}", [7]]]], SS: ["211", "00", "[19]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[19]"], "0$1"]], "0", 0, 0, 0, 0, 0, [0, ["(?:12|9[1257-9])\\d{7}"]]], ST: ["239", "00", "(?:22|9\\d)\\d{5}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[29]"]]], 0, 0, 0, 0, 0, 0, [0, ["900[5-9]\\d{3}|9(?:0[1-9]|[89]\\d)\\d{4}"]]], SV: ["503", "00", "[267]\\d{7}|(?:80\\d|900)\\d{4}(?:\\d{4})?", [7, 8, 11], [["(\\d{3})(\\d{4})", "$1 $2", ["[89]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[267]"]], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["[89]"]]], 0, 0, 0, 0, 0, 0, [0, ["[67]\\d{7}", [8]]]], SX: ["1", "011", "7215\\d{6}|(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "(5\\d{6})$|1", "721$1", 0, "721", [0, ["7215(?:1[02]|2\\d|5[034679]|8[014-8])\\d{4}"]]], SY: ["963", "00", "[1-359]\\d{8}|[1-5]\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-4]|5[1-3]"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[59]"], "0$1", 1]], "0", 0, 0, 0, 0, 0, [0, ["(?:50|9[1-9])\\d{7}", [9]]]], SZ: ["268", "00", "0800\\d{4}|(?:[237]\\d|900)\\d{6}", [8, 9], [["(\\d{4})(\\d{4})", "$1 $2", ["[0237]"]], ["(\\d{5})(\\d{4})", "$1 $2", ["9"]]], 0, 0, 0, 0, 0, 0, [0, ["7[5-9]\\d{6}", [8]]]], TA: ["290", "00", "8\\d{3}", [4], 0, 0, 0, 0, 0, 0, "8"], TC: ["1", "011", "(?:[58]\\d\\d|649|900)\\d{7}", [10], 0, "1", 0, "([2-479]\\d{6})$|1", "649$1", 0, "649", [0, ["649(?:2(?:3[129]|4[1-79])|3\\d\\d|4[34][1-3])\\d{4}"]]], TD: ["235", "00|16", "(?:22|30|[689]\\d|77)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[236-9]"]]], 0, 0, 0, 0, 0, 0, [0, ["(?:30|[69]\\d|77|8[56])\\d{6}"]], "00"], TG: ["228", "00", "[279]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[279]"]]], 0, 0, 0, 0, 0, 0, [0, ["(?:7[0-29]|9[0-36-9])\\d{6}"]]], TH: ["66", "00[1-9]", "(?:001800|[2-57]|[689]\\d)\\d{7}|1\\d{7,9}", [8, 9, 10, 13], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[13-9]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0", 0, 0, 0, 0, 0, [0, ["67(?:1[0-8]|2[4-7])\\d{5}|(?:14|6[1-6]|[89]\\d)\\d{7}", [9]]]], TJ: ["992", "810", "[0-57-9]\\d{8}", [9], [["(\\d{6})(\\d)(\\d{2})", "$1 $2 $3", ["331", "3317"]], ["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["44[02-479]|[34]7"]], ["(\\d{4})(\\d)(\\d{4})", "$1 $2 $3", ["3(?:[1245]|3[12])"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[0-57-9]"]]], 0, 0, 0, 0, 0, 0, [0, ["(?:33[03-9]|4(?:1[18]|4[02-479])|81[1-9])\\d{6}|(?:[09]\\d|1[0-27-9]|2[0-27]|[34]0|5[05]|7[01578]|8[078])\\d{7}"]], "8~10"], TK: ["690", "00", "[2-47]\\d{3,6}", [4, 5, 6, 7], 0, 0, 0, 0, 0, 0, 0, [0, ["7[2-4]\\d{2,5}"]]], TL: ["670", "00", "7\\d{7}|(?:[2-47]\\d|[89]0)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-489]|70"]], ["(\\d{4})(\\d{4})", "$1 $2", ["7"]]], 0, 0, 0, 0, 0, 0, [0, ["7[2-8]\\d{6}", [8]]]], TM: ["993", "810", "(?:[1-6]\\d|71)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["12"], "(8 $1)"], ["(\\d{3})(\\d)(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[1-5]"], "(8 $1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["[67]"], "8 $1"]], "8", 0, 0, 0, 0, 0, [0, ["(?:6\\d|71)\\d{6}"]], "8~10"], TN: ["216", "00", "[2-57-9]\\d{7}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-57-9]"]]], 0, 0, 0, 0, 0, 0, [0, ["3(?:001|[12]40)\\d{4}|(?:(?:[259]\\d|4[0-8])\\d|3(?:1[1-35]|6[0-4]|91))\\d{5}"]]], TO: ["676", "00", "(?:0800|(?:[5-8]\\d\\d|999)\\d)\\d{3}|[2-8]\\d{4}", [5, 7], [["(\\d{2})(\\d{3})", "$1-$2", ["[2-4]|50|6[09]|7[0-24-69]|8[05]"]], ["(\\d{4})(\\d{3})", "$1 $2", ["0"]], ["(\\d{3})(\\d{4})", "$1 $2", ["[5-9]"]]], 0, 0, 0, 0, 0, 0, [0, ["(?:5(?:4[0-5]|5[4-6])|6(?:[09]\\d|3[02]|8[15-9])|(?:7\\d|8[46-9])\\d|999)\\d{4}", [7]]]], TR: ["90", "00", "4\\d{6}|8\\d{11,12}|(?:[2-58]\\d\\d|900)\\d{7}", [7, 10, 12, 13], [["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["512|8[01589]|90"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["5(?:[0-59]|61)", "5(?:[0-59]|61[06])", "5(?:[0-59]|61[06]1)"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24][1-8]|3[1-9]"], "(0$1)", 1], ["(\\d{3})(\\d{3})(\\d{6,7})", "$1 $2 $3", ["80"], "0$1", 1]], "0", 0, 0, 0, 0, 0, [0, ["561(?:011|61\\d)\\d{4}|5(?:0[15-7]|1[06]|24|[34]\\d|5[1-59]|9[46])\\d{7}", [10]]]], TT: ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-46-8]\\d{6})$|1", "868$1", 0, "868", [0, ["868(?:(?:2[5-9]|3\\d)\\d|4(?:3[0-6]|[6-9]\\d)|6(?:20|78|8\\d)|7(?:0[1-9]|1[02-9]|[2-9]\\d))\\d{4}"]]], TV: ["688", "00", "(?:2|7\\d\\d|90)\\d{4}", [5, 6, 7], [["(\\d{2})(\\d{3})", "$1 $2", ["2"]], ["(\\d{2})(\\d{4})", "$1 $2", ["90"]], ["(\\d{2})(\\d{5})", "$1 $2", ["7"]]], 0, 0, 0, 0, 0, 0, [0, ["(?:7[01]\\d|90)\\d{4}", [6, 7]]]], TW: ["886", "0(?:0[25-79]|19)", "[2-689]\\d{8}|7\\d{9,10}|[2-8]\\d{7}|2\\d{6}", [7, 8, 9, 10, 11], [["(\\d{2})(\\d)(\\d{4})", "$1 $2 $3", ["202"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[258]0"], "0$1"], ["(\\d)(\\d{3,4})(\\d{4})", "$1 $2 $3", ["[23568]|4(?:0[02-48]|[1-47-9])|7[1-9]", "[23568]|4(?:0[2-48]|[1-47-9])|(?:400|7)[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[49]"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["7"], "0$1"]], "0", 0, 0, 0, 0, 0, [0, ["(?:40001[0-2]|9[0-8]\\d{4})\\d{3}", [9]]], 0, "#"], TZ: ["255", "00[056]", "(?:[25-8]\\d|41|90)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[24]"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["5"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[67]"], "0$1"]], "0", 0, 0, 0, 0, 0, [0, ["(?:6[125-9]|7[13-9])\\d{7}"]]], UA: ["380", "00", "[89]\\d{9}|[3-9]\\d{8}", [9, 10], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6[12][29]|(?:3[1-8]|4[136-8]|5[12457]|6[49])2|(?:56|65)[24]", "6[12][29]|(?:35|4[1378]|5[12457]|6[49])2|(?:56|65)[24]|(?:3[1-46-8]|46)2[013-9]"], "0$1"], ["(\\d{4})(\\d{5})", "$1 $2", ["3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6[0135689]|7[4-6])|6(?:[12][3-7]|[459])", "3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6(?:[015689]|3[02389])|7[4-6])|6(?:[12][3-7]|[459])"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[3-7]|89|9[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[89]"], "0$1"]], "0", 0, 0, 0, 0, 0, [0, ["790\\d{6}|(?:39|50|6[36-8]|7[1-357]|9[1-9])\\d{7}", [9]]], "0~0"], UG: ["256", "00[057]", "800\\d{6}|(?:[29]0|[347]\\d)\\d{7}", [9], [["(\\d{4})(\\d{5})", "$1 $2", ["202", "2024"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["[27-9]|4(?:6[45]|[7-9])"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["[34]"], "0$1"]], "0", 0, 0, 0, 0, 0, [0, ["72[48]0\\d{5}|7(?:[014-8]\\d|2[067]|36|9[0189])\\d{6}"]]], US: ["1", "011", "[2-9]\\d{9}|3\\d{6}", [10], [["(\\d{3})(\\d{4})", "$1-$2", ["310"], 0, 1], ["(\\d{3})(\\d{3})(\\d{4})", "($1) $2-$3", ["[2-9]"], 0, 1, "$1-$2-$3"]], "1", 0, 0, 0, 0, 0, [0, ["(?:3052(?:0[0-8]|[1-9]\\d)|5056(?:[0-35-9]\\d|4[0-68]))\\d{4}|(?:2742|305[3-9]|(?:472|983)[2-47-9]|505[2-57-9])\\d{6}|(?:2(?:0[1-35-9]|1[02-9]|2[03-57-9]|3[1459]|4[08]|5[1-46]|6[0279]|7[0269]|8[13])|3(?:0[1-47-9]|1[02-9]|2[0135-79]|3[0-24679]|4[167]|5[0-2]|6[01349]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[023578]|58|6[349]|7[0589]|8[04])|5(?:0[1-47-9]|1[0235-8]|20|3[0149]|4[01]|5[179]|6[1-47]|7[0-5]|8[0256])|6(?:0[1-35-9]|1[024-9]|2[03689]|3[016]|4[0156]|5[01679]|6[0-279]|78|8[0-29])|7(?:0[1-46-8]|1[2-9]|2[04-8]|3[0-247]|4[0378]|5[47]|6[02359]|7[0-59]|8[156])|8(?:0[1-68]|1[02-8]|2[0168]|3[0-2589]|4[03578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[01357-9]|5[12469]|7[0-3589]|8[04-69]))[2-9]\\d{6}"]]], UY: ["598", "0(?:0|1[3-9]\\d)", "0004\\d{2,9}|[1249]\\d{7}|(?:[49]\\d|80)\\d{5}", [6, 7, 8, 9, 10, 11, 12, 13], [["(\\d{3})(\\d{3,4})", "$1 $2", ["0"]], ["(\\d{3})(\\d{4})", "$1 $2", ["[49]0|8"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{4})(\\d{4})", "$1 $2", ["[124]"]], ["(\\d{3})(\\d{3})(\\d{2,4})", "$1 $2 $3", ["0"]], ["(\\d{3})(\\d{3})(\\d{3})(\\d{2,4})", "$1 $2 $3 $4", ["0"]]], "0", 0, 0, 0, 0, 0, [0, ["9[1-9]\\d{6}", [8]]], "00", " int. "], UZ: ["998", "00", "(?:20|33|[5-9]\\d)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[235-9]"]]], 0, 0, 0, 0, 0, 0, [0, ["(?:(?:[25]0|33|8[78]|9[0-57-9])\\d{3}|6(?:1(?:2(?:2[01]|98)|35[0-4]|50\\d|61[23]|7(?:[01][017]|4\\d|55|9[5-9]))|2(?:(?:11|7\\d)\\d|2(?:[12]1|9[01379])|5(?:[126]\\d|3[0-4]))|5(?:19[01]|2(?:27|9[26])|(?:30|59|7\\d)\\d)|6(?:2(?:1[5-9]|2[0367]|38|41|52|60)|(?:3[79]|9[0-3])\\d|4(?:56|83)|7(?:[07]\\d|1[017]|3[07]|4[047]|5[057]|67|8[0178]|9[79]))|7(?:2(?:24|3[237]|4[5-9]|7[15-8])|5(?:7[12]|8[0589])|7(?:0\\d|[39][07])|9(?:0\\d|7[079])))|7(?:[07]\\d{3}|2(?:2(?:2[79]|95)|3(?:2[5-9]|6[0-6])|57\\d|7(?:0\\d|1[17]|2[27]|3[37]|44|5[057]|66|88))|3(?:2(?:1[0-6]|21|3[469]|7[159])|(?:33|9[4-6])\\d|5(?:0[0-4]|5[579]|9\\d)|7(?:[0-3579]\\d|4[0467]|6[67]|8[078]))|4(?:2(?:29|5[0257]|6[0-7]|7[1-57])|5(?:1[0-4]|8\\d|9[5-9])|7(?:0\\d|1[024589]|2[0-27]|3[0137]|[46][07]|5[01]|7[5-9]|9[079])|9(?:7[015-9]|[89]\\d))|5(?:112|2(?:0\\d|2[29]|[49]4)|3[1568]\\d|52[6-9]|7(?:0[01578]|1[017]|[23]7|4[047]|[5-7]\\d|8[78]|9[079]))|9(?:22[128]|3(?:2[0-4]|7\\d)|57[02569]|7(?:2[05-9]|3[37]|4\\d|60|7[2579]|87|9[07]))))\\d{4}"]]], VA: ["39", "00", "0\\d{5,10}|3[0-8]\\d{7,10}|55\\d{8}|8\\d{5}(?:\\d{2,4})?|(?:1\\d|39)\\d{7,8}", [6, 7, 8, 9, 10, 11, 12], 0, 0, 0, 0, 0, 0, "06698", [0, ["3[1-9]\\d{8}|3[2-9]\\d{7}", [9, 10]]]], VC: ["1", "011", "(?:[58]\\d\\d|784|900)\\d{7}", [10], 0, "1", 0, "([2-7]\\d{6})$|1", "784$1", 0, "784", [0, ["784(?:4(?:3[0-5]|5[45]|89|9[0-8])|5(?:2[6-9]|3[0-4])|720)\\d{4}"]]], VE: ["58", "00", "[68]00\\d{7}|(?:[24]\\d|[59]0)\\d{8}", [10], [["(\\d{3})(\\d{7})", "$1-$2", ["[24-689]"], "0$1"]], "0", 0, 0, 0, 0, 0, [0, ["4(?:1[24-8]|2[246])\\d{7}"]]], VG: ["1", "011", "(?:284|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-578]\\d{6})$|1", "284$1", 0, "284", [0, ["284(?:245|3(?:0[0-3]|4[0-7]|68|9[34])|4(?:4[0-6]|68|9[69])|5(?:4[0-7]|68|9[69]))\\d{4}"]]], VI: ["1", "011", "[58]\\d{9}|(?:34|90)0\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "340$1", 0, "340", [0, ["340(?:2(?:0\\d|10|2[06-8]|4[49]|77)|3(?:32|44)|4(?:2[23]|44|7[34]|89)|5(?:1[34]|55)|6(?:2[56]|4[23]|77|9[023])|7(?:1[2-57-9]|2[57]|7\\d)|884|998)\\d{4}"]]], VN: ["84", "00", "[12]\\d{9}|[135-9]\\d{8}|[16]\\d{7}|[16-8]\\d{6}", [7, 8, 9, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["80"], "0$1", 1], ["(\\d{4})(\\d{4,6})", "$1 $2", ["1"], 0, 1], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["6"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[357-9]"], "0$1", 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["2[48]"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{3})", "$1 $2 $3", ["2"], "0$1", 1]], "0", 0, 0, 0, 0, 0, [0, ["(?:5(?:2[238]|59)|89[6-9]|99[013-9])\\d{6}|(?:3\\d|5[1689]|7[06-9]|8[1-8]|9[0-8])\\d{7}", [9]]]], VU: ["678", "00", "[57-9]\\d{6}|(?:[238]\\d|48)\\d{3}", [5, 7], [["(\\d{3})(\\d{4})", "$1 $2", ["[57-9]"]]], 0, 0, 0, 0, 0, 0, [0, ["(?:[58]\\d|7[013-7])\\d{5}", [7]]]], WF: ["681", "00", "(?:40|72|8\\d{4})\\d{4}|[89]\\d{5}", [6, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["[47-9]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]]], 0, 0, 0, 0, 0, 0, [0, ["(?:72|8[23])\\d{4}", [6]]]], WS: ["685", "0", "(?:[2-6]|8\\d{5})\\d{4}|[78]\\d{6}|[68]\\d{5}", [5, 6, 7, 10], [["(\\d{5})", "$1", ["[2-5]|6[1-9]"]], ["(\\d{3})(\\d{3,7})", "$1 $2", ["[68]"]], ["(\\d{2})(\\d{5})", "$1 $2", ["7"]]], 0, 0, 0, 0, 0, 0, [0, ["(?:7[1-35-8]|8(?:[3-7]|9\\d{3}))\\d{5}", [7, 10]]]], XK: ["383", "00", "2\\d{7,8}|3\\d{7,11}|(?:4\\d\\d|[89]00)\\d{5}", [8, 9, 10, 11, 12], [["(\\d{3})(\\d{5})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-4]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2|39"], "0$1"], ["(\\d{2})(\\d{7,10})", "$1 $2", ["3"], "0$1"]], "0", 0, 0, 0, 0, 0, [0, ["4[3-9]\\d{6}", [8]]]], YE: ["967", "00", "(?:1|7\\d)\\d{7}|[1-7]\\d{6}", [7, 8, 9], [["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-6]|7(?:[24-6]|8[0-7])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["7"], "0$1"]], "0", 0, 0, 0, 0, 0, [0, ["7[01378]\\d{7}", [9]]]], YT: ["262", "00", "7093\\d{5}|(?:80|9\\d)\\d{7}|(?:26|63)9\\d{6}", [9], 0, "0", 0, 0, 0, 0, 0, [0, ["(?:639(?:0[0-79]|1[019]|[267]\\d|3[09]|40|5[05-9]|9[04-79])|7093[5-7])\\d{4}"]]], ZA: ["27", "00", "[1-79]\\d{8}|8\\d{4,9}", [5, 6, 7, 8, 9, 10], [["(\\d{2})(\\d{3,4})", "$1 $2", ["8[1-4]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["8[1-4]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["860"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [0, ["(?:1(?:3492[0-25]|4495[0235]|549(?:20|5[01]))|4[34]492[01])\\d{3}|8[1-4]\\d{3,7}|(?:2[27]|47|54)4950\\d{3}|(?:1(?:049[2-4]|9[12]\\d\\d)|(?:50[0-2]|6\\d\\d|7(?:[0-46-9]\\d|5[0-4]))\\d\\d|8(?:5\\d{3}|7(?:08[67]|158|28[5-9]|310)))\\d{4}|(?:1[6-8]|28|3[2-69]|4[025689]|5[36-8])4920\\d{3}|(?:12|[2-5]1)492\\d{4}", [5, 6, 7, 8, 9]]]], ZM: ["260", "00", "800\\d{6}|(?:21|[579]\\d|63)\\d{7}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[28]"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["[579]"], "0$1"]], "0", 0, 0, 0, 0, 0, [0, ["(?:[59][5-8]|7[5-9])\\d{7}"]]], ZW: ["263", "00", "2(?:[0-57-9]\\d{6,8}|6[0-24-9]\\d{6,7})|[38]\\d{9}|[35-8]\\d{8}|[3-6]\\d{7}|[1-689]\\d{6}|[1-3569]\\d{5}|[1356]\\d{4}", [5, 6, 7, 8, 9, 10], [["(\\d{3})(\\d{3,5})", "$1 $2", ["2(?:0[45]|2[278]|[49]8)|3(?:[09]8|17)|6(?:[29]8|37|75)|[23][78]|(?:33|5[15]|6[68])[78]"], "0$1"], ["(\\d)(\\d{3})(\\d{2,4})", "$1 $2 $3", ["[49]"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["80"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["24|8[13-59]|(?:2[05-79]|39|5[45]|6[15-8])2", "2(?:02[014]|4|[56]20|[79]2)|392|5(?:42|525)|6(?:[16-8]21|52[013])|8[13-59]"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2(?:1[39]|2[0157]|[378]|[56][14])|3(?:12|29)", "2(?:1[39]|2[0157]|[378]|[56][14])|3(?:123|29)"], "0$1"], ["(\\d{4})(\\d{6})", "$1 $2", ["8"], "0$1"], ["(\\d{2})(\\d{3,5})", "$1 $2", ["1|2(?:0[0-36-9]|12|29|[56])|3(?:1[0-689]|[24-6])|5(?:[0236-9]|1[2-4])|6(?:[013-59]|7[0-46-9])|(?:33|55|6[68])[0-69]|(?:29|3[09]|62)[0-79]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["29[013-9]|39|54"], "0$1"], ["(\\d{4})(\\d{3,5})", "$1 $2", ["(?:25|54)8", "258|5483"], "0$1"]], "0", 0, 0, 0, 0, 0, [0, ["7(?:[1278]\\d|3[1-9])\\d{6}", [9]]]] }, nonGeographic: { 800: ["800", 0, "(?:00|[1-9]\\d)\\d{6}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["\\d"]]], 0, 0, 0, 0, 0, 0, [0, 0, ["(?:00|[1-9]\\d)\\d{6}"]]], 808: ["808", 0, "[1-9]\\d{7}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[1-9]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, 0, ["[1-9]\\d{7}"]]], 870: ["870", 0, "7\\d{11}|[235-7]\\d{8}", [9, 12], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235-7]"]]], 0, 0, 0, 0, 0, 0, [0, ["(?:[356]|774[45])\\d{8}|7[6-8]\\d{7}"], 0, 0, 0, 0, 0, 0, ["2\\d{8}", [9]]]], 878: ["878", 0, "10\\d{10}", [12], [["(\\d{2})(\\d{5})(\\d{5})", "$1 $2 $3", ["1"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, ["10\\d{10}"]]], 881: ["881", 0, "6\\d{9}|[0-36-9]\\d{8}", [9, 10], [["(\\d)(\\d{3})(\\d{5})", "$1 $2 $3", ["[0-37-9]"]], ["(\\d)(\\d{3})(\\d{5,6})", "$1 $2 $3", ["6"]]], 0, 0, 0, 0, 0, 0, [0, ["6\\d{9}|[0-36-9]\\d{8}"]]], 882: ["882", 0, "[13]\\d{6}(?:\\d{2,5})?|[19]\\d{7}|(?:[25]\\d\\d|4)\\d{7}(?:\\d{2})?", [7, 8, 9, 10, 11, 12], [["(\\d{2})(\\d{5})", "$1 $2", ["16|342"]], ["(\\d{2})(\\d{6})", "$1 $2", ["49"]], ["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["1[36]|9"]], ["(\\d{2})(\\d{4})(\\d{3})", "$1 $2 $3", ["3[23]"]], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["16"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["10|23|3(?:[15]|4[57])|4|51"]], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["34"]], ["(\\d{2})(\\d{4,5})(\\d{5})", "$1 $2 $3", ["[1-35]"]]], 0, 0, 0, 0, 0, 0, [0, ["342\\d{4}|(?:337|49)\\d{6}|(?:3(?:2|47|7\\d{3})|50\\d{3})\\d{7}", [7, 8, 9, 10, 12]], 0, 0, 0, ["348[57]\\d{7}", [11]], 0, 0, ["1(?:3(?:0[0347]|[13][0139]|2[035]|4[013568]|6[0459]|7[06]|8[15-8]|9[0689])\\d{4}|6\\d{5,10})|(?:345\\d|9[89])\\d{6}|(?:10|2(?:3|85\\d)|3(?:[15]|[69]\\d\\d)|4[15-8]|51)\\d{8}"]]], 883: ["883", 0, "(?:[1-4]\\d|51)\\d{6,10}", [8, 9, 10, 11, 12], [["(\\d{3})(\\d{3})(\\d{2,8})", "$1 $2 $3", ["[14]|2[24-689]|3[02-689]|51[24-9]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["510"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["21"]], ["(\\d{4})(\\d{4})(\\d{4})", "$1 $2 $3", ["51[13]"]], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[235]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, ["(?:2(?:00\\d\\d|10)|(?:370[1-9]|51\\d0)\\d)\\d{7}|51(?:00\\d{5}|[24-9]0\\d{4,7})|(?:1[0-79]|2[24-689]|3[02-689]|4[0-4])0\\d{5,9}"]]], 888: ["888", 0, "\\d{11}", [11], [["(\\d{3})(\\d{3})(\\d{5})", "$1 $2 $3"]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, ["\\d{11}"]]], 979: ["979", 0, "[1359]\\d{8}", [9], [["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["[1359]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, ["[1359]\\d{8}"]]] } };
function qb(e, t) {
  var r = Array.prototype.slice.call(t);
  return r.push(zb), e.apply(this, r);
}
function Kb() {
  return qb(Lb, arguments);
}
const Yb = (e) => ti.withParams(
  { type: "isValidPhoneNumber", value: e },
  (t) => !ti.req(t) || Kb(t, f2[e].code)
), Zb = {
  class: "flex w-full items-center rtl:flex-row-reverse",
  "data-testid": "fdx-phone-container"
}, Jb = { class: "input-container relative flex flex-1 items-center" }, Qb = { class: "mt-1 self-start text-red-600" }, Xb = /* @__PURE__ */ V({
  __name: "FdxInputPhoneNumber",
  props: /* @__PURE__ */ $e({
    allowedCountries: { default: () => {
    } },
    dialCodeDisabled: { type: Boolean, default: !1 },
    dialCodePlaceholder: { default: "Dial Code" },
    helpText: { default: "" },
    isDisabled: { type: Boolean, default: !1 },
    label: { default: "" },
    name: {},
    showValidationErrors: { type: Boolean },
    validateNumber: { type: Boolean, default: !0 },
    validations: { default: () => {
    } }
  }, {
    modelValue: {},
    modelModifiers: {},
    countryCode: { default: "SA" },
    countryCodeModifiers: {},
    nationalNumber: {},
    nationalNumberModifiers: {},
    countryCallingCode: {},
    countryCallingCodeModifiers: {}
  }),
  emits: ["update:modelValue", "update:countryCode", "update:nationalNumber", "update:countryCallingCode"],
  setup(e) {
    const t = Ae(e, "modelValue"), r = Ae(e, "countryCode"), n = Ae(e, "nationalNumber"), a = Ae(e, "countryCallingCode"), d = (f = null) => {
      const v = t.value;
      if (!v || !r.value) {
        n.value = v || "";
        return;
      }
      const w = f || a.value;
      try {
        const m = _0(v, { defaultCallingCode: w });
        n.value = m.nationalNumber;
      } catch {
        n.value = v.replace(new RegExp(`^\\+?${w}`), "");
      }
    }, o = O(() => ({
      isValidPhoneNumber: ti.withMessage(
        "Please enter a valid mobile number",
        Yb(a.value)
      )
    })), i = O(() => ({
      ...e.validateNumber ? o.value : {},
      ...e.validations
    })), { errorMessages: l, isFieldNotValidAndTouched: s, v$: u } = Be(e.name, i, {
      initialValue: n
    });
    ui(() => {
      a.value && n.value ? t.value = `${a.value}${n == null ? void 0 : n.value}` : t.value = void 0;
    }), He(() => {
      t.value && u.value[e.name].$touch();
    }), K(
      () => r.value,
      (f, v) => {
        try {
          if (!f || f === v)
            return;
          const w = ii(f);
          if (w !== a.value && (a.value = w), t.value)
            if (v) {
              const m = ii(v);
              d(m);
            } else
              d(w);
        } catch {
        }
      },
      { immediate: !0 }
    ), K(
      () => a.value,
      (f, v) => {
        var w;
        f !== v && (r.value = (w = f2[f || ""]) == null ? void 0 : w.code);
      }
    );
    const $ = O(
      () => Wb.filter((f) => !e.allowedCountries || e.allowedCountries.includes(f.code)).map((f) => ({
        label: `${Ub(f.code)} +${f.dial_code}`,
        name: f.name,
        value: f.code
      }))
    ), y = () => {
      n.value = "";
    }, h = /^[\d +]+$/, c = (f) => {
      if (!f)
        return "";
      const v = String(f).trim();
      if (!v)
        return "";
      try {
        return _0(v, {
          defaultCallingCode: a.value
        }).nationalNumber;
      } catch {
        return v.replace(/[^\d+]/g, "");
      }
    }, p = (f) => {
      f.data && !h.test(f.data) && f.preventDefault();
    };
    return (f, v) => {
      const w = $y, m = Uv, b = Hn;
      return S(), B(at, {
        label: f.label,
        "help-text": f.helpText,
        class: de(["flex flex-wrap items-center", { disabled: f.isDisabled }]),
        name: f.name
      }, {
        default: D(() => [
          C("div", Zb, [
            C("div", {
              class: de(["select-input-container me-2 min-w-28 rtl:ms-2 rtl:text-right", {
                disabled: f.dialCodeDisabled
              }])
            }, [
              j(w, {
                class: de(["!m-0", { hasError: g(s) }]),
                name: "phone_number_dial_selector",
                searchable: "",
                "search-keys": ["value", "label", "name"],
                modelValue: r.value,
                "onUpdate:modelValue": v[0] || (v[0] = (_) => r.value = _),
                "has-error": g(s),
                options: $.value,
                disabled: f.dialCodeDisabled || f.isDisabled,
                placeholder: f.dialCodePlaceholder,
                "data-testid": "fdx-phone-select"
              }, null, 8, ["class", "modelValue", "has-error", "options", "disabled", "placeholder"])
            ], 2),
            C("div", Jb, [
              j(m, {
                modelValue: n.value,
                "onUpdate:modelValue": v[1] || (v[1] = (_) => n.value = _),
                name: f.name,
                disabled: f.isDisabled,
                "container-class": "w-full !m-0",
                "allow-empty": "",
                "data-testid": "fdx-phone-input",
                class: "w-full",
                formatter: c,
                onBeforeinput: p
              }, null, 8, ["modelValue", "name", "disabled"]),
              j(jn, { name: "fade" }, {
                default: D(() => [
                  n.value && !f.isDisabled ? (S(), I("button", {
                    key: 0,
                    class: "absolute end-2 flex aspect-square size-6 items-center justify-center rounded-full p-0",
                    onClick: y,
                    "data-testid": "fdx-phone-clear-btn"
                  }, [
                    f.isDisabled ? Z("", !0) : (S(), B(b, { key: 0 }))
                  ])) : Z("", !0)
                ]),
                _: 1
              })
            ])
          ])
        ]),
        errorMessage: D(() => [
          C("div", Qb, [
            C("ul", null, [
              (S(!0), I(le, null, Ee(g(l), (_) => (S(), I("li", { key: _ }, Q(_), 1))), 128))
            ])
          ])
        ]),
        _: 1
      }, 8, ["label", "help-text", "class", "name"]);
    };
  }
}), qx = /* @__PURE__ */ rr(Xb, [["__scopeId", "data-v-c705e510"]]), Kx = /* @__PURE__ */ V({
  __name: "FdxInputPin",
  props: /* @__PURE__ */ $e({
    helpText: {},
    label: {},
    length: { default: 4 },
    mask: { type: Boolean },
    name: {},
    otp: { type: Boolean },
    validations: {}
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ $e(["complete"], ["update:modelValue"]),
  setup(e, { expose: t }) {
    const r = wr(e, ["length"]), n = Ae(e, "modelValue"), a = At("pin-input-input"), { isFieldNotValidAndTouched: d, value: o } = Be(r.name, r.validations, {
      initialValue: n.value
    });
    K(o, (l) => {
      l !== n.value && (n.value = l);
    }), K(n, (l) => {
      l !== o.value && (o.value = l);
    });
    function i() {
      var s, u;
      if (!a.value)
        return;
      (u = ((s = a.value[0]) == null ? void 0 : s._).vnode.el) == null || u.focus(), o.value = [];
    }
    return t({
      clearOtp: i
    }), (l, s) => (S(), B(at, {
      name: l.name,
      label: l.label,
      "help-text": l.helpText
    }, {
      default: D(() => [
        j(g(x7), me({
          id: "pin-input",
          modelValue: g(o),
          "onUpdate:modelValue": s[0] || (s[0] = (u) => $t(o) ? o.value = u : null),
          placeholder: "○",
          class: "mt-1 flex items-center gap-2",
          onComplete: s[1] || (s[1] = (u) => l.$emit("complete", u))
        }, l.$attrs), {
          default: D(() => [
            (S(!0), I(le, null, Ee(l.length, (u, $) => (S(), B(g(S7), {
              key: u,
              index: $,
              "aria-label": "Enter PIN",
              "aria-invalid": g(d),
              class: de(["size-[72px] rounded-lg border border-gray-500 bg-white text-center outline-none placeholder:text-gray-600 focus:border-primary", {
                "border-negative-500 !bg-negative-400 focus:!border-negative-500": g(d)
              }]),
              ref_for: !0,
              ref: "pin-input-input"
            }, null, 8, ["index", "aria-invalid", "class"]))), 128))
          ]),
          _: 1
        }, 16, ["modelValue"])
      ]),
      _: 1
    }, 8, ["name", "label", "help-text"]));
  }
}), ew = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, tw = ["clip-path"], rw = ["id"];
function nw(e, t) {
  return S(), I("svg", ew, [
    C("g", {
      "clip-path": "url(#" + e.idMap.clip0_5_23388 + ")"
    }, [...t[0] || (t[0] = [
      C("path", {
        d: "M12 7C9.24 7 7 9.24 7 12C7 14.76 9.24 17 12 17C14.76 17 17 14.76 17 12C17 9.24 14.76 7 12 7ZM12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.58 20 4 16.42 4 12C4 7.58 7.58 4 12 4C16.42 4 20 7.58 20 12C20 16.42 16.42 20 12 20Z",
        fill: "currentColor"
      }, null, -1)
    ])], 8, tw),
    C("defs", null, [
      C("clipPath", {
        id: e.idMap.clip0_5_23388
      }, [...t[1] || (t[1] = [
        C("rect", {
          width: "24",
          height: "24",
          fill: "white"
        }, null, -1)
      ])], 8, rw)
    ])
  ]);
}
const aw = ye({ name: "icon-radio-button-checked", render: nw, setup() {
  return { idMap: { clip0_5_23388: "uicons-" + Math.random().toString(36).substr(2, 10) } };
} }), dw = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, ow = ["clip-path"], iw = ["id"];
function lw(e, t) {
  return S(), I("svg", dw, [
    C("g", {
      "clip-path": "url(#" + e.idMap.clip0_5_23386 + ")"
    }, [...t[0] || (t[0] = [
      C("path", {
        d: "M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.58 20 4 16.42 4 12C4 7.58 7.58 4 12 4C16.42 4 20 7.58 20 12C20 16.42 16.42 20 12 20Z",
        fill: "currentColor"
      }, null, -1)
    ])], 8, ow),
    C("defs", null, [
      C("clipPath", {
        id: e.idMap.clip0_5_23386
      }, [...t[1] || (t[1] = [
        C("rect", {
          width: "24",
          height: "24",
          fill: "white"
        }, null, -1)
      ])], 8, iw)
    ])
  ]);
}
const sw = ye({ name: "icon-radio-button-unchecked", render: lw, setup() {
  return { idMap: { clip0_5_23386: "uicons-" + Math.random().toString(36).substr(2, 10) } };
} }), uw = ["for"], cw = ["id", "value", "name"], Yx = /* @__PURE__ */ V({
  __name: "FdxInputRadio",
  props: /* @__PURE__ */ $e({
    id: {},
    label: {},
    validations: {},
    value: {}
  }, {
    modelValue: { required: !1 },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    const t = e, r = Ae(e, "modelValue"), n = ft(Au, `fdx-radio-group-${tr()}`), { value: a } = Be(n, t.validations, {
      initialValue: r.value
    });
    return K(a, () => {
      a.value !== r.value && (r.value = a.value);
    }), K(r, () => {
      r.value !== a.value && (a.value = r.value);
    }), (d, o) => {
      const i = sw, l = aw;
      return S(), I("label", {
        for: d.id,
        class: "inline-flex cursor-pointer items-center gap-x-2 disabled:cursor-not-allowed"
      }, [
        Xe(C("input", {
          type: "radio",
          hidden: "",
          id: d.id,
          value: d.value,
          "onUpdate:modelValue": o[0] || (o[0] = (s) => $t(a) ? a.value = s : null),
          name: g(n),
          class: "peer"
        }, null, 8, cw), [
          [W2, g(a)]
        ]),
        j(i, { class: "text-primary-300 peer-checked:hidden" }),
        j(l, { class: "hidden text-primary-300 peer-checked:block" }),
        F(d.$slots, "label", {}, () => [
          C("span", null, Q(d.label), 1)
        ])
      ], 8, uw);
    };
  }
}), Zx = /* @__PURE__ */ V({
  __name: "FdxInputRadioGroup",
  props: /* @__PURE__ */ $e({
    name: {},
    validations: {}
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    const t = e, r = t.name || `fdx-radio-group-${tr()}`;
    Zt(Au, r);
    const n = Ae(e, "modelValue"), { value: a } = Be(r, t.validations, { initialValue: n.value });
    return K(a, () => {
      a.value !== n.value && (n.value = a.value);
    }), K(n, () => {
      n.value !== a.value && (a.value = n.value);
    }), (d, o) => F(d.$slots, "default");
  }
}), fw = { ref: "observer-el" }, Jx = /* @__PURE__ */ V({
  __name: "FdxIntersectionTrigger",
  props: {
    disabled: { type: Boolean },
    observerOptions: { default: () => ({}) }
  },
  emits: ["intersected"],
  setup(e, { emit: t }) {
    const r = At("observer-el"), n = t, a = new IntersectionObserver((d) => {
      d.forEach((o) => {
        o.isIntersecting && !e.disabled && n("intersected");
      });
    }, e.observerOptions);
    return He(() => {
      r.value && a.observe(r.value);
    }), Qr(() => {
      a.disconnect();
    }), (d, o) => (S(), I("div", fw, [
      F(d.$slots, "default")
    ], 512));
  }
}), $w = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 20 20"
};
function pw(e, t) {
  return S(), I("svg", $w, [...t[0] || (t[0] = [
    C("path", {
      fill: "currentColor",
      d: "M10 3a7 7 0 0 0-7 7a.5.5 0 0 1-1 0a8 8 0 1 1 8 8a.5.5 0 0 1 0-1a7 7 0 1 0 0-14"
    }, null, -1)
  ])]);
}
const mw = ye({ name: "icon-ellipse", render: pw }), hw = {
  key: 0,
  class: "text-caption-1 font-normal text-gray-700",
  "data-testid": "loading-text"
}, vw = /* @__PURE__ */ V({
  __name: "FdxLoadingSpinner",
  props: {
    layout: { default: "inline" },
    loadingText: { default: "Loading ..." },
    showText: { type: Boolean, default: !0 }
  },
  setup(e) {
    return (t, r) => {
      const n = mw;
      return S(), I("div", {
        class: de(["flex items-center justify-center gap-2", t.layout === "inline" ? "flex-row" : "flex-col"])
      }, [
        j(n, {
          class: "size-6 animate-spin text-gray-700",
          "data-testid": "icon-ellipse"
        }),
        t.showText ? (S(), I("span", hw, Q(t.loadingText), 1)) : Z("", !0)
      ], 2);
    };
  }
}), Qx = /* @__PURE__ */ V({
  __name: "FdxModal",
  props: /* @__PURE__ */ $e({
    backdropCloses: { type: Boolean, default: !0 },
    title: {},
    variant: { default: "base" }
  }, {
    modelValue: { type: Boolean },
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ $e(["closed", "opened"], ["update:modelValue"]),
  setup(e, { emit: t }) {
    const r = t, n = Ae(e, "modelValue");
    return (a, d) => (S(), B(ju, {
      modelValue: n.value,
      "onUpdate:modelValue": d[0] || (d[0] = (o) => n.value = o),
      title: a.title,
      class: de({
        "m-auto min-w-64 max-w-xl rounded-lg": a.variant === "base",
        "h-full max-h-none w-full max-w-none": a.variant === "full-screen"
      }),
      "backdrop-closes": a.backdropCloses,
      onClosed: d[1] || (d[1] = (o) => r("closed")),
      onOpened: d[2] || (d[2] = (o) => r("opened"))
    }, _u({
      default: D(() => [
        F(a.$slots, "default")
      ]),
      _: 2
    }, [
      a.$slots.header ? {
        name: "header",
        fn: D(({ dialogTitleId: o }) => [
          F(a.$slots, "header", { dialogTitleId: o })
        ]),
        key: "0"
      } : void 0,
      a.$slots.footer ? {
        name: "footer",
        fn: D(() => [
          F(a.$slots, "footer")
        ]),
        key: "1"
      } : void 0
    ]), 1032, ["modelValue", "title", "class", "backdrop-closes"]));
  }
}), yw = {
  key: 0,
  class: "relative mt-1 h-4 w-full",
  "data-testid": "slider-scale"
}, gw = { class: "absolute flex w-full justify-between" }, bw = { className: "text-xs text-gray-600 mt-1 block whitespace-nowrap" }, Xx = /* @__PURE__ */ V({
  __name: "FdxRangeSlider",
  props: /* @__PURE__ */ $e({
    dir: {},
    disabled: { type: Boolean },
    helpText: {},
    label: {},
    max: { default: 100 },
    min: { default: 0 },
    multiple: { type: Boolean },
    name: {},
    pointsCount: { default: 5 },
    showScale: { type: Boolean },
    step: { default: 1 },
    validations: {},
    valueFormatter: { type: Function },
    variant: {}
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    const t = wr(e, ["dir", "disabled", "max", "min", "pointsCount", "step"]), r = Ae(e, "modelValue"), { value: n } = Be(t.name, t.validations, { initialValue: r.value }), a = O(() => t.valueFormatter ? t.valueFormatter(n.value ?? []) : n.value), d = "text-title-3 text-gray-1000 my-2";
    K(n, () => {
      n.value !== r.value && (r.value = n.value);
    }), K(r, () => {
      r.value !== n.value && (n.value = r.value);
    });
    const o = O(() => {
      switch (t.variant) {
        case "danger":
          return {
            bg: "bg-negative-500",
            shadow: "hover:shadow-negative-500/10 focus:shadow-negative-500/10"
          };
        case "secondary":
          return {
            bg: "bg-secondary",
            shadow: "hover:shadow-secondary/10 focus:shadow-secondary/10"
          };
        case "success":
          return {
            bg: "bg-positive-500",
            shadow: "hover:shadow-positive-500/10 focus:shadow-positive-500/10"
          };
        case "primary":
        default:
          return {
            bg: "bg-primary",
            shadow: "hover:shadow-primary/10 focus:shadow-primary/10"
          };
      }
    }), i = O(() => {
      if (!t.showScale)
        return null;
      let l = e.pointsCount;
      const s = (e.max - e.min) / e.step;
      l > s + 1 && (l = s + 1);
      const u = Math.floor(s / (l - 1));
      return Array.from({ length: l }, ($, y) => y === 0 ? e.min : y === l - 1 ? e.max : e.min + e.step * u * y);
    });
    return (l, s) => (S(), B(at, {
      disabled: l.disabled,
      label: l.label,
      "help-text": l.helpText,
      name: l.name
    }, {
      default: D(() => [
        F(l.$slots, "prefix", {
          props: { formattedValue: a.value, value: g(n), prefixClasses: d }
        }, () => [
          C("div", {
            class: de(d)
          }, Q(a.value), 1)
        ]),
        (S(), B(g(Z7), {
          class: "group relative mt-4 flex touch-none select-none items-center",
          min: l.min,
          max: l.max,
          step: l.step,
          disabled: l.disabled,
          dir: l.dir,
          name: l.name,
          "data-testid": "redix-slider",
          modelValue: g(n),
          "onUpdate:modelValue": s[0] || (s[0] = (u) => $t(n) ? n.value = u : null),
          key: `${l.name}-${l.dir}`
        }, {
          default: D(() => [
            j(g(X7), { class: "relative h-1 grow rounded-xl bg-white" }, {
              default: D(() => [
                j(g(ev), {
                  class: de(
                    g(st)(
                      "absolute h-full rounded-xl transition-[right,left] ease-out group-aria-disabled:bg-gray-300",
                      o.value.bg
                    )
                  )
                }, null, 8, ["class"])
              ]),
              _: 1
            }),
            j(g(Q7), {
              class: de(
                g(st)(
                  "block size-5 rounded-full transition-[background-color,left,right] ease-out hover:cursor-pointer focus:outline-none group-aria-disabled:cursor-not-allowed group-aria-disabled:bg-gray-200",
                  o.value.bg,
                  o.value.shadow
                )
              ),
              "aria-label": "Volume"
            }, null, 8, ["class"])
          ]),
          _: 1
        }, 8, ["min", "max", "step", "disabled", "dir", "name", "modelValue"])),
        i.value ? (S(), I("div", yw, [
          C("ul", gw, [
            (S(!0), I(le, null, Ee(i.value, (u) => (S(), I("li", {
              key: u,
              class: de(["flex flex-col items-center", {
                "absolute -translate-x-1/2": u > l.min && u < l.max && l.dir === "ltr",
                "absolute translate-x-1/2": u > l.min && u < l.max && l.dir === "rtl"
              }]),
              style: Ct({
                insetInlineStart: `${(u - l.min) / (l.max - l.min) * 100}%`
              })
            }, [
              C("span", bw, [
                F(l.$slots, "scale-item", { item: u }, () => [
                  Me(Q(g(Eu)(u, { compact: !0, showFraction: !0 })), 1)
                ])
              ])
            ], 6))), 128))
          ])
        ])) : Z("", !0)
      ]),
      _: 3
    }, 8, ["disabled", "label", "help-text", "name"]));
  }
}), ww = {}, _w = { class: "container" };
function xw(e, t) {
  return S(), I("div", _w, [
    F(e.$slots, "default", {}, void 0, !0)
  ]);
}
const eS = /* @__PURE__ */ rr(ww, [["render", xw], ["__scopeId", "data-v-af8b8395"]]), Sw = {}, Cw = { class: "animate-pulse rounded-lg bg-gray-200" };
function Pw(e, t) {
  return S(), I("div", Cw);
}
const tS = /* @__PURE__ */ rr(Sw, [["render", Pw]]), Aw = Object.freeze({
  lg: "lg",
  md: "md",
  sm: "sm",
  xs: "xs"
}), Ew = Object.freeze({
  lg: {
    root: "h-[32px] w-[56px]",
    thumb: "h-[28px] w-[28px] data-[state=checked]:translate-x-[26px] rtl:data-[state=checked]:translate-x-[-26px]"
  },
  md: {
    root: "h-[25px] w-[42px]",
    thumb: "h-[21px] w-[21px] data-[state=checked]:translate-x-[19px] rtl:data-[state=checked]:translate-x-[-19px]"
  },
  sm: {
    root: "h-[20px] w-[36px]",
    thumb: "h-[16px] w-[16px] data-[state=checked]:translate-x-[17px] rtl:data-[state=checked]:translate-x-[-17px]"
  },
  xs: {
    root: "w-[24px] h-[14px]",
    thumb: "w-[10px] h-[10px] data-[state=checked]:translate-x-[11px] rtl:data-[state=checked]:translate-x-[-11px]"
  }
}), Mw = {
  class: "flex items-center gap-2",
  "data-testid": "fdx-switch"
}, Ow = ["for"], rS = /* @__PURE__ */ V({
  inheritAttrs: !1,
  __name: "FdxSwitch",
  props: /* @__PURE__ */ $e({
    disabled: { type: Boolean },
    label: {},
    labelAttrs: {},
    name: {},
    size: { default: () => Aw.sm },
    validations: {}
  }, {
    modelValue: { type: Boolean, default: !1 },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    const t = wr(e, ["size"]), r = tr(), n = Zr(), a = Ae(e, "modelValue"), d = O(() => Ew[e.size]), { value: o } = Be(t.name, t.validations, {
      initialValue: a.value
    });
    return K(o, () => {
      o.value !== a.value && (a.value = o.value ?? !1);
    }), K(a, () => {
      a.value !== o.value && (o.value = a.value);
    }), (i, l) => {
      const s = at;
      return S(), B(s, {
        name: i.name,
        class: "!mb-0"
      }, {
        default: D(() => [
          C("div", Mw, [
            F(i.$slots, "prefix", {}, () => {
              var u;
              return [
                i.label ? (S(), I("label", {
                  key: 0,
                  "data-testid": "fdx-switch-label",
                  class: de(g(st)("select-none pr-[10px] text-[15px] leading-none", (u = i.labelAttrs) == null ? void 0 : u.class)),
                  for: g(r)
                }, Q(i.label), 11, Ow)) : Z("", !0)
              ];
            }),
            j(g(dv), {
              "data-testid": "fdx-switch-root",
              id: g(r),
              disabled: i.disabled,
              checked: a.value,
              "onUpdate:checked": l[0] || (l[0] = (u) => a.value = u),
              class: de(
                g(st)(
                  "relative flex cursor-default rounded-full bg-gray-500 shadow-sm focus-within:outline focus-within:outline-primary data-[state=checked]:bg-primary",
                  d.value.root,
                  g(n).class
                )
              )
            }, {
              default: D(() => [
                j(g(ov), {
                  class: de(
                    g(st)(
                      "my-auto block translate-x-0.5 rounded-full bg-white shadow-sm transition-transform duration-100 will-change-transform rtl:translate-x-[-2px]",
                      d.value.thumb
                    )
                  )
                }, null, 8, ["class"])
              ]),
              _: 1
            }, 8, ["id", "disabled", "checked", "class"])
          ])
        ]),
        _: 3
      }, 8, ["name"]);
    };
  }
}), Tw = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, kw = ["clip-path"], Iw = ["id"];
function Rw(e, t) {
  return S(), I("svg", Tw, [
    C("g", {
      "clip-path": "url(#" + e.idMap.clip0_5_23660 + ")"
    }, [...t[0] || (t[0] = [
      C("path", {
        d: "M7 14L12 9L17 14H7Z",
        fill: "currentColor"
      }, null, -1)
    ])], 8, kw),
    C("defs", null, [
      C("clipPath", {
        id: e.idMap.clip0_5_23660
      }, [...t[1] || (t[1] = [
        C("rect", {
          width: "24",
          height: "24",
          fill: "white"
        }, null, -1)
      ])], 8, Iw)
    ])
  ]);
}
const Dw = ye({ name: "icon-arrow-drop-up", render: Rw, setup() {
  return { idMap: { clip0_5_23660: "uicons-" + Math.random().toString(36).substr(2, 10) } };
} });
var yn = /* @__PURE__ */ ((e) => (e.ASC = "asc", e.DESC = "desc", e.NONE = "none", e))(yn || {});
const Nw = { class: "fdx-table__table w-full text-left rtl:text-right" }, Fw = { class: "fdx-table__thead bg-white" }, Lw = { class: "fdx-table__tr border-b border-gray-100" }, Bw = ["onClick"], Vw = {
  key: 0,
  "aria-label": "Sort"
}, jw = { class: "fdx-table__tbody" }, Gw = {
  key: 0,
  class: "fdx-table__tr"
}, Uw = {
  class: "fdx-table__td",
  colspan: "100%"
}, Hw = {
  key: 1,
  class: "fdx-table__tr"
}, Ww = {
  class: "fdx-table__td py-4",
  colspan: "100%"
}, zw = ["onClick"], qw = ["rowspan"], Kw = /* @__PURE__ */ V({
  __name: "FdxTable",
  props: /* @__PURE__ */ $e({
    data: {},
    groupBy: {},
    isLoading: { type: Boolean },
    isRowClickable: { type: [Function, Boolean] }
  }, {
    columns: {
      required: !0
    },
    columnsModifiers: {}
  }),
  emits: /* @__PURE__ */ $e(["rowClicked", "sort"], ["update:columns"]),
  setup(e, { emit: t }) {
    const r = e, n = Ae(e, "columns"), a = t;
    function d(u) {
      return typeof r.isRowClickable == "function" ? r.isRowClickable(u) : r.isRowClickable;
    }
    function o(u, $) {
      if (!r.groupBy || u.name !== r.groupBy)
        return 1;
      const y = r.groupBy;
      return r.data.filter((h) => Hr(h[y], $[y])).length;
    }
    function i(u) {
      if (!u.sortable)
        return;
      const $ = u.sortedBy === yn.ASC ? yn.DESC : yn.ASC;
      n.value = n.value.map((y) => ({ ...y, sortedBy: y.name === u.name ? $ : yn.NONE })), a("sort", {
        column: u.name,
        order: $
      });
    }
    function l(u) {
      d(u) && a("rowClicked", u);
    }
    function s(u, $) {
      if (!r.groupBy || u.name !== r.groupBy)
        return !0;
      const y = r.groupBy, h = r.data.findIndex((p) => Hr(p[y], $[y]));
      return r.data.findIndex((p) => p === $) === h;
    }
    return (u, $) => {
      const y = Dw, h = Ni;
      return S(), I("table", Nw, [
        C("thead", Fw, [
          C("tr", Lw, [
            (S(!0), I(le, null, Ee(n.value, (c) => (S(), I("th", {
              key: c.name,
              class: de(["fdx-table__th relative py-4 text-caption-1 font-normal text-gray-1000", { "cursor-pointer": c.sortable }]),
              onClick: (p) => i(c)
            }, [
              Me(Q(c.label) + " ", 1),
              c.sortable ? (S(), I("button", Vw, [
                j(y, {
                  class: de([{ "!text-black": c.sortedBy === "asc" }, "absolute top-2 text-gray-200 transition"])
                }, null, 8, ["class"]),
                j(h, {
                  class: de([{ "!text-black": c.sortedBy === "desc" }, "absolute bottom-2 text-gray-200 transition"])
                }, null, 8, ["class"])
              ])) : Z("", !0)
            ], 10, Bw))), 128))
          ])
        ]),
        C("tbody", jw, [
          u.isLoading ? (S(), I("tr", Gw, [
            C("td", Uw, [
              F(u.$slots, "loading", {}, () => [
                j(vw, { class: "my-10" })
              ], !0)
            ])
          ])) : u.data.length === 0 ? (S(), I("tr", Hw, [
            C("td", Ww, [
              F(u.$slots, "empty", {}, () => [
                $[0] || ($[0] = C("p", { class: "text-center text-caption-1 text-gray-1000" }, "No data found", -1))
              ], !0)
            ])
          ])) : (S(), B(Su, {
            key: 2,
            name: "fade",
            appear: ""
          }, {
            default: D(() => [
              (S(!0), I(le, null, Ee(u.data, (c, p) => (S(), I("tr", {
                key: p,
                class: de(["fdx-table__tr border-b border-gray-100", { "cursor-pointer": d(c) }]),
                onClick: (f) => l(c)
              }, [
                (S(!0), I(le, null, Ee(n.value, (f) => (S(), I(le, {
                  key: f.name
                }, [
                  s(f, c) ? (S(), I("td", {
                    key: 0,
                    class: "fdx-table__td py-4 text-footnote font-normal",
                    rowspan: o(f, c)
                  }, [
                    F(u.$slots, f.name, { row: c }, () => [
                      c[f.name] ? (S(), I(le, { key: 0 }, [
                        Me(Q(c[f.name]), 1)
                      ], 64)) : Z("", !0)
                    ], !0)
                  ], 8, qw)) : Z("", !0)
                ], 64))), 128))
              ], 10, zw))), 128))
            ]),
            _: 3
          }))
        ])
      ]);
    };
  }
}), nS = /* @__PURE__ */ rr(Kw, [["__scopeId", "data-v-bfab32f7"]]), Yw = { key: 0 }, aS = /* @__PURE__ */ V({
  __name: "FdxTabPane",
  props: {
    label: {},
    name: {}
  },
  setup(e) {
    const t = e, r = z2(), n = H(!1), { activeTab: a, addTab: d, removeTab: o } = Z2(Cu), i = O(() => a.value === t.name), l = ye({
      render: () => {
        var s;
        return ((s = r.label) == null ? void 0 : s.call(r)) || mr("span", t.label);
      }
    });
    return d(l, t.name), Qr(() => {
      o(t.name);
    }), K(
      i,
      (s) => {
        !n.value && s && (n.value = !0);
      },
      { immediate: !0 }
    ), (s, u) => n.value ? Xe((S(), I("div", Yw, [
      F(s.$slots, "default")
    ], 512)), [
      [xo, i.value]
    ]) : Z("", !0);
  }
}), Zw = {
  ref: "tabs-wrapper-element",
  class: "tabs-container relative"
}, Jw = { class: "tabs-wrapper flex gap-6 overflow-auto border-b" }, Qw = ["href", "aria-selected", "onClick"], dS = /* @__PURE__ */ V({
  __name: "FdxTabs",
  props: /* @__PURE__ */ $e({
    ignoreRouteUpdates: { type: Boolean }
  }, {
    modelValue: { required: !0, type: String },
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ $e(["change"], ["update:modelValue"]),
  setup(e, { emit: t }) {
    const r = H([]);
    function n($, y) {
      r.value.push({ label: $, value: y });
    }
    function a($) {
      r.value = r.value.filter((y) => y.value !== $);
    }
    const d = Ae(e, "modelValue"), o = t, i = At("tabs-elements"), l = O(() => {
      if (!i.value)
        return null;
      const $ = r.value.findIndex((y) => y.value === d.value);
      return $ > -1 ? i.value[$] : null;
    });
    function s($) {
      d.value !== $.value && (d.value = $.value, o("change", $));
    }
    const u = O(() => l.value ? {
      opacity: 1,
      transform: `translateX(${l.value.offsetLeft}px)`,
      width: `${l.value.clientWidth}px`
    } : { opacity: 0 });
    return Zt(Cu, {
      activeTab: d,
      addTab: n,
      removeTab: a
    }), ($, y) => (S(), I("div", null, [
      C("div", Zw, [
        C("div", Jw, [
          (S(!0), I(le, null, Ee(r.value, (h) => (S(), I("a", {
            ref_for: !0,
            ref: "tabs-elements",
            key: h.value,
            href: $.ignoreRouteUpdates ? void 0 : `#${h.value}`,
            "aria-selected": d.value === h.value,
            class: "mb-0.5 cursor-pointer px-2 py-1 text-body aria-selected:font-bold",
            onClick: (c) => s(h)
          }, [
            (S(), B(si(h.label)))
          ], 8, Qw))), 128))
        ]),
        C("div", {
          ref: "underline-element",
          class: "absolute bottom-0 start-0 h-0.5 w-8 bg-gray-1000 transition-transform",
          style: Ct(u.value)
        }, null, 4)
      ], 512),
      F($.$slots, "default")
    ]));
  }
}), Xw = ["name"], oS = /* @__PURE__ */ V({
  __name: "FdxTextarea",
  props: /* @__PURE__ */ $e({
    helpText: {},
    label: {},
    name: {},
    validations: {}
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    const t = e, r = Ae(e, "modelValue"), { isFieldNotValidAndTouched: n, value: a } = Be(t.name, t.validations, {
      initialValue: r.value
    });
    return K(a, () => {
      a.value !== r.value && (r.value = a.value);
    }), K(r, () => {
      r.value !== a.value && (a.value = r.value);
    }), (d, o) => (S(), B(at, {
      label: d.label,
      "help-text": d.helpText,
      name: d.name
    }, {
      default: D(() => [
        Xe(C("textarea", me({
          "onUpdate:modelValue": o[0] || (o[0] = (i) => $t(a) ? a.value = i : null),
          name: d.name,
          rows: "3",
          class: ["w-full rounded-lg border border-gray-300 bg-white p-2 px-3 outline-none", { "border-red-600": g(n) }]
        }, d.$attrs), null, 16, Xw), [
          [Un, g(a)]
        ])
      ]),
      _: 1
    }, 8, ["label", "help-text", "name"]));
  }
}), e_ = { class: "fdx-timeline-event__description text-xs text-slate-500" }, t_ = /* @__PURE__ */ V({
  __name: "FdxTimelineEventDescription",
  props: {
    description: {}
  },
  setup(e) {
    return (t, r) => F(t.$slots, "default", {}, () => [
      C("p", e_, Q(t.description), 1)
    ]);
  }
}), r_ = { class: "fdx-timeline-event__title" }, n_ = { class: "text-baase" }, a_ = /* @__PURE__ */ V({
  __name: "FdxTimelineEventTitle",
  props: {
    title: {}
  },
  setup(e) {
    return (t, r) => (S(), I("div", r_, [
      F(t.$slots, "default", {}, () => [
        C("h6", n_, Q(t.title), 1)
      ])
    ]));
  }
}), d_ = { class: "flex h-5 items-center justify-center" }, o_ = /* @__PURE__ */ V({
  __name: "FdxTimelineEventIcon",
  setup(e) {
    const t = Zr();
    return (r, n) => F(r.$slots, "default", {}, () => [
      C("div", d_, [
        C("div", {
          class: de(
            g(st)(
              "fdx-timeline-event__icon m-px h-2 w-2 flex-shrink-0 rounded-full bg-gray-400",
              g(t).class
            )
          )
        }, null, 2)
      ])
    ]);
  }
}), i_ = { class: "flex flex-col items-center pe-3" }, l_ = { class: "fdx-timeline-event__inner-wrapper pb-4" }, iS = /* @__PURE__ */ V({
  __name: "FdxTimelineEvent",
  props: {
    description: {},
    title: {}
  },
  setup(e) {
    const t = Zr(), r = e;
    return (n, a) => {
      const d = o_, o = a_, i = t_;
      return S(), I("div", {
        class: de(g(st)("fdx-timeline-event flex", g(t).class))
      }, [
        C("div", i_, [
          C("div", null, [
            F(n.$slots, "icon", {}, () => [
              j(d)
            ])
          ]),
          a[0] || (a[0] = C("div", { class: "fdx-timeline-event__sidebar h-full w-px bg-gray-200" }, null, -1))
        ]),
        C("div", l_, [
          F(n.$slots, "title", {}, () => [
            j(o, null, {
              default: D(() => [
                Me(Q(r.title), 1)
              ]),
              _: 1
            })
          ]),
          F(n.$slots, "description", {}, () => [
            j(i, null, {
              default: D(() => [
                Me(Q(r.description), 1)
              ]),
              _: 1
            })
          ])
        ])
      ], 2);
    };
  }
}), s_ = {}, u_ = { class: "fdx-timeline-wrapper" };
function c_(e, t) {
  return S(), I("div", u_, [
    F(e.$slots, "default", {}, void 0, !0)
  ]);
}
const lS = /* @__PURE__ */ rr(s_, [["render", c_], ["__scopeId", "data-v-47f9b60e"]]);
function f_(e) {
  let t = !1, r;
  const n = xu(!0);
  return (...a) => (t || (r = n.run(() => e(...a)), t = !0), r);
}
typeof WorkerGlobalScope < "u" && globalThis instanceof WorkerGlobalScope;
const $_ = 5e3, p_ = f_(() => {
  const e = H([]);
  function t(n) {
    e.value = e.value.filter((a) => a.id !== n);
  }
  function r(n, a = {}) {
    const d = {
      description: n.description,
      dismissible: n.dismissible || !1,
      id: `toast-${Date.now()}-${Math.random()}`,
      title: n.title,
      variant: n.variant ?? "success"
    };
    return e.value.push(d), setTimeout(() => {
      t(d.id);
    }, a.duration ?? $_), d;
  }
  return {
    addToast: r,
    dismissToast: t,
    toasts: e
  };
}), m_ = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, h_ = ["clip-path"], v_ = ["id"];
function y_(e, t) {
  return S(), I("svg", m_, [
    C("g", {
      "clip-path": "url(#" + e.idMap.clip0_5_22806 + ")"
    }, [...t[0] || (t[0] = [
      C("path", {
        d: "M1 21H23L12 2L1 21ZM13 18H11V16H13V18ZM13 14H11V10H13V14Z",
        fill: "currentColor"
      }, null, -1)
    ])], 8, h_),
    C("defs", null, [
      C("clipPath", {
        id: e.idMap.clip0_5_22806
      }, [...t[1] || (t[1] = [
        C("rect", {
          width: "24",
          height: "24",
          fill: "white"
        }, null, -1)
      ])], 8, v_)
    ])
  ]);
}
const g_ = ye({ name: "icon-warning", render: y_, setup() {
  return { idMap: { clip0_5_22806: "uicons-" + Math.random().toString(36).substr(2, 10) } };
} }), b_ = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, w_ = ["clip-path"], __ = ["id"];
function x_(e, t) {
  return S(), I("svg", b_, [
    C("g", {
      "clip-path": "url(#" + e.idMap.clip0_5_22942 + ")"
    }, [...t[0] || (t[0] = [
      C("path", {
        d: "M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM13 17H11V11H13V17ZM13 9H11V7H13V9Z",
        fill: "currentColor"
      }, null, -1)
    ])], 8, w_),
    C("defs", null, [
      C("clipPath", {
        id: e.idMap.clip0_5_22942
      }, [...t[1] || (t[1] = [
        C("rect", {
          width: "24",
          height: "24",
          fill: "white"
        }, null, -1)
      ])], 8, __)
    ])
  ]);
}
const S_ = ye({ name: "icon-info", render: x_, setup() {
  return { idMap: { clip0_5_22942: "uicons-" + Math.random().toString(36).substr(2, 10) } };
} }), C_ = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, P_ = ["clip-path"], A_ = ["id"];
function E_(e, t) {
  return S(), I("svg", C_, [
    C("g", {
      "clip-path": "url(#" + e.idMap.clip0_5_22814 + ")"
    }, [...t[0] || (t[0] = [
      C("path", {
        d: "M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM13 17H11V15H13V17ZM13 13H11V7H13V13Z",
        fill: "currentColor"
      }, null, -1)
    ])], 8, P_),
    C("defs", null, [
      C("clipPath", {
        id: e.idMap.clip0_5_22814
      }, [...t[1] || (t[1] = [
        C("rect", {
          width: "24",
          height: "24",
          fill: "white"
        }, null, -1)
      ])], 8, A_)
    ])
  ]);
}
const M_ = ye({ name: "icon-error", render: E_, setup() {
  return { idMap: { clip0_5_22814: "uicons-" + Math.random().toString(36).substr(2, 10) } };
} }), O_ = {
  width: "1.2em",
  height: "1.2em",
  viewBox: "0 0 24 24",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, T_ = ["clip-path"], k_ = ["id"];
function I_(e, t) {
  return S(), I("svg", O_, [
    C("g", {
      "clip-path": "url(#" + e.idMap.clip0_5_23138 + ")"
    }, [...t[0] || (t[0] = [
      C("path", {
        d: "M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM10 17L5 12L6.41 10.59L10 14.17L17.59 6.58L19 8L10 17Z",
        fill: "currentColor"
      }, null, -1)
    ])], 8, T_),
    C("defs", null, [
      C("clipPath", {
        id: e.idMap.clip0_5_23138
      }, [...t[1] || (t[1] = [
        C("rect", {
          width: "24",
          height: "24",
          fill: "white"
        }, null, -1)
      ])], 8, k_)
    ])
  ]);
}
const R_ = ye({ name: "icon-check-circle", render: I_, setup() {
  return { idMap: { clip0_5_23138: "uicons-" + Math.random().toString(36).substr(2, 10) } };
} }), D_ = { class: "the-toaster__icon" }, N_ = { class: "the-toaster__content" }, F_ = { class: "the-toaster__title text-footnote font-bold" }, L_ = {
  key: 0,
  class: "the-toaster__description text-caption-1 font-normal"
}, B_ = /* @__PURE__ */ V({
  __name: "FdxToastItem",
  props: {
    toast: {}
  },
  emits: ["dismiss"],
  setup(e) {
    return (t, r) => {
      const n = R_, a = M_, d = S_, o = g_, i = Hn;
      return S(), I("div", {
        class: de(["flex gap-x-3 rounded-lg p-4", {
          "border border-positive-500 bg-positive-400 text-gray-1000": t.toast.variant === "success",
          "border border-negative-500 bg-negative-400 text-gray-1000": t.toast.variant === "error",
          "border border-blue-400 bg-blue-100 text-gray-1000": t.toast.variant === "info",
          "border border-yellow-400 bg-yellow-100 text-gray-1000": t.toast.variant === "warning"
        }])
      }, [
        C("div", D_, [
          t.toast.variant === "success" ? (S(), B(n, {
            key: 0,
            class: "size-6 text-positive-500",
            "data-testid": "icon-check-circle"
          })) : Z("", !0),
          t.toast.variant === "error" ? (S(), B(a, {
            key: 1,
            class: "size-6 text-negative-500",
            "data-testid": "icon-error"
          })) : Z("", !0),
          t.toast.variant === "info" ? (S(), B(d, {
            key: 2,
            class: "size-6 text-blue-500",
            "data-testid": "icon-info"
          })) : Z("", !0),
          t.toast.variant === "warning" ? (S(), B(o, {
            key: 3,
            class: "size-6 text-yellow-500",
            "data-testid": "icon-warning"
          })) : Z("", !0)
        ]),
        C("div", N_, [
          C("p", F_, Q(t.toast.title), 1),
          t.toast.description ? (S(), I("p", L_, Q(t.toast.description), 1)) : Z("", !0)
        ]),
        t.toast.dismissible ? (S(), I("button", {
          key: 0,
          class: "ms-auto",
          "aria-label": "Dismiss",
          onClick: r[0] || (r[0] = (l) => t.$emit("dismiss"))
        }, [
          j(i, { class: "size-4" })
        ])) : Z("", !0)
      ], 2);
    };
  }
}), sS = /* @__PURE__ */ V({
  __name: "FdxToaster",
  props: {
    placement: { default: "bottom-end" }
  },
  setup(e) {
    const { dismissToast: t, toasts: r } = p_();
    return (n, a) => (S(), I("div", {
      class: de(["fixed z-10 flex flex-col gap-y-2", {
        "start-6 top-6": n.placement === "top-start",
        "bottom-6 start-6": n.placement === "bottom-start",
        "end-6 top-6": n.placement === "top-end",
        "bottom-6 end-6": n.placement === "bottom-end"
      }])
    }, [
      j(Su, { name: "fade" }, {
        default: D(() => [
          (S(!0), I(le, null, Ee(g(r), (d) => (S(), B(B_, {
            key: d.id,
            toast: d,
            onDismiss: (o) => g(t)(d.id),
            "data-testid": "toast-item"
          }, null, 8, ["toast", "onDismiss"]))), 128))
        ]),
        _: 1
      })
    ], 2));
  }
}), V_ = { ref: "fdx-tooltip-container" }, uS = /* @__PURE__ */ V({
  __name: "FdxTooltip",
  props: {
    autoHide: { type: Boolean, default: !0 },
    delay: { default: 0 },
    disabled: { type: Boolean, default: !1 },
    display: { default: "inline-block" },
    placement: { default: "auto" },
    popperHideTriggers: { default: () => ["hover", "touch"] },
    popperShowTriggers: { default: () => ["hover", "touch"] },
    popperTriggers: { default: () => ["hover", "touch"] },
    triggers: { default: () => ["hover", "touch"] }
  },
  setup(e) {
    const t = tr(), r = At("fdx-tooltip-container"), n = H(null);
    He(() => {
      var d;
      n.value = ((d = r.value) == null ? void 0 : d.closest("dialog")) || null, n.value && !n.value.dataset.name && (n.value.dataset.name = `fdx-tooltip-${t}`);
    });
    const a = O(() => {
      var d;
      return n.value ? `[data-name="${(d = n.value) == null ? void 0 : d.dataset.name}"]` : void 0;
    });
    return (d, o) => (S(), I("div", V_, [
      j(g(o$), {
        disabled: d.disabled,
        triggers: d.triggers,
        "popper-triggers": d.popperTriggers,
        "popper-hide-triggers": d.popperHideTriggers,
        "popper-show-triggers": d.popperShowTriggers,
        placement: d.placement,
        "auto-hide": d.autoHide,
        class: de([d.display]),
        delay: d.delay,
        container: a.value
      }, {
        popper: D(() => [
          F(d.$slots, "content")
        ]),
        default: D(() => [
          F(d.$slots, "default")
        ]),
        _: 3
      }, 8, ["disabled", "triggers", "popper-triggers", "popper-hide-triggers", "popper-show-triggers", "placement", "auto-hide", "class", "delay", "container"])
    ], 512));
  }
});
var S0 = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function j_(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function G_(e) {
  if (Object.prototype.hasOwnProperty.call(e, "__esModule")) return e;
  var t = e.default;
  if (typeof t == "function") {
    var r = function n() {
      return this instanceof n ? Reflect.construct(t, arguments, this.constructor) : t.apply(this, arguments);
    };
    r.prototype = t.prototype;
  } else r = {};
  return Object.defineProperty(r, "__esModule", { value: !0 }), Object.keys(e).forEach(function(n) {
    var a = Object.getOwnPropertyDescriptor(e, n);
    Object.defineProperty(r, n, a.get ? a : {
      enumerable: !0,
      get: function() {
        return e[n];
      }
    });
  }), r;
}
var Od, C0;
function on() {
  return C0 || (C0 = 1, Od = TypeError), Od;
}
const U_ = {}, H_ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: U_
}, Symbol.toStringTag, { value: "Module" })), W_ = /* @__PURE__ */ G_(H_);
var Td, P0;
function Za() {
  if (P0) return Td;
  P0 = 1;
  var e = typeof Map == "function" && Map.prototype, t = Object.getOwnPropertyDescriptor && e ? Object.getOwnPropertyDescriptor(Map.prototype, "size") : null, r = e && t && typeof t.get == "function" ? t.get : null, n = e && Map.prototype.forEach, a = typeof Set == "function" && Set.prototype, d = Object.getOwnPropertyDescriptor && a ? Object.getOwnPropertyDescriptor(Set.prototype, "size") : null, o = a && d && typeof d.get == "function" ? d.get : null, i = a && Set.prototype.forEach, l = typeof WeakMap == "function" && WeakMap.prototype, s = l ? WeakMap.prototype.has : null, u = typeof WeakSet == "function" && WeakSet.prototype, $ = u ? WeakSet.prototype.has : null, y = typeof WeakRef == "function" && WeakRef.prototype, h = y ? WeakRef.prototype.deref : null, c = Boolean.prototype.valueOf, p = Object.prototype.toString, f = Function.prototype.toString, v = String.prototype.match, w = String.prototype.slice, m = String.prototype.replace, b = String.prototype.toUpperCase, _ = String.prototype.toLowerCase, x = RegExp.prototype.test, A = Array.prototype.concat, P = Array.prototype.join, k = Array.prototype.slice, R = Math.floor, L = typeof BigInt == "function" ? BigInt.prototype.valueOf : null, N = Object.getOwnPropertySymbols, U = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Symbol.prototype.toString : null, G = typeof Symbol == "function" && typeof Symbol.iterator == "object", Y = typeof Symbol == "function" && Symbol.toStringTag && (typeof Symbol.toStringTag === G || !0) ? Symbol.toStringTag : null, te = Object.prototype.propertyIsEnumerable, re = (typeof Reflect == "function" ? Reflect.getPrototypeOf : Object.getPrototypeOf) || ([].__proto__ === Array.prototype ? function(E) {
    return E.__proto__;
  } : null);
  function M(E, T) {
    if (E === 1 / 0 || E === -1 / 0 || E !== E || E && E > -1e3 && E < 1e3 || x.call(/e/, T))
      return T;
    var fe = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
    if (typeof E == "number") {
      var xe = E < 0 ? -R(-E) : R(E);
      if (xe !== E) {
        var Ce = String(xe), ne = w.call(T, Ce.length + 1);
        return m.call(Ce, fe, "$&_") + "." + m.call(m.call(ne, /([0-9]{3})/g, "$&_"), /_$/, "");
      }
    }
    return m.call(T, fe, "$&_");
  }
  var X = W_, ee = X.custom, Se = De(ee) ? ee : null, he = {
    __proto__: null,
    double: '"',
    single: "'"
  }, ve = {
    __proto__: null,
    double: /(["\\])/g,
    single: /(['\\])/g
  };
  Td = function E(T, fe, xe, Ce) {
    var ne = fe || {};
    if (be(ne, "quoteStyle") && !be(he, ne.quoteStyle))
      throw new TypeError('option "quoteStyle" must be "single" or "double"');
    if (be(ne, "maxStringLength") && (typeof ne.maxStringLength == "number" ? ne.maxStringLength < 0 && ne.maxStringLength !== 1 / 0 : ne.maxStringLength !== null))
      throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
    var Dt = be(ne, "customInspect") ? ne.customInspect : !0;
    if (typeof Dt != "boolean" && Dt !== "symbol")
      throw new TypeError("option \"customInspect\", if provided, must be `true`, `false`, or `'symbol'`");
    if (be(ne, "indent") && ne.indent !== null && ne.indent !== "	" && !(parseInt(ne.indent, 10) === ne.indent && ne.indent > 0))
      throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
    if (be(ne, "numericSeparator") && typeof ne.numericSeparator != "boolean")
      throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
    var or = ne.numericSeparator;
    if (typeof T > "u")
      return "undefined";
    if (T === null)
      return "null";
    if (typeof T == "boolean")
      return T ? "true" : "false";
    if (typeof T == "string")
      return zi(T, ne);
    if (typeof T == "number") {
      if (T === 0)
        return 1 / 0 / T > 0 ? "0" : "-0";
      var Ge = String(T);
      return or ? M(T, Ge) : Ge;
    }
    if (typeof T == "bigint") {
      var Nt = String(T) + "n";
      return or ? M(T, Nt) : Nt;
    }
    var ed = typeof ne.depth > "u" ? 5 : ne.depth;
    if (typeof xe > "u" && (xe = 0), xe >= ed && ed > 0 && typeof T == "object")
      return ce(T) ? "[Array]" : "[Object]";
    var Mr = A2(ne, xe);
    if (typeof Ce > "u")
      Ce = [];
    else if (Ke(Ce, T) >= 0)
      return "[Circular]";
    function Ze(Or, Jn, M2) {
      if (Jn && (Ce = k.call(Ce), Ce.push(Jn)), M2) {
        var tl = {
          depth: ne.depth
        };
        return be(ne, "quoteStyle") && (tl.quoteStyle = ne.quoteStyle), E(Or, tl, xe + 1, Ce);
      }
      return E(Or, ne, xe + 1, Ce);
    }
    if (typeof T == "function" && !ge(T)) {
      var Ki = ot(T), Yi = Yn(T, Ze);
      return "[Function" + (Ki ? ": " + Ki : " (anonymous)") + "]" + (Yi.length > 0 ? " { " + P.call(Yi, ", ") + " }" : "");
    }
    if (De(T)) {
      var Zi = G ? m.call(String(T), /^(Symbol\(.*\))_[^)]*$/, "$1") : U.call(T);
      return typeof T == "object" && !G ? ln(Zi) : Zi;
    }
    if (S2(T)) {
      for (var sn = "<" + _.call(String(T.nodeName)), td = T.attributes || [], Zn = 0; Zn < td.length; Zn++)
        sn += " " + td[Zn].name + "=" + _e(Re(td[Zn].value), "double", ne);
      return sn += ">", T.childNodes && T.childNodes.length && (sn += "..."), sn += "</" + _.call(String(T.nodeName)) + ">", sn;
    }
    if (ce(T)) {
      if (T.length === 0)
        return "[]";
      var rd = Yn(T, Ze);
      return Mr && !P2(rd) ? "[" + Xa(rd, Mr) + "]" : "[ " + P.call(rd, ", ") + " ]";
    }
    if (W(T)) {
      var nd = Yn(T, Ze);
      return !("cause" in Error.prototype) && "cause" in T && !te.call(T, "cause") ? "{ [" + String(T) + "] " + P.call(A.call("[cause]: " + Ze(T.cause), nd), ", ") + " }" : nd.length === 0 ? "[" + String(T) + "]" : "{ [" + String(T) + "] " + P.call(nd, ", ") + " }";
    }
    if (typeof T == "object" && Dt) {
      if (Se && typeof T[Se] == "function" && X)
        return X(T, { depth: ed - xe });
      if (Dt !== "symbol" && typeof T.inspect == "function")
        return T.inspect();
    }
    if (Ye(T)) {
      var Ji = [];
      return n && n.call(T, function(Or, Jn) {
        Ji.push(Ze(Jn, T, !0) + " => " + Ze(Or, T));
      }), qi("Map", r.call(T), Ji, Mr);
    }
    if (Er(T)) {
      var Qi = [];
      return i && i.call(T, function(Or) {
        Qi.push(Ze(Or, T));
      }), qi("Set", o.call(T), Qi, Mr);
    }
    if (Pr(T))
      return Qa("WeakMap");
    if (x2(T))
      return Qa("WeakSet");
    if (Ar(T))
      return Qa("WeakRef");
    if (ie(T))
      return ln(Ze(Number(T)));
    if (Ve(T))
      return ln(Ze(L.call(T)));
    if (Oe(T))
      return ln(c.call(T));
    if (oe(T))
      return ln(Ze(String(T)));
    if (typeof window < "u" && T === window)
      return "{ [object Window] }";
    if (typeof globalThis < "u" && T === globalThis || typeof S0 < "u" && T === S0)
      return "{ [object globalThis] }";
    if (!Le(T) && !ge(T)) {
      var ad = Yn(T, Ze), Xi = re ? re(T) === Object.prototype : T instanceof Object || T.constructor === Object, dd = T instanceof Object ? "" : "null prototype", el = !Xi && Y && Object(T) === T && Y in T ? w.call(we(T), 8, -1) : dd ? "Object" : "", E2 = Xi || typeof T.constructor != "function" ? "" : T.constructor.name ? T.constructor.name + " " : "", od = E2 + (el || dd ? "[" + P.call(A.call([], el || [], dd || []), ": ") + "] " : "");
      return ad.length === 0 ? od + "{}" : Mr ? od + "{" + Xa(ad, Mr) + "}" : od + "{ " + P.call(ad, ", ") + " }";
    }
    return String(T);
  };
  function _e(E, T, fe) {
    var xe = fe.quoteStyle || T, Ce = he[xe];
    return Ce + E + Ce;
  }
  function Re(E) {
    return m.call(String(E), /"/g, "&quot;");
  }
  function ke(E) {
    return !Y || !(typeof E == "object" && (Y in E || typeof E[Y] < "u"));
  }
  function ce(E) {
    return we(E) === "[object Array]" && ke(E);
  }
  function Le(E) {
    return we(E) === "[object Date]" && ke(E);
  }
  function ge(E) {
    return we(E) === "[object RegExp]" && ke(E);
  }
  function W(E) {
    return we(E) === "[object Error]" && ke(E);
  }
  function oe(E) {
    return we(E) === "[object String]" && ke(E);
  }
  function ie(E) {
    return we(E) === "[object Number]" && ke(E);
  }
  function Oe(E) {
    return we(E) === "[object Boolean]" && ke(E);
  }
  function De(E) {
    if (G)
      return E && typeof E == "object" && E instanceof Symbol;
    if (typeof E == "symbol")
      return !0;
    if (!E || typeof E != "object" || !U)
      return !1;
    try {
      return U.call(E), !0;
    } catch {
    }
    return !1;
  }
  function Ve(E) {
    if (!E || typeof E != "object" || !L)
      return !1;
    try {
      return L.call(E), !0;
    } catch {
    }
    return !1;
  }
  var J = Object.prototype.hasOwnProperty || function(E) {
    return E in this;
  };
  function be(E, T) {
    return J.call(E, T);
  }
  function we(E) {
    return p.call(E);
  }
  function ot(E) {
    if (E.name)
      return E.name;
    var T = v.call(f.call(E), /^function\s*([\w$]+)/);
    return T ? T[1] : null;
  }
  function Ke(E, T) {
    if (E.indexOf)
      return E.indexOf(T);
    for (var fe = 0, xe = E.length; fe < xe; fe++)
      if (E[fe] === T)
        return fe;
    return -1;
  }
  function Ye(E) {
    if (!r || !E || typeof E != "object")
      return !1;
    try {
      r.call(E);
      try {
        o.call(E);
      } catch {
        return !0;
      }
      return E instanceof Map;
    } catch {
    }
    return !1;
  }
  function Pr(E) {
    if (!s || !E || typeof E != "object")
      return !1;
    try {
      s.call(E, s);
      try {
        $.call(E, $);
      } catch {
        return !0;
      }
      return E instanceof WeakMap;
    } catch {
    }
    return !1;
  }
  function Ar(E) {
    if (!h || !E || typeof E != "object")
      return !1;
    try {
      return h.call(E), !0;
    } catch {
    }
    return !1;
  }
  function Er(E) {
    if (!o || !E || typeof E != "object")
      return !1;
    try {
      o.call(E);
      try {
        r.call(E);
      } catch {
        return !0;
      }
      return E instanceof Set;
    } catch {
    }
    return !1;
  }
  function x2(E) {
    if (!$ || !E || typeof E != "object")
      return !1;
    try {
      $.call(E, $);
      try {
        s.call(E, s);
      } catch {
        return !0;
      }
      return E instanceof WeakSet;
    } catch {
    }
    return !1;
  }
  function S2(E) {
    return !E || typeof E != "object" ? !1 : typeof HTMLElement < "u" && E instanceof HTMLElement ? !0 : typeof E.nodeName == "string" && typeof E.getAttribute == "function";
  }
  function zi(E, T) {
    if (E.length > T.maxStringLength) {
      var fe = E.length - T.maxStringLength, xe = "... " + fe + " more character" + (fe > 1 ? "s" : "");
      return zi(w.call(E, 0, T.maxStringLength), T) + xe;
    }
    var Ce = ve[T.quoteStyle || "single"];
    Ce.lastIndex = 0;
    var ne = m.call(m.call(E, Ce, "\\$1"), /[\x00-\x1f]/g, C2);
    return _e(ne, "single", T);
  }
  function C2(E) {
    var T = E.charCodeAt(0), fe = {
      8: "b",
      9: "t",
      10: "n",
      12: "f",
      13: "r"
    }[T];
    return fe ? "\\" + fe : "\\x" + (T < 16 ? "0" : "") + b.call(T.toString(16));
  }
  function ln(E) {
    return "Object(" + E + ")";
  }
  function Qa(E) {
    return E + " { ? }";
  }
  function qi(E, T, fe, xe) {
    var Ce = xe ? Xa(fe, xe) : P.call(fe, ", ");
    return E + " (" + T + ") {" + Ce + "}";
  }
  function P2(E) {
    for (var T = 0; T < E.length; T++)
      if (Ke(E[T], `
`) >= 0)
        return !1;
    return !0;
  }
  function A2(E, T) {
    var fe;
    if (E.indent === "	")
      fe = "	";
    else if (typeof E.indent == "number" && E.indent > 0)
      fe = P.call(Array(E.indent + 1), " ");
    else
      return null;
    return {
      base: fe,
      prev: P.call(Array(T + 1), fe)
    };
  }
  function Xa(E, T) {
    if (E.length === 0)
      return "";
    var fe = `
` + T.prev + T.base;
    return fe + P.call(E, "," + fe) + `
` + T.prev;
  }
  function Yn(E, T) {
    var fe = ce(E), xe = [];
    if (fe) {
      xe.length = E.length;
      for (var Ce = 0; Ce < E.length; Ce++)
        xe[Ce] = be(E, Ce) ? T(E[Ce], E) : "";
    }
    var ne = typeof N == "function" ? N(E) : [], Dt;
    if (G) {
      Dt = {};
      for (var or = 0; or < ne.length; or++)
        Dt["$" + ne[or]] = ne[or];
    }
    for (var Ge in E)
      be(E, Ge) && (fe && String(Number(Ge)) === Ge && Ge < E.length || G && Dt["$" + Ge] instanceof Symbol || (x.call(/[^\w$]/, Ge) ? xe.push(T(Ge, E) + ": " + T(E[Ge], E)) : xe.push(Ge + ": " + T(E[Ge], E))));
    if (typeof N == "function")
      for (var Nt = 0; Nt < ne.length; Nt++)
        te.call(E, ne[Nt]) && xe.push("[" + T(ne[Nt]) + "]: " + T(E[ne[Nt]], E));
    return xe;
  }
  return Td;
}
var kd, A0;
function z_() {
  if (A0) return kd;
  A0 = 1;
  var e = /* @__PURE__ */ Za(), t = /* @__PURE__ */ on(), r = function(i, l, s) {
    for (var u = i, $; ($ = u.next) != null; u = $)
      if ($.key === l)
        return u.next = $.next, s || ($.next = /** @type {NonNullable<typeof list.next>} */
        i.next, i.next = $), $;
  }, n = function(i, l) {
    if (i) {
      var s = r(i, l);
      return s && s.value;
    }
  }, a = function(i, l, s) {
    var u = r(i, l);
    u ? u.value = s : i.next = /** @type {import('./list.d.ts').ListNode<typeof value, typeof key>} */
    {
      // eslint-disable-line no-param-reassign, no-extra-parens
      key: l,
      next: i.next,
      value: s
    };
  }, d = function(i, l) {
    return i ? !!r(i, l) : !1;
  }, o = function(i, l) {
    if (i)
      return r(i, l, !0);
  };
  return kd = function() {
    var l, s = {
      assert: function(u) {
        if (!s.has(u))
          throw new t("Side channel does not contain " + e(u));
      },
      delete: function(u) {
        var $ = l && l.next, y = o(l, u);
        return y && $ && $ === y && (l = void 0), !!y;
      },
      get: function(u) {
        return n(l, u);
      },
      has: function(u) {
        return d(l, u);
      },
      set: function(u, $) {
        l || (l = {
          next: void 0
        }), a(
          /** @type {NonNullable<typeof $o>} */
          l,
          u,
          $
        );
      }
    };
    return s;
  }, kd;
}
var Id, E0;
function $2() {
  return E0 || (E0 = 1, Id = Object), Id;
}
var Rd, M0;
function q_() {
  return M0 || (M0 = 1, Rd = Error), Rd;
}
var Dd, O0;
function K_() {
  return O0 || (O0 = 1, Dd = EvalError), Dd;
}
var Nd, T0;
function Y_() {
  return T0 || (T0 = 1, Nd = RangeError), Nd;
}
var Fd, k0;
function Z_() {
  return k0 || (k0 = 1, Fd = ReferenceError), Fd;
}
var Ld, I0;
function J_() {
  return I0 || (I0 = 1, Ld = SyntaxError), Ld;
}
var Bd, R0;
function Q_() {
  return R0 || (R0 = 1, Bd = URIError), Bd;
}
var Vd, D0;
function X_() {
  return D0 || (D0 = 1, Vd = Math.abs), Vd;
}
var jd, N0;
function ex() {
  return N0 || (N0 = 1, jd = Math.floor), jd;
}
var Gd, F0;
function tx() {
  return F0 || (F0 = 1, Gd = Math.max), Gd;
}
var Ud, L0;
function rx() {
  return L0 || (L0 = 1, Ud = Math.min), Ud;
}
var Hd, B0;
function nx() {
  return B0 || (B0 = 1, Hd = Math.pow), Hd;
}
var Wd, V0;
function ax() {
  return V0 || (V0 = 1, Wd = Math.round), Wd;
}
var zd, j0;
function dx() {
  return j0 || (j0 = 1, zd = Number.isNaN || function(t) {
    return t !== t;
  }), zd;
}
var qd, G0;
function ox() {
  if (G0) return qd;
  G0 = 1;
  var e = /* @__PURE__ */ dx();
  return qd = function(r) {
    return e(r) || r === 0 ? r : r < 0 ? -1 : 1;
  }, qd;
}
var Kd, U0;
function ix() {
  return U0 || (U0 = 1, Kd = Object.getOwnPropertyDescriptor), Kd;
}
var Yd, H0;
function p2() {
  if (H0) return Yd;
  H0 = 1;
  var e = /* @__PURE__ */ ix();
  if (e)
    try {
      e([], "length");
    } catch {
      e = null;
    }
  return Yd = e, Yd;
}
var Zd, W0;
function lx() {
  if (W0) return Zd;
  W0 = 1;
  var e = Object.defineProperty || !1;
  if (e)
    try {
      e({}, "a", { value: 1 });
    } catch {
      e = !1;
    }
  return Zd = e, Zd;
}
var Jd, z0;
function sx() {
  return z0 || (z0 = 1, Jd = function() {
    if (typeof Symbol != "function" || typeof Object.getOwnPropertySymbols != "function")
      return !1;
    if (typeof Symbol.iterator == "symbol")
      return !0;
    var t = {}, r = Symbol("test"), n = Object(r);
    if (typeof r == "string" || Object.prototype.toString.call(r) !== "[object Symbol]" || Object.prototype.toString.call(n) !== "[object Symbol]")
      return !1;
    var a = 42;
    t[r] = a;
    for (var d in t)
      return !1;
    if (typeof Object.keys == "function" && Object.keys(t).length !== 0 || typeof Object.getOwnPropertyNames == "function" && Object.getOwnPropertyNames(t).length !== 0)
      return !1;
    var o = Object.getOwnPropertySymbols(t);
    if (o.length !== 1 || o[0] !== r || !Object.prototype.propertyIsEnumerable.call(t, r))
      return !1;
    if (typeof Object.getOwnPropertyDescriptor == "function") {
      var i = (
        /** @type {PropertyDescriptor} */
        Object.getOwnPropertyDescriptor(t, r)
      );
      if (i.value !== a || i.enumerable !== !0)
        return !1;
    }
    return !0;
  }), Jd;
}
var Qd, q0;
function ux() {
  if (q0) return Qd;
  q0 = 1;
  var e = typeof Symbol < "u" && Symbol, t = sx();
  return Qd = function() {
    return typeof e != "function" || typeof Symbol != "function" || typeof e("foo") != "symbol" || typeof Symbol("bar") != "symbol" ? !1 : t();
  }, Qd;
}
var Xd, K0;
function m2() {
  return K0 || (K0 = 1, Xd = typeof Reflect < "u" && Reflect.getPrototypeOf || null), Xd;
}
var eo, Y0;
function h2() {
  if (Y0) return eo;
  Y0 = 1;
  var e = /* @__PURE__ */ $2();
  return eo = e.getPrototypeOf || null, eo;
}
var to, Z0;
function cx() {
  if (Z0) return to;
  Z0 = 1;
  var e = "Function.prototype.bind called on incompatible ", t = Object.prototype.toString, r = Math.max, n = "[object Function]", a = function(l, s) {
    for (var u = [], $ = 0; $ < l.length; $ += 1)
      u[$] = l[$];
    for (var y = 0; y < s.length; y += 1)
      u[y + l.length] = s[y];
    return u;
  }, d = function(l, s) {
    for (var u = [], $ = s, y = 0; $ < l.length; $ += 1, y += 1)
      u[y] = l[$];
    return u;
  }, o = function(i, l) {
    for (var s = "", u = 0; u < i.length; u += 1)
      s += i[u], u + 1 < i.length && (s += l);
    return s;
  };
  return to = function(l) {
    var s = this;
    if (typeof s != "function" || t.apply(s) !== n)
      throw new TypeError(e + s);
    for (var u = d(arguments, 1), $, y = function() {
      if (this instanceof $) {
        var v = s.apply(
          this,
          a(u, arguments)
        );
        return Object(v) === v ? v : this;
      }
      return s.apply(
        l,
        a(u, arguments)
      );
    }, h = r(0, s.length - u.length), c = [], p = 0; p < h; p++)
      c[p] = "$" + p;
    if ($ = Function("binder", "return function (" + o(c, ",") + "){ return binder.apply(this,arguments); }")(y), s.prototype) {
      var f = function() {
      };
      f.prototype = s.prototype, $.prototype = new f(), f.prototype = null;
    }
    return $;
  }, to;
}
var ro, J0;
function Ja() {
  if (J0) return ro;
  J0 = 1;
  var e = cx();
  return ro = Function.prototype.bind || e, ro;
}
var no, Q0;
function Ui() {
  return Q0 || (Q0 = 1, no = Function.prototype.call), no;
}
var ao, X0;
function v2() {
  return X0 || (X0 = 1, ao = Function.prototype.apply), ao;
}
var oo, eu;
function fx() {
  return eu || (eu = 1, oo = typeof Reflect < "u" && Reflect && Reflect.apply), oo;
}
var io, tu;
function $x() {
  if (tu) return io;
  tu = 1;
  var e = Ja(), t = v2(), r = Ui(), n = fx();
  return io = n || e.call(r, t), io;
}
var lo, ru;
function y2() {
  if (ru) return lo;
  ru = 1;
  var e = Ja(), t = /* @__PURE__ */ on(), r = Ui(), n = $x();
  return lo = function(d) {
    if (d.length < 1 || typeof d[0] != "function")
      throw new t("a function is required");
    return n(e, r, d);
  }, lo;
}
var so, nu;
function px() {
  if (nu) return so;
  nu = 1;
  var e = y2(), t = /* @__PURE__ */ p2(), r;
  try {
    r = /** @type {{ __proto__?: typeof Array.prototype }} */
    [].__proto__ === Array.prototype;
  } catch (o) {
    if (!o || typeof o != "object" || !("code" in o) || o.code !== "ERR_PROTO_ACCESS")
      throw o;
  }
  var n = !!r && t && t(
    Object.prototype,
    /** @type {keyof typeof Object.prototype} */
    "__proto__"
  ), a = Object, d = a.getPrototypeOf;
  return so = n && typeof n.get == "function" ? e([n.get]) : typeof d == "function" ? (
    /** @type {import('./get')} */
    function(i) {
      return d(i == null ? i : a(i));
    }
  ) : !1, so;
}
var uo, au;
function mx() {
  if (au) return uo;
  au = 1;
  var e = m2(), t = h2(), r = /* @__PURE__ */ px();
  return uo = e ? function(a) {
    return e(a);
  } : t ? function(a) {
    if (!a || typeof a != "object" && typeof a != "function")
      throw new TypeError("getProto: not an object");
    return t(a);
  } : r ? function(a) {
    return r(a);
  } : null, uo;
}
var co, du;
function hx() {
  if (du) return co;
  du = 1;
  var e = Function.prototype.call, t = Object.prototype.hasOwnProperty, r = Ja();
  return co = r.call(e, t), co;
}
var fo, ou;
function Hi() {
  if (ou) return fo;
  ou = 1;
  var e, t = /* @__PURE__ */ $2(), r = /* @__PURE__ */ q_(), n = /* @__PURE__ */ K_(), a = /* @__PURE__ */ Y_(), d = /* @__PURE__ */ Z_(), o = /* @__PURE__ */ J_(), i = /* @__PURE__ */ on(), l = /* @__PURE__ */ Q_(), s = /* @__PURE__ */ X_(), u = /* @__PURE__ */ ex(), $ = /* @__PURE__ */ tx(), y = /* @__PURE__ */ rx(), h = /* @__PURE__ */ nx(), c = /* @__PURE__ */ ax(), p = /* @__PURE__ */ ox(), f = Function, v = function(ge) {
    try {
      return f('"use strict"; return (' + ge + ").constructor;")();
    } catch {
    }
  }, w = /* @__PURE__ */ p2(), m = /* @__PURE__ */ lx(), b = function() {
    throw new i();
  }, _ = w ? (function() {
    try {
      return arguments.callee, b;
    } catch {
      try {
        return w(arguments, "callee").get;
      } catch {
        return b;
      }
    }
  })() : b, x = ux()(), A = mx(), P = h2(), k = m2(), R = v2(), L = Ui(), N = {}, U = typeof Uint8Array > "u" || !A ? e : A(Uint8Array), G = {
    __proto__: null,
    "%AggregateError%": typeof AggregateError > "u" ? e : AggregateError,
    "%Array%": Array,
    "%ArrayBuffer%": typeof ArrayBuffer > "u" ? e : ArrayBuffer,
    "%ArrayIteratorPrototype%": x && A ? A([][Symbol.iterator]()) : e,
    "%AsyncFromSyncIteratorPrototype%": e,
    "%AsyncFunction%": N,
    "%AsyncGenerator%": N,
    "%AsyncGeneratorFunction%": N,
    "%AsyncIteratorPrototype%": N,
    "%Atomics%": typeof Atomics > "u" ? e : Atomics,
    "%BigInt%": typeof BigInt > "u" ? e : BigInt,
    "%BigInt64Array%": typeof BigInt64Array > "u" ? e : BigInt64Array,
    "%BigUint64Array%": typeof BigUint64Array > "u" ? e : BigUint64Array,
    "%Boolean%": Boolean,
    "%DataView%": typeof DataView > "u" ? e : DataView,
    "%Date%": Date,
    "%decodeURI%": decodeURI,
    "%decodeURIComponent%": decodeURIComponent,
    "%encodeURI%": encodeURI,
    "%encodeURIComponent%": encodeURIComponent,
    "%Error%": r,
    "%eval%": eval,
    // eslint-disable-line no-eval
    "%EvalError%": n,
    "%Float16Array%": typeof Float16Array > "u" ? e : Float16Array,
    "%Float32Array%": typeof Float32Array > "u" ? e : Float32Array,
    "%Float64Array%": typeof Float64Array > "u" ? e : Float64Array,
    "%FinalizationRegistry%": typeof FinalizationRegistry > "u" ? e : FinalizationRegistry,
    "%Function%": f,
    "%GeneratorFunction%": N,
    "%Int8Array%": typeof Int8Array > "u" ? e : Int8Array,
    "%Int16Array%": typeof Int16Array > "u" ? e : Int16Array,
    "%Int32Array%": typeof Int32Array > "u" ? e : Int32Array,
    "%isFinite%": isFinite,
    "%isNaN%": isNaN,
    "%IteratorPrototype%": x && A ? A(A([][Symbol.iterator]())) : e,
    "%JSON%": typeof JSON == "object" ? JSON : e,
    "%Map%": typeof Map > "u" ? e : Map,
    "%MapIteratorPrototype%": typeof Map > "u" || !x || !A ? e : A((/* @__PURE__ */ new Map())[Symbol.iterator]()),
    "%Math%": Math,
    "%Number%": Number,
    "%Object%": t,
    "%Object.getOwnPropertyDescriptor%": w,
    "%parseFloat%": parseFloat,
    "%parseInt%": parseInt,
    "%Promise%": typeof Promise > "u" ? e : Promise,
    "%Proxy%": typeof Proxy > "u" ? e : Proxy,
    "%RangeError%": a,
    "%ReferenceError%": d,
    "%Reflect%": typeof Reflect > "u" ? e : Reflect,
    "%RegExp%": RegExp,
    "%Set%": typeof Set > "u" ? e : Set,
    "%SetIteratorPrototype%": typeof Set > "u" || !x || !A ? e : A((/* @__PURE__ */ new Set())[Symbol.iterator]()),
    "%SharedArrayBuffer%": typeof SharedArrayBuffer > "u" ? e : SharedArrayBuffer,
    "%String%": String,
    "%StringIteratorPrototype%": x && A ? A(""[Symbol.iterator]()) : e,
    "%Symbol%": x ? Symbol : e,
    "%SyntaxError%": o,
    "%ThrowTypeError%": _,
    "%TypedArray%": U,
    "%TypeError%": i,
    "%Uint8Array%": typeof Uint8Array > "u" ? e : Uint8Array,
    "%Uint8ClampedArray%": typeof Uint8ClampedArray > "u" ? e : Uint8ClampedArray,
    "%Uint16Array%": typeof Uint16Array > "u" ? e : Uint16Array,
    "%Uint32Array%": typeof Uint32Array > "u" ? e : Uint32Array,
    "%URIError%": l,
    "%WeakMap%": typeof WeakMap > "u" ? e : WeakMap,
    "%WeakRef%": typeof WeakRef > "u" ? e : WeakRef,
    "%WeakSet%": typeof WeakSet > "u" ? e : WeakSet,
    "%Function.prototype.call%": L,
    "%Function.prototype.apply%": R,
    "%Object.defineProperty%": m,
    "%Object.getPrototypeOf%": P,
    "%Math.abs%": s,
    "%Math.floor%": u,
    "%Math.max%": $,
    "%Math.min%": y,
    "%Math.pow%": h,
    "%Math.round%": c,
    "%Math.sign%": p,
    "%Reflect.getPrototypeOf%": k
  };
  if (A)
    try {
      null.error;
    } catch (ge) {
      var Y = A(A(ge));
      G["%Error.prototype%"] = Y;
    }
  var te = function ge(W) {
    var oe;
    if (W === "%AsyncFunction%")
      oe = v("async function () {}");
    else if (W === "%GeneratorFunction%")
      oe = v("function* () {}");
    else if (W === "%AsyncGeneratorFunction%")
      oe = v("async function* () {}");
    else if (W === "%AsyncGenerator%") {
      var ie = ge("%AsyncGeneratorFunction%");
      ie && (oe = ie.prototype);
    } else if (W === "%AsyncIteratorPrototype%") {
      var Oe = ge("%AsyncGenerator%");
      Oe && A && (oe = A(Oe.prototype));
    }
    return G[W] = oe, oe;
  }, re = {
    __proto__: null,
    "%ArrayBufferPrototype%": ["ArrayBuffer", "prototype"],
    "%ArrayPrototype%": ["Array", "prototype"],
    "%ArrayProto_entries%": ["Array", "prototype", "entries"],
    "%ArrayProto_forEach%": ["Array", "prototype", "forEach"],
    "%ArrayProto_keys%": ["Array", "prototype", "keys"],
    "%ArrayProto_values%": ["Array", "prototype", "values"],
    "%AsyncFunctionPrototype%": ["AsyncFunction", "prototype"],
    "%AsyncGenerator%": ["AsyncGeneratorFunction", "prototype"],
    "%AsyncGeneratorPrototype%": ["AsyncGeneratorFunction", "prototype", "prototype"],
    "%BooleanPrototype%": ["Boolean", "prototype"],
    "%DataViewPrototype%": ["DataView", "prototype"],
    "%DatePrototype%": ["Date", "prototype"],
    "%ErrorPrototype%": ["Error", "prototype"],
    "%EvalErrorPrototype%": ["EvalError", "prototype"],
    "%Float32ArrayPrototype%": ["Float32Array", "prototype"],
    "%Float64ArrayPrototype%": ["Float64Array", "prototype"],
    "%FunctionPrototype%": ["Function", "prototype"],
    "%Generator%": ["GeneratorFunction", "prototype"],
    "%GeneratorPrototype%": ["GeneratorFunction", "prototype", "prototype"],
    "%Int8ArrayPrototype%": ["Int8Array", "prototype"],
    "%Int16ArrayPrototype%": ["Int16Array", "prototype"],
    "%Int32ArrayPrototype%": ["Int32Array", "prototype"],
    "%JSONParse%": ["JSON", "parse"],
    "%JSONStringify%": ["JSON", "stringify"],
    "%MapPrototype%": ["Map", "prototype"],
    "%NumberPrototype%": ["Number", "prototype"],
    "%ObjectPrototype%": ["Object", "prototype"],
    "%ObjProto_toString%": ["Object", "prototype", "toString"],
    "%ObjProto_valueOf%": ["Object", "prototype", "valueOf"],
    "%PromisePrototype%": ["Promise", "prototype"],
    "%PromiseProto_then%": ["Promise", "prototype", "then"],
    "%Promise_all%": ["Promise", "all"],
    "%Promise_reject%": ["Promise", "reject"],
    "%Promise_resolve%": ["Promise", "resolve"],
    "%RangeErrorPrototype%": ["RangeError", "prototype"],
    "%ReferenceErrorPrototype%": ["ReferenceError", "prototype"],
    "%RegExpPrototype%": ["RegExp", "prototype"],
    "%SetPrototype%": ["Set", "prototype"],
    "%SharedArrayBufferPrototype%": ["SharedArrayBuffer", "prototype"],
    "%StringPrototype%": ["String", "prototype"],
    "%SymbolPrototype%": ["Symbol", "prototype"],
    "%SyntaxErrorPrototype%": ["SyntaxError", "prototype"],
    "%TypedArrayPrototype%": ["TypedArray", "prototype"],
    "%TypeErrorPrototype%": ["TypeError", "prototype"],
    "%Uint8ArrayPrototype%": ["Uint8Array", "prototype"],
    "%Uint8ClampedArrayPrototype%": ["Uint8ClampedArray", "prototype"],
    "%Uint16ArrayPrototype%": ["Uint16Array", "prototype"],
    "%Uint32ArrayPrototype%": ["Uint32Array", "prototype"],
    "%URIErrorPrototype%": ["URIError", "prototype"],
    "%WeakMapPrototype%": ["WeakMap", "prototype"],
    "%WeakSetPrototype%": ["WeakSet", "prototype"]
  }, M = Ja(), X = /* @__PURE__ */ hx(), ee = M.call(L, Array.prototype.concat), Se = M.call(R, Array.prototype.splice), he = M.call(L, String.prototype.replace), ve = M.call(L, String.prototype.slice), _e = M.call(L, RegExp.prototype.exec), Re = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g, ke = /\\(\\)?/g, ce = function(W) {
    var oe = ve(W, 0, 1), ie = ve(W, -1);
    if (oe === "%" && ie !== "%")
      throw new o("invalid intrinsic syntax, expected closing `%`");
    if (ie === "%" && oe !== "%")
      throw new o("invalid intrinsic syntax, expected opening `%`");
    var Oe = [];
    return he(W, Re, function(De, Ve, J, be) {
      Oe[Oe.length] = J ? he(be, ke, "$1") : Ve || De;
    }), Oe;
  }, Le = function(W, oe) {
    var ie = W, Oe;
    if (X(re, ie) && (Oe = re[ie], ie = "%" + Oe[0] + "%"), X(G, ie)) {
      var De = G[ie];
      if (De === N && (De = te(ie)), typeof De > "u" && !oe)
        throw new i("intrinsic " + W + " exists, but is not available. Please file an issue!");
      return {
        alias: Oe,
        name: ie,
        value: De
      };
    }
    throw new o("intrinsic " + W + " does not exist!");
  };
  return fo = function(W, oe) {
    if (typeof W != "string" || W.length === 0)
      throw new i("intrinsic name must be a non-empty string");
    if (arguments.length > 1 && typeof oe != "boolean")
      throw new i('"allowMissing" argument must be a boolean');
    if (_e(/^%?[^%]*%?$/, W) === null)
      throw new o("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
    var ie = ce(W), Oe = ie.length > 0 ? ie[0] : "", De = Le("%" + Oe + "%", oe), Ve = De.name, J = De.value, be = !1, we = De.alias;
    we && (Oe = we[0], Se(ie, ee([0, 1], we)));
    for (var ot = 1, Ke = !0; ot < ie.length; ot += 1) {
      var Ye = ie[ot], Pr = ve(Ye, 0, 1), Ar = ve(Ye, -1);
      if ((Pr === '"' || Pr === "'" || Pr === "`" || Ar === '"' || Ar === "'" || Ar === "`") && Pr !== Ar)
        throw new o("property names with quotes must have matching quotes");
      if ((Ye === "constructor" || !Ke) && (be = !0), Oe += "." + Ye, Ve = "%" + Oe + "%", X(G, Ve))
        J = G[Ve];
      else if (J != null) {
        if (!(Ye in J)) {
          if (!oe)
            throw new i("base intrinsic for " + W + " exists, but the property is not available.");
          return;
        }
        if (w && ot + 1 >= ie.length) {
          var Er = w(J, Ye);
          Ke = !!Er, Ke && "get" in Er && !("originalValue" in Er.get) ? J = Er.get : J = J[Ye];
        } else
          Ke = X(J, Ye), J = J[Ye];
        Ke && !be && (G[Ve] = J);
      }
    }
    return J;
  }, fo;
}
var $o, iu;
function g2() {
  if (iu) return $o;
  iu = 1;
  var e = /* @__PURE__ */ Hi(), t = y2(), r = t([e("%String.prototype.indexOf%")]);
  return $o = function(a, d) {
    var o = (
      /** @type {(this: unknown, ...args: unknown[]) => unknown} */
      e(a, !!d)
    );
    return typeof o == "function" && r(a, ".prototype.") > -1 ? t(
      /** @type {const} */
      [o]
    ) : o;
  }, $o;
}
var po, lu;
function b2() {
  if (lu) return po;
  lu = 1;
  var e = /* @__PURE__ */ Hi(), t = /* @__PURE__ */ g2(), r = /* @__PURE__ */ Za(), n = /* @__PURE__ */ on(), a = e("%Map%", !0), d = t("Map.prototype.get", !0), o = t("Map.prototype.set", !0), i = t("Map.prototype.has", !0), l = t("Map.prototype.delete", !0), s = t("Map.prototype.size", !0);
  return po = !!a && /** @type {Exclude<import('.'), false>} */
  function() {
    var $, y = {
      assert: function(h) {
        if (!y.has(h))
          throw new n("Side channel does not contain " + r(h));
      },
      delete: function(h) {
        if ($) {
          var c = l($, h);
          return s($) === 0 && ($ = void 0), c;
        }
        return !1;
      },
      get: function(h) {
        if ($)
          return d($, h);
      },
      has: function(h) {
        return $ ? i($, h) : !1;
      },
      set: function(h, c) {
        $ || ($ = new a()), o($, h, c);
      }
    };
    return y;
  }, po;
}
var mo, su;
function vx() {
  if (su) return mo;
  su = 1;
  var e = /* @__PURE__ */ Hi(), t = /* @__PURE__ */ g2(), r = /* @__PURE__ */ Za(), n = b2(), a = /* @__PURE__ */ on(), d = e("%WeakMap%", !0), o = t("WeakMap.prototype.get", !0), i = t("WeakMap.prototype.set", !0), l = t("WeakMap.prototype.has", !0), s = t("WeakMap.prototype.delete", !0);
  return mo = d ? (
    /** @type {Exclude<import('.'), false>} */
    function() {
      var $, y, h = {
        assert: function(c) {
          if (!h.has(c))
            throw new a("Side channel does not contain " + r(c));
        },
        delete: function(c) {
          if (d && c && (typeof c == "object" || typeof c == "function")) {
            if ($)
              return s($, c);
          } else if (n && y)
            return y.delete(c);
          return !1;
        },
        get: function(c) {
          return d && c && (typeof c == "object" || typeof c == "function") && $ ? o($, c) : y && y.get(c);
        },
        has: function(c) {
          return d && c && (typeof c == "object" || typeof c == "function") && $ ? l($, c) : !!y && y.has(c);
        },
        set: function(c, p) {
          d && c && (typeof c == "object" || typeof c == "function") ? ($ || ($ = new d()), i($, c, p)) : n && (y || (y = n()), y.set(c, p));
        }
      };
      return h;
    }
  ) : n, mo;
}
var ho, uu;
function yx() {
  if (uu) return ho;
  uu = 1;
  var e = /* @__PURE__ */ on(), t = /* @__PURE__ */ Za(), r = z_(), n = b2(), a = vx(), d = a || n || r;
  return ho = function() {
    var i, l = {
      assert: function(s) {
        if (!l.has(s))
          throw new e("Side channel does not contain " + t(s));
      },
      delete: function(s) {
        return !!i && i.delete(s);
      },
      get: function(s) {
        return i && i.get(s);
      },
      has: function(s) {
        return !!i && i.has(s);
      },
      set: function(s, u) {
        i || (i = d()), i.set(s, u);
      }
    };
    return l;
  }, ho;
}
var vo, cu;
function Wi() {
  if (cu) return vo;
  cu = 1;
  var e = String.prototype.replace, t = /%20/g, r = {
    RFC1738: "RFC1738",
    RFC3986: "RFC3986"
  };
  return vo = {
    default: r.RFC3986,
    formatters: {
      RFC1738: function(n) {
        return e.call(n, t, "+");
      },
      RFC3986: function(n) {
        return String(n);
      }
    },
    RFC1738: r.RFC1738,
    RFC3986: r.RFC3986
  }, vo;
}
var yo, fu;
function w2() {
  if (fu) return yo;
  fu = 1;
  var e = /* @__PURE__ */ Wi(), t = Object.prototype.hasOwnProperty, r = Array.isArray, n = (function() {
    for (var f = [], v = 0; v < 256; ++v)
      f.push("%" + ((v < 16 ? "0" : "") + v.toString(16)).toUpperCase());
    return f;
  })(), a = function(v) {
    for (; v.length > 1; ) {
      var w = v.pop(), m = w.obj[w.prop];
      if (r(m)) {
        for (var b = [], _ = 0; _ < m.length; ++_)
          typeof m[_] < "u" && b.push(m[_]);
        w.obj[w.prop] = b;
      }
    }
  }, d = function(v, w) {
    for (var m = w && w.plainObjects ? { __proto__: null } : {}, b = 0; b < v.length; ++b)
      typeof v[b] < "u" && (m[b] = v[b]);
    return m;
  }, o = function f(v, w, m) {
    if (!w)
      return v;
    if (typeof w != "object" && typeof w != "function") {
      if (r(v))
        v.push(w);
      else if (v && typeof v == "object")
        (m && (m.plainObjects || m.allowPrototypes) || !t.call(Object.prototype, w)) && (v[w] = !0);
      else
        return [v, w];
      return v;
    }
    if (!v || typeof v != "object")
      return [v].concat(w);
    var b = v;
    return r(v) && !r(w) && (b = d(v, m)), r(v) && r(w) ? (w.forEach(function(_, x) {
      if (t.call(v, x)) {
        var A = v[x];
        A && typeof A == "object" && _ && typeof _ == "object" ? v[x] = f(A, _, m) : v.push(_);
      } else
        v[x] = _;
    }), v) : Object.keys(w).reduce(function(_, x) {
      var A = w[x];
      return t.call(_, x) ? _[x] = f(_[x], A, m) : _[x] = A, _;
    }, b);
  }, i = function(v, w) {
    return Object.keys(w).reduce(function(m, b) {
      return m[b] = w[b], m;
    }, v);
  }, l = function(f, v, w) {
    var m = f.replace(/\+/g, " ");
    if (w === "iso-8859-1")
      return m.replace(/%[0-9a-f]{2}/gi, unescape);
    try {
      return decodeURIComponent(m);
    } catch {
      return m;
    }
  }, s = 1024, u = function(v, w, m, b, _) {
    if (v.length === 0)
      return v;
    var x = v;
    if (typeof v == "symbol" ? x = Symbol.prototype.toString.call(v) : typeof v != "string" && (x = String(v)), m === "iso-8859-1")
      return escape(x).replace(/%u[0-9a-f]{4}/gi, function(U) {
        return "%26%23" + parseInt(U.slice(2), 16) + "%3B";
      });
    for (var A = "", P = 0; P < x.length; P += s) {
      for (var k = x.length >= s ? x.slice(P, P + s) : x, R = [], L = 0; L < k.length; ++L) {
        var N = k.charCodeAt(L);
        if (N === 45 || N === 46 || N === 95 || N === 126 || N >= 48 && N <= 57 || N >= 65 && N <= 90 || N >= 97 && N <= 122 || _ === e.RFC1738 && (N === 40 || N === 41)) {
          R[R.length] = k.charAt(L);
          continue;
        }
        if (N < 128) {
          R[R.length] = n[N];
          continue;
        }
        if (N < 2048) {
          R[R.length] = n[192 | N >> 6] + n[128 | N & 63];
          continue;
        }
        if (N < 55296 || N >= 57344) {
          R[R.length] = n[224 | N >> 12] + n[128 | N >> 6 & 63] + n[128 | N & 63];
          continue;
        }
        L += 1, N = 65536 + ((N & 1023) << 10 | k.charCodeAt(L) & 1023), R[R.length] = n[240 | N >> 18] + n[128 | N >> 12 & 63] + n[128 | N >> 6 & 63] + n[128 | N & 63];
      }
      A += R.join("");
    }
    return A;
  }, $ = function(v) {
    for (var w = [{ obj: { o: v }, prop: "o" }], m = [], b = 0; b < w.length; ++b)
      for (var _ = w[b], x = _.obj[_.prop], A = Object.keys(x), P = 0; P < A.length; ++P) {
        var k = A[P], R = x[k];
        typeof R == "object" && R !== null && m.indexOf(R) === -1 && (w.push({ obj: x, prop: k }), m.push(R));
      }
    return a(w), v;
  }, y = function(v) {
    return Object.prototype.toString.call(v) === "[object RegExp]";
  }, h = function(v) {
    return !v || typeof v != "object" ? !1 : !!(v.constructor && v.constructor.isBuffer && v.constructor.isBuffer(v));
  }, c = function(v, w) {
    return [].concat(v, w);
  }, p = function(v, w) {
    if (r(v)) {
      for (var m = [], b = 0; b < v.length; b += 1)
        m.push(w(v[b]));
      return m;
    }
    return w(v);
  };
  return yo = {
    arrayToObject: d,
    assign: i,
    combine: c,
    compact: $,
    decode: l,
    encode: u,
    isBuffer: h,
    isRegExp: y,
    maybeMap: p,
    merge: o
  }, yo;
}
var go, $u;
function gx() {
  if ($u) return go;
  $u = 1;
  var e = yx(), t = /* @__PURE__ */ w2(), r = /* @__PURE__ */ Wi(), n = Object.prototype.hasOwnProperty, a = {
    brackets: function(f) {
      return f + "[]";
    },
    comma: "comma",
    indices: function(f, v) {
      return f + "[" + v + "]";
    },
    repeat: function(f) {
      return f;
    }
  }, d = Array.isArray, o = Array.prototype.push, i = function(p, f) {
    o.apply(p, d(f) ? f : [f]);
  }, l = Date.prototype.toISOString, s = r.default, u = {
    addQueryPrefix: !1,
    allowDots: !1,
    allowEmptyArrays: !1,
    arrayFormat: "indices",
    charset: "utf-8",
    charsetSentinel: !1,
    commaRoundTrip: !1,
    delimiter: "&",
    encode: !0,
    encodeDotInKeys: !1,
    encoder: t.encode,
    encodeValuesOnly: !1,
    filter: void 0,
    format: s,
    formatter: r.formatters[s],
    // deprecated
    indices: !1,
    serializeDate: function(f) {
      return l.call(f);
    },
    skipNulls: !1,
    strictNullHandling: !1
  }, $ = function(f) {
    return typeof f == "string" || typeof f == "number" || typeof f == "boolean" || typeof f == "symbol" || typeof f == "bigint";
  }, y = {}, h = function p(f, v, w, m, b, _, x, A, P, k, R, L, N, U, G, Y, te, re) {
    for (var M = f, X = re, ee = 0, Se = !1; (X = X.get(y)) !== void 0 && !Se; ) {
      var he = X.get(f);
      if (ee += 1, typeof he < "u") {
        if (he === ee)
          throw new RangeError("Cyclic object value");
        Se = !0;
      }
      typeof X.get(y) > "u" && (ee = 0);
    }
    if (typeof k == "function" ? M = k(v, M) : M instanceof Date ? M = N(M) : w === "comma" && d(M) && (M = t.maybeMap(M, function(Ve) {
      return Ve instanceof Date ? N(Ve) : Ve;
    })), M === null) {
      if (_)
        return P && !Y ? P(v, u.encoder, te, "key", U) : v;
      M = "";
    }
    if ($(M) || t.isBuffer(M)) {
      if (P) {
        var ve = Y ? v : P(v, u.encoder, te, "key", U);
        return [G(ve) + "=" + G(P(M, u.encoder, te, "value", U))];
      }
      return [G(v) + "=" + G(String(M))];
    }
    var _e = [];
    if (typeof M > "u")
      return _e;
    var Re;
    if (w === "comma" && d(M))
      Y && P && (M = t.maybeMap(M, P)), Re = [{ value: M.length > 0 ? M.join(",") || null : void 0 }];
    else if (d(k))
      Re = k;
    else {
      var ke = Object.keys(M);
      Re = R ? ke.sort(R) : ke;
    }
    var ce = A ? String(v).replace(/\./g, "%2E") : String(v), Le = m && d(M) && M.length === 1 ? ce + "[]" : ce;
    if (b && d(M) && M.length === 0)
      return Le + "[]";
    for (var ge = 0; ge < Re.length; ++ge) {
      var W = Re[ge], oe = typeof W == "object" && W && typeof W.value < "u" ? W.value : M[W];
      if (!(x && oe === null)) {
        var ie = L && A ? String(W).replace(/\./g, "%2E") : String(W), Oe = d(M) ? typeof w == "function" ? w(Le, ie) : Le : Le + (L ? "." + ie : "[" + ie + "]");
        re.set(f, ee);
        var De = e();
        De.set(y, re), i(_e, p(
          oe,
          Oe,
          w,
          m,
          b,
          _,
          x,
          A,
          w === "comma" && Y && d(M) ? null : P,
          k,
          R,
          L,
          N,
          U,
          G,
          Y,
          te,
          De
        ));
      }
    }
    return _e;
  }, c = function(f) {
    if (!f)
      return u;
    if (typeof f.allowEmptyArrays < "u" && typeof f.allowEmptyArrays != "boolean")
      throw new TypeError("`allowEmptyArrays` option can only be `true` or `false`, when provided");
    if (typeof f.encodeDotInKeys < "u" && typeof f.encodeDotInKeys != "boolean")
      throw new TypeError("`encodeDotInKeys` option can only be `true` or `false`, when provided");
    if (f.encoder !== null && typeof f.encoder < "u" && typeof f.encoder != "function")
      throw new TypeError("Encoder has to be a function.");
    var v = f.charset || u.charset;
    if (typeof f.charset < "u" && f.charset !== "utf-8" && f.charset !== "iso-8859-1")
      throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
    var w = r.default;
    if (typeof f.format < "u") {
      if (!n.call(r.formatters, f.format))
        throw new TypeError("Unknown format option provided.");
      w = f.format;
    }
    var m = r.formatters[w], b = u.filter;
    (typeof f.filter == "function" || d(f.filter)) && (b = f.filter);
    var _;
    if (f.arrayFormat in a ? _ = f.arrayFormat : "indices" in f ? _ = f.indices ? "indices" : "repeat" : _ = u.arrayFormat, "commaRoundTrip" in f && typeof f.commaRoundTrip != "boolean")
      throw new TypeError("`commaRoundTrip` must be a boolean, or absent");
    var x = typeof f.allowDots > "u" ? f.encodeDotInKeys === !0 ? !0 : u.allowDots : !!f.allowDots;
    return {
      addQueryPrefix: typeof f.addQueryPrefix == "boolean" ? f.addQueryPrefix : u.addQueryPrefix,
      allowDots: x,
      allowEmptyArrays: typeof f.allowEmptyArrays == "boolean" ? !!f.allowEmptyArrays : u.allowEmptyArrays,
      arrayFormat: _,
      charset: v,
      charsetSentinel: typeof f.charsetSentinel == "boolean" ? f.charsetSentinel : u.charsetSentinel,
      commaRoundTrip: !!f.commaRoundTrip,
      delimiter: typeof f.delimiter > "u" ? u.delimiter : f.delimiter,
      encode: typeof f.encode == "boolean" ? f.encode : u.encode,
      encodeDotInKeys: typeof f.encodeDotInKeys == "boolean" ? f.encodeDotInKeys : u.encodeDotInKeys,
      encoder: typeof f.encoder == "function" ? f.encoder : u.encoder,
      encodeValuesOnly: typeof f.encodeValuesOnly == "boolean" ? f.encodeValuesOnly : u.encodeValuesOnly,
      filter: b,
      format: w,
      formatter: m,
      serializeDate: typeof f.serializeDate == "function" ? f.serializeDate : u.serializeDate,
      skipNulls: typeof f.skipNulls == "boolean" ? f.skipNulls : u.skipNulls,
      sort: typeof f.sort == "function" ? f.sort : null,
      strictNullHandling: typeof f.strictNullHandling == "boolean" ? f.strictNullHandling : u.strictNullHandling
    };
  };
  return go = function(p, f) {
    var v = p, w = c(f), m, b;
    typeof w.filter == "function" ? (b = w.filter, v = b("", v)) : d(w.filter) && (b = w.filter, m = b);
    var _ = [];
    if (typeof v != "object" || v === null)
      return "";
    var x = a[w.arrayFormat], A = x === "comma" && w.commaRoundTrip;
    m || (m = Object.keys(v)), w.sort && m.sort(w.sort);
    for (var P = e(), k = 0; k < m.length; ++k) {
      var R = m[k], L = v[R];
      w.skipNulls && L === null || i(_, h(
        L,
        R,
        x,
        A,
        w.allowEmptyArrays,
        w.strictNullHandling,
        w.skipNulls,
        w.encodeDotInKeys,
        w.encode ? w.encoder : null,
        w.filter,
        w.sort,
        w.allowDots,
        w.serializeDate,
        w.format,
        w.formatter,
        w.encodeValuesOnly,
        w.charset,
        P
      ));
    }
    var N = _.join(w.delimiter), U = w.addQueryPrefix === !0 ? "?" : "";
    return w.charsetSentinel && (w.charset === "iso-8859-1" ? U += "utf8=%26%2310003%3B&" : U += "utf8=%E2%9C%93&"), N.length > 0 ? U + N : "";
  }, go;
}
var bo, pu;
function bx() {
  if (pu) return bo;
  pu = 1;
  var e = /* @__PURE__ */ w2(), t = Object.prototype.hasOwnProperty, r = Array.isArray, n = {
    allowDots: !1,
    allowEmptyArrays: !1,
    allowPrototypes: !1,
    allowSparse: !1,
    arrayLimit: 20,
    charset: "utf-8",
    charsetSentinel: !1,
    comma: !1,
    decodeDotInKeys: !1,
    decoder: e.decode,
    delimiter: "&",
    depth: 5,
    duplicates: "combine",
    ignoreQueryPrefix: !1,
    interpretNumericEntities: !1,
    parameterLimit: 1e3,
    parseArrays: !0,
    plainObjects: !1,
    strictDepth: !1,
    strictNullHandling: !1,
    throwOnLimitExceeded: !1
  }, a = function(y) {
    return y.replace(/&#(\d+);/g, function(h, c) {
      return String.fromCharCode(parseInt(c, 10));
    });
  }, d = function(y, h, c) {
    if (y && typeof y == "string" && h.comma && y.indexOf(",") > -1)
      return y.split(",");
    if (h.throwOnLimitExceeded && c >= h.arrayLimit)
      throw new RangeError("Array limit exceeded. Only " + h.arrayLimit + " element" + (h.arrayLimit === 1 ? "" : "s") + " allowed in an array.");
    return y;
  }, o = "utf8=%26%2310003%3B", i = "utf8=%E2%9C%93", l = function(h, c) {
    var p = { __proto__: null }, f = c.ignoreQueryPrefix ? h.replace(/^\?/, "") : h;
    f = f.replace(/%5B/gi, "[").replace(/%5D/gi, "]");
    var v = c.parameterLimit === 1 / 0 ? void 0 : c.parameterLimit, w = f.split(
      c.delimiter,
      c.throwOnLimitExceeded ? v + 1 : v
    );
    if (c.throwOnLimitExceeded && w.length > v)
      throw new RangeError("Parameter limit exceeded. Only " + v + " parameter" + (v === 1 ? "" : "s") + " allowed.");
    var m = -1, b, _ = c.charset;
    if (c.charsetSentinel)
      for (b = 0; b < w.length; ++b)
        w[b].indexOf("utf8=") === 0 && (w[b] === i ? _ = "utf-8" : w[b] === o && (_ = "iso-8859-1"), m = b, b = w.length);
    for (b = 0; b < w.length; ++b)
      if (b !== m) {
        var x = w[b], A = x.indexOf("]="), P = A === -1 ? x.indexOf("=") : A + 1, k, R;
        P === -1 ? (k = c.decoder(x, n.decoder, _, "key"), R = c.strictNullHandling ? null : "") : (k = c.decoder(x.slice(0, P), n.decoder, _, "key"), R = e.maybeMap(
          d(
            x.slice(P + 1),
            c,
            r(p[k]) ? p[k].length : 0
          ),
          function(N) {
            return c.decoder(N, n.decoder, _, "value");
          }
        )), R && c.interpretNumericEntities && _ === "iso-8859-1" && (R = a(String(R))), x.indexOf("[]=") > -1 && (R = r(R) ? [R] : R);
        var L = t.call(p, k);
        L && c.duplicates === "combine" ? p[k] = e.combine(p[k], R) : (!L || c.duplicates === "last") && (p[k] = R);
      }
    return p;
  }, s = function(y, h, c, p) {
    var f = 0;
    if (y.length > 0 && y[y.length - 1] === "[]") {
      var v = y.slice(0, -1).join("");
      f = Array.isArray(h) && h[v] ? h[v].length : 0;
    }
    for (var w = p ? h : d(h, c, f), m = y.length - 1; m >= 0; --m) {
      var b, _ = y[m];
      if (_ === "[]" && c.parseArrays)
        b = c.allowEmptyArrays && (w === "" || c.strictNullHandling && w === null) ? [] : e.combine([], w);
      else {
        b = c.plainObjects ? { __proto__: null } : {};
        var x = _.charAt(0) === "[" && _.charAt(_.length - 1) === "]" ? _.slice(1, -1) : _, A = c.decodeDotInKeys ? x.replace(/%2E/g, ".") : x, P = parseInt(A, 10);
        !c.parseArrays && A === "" ? b = { 0: w } : !isNaN(P) && _ !== A && String(P) === A && P >= 0 && c.parseArrays && P <= c.arrayLimit ? (b = [], b[P] = w) : A !== "__proto__" && (b[A] = w);
      }
      w = b;
    }
    return w;
  }, u = function(h, c, p, f) {
    if (h) {
      var v = p.allowDots ? h.replace(/\.([^.[]+)/g, "[$1]") : h, w = /(\[[^[\]]*])/, m = /(\[[^[\]]*])/g, b = p.depth > 0 && w.exec(v), _ = b ? v.slice(0, b.index) : v, x = [];
      if (_) {
        if (!p.plainObjects && t.call(Object.prototype, _) && !p.allowPrototypes)
          return;
        x.push(_);
      }
      for (var A = 0; p.depth > 0 && (b = m.exec(v)) !== null && A < p.depth; ) {
        if (A += 1, !p.plainObjects && t.call(Object.prototype, b[1].slice(1, -1)) && !p.allowPrototypes)
          return;
        x.push(b[1]);
      }
      if (b) {
        if (p.strictDepth === !0)
          throw new RangeError("Input depth exceeded depth option of " + p.depth + " and strictDepth is true");
        x.push("[" + v.slice(b.index) + "]");
      }
      return s(x, c, p, f);
    }
  }, $ = function(h) {
    if (!h)
      return n;
    if (typeof h.allowEmptyArrays < "u" && typeof h.allowEmptyArrays != "boolean")
      throw new TypeError("`allowEmptyArrays` option can only be `true` or `false`, when provided");
    if (typeof h.decodeDotInKeys < "u" && typeof h.decodeDotInKeys != "boolean")
      throw new TypeError("`decodeDotInKeys` option can only be `true` or `false`, when provided");
    if (h.decoder !== null && typeof h.decoder < "u" && typeof h.decoder != "function")
      throw new TypeError("Decoder has to be a function.");
    if (typeof h.charset < "u" && h.charset !== "utf-8" && h.charset !== "iso-8859-1")
      throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
    if (typeof h.throwOnLimitExceeded < "u" && typeof h.throwOnLimitExceeded != "boolean")
      throw new TypeError("`throwOnLimitExceeded` option must be a boolean");
    var c = typeof h.charset > "u" ? n.charset : h.charset, p = typeof h.duplicates > "u" ? n.duplicates : h.duplicates;
    if (p !== "combine" && p !== "first" && p !== "last")
      throw new TypeError("The duplicates option must be either combine, first, or last");
    var f = typeof h.allowDots > "u" ? h.decodeDotInKeys === !0 ? !0 : n.allowDots : !!h.allowDots;
    return {
      allowDots: f,
      allowEmptyArrays: typeof h.allowEmptyArrays == "boolean" ? !!h.allowEmptyArrays : n.allowEmptyArrays,
      allowPrototypes: typeof h.allowPrototypes == "boolean" ? h.allowPrototypes : n.allowPrototypes,
      allowSparse: typeof h.allowSparse == "boolean" ? h.allowSparse : n.allowSparse,
      arrayLimit: typeof h.arrayLimit == "number" ? h.arrayLimit : n.arrayLimit,
      charset: c,
      charsetSentinel: typeof h.charsetSentinel == "boolean" ? h.charsetSentinel : n.charsetSentinel,
      comma: typeof h.comma == "boolean" ? h.comma : n.comma,
      decodeDotInKeys: typeof h.decodeDotInKeys == "boolean" ? h.decodeDotInKeys : n.decodeDotInKeys,
      decoder: typeof h.decoder == "function" ? h.decoder : n.decoder,
      delimiter: typeof h.delimiter == "string" || e.isRegExp(h.delimiter) ? h.delimiter : n.delimiter,
      // eslint-disable-next-line no-implicit-coercion, no-extra-parens
      depth: typeof h.depth == "number" || h.depth === !1 ? +h.depth : n.depth,
      duplicates: p,
      ignoreQueryPrefix: h.ignoreQueryPrefix === !0,
      interpretNumericEntities: typeof h.interpretNumericEntities == "boolean" ? h.interpretNumericEntities : n.interpretNumericEntities,
      parameterLimit: typeof h.parameterLimit == "number" ? h.parameterLimit : n.parameterLimit,
      parseArrays: h.parseArrays !== !1,
      plainObjects: typeof h.plainObjects == "boolean" ? h.plainObjects : n.plainObjects,
      strictDepth: typeof h.strictDepth == "boolean" ? !!h.strictDepth : n.strictDepth,
      strictNullHandling: typeof h.strictNullHandling == "boolean" ? h.strictNullHandling : n.strictNullHandling,
      throwOnLimitExceeded: typeof h.throwOnLimitExceeded == "boolean" ? h.throwOnLimitExceeded : !1
    };
  };
  return bo = function(y, h) {
    var c = $(h);
    if (y === "" || y === null || typeof y > "u")
      return c.plainObjects ? { __proto__: null } : {};
    for (var p = typeof y == "string" ? l(y, c) : y, f = c.plainObjects ? { __proto__: null } : {}, v = Object.keys(p), w = 0; w < v.length; ++w) {
      var m = v[w], b = u(m, p[m], c, typeof y == "string");
      f = e.merge(f, b, c);
    }
    return c.allowSparse === !0 ? f : e.compact(f);
  }, bo;
}
var wo, mu;
function wx() {
  if (mu) return wo;
  mu = 1;
  var e = /* @__PURE__ */ gx(), t = /* @__PURE__ */ bx(), r = /* @__PURE__ */ Wi();
  return wo = {
    formats: r,
    parse: t,
    stringify: e
  }, wo;
}
var _x = /* @__PURE__ */ wx();
const li = /* @__PURE__ */ j_(_x);
/*!
  * vue-router v4.5.1
  * (c) 2025 Eduardo San Martin Morote
  * @license MIT
  */
var hu;
(function(e) {
  e.pop = "pop", e.push = "push";
})(hu || (hu = {}));
var vu;
(function(e) {
  e.back = "back", e.forward = "forward", e.unknown = "";
})(vu || (vu = {}));
Symbol(process.env.NODE_ENV !== "production" ? "navigation failure" : "");
var yu;
(function(e) {
  e[e.aborted = 4] = "aborted", e[e.cancelled = 8] = "cancelled", e[e.duplicated = 16] = "duplicated";
})(yu || (yu = {}));
Symbol(process.env.NODE_ENV !== "production" ? "router view location matched" : "");
Symbol(process.env.NODE_ENV !== "production" ? "router view depth" : "");
const xx = Symbol(process.env.NODE_ENV !== "production" ? "router" : ""), Sx = Symbol(process.env.NODE_ENV !== "production" ? "route location" : "");
Symbol(process.env.NODE_ENV !== "production" ? "router view location" : "");
function Cx() {
  return ft(xx);
}
function Px(e) {
  return ft(Sx);
}
const Ax = "filter";
function cS(e) {
  const t = e || {}, r = t.filterKey || Ax, n = t.stringify || li.stringify, a = t.parse || li.parse, d = Cx(), o = Px(), i = H({});
  function l() {
    i.value = {};
  }
  function s($, y) {
    y !== void 0 ? i.value[$] = y : delete i.value[$];
  }
  t != null && t.ignoreQueryParams || K(
    () => i,
    () => {
      d == null || d.replace({
        query: gi(i.value) ? void 0 : {
          [r]: n(i.value)
        }
      });
    },
    { deep: !0 }
  );
  function u() {
    const $ = o == null ? void 0 : o.query[r];
    if (!(!$ || typeof $ != "string"))
      try {
        const y = a($);
        i.value = y;
      } catch {
        i.value = {};
      }
  }
  return u(), {
    appliedFilters: i,
    resetFilters: l,
    setFilter: s
  };
}
function fS() {
  const e = H(), t = H(!1);
  return K(e, (r) => {
    t.value = !!r;
  }), K(t, (r) => {
    r || (e.value = void 0);
  }), [e, t];
}
const Je = {
  baseUrl: ""
};
function $S(e) {
  e.baseUrl && (Je.baseUrl = e.baseUrl), e.onError && (Je.onError = e.onError), e.requestInterceptor && (Je.requestInterceptor = e.requestInterceptor), e.responseInterceptor && (Je.responseInterceptor = e.responseInterceptor);
}
function Ex(e, t) {
  return gi(t) ? e : `${e}?${li.stringify(t)}`;
}
function Mx() {
  let e = null;
  return {
    abort: () => {
      e == null || e.abort(), e = null;
    },
    get: () => e,
    set: () => (e = new AbortController(), e)
  };
}
function Ox() {
  const e = [];
  return {
    add: (t) => e.push(t),
    call: (t) => e.forEach((r) => r(t))
  };
}
function Tx() {
  return {
    data: H(null),
    error: H(null),
    isLoading: H(!1),
    requestId: { current: 0 }
  };
}
async function _2(e, { responseType: t = "json", ...r }, { maxRetries: n = 0, retryDelay: a = 0, retryIf: d = () => !1 }, o) {
  try {
    const i = await fetch(e, { ...r, signal: o.signal });
    if (!i.ok)
      throw {
        body: await gu(i, "json"),
        cause: i
      };
    return gu(i, t);
  } catch (i) {
    if (n > 0 || d(i)) {
      const l = Math.max(a * 2, 1);
      return new Promise((s, u) => {
        setTimeout(() => {
          _2(
            e,
            { responseType: t, ...r },
            {
              maxRetries: n - 1,
              retryDelay: l,
              retryIf: d
            },
            o
          ).then(s).catch(u);
        }, a);
      });
    } else
      throw i;
  }
}
async function gu(e, t = "json") {
  const r = {
    arrayBuffer: () => e.arrayBuffer(),
    blob: () => e.blob(),
    json: () => e.json(),
    text: () => e.text()
  };
  return (r[t] || r.json)();
}
function Kn(e, t, r = {}) {
  const n = Tx(), a = Mx(), d = Ox(), o = async (...l) => {
    let s, u;
    const $ = ++n.requestId.current;
    t === "GET" || t === "DELETE" ? (u = l[0], s = void 0) : (s = l[0], u = l[1]), n.isLoading.value = !0, n.data.value = null, n.error.value = null;
    const y = a.set(), h = Nr(e), c = Nr(r), p = { ...c.params, ...u == null ? void 0 : u.params }, f = Ex(`${Je.baseUrl}/${h}`, p), v = {}, w = s instanceof FormData;
    w || (v["Content-Type"] = "application/json");
    let m = {
      body: w ? s : s ? JSON.stringify(s) : void 0,
      headers: {
        ...v,
        ...c.headers
      },
      method: t,
      ...c
    };
    Je.requestInterceptor && (m = Je.requestInterceptor(m));
    try {
      const b = await _2(
        f,
        m,
        {
          ...c.retry
        },
        y
      );
      n.data.value = Je.responseInterceptor ? Je.responseInterceptor(b) : b, d.call(n.data.value);
    } catch (b) {
      Je.onError && !c.skipGlobalErrorHandler && Je.onError(b), n.error.value = b;
    } finally {
      $ === n.requestId.current && (n.isLoading.value = !1);
    }
    return { data: n.data.value, error: n.error.value };
  }, i = Nr(r);
  return t === "GET" && !i.disableAutoExecute && ui(() => {
    o();
  }), {
    ...n,
    abort: a.abort,
    execute: o,
    onData: d.add
  };
}
const pS = (e, t) => Kn(e, "GET", t), mS = (e, t) => Kn(e, "POST", t), hS = (e, t) => Kn(e, "PATCH", t), vS = (e, t) => Kn(e, "PUT", t), yS = (e, t) => Kn(e, "DELETE", t);
export {
  Ix as FdxAccordion,
  Dx as FdxAvatar,
  Vu as FdxButton,
  N3 as FdxCard,
  Nx as FdxChip,
  Fx as FdxCollapsible,
  Lx as FdxCountDown,
  Bx as FdxDrawer,
  bi as FdxDropdown,
  Xm as FdxErrorMessages,
  Vx as FdxFormBox,
  at as FdxFormItemContainer,
  jx as FdxInputCheckbox,
  Ux as FdxInputDate,
  Hx as FdxInputDateRange,
  Wx as FdxInputFile,
  Uv as FdxInputNumber,
  zx as FdxInputPassword,
  qx as FdxInputPhoneNumber,
  Kx as FdxInputPin,
  Yx as FdxInputRadio,
  Zx as FdxInputRadioGroup,
  $y as FdxInputSelect,
  Gv as FdxInputText,
  Jx as FdxIntersectionTrigger,
  vw as FdxLoadingSpinner,
  Qx as FdxModal,
  Xx as FdxRangeSlider,
  eS as FdxScrollableFadeContainer,
  tS as FdxSkeletonElement,
  rS as FdxSwitch,
  aS as FdxTabPane,
  nS as FdxTable,
  dS as FdxTabs,
  oS as FdxTextarea,
  iS as FdxTimelineEvent,
  t_ as FdxTimelineEventDescription,
  o_ as FdxTimelineEventIcon,
  a_ as FdxTimelineEventTitle,
  lS as FdxTimelineWrapper,
  sS as FdxToaster,
  uS as FdxTooltip,
  $S as configUseFetch,
  Rx as formatCurrency,
  Eu as formatNumber,
  K2 as generateColorFromHash,
  J2 as generateInitials,
  Y2 as getTextColor,
  Q2 as hashString,
  Z2 as injectStrict,
  st as twMerge,
  yS as useDelete,
  fS as useDialogState,
  cS as useFilters,
  pS as useGet,
  hS as usePatch,
  mS as usePost,
  vS as usePut,
  p_ as useToaster
};
